import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  MultiPolygon: readonly (readonly (readonly (readonly number[])[])[])[];
}

export interface AccessSettingInput {
  readonly EMAIL_LIST?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly type: AccessSettingType;
}

export enum AccessSettingType {
  EVERYONE = 'EVERYONE',
  LINK_ONLY = 'LINK_ONLY'
}

export interface AdminCreateSocialConnectionInput {
  readonly provider: SocialConnectionProvider;
  readonly token: Scalars['String'];
}

export interface AdminRegistrationAdditionalDataInput {
  readonly demoRequested?: InputMaybe<Scalars['Boolean']>;
  readonly interestIds: ReadonlyArray<Scalars['ID']>;
  readonly outcomeId?: InputMaybe<Scalars['String']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
  readonly reasonId?: InputMaybe<Scalars['String']>;
}

export enum AdminRegistrationDecision {
  APPROVED = 'APPROVED',
  APPROVED_AUTOMATIC = 'APPROVED_AUTOMATIC',
  REJECTED = 'REJECTED'
}

export interface AdminRegistrationProfileSelectionInput {
  readonly adminRoleId?: InputMaybe<Scalars['ID']>;
  readonly location: LocationInput;
  readonly organizationAreaId: Scalars['ID'];
  readonly organizationSubtypeId?: InputMaybe<Scalars['ID']>;
  readonly organizationTypeId: Scalars['ID'];
  readonly profileName: Scalars['String'];
}

export interface AdminRegistrationUserInput {
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
  readonly password: Scalars['String'];
  readonly referralSource?: InputMaybe<Scalars['String']>;
}

export enum AdminRoleFilter {
  ACTIVE = 'ACTIVE',
  ALL = 'ALL'
}

export interface AdminShareEmailInput {
  readonly message?: InputMaybe<Scalars['String']>;
  readonly recipientEmail: Scalars['String'];
  readonly recipientName: Scalars['String'];
}

export interface AdminUpdatePublishingEntityInput {
  readonly description: Scalars['String'];
  readonly mailingData?: InputMaybe<PublishingEntityMailingsInput>;
  readonly name: Scalars['String'];
  readonly postedBy: Scalars['String'];
  readonly primaryImageUrl?: InputMaybe<Scalars['String']>;
  readonly profileCoverImageUrl?: InputMaybe<Scalars['String']>;
}

export interface AdminUpdateSocialConnectionInput {
  readonly provider: SocialConnectionProvider;
  readonly selectedProfiles: ReadonlyArray<Scalars['String']>;
}

export enum AiAssistantMessageRole {
  ASSISTANT = 'ASSISTANT',
  FILE_UPLOAD = 'FILE_UPLOAD',
  SYSTEM = 'SYSTEM',
  USER = 'USER'
}

export enum AiAssistantQueryStatusType {
  PROCESSING = 'PROCESSING',
  RESPONDED = 'RESPONDED'
}

export enum AiAssistantSessionSortType {
  ASSISTANT_NAME = 'ASSISTANT_NAME',
  NUMBER_OF_QUERIES = 'NUMBER_OF_QUERIES',
  SESSION_START_AT = 'SESSION_START_AT'
}

export enum AiAssistantSessionStatusType {
  ACTIVE = 'ACTIVE',
  NOT_FOUND = 'NOT_FOUND'
}

export interface AiAssistantUserSessionUpdateInput {
  readonly name?: InputMaybe<Scalars['String']>;
}

export enum AnalyticsBenchmarkValue {
  HIGHER = 'HIGHER',
  LESS_FAVORABLE = 'LESS_FAVORABLE',
  LOWER = 'LOWER',
  MORE_FAVORABLE = 'MORE_FAVORABLE',
  MUCH_HIGHER = 'MUCH_HIGHER',
  MUCH_LOWER = 'MUCH_LOWER',
  SIMILAR = 'SIMILAR'
}

export enum AnalyticsDomain {
  COMMUNITY_CHARACTERISTICS = 'COMMUNITY_CHARACTERISTICS',
  COMMUNITY_DESIGN = 'COMMUNITY_DESIGN',
  COMMUNITY_LIVABILITY = 'COMMUNITY_LIVABILITY',
  ECONOMY = 'ECONOMY',
  EDUCATION_ARTS_CULTURE = 'EDUCATION_ARTS_CULTURE',
  FINANCE = 'FINANCE',
  GOVERNANCE = 'GOVERNANCE',
  HEALTH_AND_WELLNESS = 'HEALTH_AND_WELLNESS',
  INCLUSIVITY_AND_ENGAGEMENT = 'INCLUSIVITY_AND_ENGAGEMENT',
  MOBILITY = 'MOBILITY',
  NATURAL_ENVIRONMENT = 'NATURAL_ENVIRONMENT',
  PARKS_AND_RECREATION = 'PARKS_AND_RECREATION',
  SAFETY = 'SAFETY',
  UTILITIES = 'UTILITIES'
}

export enum AnalyticsSubdomain {
  AIR_QUALITY = 'AIR_QUALITY',
  ALTERNATE_MODES = 'ALTERNATE_MODES',
  ARTS_CULTURE = 'ARTS_CULTURE',
  AUTO = 'AUTO',
  BROADBAND = 'BROADBAND',
  BUSINESS_VITALITY = 'BUSINESS_VITALITY',
  CLIMATE = 'CLIMATE',
  COMMUNITY_CHARACTERISTICS = 'COMMUNITY_CHARACTERISTICS',
  COMMUNITY_CLEANLINESS = 'COMMUNITY_CLEANLINESS',
  COMMUNITY_LIVABILITY = 'COMMUNITY_LIVABILITY',
  DIVERSITY_INCLUSION = 'DIVERSITY_INCLUSION',
  ECONOMY = 'ECONOMY',
  EDUCATION = 'EDUCATION',
  EMPLOYMENT = 'EMPLOYMENT',
  ENGAGEMENT_CIVIC_SOCIAL = 'ENGAGEMENT_CIVIC_SOCIAL',
  ENVIRONMENTAL_HEALTH = 'ENVIRONMENTAL_HEALTH',
  EQUITY = 'EQUITY',
  EXPENDITURES = 'EXPENDITURES',
  FEELINGS_OF_SAFETY = 'FEELINGS_OF_SAFETY',
  FIRE_EMS = 'FIRE_EMS',
  FOOD_SECURITY = 'FOOD_SECURITY',
  GOVERNANCE = 'GOVERNANCE',
  HEALTHCARE = 'HEALTHCARE',
  HEALTHY_LIFESTYLES = 'HEALTHY_LIFESTYLES',
  HOUSING = 'HOUSING',
  INCOME = 'INCOME',
  LAND_USE = 'LAND_USE',
  LAW_ENFORCEMENT = 'LAW_ENFORCEMENT',
  LIBRARIES = 'LIBRARIES',
  MENTAL_HEALTH = 'MENTAL_HEALTH',
  MOBILITY = 'MOBILITY',
  PARKS = 'PARKS',
  PATHS_AND_TRAILS = 'PATHS_AND_TRAILS',
  POWER = 'POWER',
  RECREATION = 'RECREATION',
  RESIDENT_HEALTH = 'RESIDENT_HEALTH',
  REVENUE = 'REVENUE',
  SAFETY = 'SAFETY',
  SOLID_WASTE_MANAGEMENT = 'SOLID_WASTE_MANAGEMENT',
  UTILITIES = 'UTILITIES',
  WATER_SEWER = 'WATER_SEWER',
  WELLNESS = 'WELLNESS'
}

export enum AnalyticsValueType {
  AMOUNT = 'AMOUNT',
  CURRENCY = 'CURRENCY',
  PERCENT = 'PERCENT'
}

export interface ArbitraryQueryParamInput {
  readonly key: Scalars['String'];
  readonly value: Scalars['String'];
}

export enum AreaLookupType {
  ANY = 'ANY',
  CITY = 'CITY',
  COUNTY = 'COUNTY',
  STATE = 'STATE',
  SUB_CITY = 'SUB_CITY'
}

export interface AssistantIdInput {
  readonly id: Scalars['ID'];
  readonly type: AssistantType;
}

export enum AssistantType {
  OpenAIAssistant = 'OpenAIAssistant',
  PubAssistant = 'PubAssistant',
  StandardAssistant = 'StandardAssistant'
}

export enum BalancingActSimulationType {
  BUDGET = 'BUDGET',
  CLIMATE = 'CLIMATE',
  HOUSING = 'HOUSING',
  NON_NUMERICAL = 'NON_NUMERICAL',
  POINTS = 'POINTS',
  PROJECT_MANAGEMENT = 'PROJECT_MANAGEMENT',
  RECEIPT = 'RECEIPT'
}

export enum BenchmarkFilter {
  DEFAULT = 'DEFAULT',
  POPULATION = 'POPULATION',
  SES_DEFAULT = 'SES_DEFAULT',
  SES_POPULATION = 'SES_POPULATION',
  SES_STATE = 'SES_STATE',
  SES_STATE_AND_POP = 'SES_STATE_AND_POP',
  STATE = 'STATE',
  STATE_AND_POP = 'STATE_AND_POP'
}

export interface BenchmarkProgramInput {
  readonly addonItems: ReadonlyArray<ReviewSelectionNotification>;
  readonly singleAddonItem: ReadonlyArray<SurveyItems>;
}

export enum BenchmarkReportRequestAreaGroup {
  A = 'A',
  B = 'B'
}

export interface BenchmarkReportRequestAreaInput {
  readonly group?: InputMaybe<BenchmarkReportRequestAreaGroup>;
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly value?: InputMaybe<Scalars['String']>;
  readonly weight?: InputMaybe<Scalars['Float']>;
}

export interface BenchmarkReportRequestInput {
  readonly additionalNotes?: InputMaybe<Scalars['String']>;
  readonly areaData: ReadonlyArray<BenchmarkReportRequestAreaInput>;
  readonly benchmarkSurveyType: BenchmarkSurveyTypes;
  readonly clientDueAt?: InputMaybe<GqlDateInput>;
  readonly closedAt?: InputMaybe<GqlDateInput>;
  readonly customBenchmarks?: InputMaybe<Scalars['String']>;
  readonly eligibleSamplingResponseCount?: InputMaybe<Scalars['Int']>;
  readonly emailedCount?: InputMaybe<Scalars['Int']>;
  readonly expectedTrendYears?: InputMaybe<Scalars['String']>;
  readonly fips?: InputMaybe<Scalars['String']>;
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly mailedCount?: InputMaybe<Scalars['Int']>;
  readonly publishingEntityId: Scalars['ID'];
  readonly questionSetData: ReadonlyArray<BenchmarkReportRequestQuestionSetInput>;
  readonly reportDueAt?: InputMaybe<GqlDateInput>;
  readonly responseRate?: InputMaybe<Scalars['Float']>;
  readonly startAt?: InputMaybe<GqlDateInput>;
  readonly surveyFormat?: InputMaybe<SurveyFormat>;
  readonly trendsExpected?: InputMaybe<Scalars['Boolean']>;
}

export interface BenchmarkReportRequestQuestionSetInput {
  readonly contentSetId?: InputMaybe<Scalars['ID']>;
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly language?: InputMaybe<Scalars['String']>;
  readonly optIn?: InputMaybe<Scalars['Boolean']>;
  readonly weighted?: InputMaybe<Scalars['Boolean']>;
}

export enum BenchmarkReportRequestStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export enum BenchmarkSurveyTypes {
  ARPA_BUSINESS = 'ARPA_BUSINESS',
  ARPA_RESIDENT = 'ARPA_RESIDENT',
  CASOA = 'CASOA',
  NBS = 'NBS',
  NCI = 'NCI',
  NCS = 'NCS',
  NCS_OA = 'NCS_OA',
  NES = 'NES',
  NES_LE = 'NES_LE',
  NLES = 'NLES',
  NPSS = 'NPSS'
}

export enum BenchmarkValue {
  HIGHER = 'HIGHER',
  LOWER = 'LOWER',
  MUCH_HIGHER = 'MUCH_HIGHER',
  MUCH_LOWER = 'MUCH_LOWER',
  SIMILAR = 'SIMILAR'
}

export enum BillingScheme {
  PER_UNIT = 'PER_UNIT',
  TIERED = 'TIERED'
}

export enum BottomIcon {
  LIVE_TV = 'LIVE_TV'
}

export enum CacheControlScope {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export enum ClientOnlyAnalyticsEvent {
  ADMIN_ATTEMPTED_PROFILE_COVER_IMAGE_UPLOAD = 'ADMIN_ATTEMPTED_PROFILE_COVER_IMAGE_UPLOAD',
  ADMIN_ATTEMPTED_PROFILE_IMAGE_UPLOAD = 'ADMIN_ATTEMPTED_PROFILE_IMAGE_UPLOAD',
  ADMIN_POSTED_DRAFT_SURVEY = 'ADMIN_POSTED_DRAFT_SURVEY',
  ADMIN_VIEWED_ENGAGEMENT_BOOST_OPTIONS = 'ADMIN_VIEWED_ENGAGEMENT_BOOST_OPTIONS'
}

export interface CommentFilter {
  readonly filter: CommentFilterOption;
  readonly publishingEntityId: Scalars['ID'];
}

export enum CommentFilterOption {
  SUBSCRIBERS = 'SUBSCRIBERS'
}

export interface ConditionsInput {
  readonly metaConditions: ReadonlyArray<MetaConditionInput>;
  readonly questionChoiceConditions: ReadonlyArray<QuestionChoiceConditionInput>;
}

export enum ContentOutcomeState {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export interface CoordinateInput {
  readonly lat: Scalars['Float'];
  readonly lng: Scalars['Float'];
}

export interface CreateGoalInput {
  readonly planId: Scalars['ID'];
  readonly publishingEntityId: Scalars['ID'];
  readonly value: Scalars['Float'];
  readonly variableId: Scalars['ID'];
}

export interface CreateSuperAdminInput {
  readonly email: Scalars['String'];
  readonly name: Scalars['String'];
}

export enum CrmTrackedEvent {
  ADMIN_VIEWED_DEMO_SITE = 'ADMIN_VIEWED_DEMO_SITE',
  ADMIN_VIEWED_LEARN_MORE_ITEM_CASOA = 'ADMIN_VIEWED_LEARN_MORE_ITEM_CASOA',
  ADMIN_VIEWED_LEARN_MORE_ITEM_NBS = 'ADMIN_VIEWED_LEARN_MORE_ITEM_NBS',
  ADMIN_VIEWED_LEARN_MORE_ITEM_NCS = 'ADMIN_VIEWED_LEARN_MORE_ITEM_NCS',
  ADMIN_VIEWED_LEARN_MORE_ITEM_NCS_S = 'ADMIN_VIEWED_LEARN_MORE_ITEM_NCS_S',
  ADMIN_VIEWED_LEARN_MORE_ITEM_NES = 'ADMIN_VIEWED_LEARN_MORE_ITEM_NES',
  ADMIN_VIEWED_LEARN_MORE_ITEM_NES_LE = 'ADMIN_VIEWED_LEARN_MORE_ITEM_NES_LE',
  ADMIN_VIEWED_LEARN_MORE_ITEM_NLES = 'ADMIN_VIEWED_LEARN_MORE_ITEM_NLES',
  ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK = 'ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK',
  ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_COMMUNITY_CHARACTERISTICS = 'ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_COMMUNITY_CHARACTERISTICS',
  ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_COMMUNITY_DESIGN = 'ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_COMMUNITY_DESIGN',
  ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_COMMUNITY_LIVABILITY = 'ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_COMMUNITY_LIVABILITY',
  ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_ECONOMY = 'ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_ECONOMY',
  ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_EDUCATION_ARTS_CULTURE = 'ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_EDUCATION_ARTS_CULTURE',
  ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_FINANCE = 'ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_FINANCE',
  ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_GOVERNANCE = 'ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_GOVERNANCE',
  ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_HEALTH_AND_WELLNESS = 'ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_HEALTH_AND_WELLNESS',
  ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_INCLUSIVITY_AND_ENGAGEMENT = 'ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_INCLUSIVITY_AND_ENGAGEMENT',
  ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_MOBILITY = 'ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_MOBILITY',
  ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_NATURAL_ENVIRONMENT = 'ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_NATURAL_ENVIRONMENT',
  ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_PARKS_AND_RECREATION = 'ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_PARKS_AND_RECREATION',
  ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_SAFETY = 'ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_SAFETY',
  ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_UTILITIES = 'ADMIN_VIEWED_LEARN_MORE_ITEM_TRACK_UTILITIES'
}

export interface CsvReportInput {
  readonly contentSetId: Scalars['ID'];
  readonly scopedPublishingEntityId: Scalars['ID'];
}

export interface DataDictionaryInput {
  readonly reportDisplayLabel?: InputMaybe<Scalars['String']>;
  readonly scaleData?: InputMaybe<ScaleDataInput>;
}

export enum DateLevel {
  MONTH = 'MONTH',
  YEAR = 'YEAR'
}

export interface DeleteGoalInput {
  readonly goalId: Scalars['ID'];
  readonly publishingEntityId: Scalars['ID'];
}

export interface DemographicLocationStatSourceInput {
  readonly geoViewId: Scalars['ID'];
}

export enum DemographicStatSource {
  THIRD_PARTY = 'THIRD_PARTY',
  USER_REPORTED = 'USER_REPORTED'
}

export interface DemographicStatSourceInput {
  readonly source: DemographicStatSource;
}

export enum DisparityLevel {
  LARGE = 'LARGE',
  SIMILAR = 'SIMILAR',
  SMALL = 'SMALL'
}

export enum EmailLoginFailedReason {
  INVALID = 'INVALID'
}

export enum EmailSignupFailedReason {
  COULD_NOT_INSERT_USER = 'COULD_NOT_INSERT_USER',
  EMAIL_TAKEN = 'EMAIL_TAKEN',
  INVALID = 'INVALID',
  RESPONDENT_TAKEN = 'RESPONDENT_TAKEN'
}

export enum EmailType {
  AdminShareEmail = 'AdminShareEmail',
  OutcomeEmail = 'OutcomeEmail',
  OutreachEmail = 'OutreachEmail',
  WeeklyEmail = 'WeeklyEmail'
}

export enum EmailVerificationStatus {
  NEEDS_VERIFICATION = 'NEEDS_VERIFICATION',
  VERIFICATION_NOT_NEEDED = 'VERIFICATION_NOT_NEEDED',
  VERIFIED = 'VERIFIED'
}

export interface FeatureSettingInput {
  readonly dateToEnableUntil?: InputMaybe<GqlDateInput>;
  readonly featureSettingId: Scalars['ID'];
  readonly isUnlimited?: InputMaybe<Scalars['Boolean']>;
  readonly quantity?: InputMaybe<Scalars['Int']>;
}

export enum FipsAreaType {
  COUNTY = 'COUNTY',
  COUNTY_SUBDIVISION = 'COUNTY_SUBDIVISION',
  CUSTOM = 'CUSTOM',
  MSA = 'MSA',
  NATION = 'NATION',
  PLACE = 'PLACE',
  STATE = 'STATE'
}

export enum FlagEvaluationErrorReason {
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN'
}

export enum FlagEvaluationReason {
  DEFAULT = 'DEFAULT',
  FLAG_DISABLED = 'FLAG_DISABLED',
  MATCH = 'MATCH',
  UNKNOWN = 'UNKNOWN'
}

export interface GeoJsonMultiPolygonInput {
  readonly coordinates: Scalars['MultiPolygon'];
  readonly type: Scalars['String'];
}

export interface GqlDateInput {
  readonly raw: Scalars['Float'];
}

export enum GqlQuestionSetGeneratedTypes {
  POLCO_BASE = 'POLCO_BASE',
  RAILS_BASE = 'RAILS_BASE',
  RAILS_SET = 'RAILS_SET'
}

export interface GridInput {
  readonly choices: ReadonlyArray<QuestionChoiceInput>;
  readonly dataDictionary?: InputMaybe<DataDictionaryInput>;
  readonly ephemeralReferenceId: Scalars['ID'];
  readonly gridRootHierarchyId?: InputMaybe<Scalars['ID']>;
  readonly metaConditionReferenceId?: InputMaybe<Scalars['ID']>;
  readonly randomizeChoices?: InputMaybe<Scalars['Boolean']>;
  readonly rows: ReadonlyArray<GridRowInput>;
  readonly shareableQuestionChoiceSetId?: InputMaybe<Scalars['ID']>;
  readonly title: Scalars['String'];
}

export interface GridRowInput {
  readonly ephemeralReferenceId: Scalars['ID'];
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly label: Scalars['String'];
  readonly metaConditionReferenceId?: InputMaybe<Scalars['ID']>;
  readonly optional: Scalars['Boolean'];
  readonly reportDisplayLabel?: InputMaybe<Scalars['String']>;
  readonly variableName?: InputMaybe<Scalars['String']>;
}

export interface GridVoteInput {
  readonly choiceId: Scalars['ID'];
  readonly questionId: Scalars['ID'];
}

export interface IdeaInput {
  readonly description?: InputMaybe<Scalars['String']>;
  readonly publishingEntityId: Scalars['ID'];
  readonly title: Scalars['String'];
}

export enum IdeaInteractionAction {
  REMOVE_VOTE = 'REMOVE_VOTE',
  VOTE_DOWN = 'VOTE_DOWN',
  VOTE_UP = 'VOTE_UP'
}

export enum InputVoteType {
  VOTE_ACKNOWLEDGE = 'VOTE_ACKNOWLEDGE',
  VOTE_FREE_TEXT = 'VOTE_FREE_TEXT',
  VOTE_MULTIPLE_CHOICES = 'VOTE_MULTIPLE_CHOICES',
  VOTE_POINT_ALLOCATION = 'VOTE_POINT_ALLOCATION'
}

export interface InteractionInput {
  readonly action: IdeaInteractionAction;
  readonly ideaId: Scalars['String'];
}

export enum KnownOrganizationAreaKey {
  OTHER = 'OTHER',
  UNITED_STATES = 'UNITED_STATES'
}

export enum LanguageKey {
  AMHARIC = 'AMHARIC',
  ARABIC = 'ARABIC',
  BENGALI = 'BENGALI',
  BURMESE = 'BURMESE',
  CAPE_VERDEAN_CREOLE = 'CAPE_VERDEAN_CREOLE',
  CHINESE_SIMPLIFIED = 'CHINESE_SIMPLIFIED',
  CHINESE_TRADITIONAL = 'CHINESE_TRADITIONAL',
  ENGLISH = 'ENGLISH',
  FARSI = 'FARSI',
  FRENCH = 'FRENCH',
  GERMAN = 'GERMAN',
  GUJARATI = 'GUJARATI',
  HAITIAN_CREOLE = 'HAITIAN_CREOLE',
  HINDI = 'HINDI',
  HMONG = 'HMONG',
  JAPANESE = 'JAPANESE',
  KOREAN = 'KOREAN',
  MARSHALLESE = 'MARSHALLESE',
  NEPALI = 'NEPALI',
  OROMO = 'OROMO',
  POLISH = 'POLISH',
  PORTUGUESE = 'PORTUGUESE',
  RUSSIAN = 'RUSSIAN',
  SOMALI = 'SOMALI',
  SPANISH = 'SPANISH',
  SWAHILI = 'SWAHILI',
  TAGALOG = 'TAGALOG',
  UKRAINIAN = 'UKRAINIAN',
  VIETNAMESE = 'VIETNAMESE',
  YIDDISH = 'YIDDISH'
}

export interface LocationInput {
  readonly coordinate: CoordinateInput;
  readonly level?: InputMaybe<LocationLevel>;
  readonly rawAddress: Scalars['String'];
}

export enum LocationLevel {
  CITY = 'CITY',
  COUNTRY = 'COUNTRY',
  COUNTY = 'COUNTY',
  STATE = 'STATE'
}

export interface McChoice {
  readonly comment?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
}

export interface MagicLinkRequestInput {
  readonly email: Scalars['String'];
  readonly params?: InputMaybe<ReadonlyArray<ArbitraryQueryParamInput>>;
  readonly path: Scalars['String'];
}

export enum MapStatsStatus {
  ENABLED = 'ENABLED',
  NOT_ENABLED = 'NOT_ENABLED',
  NOT_ENOUGH_DATA = 'NOT_ENOUGH_DATA'
}

export enum MatrixSource {
  ARPA_BUSINESS = 'ARPA_BUSINESS',
  ARPA_RESIDENT = 'ARPA_RESIDENT',
  BALANCING_ACT = 'BALANCING_ACT',
  CASOA = 'CASOA',
  ENGAGE = 'ENGAGE',
  GPAL = 'GPAL',
  NATIONAL = 'NATIONAL',
  NBS = 'NBS',
  NCI = 'NCI',
  NCS = 'NCS',
  NES = 'NES',
  NES_LE = 'NES_LE',
  NLES = 'NLES',
  NPSS = 'NPSS'
}

export enum MatrixSourceType {
  DERIVED = 'DERIVED',
  STATED = 'STATED'
}

export enum MatrixTopic {
  COMMUNITY_DESIGN = 'COMMUNITY_DESIGN',
  ECONOMY = 'ECONOMY',
  EDUCATION_ARTS_CULTURE = 'EDUCATION_ARTS_CULTURE',
  GOVERNANCE = 'GOVERNANCE',
  HEALTH_AND_WELLNESS = 'HEALTH_AND_WELLNESS',
  INCLUSIVITY_AND_ENGAGEMENT = 'INCLUSIVITY_AND_ENGAGEMENT',
  MOBILITY = 'MOBILITY',
  NATURAL_ENVIRONMENT = 'NATURAL_ENVIRONMENT',
  PARKS_AND_RECREATION = 'PARKS_AND_RECREATION',
  SAFETY = 'SAFETY',
  UTILITIES = 'UTILITIES'
}

export enum MetaConditionCombinationOperator {
  ALL = 'ALL',
  NONE = 'NONE',
  NOT_ALL = 'NOT_ALL',
  SOME = 'SOME'
}

export interface MetaConditionInput {
  readonly childMetaConditionReferenceIds: ReadonlyArray<Scalars['ID']>;
  readonly combinationOperator: MetaConditionCombinationOperator;
  readonly displayName: Scalars['String'];
  readonly ephemeralReferenceId: Scalars['ID'];
  readonly id?: InputMaybe<Scalars['ID']>;
}

export interface NewShortUrlParameters {
  readonly type: Scalars['String'];
  readonly values: ReadonlyArray<InputMaybe<Scalars['String']>>;
}

export interface OutcomeInput {
  readonly tabIds: ReadonlyArray<Scalars['ID']>;
  readonly text: Scalars['String'];
}

export interface PaginationParams {
  readonly page: Scalars['Int'];
  readonly perPage: Scalars['Int'];
}

export interface PointAllocationChoice {
  readonly id: Scalars['ID'];
  readonly point: Scalars['Float'];
}

export interface PresidingAreaInput {
  readonly name: Scalars['String'];
  readonly shape?: InputMaybe<GeoJsonMultiPolygonInput>;
}

export enum PublishingEntityActivationState {
  ACTIVATED = 'ACTIVATED',
  ACTIVATION_REQUESTED = 'ACTIVATION_REQUESTED',
  NOT_ACTIVATED = 'NOT_ACTIVATED'
}

export enum PublishingEntityApprovalDecision {
  APPROVED = 'APPROVED',
  APPROVED_AUTOMATIC = 'APPROVED_AUTOMATIC',
  NOT_APPROVED = 'NOT_APPROVED'
}

export enum PublishingEntityAssetType {
  BACKGROUND = 'BACKGROUND',
  BANNER = 'BANNER',
  GIS_PRIMARY = 'GIS_PRIMARY',
  GIS_SECONDARY = 'GIS_SECONDARY',
  MAILING_LOGO = 'MAILING_LOGO',
  PRIMARY = 'PRIMARY',
  PRIMARY_SIGNATURE = 'PRIMARY_SIGNATURE',
  PROFILE_COVER = 'PROFILE_COVER',
  SECONDARY = 'SECONDARY',
  SECONDARY_SIGNATURE = 'SECONDARY_SIGNATURE'
}

export interface PublishingEntityCreationInput {
  readonly organizationAreaId: Scalars['ID'];
  readonly organizationSubtypeId?: InputMaybe<Scalars['ID']>;
  readonly organizationTypeId: Scalars['ID'];
  readonly presidingArea?: InputMaybe<RequiredPresidingAreaInput>;
  readonly pubName: Scalars['String'];
  readonly subscriptionMode: SubscriptionMode;
}

export interface PublishingEntityMailingsInput {
  readonly adminIndicatedComplete: Scalars['Boolean'];
  readonly contactPhoneNumber?: InputMaybe<Scalars['String']>;
  readonly fullName?: InputMaybe<Scalars['String']>;
  readonly gisPrimaryUrl?: InputMaybe<Scalars['String']>;
  readonly gisSecondaryUrl?: InputMaybe<Scalars['String']>;
  readonly mailingLogoUrl?: InputMaybe<Scalars['String']>;
  readonly primarySignatureUrl?: InputMaybe<Scalars['String']>;
  readonly returnMailingAddress?: InputMaybe<Scalars['String']>;
  readonly samplingZipCodes?: InputMaybe<Scalars['String']>;
  readonly secondarySigatureUrl?: InputMaybe<Scalars['String']>;
  readonly title?: InputMaybe<Scalars['String']>;
  readonly useExistingInfo: Scalars['Boolean'];
}

export enum PublishingEntityTypeFilter {
  ACTIVE = 'ACTIVE',
  ALL = 'ALL'
}

export enum PurchaseStatusType {
  FREE_TRIAL = 'FREE_TRIAL',
  PAID = 'PAID',
  UNPAID = 'UNPAID'
}

export enum QualitativeQuestionResultSortType {
  BENCHMARK_DIFFERENCE = 'BENCHMARK_DIFFERENCE',
  TREND_DIFFERENCE = 'TREND_DIFFERENCE',
  WEIGHTED_PERCENT = 'WEIGHTED_PERCENT'
}

export enum QualitativeTopics {
  IMPORTANCE = 'IMPORTANCE',
  QUALITY = 'QUALITY'
}

export interface QuestionChoiceConditionInput {
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly metaConditionReferenceId: Scalars['ID'];
  readonly questionChoiceReferenceId: Scalars['ID'];
  readonly questionReferenceId: Scalars['ID'];
}

export interface QuestionChoiceInput {
  readonly choiceValue?: InputMaybe<Scalars['Float']>;
  readonly ephemeralReferenceId: Scalars['ID'];
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly includeComment: Scalars['Boolean'];
  readonly text: Scalars['String'];
}

export interface QuestionHeaderInput {
  readonly description?: InputMaybe<Scalars['String']>;
  readonly ephemeralReferenceId: Scalars['ID'];
  readonly hierarchyId?: InputMaybe<Scalars['ID']>;
  readonly label: Scalars['String'];
  readonly metaConditionReferenceId?: InputMaybe<Scalars['ID']>;
}

export enum QuestionHierarchyChildInputType {
  GRID = 'GRID',
  HEADER = 'HEADER',
  QUESTION = 'QUESTION',
  ROW = 'ROW',
  SIMULATION = 'SIMULATION',
  VISUALIZATION = 'VISUALIZATION'
}

export enum QuestionHierarchyParentNodeType {
  GRID = 'GRID',
  HEADER = 'HEADER',
  ROW = 'ROW'
}

export interface QuestionInput {
  readonly backgroundInfo: Scalars['String'];
  readonly choices: ReadonlyArray<QuestionChoiceInput>;
  readonly dataDictionary?: InputMaybe<DataDictionaryInput>;
  readonly demographicAttributeId?: InputMaybe<Scalars['String']>;
  readonly ephemeralReferenceId: Scalars['ID'];
  readonly imageUrls: ReadonlyArray<Scalars['String']>;
  readonly maxSelection?: InputMaybe<Scalars['Int']>;
  readonly metaConditionReferenceId?: InputMaybe<Scalars['ID']>;
  readonly optional: Scalars['Boolean'];
  readonly questionId?: InputMaybe<Scalars['ID']>;
  readonly randomizeChoices?: InputMaybe<Scalars['Boolean']>;
  readonly shareableQuestionChoiceSetId?: InputMaybe<Scalars['ID']>;
  readonly title: Scalars['String'];
  readonly type: QuestionType;
  readonly variableName?: InputMaybe<Scalars['String']>;
}

export enum QuestionRelationshipType {
  BENCHMARK = 'BENCHMARK',
  COPY = 'COPY'
}

export interface QuestionScheduleInput {
  readonly future?: InputMaybe<QuestionSchedule_Future>;
  readonly now?: InputMaybe<QuestionSchedule_Now>;
  readonly soon?: InputMaybe<QuestionSchedule_Soon>;
  readonly type: QuestionSchedule_Type;
}

export interface QuestionScheduleWithIdInput {
  readonly id: Scalars['ID'];
  readonly schedule: QuestionScheduleInput;
}

export interface QuestionSchedule_Future {
  readonly closeDate?: InputMaybe<GqlDateInput>;
  readonly openDate: GqlDateInput;
}

export interface QuestionSchedule_Now {
  readonly closeDate?: InputMaybe<GqlDateInput>;
}

export interface QuestionSchedule_Soon {
  readonly seconds: Scalars['Int'];
}

export enum QuestionSchedule_Type {
  CLOSE_NOW = 'CLOSE_NOW',
  CLOSE_SOON = 'CLOSE_SOON',
  EXTEND = 'EXTEND',
  MOVE_TO_CART = 'MOVE_TO_CART',
  MOVE_TO_DRAFT = 'MOVE_TO_DRAFT',
  PUBLISH_NOW = 'PUBLISH_NOW',
  SCHEDULE_FUTURE = 'SCHEDULE_FUTURE'
}

export enum QuestionSetFeatureSetType {
  CONTENT_POST = 'CONTENT_POST',
  ENGAGEMENT_PAGE = 'ENGAGEMENT_PAGE'
}

export interface QuestionSetGenericInput {
  readonly accessSetting?: InputMaybe<AccessSettingInput>;
  readonly allowGuestRespondents: Scalars['Boolean'];
  readonly allowMultipleResponses: Scalars['Boolean'];
  readonly description?: InputMaybe<Scalars['String']>;
  readonly featureSetType: QuestionSetFeatureSetType;
  readonly hasAutomaticWeighting?: InputMaybe<Scalars['Boolean']>;
  readonly isPinnedToPublisher: Scalars['Boolean'];
  readonly name: Scalars['String'];
  readonly setImageId?: InputMaybe<Scalars['String']>;
  readonly shortDescription?: InputMaybe<Scalars['String']>;
  readonly showConversionPrompts: Scalars['Boolean'];
}

export interface QuestionSetInput {
  readonly GENERIC?: InputMaybe<QuestionSetGenericInput>;
  readonly POLCO_LIVE?: InputMaybe<QuestionSetPolcoLiveInput>;
  readonly SET?: InputMaybe<QuestionSetPollSetInput>;
  readonly SURVEY?: InputMaybe<QuestionSetSurveyInput>;
  readonly type: QuestionSetType;
}

export interface QuestionSetPolcoLiveInput {
  readonly accessSetting?: InputMaybe<AccessSettingInput>;
  readonly allowGuestRespondents: Scalars['Boolean'];
  readonly description?: InputMaybe<Scalars['String']>;
  readonly eventEndDate?: InputMaybe<GqlDateInput>;
  readonly eventStartDate?: InputMaybe<GqlDateInput>;
  readonly isPinnedToPublisher: Scalars['Boolean'];
  readonly liveVideoLink?: InputMaybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly setImageId?: InputMaybe<Scalars['String']>;
  readonly shortDescription?: InputMaybe<Scalars['String']>;
  readonly showConversionPrompts: Scalars['Boolean'];
  readonly state: QuestionStatus;
}

export interface QuestionSetPollSetInput {
  readonly accessSetting?: InputMaybe<AccessSettingInput>;
  readonly allowGuestRespondents: Scalars['Boolean'];
  readonly allowMultipleResponses: Scalars['Boolean'];
  readonly description?: InputMaybe<Scalars['String']>;
  readonly isPinnedToPublisher: Scalars['Boolean'];
  readonly name: Scalars['String'];
  readonly setImageId?: InputMaybe<Scalars['String']>;
  readonly shortDescription?: InputMaybe<Scalars['String']>;
  readonly showConversionPrompts: Scalars['Boolean'];
}

export enum QuestionSetStatus {
  ARCHIVED = 'ARCHIVED',
  CLOSED = 'CLOSED',
  HISTORIC_RECORD = 'HISTORIC_RECORD',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  SCHEDULED = 'SCHEDULED',
  SOFT_DELETED = 'SOFT_DELETED'
}

export interface QuestionSetSurveyInput {
  readonly accessSetting?: InputMaybe<AccessSettingInput>;
  readonly allowGuestRespondents: Scalars['Boolean'];
  readonly allowMultipleResponses: Scalars['Boolean'];
  readonly description?: InputMaybe<Scalars['String']>;
  readonly hasAutomaticWeighting?: InputMaybe<Scalars['Boolean']>;
  readonly isPinnedToPublisher: Scalars['Boolean'];
  readonly name: Scalars['String'];
  readonly setImageId?: InputMaybe<Scalars['String']>;
  readonly shortDescription?: InputMaybe<Scalars['String']>;
  readonly showConversionPrompts: Scalars['Boolean'];
}

export enum QuestionSetType {
  GENERIC = 'GENERIC',
  POLCO_LIVE = 'POLCO_LIVE',
  SET = 'SET',
  SURVEY = 'SURVEY'
}

export enum QuestionStatus {
  ARCHIVED = 'ARCHIVED',
  CART = 'CART',
  CLOSED = 'CLOSED',
  DRAFT = 'DRAFT',
  HISTORIC_RECORD = 'HISTORIC_RECORD',
  PUBLISHED = 'PUBLISHED',
  SCHEDULED = 'SCHEDULED',
  SOFT_DELETED = 'SOFT_DELETED'
}

export enum QuestionType {
  FREE_TEXT = 'FREE_TEXT',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  POINT_ALLOCATION = 'POINT_ALLOCATION'
}

export interface RegistrationMetadataEntry {
  readonly key: Scalars['String'];
  readonly value: Scalars['String'];
}

export enum ReportGenerationStatus {
  NOT_TAGGED = 'NOT_TAGGED',
  PENDING = 'PENDING',
  TAGGED = 'TAGGED'
}

export interface ReportTabContentInput {
  readonly HTML?: InputMaybe<Scalars['String']>;
  readonly TABLEAU?: InputMaybe<Scalars['String']>;
  readonly height?: InputMaybe<Scalars['Int']>;
  readonly type: ReportTabContentType;
}

export enum ReportTabContentType {
  ADVANCED_RESULTS = 'ADVANCED_RESULTS',
  COMMUNITY_NEEDS = 'COMMUNITY_NEEDS',
  COMMUNITY_READINESS = 'COMMUNITY_READINESS',
  CROSSTABS = 'CROSSTABS',
  ECONOMIC_CONTRIBUTION = 'ECONOMIC_CONTRIBUTION',
  FULL_TRENDS = 'FULL_TRENDS',
  HTML = 'HTML',
  INTRODUCTION = 'INTRODUCTION',
  KEY_FINDINGS = 'KEY_FINDINGS',
  METHODS = 'METHODS',
  OVERVIEW = 'OVERVIEW',
  PARTICIPATION = 'PARTICIPATION',
  QUALITY_IMPORTANCE = 'QUALITY_IMPORTANCE',
  REPOSTS = 'REPOSTS',
  RESULTS = 'RESULTS',
  TABLEAU = 'TABLEAU',
  TOPICS = 'TOPICS',
  UNDERSTANDING_THE_REPORT = 'UNDERSTANDING_THE_REPORT'
}

export interface ReportTabCreateInput {
  readonly content: ReportTabContentInput;
  readonly title: Scalars['String'];
  readonly visible: Scalars['Boolean'];
}

export interface ReportTabUpdateInput {
  readonly content: ReportTabContentInput;
  readonly id: Scalars['ID'];
  readonly title: Scalars['String'];
  readonly trackDomain?: InputMaybe<AnalyticsDomain>;
  readonly visible: Scalars['Boolean'];
}

export interface RequestFeatureContactInfo {
  readonly email?: InputMaybe<Scalars['String']>;
  readonly feature: Scalars['String'];
  readonly message?: InputMaybe<Scalars['String']>;
  readonly phone?: InputMaybe<Scalars['String']>;
  readonly phoneExt?: InputMaybe<Scalars['String']>;
}

export enum RequestPasswordResetContext {
  ADMIN_CLAIM_ACCOUNT = 'ADMIN_CLAIM_ACCOUNT',
  ADMIN_FORGOT_PASSWORD = 'ADMIN_FORGOT_PASSWORD',
  RESPONDENT_FORGOT_PASSWORD = 'RESPONDENT_FORGOT_PASSWORD'
}

export interface RequiredPresidingAreaInput {
  readonly name: Scalars['String'];
  readonly shape: GeoJsonMultiPolygonInput;
}

export enum ResendVerificationEmailResult {
  ALREADY_VERIFIED = 'ALREADY_VERIFIED',
  EMAIL_SENT = 'EMAIL_SENT',
  FAILED_TO_SEND = 'FAILED_TO_SEND'
}

export interface ResetFeatureSettingState {
  readonly enableUntil: GqlDateInput;
  readonly tierId: Scalars['ID'];
}

export enum ResetPasswordFailedReason {
  INVALID_TOKEN = 'INVALID_TOKEN',
  RESET_FAILED = 'RESET_FAILED'
}

export enum RespondentAttributeValueSource {
  THIRD_PARTY = 'THIRD_PARTY',
  USER_REPORTED = 'USER_REPORTED'
}

export enum RespondentFeedItemActionType {
  OPEN_ITEM = 'OPEN_ITEM',
  OPEN_OUTCOME = 'OPEN_OUTCOME',
  OPEN_PUBLISHER = 'OPEN_PUBLISHER',
  SHARE = 'SHARE',
  TOGGLE_FOLLOW = 'TOGGLE_FOLLOW',
  VOTE = 'VOTE'
}

export enum RespondentFeedItemBadgeType {
  BALANCING_ACT_SIMULATION = 'BALANCING_ACT_SIMULATION',
  CONTENT_POST = 'CONTENT_POST',
  ENGAGEMENT_PAGE = 'ENGAGEMENT_PAGE',
  IDEA = 'IDEA',
  POLCO_LIVE = 'POLCO_LIVE',
  POLL_SET = 'POLL_SET',
  QUESTION = 'QUESTION',
  REPOST = 'REPOST',
  SURVEY = 'SURVEY'
}

export enum RespondentFeedItemStatus {
  CLOSED = 'CLOSED',
  OPEN = 'OPEN'
}

export enum RespondentsSetStatus {
  CLOSED = 'CLOSED',
  COMPLETE = 'COMPLETE',
  NOT_STARTED = 'NOT_STARTED',
  START = 'START'
}

export enum ResponseStatType {
  AGE = 'AGE',
  GENDER = 'GENDER',
  LANGUAGE = 'LANGUAGE',
  LOCATION = 'LOCATION',
  RACE = 'RACE',
  SAMPLE = 'SAMPLE',
  VERIFIED_RESPONSES = 'VERIFIED_RESPONSES'
}

export interface ResponseStatsInput {
  readonly AGE?: InputMaybe<DemographicStatSourceInput>;
  readonly GENDER?: InputMaybe<DemographicStatSourceInput>;
  readonly LOCATION?: InputMaybe<DemographicLocationStatSourceInput>;
  readonly scopeByPublishingEntityId: Scalars['ID'];
  readonly type: ResponseStatType;
}

export interface ResultFilter {
  readonly publishingEntityId: Scalars['ID'];
  readonly type: ResultFilterOption;
}

export enum ResultFilterOption {
  REGISTERED = 'REGISTERED',
  SUBSCRIBERS = 'SUBSCRIBERS',
  VERIFIED = 'VERIFIED'
}

export interface ReviewSelectionNotification {
  readonly cost?: InputMaybe<Scalars['Float']>;
  readonly id: Scalars['ID'];
  readonly itemName: Scalars['String'];
}

export interface RowContentInput {
  readonly contentId: Scalars['ID'];
  readonly hierarchyId?: InputMaybe<Scalars['ID']>;
  readonly type: RowContentType;
}

export enum RowContentType {
  BA_RECEIPT = 'BA_RECEIPT',
  BA_SIM = 'BA_SIM',
  POLCO = 'POLCO'
}

export interface RowNodeInput {
  readonly ephemeralReferenceId: Scalars['ID'];
  readonly hierarchyId?: InputMaybe<Scalars['ID']>;
  readonly items: ReadonlyArray<RowContentInput>;
  readonly label: Scalars['String'];
  readonly metaConditionReferenceId?: InputMaybe<Scalars['ID']>;
  readonly numColumns: Scalars['Int'];
}

export enum SavedVisualizationActivationState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export interface ScaleDataInput {
  readonly scaleThreshold: Scalars['Int'];
  readonly scaleType: ScaleType;
}

export enum ScaleType {
  POSITIVE = 'POSITIVE',
  PROBLEMATIC = 'PROBLEMATIC'
}

export enum ShareableContentDomains {
  COMMUNITY_DESIGN = 'COMMUNITY_DESIGN',
  ECONOMY = 'ECONOMY',
  EDUCATION_ARTS_CULTURE = 'EDUCATION_ARTS_CULTURE',
  FINANCE = 'FINANCE',
  GENERAL = 'GENERAL',
  GOVERNANCE = 'GOVERNANCE',
  HEALTH_WELLNESS = 'HEALTH_WELLNESS',
  INCLUSIVITY_ENGAGEMENT = 'INCLUSIVITY_ENGAGEMENT',
  MOBILITY = 'MOBILITY',
  NATURAL_ENVIRONMENT = 'NATURAL_ENVIRONMENT',
  PARKS_RECREATION = 'PARKS_RECREATION',
  SAFETY = 'SAFETY',
  UTILITIES = 'UTILITIES'
}

export enum ShareableContentType {
  BENCHMARK = 'BENCHMARK',
  RECOMMENDED = 'RECOMMENDED',
  REPOST = 'REPOST',
  STANDARD_DEMO_QUESTIONS = 'STANDARD_DEMO_QUESTIONS'
}

export enum SimulationAlertType {
  BOTH = 'BOTH',
  DECREASE = 'DECREASE',
  INCREASE = 'INCREASE',
  NONE = 'NONE',
  THRESHOLD = 'THRESHOLD'
}

export interface SimulationCategoryEdit {
  readonly additionalDetails?: InputMaybe<Scalars['String']>;
  readonly adjustment: Scalars['Int'];
  readonly details?: InputMaybe<Scalars['String']>;
  readonly displayOrder: Scalars['Int'];
  readonly id?: InputMaybe<Scalars['Int']>;
  readonly isLocked: Scalars['Boolean'];
  readonly name: Scalars['String'];
  readonly subcategories: ReadonlyArray<SimulationSubcategoryEdit>;
  readonly type: SimulationCategoryType;
}

export enum SimulationCategoryType {
  EXPENSE = 'EXPENSE',
  REVENUE = 'REVENUE'
}

export interface SimulationInput {
  readonly adjustment: Scalars['Int'];
  readonly categories: ReadonlyArray<SimulationCategoryEdit>;
  readonly description?: InputMaybe<Scalars['String']>;
  readonly entryScreenClosingText?: InputMaybe<Scalars['String']>;
  readonly entryScreenIntroductionText?: InputMaybe<Scalars['String']>;
  readonly exitScreenClosingText?: InputMaybe<Scalars['String']>;
  readonly expenseDisclaimer?: InputMaybe<Scalars['String']>;
  readonly generalDisclaimer?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['Int'];
  readonly isBudgetHidden: Scalars['Boolean'];
  readonly isBudgetSubmittableWithDeficit: Scalars['Boolean'];
  readonly isCommentingEnabled: Scalars['Boolean'];
  readonly isExpenseBarChartEnabled: Scalars['Boolean'];
  readonly isExpenseChartEnabled: Scalars['Boolean'];
  readonly isExpenseOrderRandomized: Scalars['Boolean'];
  readonly isFooterHidden: Scalars['Boolean'];
  readonly isPb: Scalars['Boolean'];
  readonly isQuestionManagementEnabled: Scalars['Boolean'];
  readonly isRevenueChartEnabled: Scalars['Boolean'];
  readonly isRevenueOrderRandomized: Scalars['Boolean'];
  readonly isSharingEnabled: Scalars['Boolean'];
  readonly isTaxReceiptSubtotalBreakdownEnabled: Scalars['Boolean'];
  readonly locale: Scalars['String'];
  readonly mapFocusDisplay?: InputMaybe<Scalars['Boolean']>;
  readonly maxItems?: InputMaybe<Scalars['Int']>;
  readonly mode: BalancingActSimulationType;
  readonly name: Scalars['String'];
  readonly revenueDisclaimer?: InputMaybe<Scalars['String']>;
  readonly shareResultsEnabled: Scalars['Boolean'];
  readonly slug: Scalars['String'];
  readonly status: SimulationStatus;
  readonly submissionRedirectUrl?: InputMaybe<Scalars['String']>;
  readonly timerMinutes: Scalars['Int'];
}

export interface SimulationNodeInput {
  readonly ephemeralReferenceId: Scalars['ID'];
  readonly hierarchyId?: InputMaybe<Scalars['ID']>;
  readonly metaConditionReferenceId?: InputMaybe<Scalars['ID']>;
  readonly simulationId: Scalars['Int'];
  readonly simulationType: SimulationNodeType;
}

export enum SimulationNodeType {
  BUDGET = 'BUDGET',
  HOUSING = 'HOUSING',
  PRIORITIZE = 'PRIORITIZE',
  RECEIPT = 'RECEIPT'
}

export enum SimulationStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  INACTIVE = 'INACTIVE',
  NEW = 'NEW'
}

export interface SimulationSubcategoryEdit {
  readonly additionalDetails?: InputMaybe<Scalars['String']>;
  readonly adjustment: Scalars['Int'];
  readonly alertThreshold?: InputMaybe<Scalars['Int']>;
  readonly alertType: SimulationAlertType;
  readonly amount: Scalars['Int'];
  readonly ceilingAlertText?: InputMaybe<Scalars['String']>;
  readonly ceilingAmount: Scalars['Int'];
  readonly customIncrementAmount: Scalars['Int'];
  readonly customIncrementRate: Scalars['Int'];
  readonly customIncrementRateForTaxRate: Scalars['Int'];
  readonly customizedQuestionJson?: InputMaybe<Scalars['String']>;
  readonly details?: InputMaybe<Scalars['String']>;
  readonly displayOrder: Scalars['Int'];
  readonly floorAlertText?: InputMaybe<Scalars['String']>;
  readonly floorAmount: Scalars['Int'];
  readonly geojson?: InputMaybe<Scalars['String']>;
  readonly id?: InputMaybe<Scalars['Int']>;
  readonly inTour: Scalars['Boolean'];
  readonly isLocked: Scalars['Boolean'];
  readonly name: Scalars['String'];
  readonly suggestionBox: Scalars['Boolean'];
  readonly suggestionBoxMode?: InputMaybe<Scalars['String']>;
}

export enum SocialConnectionProvider {
  FACEBOOK = 'FACEBOOK',
  TWITTER = 'TWITTER'
}

export interface SocialLoginData {
  readonly token: Scalars['String'];
  readonly type: SocialLoginType;
}

export enum SocialLoginType {
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE'
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum StatisticType {
  INDEX = 'INDEX',
  INDICATOR = 'INDICATOR',
  SENTIMENT_VALUE = 'SENTIMENT_VALUE'
}

export enum StoreItemCategory {
  COMING_SOON = 'COMING_SOON',
  FEATURE = 'FEATURE',
  FREE_SERVICE = 'FREE_SERVICE',
  SERVICE = 'SERVICE',
  SURVEY = 'SURVEY',
  TIER = 'TIER',
  UNKNOWN = 'UNKNOWN'
}

export enum StoreItemProvider {
  NRC = 'NRC',
  POLCO = 'POLCO'
}

export enum StoreItemPublisherStatus {
  ACTIVATED = 'ACTIVATED',
  ACTIVATION_EXPIRED = 'ACTIVATION_EXPIRED',
  NEVER_ACTIVATED_OR_TRIALED = 'NEVER_ACTIVATED_OR_TRIALED',
  TRIAL_ACTIVATED = 'TRIAL_ACTIVATED',
  TRIAL_EXPIRED = 'TRIAL_EXPIRED',
  UNPAID = 'UNPAID'
}

export enum StoreItemsType {
  A_LA_CARTE = 'A_LA_CARTE',
  TIER = 'TIER'
}

export interface StorePurchaseNoPayment {
  readonly publishingEntityId: Scalars['ID'];
  readonly storeItemIds: ReadonlyArray<Scalars['ID']>;
  readonly transactionType: TransactionType;
}

export enum StripeInterval {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

export enum StripeUsageType {
  LICENSED = 'LICENSED',
  METERED = 'METERED'
}

export enum SubscriberStatType {
  AGE = 'AGE',
  GENDER = 'GENDER',
  LOCATION = 'LOCATION',
  RACE = 'RACE'
}

export interface SubscriberStatsInput {
  readonly AGE?: InputMaybe<DemographicStatSourceInput>;
  readonly GENDER?: InputMaybe<DemographicStatSourceInput>;
  readonly LOCATION?: InputMaybe<DemographicLocationStatSourceInput>;
  readonly type: SubscriberStatType;
}

export enum SubscriptionMode {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL'
}

export enum SubscriptionType {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL',
  MANUAL_UNFOLLOWED = 'MANUAL_UNFOLLOWED'
}

export interface SuperAdminPublisherAttributesInput {
  readonly baCustomerId?: InputMaybe<Scalars['Int']>;
  readonly envisioId?: InputMaybe<Scalars['String']>;
  readonly fips?: InputMaybe<Scalars['String']>;
  readonly isEnterprise?: InputMaybe<Scalars['Boolean']>;
}

export enum SuperAdminPublisherFilter {
  ACTIVATED_WITHOUT_GEO_MAPPING = 'ACTIVATED_WITHOUT_GEO_MAPPING',
  ACTIVATED_WITHOUT_HUBSPOT_MAPPING = 'ACTIVATED_WITHOUT_HUBSPOT_MAPPING'
}

export enum SurveyFormat {
  BOTH_ONLINE_AND_MAIL = 'BOTH_ONLINE_AND_MAIL',
  MAIL_ONLY = 'MAIL_ONLY',
  ONLINE_ONLY = 'ONLINE_ONLY'
}

export interface SurveyItems {
  readonly cost: Scalars['Float'];
  readonly description: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly title: Scalars['String'];
}

export interface SurveyNodeInput {
  readonly GRID?: InputMaybe<GridInput>;
  readonly HEADER?: InputMaybe<QuestionHeaderInput>;
  readonly QUESTION?: InputMaybe<QuestionInput>;
  readonly ROW?: InputMaybe<RowNodeInput>;
  readonly SIMULATION?: InputMaybe<SimulationNodeInput>;
  readonly VISUALIZATION?: InputMaybe<VisualizationNodeInput>;
  readonly type: QuestionHierarchyChildInputType;
}

export interface SurveyVoteInput {
  readonly GRID?: InputMaybe<ReadonlyArray<GridVoteInput>>;
  readonly QUESTION?: InputMaybe<VoteInput>;
  readonly type: SurveyVoteInputType;
}

export enum SurveyVoteInputType {
  GRID = 'GRID',
  QUESTION = 'QUESTION'
}

export interface SurveyVoteInputWithId {
  readonly input: SurveyVoteInput;
  readonly questionOrGridId: Scalars['ID'];
}

export interface TemplateParams {
  readonly key: Scalars['String'];
  readonly replaceWith: Scalars['String'];
}

export enum ThirdParty {
  HUBSPOT = 'HUBSPOT'
}

export interface ThirdPartyRecordInput {
  readonly publishingEntityId: Scalars['String'];
  readonly thirdParty: ThirdParty;
  readonly thirdPartyIdentifier: Scalars['String'];
}

export enum TimeBreakdownInterval {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK'
}

export enum TopicCategories {
  ARPA_KPI = 'ARPA_KPI',
  COMMUNITY_DESIGN = 'COMMUNITY_DESIGN',
  COMMUNITY_LIVABILITY = 'COMMUNITY_LIVABILITY',
  EMPLOYMENT_AND_FINANCES = 'EMPLOYMENT_AND_FINANCES',
  EQUITY_AND_INCLUSION = 'EQUITY_AND_INCLUSION',
  HEALTH_AND_WELLNESS = 'HEALTH_AND_WELLNESS',
  INFORMATION_AND_ASSISTANCE = 'INFORMATION_AND_ASSISTANCE',
  OVERALL = 'OVERALL',
  OVERALL_COMMUNITY_QUALITY = 'OVERALL_COMMUNITY_QUALITY',
  PRODUCTIVE_ACTIVITIES = 'PRODUCTIVE_ACTIVITIES'
}

export interface TopicFilter {
  readonly CATEGORIES?: InputMaybe<ReadonlyArray<TopicCategories>>;
  readonly DOMAIN?: InputMaybe<Scalars['String']>;
  readonly IDS?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly type: TopicFilterType;
}

export enum TopicFilterType {
  ALL_CATEGORIZED = 'ALL_CATEGORIZED',
  ALL_NON_QUALITATIVE = 'ALL_NON_QUALITATIVE',
  CATEGORIES = 'CATEGORIES',
  DOMAIN = 'DOMAIN',
  IDS = 'IDS'
}

export interface TopicQualitativeQuestionResultSortInput {
  readonly qualitativeQuestionType: QualitativeTopics;
  readonly sortBy: QualitativeQuestionResultSortType;
}

export interface TopicSortInput {
  readonly QUALITATIVE_QUESTION_RESULT?: InputMaybe<TopicQualitativeQuestionResultSortInput>;
  readonly order: SortOrder;
  readonly type: TopicSortType;
}

export enum TopicSortType {
  QUALITATIVE_QUESTION_RESULT = 'QUALITATIVE_QUESTION_RESULT'
}

export enum TrackAreaMode {
  COMPARISON_GROUP = 'COMPARISON_GROUP',
  LOCAL = 'LOCAL',
  NATIONAL = 'NATIONAL'
}

export enum TrackVariableDirection {
  NEG = 'NEG',
  POS = 'POS'
}

export interface TrackVariableVisualizationInput {
  readonly baseFips?: InputMaybe<Scalars['String']>;
  readonly benchmarkFilter: BenchmarkFilter;
  readonly comparisongroupId?: InputMaybe<Scalars['String']>;
  readonly groupFips: ReadonlyArray<Scalars['String']>;
  readonly publishingEntityId: Scalars['ID'];
  readonly recordedAt?: InputMaybe<GqlDateInput>;
  readonly state: SavedVisualizationActivationState;
  readonly variableId: Scalars['ID'];
  readonly visualizationType?: InputMaybe<VisualizationType>;
}

export enum TransactionType {
  EXPRESS_INTEREST = 'EXPRESS_INTEREST',
  FREE_ITEM = 'FREE_ITEM',
  FREE_TRIAL = 'FREE_TRIAL',
  QUOTE = 'QUOTE'
}

export interface Translation {
  readonly language: LanguageKey;
  readonly value: Scalars['String'];
}

export interface TranslationSet {
  readonly defaultValue: Scalars['String'];
  readonly translations: ReadonlyArray<Translation>;
}

export enum TrendValue {
  HIGHER = 'HIGHER',
  LOWER = 'LOWER',
  SIMILAR = 'SIMILAR'
}

export interface UpdateGoalInput {
  readonly goalId: Scalars['ID'];
  readonly publishingEntityId: Scalars['ID'];
  readonly value: Scalars['Float'];
}

export interface UpdatePerformanceDataVisualizationInput {
  readonly state: SavedVisualizationActivationState;
  readonly visualizationId: Scalars['ID'];
}

export interface UpdateRespondentProfileInput {
  readonly avatarUrl?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly firstName?: InputMaybe<Scalars['String']>;
  readonly inputtedLat?: InputMaybe<Scalars['Float']>;
  readonly inputtedLon?: InputMaybe<Scalars['Float']>;
  readonly lastName?: InputMaybe<Scalars['String']>;
  readonly outcomeEmailEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly outreachEmailEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly postAnonymously?: InputMaybe<Scalars['Boolean']>;
  readonly requestLocationLastShown?: InputMaybe<GqlDateInput>;
  readonly weeklyEmailEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly zipCode?: InputMaybe<Scalars['String']>;
}

export interface UploadShortUrlInput {
  readonly fullUrl: Scalars['String'];
  readonly shortUrl: Scalars['String'];
}

export enum VariableDemographicSegment {
  ALL = 'ALL',
  OA = 'OA'
}

export enum VariableDisplayType {
  DEFAULT = 'DEFAULT',
  OLDER_ADULTS = 'OLDER_ADULTS'
}

export interface VisualizationNodeInput {
  readonly ephemeralReferenceId: Scalars['ID'];
  readonly hierarchyId?: InputMaybe<Scalars['ID']>;
  readonly label?: InputMaybe<Scalars['String']>;
  readonly metaConditionReferenceId?: InputMaybe<Scalars['ID']>;
  readonly visualizationId: Scalars['ID'];
}

export enum VisualizationType {
  HISTOGRAM = 'HISTOGRAM',
  LINE = 'LINE',
  MAP = 'MAP',
  PROGRESS = 'PROGRESS'
}

export interface VoteAcknowledge {
  readonly _dontUse?: InputMaybe<Scalars['Boolean']>;
}

export interface VoteFreeText {
  readonly comment: Scalars['String'];
}

export interface VoteInput {
  readonly VOTE_ACKNOWLEDGE?: InputMaybe<VoteAcknowledge>;
  readonly VOTE_FREE_TEXT?: InputMaybe<VoteFreeText>;
  readonly VOTE_MULTIPLE_CHOICES?: InputMaybe<VoteMultipleChoicesInput>;
  readonly VOTE_POINT_ALLOCATION?: InputMaybe<VotePointAllocation>;
  readonly type: InputVoteType;
}

export interface VoteMetadataEntry {
  readonly type: Scalars['String'];
  readonly value: Scalars['String'];
}

export interface VoteMultipleChoicesInput {
  readonly choices: ReadonlyArray<McChoice>;
}

export interface VotePointAllocation {
  readonly choices: ReadonlyArray<PointAllocationChoice>;
}

export enum VoteType {
  DOWN = 'DOWN',
  NONE = 'NONE',
  UP = 'UP'
}

export type AggregateResults = { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly topic: string | null, readonly category: string | null, readonly choices: ReadonlyArray<{ readonly __typename: 'AggregateVotingChoice', readonly rawTotal: number, readonly weightedTotal: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly trendSignificance: number | null, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly scalePercent: number, readonly value: TrendValue | null, readonly date: { readonly __typename: 'GqlDate', readonly raw: number }, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null }> } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue, readonly rank: number, readonly totalDataPoints: number, readonly benchmarkSignificance: number | null, readonly dateRange: { readonly __typename: 'BenchmarkDateRange', readonly start: { readonly __typename: 'GqlDate', readonly raw: number }, readonly end: { readonly __typename: 'GqlDate', readonly raw: number } } } | null };

export type BalancingActReportingCategory_BalancingActReportingCategory_ = { readonly __typename: 'BalancingActReportingCategory', readonly id: number, readonly averageAmountDecreased: number, readonly averageAmountIncreased: number, readonly averagePercentChange: number, readonly averageSessionAmountChanged: number, readonly averageSessionDecreased: number, readonly averageSessionIncreased: number, readonly averageSubmittedAmount: number, readonly averageSubmittedAmountChanged: number, readonly decreaseClicks: number, readonly detailsClicks: number, readonly displayOrder: number, readonly increaseClicks: number, readonly infoClicks: number, readonly maxSubmittedAmount: number, readonly medianSessionAmountChanged: number, readonly medianSubmittedAmountChanged: number, readonly modeSessionAmountChanged: number, readonly modeSubmittedAmountChanged: number, readonly minSubmittedAmount: number, readonly name: string, readonly percentSubmissionsChanged: number, readonly percentSubmissionsDecreased: number, readonly percentSubmissionsIncreased: number, readonly percentSubmissionsUnchanged: number, readonly totalSubmissionsChanged: number, readonly totalSubmissionsDecreased: number, readonly totalSubmissionsIncreased: number, readonly totalSubmissionsUnchanged: number };

export type BalancingActReportingCategory_BalancingActReportingSubcategory_ = { readonly __typename: 'BalancingActReportingSubcategory', readonly id: number, readonly averageAmountDecreased: number, readonly averageAmountIncreased: number, readonly averagePercentChange: number, readonly averageSessionAmountChanged: number, readonly averageSessionDecreased: number, readonly averageSessionIncreased: number, readonly averageSubmittedAmount: number, readonly averageSubmittedAmountChanged: number, readonly decreaseClicks: number, readonly detailsClicks: number, readonly displayOrder: number, readonly increaseClicks: number, readonly infoClicks: number, readonly maxSubmittedAmount: number, readonly medianSessionAmountChanged: number, readonly medianSubmittedAmountChanged: number, readonly modeSessionAmountChanged: number, readonly modeSubmittedAmountChanged: number, readonly minSubmittedAmount: number, readonly name: string, readonly percentSubmissionsChanged: number, readonly percentSubmissionsDecreased: number, readonly percentSubmissionsIncreased: number, readonly percentSubmissionsUnchanged: number, readonly totalSubmissionsChanged: number, readonly totalSubmissionsDecreased: number, readonly totalSubmissionsIncreased: number, readonly totalSubmissionsUnchanged: number };

export type BalancingActReportingCategory = BalancingActReportingCategory_BalancingActReportingCategory_ | BalancingActReportingCategory_BalancingActReportingSubcategory_;

export type Breakdown = { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> };

export type ComparisonGroupTrackDomain = { readonly __typename: 'TrackDomain', readonly id: string, readonly domain: AnalyticsDomain, readonly fips: ReadonlyArray<string>, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }>, readonly indicators: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> };

export type DomainTrackVariables = { readonly __typename: 'TrackDomain', readonly id: string, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }>, readonly sentimentValues: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }>, readonly indicators: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> };

export type Multilang = { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> };

export type PerformanceDatum_Variable = { readonly __typename: 'AnalyticsVariable', readonly id: string, readonly name: string, readonly statisticType: StatisticType, readonly valueType: AnalyticsValueType, readonly suffix: string | null, readonly label: string, readonly description: string | null, readonly source: string | null, readonly dateLevel: DateLevel, readonly includedInIndex: boolean, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> };

export type AdminSimulationNode = { readonly __typename: 'QuestionHierarchySimulationNode', readonly id: string, readonly simulationType: SimulationNodeType, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly simulation: { readonly __typename: 'SimulationNodeData', readonly id: number, readonly url: string, readonly adminData: { readonly __typename: 'SimulationNodeAdminData', readonly name: string, readonly description: string | null, readonly prioritization: boolean, readonly simulationType: BalancingActSimulationType, readonly status: QuestionSetStatus } | null } | null };

export type VisualizationNode = { readonly __typename: 'QuestionHierarchyVisualizationNode', readonly id: string, readonly altLabel: string | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly trackVariableVisualization: { readonly __typename: 'TrackVariableVisualization', readonly id: string, readonly fips: string | null, readonly publishingEntityId: string, readonly benchmarkFilter: BenchmarkFilter, readonly visualizationType: VisualizationType | null, readonly state: SavedVisualizationActivationState, readonly comparisonGroupId: string | null, readonly visualizationAreas: ReadonlyArray<{ readonly __typename: 'FipsArea', readonly id: string, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null }>, readonly plans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }>, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly trackVariables: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } | { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }> } | null };

export type QuestionResults_Fragment = { readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } };

export type RespondentFeed_Item = { readonly __typename: 'RespondentFeedItem', readonly id: string, readonly image: string | null, readonly isPinnedToPublisher: boolean, readonly primaryCallout: string, readonly bottomData: string | null, readonly bottomIcon: BottomIcon | null, readonly badges: ReadonlyArray<{ readonly __typename: 'RespondentFeedItemBadge', readonly type: RespondentFeedItemBadgeType, readonly label: string }>, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly subscriptionType: SubscriptionType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }>, readonly presidingArea: { readonly __typename: 'PresidingArea', readonly id: string, readonly name: string } | null }, readonly topAction: { readonly __typename: 'RespondentFeedItemAction', readonly type: RespondentFeedItemActionType } | null, readonly dotActions: ReadonlyArray<{ readonly __typename: 'RespondentFeedItemAction', readonly type: RespondentFeedItemActionType }>, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly primaryAction: { readonly __typename: 'RespondentFeedItemAction', readonly type: RespondentFeedItemActionType }, readonly secondaryBottomActions: ReadonlyArray<{ readonly __typename: 'RespondentFeedItemAction', readonly type: RespondentFeedItemActionType }>, readonly typedData: { readonly __typename: 'RespondentFeedItemTypedData_BalancingActSimulation', readonly id: string, readonly contentState: RespondentFeedItemStatus, readonly simulationType: string } | { readonly __typename: 'RespondentFeedItemTypedData_Idea', readonly id: string, readonly idea: { readonly __typename: 'Idea', readonly id: string, readonly respondentVote: VoteType, readonly respondent: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly publicName: string } | { readonly __typename: 'PublicRespondent', readonly id: string, readonly publicName: string }, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly aggregations: { readonly __typename: 'IdeaAggregations', readonly voteUp: number, readonly voteDown: number } | null } } | { readonly __typename: 'RespondentFeedItemTypedData_Question', readonly id: string, readonly voted: boolean, readonly acknowledgeOnly: boolean, readonly setSlug: string | null, readonly setId: string, readonly contentState: RespondentFeedItemStatus } | { readonly __typename: 'RespondentFeedItemTypedData_QuestionSet', readonly id: string, readonly slug: string | null, readonly contentType: QuestionSetType, readonly contentState: RespondentFeedItemStatus, readonly shareable: boolean } };

export type RespondentSimulationNode = { readonly __typename: 'QuestionHierarchySimulationNode', readonly id: string, readonly simulationType: SimulationNodeType, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly simulation: { readonly __typename: 'SimulationNodeData', readonly id: number, readonly url: string } | null };

export type RowContentHierarchyNodes = { readonly __typename: 'QuestionHierarchyParentNode', readonly rowContents: ReadonlyArray<{ readonly __typename: 'RowContentHierarchyNodeBaReceipt', readonly id: string, readonly receipt: { readonly __typename: 'BalancingActSimulationWithPubId', readonly id: number, readonly name: string, readonly simulationType: string, readonly publishedAt: { readonly __typename: 'GqlDate', readonly raw: number } } } | { readonly __typename: 'RowContentHierarchyNodeBaSim', readonly id: string, readonly simulation: { readonly __typename: 'BalancingActSimulationWithPubId', readonly id: number, readonly name: string, readonly simulationType: string, readonly prioritization: boolean, readonly publishedAt: { readonly __typename: 'GqlDate', readonly raw: number } } } | { readonly __typename: 'RowContentHierarchyNodePolco', readonly id: string, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'Survey', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } }> };

export type SimulationCategory = { readonly __typename: 'SimulationCategory', readonly id: number, readonly name: string, readonly type: SimulationCategoryType, readonly displayOrder: number, readonly isLocked: boolean, readonly details: string | null, readonly subcategories: ReadonlyArray<{ readonly __typename: 'SimulationSubcategory', readonly id: number, readonly name: string, readonly displayOrder: number, readonly amount: number, readonly details: string | null, readonly isLocked: boolean, readonly inTour: boolean }> };

export type StatBreakdownLocation = { readonly __typename: 'StatBreakdownLocation', readonly center: { readonly __typename: 'CoordinateCenter', readonly size: number, readonly coordinate: { readonly __typename: 'Coordinate', readonly lat: number, readonly lng: number } }, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownLocationValue', readonly key: string, readonly total: number, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } }> };

export type StrategicPlan = { readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> };

export type SurveyBenchmarkTopic = { readonly __typename: 'SurveyBenchmarkTopic', readonly id: string, readonly topic: { readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string, readonly icon: string | null, readonly description: string | null, readonly trackDomain: AnalyticsDomain | null, readonly category: { readonly __typename: 'TopicCategory', readonly id: string, readonly name: string, readonly priority: number | null } | null } };

export type TrackVisualization = { readonly __typename: 'TrackVariableVisualization', readonly id: string, readonly fips: string | null, readonly publishingEntityId: string, readonly benchmarkFilter: BenchmarkFilter, readonly visualizationType: VisualizationType | null, readonly state: SavedVisualizationActivationState, readonly comparisonGroupId: string | null, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly trackVariables: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } | { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }> };

export type TrackVariableWithDistribution = { readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> };

export type TrackVariable = { readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> };

export type TrendAggregateResult = { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly trendSignificance: number | null, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly scalePercent: number, readonly value: TrendValue | null, readonly date: { readonly __typename: 'GqlDate', readonly raw: number }, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null }> };

export type TrackVariables = { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }> }> };

export type TrackVariableWithDistributions = { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> };

export type AddAdminToPublishingEntityVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  adminEmail: Scalars['String'];
  adminName: Scalars['String'];
  roleId?: InputMaybe<Scalars['ID']>;
}>;


export type AddAdminToPublishingEntity = { readonly addAdminToPublishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly managingAdmins: ReadonlyArray<{ readonly __typename: 'PublishingEntityAdmin', readonly id: string, readonly roleId: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly name: string, readonly email: string } | { readonly __typename: 'PublicAdmin', readonly id: string, readonly name: string } }> | null } };

export type AddCommentVariables = Exact<{
  questionId: Scalars['ID'];
  comment: Scalars['String'];
}>;


export type AddComment = { readonly addComment: { readonly __typename: 'Comment', readonly id: string, readonly comment: string, readonly commenter: { readonly __typename: 'PrivateRespondent', readonly id: string } | { readonly __typename: 'PublicRespondent', readonly id: string }, readonly commentDate: { readonly __typename: 'GqlDate', readonly raw: number } } };

export type AdminAiAssistantCancelProcessingVariables = Exact<{
  sessionId: Scalars['ID'];
  assistant: AssistantIdInput;
}>;


export type AdminAiAssistantCancelProcessing = { readonly adminAiAssistantCancelProcessing: { readonly __typename: 'AiAssistantSession', readonly id: string, readonly queryStatus: { readonly __typename: 'AiAssistantQueryStatus', readonly type: AiAssistantQueryStatusType, readonly message: string | null, readonly loadingText: string | null } | null } };

export type AdminAiAssistantCreateSessionVariables = Exact<{
  sessionId: Scalars['ID'];
  assistant: AssistantIdInput;
  sessionIdToResume?: InputMaybe<Scalars['ID']>;
}>;


export type AdminAiAssistantCreateSession = { readonly adminAiAssistantCreateSession: string | null };

export type AdminAiAssistantDeleteUserSessionVariables = Exact<{
  sessionId: Scalars['ID'];
}>;


export type AdminAiAssistantDeleteUserSession = { readonly adminAiAssistantDeleteUserSession: boolean };

export type AdminAiAssistantPostMessageVariables = Exact<{
  sessionId: Scalars['ID'];
  assistant: AssistantIdInput;
  messageContent: Scalars['String'];
}>;


export type AdminAiAssistantPostMessage = { readonly adminAiAssistantPostMessage: { readonly __typename: 'AiAssistantSessionWithStats', readonly id: string, readonly queryStatus: { readonly __typename: 'AiAssistantQueryStatus', readonly type: AiAssistantQueryStatusType, readonly message: string | null, readonly loadingText: string | null } | null, readonly stats: { readonly __typename: 'AiAssistantPublisher', readonly publishingEntityId: string, readonly sessionCount: number, readonly queryCount: number } } };

export type AdminAiAssistantUpdateUserSessionVariables = Exact<{
  sessionId: Scalars['ID'];
  input: AiAssistantUserSessionUpdateInput;
}>;


export type AdminAiAssistantUpdateUserSession = { readonly adminAiAssistantUpdateUserSession: { readonly __typename: 'AiAssistantUserSession', readonly id: string, readonly name: string | null } };

export type AdminAiAssistantUploadFileVariables = Exact<{
  sessionId: Scalars['ID'];
  assistant: AssistantIdInput;
  file: Scalars['String'];
  fileName: Scalars['String'];
}>;


export type AdminAiAssistantUploadFile = { readonly adminAiAssistantUploadFile: string };

export type AdminCopyContentSetVariables = Exact<{
  contentSetId: Scalars['ID'];
  receivingPublishingEntityId: Scalars['ID'];
  questionRelationship: QuestionRelationshipType;
  newName: Scalars['String'];
  templateParams: ReadonlyArray<TemplateParams> | TemplateParams;
}>;


export type AdminCopyContentSet = { readonly adminCopyContentSet: { readonly __typename: 'GenericContent', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | { readonly __typename: 'Survey', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } };

export type AdminCreateEmailListVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  listName: Scalars['String'];
  emails?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type AdminCreateEmailList = { readonly adminCreateEmailList: { readonly __typename: 'EmailList', readonly id: string, readonly name: string, readonly emails: ReadonlyArray<string> } };

export type AdminCreateSocialConnectionVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  input: AdminCreateSocialConnectionInput;
}>;


export type AdminCreateSocialConnection = { readonly adminCreateSocialConnection: { readonly __typename: 'PendingSocialConnection', readonly provider: SocialConnectionProvider, readonly availableAccounts: ReadonlyArray<{ readonly __typename: 'SocialConnectionAccount', readonly id: string, readonly name: string }> | null } };

export type AdminCsvReportUrlVariables = Exact<{
  input: CsvReportInput;
}>;


export type AdminCsvReportUrl = { readonly adminCsvReportUrl: string | null };

export type DeletePollSetQuestionVariables = Exact<{
  questionId: Scalars['ID'];
}>;


export type DeletePollSetQuestion = { readonly deletePollSetQuestion: boolean };

export type AdminDeleteSocialConnectionVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  socialConnectionType: SocialConnectionProvider;
}>;


export type AdminDeleteSocialConnection = { readonly adminDeleteSocialConnection: boolean };

export type AdminDuplicateSimulationVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  balancingActSimulationId: Scalars['Int'];
  type: BalancingActSimulationType;
}>;


export type AdminDuplicateSimulation = { readonly duplicateSimulation: { readonly __typename: 'DuplicateSimulationResult', readonly id: number } };

export type AdminEnableTrackDomainFeatureSettingsVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  featureSettings: ReadonlyArray<FeatureSettingInput> | FeatureSettingInput;
}>;


export type AdminEnableTrackDomainFeatureSettings = { readonly adminEnableTrackDomainFeatureSettings: ReadonlyArray<{ readonly __typename: 'PublishingEntityFeatureSetting', readonly id: string, readonly featureSettingId: string, readonly featureSettingName: string, readonly enabled: boolean, readonly quantity: number, readonly isUnlimited: boolean, readonly expirationDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }> };

export type AdminGenerateBenchmarkSurveyPdfVariables = Exact<{
  surveyId: Scalars['ID'];
}>;


export type AdminGenerateBenchmarkSurveyPdf = { readonly generateBenchmarkSurveyPdf: boolean };

export type AdminMakeNoPaymentStorePurchaseVariables = Exact<{
  input: StorePurchaseNoPayment;
}>;


export type AdminMakeNoPaymentStorePurchase = { readonly adminMakeNoPaymentStorePurchase: ReadonlyArray<{ readonly __typename: 'PublishingEntityStoreItem', readonly id: string, readonly status: StoreItemPublisherStatus, readonly purchasedInStripe: boolean, readonly expiresAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly storeItem: { readonly __typename: 'StoreItem', readonly id: string, readonly name: string, readonly provider: StoreItemProvider, readonly shortDescription: string, readonly longDescription: string, readonly freeTrialLengthMs: number | null, readonly purchaseLengthMs: number, readonly repurchaseDelayMs: number, readonly key: string, readonly thumbnailUrl: string | null, readonly mainImageUrl: string | null, readonly category: StoreItemCategory, readonly oneTime: boolean, readonly stripeId: string | null, readonly linkedFeatureSettingId: string | null, readonly plans: ReadonlyArray<{ readonly __typename: 'StoreItemPlan', readonly id: string, readonly active: boolean, readonly amount: number | null, readonly trialPeriodDays: number | null, readonly billingScheme: BillingScheme | null, readonly interval: StripeInterval, readonly intervalCount: number, readonly nickname: string | null, readonly product: string, readonly usageType: StripeUsageType }>, readonly childStoreItems: ReadonlyArray<{ readonly __typename: 'StoreItem', readonly id: string, readonly key: string, readonly name: string, readonly shortDescription: string, readonly category: StoreItemCategory, readonly order: number | null, readonly isHiddenInUI: boolean }> } }> };

export type AdminRegistrationAdditionalDataVariables = Exact<{
  registrationId: Scalars['ID'];
  additionalData: AdminRegistrationAdditionalDataInput;
}>;


export type AdminRegistrationAdditionalData = { readonly adminRegistrationAdditionalData: { readonly __typename: 'AdminRegistration', readonly id: string, readonly registrationReason: { readonly __typename: 'AdminRegistrationReason', readonly id: string } | null, readonly desiredOutcome: { readonly __typename: 'AdminRegistrationOutcome', readonly id: string } | null, readonly interests: ReadonlyArray<{ readonly __typename: 'AdminRegistrationInterest', readonly id: string }> } };

export type AdminRegistrationForRespondentVariables = Exact<{
  metadata: ReadonlyArray<RegistrationMetadataEntry> | RegistrationMetadataEntry;
}>;


export type AdminRegistrationForRespondent = { readonly adminRegistrationForRespondent: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly registrationRequests: ReadonlyArray<{ readonly __typename: 'AdminRegistration', readonly id: string, readonly createdTime: { readonly __typename: 'GqlDate', readonly raw: number } }> } | { readonly __typename: 'PublicAdmin' } | null } | null } };

export type AdminRegistrationProfileSelectionVariables = Exact<{
  registrationId: Scalars['ID'];
  profileInput: AdminRegistrationProfileSelectionInput;
}>;


export type AdminRegistrationProfileSelection = { readonly adminRegistrationProfileSelection: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly registrationRequests: ReadonlyArray<{ readonly __typename: 'AdminRegistration', readonly id: string, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly type: { readonly __typename: 'PublishingEntityType', readonly id: string } | null, readonly presidingArea: { readonly __typename: 'PresidingArea', readonly id: string, readonly name: string, readonly center: { readonly __typename: 'CoordinateCenter', readonly size: number, readonly coordinate: { readonly __typename: 'Coordinate', readonly lat: number, readonly lng: number } } } | null } | null, readonly metadata: ReadonlyArray<{ readonly __typename: 'AdminRegistrationMetadata', readonly key: string, readonly value: string }> }>, readonly activePublishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly type: { readonly __typename: 'PublishingEntityType', readonly id: string } | null, readonly presidingArea: { readonly __typename: 'PresidingArea', readonly id: string, readonly name: string, readonly center: { readonly __typename: 'CoordinateCenter', readonly size: number, readonly coordinate: { readonly __typename: 'Coordinate', readonly lat: number, readonly lng: number } } } | null } | null } | { readonly __typename: 'PublicAdmin' } };

export type AdminRegistrationUserCreationVariables = Exact<{
  userData: AdminRegistrationUserInput;
  metadata: ReadonlyArray<RegistrationMetadataEntry> | RegistrationMetadataEntry;
}>;


export type AdminRegistrationUserCreation = { readonly adminRegistrationUserCreation: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly registrationRequests: ReadonlyArray<{ readonly __typename: 'AdminRegistration', readonly id: string, readonly createdTime: { readonly __typename: 'GqlDate', readonly raw: number } }> } | { readonly __typename: 'PublicAdmin' } | null } | null } };

export type AdminRequestFeatureContactInfoVariables = Exact<{
  input: RequestFeatureContactInfo;
}>;


export type AdminRequestFeatureContactInfo = { readonly adminRequestFeatureContactInfo: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly requestedFeatures: ReadonlyArray<string>, readonly commsEmail: string | null, readonly phoneNumber: string | null, readonly phoneExt: string | null } | { readonly __typename: 'PublicAdmin' } };

export type AdminRequestFeaturesVariables = Exact<{
  features: ReadonlyArray<Scalars['String']> | Scalars['String'];
}>;


export type AdminRequestFeatures = { readonly adminRequestFeatures: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly requestedFeatures: ReadonlyArray<string> } | { readonly __typename: 'PublicAdmin' } };

export type AdminResendVerificationEmailVariables = Exact<{ [key: string]: never; }>;


export type AdminResendVerificationEmail = { readonly adminResendVerificationEmail: ResendVerificationEmailResult };

export type AdminRevertSurveyToDraftVariables = Exact<{
  surveyId: Scalars['ID'];
}>;


export type AdminRevertSurveyToDraft = { readonly adminRevertSurveyToDraft: { readonly __typename: 'GenericContent', readonly id: string, readonly totalRespondents: number | null, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly totalRespondents: number | null, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly totalRespondents: number | null, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } } | { readonly __typename: 'Survey', readonly id: string, readonly totalRespondents: number | null, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } } };

export type AdminSaveNewTrackGoalVariables = Exact<{
  input: CreateGoalInput;
}>;


export type AdminSaveNewTrackGoal = { readonly adminSaveNewTrackGoal: { readonly __typename: 'PublishingEntity', readonly id: string, readonly strategicPlans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }> } };

export type AdminSaveNewVisualizationVariables = Exact<{
  input: TrackVariableVisualizationInput;
  areaMode?: InputMaybe<TrackAreaMode>;
  comparisonGroupId?: InputMaybe<Scalars['ID']>;
  fipsCodes?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type AdminSaveNewVisualization = { readonly adminSaveNewVisualizationWithMultipleFips: { readonly __typename: 'PublishingEntity', readonly id: string, readonly trackVariableVisualizations: ReadonlyArray<{ readonly __typename: 'TrackVariableVisualization', readonly id: string, readonly fips: string | null, readonly publishingEntityId: string, readonly benchmarkFilter: BenchmarkFilter, readonly visualizationType: VisualizationType | null, readonly state: SavedVisualizationActivationState, readonly comparisonGroupId: string | null, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly trackVariables: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } | { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }> }> } };

export type ScheduleQuestionsVariables = Exact<{
  questionSetId: Scalars['ID'];
  questions: ReadonlyArray<QuestionScheduleWithIdInput> | QuestionScheduleWithIdInput;
  accessSetting?: InputMaybe<AccessSettingInput>;
}>;


export type ScheduleQuestions = { readonly scheduleQuestions: { readonly __typename: 'GenericContent', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly contents: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus } } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus } }> } | { readonly __typename: 'QuestionHierarchySimulationNode' } | { readonly __typename: 'QuestionHierarchyVisualizationNode' }> } | { readonly __typename: 'PolcoLive', readonly id: string, readonly createdQuestions: { readonly __typename: 'CreatedQuestionsData', readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } }> } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly createdQuestions: { readonly __typename: 'CreatedQuestionsData', readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } }> } } | { readonly __typename: 'Survey', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly contents: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus } } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus } }> } | { readonly __typename: 'QuestionHierarchySimulationNode' } | { readonly __typename: 'QuestionHierarchyVisualizationNode' }> } };

export type AdminSendOutreachEmailVariables = Exact<{
  emailListIds: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
  publishingEntityId: Scalars['ID'];
  emailSubscribers: Scalars['Boolean'];
  questionSetId: Scalars['ID'];
  subject: Scalars['String'];
  message: Scalars['String'];
  sendDate?: InputMaybe<GqlDateInput>;
}>;


export type AdminSendOutreachEmail = { readonly adminSendOutreachEmail: boolean };

export type AdminSendShareEmailVariables = Exact<{
  emailArgs: AdminShareEmailInput;
}>;


export type AdminSendShareEmail = { readonly adminSendSharePolcoEmail: boolean };

export type AdminSetActivePublishingEntityVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type AdminSetActivePublishingEntity = { readonly adminSetActivePublishingEntity: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly superAdmin: boolean, readonly demoPollyUrl: string | null, readonly activePublishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly activationState: PublishingEntityActivationState, readonly showExampleQuestions: boolean, readonly slug: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly url: string, readonly type: PublishingEntityAssetType }>, readonly featureSettings: ReadonlyArray<{ readonly __typename: 'PublishingEntityFeatureSetting', readonly id: string, readonly featureSettingId: string, readonly featureSettingName: string, readonly enabled: boolean, readonly quantity: number, readonly isUnlimited: boolean, readonly expirationDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }> | null } | null } | { readonly __typename: 'PublicAdmin' } };

export type SetPollSetQuestionVariables = Exact<{
  questionSetId: Scalars['ID'];
  input: QuestionInput;
  schedule?: InputMaybe<QuestionScheduleInput>;
}>;


export type SetPollSetQuestion = { readonly setPollSetQuestion: { readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly isBenchmarkedQuestion: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } } };

export type AdminSetPublishingEntityShortUrlVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  url?: InputMaybe<Scalars['String']>;
}>;


export type AdminSetPublishingEntityShortUrl = { readonly adminSetPublishingEntityShortUrl: { readonly __typename: 'ShortUrl', readonly id: string, readonly shortUrl: string } | null };

export type AdminSetShowExampleQuestionsVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  show: Scalars['Boolean'];
}>;


export type AdminSetShowExampleQuestions = { readonly adminSetShowExampleQuestions: { readonly __typename: 'PublishingEntity', readonly id: string, readonly showExampleQuestions: boolean } };

export type SetSurveyContentsVariables = Exact<{
  questionSetId: Scalars['ID'];
  input: ReadonlyArray<SurveyNodeInput> | SurveyNodeInput;
  conditions: ConditionsInput;
  areaMode?: InputMaybe<TrackAreaMode>;
  comparisonGroupId?: InputMaybe<Scalars['ID']>;
  fipsCodes?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type SetSurveyContents = { readonly setSurveyContents: { readonly __typename: 'Survey', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly contents: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly questionNumber: number | null, readonly summary: string | null, readonly optional: boolean, readonly variableName: string | null, readonly reportDisplayLabel: string | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly displayName: string, readonly combinationOperator: MetaConditionCombinationOperator, readonly childMetaConditionIds: ReadonlyArray<string> }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }> }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly questionNumber: number | null, readonly nodeType: QuestionHierarchyParentNodeType, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly displayName: string, readonly combinationOperator: MetaConditionCombinationOperator, readonly childMetaConditionIds: ReadonlyArray<string> }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly variableName: string | null, readonly reportDisplayLabel: string | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly displayName: string, readonly combinationOperator: MetaConditionCombinationOperator, readonly childMetaConditionIds: ReadonlyArray<string> }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }> } }> } | { readonly __typename: 'QuestionHierarchySimulationNode', readonly id: string, readonly simulationType: SimulationNodeType, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly simulation: { readonly __typename: 'SimulationNodeData', readonly id: number, readonly url: string, readonly adminData: { readonly __typename: 'SimulationNodeAdminData', readonly name: string, readonly description: string | null, readonly prioritization: boolean, readonly simulationType: BalancingActSimulationType, readonly status: QuestionSetStatus } | null } | null } | { readonly __typename: 'QuestionHierarchyVisualizationNode', readonly id: string, readonly altLabel: string | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly trackVariableVisualization: { readonly __typename: 'TrackVariableVisualization', readonly id: string, readonly fips: string | null, readonly publishingEntityId: string, readonly benchmarkFilter: BenchmarkFilter, readonly visualizationType: VisualizationType | null, readonly state: SavedVisualizationActivationState, readonly comparisonGroupId: string | null, readonly visualizationAreas: ReadonlyArray<{ readonly __typename: 'FipsArea', readonly id: string, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null }>, readonly plans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }>, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly trackVariables: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } | { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }> } | null }>, readonly allConditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly displayName: string, readonly combinationOperator: MetaConditionCombinationOperator, readonly childMetaConditionIds: ReadonlyArray<string> }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> } } };

export type AdminTrackEventInCrmVariables = Exact<{
  event: CrmTrackedEvent;
}>;


export type AdminTrackEventInCrm = { readonly adminTrackEventInCrm: boolean };

export type AdminUpdateEmailListVariables = Exact<{
  emailListId: Scalars['ID'];
  emails: ReadonlyArray<Scalars['String']> | Scalars['String'];
  name: Scalars['String'];
}>;


export type AdminUpdateEmailList = { readonly adminUpdateEmailList: { readonly __typename: 'EmailList', readonly id: string, readonly name: string, readonly emails: ReadonlyArray<string> } };

export type AdminUpdatePublishingEntityVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  input: AdminUpdatePublishingEntityInput;
}>;


export type AdminUpdatePublishingEntity = { readonly adminUpdatePublishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly postedBy: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> } };

export type AdminUpdateSimulationVariables = Exact<{
  simId: Scalars['ID'];
  simulationUpdate: SimulationInput;
}>;


export type AdminUpdateSimulation = { readonly setSimulationContents: { readonly __typename: 'AdminBalancingActSimulation', readonly id: number, readonly name: string, readonly locale: string, readonly description: string | null, readonly slug: string, readonly url: string, readonly status: QuestionSetStatus, readonly isPrioritization: boolean, readonly type: BalancingActSimulationType, readonly canPreview: boolean, readonly canPublish: boolean, readonly submissionsAvailable: boolean, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly updatedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly categories: ReadonlyArray<{ readonly __typename: 'SimulationCategory', readonly id: number, readonly name: string, readonly type: SimulationCategoryType, readonly displayOrder: number, readonly isLocked: boolean, readonly details: string | null, readonly subcategories: ReadonlyArray<{ readonly __typename: 'SimulationSubcategory', readonly id: number, readonly name: string, readonly displayOrder: number, readonly amount: number, readonly details: string | null, readonly isLocked: boolean, readonly inTour: boolean }> }> } };

export type AdminUpdateSocialConnectionVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  input: AdminUpdateSocialConnectionInput;
}>;


export type AdminUpdateSocialConnection = { readonly adminSetActiveSocialConnectionProfiles: { readonly __typename: 'SocialConnection', readonly id: string, readonly provider: SocialConnectionProvider } };

export type AdminUpdateVisualizationStateVariables = Exact<{
  input: UpdatePerformanceDataVisualizationInput;
}>;


export type AdminUpdateVisualizationState = { readonly adminUpdateTrackVariableVisualizationState: { readonly __typename: 'TrackVariableVisualization', readonly id: string, readonly visualizationType: VisualizationType | null, readonly state: SavedVisualizationActivationState, readonly comparisonGroupId: string | null } };

export type ApplyRecommendedContentSetVariables = Exact<{
  contentSetId: Scalars['ID'];
  publishingEntityId: Scalars['ID'];
  questions?: InputMaybe<ReadonlyArray<Scalars['ID']> | Scalars['ID']>;
}>;


export type ApplyRecommendedContentSet = { readonly applyRecommendedContentSet: { readonly __typename: 'GenericContent', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | { readonly __typename: 'Survey', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } };

export type ArchiveQuestionSetVariables = Exact<{
  surveyId: Scalars['ID'];
  status: QuestionStatus;
  accessSetting?: InputMaybe<AccessSettingInput>;
}>;


export type ArchiveQuestionSet = { readonly archiveQuestionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly accessSetting: { readonly __typename: 'AccessSetting_Email', readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | { readonly __typename: 'AccessSetting_Everyone' } | { readonly __typename: 'AccessSetting_Link' } | null } | { readonly __typename: 'PolcoLive', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly accessSetting: { readonly __typename: 'AccessSetting_Email', readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | { readonly __typename: 'AccessSetting_Everyone' } | { readonly __typename: 'AccessSetting_Link' } | null, readonly createdQuestions: { readonly __typename: 'CreatedQuestionsData', readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string } }> } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly accessSetting: { readonly __typename: 'AccessSetting_Email', readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | { readonly __typename: 'AccessSetting_Everyone' } | { readonly __typename: 'AccessSetting_Link' } | null, readonly createdQuestions: { readonly __typename: 'CreatedQuestionsData', readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string } }> } } | { readonly __typename: 'Survey', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly accessSetting: { readonly __typename: 'AccessSetting_Email', readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | { readonly __typename: 'AccessSetting_Everyone' } | { readonly __typename: 'AccessSetting_Link' } | null } };

export type ContentSetSocialShareVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  shareTypes: ReadonlyArray<SocialConnectionProvider> | SocialConnectionProvider;
  contentSetId: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
}>;


export type ContentSetSocialShare = { readonly contentSetSocialShare: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string } };

export type CreateClientOnlyAnalyticsEventVariables = Exact<{
  event: ClientOnlyAnalyticsEvent;
  metadata?: InputMaybe<Scalars['String']>;
}>;


export type CreateClientOnlyAnalyticsEvent = { readonly createClientOnlyAnalyticsEvent: boolean };

export type CreateIdeaVariables = Exact<{
  input: IdeaInput;
}>;


export type CreateIdea = { readonly createIdea: { readonly __typename: 'Idea', readonly id: string, readonly title: string, readonly description: string | null, readonly respondent: { readonly __typename: 'PrivateRespondent', readonly id: string } | { readonly __typename: 'PublicRespondent', readonly id: string }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number } } };

export type CreateOutcomeVariables = Exact<{
  setId: Scalars['ID'];
  input: OutcomeInput;
}>;


export type CreateOutcome = { readonly createOutcome: { readonly __typename: 'GenericContent', readonly id: string, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly publiclyShared: boolean }> | null, readonly outcome: { readonly __typename: 'Outcome', readonly id: string, readonly text: string, readonly state: ContentOutcomeState } | null } | { readonly __typename: 'PolcoLive', readonly id: string, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly publiclyShared: boolean }> | null, readonly outcome: { readonly __typename: 'Outcome', readonly id: string, readonly text: string, readonly state: ContentOutcomeState } | null } | { readonly __typename: 'QuestionSet', readonly id: string, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly publiclyShared: boolean }> | null, readonly outcome: { readonly __typename: 'Outcome', readonly id: string, readonly text: string, readonly state: ContentOutcomeState } | null } | { readonly __typename: 'Survey', readonly id: string, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly publiclyShared: boolean }> | null, readonly outcome: { readonly __typename: 'Outcome', readonly id: string, readonly text: string, readonly state: ContentOutcomeState } | null } };

export type CreateQuestionSetVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  input: QuestionSetInput;
}>;


export type CreateQuestionSet = { readonly createQuestionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | { readonly __typename: 'Survey', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } };

export type DeleteAdminFromPublishingEntityVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  adminId: Scalars['ID'];
}>;


export type DeleteAdminFromPublishingEntity = { readonly deleteAdminFromPublishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly managingAdmins: ReadonlyArray<{ readonly __typename: 'PublishingEntityAdmin', readonly id: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly name: string, readonly user: { readonly __typename: 'User', readonly id: string } } | { readonly __typename: 'PublicAdmin', readonly id: string, readonly name: string, readonly user: { readonly __typename: 'User', readonly id: string } } }> | null } };

export type DeleteEmailListVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  emailListId: Scalars['ID'];
}>;


export type DeleteEmailList = { readonly deleteEmailList: boolean };

export type DeleteOutcomeVariables = Exact<{
  outcomeId: Scalars['ID'];
}>;


export type DeleteOutcome = { readonly deleteOutcome: boolean };

export type DeleteQuestionSetVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteQuestionSet = { readonly deleteQuestionSet: boolean };

export type EmailLoginVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  fingerprint: Scalars['String'];
}>;


export type EmailLogin = { readonly emailLogin: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string, readonly respondent: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null, readonly avatarUrl: string | null, readonly guest: boolean, readonly zipCode: string | null, readonly verified: boolean, readonly invitedPlaceholderAccount: boolean, readonly requiresVerificationPrompt: boolean, readonly postAnonymously: boolean, readonly subscriptions: ReadonlyArray<{ readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string }> } | { readonly __typename: 'PublicRespondent' } | null, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly superAdmin: boolean, readonly emailVerificationStatus: EmailVerificationStatus, readonly demoPollyUrl: string | null, readonly registrationRequests: ReadonlyArray<{ readonly __typename: 'AdminRegistration', readonly id: string, readonly decision: AdminRegistrationDecision | null }>, readonly activePublishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string } | null } | { readonly __typename: 'PublicAdmin' } | null } | null, readonly location: { readonly __typename: 'UserLocation', readonly id: string, readonly ip: string | null, readonly zipCode: string | null, readonly coordinate: { readonly __typename: 'Coordinate', readonly lat: number, readonly lng: number } | null } | null } | { readonly __typename: 'EmailLoginFailed', readonly reason: EmailLoginFailedReason } };

export type EmailSignupVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  zipCode: Scalars['String'];
  fingerprint: Scalars['String'];
}>;


export type EmailSignup = { readonly emailSignup: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string, readonly respondent: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly avatarUrl: string | null, readonly email: string | null, readonly guest: boolean, readonly zipCode: string | null, readonly verified: boolean, readonly invitedPlaceholderAccount: boolean, readonly requiresVerificationPrompt: boolean, readonly postAnonymously: boolean, readonly subscriptions: ReadonlyArray<{ readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string }> } | { readonly __typename: 'PublicRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly avatarUrl: string | null } | null } | null, readonly location: { readonly __typename: 'UserLocation', readonly id: string, readonly ip: string | null, readonly zipCode: string | null, readonly coordinate: { readonly __typename: 'Coordinate', readonly lat: number, readonly lng: number } | null } | null } | { readonly __typename: 'EmailSignupFailed', readonly reason: EmailSignupFailedReason } };

export type FollowPublishingEntityVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  respondentId: Scalars['ID'];
  follow: Scalars['Boolean'];
}>;


export type FollowPublishingEntity = { readonly followPublishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly subscriptionType: SubscriptionType | null } };

export type InteractWithIdeaVariables = Exact<{
  input: InteractionInput;
  respondentId: Scalars['ID'];
}>;


export type InteractWithIdea = { readonly interactWithIdea: { readonly __typename: 'Idea', readonly id: string, readonly respondentVote: VoteType, readonly aggregations: { readonly __typename: 'IdeaAggregations', readonly voteUp: number, readonly voteDown: number } | null } };

export type LogOutVariables = Exact<{ [key: string]: never; }>;


export type LogOut = { readonly logOut: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string } | null } };

export type PasswordResetVariables = Exact<{
  password: Scalars['String'];
  token: Scalars['String'];
  email: Scalars['String'];
  fingerprint: Scalars['String'];
  context: RequestPasswordResetContext;
}>;


export type PasswordReset = { readonly passwordReset: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string, readonly respondent: { readonly __typename: 'PrivateRespondent', readonly id: string } | { readonly __typename: 'PublicRespondent', readonly id: string } | null, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string } | { readonly __typename: 'PublicAdmin', readonly id: string } | null } | null } | { readonly __typename: 'ResetPasswordFailed', readonly reason: ResetPasswordFailedReason } };

export type PublishOutcomeVariables = Exact<{
  outcomeId: Scalars['ID'];
}>;


export type PublishOutcome = { readonly publishOutcome: { readonly __typename: 'Outcome', readonly id: string, readonly state: ContentOutcomeState, readonly text: string } };

export type PublishingEntitySocialShareVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  shareTypes: ReadonlyArray<SocialConnectionProvider> | SocialConnectionProvider;
}>;


export type PublishingEntitySocialShare = { readonly publishingEntitySocialShare: { readonly __typename: 'PublishingEntity', readonly id: string } };

export type VoteForQuestionVariables = Exact<{
  questionId: Scalars['ID'];
  voteInput: VoteInput;
  upvoteComments: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
  voteMetadata: ReadonlyArray<VoteMetadataEntry> | VoteMetadataEntry;
}>;


export type VoteForQuestion = { readonly voteForQuestion: { readonly __typename: 'Vote', readonly id: string, readonly choices: ReadonlyArray<{ readonly __typename: 'RespondentQuestionChoice', readonly id: string, readonly allocation: number, readonly questionChoice: { readonly __typename: 'QuestionChoice', readonly id: string } }> | null, readonly comment: { readonly __typename: 'Comment', readonly id: string, readonly comment: string, readonly upvoteCount: number } | null, readonly upvotedComments: ReadonlyArray<{ readonly __typename: 'Comment', readonly id: string }>, readonly voter: { readonly __typename: 'PrivateRespondent', readonly id: string } | { readonly __typename: 'PublicRespondent', readonly id: string } } };

export type ReorderQuestionSetVariables = Exact<{
  setId: Scalars['ID'];
  questionIds: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
}>;


export type ReorderQuestionSet = { readonly reorderQuestionSet: { readonly __typename: 'GenericContent' } | { readonly __typename: 'PolcoLive', readonly id: string, readonly createdQuestions: { readonly __typename: 'CreatedQuestionsData', readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string }> } } | { readonly __typename: 'QuestionSet' } | { readonly __typename: 'Survey' } };

export type RepostContentSetVariables = Exact<{
  contentSetId: Scalars['ID'];
  forPublisherId: Scalars['ID'];
}>;


export type RepostContentSet = { readonly repostContentSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string } };

export type RequestBenchmarkProgramVariables = Exact<{
  benchmarkProgram: BenchmarkProgramInput;
}>;


export type RequestBenchmarkProgram = { readonly requestBenchmarkProgram: boolean };

export type RequestMagicLinkEmailVariables = Exact<{
  input: MagicLinkRequestInput;
}>;


export type RequestMagicLinkEmail = { readonly requestMagicLinkEmail: boolean };

export type RequestPasswordResetVariables = Exact<{
  email: Scalars['String'];
  context: RequestPasswordResetContext;
}>;


export type RequestPasswordReset = { readonly requestPasswordReset: boolean };

export type RespondentUpdateProfileVariables = Exact<{
  respondentId: Scalars['ID'];
  input: UpdateRespondentProfileInput;
}>;


export type RespondentUpdateProfile = { readonly updateRespondent: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly zipCode: string | null, readonly inputtedLat: number | null, readonly inputtedLon: number | null, readonly postAnonymously: boolean, readonly avatarUrl: string | null, readonly guest: boolean, readonly verified: boolean, readonly invitedPlaceholderAccount: boolean, readonly requiresVerificationPrompt: boolean, readonly email: string | null, readonly requestLocationLastShown: { readonly __typename: 'GqlDate', readonly raw: number } | null } | { readonly __typename: 'PublicRespondent' } };

export type RetrieveBenchmarkSurveyPdfVariables = Exact<{
  surveyId: Scalars['ID'];
}>;


export type RetrieveBenchmarkSurveyPdf = { readonly retrieveBenchmarkSurveyPdf: string | null };

export type ScheduleSurveyVariables = Exact<{
  surveyId: Scalars['ID'];
  schedule: QuestionScheduleInput;
  accessSetting?: InputMaybe<AccessSettingInput>;
}>;


export type ScheduleSurvey = { readonly scheduleSurvey: { readonly __typename: 'GenericContent', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly accessSetting: { readonly __typename: 'AccessSetting_Email', readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | { readonly __typename: 'AccessSetting_Everyone' } | { readonly __typename: 'AccessSetting_Link' } | null } | { readonly __typename: 'PolcoLive', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly accessSetting: { readonly __typename: 'AccessSetting_Email', readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | { readonly __typename: 'AccessSetting_Everyone' } | { readonly __typename: 'AccessSetting_Link' } | null } | { readonly __typename: 'QuestionSet', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly accessSetting: { readonly __typename: 'AccessSetting_Email', readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | { readonly __typename: 'AccessSetting_Everyone' } | { readonly __typename: 'AccessSetting_Link' } | null } | { readonly __typename: 'Survey', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly accessSetting: { readonly __typename: 'AccessSetting_Email', readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | { readonly __typename: 'AccessSetting_Everyone' } | { readonly __typename: 'AccessSetting_Link' } | null } };

export type SocialLoginVariables = Exact<{
  data: SocialLoginData;
  fingerprint: Scalars['String'];
}>;


export type SocialLogin = { readonly socialLogin: { readonly __typename: 'SocialUserResult', readonly isNewUser: boolean, readonly currentUser: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string, readonly respondent: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly avatarUrl: string | null, readonly guest: boolean, readonly zipCode: string | null, readonly verified: boolean, readonly email: string | null } | { readonly __typename: 'PublicRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly avatarUrl: string | null } | null } | null, readonly location: { readonly __typename: 'UserLocation', readonly id: string, readonly ip: string | null, readonly zipCode: string | null, readonly coordinate: { readonly __typename: 'Coordinate', readonly lat: number, readonly lng: number } | null } | null } } | null };

export type SoftDeleteQuestionSetVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SoftDeleteQuestionSet = { readonly softDeleteQuestionSet: { readonly __typename: 'GenericContent' } | { readonly __typename: 'PolcoLive' } | { readonly __typename: 'QuestionSet' } | { readonly __typename: 'Survey' } };

export type SuperAdminApproveRegistrationVariables = Exact<{
  registrationId: Scalars['ID'];
}>;


export type SuperAdminApproveRegistration = { readonly superAdminApproveRegistration: { readonly __typename: 'AdminRegistrationResult', readonly id: string } };

export type SuperAdminAssociatePublishingEntityWithRegistrationVariables = Exact<{
  registrationId: Scalars['ID'];
  publishingEntityId: Scalars['ID'];
}>;


export type SuperAdminAssociatePublishingEntityWithRegistration = { readonly superAdminAssociatePublishingEntityWithRegistration: { readonly __typename: 'AdminRegistration', readonly id: string, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | null, readonly user: { readonly __typename: 'User', readonly id: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly name: string } | { readonly __typename: 'PublicAdmin', readonly id: string, readonly name: string } | null } } };

export type SuperAdminCreateContentSetReportTabVariables = Exact<{
  setId: Scalars['ID'];
  input: ReportTabCreateInput;
}>;


export type SuperAdminCreateContentSetReportTab = { readonly superAdminCreateContentSetReportTab: { readonly __typename: 'GenericContent', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly visibleToAdmins: boolean, readonly order: number, readonly trackDomain: AnalyticsDomain | null, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null } | { readonly __typename: 'PolcoLive', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly visibleToAdmins: boolean, readonly order: number, readonly trackDomain: AnalyticsDomain | null, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null } | { readonly __typename: 'QuestionSet', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly visibleToAdmins: boolean, readonly order: number, readonly trackDomain: AnalyticsDomain | null, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null } | { readonly __typename: 'Survey', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly visibleToAdmins: boolean, readonly order: number, readonly trackDomain: AnalyticsDomain | null, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null } };

export type SuperAdminCreateOrUpdateRecommendedContentVariables = Exact<{
  isPaidContent: Scalars['Boolean'];
  setId: Scalars['ID'];
  shareableContentType: ShareableContentType;
  adminDescription?: InputMaybe<Scalars['String']>;
  domains: ReadonlyArray<ShareableContentDomains> | ShareableContentDomains;
}>;


export type SuperAdminCreateOrUpdateRecommendedContent = { readonly superAdminCreateOrUpdateRecommendedContent: { readonly __typename: 'ShareableContentSet', readonly id: string, readonly shareType: ShareableContentType, readonly adminDescription: string | null, readonly isPaidContent: boolean, readonly contentSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string } } };

export type SuperAdminCreatePublisherPresidingAreaVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  areaShape: GeoJsonMultiPolygonInput;
  areaName: Scalars['String'];
}>;


export type SuperAdminCreatePublisherPresidingArea = { readonly superAdminUpdatePresidingArea: { readonly __typename: 'PublishingEntity', readonly id: string, readonly presidingArea: { readonly __typename: 'PresidingArea', readonly id: string, readonly name: string, readonly center: { readonly __typename: 'CoordinateCenter', readonly size: number, readonly coordinate: { readonly __typename: 'Coordinate', readonly lat: number, readonly lng: number } }, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null } | null } };

export type SuperAdminCreatePublishingEntityVariables = Exact<{
  input: PublishingEntityCreationInput;
}>;


export type SuperAdminCreatePublishingEntity = { readonly superAdminCreatePublishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string } };

export type SuperAdminCreateSuperAdminVariables = Exact<{
  input: CreateSuperAdminInput;
}>;


export type SuperAdminCreateSuperAdmin = { readonly superAdminCreateSuperAdmin: { readonly __typename: 'CreateSuperAdminResult', readonly activationLink: string | null } };

export type SuperAdminCreateThirdPartyRecordVariables = Exact<{
  input: ThirdPartyRecordInput;
}>;


export type SuperAdminCreateThirdPartyRecord = { readonly superAdminCreateThirdPartyRecord: { readonly __typename: 'ThirdPartyRecord', readonly id: string, readonly thirdParty: ThirdParty, readonly thirdPartyIdentifier: string } };

export type SuperAdminDeleteBenchmarkReportRequestVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SuperAdminDeleteBenchmarkReportRequest = { readonly superAdminDeleteBenchmarkReportRequest: boolean };

export type SuperAdminDeleteContentSetReportTabVariables = Exact<{
  tabId: Scalars['ID'];
}>;


export type SuperAdminDeleteContentSetReportTab = { readonly superAdminDeleteContentSetReportTab: { readonly __typename: 'GenericContent', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly visibleToAdmins: boolean, readonly order: number, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null } | { readonly __typename: 'PolcoLive', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly visibleToAdmins: boolean, readonly order: number, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null } | { readonly __typename: 'QuestionSet', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly visibleToAdmins: boolean, readonly order: number, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null } | { readonly __typename: 'Survey', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly visibleToAdmins: boolean, readonly order: number, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null } };

export type SuperAdminDeletePublishingEntityVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type SuperAdminDeletePublishingEntity = { readonly superAdminDeletePublishingEntity: boolean };

export type SuperAdminDeleteShortUrlVariables = Exact<{
  shortUrlId: Scalars['ID'];
}>;


export type SuperAdminDeleteShortUrl = { readonly superAdminDeleteShortUrl: boolean };

export type SuperAdminDeleteThirdPartyRecordVariables = Exact<{
  thirdPartyRecordId: Scalars['ID'];
}>;


export type SuperAdminDeleteThirdPartyRecord = { readonly superAdminDeleteThirdPartyRecord: boolean };

export type SuperAdminDownloadBenchmarkReporRequesttDataVariables = Exact<{
  requestId: Scalars['ID'];
}>;


export type SuperAdminDownloadBenchmarkReporRequesttData = { readonly superAdminDownloadBenchmarkReportRequestData: string };

export type SuperAdminGenerateContentSetShortUrlsVariables = Exact<{
  setId: Scalars['ID'];
  parameters: ReadonlyArray<NewShortUrlParameters> | NewShortUrlParameters;
}>;


export type SuperAdminGenerateContentSetShortUrls = { readonly superAdminGenerateContentSetShortUrls: { readonly __typename: 'GenericContent', readonly id: string, readonly shortUrls: ReadonlyArray<{ readonly __typename: 'ShortUrl', readonly id: string, readonly shortUrl: string, readonly fullUrl: string }> } | { readonly __typename: 'PolcoLive', readonly id: string, readonly shortUrls: ReadonlyArray<{ readonly __typename: 'ShortUrl', readonly id: string, readonly shortUrl: string, readonly fullUrl: string }> } | { readonly __typename: 'QuestionSet', readonly id: string, readonly shortUrls: ReadonlyArray<{ readonly __typename: 'ShortUrl', readonly id: string, readonly shortUrl: string, readonly fullUrl: string }> } | { readonly __typename: 'Survey', readonly id: string, readonly shortUrls: ReadonlyArray<{ readonly __typename: 'ShortUrl', readonly id: string, readonly shortUrl: string, readonly fullUrl: string }> } };

export type SuperAdminImportTranslationsVariables = Exact<{
  surveyId: Scalars['ID'];
  translationSets: ReadonlyArray<TranslationSet> | TranslationSet;
}>;


export type SuperAdminImportTranslations = { readonly superAdminImportTranslations: boolean };

export type SuperAdminPublishBenchmarkReportRequestVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SuperAdminPublishBenchmarkReportRequest = { readonly superAdminPublishBenchmarkReportRequest: { readonly __typename: 'BenchmarkReportRequest', readonly id: string, readonly status: BenchmarkReportRequestStatus } };

export type SuperAdminRejectRegistrationVariables = Exact<{
  registrationId: Scalars['ID'];
}>;


export type SuperAdminRejectRegistration = { readonly superAdminRejectRegistration: { readonly __typename: 'AdminRegistrationResult', readonly id: string } };

export type SuperAdminRemovePublisherPresidingAreaVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type SuperAdminRemovePublisherPresidingArea = { readonly superAdminUpdatePresidingArea: { readonly __typename: 'PublishingEntity', readonly id: string, readonly presidingArea: { readonly __typename: 'PresidingArea', readonly id: string, readonly name: string, readonly center: { readonly __typename: 'CoordinateCenter', readonly size: number, readonly coordinate: { readonly __typename: 'Coordinate', readonly lat: number, readonly lng: number } }, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null } | null } };

export type SuperAdminRemoveSuperAdminVariables = Exact<{
  adminId: Scalars['ID'];
}>;


export type SuperAdminRemoveSuperAdmin = { readonly superAdminRemoveSuperAdmin: boolean };

export type SuperAdminReorderReportTabsVariables = Exact<{
  setId: Scalars['ID'];
  tabOrder: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
}>;


export type SuperAdminReorderReportTabs = { readonly superAdminReorderReportTabs: { readonly __typename: 'GenericContent', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly visibleToAdmins: boolean, readonly order: number, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null } | { readonly __typename: 'PolcoLive', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly visibleToAdmins: boolean, readonly order: number, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null } | { readonly __typename: 'QuestionSet', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly visibleToAdmins: boolean, readonly order: number, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null } | { readonly __typename: 'Survey', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly visibleToAdmins: boolean, readonly order: number, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null } };

export type SuperAdminResetFeatureSettingsVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  resetState?: InputMaybe<ResetFeatureSettingState>;
}>;


export type SuperAdminResetFeatureSettings = { readonly superAdminResetFeatureSettings: ReadonlyArray<{ readonly __typename: 'PublishingEntityFeatureSetting', readonly id: string, readonly featureSettingId: string, readonly featureSettingName: string, readonly enabled: boolean, readonly expirationDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }> };

export type SuperAdminSetPurchaseStatusVariables = Exact<{
  purchaseId: Scalars['ID'];
  markPaid: Scalars['Boolean'];
}>;


export type SuperAdminSetPurchaseStatus = { readonly superAdminSetPurchaseStatus: { readonly __typename: 'PurchasedStoreItem', readonly id: string, readonly price: number, readonly status: PurchaseStatusType, readonly createdAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly storeItem: { readonly __typename: 'StoreItem', readonly id: string, readonly name: string, readonly provider: StoreItemProvider }, readonly purchasedByAdmin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly name: string } | { readonly __typename: 'PublicAdmin', readonly id: string, readonly name: string } } | null };

export type SuperAdminTogglePublishingEntityFeatureSettingVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  featureSettingId: Scalars['ID'];
  dateToEnableUntil?: InputMaybe<GqlDateInput>;
  quantity?: InputMaybe<Scalars['Int']>;
  isUnlimited?: InputMaybe<Scalars['Boolean']>;
}>;


export type SuperAdminTogglePublishingEntityFeatureSetting = { readonly superAdminTogglePublishingEntityFeatureSetting: { readonly __typename: 'PublishingEntityFeatureSetting', readonly id: string, readonly featureSettingId: string, readonly featureSettingName: string, readonly enabled: boolean, readonly quantity: number, readonly isUnlimited: boolean, readonly expirationDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } };

export type SuperAdminTogglePublishingEntityFeatureSettingsVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  featureSettings: ReadonlyArray<FeatureSettingInput> | FeatureSettingInput;
}>;


export type SuperAdminTogglePublishingEntityFeatureSettings = { readonly superAdminTogglePublishingEntityFeatureSettings: ReadonlyArray<{ readonly __typename: 'PublishingEntityFeatureSetting', readonly id: string, readonly featureSettingId: string, readonly featureSettingName: string, readonly enabled: boolean, readonly quantity: number, readonly isUnlimited: boolean, readonly expirationDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }> };

export type SuperAdminUpdateContentSetReportTabVariables = Exact<{
  setId: Scalars['ID'];
  input: ReportTabUpdateInput;
}>;


export type SuperAdminUpdateContentSetReportTab = { readonly superAdminUpdateContentSetReportTab: { readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly visibleToAdmins: boolean, readonly order: number, readonly trackDomain: AnalyticsDomain | null, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } } };

export type SuperAdminUpdatePublisherAttributesVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  attributes: SuperAdminPublisherAttributesInput;
}>;


export type SuperAdminUpdatePublisherAttributes = { readonly superAdminUpdatePublisherAttributes: { readonly __typename: 'PublishingEntity', readonly id: string, readonly isEnterprise: boolean, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string } | null, readonly envisioSetting: { readonly __typename: 'PublishingEntityEnvisioSetting', readonly id: string, readonly instanceId: string | null, readonly magicToken: string } | null, readonly balancingActCustomer: { readonly __typename: 'BalancingActCustomer', readonly id: number } | null } };

export type SuperAdminUpdatePublisherPresidingAreaVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  areaShape?: InputMaybe<GeoJsonMultiPolygonInput>;
  areaName: Scalars['String'];
}>;


export type SuperAdminUpdatePublisherPresidingArea = { readonly superAdminUpdatePresidingArea: { readonly __typename: 'PublishingEntity', readonly id: string, readonly presidingArea: { readonly __typename: 'PresidingArea', readonly id: string, readonly name: string, readonly center: { readonly __typename: 'CoordinateCenter', readonly size: number, readonly coordinate: { readonly __typename: 'Coordinate', readonly lat: number, readonly lng: number } }, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null } | null } };

export type SuperAdminUpdateShortUrlVariables = Exact<{
  shortUrlId: Scalars['ID'];
  updatedShortUrl: Scalars['String'];
}>;


export type SuperAdminUpdateShortUrl = { readonly superAdminUpdateShortUrl: { readonly __typename: 'ShortUrl', readonly id: string, readonly shortUrl: string, readonly fullUrl: string } };

export type SuperAdminUpdateThirdPartyRecordVariables = Exact<{
  input: ThirdPartyRecordInput;
  thirdPartyRecordId: Scalars['ID'];
}>;


export type SuperAdminUpdateThirdPartyRecord = { readonly superAdminUpdateThirdPartyRecord: { readonly __typename: 'ThirdPartyRecord', readonly id: string, readonly thirdParty: ThirdParty, readonly thirdPartyIdentifier: string } };

export type SuperAdminUploadContentSetShortUrlsVariables = Exact<{
  setId: Scalars['ID'];
  shortUrls: ReadonlyArray<UploadShortUrlInput> | UploadShortUrlInput;
}>;


export type SuperAdminUploadContentSetShortUrls = { readonly superAdminUploadContentSetShortUrls: boolean };

export type SuperAdminUpsertBenchmarkReportRequestVariables = Exact<{
  input: BenchmarkReportRequestInput;
}>;


export type SuperAdminUpsertBenchmarkReportRequest = { readonly superAdminUpsertBenchmarkReportRequest: { readonly __typename: 'BenchmarkReportRequest', readonly id: string, readonly status: BenchmarkReportRequestStatus, readonly benchmarkSurveyType: BenchmarkSurveyTypes, readonly surveyFormat: SurveyFormat | null, readonly trendsExpected: boolean, readonly expectedTrendYears: string | null, readonly fips: string | null, readonly customBenchmarks: string | null, readonly additionalNotes: string | null, readonly mailedCount: number | null, readonly emailedCount: number | null, readonly eligibleSamplingResponseCount: number | null, readonly responseRate: number | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly startAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly clientDueAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly reportDueAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly questionSetData: ReadonlyArray<{ readonly __typename: 'BenchmarkReportRequestQuestionSetData', readonly id: string, readonly language: string | null, readonly optIn: boolean, readonly weighted: boolean, readonly contentSet: { readonly __typename: 'GenericContent', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | { readonly __typename: 'Survey', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | null }> | null, readonly areaData: ReadonlyArray<{ readonly __typename: 'BenchmarkReportRequestAreaData', readonly id: string, readonly name: string | null, readonly value: string | null, readonly group: BenchmarkReportRequestAreaGroup | null, readonly weight: number | null }> | null } };

export type VoteForSurveyVariables = Exact<{
  questionSetId: Scalars['ID'];
  surveyInput: ReadonlyArray<SurveyVoteInputWithId> | SurveyVoteInputWithId;
  voteMetadata: ReadonlyArray<VoteMetadataEntry> | VoteMetadataEntry;
}>;


export type VoteForSurvey = { readonly voteForSurvey: { readonly __typename: 'SurveyVoteResult', readonly id: string, readonly voter: { readonly __typename: 'PrivateRespondent', readonly id: string } | { readonly __typename: 'PublicRespondent', readonly id: string } } };

export type UnUpvoteCommentVariables = Exact<{
  questionId: Scalars['ID'];
  commentId: Scalars['ID'];
}>;


export type UnUpvoteComment = { readonly unUpvoteComment: { readonly __typename: 'CommentUpvoteResult', readonly voteId: string, readonly questionId: string, readonly direction: VoteType, readonly comment: { readonly __typename: 'Comment', readonly id: string, readonly upvoteCount: number } } };

export type UnsubscribeFromAdminShareEmailVariables = Exact<{
  shareEmailMetadataId: Scalars['ID'];
}>;


export type UnsubscribeFromAdminShareEmail = { readonly unsubscribeFromAdminShareEmail: boolean };

export type UnsubscribeFromOutreachEmailVariables = Exact<{
  emailListEntryId: Scalars['ID'];
}>;


export type UnsubscribeFromOutreachEmail = { readonly unsubscribeFromOutreachEmail: boolean };

export type UpdateAdminForPublishingEntityVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  userId: Scalars['ID'];
  roleId: Scalars['ID'];
}>;


export type UpdateAdminForPublishingEntity = { readonly updateAdminForPublishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly managingAdmins: ReadonlyArray<{ readonly __typename: 'PublishingEntityAdmin', readonly id: string, readonly roleId: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly name: string, readonly email: string } | { readonly __typename: 'PublicAdmin', readonly id: string, readonly name: string } }> | null } };

export type UpdateEmailSettingsVariables = Exact<{
  token: Scalars['String'];
  unsubscribeTypes: ReadonlyArray<EmailType> | EmailType;
}>;


export type UpdateEmailSettings = { readonly updateEmailSettings: boolean };

export type UpdateOutcomeVariables = Exact<{
  outcomeId: Scalars['ID'];
  input: OutcomeInput;
}>;


export type UpdateOutcome = { readonly updateOutcome: { readonly __typename: 'GenericContent', readonly id: string, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly publiclyShared: boolean }> | null, readonly outcome: { readonly __typename: 'Outcome', readonly id: string, readonly text: string, readonly state: ContentOutcomeState } | null } | { readonly __typename: 'PolcoLive', readonly id: string, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly publiclyShared: boolean }> | null, readonly outcome: { readonly __typename: 'Outcome', readonly id: string, readonly text: string, readonly state: ContentOutcomeState } | null } | { readonly __typename: 'QuestionSet', readonly id: string, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly publiclyShared: boolean }> | null, readonly outcome: { readonly __typename: 'Outcome', readonly id: string, readonly text: string, readonly state: ContentOutcomeState } | null } | { readonly __typename: 'Survey', readonly id: string, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly publiclyShared: boolean }> | null, readonly outcome: { readonly __typename: 'Outcome', readonly id: string, readonly text: string, readonly state: ContentOutcomeState } | null } };

export type UpdateQuestionSetVariables = Exact<{
  id: Scalars['ID'];
  input: QuestionSetInput;
}>;


export type UpdateQuestionSet = { readonly updateQuestionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly accessSetting: { readonly __typename: 'AccessSetting_Email', readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | { readonly __typename: 'AccessSetting_Everyone' } | { readonly __typename: 'AccessSetting_Link' } | null } | { readonly __typename: 'PolcoLive', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly accessSetting: { readonly __typename: 'AccessSetting_Email', readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | { readonly __typename: 'AccessSetting_Everyone' } | { readonly __typename: 'AccessSetting_Link' } | null } | { readonly __typename: 'QuestionSet', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly accessSetting: { readonly __typename: 'AccessSetting_Email', readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | { readonly __typename: 'AccessSetting_Everyone' } | { readonly __typename: 'AccessSetting_Link' } | null } | { readonly __typename: 'Survey', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly accessSetting: { readonly __typename: 'AccessSetting_Email', readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | { readonly __typename: 'AccessSetting_Everyone' } | { readonly __typename: 'AccessSetting_Link' } | null } };

export type UploadQuestionSetImageVariables = Exact<{
  imageUrl: Scalars['String'];
  publishingEntityId: Scalars['ID'];
}>;


export type UploadQuestionSetImage = { readonly uploadQuestionSetImage: { readonly __typename: 'PublishingEntity', readonly id: string, readonly questionSetImages: ReadonlyArray<{ readonly __typename: 'QuestionSetImage', readonly id: string, readonly horizontalUrl: string }> } };

export type UpvoteCommentVariables = Exact<{
  questionId: Scalars['ID'];
  commentId: Scalars['ID'];
}>;


export type UpvoteComment = { readonly upvoteComment: { readonly __typename: 'CommentUpvoteResult', readonly voteId: string, readonly questionId: string, readonly direction: VoteType, readonly comment: { readonly __typename: 'Comment', readonly id: string, readonly upvoteCount: number } } };

export type VerifyAdminEmailVariables = Exact<{
  userId: Scalars['ID'];
  token: Scalars['String'];
}>;


export type VerifyAdminEmail = { readonly verifyAdminEmail: { readonly __typename: 'User', readonly id: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly name: string, readonly email: string, readonly emailVerificationStatus: EmailVerificationStatus, readonly registrationRequests: ReadonlyArray<{ readonly __typename: 'AdminRegistration', readonly id: string, readonly decision: AdminRegistrationDecision | null, readonly createdTime: { readonly __typename: 'GqlDate', readonly raw: number }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string } | null }>, readonly activePublishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string } | null } | { readonly __typename: 'PublicAdmin' } | null } };

export type AdminDeleteTrackGoalVariables = Exact<{
  input: DeleteGoalInput;
}>;


export type AdminDeleteTrackGoal = { readonly adminDeleteTrackGoal: { readonly __typename: 'PublishingEntity', readonly id: string, readonly strategicPlans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }> } };

export type AdminUpdateTrackGoalVariables = Exact<{
  input: UpdateGoalInput;
}>;


export type AdminUpdateTrackGoal = { readonly adminUpdateTrackGoal: { readonly __typename: 'PublishingEntity', readonly id: string, readonly strategicPlans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }> } };

export type AdminBenchmarkReportCrosstabVariables = Exact<{
  surveyId: Scalars['ID'];
  topicId: Scalars['ID'];
  dimensionGroupDefinitionId: Scalars['ID'];
}>;


export type AdminBenchmarkReportCrosstab = { readonly openContentSetById: { readonly __typename: 'GenericContent' } | { readonly __typename: 'PolcoLive' } | { readonly __typename: 'QuestionSet' } | { readonly __typename: 'Survey', readonly id: string, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly crosstab: ReadonlyArray<{ readonly __typename: 'CrosstabGridResults', readonly label: string, readonly questionResults: ReadonlyArray<{ readonly __typename: 'CrosstabQuestionResults', readonly question: { readonly __typename: 'Question', readonly id: string, readonly questionNumber: number | null, readonly isBenchmarkedQuestion: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null }, readonly hierarchyParentNode: { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null } | null, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'Survey', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly topic: string | null, readonly category: string | null, readonly choices: ReadonlyArray<{ readonly __typename: 'AggregateVotingChoice', readonly rawTotal: number, readonly weightedTotal: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly trendSignificance: number | null, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly scalePercent: number, readonly value: TrendValue | null, readonly date: { readonly __typename: 'GqlDate', readonly raw: number }, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null }> } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue, readonly rank: number, readonly totalDataPoints: number, readonly benchmarkSignificance: number | null, readonly dateRange: { readonly __typename: 'BenchmarkDateRange', readonly start: { readonly __typename: 'GqlDate', readonly raw: number }, readonly end: { readonly __typename: 'GqlDate', readonly raw: number } } } | null } | null, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number }, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly value: number, readonly text: string }> | null }, readonly results: ReadonlyArray<{ readonly __typename: 'CrosstabResultValue', readonly value: number | null, readonly crosstabGroup: { readonly __typename: 'CrosstabGroup', readonly label: string }, readonly statisticalDifferences: ReadonlyArray<{ readonly __typename: 'CrosstabGroup', readonly label: string }> | null }> | null }> } | { readonly __typename: 'CrosstabQuestionResults', readonly question: { readonly __typename: 'Question', readonly id: string, readonly questionNumber: number | null, readonly isBenchmarkedQuestion: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null }, readonly hierarchyParentNode: { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null } | null, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'Survey', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly topic: string | null, readonly category: string | null, readonly choices: ReadonlyArray<{ readonly __typename: 'AggregateVotingChoice', readonly rawTotal: number, readonly weightedTotal: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly trendSignificance: number | null, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly scalePercent: number, readonly value: TrendValue | null, readonly date: { readonly __typename: 'GqlDate', readonly raw: number }, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null }> } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue, readonly rank: number, readonly totalDataPoints: number, readonly benchmarkSignificance: number | null, readonly dateRange: { readonly __typename: 'BenchmarkDateRange', readonly start: { readonly __typename: 'GqlDate', readonly raw: number }, readonly end: { readonly __typename: 'GqlDate', readonly raw: number } } } | null } | null, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number }, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly value: number, readonly text: string }> | null }, readonly results: ReadonlyArray<{ readonly __typename: 'CrosstabResultValue', readonly value: number | null, readonly crosstabGroup: { readonly __typename: 'CrosstabGroup', readonly label: string }, readonly statisticalDifferences: ReadonlyArray<{ readonly __typename: 'CrosstabGroup', readonly label: string }> | null }> | null }> | null } | null };

export type Crosstab_QuestionResults = { readonly __typename: 'CrosstabQuestionResults', readonly question: { readonly __typename: 'Question', readonly id: string, readonly questionNumber: number | null, readonly isBenchmarkedQuestion: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null }, readonly hierarchyParentNode: { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null } | null, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'Survey', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly topic: string | null, readonly category: string | null, readonly choices: ReadonlyArray<{ readonly __typename: 'AggregateVotingChoice', readonly rawTotal: number, readonly weightedTotal: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly trendSignificance: number | null, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly scalePercent: number, readonly value: TrendValue | null, readonly date: { readonly __typename: 'GqlDate', readonly raw: number }, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null }> } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue, readonly rank: number, readonly totalDataPoints: number, readonly benchmarkSignificance: number | null, readonly dateRange: { readonly __typename: 'BenchmarkDateRange', readonly start: { readonly __typename: 'GqlDate', readonly raw: number }, readonly end: { readonly __typename: 'GqlDate', readonly raw: number } } } | null } | null, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number }, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly value: number, readonly text: string }> | null }, readonly results: ReadonlyArray<{ readonly __typename: 'CrosstabResultValue', readonly value: number | null, readonly crosstabGroup: { readonly __typename: 'CrosstabGroup', readonly label: string }, readonly statisticalDifferences: ReadonlyArray<{ readonly __typename: 'CrosstabGroup', readonly label: string }> | null }> | null };

export type AdminBenchmarkReportTopicDisparitiesVariables = Exact<{
  surveyId: Scalars['ID'];
  dimensionGroupDefinitionIds: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
  filter: TopicFilter;
}>;


export type AdminBenchmarkReportTopicDisparities = { readonly openContentSetById: { readonly __typename: 'GenericContent' } | { readonly __typename: 'PolcoLive' } | { readonly __typename: 'QuestionSet' } | { readonly __typename: 'Survey', readonly id: string, readonly topicDisparities: ReadonlyArray<{ readonly __typename: 'TopicDisparity', readonly disparityLevel: DisparityLevel | null, readonly topic: { readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string, readonly icon: string | null, readonly description: string | null }, readonly dimensionGroupDefinition: { readonly __typename: 'DimensionGroupDefinition', readonly id: string, readonly description: string } }> } | null };

export type AdminBenchmarkReportTopicRankingsVariables = Exact<{
  setId: Scalars['ID'];
  filter: TopicFilter;
}>;


export type AdminBenchmarkReportTopicRankings = { readonly openContentSetById: { readonly __typename: 'GenericContent' } | { readonly __typename: 'PolcoLive' } | { readonly __typename: 'QuestionSet' } | { readonly __typename: 'Survey', readonly id: string, readonly topicsByQualityPercent: ReadonlyArray<{ readonly __typename: 'SurveyBenchmarkTopic', readonly id: string, readonly importance: { readonly __typename: 'Question', readonly id: string, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue } | null } | null } | null, readonly quality: { readonly __typename: 'Question', readonly id: string, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly date: { readonly __typename: 'GqlDate', readonly raw: number } }> } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue } | null } | null } | null, readonly topic: { readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string, readonly icon: string | null, readonly description: string | null, readonly trackDomain: AnalyticsDomain | null, readonly category: { readonly __typename: 'TopicCategory', readonly id: string, readonly name: string, readonly priority: number | null } | null } }>, readonly topicsByTrendDifference: ReadonlyArray<{ readonly __typename: 'SurveyBenchmarkTopic', readonly id: string, readonly importance: { readonly __typename: 'Question', readonly id: string, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue } | null } | null } | null, readonly quality: { readonly __typename: 'Question', readonly id: string, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly date: { readonly __typename: 'GqlDate', readonly raw: number } }> } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue } | null } | null } | null, readonly topic: { readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string, readonly icon: string | null, readonly description: string | null, readonly trackDomain: AnalyticsDomain | null, readonly category: { readonly __typename: 'TopicCategory', readonly id: string, readonly name: string, readonly priority: number | null } | null } }>, readonly topicsByBenchmarkDifference: ReadonlyArray<{ readonly __typename: 'SurveyBenchmarkTopic', readonly id: string, readonly importance: { readonly __typename: 'Question', readonly id: string, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue } | null } | null } | null, readonly quality: { readonly __typename: 'Question', readonly id: string, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly date: { readonly __typename: 'GqlDate', readonly raw: number } }> } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue } | null } | null } | null, readonly topic: { readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string, readonly icon: string | null, readonly description: string | null, readonly trackDomain: AnalyticsDomain | null, readonly category: { readonly __typename: 'TopicCategory', readonly id: string, readonly name: string, readonly priority: number | null } | null } }>, readonly criticalFocusTopics: ReadonlyArray<{ readonly __typename: 'SurveyBenchmarkTopic', readonly id: string, readonly topic: { readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string, readonly icon: string | null, readonly description: string | null, readonly trackDomain: AnalyticsDomain | null, readonly category: { readonly __typename: 'TopicCategory', readonly id: string, readonly name: string, readonly priority: number | null } | null } }> } | null };

export type TopicDetails = { readonly __typename: 'SurveyBenchmarkTopic', readonly id: string, readonly importance: { readonly __typename: 'Question', readonly id: string, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue } | null } | null } | null, readonly quality: { readonly __typename: 'Question', readonly id: string, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly date: { readonly __typename: 'GqlDate', readonly raw: number } }> } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue } | null } | null } | null, readonly topic: { readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string, readonly icon: string | null, readonly description: string | null, readonly trackDomain: AnalyticsDomain | null, readonly category: { readonly __typename: 'TopicCategory', readonly id: string, readonly name: string, readonly priority: number | null } | null } };

export type AdminComparisonGroupDomainIndexScoresVariables = Exact<{
  comparisonGroupId: Scalars['ID'];
  domain: AnalyticsDomain;
  displayType?: InputMaybe<VariableDisplayType>;
  areaMode: TrackAreaMode;
  historicalDataEntries?: InputMaybe<Scalars['Int']>;
  fipsCodes?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type AdminComparisonGroupDomainIndexScores = { readonly openComparisonGroupById: { readonly __typename: 'ComparisonGroup', readonly id: string, readonly name: string, readonly trackDomain: { readonly __typename: 'TrackDomain', readonly id: string, readonly domain: AnalyticsDomain, readonly fips: ReadonlyArray<string>, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> } } | null };

export type AdminComparisonGroupDomainIndicatorsVariables = Exact<{
  comparisonGroupId: Scalars['ID'];
  domain: AnalyticsDomain;
  displayType?: InputMaybe<VariableDisplayType>;
  areaMode: TrackAreaMode;
  includeHierarchicalData: Scalars['Boolean'];
  historicalDataEntries?: InputMaybe<Scalars['Int']>;
  fipsCodes?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type AdminComparisonGroupDomainIndicators = { readonly openComparisonGroupById: { readonly __typename: 'ComparisonGroup', readonly id: string, readonly name: string, readonly trackDomain: { readonly __typename: 'TrackDomain', readonly id: string, readonly domain: AnalyticsDomain, readonly fips: ReadonlyArray<string>, readonly indicators: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> } } | null };

export type AdminComparisonGroupDomainTrackVariablesVariables = Exact<{
  comparisonGroupId: Scalars['ID'];
  domain: AnalyticsDomain;
  displayType?: InputMaybe<VariableDisplayType>;
  areaMode: TrackAreaMode;
  includeHierarchicalData: Scalars['Boolean'];
  historicalDataEntries?: InputMaybe<Scalars['Int']>;
  fipsCodes?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type AdminComparisonGroupDomainTrackVariables = { readonly openComparisonGroupById: { readonly __typename: 'ComparisonGroup', readonly id: string, readonly name: string, readonly trackDomain: { readonly __typename: 'TrackDomain', readonly id: string, readonly domain: AnalyticsDomain, readonly fips: ReadonlyArray<string>, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }>, readonly indicators: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> } } | null };

export type AdminComparisonGroupFipsShapesVariables = Exact<{
  comparisonGroupId: Scalars['ID'];
}>;


export type AdminComparisonGroupFipsShapes = { readonly openComparisonGroupById: { readonly __typename: 'ComparisonGroup', readonly id: string, readonly name: string, readonly fips: ReadonlyArray<{ readonly __typename: 'FipsArea', readonly id: string, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null }>, readonly boundingBox: { readonly __typename: 'GeoBoundingBox', readonly id: string, readonly xMin: number, readonly xMax: number, readonly yMin: number, readonly yMax: number } | null } | null };

export type AdminComparisonGroupTrackOverviewVariables = Exact<{
  comparisonGroupId: Scalars['ID'];
  areaMode: TrackAreaMode;
  displayType: VariableDisplayType;
  historicalDataEntries?: InputMaybe<Scalars['Int']>;
  fipsCodes?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type AdminComparisonGroupTrackOverview = { readonly openComparisonGroupById: { readonly __typename: 'ComparisonGroup', readonly id: string, readonly name: string, readonly SAFETY: { readonly __typename: 'TrackDomain', readonly id: string, readonly domain: AnalyticsDomain, readonly fips: ReadonlyArray<string>, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly ECONOMY: { readonly __typename: 'TrackDomain', readonly id: string, readonly domain: AnalyticsDomain, readonly fips: ReadonlyArray<string>, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly EDUCATION_ARTS_CULTURE: { readonly __typename: 'TrackDomain', readonly id: string, readonly domain: AnalyticsDomain, readonly fips: ReadonlyArray<string>, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly MOBILITY: { readonly __typename: 'TrackDomain', readonly id: string, readonly domain: AnalyticsDomain, readonly fips: ReadonlyArray<string>, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly COMMUNITY_DESIGN: { readonly __typename: 'TrackDomain', readonly id: string, readonly domain: AnalyticsDomain, readonly fips: ReadonlyArray<string>, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly PARKS_AND_RECREATION: { readonly __typename: 'TrackDomain', readonly id: string, readonly domain: AnalyticsDomain, readonly fips: ReadonlyArray<string>, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly UTILITIES: { readonly __typename: 'TrackDomain', readonly id: string, readonly domain: AnalyticsDomain, readonly fips: ReadonlyArray<string>, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly HEALTH_AND_WELLNESS: { readonly __typename: 'TrackDomain', readonly id: string, readonly domain: AnalyticsDomain, readonly fips: ReadonlyArray<string>, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly INCLUSIVITY_AND_ENGAGEMENT: { readonly __typename: 'TrackDomain', readonly id: string, readonly domain: AnalyticsDomain, readonly fips: ReadonlyArray<string>, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly NATURAL_ENVIRONMENT: { readonly __typename: 'TrackDomain', readonly id: string, readonly domain: AnalyticsDomain, readonly fips: ReadonlyArray<string>, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly COMMUNITY_CHARACTERISTICS: { readonly __typename: 'TrackDomain', readonly id: string, readonly domain: AnalyticsDomain, readonly fips: ReadonlyArray<string>, readonly indicators: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> } } | null };

export type AdminContentReportVariables = Exact<{
  setId: Scalars['ID'];
  publishingEntityId: Scalars['ID'];
  source: RespondentAttributeValueSource;
  filter?: InputMaybe<ResultFilter>;
  paginationForComments?: InputMaybe<PaginationParams>;
}>;


export type AdminContentReport = { readonly openContentSetById: { readonly __typename: 'GenericContent', readonly id: string, readonly questionsCount: number, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly order: number, readonly visibleToAdmins: boolean, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null, readonly contents: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly totalVotesCount: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }> }, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number, readonly comments: ReadonlyArray<{ readonly __typename: 'Comment', readonly id: string, readonly comment: string, readonly upvoteCount: number, readonly commenterChoice: { readonly __typename: 'QuestionChoice', readonly id: string } | null, readonly commenter: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly postAnonymously: boolean, readonly avatarUrl: string | null } | { readonly __typename: 'PublicRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly postAnonymously: boolean, readonly avatarUrl: string | null } }> }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly stats: { readonly __typename: 'QuestionStats', readonly id: string, readonly breakdowns: ReadonlyArray<{ readonly __typename: 'QuestionStatsBreakdown', readonly key: string, readonly hits: number, readonly buckets: ReadonlyArray<{ readonly __typename: 'StatBucketGroup', readonly key: string, readonly hits: number, readonly buckets: ReadonlyArray<{ readonly __typename: 'StatBucket', readonly key: string, readonly hits: number }> }> }> | null } } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly structureType: QuestionHierarchyParentNodeType, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly structureDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly survey: { readonly __typename: 'Survey', readonly id: string }, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly totalVotesCount: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }> }, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number, readonly comments: ReadonlyArray<{ readonly __typename: 'Comment', readonly id: string, readonly comment: string, readonly upvoteCount: number, readonly commenterChoice: { readonly __typename: 'QuestionChoice', readonly id: string } | null, readonly commenter: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly postAnonymously: boolean, readonly avatarUrl: string | null } | { readonly __typename: 'PublicRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly postAnonymously: boolean, readonly avatarUrl: string | null } }> }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly stats: { readonly __typename: 'QuestionStats', readonly id: string, readonly breakdowns: ReadonlyArray<{ readonly __typename: 'QuestionStatsBreakdown', readonly key: string, readonly hits: number, readonly buckets: ReadonlyArray<{ readonly __typename: 'StatBucketGroup', readonly key: string, readonly hits: number, readonly buckets: ReadonlyArray<{ readonly __typename: 'StatBucket', readonly key: string, readonly hits: number }> }> }> | null } }> } | { readonly __typename: 'QuestionHierarchySimulationNode' } | { readonly __typename: 'QuestionHierarchyVisualizationNode' }> } | { readonly __typename: 'PolcoLive', readonly id: string, readonly questionsCount: number, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly order: number, readonly visibleToAdmins: boolean, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null, readonly createdQuestions: { readonly __typename: 'CreatedQuestionsData', readonly pagination: { readonly __typename: 'PaginationData', readonly totalCount: number }, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly totalVotesCount: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }> }, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number, readonly comments: ReadonlyArray<{ readonly __typename: 'Comment', readonly id: string, readonly comment: string, readonly upvoteCount: number, readonly commenterChoice: { readonly __typename: 'QuestionChoice', readonly id: string } | null, readonly commenter: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly postAnonymously: boolean, readonly avatarUrl: string | null } | { readonly __typename: 'PublicRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly postAnonymously: boolean, readonly avatarUrl: string | null } }> }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly stats: { readonly __typename: 'QuestionStats', readonly id: string, readonly breakdowns: ReadonlyArray<{ readonly __typename: 'QuestionStatsBreakdown', readonly key: string, readonly hits: number, readonly buckets: ReadonlyArray<{ readonly __typename: 'StatBucketGroup', readonly key: string, readonly hits: number, readonly buckets: ReadonlyArray<{ readonly __typename: 'StatBucket', readonly key: string, readonly hits: number }> }> }> | null } }> } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly questionsCount: number, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly order: number, readonly visibleToAdmins: boolean, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null, readonly createdQuestions: { readonly __typename: 'CreatedQuestionsData', readonly pagination: { readonly __typename: 'PaginationData', readonly totalCount: number }, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly totalVotesCount: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }> }, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number, readonly comments: ReadonlyArray<{ readonly __typename: 'Comment', readonly id: string, readonly comment: string, readonly upvoteCount: number, readonly commenterChoice: { readonly __typename: 'QuestionChoice', readonly id: string } | null, readonly commenter: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly postAnonymously: boolean, readonly avatarUrl: string | null } | { readonly __typename: 'PublicRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly postAnonymously: boolean, readonly avatarUrl: string | null } }> }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly stats: { readonly __typename: 'QuestionStats', readonly id: string, readonly breakdowns: ReadonlyArray<{ readonly __typename: 'QuestionStatsBreakdown', readonly key: string, readonly hits: number, readonly buckets: ReadonlyArray<{ readonly __typename: 'StatBucketGroup', readonly key: string, readonly hits: number, readonly buckets: ReadonlyArray<{ readonly __typename: 'StatBucket', readonly key: string, readonly hits: number }> }> }> | null } }> } } | { readonly __typename: 'Survey', readonly id: string, readonly questionsCount: number, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly order: number, readonly visibleToAdmins: boolean, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null, readonly contents: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly totalVotesCount: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }> }, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number, readonly comments: ReadonlyArray<{ readonly __typename: 'Comment', readonly id: string, readonly comment: string, readonly upvoteCount: number, readonly commenterChoice: { readonly __typename: 'QuestionChoice', readonly id: string } | null, readonly commenter: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly postAnonymously: boolean, readonly avatarUrl: string | null } | { readonly __typename: 'PublicRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly postAnonymously: boolean, readonly avatarUrl: string | null } }> }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly stats: { readonly __typename: 'QuestionStats', readonly id: string, readonly breakdowns: ReadonlyArray<{ readonly __typename: 'QuestionStatsBreakdown', readonly key: string, readonly hits: number, readonly buckets: ReadonlyArray<{ readonly __typename: 'StatBucketGroup', readonly key: string, readonly hits: number, readonly buckets: ReadonlyArray<{ readonly __typename: 'StatBucket', readonly key: string, readonly hits: number }> }> }> | null } } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly structureType: QuestionHierarchyParentNodeType, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly structureDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly survey: { readonly __typename: 'Survey', readonly id: string }, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly totalVotesCount: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }> }, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number, readonly comments: ReadonlyArray<{ readonly __typename: 'Comment', readonly id: string, readonly comment: string, readonly upvoteCount: number, readonly commenterChoice: { readonly __typename: 'QuestionChoice', readonly id: string } | null, readonly commenter: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly postAnonymously: boolean, readonly avatarUrl: string | null } | { readonly __typename: 'PublicRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly postAnonymously: boolean, readonly avatarUrl: string | null } }> }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly stats: { readonly __typename: 'QuestionStats', readonly id: string, readonly breakdowns: ReadonlyArray<{ readonly __typename: 'QuestionStatsBreakdown', readonly key: string, readonly hits: number, readonly buckets: ReadonlyArray<{ readonly __typename: 'StatBucketGroup', readonly key: string, readonly hits: number, readonly buckets: ReadonlyArray<{ readonly __typename: 'StatBucket', readonly key: string, readonly hits: number }> }> }> | null } }> } | { readonly __typename: 'QuestionHierarchySimulationNode' } | { readonly __typename: 'QuestionHierarchyVisualizationNode' }> } | null };

export type AdminContentSetRespondentStatsWithRepresentivityDataVariables = Exact<{
  setId: Scalars['ID'];
  publishingEntityId: Scalars['ID'];
}>;


export type AdminContentSetRespondentStatsWithRepresentivityData = { readonly openContentSetById: { readonly __typename: 'GenericContent', readonly id: string, readonly slug: string | null, readonly shortId: string | null, readonly totalRespondents: number | null, readonly benchmarkType: { readonly __typename: 'BenchmarkType', readonly type: BenchmarkSurveyTypes | null, readonly weighted: boolean } | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string }, readonly alternateLanguages: ReadonlyArray<{ readonly __typename: 'Language', readonly id: string, readonly key: string, readonly name: string }>, readonly responsesOverTime: { readonly __typename: 'TimeBreakdown', readonly interval: TimeBreakdownInterval, readonly data: ReadonlyArray<{ readonly __typename: 'TimeBreakdownData', readonly value: number, readonly time: string }> } | null, readonly ageBreakdown: { readonly __typename: 'RepresentivityBreakdown', readonly label: string, readonly unknownBreakdown: { readonly __typename: 'RepresentivityUnknownBreakdownValue', readonly label: string, readonly respondentSelfReportedPercent: number, readonly respondentThirdPartyPercent: number } | null, readonly breakdowns: ReadonlyArray<{ readonly __typename: 'RepresentivityBreakdownValue', readonly label: string, readonly respondentSelfReportedPercent: number, readonly respondentThirdPartyPercent: number, readonly communityPercent: number | null }> } | null, readonly genderBreakdown: { readonly __typename: 'RepresentivityBreakdown', readonly label: string, readonly unknownBreakdown: { readonly __typename: 'RepresentivityUnknownBreakdownValue', readonly label: string, readonly respondentSelfReportedPercent: number, readonly respondentThirdPartyPercent: number } | null, readonly breakdowns: ReadonlyArray<{ readonly __typename: 'RepresentivityBreakdownValue', readonly label: string, readonly respondentSelfReportedPercent: number, readonly respondentThirdPartyPercent: number, readonly communityPercent: number | null }> } | null, readonly raceBreakdown: { readonly __typename: 'RepresentivityBreakdown', readonly label: string, readonly unknownBreakdown: { readonly __typename: 'RepresentivityUnknownBreakdownValue', readonly label: string, readonly respondentSelfReportedPercent: number, readonly respondentThirdPartyPercent: number } | null, readonly breakdowns: ReadonlyArray<{ readonly __typename: 'RepresentivityBreakdownValue', readonly label: string, readonly respondentSelfReportedPercent: number, readonly respondentThirdPartyPercent: number, readonly communityPercent: number | null }> } | null, readonly sampleBreakdown: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly languageBreakdown: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly verifiedResponses: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown' } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta', readonly changeLabel: string, readonly currentValue: number, readonly label: string, readonly recentChange: number } | null } | { readonly __typename: 'PolcoLive' } | { readonly __typename: 'QuestionSet' } | { readonly __typename: 'Survey', readonly id: string, readonly slug: string | null, readonly shortId: string | null, readonly totalRespondents: number | null, readonly benchmarkType: { readonly __typename: 'BenchmarkType', readonly type: BenchmarkSurveyTypes | null, readonly weighted: boolean } | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string }, readonly alternateLanguages: ReadonlyArray<{ readonly __typename: 'Language', readonly id: string, readonly key: string, readonly name: string }>, readonly responsesOverTime: { readonly __typename: 'TimeBreakdown', readonly interval: TimeBreakdownInterval, readonly data: ReadonlyArray<{ readonly __typename: 'TimeBreakdownData', readonly value: number, readonly time: string }> } | null, readonly ageBreakdown: { readonly __typename: 'RepresentivityBreakdown', readonly label: string, readonly unknownBreakdown: { readonly __typename: 'RepresentivityUnknownBreakdownValue', readonly label: string, readonly respondentSelfReportedPercent: number, readonly respondentThirdPartyPercent: number } | null, readonly breakdowns: ReadonlyArray<{ readonly __typename: 'RepresentivityBreakdownValue', readonly label: string, readonly respondentSelfReportedPercent: number, readonly respondentThirdPartyPercent: number, readonly communityPercent: number | null }> } | null, readonly genderBreakdown: { readonly __typename: 'RepresentivityBreakdown', readonly label: string, readonly unknownBreakdown: { readonly __typename: 'RepresentivityUnknownBreakdownValue', readonly label: string, readonly respondentSelfReportedPercent: number, readonly respondentThirdPartyPercent: number } | null, readonly breakdowns: ReadonlyArray<{ readonly __typename: 'RepresentivityBreakdownValue', readonly label: string, readonly respondentSelfReportedPercent: number, readonly respondentThirdPartyPercent: number, readonly communityPercent: number | null }> } | null, readonly raceBreakdown: { readonly __typename: 'RepresentivityBreakdown', readonly label: string, readonly unknownBreakdown: { readonly __typename: 'RepresentivityUnknownBreakdownValue', readonly label: string, readonly respondentSelfReportedPercent: number, readonly respondentThirdPartyPercent: number } | null, readonly breakdowns: ReadonlyArray<{ readonly __typename: 'RepresentivityBreakdownValue', readonly label: string, readonly respondentSelfReportedPercent: number, readonly respondentThirdPartyPercent: number, readonly communityPercent: number | null }> } | null, readonly sampleBreakdown: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly languageBreakdown: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly verifiedResponses: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown' } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta', readonly changeLabel: string, readonly currentValue: number, readonly label: string, readonly recentChange: number } | null } | null };

export type AdminContentSetRespondentsStatsVariables = Exact<{
  setId: Scalars['ID'];
  publishingEntityId: Scalars['ID'];
}>;


export type AdminContentSetRespondentsStats = { readonly openContentSetById: { readonly __typename: 'GenericContent' } | { readonly __typename: 'PolcoLive' } | { readonly __typename: 'QuestionSet' } | { readonly __typename: 'Survey', readonly id: string, readonly slug: string | null, readonly shortId: string | null, readonly totalRespondents: number | null, readonly benchmarkType: { readonly __typename: 'BenchmarkType', readonly type: BenchmarkSurveyTypes | null, readonly weighted: boolean } | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string }, readonly alternateLanguages: ReadonlyArray<{ readonly __typename: 'Language', readonly id: string, readonly key: string, readonly name: string }>, readonly responsesOverTime: { readonly __typename: 'TimeBreakdown', readonly interval: TimeBreakdownInterval, readonly data: ReadonlyArray<{ readonly __typename: 'TimeBreakdownData', readonly value: number, readonly time: string }> } | null, readonly ageBreakdownThirdParty: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly ageBreakdownUserReported: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly genderBreakdownThirdParty: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly genderBreakdownUserReported: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly sampleBreakdown: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly languageBreakdown: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly raceBreakdown: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly verifiedResponses: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown' } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta', readonly changeLabel: string, readonly currentValue: number, readonly label: string, readonly recentChange: number } | null } | null };

export type AdminContentSetRespondentsStatsLocationVariables = Exact<{
  setId: Scalars['ID'];
  publishingEntityId: Scalars['ID'];
  geoViewId: Scalars['ID'];
}>;


export type AdminContentSetRespondentsStatsLocation = { readonly openContentSetById: { readonly __typename: 'GenericContent' } | { readonly __typename: 'PolcoLive' } | { readonly __typename: 'QuestionSet' } | { readonly __typename: 'Survey', readonly id: string, readonly locationBreakdown: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown' } | { readonly __typename: 'StatBreakdownLocation', readonly center: { readonly __typename: 'CoordinateCenter', readonly size: number, readonly coordinate: { readonly __typename: 'Coordinate', readonly lat: number, readonly lng: number } }, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownLocationValue', readonly key: string, readonly total: number, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } }> } | { readonly __typename: 'StatValueDelta' } | null } | null };

export type AdminCopyContentSetDataVariables = Exact<{
  filter: Scalars['String'];
}>;


export type AdminCopyContentSetData = { readonly currentUser: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly superAdmin: boolean, readonly managedPublishingEntities: ReadonlyArray<{ readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly presidingArea: { readonly __typename: 'PresidingArea', readonly id: string, readonly name: string } | null }> } | { readonly __typename: 'PublicAdmin' } | null } | null } };

export type AdminCurrentAiAssistantQueryStatusVariables = Exact<{
  sessionId: Scalars['ID'];
  assistant: AssistantIdInput;
}>;


export type AdminCurrentAiAssistantQueryStatus = { readonly currentAiAssistantSession: { readonly __typename: 'AiAssistantSession', readonly id: string, readonly queryStatus: { readonly __typename: 'AiAssistantQueryStatus', readonly type: AiAssistantQueryStatusType, readonly loadingText: string | null, readonly message: string | null } | null } };

export type AdminCurrentAiAssistantSessionConversationVariables = Exact<{
  sessionId: Scalars['ID'];
  assistant: AssistantIdInput;
}>;


export type AdminCurrentAiAssistantSessionConversation = { readonly currentAiAssistantSession: { readonly __typename: 'AiAssistantSession', readonly id: string, readonly conversation: { readonly __typename: 'AiAssistantConversation', readonly modelVersion: string | null, readonly userId: string | null, readonly publishingEntityId: string | null, readonly messages: ReadonlyArray<{ readonly __typename: 'AiAssistantMessage', readonly role: AiAssistantMessageRole, readonly content: string, readonly timestamp: { readonly __typename: 'GqlDate', readonly raw: number } }> | null } | null } };

export type AdminCurrentAiAssistantSessionStatusVariables = Exact<{
  sessionId: Scalars['ID'];
  assistant: AssistantIdInput;
}>;


export type AdminCurrentAiAssistantSessionStatus = { readonly currentAiAssistantSession: { readonly __typename: 'AiAssistantSession', readonly id: string, readonly status: AiAssistantSessionStatusType | null } };

export type AdminDashboardVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type AdminDashboard = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly totalSubscribers: number | null, readonly totalResponses: { readonly __typename: 'StatValueDelta', readonly changeLabel: string, readonly currentValue: number, readonly label: string, readonly recentChange: number } | null, readonly subscribersOverTime: { readonly __typename: 'TimeBreakdown', readonly interval: TimeBreakdownInterval, readonly data: ReadonlyArray<{ readonly __typename: 'TimeBreakdownData', readonly value: number, readonly time: string }> } | null } | null };

export type AdminDashboardDemographicsVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type AdminDashboardDemographics = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly ageBreakdownThirdParty: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly ageBreakdownUserReported: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly genderBreakdownThirdParty: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly genderBreakdownUserReported: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly raceBreakdown: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null } | null };

export type AdminDashboardLocationVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  geoViewId: Scalars['ID'];
}>;


export type AdminDashboardLocation = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly locationBreakdown: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown' } | { readonly __typename: 'StatBreakdownLocation', readonly center: { readonly __typename: 'CoordinateCenter', readonly size: number, readonly coordinate: { readonly __typename: 'Coordinate', readonly lat: number, readonly lng: number } }, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownLocationValue', readonly key: string, readonly total: number, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } }> } | { readonly __typename: 'StatValueDelta' } | null } | null };

export type AdminLibraryContentSearchVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  query: Scalars['String'];
}>;


export type AdminLibraryContentSearch = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly featureSettings: ReadonlyArray<{ readonly __typename: 'PublishingEntityFeatureSetting', readonly id: string, readonly featureSettingName: string, readonly enabled: boolean }> | null, readonly searchShareableContent: { readonly __typename: 'LibrarySearchResult', readonly paywalledItemCount: number, readonly surveys: ReadonlyArray<{ readonly __typename: 'GenericContent', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly questionsCount: number, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string }, readonly shareableContentSet: { readonly __typename: 'ShareableContentSet', readonly id: string, readonly shareType: ShareableContentType, readonly order: number | null, readonly adminDescription: string | null, readonly numberOfShares: number, readonly domains: ReadonlyArray<ShareableContentDomains>, readonly isPaidContent: boolean } | null } | { readonly __typename: 'PolcoLive', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly questionsCount: number, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string }, readonly shareableContentSet: { readonly __typename: 'ShareableContentSet', readonly id: string, readonly shareType: ShareableContentType, readonly order: number | null, readonly adminDescription: string | null, readonly numberOfShares: number, readonly domains: ReadonlyArray<ShareableContentDomains>, readonly isPaidContent: boolean } | null } | { readonly __typename: 'QuestionSet', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly questionsCount: number, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string }, readonly shareableContentSet: { readonly __typename: 'ShareableContentSet', readonly id: string, readonly shareType: ShareableContentType, readonly order: number | null, readonly adminDescription: string | null, readonly numberOfShares: number, readonly domains: ReadonlyArray<ShareableContentDomains>, readonly isPaidContent: boolean } | null } | { readonly __typename: 'Survey', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly questionsCount: number, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string }, readonly shareableContentSet: { readonly __typename: 'ShareableContentSet', readonly id: string, readonly shareType: ShareableContentType, readonly order: number | null, readonly adminDescription: string | null, readonly numberOfShares: number, readonly domains: ReadonlyArray<ShareableContentDomains>, readonly isPaidContent: boolean } | null }>, readonly simulations: ReadonlyArray<{ readonly __typename: 'AdminBalancingActSimulation', readonly id: number, readonly name: string, readonly description: string | null, readonly type: BalancingActSimulationType, readonly status: QuestionSetStatus, readonly isPrioritization: boolean, readonly url: string, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number } }> } } | null };

export type ContentSetAndShareable_GenericContent_ = { readonly __typename: 'GenericContent', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly questionsCount: number, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string }, readonly shareableContentSet: { readonly __typename: 'ShareableContentSet', readonly id: string, readonly shareType: ShareableContentType, readonly order: number | null, readonly adminDescription: string | null, readonly numberOfShares: number, readonly domains: ReadonlyArray<ShareableContentDomains>, readonly isPaidContent: boolean } | null };

export type ContentSetAndShareable_PolcoLive_ = { readonly __typename: 'PolcoLive', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly questionsCount: number, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string }, readonly shareableContentSet: { readonly __typename: 'ShareableContentSet', readonly id: string, readonly shareType: ShareableContentType, readonly order: number | null, readonly adminDescription: string | null, readonly numberOfShares: number, readonly domains: ReadonlyArray<ShareableContentDomains>, readonly isPaidContent: boolean } | null };

export type ContentSetAndShareable_QuestionSet_ = { readonly __typename: 'QuestionSet', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly questionsCount: number, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string }, readonly shareableContentSet: { readonly __typename: 'ShareableContentSet', readonly id: string, readonly shareType: ShareableContentType, readonly order: number | null, readonly adminDescription: string | null, readonly numberOfShares: number, readonly domains: ReadonlyArray<ShareableContentDomains>, readonly isPaidContent: boolean } | null };

export type ContentSetAndShareable_Survey_ = { readonly __typename: 'Survey', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly questionsCount: number, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string }, readonly shareableContentSet: { readonly __typename: 'ShareableContentSet', readonly id: string, readonly shareType: ShareableContentType, readonly order: number | null, readonly adminDescription: string | null, readonly numberOfShares: number, readonly domains: ReadonlyArray<ShareableContentDomains>, readonly isPaidContent: boolean } | null };

export type ContentSetAndShareable = ContentSetAndShareable_GenericContent_ | ContentSetAndShareable_PolcoLive_ | ContentSetAndShareable_QuestionSet_ | ContentSetAndShareable_Survey_;

export type AdminLiveQuestionResultsVariables = Exact<{
  questionId: Scalars['ID'];
  pagination: PaginationParams;
}>;


export type AdminLiveQuestionResults = { readonly openQuestion: { readonly __typename: 'Question', readonly id: string, readonly totalVotesCount: number | null, readonly variableName: string | null, readonly optional: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly text: string, readonly value: number }> | null, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number, readonly comments: ReadonlyArray<{ readonly __typename: 'Comment', readonly id: string, readonly comment: string, readonly upvoteCount: number, readonly commenterChoice: { readonly __typename: 'QuestionChoice', readonly id: string } | null, readonly commenter: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly postAnonymously: boolean, readonly avatarUrl: string | null } | { readonly __typename: 'PublicRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly postAnonymously: boolean, readonly avatarUrl: string | null }, readonly commentDate: { readonly __typename: 'GqlDate', readonly raw: number } }> }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }> } | null };

export type AdminLiveQuestionSetStructureVariables = Exact<{
  setId: Scalars['ID'];
}>;


export type AdminLiveQuestionSetStructure = { readonly openContentSetById: { readonly __typename: 'GenericContent' } | { readonly __typename: 'PolcoLive', readonly id: string, readonly createdQuestions: { readonly __typename: 'CreatedQuestionsData', readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly totalVotesCount: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType } }> }, readonly settings: { readonly __typename: 'PolcoLiveSettings', readonly id: string, readonly state: QuestionStatus, readonly eventStartDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly eventEndDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } } | { readonly __typename: 'QuestionSet' } | { readonly __typename: 'Survey' } | null };

export type AdminLoadEmailListWithEmailsVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type AdminLoadEmailListWithEmails = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string, readonly emails: ReadonlyArray<string> }> } | null };

export type AdminLoadPublisherShareConfigurationsVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type AdminLoadPublisherShareConfigurations = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly totalSubscribers: number | null, readonly socialConnections: ReadonlyArray<{ readonly __typename: 'SocialConnection', readonly id: string, readonly provider: SocialConnectionProvider, readonly profileNames: ReadonlyArray<string> }> | null, readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | null };

export type AdminLoadQuestionSetCreationDataVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type AdminLoadQuestionSetCreationData = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly featureSettings: ReadonlyArray<{ readonly __typename: 'PublishingEntityFeatureSetting', readonly id: string, readonly featureSettingId: string, readonly featureSettingName: string, readonly activeCount: number | null, readonly quantity: number, readonly isUnlimited: boolean, readonly enabled: boolean, readonly expirationDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }> | null, readonly demographicQuestions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly summary: string | null, readonly optional: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus }, readonly demographicAttribute: { readonly __typename: 'DemographicAttribute', readonly id: string, readonly name: string, readonly premium: boolean, readonly owner: { readonly __typename: 'PublishingEntity', readonly id: string } | null } | null }> } | null };

export type AdminLoadQuestionSetImagesVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type AdminLoadQuestionSetImages = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly questionSetImages: ReadonlyArray<{ readonly __typename: 'QuestionSetImage', readonly id: string, readonly horizontalUrl: string }> } | null };

export type AdminMenuItemsVariables = Exact<{ [key: string]: never; }>;


export type AdminMenuItems = { readonly currentUser: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly menuItems: ReadonlyArray<{ readonly __typename: 'MenuItem', readonly id: string, readonly text: string, readonly url: string | null, readonly icon: string | null, readonly materialIcon: string | null, readonly isNew: boolean | null, readonly isShown: boolean | null, readonly childrenMenuItems: ReadonlyArray<{ readonly __typename: 'MenuItem', readonly id: string, readonly text: string, readonly url: string | null, readonly icon: string | null, readonly materialIcon: string | null, readonly isNew: boolean | null, readonly isShown: boolean | null }> }> } | { readonly __typename: 'PublicAdmin' } | null } | null } };

export type AdminNcsFacetSummariesVariables = Exact<{ [key: string]: never; }>;


export type AdminNcsFacetSummaries = { readonly currentUser: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly activePublishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly ncsFacetSummaries: ReadonlyArray<{ readonly __typename: 'NcsFacetSummary', readonly id: string, readonly surveyid: string, readonly GEO_NAME: string, readonly fips: number, readonly year: number, readonly ncs: number, readonly added: string, readonly area: number, readonly title: string, readonly newmax: number, readonly pctpos: number, readonly avgptm: number, readonly n: number, readonly bmark: string }> | null } | null } | { readonly __typename: 'PublicAdmin' } | null } | null } };

export type AdminOpenBalancingActSimulationVariables = Exact<{
  balancingActSimulationId: Scalars['Int'];
}>;


export type AdminOpenBalancingActSimulation = { readonly openBalancingActSimulation: { readonly __typename: 'BalancingActSimulationWithPubId', readonly id: number, readonly url: string, readonly publishingEntityId: string } };

export type AdminOpenBalancingActTaxReceiptVariables = Exact<{
  balancingActTaxReceiptId: Scalars['Int'];
}>;


export type AdminOpenBalancingActTaxReceipt = { readonly openBalancingActTaxReceipt: { readonly __typename: 'BalancingActSimulationWithPubId', readonly id: number, readonly url: string, readonly publishingEntityId: string } };

export type AdminOpenDashboardByIdVariables = Exact<{
  dashboardId: Scalars['ID'];
  areaMode?: InputMaybe<TrackAreaMode>;
  comparisonGroupId?: InputMaybe<Scalars['ID']>;
  fipsCodes?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type AdminOpenDashboardById = { readonly openDashboardById: { readonly __typename: 'Dashboard', readonly id: string, readonly name: string, readonly nodes: ReadonlyArray<{ readonly __typename: 'DashboardByodVariableNode', readonly id: string, readonly byodVariable: { readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } } | { readonly __typename: 'DashboardHtmlNode', readonly id: string, readonly rawHtml: string } | { readonly __typename: 'DashboardVariableNode', readonly id: string, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } }> | null } };

export type AdminOpenFullTrendsQuestionSetAggregateResultsVariables = Exact<{
  setId: Scalars['ID'];
  filterByTopicIds?: InputMaybe<ReadonlyArray<Scalars['ID']> | Scalars['ID']>;
  reportingBetaMode?: InputMaybe<Scalars['Boolean']>;
  areaMode?: InputMaybe<TrackAreaMode>;
  comparisonGroupId?: InputMaybe<Scalars['ID']>;
  fipsCodes?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type AdminOpenFullTrendsQuestionSetAggregateResults = { readonly openContentSetById: { readonly __typename: 'GenericContent', readonly id: string, readonly hasAutomaticWeighting: boolean, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly hasAutomaticWeighting: boolean, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly hasAutomaticWeighting: boolean, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'Survey', readonly id: string, readonly hasAutomaticWeighting: boolean, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly benchmarkType: { readonly __typename: 'BenchmarkType', readonly weighted: boolean } | null, readonly topics: ReadonlyArray<{ readonly __typename: 'SurveyBenchmarkTopic', readonly id: string, readonly topic: { readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string, readonly icon: string | null, readonly description: string | null, readonly trackDomain: AnalyticsDomain | null, readonly category: { readonly __typename: 'TopicCategory', readonly id: string, readonly name: string, readonly priority: number | null } | null } }>, readonly contents: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly variableName: string | null, readonly isBenchmarkedQuestion: boolean, readonly questionNumber: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null }, readonly hierarchyParentNode: { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null } | null, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number }, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly value: number, readonly text: string }> | null, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly topic: string | null, readonly category: string | null, readonly choices: ReadonlyArray<{ readonly __typename: 'AggregateVotingChoice', readonly rawTotal: number, readonly weightedTotal: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly trendSignificance: number | null, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly scalePercent: number, readonly value: TrendValue | null, readonly date: { readonly __typename: 'GqlDate', readonly raw: number }, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null }> } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue, readonly rank: number, readonly totalDataPoints: number, readonly benchmarkSignificance: number | null, readonly dateRange: { readonly __typename: 'BenchmarkDateRange', readonly start: { readonly __typename: 'GqlDate', readonly raw: number }, readonly end: { readonly __typename: 'GqlDate', readonly raw: number } } } | null } | null } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly questionNumber: number | null, readonly structureType: QuestionHierarchyParentNodeType, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly variableName: string | null, readonly isBenchmarkedQuestion: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null }, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly topic: string | null, readonly category: string | null, readonly choices: ReadonlyArray<{ readonly __typename: 'AggregateVotingChoice', readonly rawTotal: number, readonly weightedTotal: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly trendSignificance: number | null, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly scalePercent: number, readonly value: TrendValue | null, readonly date: { readonly __typename: 'GqlDate', readonly raw: number }, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null }> } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue, readonly rank: number, readonly totalDataPoints: number, readonly benchmarkSignificance: number | null, readonly dateRange: { readonly __typename: 'BenchmarkDateRange', readonly start: { readonly __typename: 'GqlDate', readonly raw: number }, readonly end: { readonly __typename: 'GqlDate', readonly raw: number } } } | null } | null }> } | { readonly __typename: 'QuestionHierarchySimulationNode', readonly id: string, readonly simulationType: SimulationNodeType, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly simulation: { readonly __typename: 'SimulationNodeData', readonly id: number, readonly url: string, readonly adminData: { readonly __typename: 'SimulationNodeAdminData', readonly name: string, readonly description: string | null, readonly prioritization: boolean, readonly simulationType: BalancingActSimulationType, readonly status: QuestionSetStatus } | null } | null } | { readonly __typename: 'QuestionHierarchyVisualizationNode', readonly id: string, readonly altLabel: string | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly trackVariableVisualization: { readonly __typename: 'TrackVariableVisualization', readonly id: string, readonly fips: string | null, readonly publishingEntityId: string, readonly benchmarkFilter: BenchmarkFilter, readonly visualizationType: VisualizationType | null, readonly state: SavedVisualizationActivationState, readonly comparisonGroupId: string | null, readonly visualizationAreas: ReadonlyArray<{ readonly __typename: 'FipsArea', readonly id: string, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null }>, readonly plans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }>, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly trackVariables: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } | { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }> } | null }> } | null };

export type AdminOpenPublishingEntityGeoViewByIdVariables = Exact<{
  geoViewId: Scalars['ID'];
}>;


export type AdminOpenPublishingEntityGeoViewById = { readonly openPublishingEntityGeoViewById: { readonly __typename: 'PublishingEntityGeoView', readonly id: string, readonly name: string, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly geoAreas: ReadonlyArray<{ readonly __typename: 'GeoArea', readonly id: string, readonly name: string, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } }> } | null };

export type AdminOpenQuestionVariables = Exact<{
  questionId: Scalars['ID'];
  filter?: InputMaybe<ResultFilter>;
}>;


export type AdminOpenQuestion = { readonly openQuestion: { readonly __typename: 'Question', readonly id: string, readonly summary: string | null, readonly shortId: string | null, readonly optional: boolean, readonly isBenchmarkedQuestion: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }> }, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }> } | null };

export type AdminOpenQuestionAggregateResultsVariables = Exact<{
  questionId: Scalars['ID'];
  reportingBetaMode?: InputMaybe<Scalars['Boolean']>;
}>;


export type AdminOpenQuestionAggregateResults = { readonly openQuestion: { readonly __typename: 'Question', readonly id: string, readonly isBenchmarkedQuestion: boolean, readonly questionNumber: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleThreshold: number, readonly scaleType: ScaleType, readonly alternateScaleName: string | null } | null }, readonly hierarchyParentNode: { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null } | null, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'Survey', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly topic: string | null, readonly category: string | null, readonly choices: ReadonlyArray<{ readonly __typename: 'AggregateVotingChoice', readonly rawTotal: number, readonly weightedTotal: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly trendSignificance: number | null, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly scalePercent: number, readonly value: TrendValue | null, readonly date: { readonly __typename: 'GqlDate', readonly raw: number }, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null }> } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue, readonly rank: number, readonly totalDataPoints: number, readonly benchmarkSignificance: number | null, readonly dateRange: { readonly __typename: 'BenchmarkDateRange', readonly start: { readonly __typename: 'GqlDate', readonly raw: number }, readonly end: { readonly __typename: 'GqlDate', readonly raw: number } } } | null } | null, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number }, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly value: number, readonly text: string }> | null } | null };

export type AdminOpenQuestionBaseVariables = Exact<{
  questionId: Scalars['ID'];
}>;


export type AdminOpenQuestionBase = { readonly openQuestion: { readonly __typename: 'Question', readonly id: string, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string } } | { readonly __typename: 'Survey', readonly id: string, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string } } } | null };

export type AdminOpenQuestionSetVariables = Exact<{
  setId: Scalars['ID'];
  filter?: InputMaybe<ResultFilter>;
  commentFilter?: InputMaybe<CommentFilter>;
  filterByTopicIds?: InputMaybe<ReadonlyArray<Scalars['ID']> | Scalars['ID']>;
  areaMode?: InputMaybe<TrackAreaMode>;
  comparisonGroupId?: InputMaybe<Scalars['ID']>;
  fipsCodes?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type AdminOpenQuestionSet = { readonly openContentSetById: { readonly __typename: 'GenericContent', readonly id: string, readonly slug: string | null, readonly allowGuestRespondents: boolean, readonly allowMultipleResponses: boolean, readonly showConversionPrompts: boolean, readonly setImageId: string | null, readonly featureSetType: QuestionSetFeatureSetType | null, readonly questionsCount: number, readonly hasBenchmarkedContent: boolean, readonly polcoManaged: boolean, readonly isPinnedToPublisher: boolean, readonly hasAutomaticWeighting: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly id: string, readonly horizontalUrl: string } | null, readonly accessSetting: { readonly __typename: 'AccessSetting_Email', readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | { readonly __typename: 'AccessSetting_Everyone' } | { readonly __typename: 'AccessSetting_Link' } | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly dimensionGroupDefinitions: ReadonlyArray<{ readonly __typename: 'DimensionGroupDefinition', readonly id: string, readonly description: string }>, readonly benchmarkType: { readonly __typename: 'BenchmarkType', readonly weighted: boolean } | null, readonly topics: ReadonlyArray<{ readonly __typename: 'SurveyBenchmarkTopic', readonly id: string, readonly topic: { readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string, readonly icon: string | null, readonly description: string | null, readonly trackDomain: AnalyticsDomain | null, readonly category: { readonly __typename: 'TopicCategory', readonly id: string, readonly name: string, readonly priority: number | null } | null } }>, readonly contents: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly summary: string | null, readonly questionNumber: number | null, readonly optional: boolean, readonly isBenchmarkedQuestion: boolean, readonly variableName: string | null, readonly totalVotesCount: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly text: string, readonly value: number }> | null, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number }, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string } } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly questionNumber: number | null, readonly hasBenchmarkedContent: boolean, readonly structureType: QuestionHierarchyParentNodeType, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly structureDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly survey: { readonly __typename: 'Survey', readonly id: string }, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly isBenchmarkedQuestion: boolean, readonly variableName: string | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus } }> } | { readonly __typename: 'QuestionHierarchySimulationNode', readonly id: string, readonly simulationType: SimulationNodeType, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly simulation: { readonly __typename: 'SimulationNodeData', readonly id: number, readonly url: string, readonly adminData: { readonly __typename: 'SimulationNodeAdminData', readonly name: string, readonly description: string | null, readonly prioritization: boolean, readonly simulationType: BalancingActSimulationType, readonly status: QuestionSetStatus } | null } | null } | { readonly __typename: 'QuestionHierarchyVisualizationNode', readonly id: string, readonly altLabel: string | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly trackVariableVisualization: { readonly __typename: 'TrackVariableVisualization', readonly id: string, readonly fips: string | null, readonly publishingEntityId: string, readonly benchmarkFilter: BenchmarkFilter, readonly visualizationType: VisualizationType | null, readonly state: SavedVisualizationActivationState, readonly comparisonGroupId: string | null, readonly visualizationAreas: ReadonlyArray<{ readonly __typename: 'FipsArea', readonly id: string, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null }>, readonly plans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }>, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly trackVariables: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } | { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }> } | null }> } | { readonly __typename: 'PolcoLive', readonly id: string, readonly slug: string | null, readonly allowGuestRespondents: boolean, readonly allowMultipleResponses: boolean, readonly showConversionPrompts: boolean, readonly setImageId: string | null, readonly featureSetType: QuestionSetFeatureSetType | null, readonly questionsCount: number, readonly hasBenchmarkedContent: boolean, readonly polcoManaged: boolean, readonly isPinnedToPublisher: boolean, readonly hasAutomaticWeighting: boolean, readonly shortId: string | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly id: string, readonly horizontalUrl: string } | null, readonly accessSetting: { readonly __typename: 'AccessSetting_Email', readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | { readonly __typename: 'AccessSetting_Everyone' } | { readonly __typename: 'AccessSetting_Link' } | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly settings: { readonly __typename: 'PolcoLiveSettings', readonly id: string, readonly liveVideoLink: string | null, readonly state: QuestionStatus, readonly eventStartDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly eventEndDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly createdQuestions: { readonly __typename: 'CreatedQuestionsData', readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly variableName: string | null, readonly totalVotesCount: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly value: number, readonly text: string }> | null, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number }, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string } }>, readonly pagination: { readonly __typename: 'PaginationData', readonly totalCount: number } } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly slug: string | null, readonly allowGuestRespondents: boolean, readonly allowMultipleResponses: boolean, readonly showConversionPrompts: boolean, readonly setImageId: string | null, readonly featureSetType: QuestionSetFeatureSetType | null, readonly questionsCount: number, readonly hasBenchmarkedContent: boolean, readonly polcoManaged: boolean, readonly isPinnedToPublisher: boolean, readonly hasAutomaticWeighting: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly id: string, readonly horizontalUrl: string } | null, readonly accessSetting: { readonly __typename: 'AccessSetting_Email', readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | { readonly __typename: 'AccessSetting_Everyone' } | { readonly __typename: 'AccessSetting_Link' } | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly createdQuestions: { readonly __typename: 'CreatedQuestionsData', readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly isBenchmarkedQuestion: boolean, readonly variableName: string | null, readonly totalVotesCount: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly value: number, readonly text: string }> | null, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number }, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string } }>, readonly pagination: { readonly __typename: 'PaginationData', readonly totalCount: number } } } | { readonly __typename: 'Survey', readonly id: string, readonly slug: string | null, readonly allowGuestRespondents: boolean, readonly allowMultipleResponses: boolean, readonly showConversionPrompts: boolean, readonly setImageId: string | null, readonly featureSetType: QuestionSetFeatureSetType | null, readonly questionsCount: number, readonly hasBenchmarkedContent: boolean, readonly polcoManaged: boolean, readonly isPinnedToPublisher: boolean, readonly hasAutomaticWeighting: boolean, readonly hasVisibleReportTabs: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly id: string, readonly horizontalUrl: string } | null, readonly accessSetting: { readonly __typename: 'AccessSetting_Email', readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | { readonly __typename: 'AccessSetting_Everyone' } | { readonly __typename: 'AccessSetting_Link' } | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly dimensionGroupDefinitions: ReadonlyArray<{ readonly __typename: 'DimensionGroupDefinition', readonly id: string, readonly description: string }>, readonly benchmarkType: { readonly __typename: 'BenchmarkType', readonly weighted: boolean } | null, readonly topics: ReadonlyArray<{ readonly __typename: 'SurveyBenchmarkTopic', readonly id: string, readonly topic: { readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string, readonly icon: string | null, readonly description: string | null, readonly trackDomain: AnalyticsDomain | null, readonly category: { readonly __typename: 'TopicCategory', readonly id: string, readonly name: string, readonly priority: number | null } | null } }>, readonly contents: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly summary: string | null, readonly questionNumber: number | null, readonly optional: boolean, readonly isBenchmarkedQuestion: boolean, readonly variableName: string | null, readonly totalVotesCount: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly text: string, readonly value: number }> | null, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number }, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string } } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly questionNumber: number | null, readonly hasBenchmarkedContent: boolean, readonly structureType: QuestionHierarchyParentNodeType, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly structureDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly survey: { readonly __typename: 'Survey', readonly id: string }, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly isBenchmarkedQuestion: boolean, readonly variableName: string | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus } }> } | { readonly __typename: 'QuestionHierarchySimulationNode', readonly id: string, readonly simulationType: SimulationNodeType, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly simulation: { readonly __typename: 'SimulationNodeData', readonly id: number, readonly url: string, readonly adminData: { readonly __typename: 'SimulationNodeAdminData', readonly name: string, readonly description: string | null, readonly prioritization: boolean, readonly simulationType: BalancingActSimulationType, readonly status: QuestionSetStatus } | null } | null } | { readonly __typename: 'QuestionHierarchyVisualizationNode', readonly id: string, readonly altLabel: string | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly trackVariableVisualization: { readonly __typename: 'TrackVariableVisualization', readonly id: string, readonly fips: string | null, readonly publishingEntityId: string, readonly benchmarkFilter: BenchmarkFilter, readonly visualizationType: VisualizationType | null, readonly state: SavedVisualizationActivationState, readonly comparisonGroupId: string | null, readonly visualizationAreas: ReadonlyArray<{ readonly __typename: 'FipsArea', readonly id: string, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null }>, readonly plans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }>, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly trackVariables: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } | { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }> } | null }> } | null };

export type AdminOpenQuestionSet_QuestionSet = { readonly __typename: 'QuestionSet', readonly createdQuestions: { readonly __typename: 'CreatedQuestionsData', readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly isBenchmarkedQuestion: boolean, readonly variableName: string | null, readonly totalVotesCount: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly value: number, readonly text: string }> | null, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number }, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string } }>, readonly pagination: { readonly __typename: 'PaginationData', readonly totalCount: number } } };

export type AdminOpenQuestionSet_PolcoLive = { readonly __typename: 'PolcoLive', readonly shortId: string | null, readonly settings: { readonly __typename: 'PolcoLiveSettings', readonly id: string, readonly liveVideoLink: string | null, readonly state: QuestionStatus, readonly eventStartDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly eventEndDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly createdQuestions: { readonly __typename: 'CreatedQuestionsData', readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly variableName: string | null, readonly totalVotesCount: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly value: number, readonly text: string }> | null, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number }, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string } }>, readonly pagination: { readonly __typename: 'PaginationData', readonly totalCount: number } } };

export type AdminOpenQuestionSet_Survey = { readonly __typename: 'Survey', readonly hasAutomaticWeighting: boolean, readonly hasVisibleReportTabs: boolean, readonly dimensionGroupDefinitions: ReadonlyArray<{ readonly __typename: 'DimensionGroupDefinition', readonly id: string, readonly description: string }>, readonly benchmarkType: { readonly __typename: 'BenchmarkType', readonly weighted: boolean } | null, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly topics: ReadonlyArray<{ readonly __typename: 'SurveyBenchmarkTopic', readonly id: string, readonly topic: { readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string, readonly icon: string | null, readonly description: string | null, readonly trackDomain: AnalyticsDomain | null, readonly category: { readonly __typename: 'TopicCategory', readonly id: string, readonly name: string, readonly priority: number | null } | null } }>, readonly contents: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly summary: string | null, readonly questionNumber: number | null, readonly optional: boolean, readonly isBenchmarkedQuestion: boolean, readonly variableName: string | null, readonly totalVotesCount: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly text: string, readonly value: number }> | null, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number }, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string } } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly questionNumber: number | null, readonly hasBenchmarkedContent: boolean, readonly structureType: QuestionHierarchyParentNodeType, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly structureDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly survey: { readonly __typename: 'Survey', readonly id: string }, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly isBenchmarkedQuestion: boolean, readonly variableName: string | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus } }> } | { readonly __typename: 'QuestionHierarchySimulationNode', readonly id: string, readonly simulationType: SimulationNodeType, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly simulation: { readonly __typename: 'SimulationNodeData', readonly id: number, readonly url: string, readonly adminData: { readonly __typename: 'SimulationNodeAdminData', readonly name: string, readonly description: string | null, readonly prioritization: boolean, readonly simulationType: BalancingActSimulationType, readonly status: QuestionSetStatus } | null } | null } | { readonly __typename: 'QuestionHierarchyVisualizationNode', readonly id: string, readonly altLabel: string | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly trackVariableVisualization: { readonly __typename: 'TrackVariableVisualization', readonly id: string, readonly fips: string | null, readonly publishingEntityId: string, readonly benchmarkFilter: BenchmarkFilter, readonly visualizationType: VisualizationType | null, readonly state: SavedVisualizationActivationState, readonly comparisonGroupId: string | null, readonly visualizationAreas: ReadonlyArray<{ readonly __typename: 'FipsArea', readonly id: string, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null }>, readonly plans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }>, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly trackVariables: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } | { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }> } | null }> };

export type AdminOpenQuestionSet_Generic = { readonly __typename: 'GenericContent', readonly hasAutomaticWeighting: boolean, readonly dimensionGroupDefinitions: ReadonlyArray<{ readonly __typename: 'DimensionGroupDefinition', readonly id: string, readonly description: string }>, readonly benchmarkType: { readonly __typename: 'BenchmarkType', readonly weighted: boolean } | null, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly topics: ReadonlyArray<{ readonly __typename: 'SurveyBenchmarkTopic', readonly id: string, readonly topic: { readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string, readonly icon: string | null, readonly description: string | null, readonly trackDomain: AnalyticsDomain | null, readonly category: { readonly __typename: 'TopicCategory', readonly id: string, readonly name: string, readonly priority: number | null } | null } }>, readonly contents: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly summary: string | null, readonly questionNumber: number | null, readonly optional: boolean, readonly isBenchmarkedQuestion: boolean, readonly variableName: string | null, readonly totalVotesCount: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly text: string, readonly value: number }> | null, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number }, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string } } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly questionNumber: number | null, readonly hasBenchmarkedContent: boolean, readonly structureType: QuestionHierarchyParentNodeType, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly structureDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly survey: { readonly __typename: 'Survey', readonly id: string }, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly isBenchmarkedQuestion: boolean, readonly variableName: string | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus } }> } | { readonly __typename: 'QuestionHierarchySimulationNode', readonly id: string, readonly simulationType: SimulationNodeType, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly simulation: { readonly __typename: 'SimulationNodeData', readonly id: number, readonly url: string, readonly adminData: { readonly __typename: 'SimulationNodeAdminData', readonly name: string, readonly description: string | null, readonly prioritization: boolean, readonly simulationType: BalancingActSimulationType, readonly status: QuestionSetStatus } | null } | null } | { readonly __typename: 'QuestionHierarchyVisualizationNode', readonly id: string, readonly altLabel: string | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly trackVariableVisualization: { readonly __typename: 'TrackVariableVisualization', readonly id: string, readonly fips: string | null, readonly publishingEntityId: string, readonly benchmarkFilter: BenchmarkFilter, readonly visualizationType: VisualizationType | null, readonly state: SavedVisualizationActivationState, readonly comparisonGroupId: string | null, readonly visualizationAreas: ReadonlyArray<{ readonly __typename: 'FipsArea', readonly id: string, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null }>, readonly plans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }>, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly trackVariables: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } | { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }> } | null }> };

export type AdminOpenQuestionSetAggregateResultsVariables = Exact<{
  setId: Scalars['ID'];
  filterByTopicIds?: InputMaybe<ReadonlyArray<Scalars['ID']> | Scalars['ID']>;
  omitBenchmarks?: InputMaybe<Scalars['Boolean']>;
  omitTrends?: InputMaybe<Scalars['Boolean']>;
  reportingBetaMode?: InputMaybe<Scalars['Boolean']>;
  onlyGridQuestions?: InputMaybe<Scalars['Boolean']>;
  areaMode?: InputMaybe<TrackAreaMode>;
  comparisonGroupId?: InputMaybe<Scalars['ID']>;
  fipsCodes?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type AdminOpenQuestionSetAggregateResults = { readonly openContentSetById: { readonly __typename: 'GenericContent', readonly id: string, readonly hasAutomaticWeighting: boolean, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly benchmarkType: { readonly __typename: 'BenchmarkType', readonly weighted: boolean } | null, readonly topics: ReadonlyArray<{ readonly __typename: 'SurveyBenchmarkTopic', readonly id: string, readonly topic: { readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string, readonly icon: string | null, readonly description: string | null, readonly trackDomain: AnalyticsDomain | null, readonly category: { readonly __typename: 'TopicCategory', readonly id: string, readonly name: string, readonly priority: number | null } | null } }>, readonly contents: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly variableName: string | null, readonly isBenchmarkedQuestion: boolean, readonly questionNumber: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null }, readonly hierarchyParentNode: { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null } | null, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number }, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly value: number, readonly text: string }> | null, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly topic: string | null, readonly category: string | null, readonly choices: ReadonlyArray<{ readonly __typename: 'AggregateVotingChoice', readonly rawTotal: number, readonly weightedTotal: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly trendSignificance: number | null, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly scalePercent: number, readonly value: TrendValue | null, readonly date: { readonly __typename: 'GqlDate', readonly raw: number }, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null }> } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue, readonly rank: number, readonly totalDataPoints: number, readonly benchmarkSignificance: number | null, readonly dateRange: { readonly __typename: 'BenchmarkDateRange', readonly start: { readonly __typename: 'GqlDate', readonly raw: number }, readonly end: { readonly __typename: 'GqlDate', readonly raw: number } } } | null } | null } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly questionNumber: number | null, readonly structureType: QuestionHierarchyParentNodeType, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly variableName: string | null, readonly isBenchmarkedQuestion: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null }, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly topic: string | null, readonly category: string | null, readonly choices: ReadonlyArray<{ readonly __typename: 'AggregateVotingChoice', readonly rawTotal: number, readonly weightedTotal: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly trendSignificance: number | null, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly scalePercent: number, readonly value: TrendValue | null, readonly date: { readonly __typename: 'GqlDate', readonly raw: number }, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null }> } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue, readonly rank: number, readonly totalDataPoints: number, readonly benchmarkSignificance: number | null, readonly dateRange: { readonly __typename: 'BenchmarkDateRange', readonly start: { readonly __typename: 'GqlDate', readonly raw: number }, readonly end: { readonly __typename: 'GqlDate', readonly raw: number } } } | null } | null }> } | { readonly __typename: 'QuestionHierarchySimulationNode', readonly id: string, readonly simulationType: SimulationNodeType, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly simulation: { readonly __typename: 'SimulationNodeData', readonly id: number, readonly url: string, readonly adminData: { readonly __typename: 'SimulationNodeAdminData', readonly name: string, readonly description: string | null, readonly prioritization: boolean, readonly simulationType: BalancingActSimulationType, readonly status: QuestionSetStatus } | null } | null } | { readonly __typename: 'QuestionHierarchyVisualizationNode', readonly id: string, readonly altLabel: string | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly trackVariableVisualization: { readonly __typename: 'TrackVariableVisualization', readonly id: string, readonly fips: string | null, readonly publishingEntityId: string, readonly benchmarkFilter: BenchmarkFilter, readonly visualizationType: VisualizationType | null, readonly state: SavedVisualizationActivationState, readonly comparisonGroupId: string | null, readonly visualizationAreas: ReadonlyArray<{ readonly __typename: 'FipsArea', readonly id: string, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null }>, readonly plans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }>, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly trackVariables: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } | { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }> } | null }> } | { readonly __typename: 'PolcoLive', readonly id: string, readonly hasAutomaticWeighting: boolean, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly hasAutomaticWeighting: boolean, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'Survey', readonly id: string, readonly hasAutomaticWeighting: boolean, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly benchmarkType: { readonly __typename: 'BenchmarkType', readonly weighted: boolean } | null, readonly topics: ReadonlyArray<{ readonly __typename: 'SurveyBenchmarkTopic', readonly id: string, readonly topic: { readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string, readonly icon: string | null, readonly description: string | null, readonly trackDomain: AnalyticsDomain | null, readonly category: { readonly __typename: 'TopicCategory', readonly id: string, readonly name: string, readonly priority: number | null } | null } }>, readonly contents: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly variableName: string | null, readonly isBenchmarkedQuestion: boolean, readonly questionNumber: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null }, readonly hierarchyParentNode: { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null } | null, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number }, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly value: number, readonly text: string }> | null, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly topic: string | null, readonly category: string | null, readonly choices: ReadonlyArray<{ readonly __typename: 'AggregateVotingChoice', readonly rawTotal: number, readonly weightedTotal: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly trendSignificance: number | null, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly scalePercent: number, readonly value: TrendValue | null, readonly date: { readonly __typename: 'GqlDate', readonly raw: number }, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null }> } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue, readonly rank: number, readonly totalDataPoints: number, readonly benchmarkSignificance: number | null, readonly dateRange: { readonly __typename: 'BenchmarkDateRange', readonly start: { readonly __typename: 'GqlDate', readonly raw: number }, readonly end: { readonly __typename: 'GqlDate', readonly raw: number } } } | null } | null } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly questionNumber: number | null, readonly structureType: QuestionHierarchyParentNodeType, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly variableName: string | null, readonly isBenchmarkedQuestion: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null }, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly topic: string | null, readonly category: string | null, readonly choices: ReadonlyArray<{ readonly __typename: 'AggregateVotingChoice', readonly rawTotal: number, readonly weightedTotal: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly trendSignificance: number | null, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly scalePercent: number, readonly value: TrendValue | null, readonly date: { readonly __typename: 'GqlDate', readonly raw: number }, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null }> } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue, readonly rank: number, readonly totalDataPoints: number, readonly benchmarkSignificance: number | null, readonly dateRange: { readonly __typename: 'BenchmarkDateRange', readonly start: { readonly __typename: 'GqlDate', readonly raw: number }, readonly end: { readonly __typename: 'GqlDate', readonly raw: number } } } | null } | null }> } | { readonly __typename: 'QuestionHierarchySimulationNode', readonly id: string, readonly simulationType: SimulationNodeType, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly simulation: { readonly __typename: 'SimulationNodeData', readonly id: number, readonly url: string, readonly adminData: { readonly __typename: 'SimulationNodeAdminData', readonly name: string, readonly description: string | null, readonly prioritization: boolean, readonly simulationType: BalancingActSimulationType, readonly status: QuestionSetStatus } | null } | null } | { readonly __typename: 'QuestionHierarchyVisualizationNode', readonly id: string, readonly altLabel: string | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly trackVariableVisualization: { readonly __typename: 'TrackVariableVisualization', readonly id: string, readonly fips: string | null, readonly publishingEntityId: string, readonly benchmarkFilter: BenchmarkFilter, readonly visualizationType: VisualizationType | null, readonly state: SavedVisualizationActivationState, readonly comparisonGroupId: string | null, readonly visualizationAreas: ReadonlyArray<{ readonly __typename: 'FipsArea', readonly id: string, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null }>, readonly plans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }>, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly trackVariables: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } | { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }> } | null }> } | null };

export type AdminOpenQuestionSetBaseVariables = Exact<{
  setId: Scalars['ID'];
}>;


export type AdminOpenQuestionSetBase = { readonly openContentSetById: { readonly __typename: 'GenericContent', readonly id: string, readonly hasAutomaticWeighting: boolean, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly hasAutomaticWeighting: boolean, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly hasAutomaticWeighting: boolean, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } } | { readonly __typename: 'Survey', readonly id: string, readonly hasAutomaticWeighting: boolean, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly benchmarkType: { readonly __typename: 'BenchmarkType', readonly type: BenchmarkSurveyTypes | null } | null } | null };

export type AdminOpenQuestionSetBenchmarkOverviewStructureVariables = Exact<{
  setId: Scalars['ID'];
}>;


export type AdminOpenQuestionSetBenchmarkOverviewStructure = { readonly openContentSetById: { readonly __typename: 'GenericContent' } | { readonly __typename: 'PolcoLive' } | { readonly __typename: 'QuestionSet' } | { readonly __typename: 'Survey', readonly id: string, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly benchmarkType: { readonly __typename: 'BenchmarkType', readonly type: BenchmarkSurveyTypes | null } | null, readonly dimensionGroupDefinitions: ReadonlyArray<{ readonly __typename: 'DimensionGroupDefinition', readonly id: string, readonly description: string }> } | null };

export type AdminOpenQuestionSetCrosstabOptionsVariables = Exact<{
  setId: Scalars['ID'];
  filter: TopicFilter;
}>;


export type AdminOpenQuestionSetCrosstabOptions = { readonly openContentSetById: { readonly __typename: 'GenericContent' } | { readonly __typename: 'PolcoLive' } | { readonly __typename: 'QuestionSet' } | { readonly __typename: 'Survey', readonly id: string, readonly topics: ReadonlyArray<{ readonly __typename: 'SurveyBenchmarkTopic', readonly id: string, readonly topic: { readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string, readonly icon: string | null, readonly description: string | null, readonly trackDomain: AnalyticsDomain | null, readonly category: { readonly __typename: 'TopicCategory', readonly id: string, readonly name: string, readonly priority: number | null } | null } }>, readonly dimensionGroupDefinitions: ReadonlyArray<{ readonly __typename: 'DimensionGroupDefinition', readonly id: string, readonly description: string }> } | null };

export type AdminOpenQuestionSetGridAggregateResultsVariables = Exact<{
  setId: Scalars['ID'];
  filterByTopicIds?: InputMaybe<ReadonlyArray<Scalars['ID']> | Scalars['ID']>;
  omitBenchmarks?: InputMaybe<Scalars['Boolean']>;
  omitTrends?: InputMaybe<Scalars['Boolean']>;
  reportingBetaMode?: InputMaybe<Scalars['Boolean']>;
}>;


export type AdminOpenQuestionSetGridAggregateResults = { readonly openContentSetById: { readonly __typename: 'GenericContent', readonly id: string, readonly hasAutomaticWeighting: boolean, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly hasAutomaticWeighting: boolean, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly hasAutomaticWeighting: boolean, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'Survey', readonly id: string, readonly hasAutomaticWeighting: boolean, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly benchmarkType: { readonly __typename: 'BenchmarkType', readonly weighted: boolean } | null, readonly contents: ReadonlyArray<{ readonly __typename: 'Question' } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly questionNumber: number | null, readonly structureType: QuestionHierarchyParentNodeType, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly variableName: string | null, readonly isBenchmarkedQuestion: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null }, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly topic: string | null, readonly category: string | null, readonly choices: ReadonlyArray<{ readonly __typename: 'AggregateVotingChoice', readonly rawTotal: number, readonly weightedTotal: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly trendSignificance: number | null, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly scalePercent: number, readonly value: TrendValue | null, readonly date: { readonly __typename: 'GqlDate', readonly raw: number }, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null }> } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue, readonly rank: number, readonly totalDataPoints: number, readonly benchmarkSignificance: number | null, readonly dateRange: { readonly __typename: 'BenchmarkDateRange', readonly start: { readonly __typename: 'GqlDate', readonly raw: number }, readonly end: { readonly __typename: 'GqlDate', readonly raw: number } } } | null } | null }> } | { readonly __typename: 'QuestionHierarchySimulationNode' } | { readonly __typename: 'QuestionHierarchyVisualizationNode' }> } | null };

export type AdminOpenQuestionSetStructureVariables = Exact<{
  setId: Scalars['ID'];
  areaMode?: InputMaybe<TrackAreaMode>;
  comparisonGroupId?: InputMaybe<Scalars['ID']>;
  fipsCodes?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type AdminOpenQuestionSetStructure = { readonly openContentSetById: { readonly __typename: 'GenericContent', readonly id: string, readonly slug: string | null, readonly featureSetType: QuestionSetFeatureSetType | null, readonly questionsCount: number, readonly hasBenchmarkedContent: boolean, readonly polcoManaged: boolean, readonly isPinnedToPublisher: boolean, readonly isRepostable: boolean, readonly hasAutomaticWeighting: boolean, readonly allowMultipleResponses: boolean, readonly allowGuestRespondents: boolean, readonly showConversionPrompts: boolean, readonly setImageId: string | null, readonly shortId: string | null, readonly hasPdfUrl: boolean, readonly totalRespondents: number | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly id: string, readonly horizontalUrl: string } | null, readonly reposters: ReadonlyArray<{ readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly accessSetting: { readonly __typename: 'AccessSetting_Email', readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | { readonly __typename: 'AccessSetting_Everyone' } | { readonly __typename: 'AccessSetting_Link' } | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly outcome: { readonly __typename: 'Outcome', readonly id: string, readonly text: string, readonly state: ContentOutcomeState } | null, readonly alternateLanguages: ReadonlyArray<{ readonly __typename: 'Language', readonly id: string, readonly key: string, readonly name: string }>, readonly benchmarkType: { readonly __typename: 'BenchmarkType', readonly type: BenchmarkSurveyTypes | null } | null, readonly allConditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly displayName: string, readonly combinationOperator: MetaConditionCombinationOperator, readonly childMetaConditionIds: ReadonlyArray<string> }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly contents: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly questionNumber: number | null, readonly summary: string | null, readonly optional: boolean, readonly variableName: string | null, readonly reportDisplayLabel: string | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus }, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string }, readonly demographicAttribute: { readonly __typename: 'DemographicAttribute', readonly id: string, readonly name: string, readonly premium: boolean, readonly owner: { readonly __typename: 'PublishingEntity', readonly id: string } | null } | null } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly questionNumber: number | null, readonly numColumns: number, readonly structureType: QuestionHierarchyParentNodeType, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly structureDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly survey: { readonly __typename: 'Survey', readonly id: string }, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly variableName: string | null, readonly reportDisplayLabel: string | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus }, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> } }>, readonly rowContents: ReadonlyArray<{ readonly __typename: 'RowContentHierarchyNodeBaReceipt', readonly id: string, readonly receipt: { readonly __typename: 'BalancingActSimulationWithPubId', readonly id: number, readonly name: string, readonly simulationType: string, readonly publishedAt: { readonly __typename: 'GqlDate', readonly raw: number } } } | { readonly __typename: 'RowContentHierarchyNodeBaSim', readonly id: string, readonly simulation: { readonly __typename: 'BalancingActSimulationWithPubId', readonly id: number, readonly name: string, readonly simulationType: string, readonly prioritization: boolean, readonly publishedAt: { readonly __typename: 'GqlDate', readonly raw: number } } } | { readonly __typename: 'RowContentHierarchyNodePolco', readonly id: string, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'Survey', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } }> } | { readonly __typename: 'QuestionHierarchySimulationNode', readonly id: string, readonly simulationType: SimulationNodeType, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly simulation: { readonly __typename: 'SimulationNodeData', readonly id: number, readonly url: string, readonly adminData: { readonly __typename: 'SimulationNodeAdminData', readonly name: string, readonly description: string | null, readonly prioritization: boolean, readonly simulationType: BalancingActSimulationType, readonly status: QuestionSetStatus } | null } | null } | { readonly __typename: 'QuestionHierarchyVisualizationNode', readonly id: string, readonly altLabel: string | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly trackVariableVisualization: { readonly __typename: 'TrackVariableVisualization', readonly id: string, readonly fips: string | null, readonly publishingEntityId: string, readonly benchmarkFilter: BenchmarkFilter, readonly visualizationType: VisualizationType | null, readonly state: SavedVisualizationActivationState, readonly comparisonGroupId: string | null, readonly visualizationAreas: ReadonlyArray<{ readonly __typename: 'FipsArea', readonly id: string, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null }>, readonly plans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }>, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly trackVariables: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } | { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }> } | null }>, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly order: number, readonly visibleToAdmins: boolean, readonly publiclyShared: boolean, readonly trackDomain: AnalyticsDomain | null, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null } | { readonly __typename: 'PolcoLive', readonly id: string, readonly slug: string | null, readonly featureSetType: QuestionSetFeatureSetType | null, readonly questionsCount: number, readonly hasBenchmarkedContent: boolean, readonly polcoManaged: boolean, readonly isPinnedToPublisher: boolean, readonly isRepostable: boolean, readonly hasAutomaticWeighting: boolean, readonly allowMultipleResponses: boolean, readonly allowGuestRespondents: boolean, readonly showConversionPrompts: boolean, readonly setImageId: string | null, readonly shortId: string | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly id: string, readonly horizontalUrl: string } | null, readonly reposters: ReadonlyArray<{ readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly accessSetting: { readonly __typename: 'AccessSetting_Email', readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | { readonly __typename: 'AccessSetting_Everyone' } | { readonly __typename: 'AccessSetting_Link' } | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly outcome: { readonly __typename: 'Outcome', readonly id: string, readonly text: string, readonly state: ContentOutcomeState } | null, readonly alternateLanguages: ReadonlyArray<{ readonly __typename: 'Language', readonly id: string, readonly key: string, readonly name: string }>, readonly settings: { readonly __typename: 'PolcoLiveSettings', readonly id: string, readonly liveVideoLink: string | null, readonly state: QuestionStatus, readonly eventStartDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly eventEndDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly createdQuestions: { readonly __typename: 'CreatedQuestionsData', readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly variableName: string | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string } }>, readonly pagination: { readonly __typename: 'PaginationData', readonly totalCount: number } } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly slug: string | null, readonly featureSetType: QuestionSetFeatureSetType | null, readonly questionsCount: number, readonly hasBenchmarkedContent: boolean, readonly polcoManaged: boolean, readonly isPinnedToPublisher: boolean, readonly isRepostable: boolean, readonly hasAutomaticWeighting: boolean, readonly allowMultipleResponses: boolean, readonly allowGuestRespondents: boolean, readonly showConversionPrompts: boolean, readonly setImageId: string | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly id: string, readonly horizontalUrl: string } | null, readonly reposters: ReadonlyArray<{ readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly accessSetting: { readonly __typename: 'AccessSetting_Email', readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | { readonly __typename: 'AccessSetting_Everyone' } | { readonly __typename: 'AccessSetting_Link' } | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly outcome: { readonly __typename: 'Outcome', readonly id: string, readonly text: string, readonly state: ContentOutcomeState } | null, readonly alternateLanguages: ReadonlyArray<{ readonly __typename: 'Language', readonly id: string, readonly key: string, readonly name: string }>, readonly createdQuestions: { readonly __typename: 'CreatedQuestionsData', readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly questionNumber: number | null, readonly optional: boolean, readonly variableName: string | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly includeComment: boolean, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string } }>, readonly pagination: { readonly __typename: 'PaginationData', readonly totalCount: number } } } | { readonly __typename: 'Survey', readonly id: string, readonly slug: string | null, readonly featureSetType: QuestionSetFeatureSetType | null, readonly questionsCount: number, readonly hasBenchmarkedContent: boolean, readonly polcoManaged: boolean, readonly isPinnedToPublisher: boolean, readonly isRepostable: boolean, readonly hasAutomaticWeighting: boolean, readonly allowMultipleResponses: boolean, readonly allowGuestRespondents: boolean, readonly showConversionPrompts: boolean, readonly setImageId: string | null, readonly shortId: string | null, readonly hasVisibleReportTabs: boolean, readonly hasPdfUrl: boolean, readonly totalRespondents: number | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly id: string, readonly horizontalUrl: string } | null, readonly reposters: ReadonlyArray<{ readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly accessSetting: { readonly __typename: 'AccessSetting_Email', readonly emailLists: ReadonlyArray<{ readonly __typename: 'EmailList', readonly id: string, readonly name: string }> } | { readonly __typename: 'AccessSetting_Everyone' } | { readonly __typename: 'AccessSetting_Link' } | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly outcome: { readonly __typename: 'Outcome', readonly id: string, readonly text: string, readonly state: ContentOutcomeState } | null, readonly alternateLanguages: ReadonlyArray<{ readonly __typename: 'Language', readonly id: string, readonly key: string, readonly name: string }>, readonly benchmarkType: { readonly __typename: 'BenchmarkType', readonly type: BenchmarkSurveyTypes | null } | null, readonly allConditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly displayName: string, readonly combinationOperator: MetaConditionCombinationOperator, readonly childMetaConditionIds: ReadonlyArray<string> }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly contents: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly questionNumber: number | null, readonly summary: string | null, readonly optional: boolean, readonly variableName: string | null, readonly reportDisplayLabel: string | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly includeComment: boolean, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus }, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string }, readonly demographicAttribute: { readonly __typename: 'DemographicAttribute', readonly id: string, readonly name: string, readonly premium: boolean, readonly owner: { readonly __typename: 'PublishingEntity', readonly id: string } | null } | null } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly questionNumber: number | null, readonly numColumns: number, readonly structureType: QuestionHierarchyParentNodeType, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly structureDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly survey: { readonly __typename: 'Survey', readonly id: string }, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly variableName: string | null, readonly reportDisplayLabel: string | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus }, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> } }>, readonly rowContents: ReadonlyArray<{ readonly __typename: 'RowContentHierarchyNodeBaReceipt', readonly id: string, readonly receipt: { readonly __typename: 'BalancingActSimulationWithPubId', readonly id: number, readonly name: string, readonly simulationType: string, readonly publishedAt: { readonly __typename: 'GqlDate', readonly raw: number } } } | { readonly __typename: 'RowContentHierarchyNodeBaSim', readonly id: string, readonly simulation: { readonly __typename: 'BalancingActSimulationWithPubId', readonly id: number, readonly name: string, readonly simulationType: string, readonly prioritization: boolean, readonly publishedAt: { readonly __typename: 'GqlDate', readonly raw: number } } } | { readonly __typename: 'RowContentHierarchyNodePolco', readonly id: string, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'Survey', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } }> } | { readonly __typename: 'QuestionHierarchySimulationNode', readonly id: string, readonly simulationType: SimulationNodeType, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly simulation: { readonly __typename: 'SimulationNodeData', readonly id: number, readonly url: string, readonly adminData: { readonly __typename: 'SimulationNodeAdminData', readonly name: string, readonly description: string | null, readonly prioritization: boolean, readonly simulationType: BalancingActSimulationType, readonly status: QuestionSetStatus } | null } | null } | { readonly __typename: 'QuestionHierarchyVisualizationNode', readonly id: string, readonly altLabel: string | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly trackVariableVisualization: { readonly __typename: 'TrackVariableVisualization', readonly id: string, readonly fips: string | null, readonly publishingEntityId: string, readonly benchmarkFilter: BenchmarkFilter, readonly visualizationType: VisualizationType | null, readonly state: SavedVisualizationActivationState, readonly comparisonGroupId: string | null, readonly visualizationAreas: ReadonlyArray<{ readonly __typename: 'FipsArea', readonly id: string, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null }>, readonly plans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }>, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly trackVariables: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } | { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }> } | null }>, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly order: number, readonly visibleToAdmins: boolean, readonly publiclyShared: boolean, readonly trackDomain: AnalyticsDomain | null, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null } | null };

export type AdminOpenQuestionSetTopicDetailsQualityAggregateResultVariables = Exact<{
  setId: Scalars['ID'];
  filter: TopicFilter;
}>;


export type AdminOpenQuestionSetTopicDetailsQualityAggregateResult = { readonly openContentSetById: { readonly __typename: 'GenericContent' } | { readonly __typename: 'PolcoLive' } | { readonly __typename: 'QuestionSet' } | { readonly __typename: 'Survey', readonly id: string, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly topics: ReadonlyArray<{ readonly __typename: 'SurveyBenchmarkTopic', readonly id: string, readonly quality: { readonly __typename: 'TopicAggregateResult', readonly aggregateValue: number | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly trendSignificance: number | null, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly scalePercent: number, readonly value: TrendValue | null, readonly date: { readonly __typename: 'GqlDate', readonly raw: number }, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null }> } | null } | null, readonly relatedQuestions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly isBenchmarkedQuestion: boolean, readonly questionNumber: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly topics: ReadonlyArray<{ readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string }>, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null }, readonly hierarchyParentNode: { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null } | null, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly topic: string | null, readonly category: string | null, readonly choices: ReadonlyArray<{ readonly __typename: 'AggregateVotingChoice', readonly rawTotal: number, readonly weightedTotal: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly trendSignificance: number | null, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly scalePercent: number, readonly value: TrendValue | null, readonly date: { readonly __typename: 'GqlDate', readonly raw: number }, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null }> } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue, readonly rank: number, readonly totalDataPoints: number, readonly benchmarkSignificance: number | null, readonly dateRange: { readonly __typename: 'BenchmarkDateRange', readonly start: { readonly __typename: 'GqlDate', readonly raw: number }, readonly end: { readonly __typename: 'GqlDate', readonly raw: number } } } | null } | null, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number }, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly value: number, readonly text: string }> | null, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'Survey', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } }>, readonly topic: { readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string, readonly icon: string | null, readonly description: string | null, readonly trackDomain: AnalyticsDomain | null, readonly category: { readonly __typename: 'TopicCategory', readonly id: string, readonly name: string, readonly priority: number | null } | null } }> } | null };

export type AdminOpenQuestionSetTopicDetailsQualityImportanceVariables = Exact<{
  setId: Scalars['ID'];
  filter: TopicFilter;
}>;


export type AdminOpenQuestionSetTopicDetailsQualityImportance = { readonly openContentSetById: { readonly __typename: 'GenericContent' } | { readonly __typename: 'PolcoLive' } | { readonly __typename: 'QuestionSet' } | { readonly __typename: 'Survey', readonly id: string, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly topics: ReadonlyArray<{ readonly __typename: 'SurveyBenchmarkTopic', readonly id: string, readonly importance: { readonly __typename: 'Question', readonly id: string, readonly isBenchmarkedQuestion: boolean, readonly questionNumber: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null }, readonly hierarchyParentNode: { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null } | null, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly topic: string | null, readonly category: string | null, readonly choices: ReadonlyArray<{ readonly __typename: 'AggregateVotingChoice', readonly rawTotal: number, readonly weightedTotal: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly trendSignificance: number | null, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly scalePercent: number, readonly value: TrendValue | null, readonly date: { readonly __typename: 'GqlDate', readonly raw: number }, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null }> } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue, readonly rank: number, readonly totalDataPoints: number, readonly benchmarkSignificance: number | null, readonly dateRange: { readonly __typename: 'BenchmarkDateRange', readonly start: { readonly __typename: 'GqlDate', readonly raw: number }, readonly end: { readonly __typename: 'GqlDate', readonly raw: number } } } | null } | null, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number }, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly value: number, readonly text: string }> | null, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'Survey', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } } | null, readonly quality: { readonly __typename: 'Question', readonly id: string, readonly isBenchmarkedQuestion: boolean, readonly questionNumber: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null }, readonly hierarchyParentNode: { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null } | null, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly topic: string | null, readonly category: string | null, readonly choices: ReadonlyArray<{ readonly __typename: 'AggregateVotingChoice', readonly rawTotal: number, readonly weightedTotal: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly trendSignificance: number | null, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly scalePercent: number, readonly value: TrendValue | null, readonly date: { readonly __typename: 'GqlDate', readonly raw: number }, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null }> } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue, readonly rank: number, readonly totalDataPoints: number, readonly benchmarkSignificance: number | null, readonly dateRange: { readonly __typename: 'BenchmarkDateRange', readonly start: { readonly __typename: 'GqlDate', readonly raw: number }, readonly end: { readonly __typename: 'GqlDate', readonly raw: number } } } | null } | null, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number }, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly value: number, readonly text: string }> | null, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'Survey', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } } | null, readonly relatedQuestions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly isBenchmarkedQuestion: boolean, readonly questionNumber: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly topics: ReadonlyArray<{ readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string }>, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null }, readonly hierarchyParentNode: { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null } | null, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly topic: string | null, readonly category: string | null, readonly choices: ReadonlyArray<{ readonly __typename: 'AggregateVotingChoice', readonly rawTotal: number, readonly weightedTotal: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number, readonly alternateScaleName: string | null } | null, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly trendSignificance: number | null, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly scalePercent: number, readonly value: TrendValue | null, readonly date: { readonly __typename: 'GqlDate', readonly raw: number }, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null }> } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue, readonly rank: number, readonly totalDataPoints: number, readonly benchmarkSignificance: number | null, readonly dateRange: { readonly __typename: 'BenchmarkDateRange', readonly start: { readonly __typename: 'GqlDate', readonly raw: number }, readonly end: { readonly __typename: 'GqlDate', readonly raw: number } } } | null } | null, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number }, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly value: number, readonly text: string }> | null, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'Survey', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } }>, readonly topic: { readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string, readonly icon: string | null, readonly description: string | null, readonly trackDomain: AnalyticsDomain | null, readonly category: { readonly __typename: 'TopicCategory', readonly id: string, readonly name: string, readonly priority: number | null } | null } }> } | null };

export type AdminOpenQuestionSetTopicsQualityAggregateResultVariables = Exact<{
  setId: Scalars['ID'];
  filter: TopicFilter;
}>;


export type AdminOpenQuestionSetTopicsQualityAggregateResult = { readonly openContentSetById: { readonly __typename: 'GenericContent' } | { readonly __typename: 'PolcoLive' } | { readonly __typename: 'QuestionSet' } | { readonly __typename: 'Survey', readonly id: string, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly topics: ReadonlyArray<{ readonly __typename: 'SurveyBenchmarkTopic', readonly id: string, readonly quality: { readonly __typename: 'TopicAggregateResult', readonly aggregateValue: number | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue, readonly trendSignificance: number | null, readonly historicalDataPoints: ReadonlyArray<{ readonly __typename: 'TrendHistoricalDataPoint', readonly scalePercent: number, readonly value: TrendValue | null, readonly date: { readonly __typename: 'GqlDate', readonly raw: number }, readonly averageChoiceValueData: { readonly __typename: 'AverageChoiceValueData', readonly averageChoiceValue: number, readonly scaleName: string } | null }> } | null } | null, readonly topic: { readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string, readonly icon: string | null, readonly description: string | null, readonly trackDomain: AnalyticsDomain | null, readonly category: { readonly __typename: 'TopicCategory', readonly id: string, readonly name: string, readonly priority: number | null } | null } }> } | null };

export type AdminOpenQuestionSetTopicsQualityImportanceVariables = Exact<{
  setId: Scalars['ID'];
  filter: TopicFilter;
}>;


export type AdminOpenQuestionSetTopicsQualityImportance = { readonly openContentSetById: { readonly __typename: 'GenericContent' } | { readonly __typename: 'PolcoLive' } | { readonly __typename: 'QuestionSet' } | { readonly __typename: 'Survey', readonly id: string, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly topics: ReadonlyArray<{ readonly __typename: 'SurveyBenchmarkTopic', readonly id: string, readonly importance: { readonly __typename: 'Question', readonly id: string, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue } | null } | null } | null, readonly quality: { readonly __typename: 'Question', readonly id: string, readonly aggregateResults: { readonly __typename: 'AggregateResults', readonly aggregateValue: number | null, readonly trend: { readonly __typename: 'TrendAggregateResult', readonly value: TrendValue } | null, readonly benchmark: { readonly __typename: 'BenchmarkAggregateResult', readonly value: BenchmarkValue } | null } | null } | null, readonly topic: { readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string, readonly icon: string | null, readonly description: string | null, readonly trackDomain: AnalyticsDomain | null, readonly category: { readonly __typename: 'TopicCategory', readonly id: string, readonly name: string, readonly priority: number | null } | null } }>, readonly criticalFocusTopics: ReadonlyArray<{ readonly __typename: 'SurveyBenchmarkTopic', readonly id: string, readonly topic: { readonly __typename: 'BenchmarkTopic', readonly id: string, readonly name: string, readonly icon: string | null, readonly description: string | null, readonly trackDomain: AnalyticsDomain | null, readonly category: { readonly __typename: 'TopicCategory', readonly id: string, readonly name: string, readonly priority: number | null } | null } }> } | null };

export type AdminOpenQuestionStructureVariables = Exact<{
  questionId: Scalars['ID'];
}>;


export type AdminOpenQuestionStructure = { readonly openQuestion: { readonly __typename: 'Question', readonly id: string, readonly summary: string | null, readonly shortId: string | null, readonly optional: boolean, readonly isBenchmarkedQuestion: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly polcoManaged: boolean } | { readonly __typename: 'PolcoLive', readonly id: string, readonly polcoManaged: boolean } | { readonly __typename: 'QuestionSet', readonly id: string, readonly polcoManaged: boolean } | { readonly __typename: 'Survey', readonly id: string, readonly polcoManaged: boolean }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } } | null };

export type OpenQuestionWithCommentsVariables = Exact<{
  commentFilter?: InputMaybe<CommentFilter>;
  pagination?: InputMaybe<PaginationParams>;
  questionId: Scalars['ID'];
  resultFilter?: InputMaybe<ResultFilter>;
}>;


export type OpenQuestionWithComments = { readonly openQuestion: { readonly __typename: 'Question', readonly id: string, readonly summary: string | null, readonly variableName: string | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }> }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number, readonly comments: ReadonlyArray<{ readonly __typename: 'Comment', readonly id: string, readonly comment: string, readonly upvoteCount: number, readonly commenterChoice: { readonly __typename: 'QuestionChoice', readonly id: string } | null, readonly commenter: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly postAnonymously: boolean, readonly avatarUrl: string | null } | { readonly __typename: 'PublicRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly postAnonymously: boolean, readonly avatarUrl: string | null }, readonly commentDate: { readonly __typename: 'GqlDate', readonly raw: number } }> } } | null };

export type AdminOpenVisualizationVariables = Exact<{
  visualizationId: Scalars['ID'];
  areaMode?: InputMaybe<TrackAreaMode>;
  comparisonGroupId?: InputMaybe<Scalars['ID']>;
  fipsCodes?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type AdminOpenVisualization = { readonly openSavedTrackVariableVisualizationById: { readonly __typename: 'TrackVariableVisualization', readonly id: string, readonly fips: string | null, readonly publishingEntityId: string, readonly benchmarkFilter: BenchmarkFilter, readonly visualizationType: VisualizationType | null, readonly state: SavedVisualizationActivationState, readonly comparisonGroupId: string | null, readonly visualizationAreas: ReadonlyArray<{ readonly __typename: 'FipsArea', readonly id: string, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null }>, readonly boundingBox: { readonly __typename: 'GeoBoundingBox', readonly id: string, readonly xMin: number, readonly xMax: number, readonly yMin: number, readonly yMax: number } | null, readonly plans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }>, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly trackVariables: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } | { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }> } | null };

export type AdminOverviewParticipantsVariables = Exact<{
  setId: Scalars['ID'];
}>;


export type AdminOverviewParticipants = { readonly openContentSetById: { readonly __typename: 'GenericContent' } | { readonly __typename: 'PolcoLive' } | { readonly __typename: 'QuestionSet' } | { readonly __typename: 'Survey', readonly id: string, readonly totalRespondents: number | null, readonly totalWeightedRespondents: number | null, readonly benchmarkType: { readonly __typename: 'BenchmarkType', readonly type: BenchmarkSurveyTypes | null } | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } } | null };

export type AdminPublishContentLimitVariables = Exact<{
  setId: Scalars['ID'];
  skipBenchmarkCheck: Scalars['Boolean'];
}>;


export type AdminPublishContentLimit = { readonly currentUser: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly superAdmin: boolean, readonly requestedFeatures: ReadonlyArray<string>, readonly activePublishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly isEnterprise: boolean, readonly engageContentLimit: ReadonlyArray<{ readonly __typename: 'PublishingEntityFeatureSetting', readonly id: string, readonly isUnlimited: boolean, readonly featureSettingId: string, readonly featureSettingName: string, readonly enabled: boolean, readonly quantity: number, readonly activeCount: number | null, readonly expirationDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }> | null } | null } | { readonly __typename: 'PublicAdmin' } | null } | null }, readonly openContentSetById?: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string, readonly benchmarkType: { readonly __typename: 'BenchmarkType', readonly type: BenchmarkSurveyTypes | null } | null } | null };

export type AdminPublishersFeatureSettingsVariables = Exact<{
  filter?: InputMaybe<Scalars['String']>;
}>;


export type AdminPublishersFeatureSettings = { readonly adminPublishers: ReadonlyArray<{ readonly __typename: 'PublishingEntity', readonly id: string, readonly occupiedSeats: number, readonly activeEngageContentCount: number, readonly totalSeats: number, readonly aiAssistantQueryLimit: number, readonly grantWriterAssistantQueryLimit: number, readonly engageContentLimit: number, readonly visualizationsLimit: number, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }> };

export type AdminPublishersWithSeatsVariables = Exact<{
  filter?: InputMaybe<Scalars['String']>;
}>;


export type AdminPublishersWithSeats = { readonly adminPublishers: ReadonlyArray<{ readonly __typename: 'PublishingEntity', readonly id: string, readonly occupiedSeats: number, readonly totalSeats: number, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }> };

export type AdminPublishingEntityAiAssistantInteractionsVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  assistant: AssistantIdInput;
}>;


export type AdminPublishingEntityAiAssistantInteractions = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly aiAssistantInteractions: { readonly __typename: 'AiAssistantPublisher', readonly publishingEntityId: string, readonly sessionCount: number, readonly queryCount: number } | null } | null };

export type AdminPublishingEntityBenchmarkSurveysVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  type?: InputMaybe<BenchmarkSurveyTypes>;
}>;


export type AdminPublishingEntityBenchmarkSurveys = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly createdBenchmarkSurveys: ReadonlyArray<{ readonly __typename: 'Survey', readonly id: string, readonly hasVisibleReportTabs: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly benchmarkType: { readonly __typename: 'BenchmarkType', readonly type: BenchmarkSurveyTypes | null } | null }> } | null };

export type AdminPublishingEntityComparisonGroupsVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type AdminPublishingEntityComparisonGroups = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly shortName: string | null, readonly type: FipsAreaType | null } | null, readonly comparisonGroups: ReadonlyArray<{ readonly __typename: 'ComparisonGroup', readonly id: string, readonly name: string, readonly fips: ReadonlyArray<{ readonly __typename: 'FipsArea', readonly id: string }> }> } | null };

export type AdminPublishingEntityContentListVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type AdminPublishingEntityContentList = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly simulations: ReadonlyArray<{ readonly __typename: 'AdminBalancingActSimulation', readonly id: number, readonly name: string, readonly isPrioritization: boolean, readonly type: BalancingActSimulationType, readonly url: string, readonly description: string | null, readonly status: QuestionSetStatus, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly createdQuestionSets: { readonly __typename: 'QuestionSetsData', readonly questionSets: ReadonlyArray<{ readonly __typename: 'GenericContent', readonly id: string, readonly slug: string | null, readonly featureSetType: QuestionSetFeatureSetType | null, readonly isPinnedToPublisher: boolean, readonly questionsCount: number, readonly totalRespondents: number | null, readonly polcoManaged: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string }, readonly shareableContentSet: { readonly __typename: 'ShareableContentSet', readonly id: string, readonly isPaidContent: boolean, readonly shareType: ShareableContentType, readonly adminDescription: string | null, readonly contentSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string } } | null } | { readonly __typename: 'PolcoLive', readonly id: string, readonly slug: string | null, readonly featureSetType: QuestionSetFeatureSetType | null, readonly isPinnedToPublisher: boolean, readonly questionsCount: number, readonly totalRespondents: number | null, readonly polcoManaged: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string }, readonly shareableContentSet: { readonly __typename: 'ShareableContentSet', readonly id: string, readonly isPaidContent: boolean, readonly shareType: ShareableContentType, readonly adminDescription: string | null, readonly contentSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string } } | null, readonly settings: { readonly __typename: 'PolcoLiveSettings', readonly id: string, readonly eventStartDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly eventEndDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly slug: string | null, readonly featureSetType: QuestionSetFeatureSetType | null, readonly isPinnedToPublisher: boolean, readonly questionsCount: number, readonly totalRespondents: number | null, readonly polcoManaged: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string }, readonly shareableContentSet: { readonly __typename: 'ShareableContentSet', readonly id: string, readonly isPaidContent: boolean, readonly shareType: ShareableContentType, readonly adminDescription: string | null, readonly contentSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string } } | null } | { readonly __typename: 'Survey', readonly id: string, readonly slug: string | null, readonly featureSetType: QuestionSetFeatureSetType | null, readonly isPinnedToPublisher: boolean, readonly questionsCount: number, readonly totalRespondents: number | null, readonly polcoManaged: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string }, readonly shareableContentSet: { readonly __typename: 'ShareableContentSet', readonly id: string, readonly isPaidContent: boolean, readonly shareType: ShareableContentType, readonly adminDescription: string | null, readonly contentSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string } } | null }> } | null, readonly shareableContentSetsForSidebar: ReadonlyArray<{ readonly __typename: 'ShareableContentSet', readonly id: string, readonly shareType: ShareableContentType, readonly isPaidContent: boolean, readonly adminDescription: string | null, readonly contentSet: { readonly __typename: 'GenericContent', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null } | { readonly __typename: 'PolcoLive', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null } | { readonly __typename: 'QuestionSet', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null } | { readonly __typename: 'Survey', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null } }> | null, readonly ncsFacetSummaries: ReadonlyArray<{ readonly __typename: 'NcsFacetSummary', readonly id: string, readonly surveyid: string, readonly GEO_NAME: string, readonly fips: number, readonly year: number, readonly ncs: number, readonly added: string, readonly area: number, readonly title: string, readonly newmax: number, readonly pctpos: number, readonly avgptm: number, readonly n: number, readonly bmark: string }> | null } | null };

export type AdminPublishingEntityContentSetIdsVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type AdminPublishingEntityContentSetIds = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly createdQuestionSets: { readonly __typename: 'QuestionSetsData', readonly questionSets: ReadonlyArray<{ readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string }> } | null } | null };

export type AdminPublishingEntityContentSetNamesAndShortUrlsVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type AdminPublishingEntityContentSetNamesAndShortUrls = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly createdQuestionSets: { readonly __typename: 'QuestionSetsData', readonly questionSets: ReadonlyArray<{ readonly __typename: 'GenericContent', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortUrls: ReadonlyArray<{ readonly __typename: 'ShortUrl', readonly id: string, readonly fullUrl: string, readonly shortUrl: string }> } | { readonly __typename: 'PolcoLive', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortUrls: ReadonlyArray<{ readonly __typename: 'ShortUrl', readonly id: string, readonly fullUrl: string, readonly shortUrl: string }> } | { readonly __typename: 'QuestionSet', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortUrls: ReadonlyArray<{ readonly __typename: 'ShortUrl', readonly id: string, readonly fullUrl: string, readonly shortUrl: string }> } | { readonly __typename: 'Survey', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortUrls: ReadonlyArray<{ readonly __typename: 'ShortUrl', readonly id: string, readonly fullUrl: string, readonly shortUrl: string }> }> } | null } | null };

export type AdminPublishingEntityFeatureSettingsVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type AdminPublishingEntityFeatureSettings = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly occupiedSeats: number, readonly activeEngageContentCount: number, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly aiAssistantInteractions: { readonly __typename: 'AiAssistantPublisher', readonly queryCount: number } | null, readonly grantWriterAssistantInteractions: { readonly __typename: 'AiAssistantPublisher', readonly queryCount: number } | null, readonly featureSettings: ReadonlyArray<{ readonly __typename: 'PublishingEntityFeatureSetting', readonly id: string, readonly featureSettingId: string, readonly featureSettingName: string, readonly enabled: boolean, readonly quantity: number, readonly isUnlimited: boolean, readonly expirationDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }> | null } | null };

export type AdminPublishingEntityIdeaSubmissionsVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  pagination: PaginationParams;
}>;


export type AdminPublishingEntityIdeaSubmissions = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly ideaSubmissions: ReadonlyArray<{ readonly __typename: 'Idea', readonly id: string, readonly title: string, readonly respondent: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly publicName: string } | { readonly __typename: 'PublicRespondent', readonly id: string, readonly publicName: string }, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly aggregations: { readonly __typename: 'IdeaAggregations', readonly voteUp: number, readonly voteDown: number } | null }> } | null };

export type AdminPublishingEntityOutreachVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type AdminPublishingEntityOutreach = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortUrl: { readonly __typename: 'ShortUrl', readonly id: string, readonly shortUrl: string } | null, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }>, readonly socialConnections: ReadonlyArray<{ readonly __typename: 'SocialConnection', readonly id: string, readonly provider: SocialConnectionProvider, readonly profileNames: ReadonlyArray<string> }> | null } | null };

export type AdminPublishingEntityPerformanceDataVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  includeHierarchicalData?: InputMaybe<Scalars['Boolean']>;
  historicalDataEntries?: InputMaybe<Scalars['Int']>;
  displayType?: InputMaybe<VariableDisplayType>;
  areaMode: TrackAreaMode;
  comparisonGroupId?: InputMaybe<Scalars['ID']>;
  fipsCodes?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type AdminPublishingEntityPerformanceData = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly COMMUNITY_CHARACTERISTICS: { readonly __typename: 'TrackDomain', readonly id: string, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }>, readonly sentimentValues: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }>, readonly indicators: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly SAFETY: { readonly __typename: 'TrackDomain', readonly id: string, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }>, readonly sentimentValues: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }>, readonly indicators: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly ECONOMY: { readonly __typename: 'TrackDomain', readonly id: string, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }>, readonly sentimentValues: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }>, readonly indicators: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly COMMUNITY_DESIGN: { readonly __typename: 'TrackDomain', readonly id: string, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }>, readonly sentimentValues: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }>, readonly indicators: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly MOBILITY: { readonly __typename: 'TrackDomain', readonly id: string, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }>, readonly sentimentValues: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }>, readonly indicators: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly UTILITIES: { readonly __typename: 'TrackDomain', readonly id: string, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }>, readonly sentimentValues: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }>, readonly indicators: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly HEALTH_AND_WELLNESS: { readonly __typename: 'TrackDomain', readonly id: string, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }>, readonly sentimentValues: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }>, readonly indicators: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly INCLUSIVITY_AND_ENGAGEMENT: { readonly __typename: 'TrackDomain', readonly id: string, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }>, readonly sentimentValues: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }>, readonly indicators: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly EDUCATION_ARTS_CULTURE: { readonly __typename: 'TrackDomain', readonly id: string, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }>, readonly sentimentValues: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }>, readonly indicators: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly GOVERNANCE: { readonly __typename: 'TrackDomain', readonly id: string, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }>, readonly sentimentValues: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }>, readonly indicators: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly COMMUNITY_LIVABILITY: { readonly __typename: 'TrackDomain', readonly id: string, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }>, readonly sentimentValues: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }>, readonly indicators: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly NATURAL_ENVIRONMENT: { readonly __typename: 'TrackDomain', readonly id: string, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }>, readonly sentimentValues: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }>, readonly indicators: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly PARKS_AND_RECREATION: { readonly __typename: 'TrackDomain', readonly id: string, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }>, readonly sentimentValues: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }>, readonly indicators: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> }, readonly FINANCE: { readonly __typename: 'TrackDomain', readonly id: string, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }>, readonly sentimentValues: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }>, readonly indicators: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> } } | null };

export type AdminPublishingEntityPerformanceDataByDomainVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  domain: AnalyticsDomain;
  includeHierarchicalData?: InputMaybe<Scalars['Boolean']>;
  historicalDataEntries?: InputMaybe<Scalars['Int']>;
  displayType?: InputMaybe<VariableDisplayType>;
  areaMode: TrackAreaMode;
  comparisonGroupId?: InputMaybe<Scalars['ID']>;
  fipsCodes?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type AdminPublishingEntityPerformanceDataByDomain = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly trackDomain: { readonly __typename: 'TrackDomain', readonly id: string, readonly indexScores: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }>, readonly sentimentValues: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }>, readonly indicators: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> }> } } | null };

export type AdminPublishingEntityQualityImportanceMatrixVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type AdminPublishingEntityQualityImportanceMatrix = { readonly openQualityImportanceMatrix: ReadonlyArray<{ readonly __typename: 'QiMatrix', readonly publishingEntityId: string, readonly points: ReadonlyArray<{ readonly __typename: 'QiMatrixPoint', readonly topic: MatrixTopic, readonly importance: { readonly __typename: 'QiMatrixAxis', readonly value: number, readonly sources: ReadonlyArray<{ readonly __typename: 'QiMatrixSource', readonly questionSetId: string | null, readonly source: MatrixSource | null, readonly sourceLabel: string | null, readonly sourceType: MatrixSourceType }> }, readonly quality: { readonly __typename: 'QiMatrixAxis', readonly value: number, readonly sources: ReadonlyArray<{ readonly __typename: 'QiMatrixSource', readonly questionSetId: string | null, readonly source: MatrixSource | null, readonly sourceLabel: string | null, readonly sourceType: MatrixSourceType }> } }>, readonly date: { readonly __typename: 'GqlDate', readonly raw: number } }> };

export type AdminPublishingEntityRolesVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type AdminPublishingEntityRoles = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly adminRoles: ReadonlyArray<{ readonly __typename: 'AdminRole', readonly id: string, readonly name: string, readonly description: string, readonly permissions: ReadonlyArray<{ readonly __typename: 'AdminPermission', readonly name: string, readonly displayName: string, readonly category: { readonly __typename: 'AdminPermissionCategory', readonly id: string, readonly name: string } }> }> | null } | null };

export type AdminPublishingEntitySettingsVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type AdminPublishingEntitySettings = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly occupiedSeats: number, readonly totalSeats: number, readonly managingAdmins: ReadonlyArray<{ readonly __typename: 'PublishingEntityAdmin', readonly id: string, readonly roleId: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly name: string, readonly isEnvisioUser: boolean, readonly email: string, readonly user: { readonly __typename: 'User', readonly id: string } } | { readonly __typename: 'PublicAdmin', readonly id: string, readonly name: string, readonly isEnvisioUser: boolean, readonly user: { readonly __typename: 'User', readonly id: string } } }> | null, readonly featureSettings: ReadonlyArray<{ readonly __typename: 'PublishingEntityFeatureSetting', readonly id: string, readonly featureSettingId: string, readonly featureSettingName: string, readonly enabled: boolean, readonly quantity: number, readonly isUnlimited: boolean, readonly expirationDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }> | null } | null };

export type AdminPublishingEntitySimulationWithResultsVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  balancingActSimulationId: Scalars['Int'];
}>;


export type AdminPublishingEntitySimulationWithResults = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly simulations: ReadonlyArray<{ readonly __typename: 'AdminBalancingActSimulation', readonly id: number, readonly name: string, readonly isPrioritization: boolean, readonly type: BalancingActSimulationType, readonly url: string, readonly status: QuestionSetStatus, readonly results: { readonly __typename: 'BalancingActSimulationReportingResults', readonly averageSecondsOnSite: number, readonly averageSubmittedExpenses: number, readonly averageSubmittedRevenue: number, readonly budgetName: string, readonly clientName: string, readonly resetAllClicks: number, readonly status: QuestionSetStatus, readonly submissionCount: number, readonly taxpayerReceiptExperiences: number, readonly totalPageviews: number, readonly locale: string | null, readonly metric: { readonly __typename: 'BalancingActReportingMetricGroups', readonly age: ReadonlyArray<{ readonly __typename: 'BalancingActReportingMetric', readonly label: string, readonly amount: number, readonly rank: number, readonly percentage: number }> | null, readonly city: ReadonlyArray<{ readonly __typename: 'BalancingActReportingMetric', readonly label: string, readonly amount: number, readonly rank: number, readonly percentage: number }> | null, readonly deviceType: ReadonlyArray<{ readonly __typename: 'BalancingActReportingMetric', readonly label: string, readonly amount: number, readonly rank: number, readonly percentage: number }> | null, readonly gender: ReadonlyArray<{ readonly __typename: 'BalancingActReportingMetric', readonly label: string, readonly amount: number, readonly rank: number, readonly percentage: number }> | null, readonly userType: ReadonlyArray<{ readonly __typename: 'BalancingActReportingMetric', readonly label: string, readonly amount: number, readonly rank: number, readonly percentage: number }> | null }, readonly referrerPaths: ReadonlyArray<{ readonly __typename: 'BalancingActReportingSource', readonly source: string | null, readonly sessions: number | null, readonly rank: number | null, readonly percentage: number | null }>, readonly sources: ReadonlyArray<{ readonly __typename: 'BalancingActReportingSource', readonly source: string | null, readonly sessions: number | null, readonly rank: number | null, readonly percentage: number | null }>, readonly socialNetworks: ReadonlyArray<{ readonly __typename: 'BalancingActReportingSource', readonly source: string | null, readonly sessions: number | null, readonly rank: number | null, readonly percentage: number | null }>, readonly categories: ReadonlyArray<{ readonly __typename: 'BalancingActReportingCategory', readonly openClicks: number, readonly total: number, readonly type: string, readonly id: number, readonly averageAmountDecreased: number, readonly averageAmountIncreased: number, readonly averagePercentChange: number, readonly averageSessionAmountChanged: number, readonly averageSessionDecreased: number, readonly averageSessionIncreased: number, readonly averageSubmittedAmount: number, readonly averageSubmittedAmountChanged: number, readonly decreaseClicks: number, readonly detailsClicks: number, readonly displayOrder: number, readonly increaseClicks: number, readonly infoClicks: number, readonly maxSubmittedAmount: number, readonly medianSessionAmountChanged: number, readonly medianSubmittedAmountChanged: number, readonly modeSessionAmountChanged: number, readonly modeSubmittedAmountChanged: number, readonly minSubmittedAmount: number, readonly name: string, readonly percentSubmissionsChanged: number, readonly percentSubmissionsDecreased: number, readonly percentSubmissionsIncreased: number, readonly percentSubmissionsUnchanged: number, readonly totalSubmissionsChanged: number, readonly totalSubmissionsDecreased: number, readonly totalSubmissionsIncreased: number, readonly totalSubmissionsUnchanged: number, readonly subcategories: ReadonlyArray<{ readonly __typename: 'BalancingActReportingSubcategory', readonly amount: number, readonly averageSubmittedRate: number, readonly customQuestionText: string | null, readonly customizedQuestionJson: string | null, readonly id: number, readonly averageAmountDecreased: number, readonly averageAmountIncreased: number, readonly averagePercentChange: number, readonly averageSessionAmountChanged: number, readonly averageSessionDecreased: number, readonly averageSessionIncreased: number, readonly averageSubmittedAmount: number, readonly averageSubmittedAmountChanged: number, readonly decreaseClicks: number, readonly detailsClicks: number, readonly displayOrder: number, readonly increaseClicks: number, readonly infoClicks: number, readonly maxSubmittedAmount: number, readonly medianSessionAmountChanged: number, readonly medianSubmittedAmountChanged: number, readonly modeSessionAmountChanged: number, readonly modeSubmittedAmountChanged: number, readonly minSubmittedAmount: number, readonly name: string, readonly percentSubmissionsChanged: number, readonly percentSubmissionsDecreased: number, readonly percentSubmissionsIncreased: number, readonly percentSubmissionsUnchanged: number, readonly totalSubmissionsChanged: number, readonly totalSubmissionsDecreased: number, readonly totalSubmissionsIncreased: number, readonly totalSubmissionsUnchanged: number, readonly comments: ReadonlyArray<{ readonly __typename: 'BalancingActReportingSubcategoryComment', readonly text: string, readonly timestamp: string }>, readonly questionOptions: ReadonlyArray<{ readonly __typename: 'BalancingActReportingSubcategoryQuestionOption', readonly displayOrder: number, readonly title: string, readonly deltaAmount: number, readonly netAmount: number, readonly submittedCount: number, readonly submittedPercentage: number, readonly clickedCount: number, readonly clickedPercentage: number }> }> }> } | null }> } | null };

export type AdminPublishingEntitySimulationsVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  balancingActSimulationId?: InputMaybe<Scalars['Int']>;
}>;


export type AdminPublishingEntitySimulations = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly simulations: ReadonlyArray<{ readonly __typename: 'AdminBalancingActSimulation', readonly id: number, readonly name: string, readonly isPrioritization: boolean, readonly type: BalancingActSimulationType, readonly url: string, readonly status: QuestionSetStatus, readonly description: string | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number } }> } | null };

export type AdminPublishingEntitySimulationsWithCategoriesVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  balancingActSimulationId?: InputMaybe<Scalars['Int']>;
}>;


export type AdminPublishingEntitySimulationsWithCategories = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly simulations: ReadonlyArray<{ readonly __typename: 'AdminBalancingActSimulation', readonly id: number, readonly name: string, readonly type: BalancingActSimulationType, readonly url: string, readonly description: string | null, readonly categories: ReadonlyArray<{ readonly __typename: 'SimulationCategory', readonly id: number, readonly name: string, readonly type: SimulationCategoryType, readonly subcategories: ReadonlyArray<{ readonly __typename: 'SimulationSubcategory', readonly id: number, readonly name: string, readonly amount: number, readonly details: string | null, readonly isLocked: boolean }> }> }> } | null };

export type AdminPublishingEntityStrategicPlansVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type AdminPublishingEntityStrategicPlans = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly strategicPlans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }> } | null };

export type AdminPublishingEntityVisualizationsVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  areaMode?: InputMaybe<TrackAreaMode>;
  comparisonGroupId?: InputMaybe<Scalars['ID']>;
  notShowingVisualizations: Scalars['Boolean'];
  fipsCodes?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type AdminPublishingEntityVisualizations = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly trackVariableVisualizations: ReadonlyArray<{ readonly __typename: 'TrackVariableVisualization', readonly id: string, readonly fips: string | null, readonly publishingEntityId: string, readonly benchmarkFilter: BenchmarkFilter, readonly visualizationType: VisualizationType | null, readonly state: SavedVisualizationActivationState, readonly comparisonGroupId: string | null, readonly visualizationAreas?: ReadonlyArray<{ readonly __typename: 'FipsArea', readonly id: string, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null }>, readonly boundingBox: { readonly __typename: 'GeoBoundingBox', readonly id: string, readonly xMin: number, readonly xMax: number, readonly yMin: number, readonly yMax: number } | null, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly trackVariables: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } | { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }> }>, readonly featureSettings: ReadonlyArray<{ readonly __typename: 'PublishingEntityFeatureSetting', readonly id: string, readonly isUnlimited: boolean, readonly activeCount: number | null, readonly featureSettingName: string, readonly featureSettingId: string, readonly enabled: boolean, readonly quantity: number, readonly expirationDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }> | null, readonly strategicPlans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }> } | null };

export type AdminPublishingWizardScheduleVariables = Exact<{
  questionSetId: Scalars['ID'];
}>;


export type AdminPublishingWizardSchedule = { readonly currentUser: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly activePublishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortUrl: { readonly __typename: 'ShortUrl', readonly id: string, readonly shortUrl: string } | null, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly socialConnections: ReadonlyArray<{ readonly __typename: 'SocialConnection', readonly id: string, readonly provider: SocialConnectionProvider }> | null, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> } | null } | { readonly __typename: 'PublicAdmin' } | null } | null }, readonly openContentSetById: { readonly __typename: 'GenericContent', readonly id: string, readonly hasBenchmarkedContent: boolean, readonly polcoManaged: boolean, readonly questionsCount: number, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly hasBenchmarkedContent: boolean, readonly polcoManaged: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> }, readonly cartQuestions: { readonly __typename: 'CreatedQuestionsData', readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly isBenchmarkedQuestion: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } }> } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly hasBenchmarkedContent: boolean, readonly polcoManaged: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> }, readonly cartQuestions: { readonly __typename: 'CreatedQuestionsData', readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly isBenchmarkedQuestion: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } }> } } | { readonly __typename: 'Survey', readonly id: string, readonly hasBenchmarkedContent: boolean, readonly polcoManaged: boolean, readonly questionsCount: number, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } } | null };

export type AdminPublishingWizardShareVariables = Exact<{
  questionSetId: Scalars['ID'];
}>;


export type AdminPublishingWizardShare = { readonly currentUser: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly requestedFeatures: ReadonlyArray<string>, readonly activePublishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortUrl: { readonly __typename: 'ShortUrl', readonly id: string, readonly shortUrl: string } | null, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly socialConnections: ReadonlyArray<{ readonly __typename: 'SocialConnection', readonly id: string, readonly provider: SocialConnectionProvider, readonly profileNames: ReadonlyArray<string> }> | null, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }>, readonly featureSettings: ReadonlyArray<{ readonly __typename: 'PublishingEntityFeatureSetting', readonly id: string, readonly featureSettingId: string, readonly featureSettingName: string, readonly enabled: boolean, readonly quantity: number, readonly isUnlimited: boolean, readonly expirationDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }> | null } | null } | { readonly __typename: 'PublicAdmin' } | null } | null }, readonly openContentSetById: { readonly __typename: 'GenericContent', readonly id: string, readonly slug: string | null, readonly questionsCount: number, readonly shortId: string | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly slug: string | null, readonly shortId: string | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> }, readonly cartQuestions: { readonly __typename: 'CreatedQuestionsData', readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } }> } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly slug: string | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> }, readonly cartQuestions: { readonly __typename: 'CreatedQuestionsData', readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } }> } } | { readonly __typename: 'Survey', readonly id: string, readonly slug: string | null, readonly questionsCount: number, readonly shortId: string | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } } | null };

export type AdminQuestionResultsAdvancedVariables = Exact<{
  questionId: Scalars['ID'];
  publishingEntityId: Scalars['ID'];
  source: RespondentAttributeValueSource;
}>;


export type AdminQuestionResultsAdvanced = { readonly openQuestion: { readonly __typename: 'Question', readonly id: string, readonly totalVotesCount: number | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly text: string, readonly value: number }> | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType } | null }, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } } | { readonly __typename: 'Survey', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }, readonly stats: { readonly __typename: 'QuestionStats', readonly id: string, readonly overview: ReadonlyArray<{ readonly __typename: 'QuestionStatsOverview', readonly label: string, readonly stats: { readonly __typename: 'QuestionStatsData', readonly totalResponses: number, readonly byChoice: ReadonlyArray<{ readonly __typename: 'QuestionStat', readonly choiceId: string, readonly label: string, readonly percent: number, readonly value: number }> } }> | null, readonly breakdowns: ReadonlyArray<{ readonly __typename: 'QuestionStatsBreakdown', readonly key: string, readonly hits: number, readonly buckets: ReadonlyArray<{ readonly __typename: 'StatBucketGroup', readonly key: string, readonly hits: number, readonly buckets: ReadonlyArray<{ readonly __typename: 'StatBucket', readonly key: string, readonly hits: number }> }> }> | null } } | null };

export type AdminQuestionResultsAdvancedMapVariables = Exact<{
  questionId: Scalars['ID'];
  publishingEntityId: Scalars['ID'];
  source: RespondentAttributeValueSource;
  geoViewId: Scalars['ID'];
}>;


export type AdminQuestionResultsAdvancedMap = { readonly openQuestion: { readonly __typename: 'Question', readonly id: string, readonly stats: { readonly __typename: 'QuestionStats', readonly id: string, readonly map: { readonly __typename: 'QuestionMapStatsWithStatus', readonly mapStatsStatus: MapStatsStatus, readonly questionMapStats: { readonly __typename: 'QuestionMapStats', readonly hits: number, readonly buckets: ReadonlyArray<{ readonly __typename: 'MapStatBucketGroup', readonly key: string, readonly hits: number, readonly buckets: ReadonlyArray<{ readonly __typename: 'StatBucket', readonly key: string, readonly hits: number }>, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } }>, readonly center: { readonly __typename: 'CoordinateCenter', readonly size: number, readonly coordinate: { readonly __typename: 'Coordinate', readonly lat: number, readonly lng: number } } } | null } | null } } | null };

export type AdminQuestionResultsHeaderVariables = Exact<{
  questionId: Scalars['ID'];
  filter?: InputMaybe<ResultFilter>;
}>;


export type AdminQuestionResultsHeader = { readonly openQuestion: { readonly __typename: 'Question', readonly id: string, readonly totalVotesCount: number | null, readonly shortId: string | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly commentsWordCount: ReadonlyArray<{ readonly __typename: 'WordCount', readonly text: string, readonly value: number }> | null, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly slug: string | null, readonly allowGuestRespondents: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly socialConnections: ReadonlyArray<{ readonly __typename: 'SocialConnection', readonly id: string, readonly provider: SocialConnectionProvider, readonly profileNames: ReadonlyArray<string> }> | null } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly slug: string | null, readonly allowGuestRespondents: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly socialConnections: ReadonlyArray<{ readonly __typename: 'SocialConnection', readonly id: string, readonly provider: SocialConnectionProvider, readonly profileNames: ReadonlyArray<string> }> | null } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly slug: string | null, readonly allowGuestRespondents: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly socialConnections: ReadonlyArray<{ readonly __typename: 'SocialConnection', readonly id: string, readonly provider: SocialConnectionProvider, readonly profileNames: ReadonlyArray<string> }> | null } } | { readonly __typename: 'Survey', readonly id: string, readonly slug: string | null, readonly allowGuestRespondents: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly socialConnections: ReadonlyArray<{ readonly __typename: 'SocialConnection', readonly id: string, readonly provider: SocialConnectionProvider, readonly profileNames: ReadonlyArray<string> }> | null } }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType } | null }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }> } | null };

export type AdminQuestionStatsVariables = Exact<{
  questionId: Scalars['ID'];
  publishingEntityId: Scalars['ID'];
  geoViewId: Scalars['ID'];
}>;


export type AdminQuestionStats = { readonly openQuestion: { readonly __typename: 'Question', readonly id: string, readonly totalVotesCount: number | null, readonly responsesOverTime: { readonly __typename: 'TimeBreakdown', readonly interval: TimeBreakdownInterval, readonly data: ReadonlyArray<{ readonly __typename: 'TimeBreakdownData', readonly value: number, readonly time: string }> } | null, readonly ageBreakdownThirdParty: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly ageBreakdownUserReported: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly genderBreakdownThirdParty: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly genderBreakdownUserReported: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly sampleBreakdown: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly languageBreakdown: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly raceBreakdown: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown', readonly label: string, readonly unknownTotal: number, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownValue', readonly label: string, readonly total: number }> } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta' } | null, readonly verifiedResponses: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown' } | { readonly __typename: 'StatBreakdownLocation' } | { readonly __typename: 'StatValueDelta', readonly changeLabel: string, readonly currentValue: number, readonly label: string, readonly recentChange: number } | null, readonly locationBreakdown: { readonly __typename: 'EmptyBreakdown' } | { readonly __typename: 'FeatureSettingMissingBreakdown' } | { readonly __typename: 'ProtectedStatBreakdown' } | { readonly __typename: 'StatBreakdown' } | { readonly __typename: 'StatBreakdownLocation', readonly center: { readonly __typename: 'CoordinateCenter', readonly size: number, readonly coordinate: { readonly __typename: 'Coordinate', readonly lat: number, readonly lng: number } }, readonly values: ReadonlyArray<{ readonly __typename: 'StatBreakdownLocationValue', readonly key: string, readonly total: number, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } }> } | { readonly __typename: 'StatValueDelta' } | null } | null };

export type AdminReadyToShareQuestionsVariables = Exact<{
  setId: Scalars['ID'];
  forPublisherId: Scalars['ID'];
  shareType: ShareableContentType;
  areaMode?: InputMaybe<TrackAreaMode>;
  comparisonGroupId?: InputMaybe<Scalars['ID']>;
  fipsCodes?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type AdminReadyToShareQuestions = { readonly adminShareableContentSet: { readonly __typename: 'ShareableContentSet', readonly id: string, readonly isPaidContent: boolean, readonly domains: ReadonlyArray<ShareableContentDomains>, readonly contentSet: { readonly __typename: 'GenericContent', readonly id: string, readonly questionsCount: number, readonly setImageId: string | null, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly contents: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly questionNumber: number | null, readonly summary: string | null, readonly reportDisplayLabel: string | null, readonly variableName: string | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus }, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string }, readonly demographicAttribute: { readonly __typename: 'DemographicAttribute', readonly id: string, readonly name: string, readonly premium: boolean, readonly owner: { readonly __typename: 'PublishingEntity', readonly id: string } | null } | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> } } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly questionNumber: number | null, readonly numColumns: number, readonly structureType: QuestionHierarchyParentNodeType, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly structureDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly survey: { readonly __typename: 'Survey', readonly id: string }, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null } }>, readonly rowContents: ReadonlyArray<{ readonly __typename: 'RowContentHierarchyNodeBaReceipt', readonly id: string, readonly receipt: { readonly __typename: 'BalancingActSimulationWithPubId', readonly id: number, readonly name: string, readonly simulationType: string, readonly publishedAt: { readonly __typename: 'GqlDate', readonly raw: number } } } | { readonly __typename: 'RowContentHierarchyNodeBaSim', readonly id: string, readonly simulation: { readonly __typename: 'BalancingActSimulationWithPubId', readonly id: number, readonly name: string, readonly simulationType: string, readonly prioritization: boolean, readonly publishedAt: { readonly __typename: 'GqlDate', readonly raw: number } } } | { readonly __typename: 'RowContentHierarchyNodePolco', readonly id: string, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'Survey', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } }> } | { readonly __typename: 'QuestionHierarchySimulationNode', readonly id: string, readonly simulationType: SimulationNodeType, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly simulation: { readonly __typename: 'SimulationNodeData', readonly id: number, readonly url: string, readonly adminData: { readonly __typename: 'SimulationNodeAdminData', readonly name: string, readonly description: string | null, readonly prioritization: boolean, readonly simulationType: BalancingActSimulationType, readonly status: QuestionSetStatus } | null } | null } | { readonly __typename: 'QuestionHierarchyVisualizationNode', readonly id: string, readonly altLabel: string | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly trackVariableVisualization: { readonly __typename: 'TrackVariableVisualization', readonly id: string, readonly fips: string | null, readonly publishingEntityId: string, readonly benchmarkFilter: BenchmarkFilter, readonly visualizationType: VisualizationType | null, readonly state: SavedVisualizationActivationState, readonly comparisonGroupId: string | null, readonly visualizationAreas: ReadonlyArray<{ readonly __typename: 'FipsArea', readonly id: string, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null }>, readonly plans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }>, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly trackVariables: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } | { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }> } | null }> } | { readonly __typename: 'PolcoLive', readonly id: string, readonly questionsCount: number, readonly setImageId: string | null, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly createdQuestions: { readonly __typename: 'CreatedQuestionsData', readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus } }> } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly questionsCount: number, readonly setImageId: string | null, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly createdQuestions: { readonly __typename: 'CreatedQuestionsData', readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus } }> } } | { readonly __typename: 'Survey', readonly id: string, readonly questionsCount: number, readonly setImageId: string | null, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly contents: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly questionNumber: number | null, readonly summary: string | null, readonly reportDisplayLabel: string | null, readonly variableName: string | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleType: ScaleType, readonly scaleThreshold: number } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus }, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string }, readonly demographicAttribute: { readonly __typename: 'DemographicAttribute', readonly id: string, readonly name: string, readonly premium: boolean, readonly owner: { readonly __typename: 'PublishingEntity', readonly id: string } | null } | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> } } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly questionNumber: number | null, readonly numColumns: number, readonly structureType: QuestionHierarchyParentNodeType, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly structureDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly survey: { readonly __typename: 'Survey', readonly id: string }, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null } }>, readonly rowContents: ReadonlyArray<{ readonly __typename: 'RowContentHierarchyNodeBaReceipt', readonly id: string, readonly receipt: { readonly __typename: 'BalancingActSimulationWithPubId', readonly id: number, readonly name: string, readonly simulationType: string, readonly publishedAt: { readonly __typename: 'GqlDate', readonly raw: number } } } | { readonly __typename: 'RowContentHierarchyNodeBaSim', readonly id: string, readonly simulation: { readonly __typename: 'BalancingActSimulationWithPubId', readonly id: number, readonly name: string, readonly simulationType: string, readonly prioritization: boolean, readonly publishedAt: { readonly __typename: 'GqlDate', readonly raw: number } } } | { readonly __typename: 'RowContentHierarchyNodePolco', readonly id: string, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'Survey', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } }> } | { readonly __typename: 'QuestionHierarchySimulationNode', readonly id: string, readonly simulationType: SimulationNodeType, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly simulation: { readonly __typename: 'SimulationNodeData', readonly id: number, readonly url: string, readonly adminData: { readonly __typename: 'SimulationNodeAdminData', readonly name: string, readonly description: string | null, readonly prioritization: boolean, readonly simulationType: BalancingActSimulationType, readonly status: QuestionSetStatus } | null } | null } | { readonly __typename: 'QuestionHierarchyVisualizationNode', readonly id: string, readonly altLabel: string | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly trackVariableVisualization: { readonly __typename: 'TrackVariableVisualization', readonly id: string, readonly fips: string | null, readonly publishingEntityId: string, readonly benchmarkFilter: BenchmarkFilter, readonly visualizationType: VisualizationType | null, readonly state: SavedVisualizationActivationState, readonly comparisonGroupId: string | null, readonly visualizationAreas: ReadonlyArray<{ readonly __typename: 'FipsArea', readonly id: string, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null }>, readonly plans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }>, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly trackVariables: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } | { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }> } | null }> } } | null };

export type AdminRegistrationRolesVariables = Exact<{
  filter: AdminRoleFilter;
}>;


export type AdminRegistrationRoles = { readonly adminRegistrationRoles: ReadonlyArray<{ readonly __typename: 'AdminRegistrationRole', readonly id: string, readonly displayName: string, readonly archived: boolean }> };

export type AdminStoreVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  storeType: StoreItemsType;
}>;


export type AdminStore = { readonly adminOrderedStoreItems: ReadonlyArray<{ readonly __typename: 'PublishingEntityStoreItem', readonly id: string, readonly purchasedInStripe: boolean, readonly status: StoreItemPublisherStatus, readonly expiresAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly storeItem: { readonly __typename: 'StoreItem', readonly id: string, readonly name: string, readonly provider: StoreItemProvider, readonly shortDescription: string, readonly longDescription: string, readonly freeTrialLengthMs: number | null, readonly purchaseLengthMs: number, readonly repurchaseDelayMs: number, readonly key: string, readonly thumbnailUrl: string | null, readonly mainImageUrl: string | null, readonly category: StoreItemCategory, readonly oneTime: boolean, readonly stripeId: string | null, readonly linkedFeatureSettingId: string | null, readonly isHiddenInUI: boolean, readonly plans: ReadonlyArray<{ readonly __typename: 'StoreItemPlan', readonly id: string, readonly active: boolean, readonly amount: number | null, readonly trialPeriodDays: number | null, readonly billingScheme: BillingScheme | null, readonly interval: StripeInterval, readonly intervalCount: number, readonly nickname: string | null, readonly product: string, readonly usageType: StripeUsageType }>, readonly childStoreItems: ReadonlyArray<{ readonly __typename: 'StoreItem', readonly id: string, readonly key: string, readonly name: string, readonly shortDescription: string, readonly category: StoreItemCategory, readonly order: number | null, readonly isHiddenInUI: boolean }> } }> };

export type AdminStoreItemVariables = Exact<{
  publishingEntityId: Scalars['ID'];
  idOrKey: Scalars['String'];
}>;


export type AdminStoreItem = { readonly adminStoreItemByIdOrKey: { readonly __typename: 'PublishingEntityStoreItem', readonly id: string, readonly purchasedInStripe: boolean, readonly status: StoreItemPublisherStatus, readonly expiresAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly storeItem: { readonly __typename: 'StoreItem', readonly id: string, readonly name: string, readonly provider: StoreItemProvider, readonly shortDescription: string, readonly longDescription: string, readonly freeTrialLengthMs: number | null, readonly purchaseLengthMs: number, readonly repurchaseDelayMs: number, readonly key: string, readonly thumbnailUrl: string | null, readonly mainImageUrl: string | null, readonly category: StoreItemCategory, readonly oneTime: boolean, readonly stripeId: string | null, readonly linkedFeatureSettingId: string | null, readonly isHiddenInUI: boolean, readonly plans: ReadonlyArray<{ readonly __typename: 'StoreItemPlan', readonly id: string, readonly active: boolean, readonly amount: number | null, readonly trialPeriodDays: number | null, readonly billingScheme: BillingScheme | null, readonly interval: StripeInterval, readonly intervalCount: number, readonly nickname: string | null, readonly product: string, readonly usageType: StripeUsageType }>, readonly childStoreItems: ReadonlyArray<{ readonly __typename: 'StoreItem', readonly id: string, readonly key: string, readonly name: string, readonly shortDescription: string, readonly category: StoreItemCategory, readonly order: number | null, readonly isHiddenInUI: boolean }> } } | null };

export type CurrentActiveFlagsVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']>;
  publishingEntityId?: InputMaybe<Scalars['ID']>;
}>;


export type CurrentActiveFlags = { readonly flags: { readonly __typename: 'ActiveFlags', readonly flags: ReadonlyArray<{ readonly __typename: 'BooleanFlag', readonly flagKey: string, readonly enabled: boolean } | { readonly __typename: 'ErrorFlag', readonly flagKey: string } | { readonly __typename: 'VariantFlag', readonly match: boolean, readonly flagKey: string }> } };

export type CurrentAdminVariables = Exact<{ [key: string]: never; }>;


export type CurrentAdmin = { readonly currentUser: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly name: string, readonly email: string, readonly permissions: ReadonlyArray<string>, readonly superAdmin: boolean, readonly emailVerificationStatus: EmailVerificationStatus, readonly isEnvisioUser: boolean, readonly demoPollyUrl: string | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly registrationRequests: ReadonlyArray<{ readonly __typename: 'AdminRegistration', readonly id: string, readonly decision: AdminRegistrationDecision | null, readonly createdTime: { readonly __typename: 'GqlDate', readonly raw: number }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string } | null }>, readonly registrationRole: { readonly __typename: 'AdminRegistrationRole', readonly id: string, readonly displayName: string, readonly persona: { readonly __typename: 'AdminPersona', readonly id: string, readonly name: string } | null } | null, readonly activePublishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly activationState: PublishingEntityActivationState, readonly showExampleQuestions: boolean, readonly slug: string, readonly systemType: string | null, readonly approvalDecision: PublishingEntityApprovalDecision, readonly isEnterprise: boolean, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly postedBy: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly url: string, readonly type: PublishingEntityAssetType }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly type: FipsAreaType | null, readonly populationSizeSegment: string | null } | null, readonly featureSettings: ReadonlyArray<{ readonly __typename: 'PublishingEntityFeatureSetting', readonly id: string, readonly featureSettingId: string, readonly featureSettingName: string, readonly enabled: boolean, readonly quantity: number, readonly isUnlimited: boolean, readonly expirationDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }> | null, readonly defaultGeoView: { readonly __typename: 'GeoView', readonly id: string, readonly name: string } | { readonly __typename: 'PublishingEntityGeoView', readonly id: string, readonly name: string }, readonly availableGeoViews: ReadonlyArray<{ readonly __typename: 'GeoView', readonly id: string, readonly name: string } | { readonly __typename: 'PublishingEntityGeoView', readonly id: string, readonly name: string }>, readonly presidingArea: { readonly __typename: 'PresidingArea', readonly id: string, readonly name: string, readonly center: { readonly __typename: 'CoordinateCenter', readonly size: number, readonly coordinate: { readonly __typename: 'Coordinate', readonly lat: number, readonly lng: number } } } | null, readonly activeLiveEvents: ReadonlyArray<{ readonly __typename: 'PolcoLive', readonly id: string, readonly slug: string | null }>, readonly balancingActCustomer: { readonly __typename: 'BalancingActCustomer', readonly id: number, readonly name: string } | null, readonly organizationType: { readonly __typename: 'PublishingEntityOrganizationType', readonly id: string, readonly displayName: string } | null, readonly organizationSubtype: { readonly __typename: 'PublishingEntityOrganizationSubtype', readonly id: string, readonly displayName: string } | null, readonly storeTiers: ReadonlyArray<{ readonly __typename: 'PublishingEntityStoreItem', readonly id: string, readonly purchasedInStripe: boolean, readonly status: StoreItemPublisherStatus, readonly expiresAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly storeItem: { readonly __typename: 'StoreItem', readonly id: string, readonly name: string, readonly provider: StoreItemProvider, readonly shortDescription: string, readonly longDescription: string, readonly freeTrialLengthMs: number | null, readonly purchaseLengthMs: number, readonly repurchaseDelayMs: number, readonly key: string, readonly thumbnailUrl: string | null, readonly mainImageUrl: string | null, readonly category: StoreItemCategory, readonly oneTime: boolean, readonly stripeId: string | null, readonly linkedFeatureSettingId: string | null, readonly isHiddenInUI: boolean, readonly plans: ReadonlyArray<{ readonly __typename: 'StoreItemPlan', readonly id: string, readonly active: boolean, readonly amount: number | null, readonly trialPeriodDays: number | null, readonly billingScheme: BillingScheme | null, readonly interval: StripeInterval, readonly intervalCount: number, readonly nickname: string | null, readonly product: string, readonly usageType: StripeUsageType }>, readonly childStoreItems: ReadonlyArray<{ readonly __typename: 'StoreItem', readonly id: string, readonly key: string, readonly name: string, readonly shortDescription: string, readonly category: StoreItemCategory, readonly order: number | null, readonly isHiddenInUI: boolean }> } }> } | null, readonly menuItems: ReadonlyArray<{ readonly __typename: 'MenuItem', readonly id: string, readonly text: string, readonly url: string | null, readonly icon: string | null, readonly materialIcon: string | null, readonly isNew: boolean | null, readonly isShown: boolean | null, readonly childrenMenuItems: ReadonlyArray<{ readonly __typename: 'MenuItem', readonly id: string, readonly text: string, readonly url: string | null, readonly icon: string | null, readonly materialIcon: string | null, readonly isNew: boolean | null, readonly isShown: boolean | null }> }> } | { readonly __typename: 'PublicAdmin' } | null } | null } };

export type CurrentAdminAiSessionsVariables = Exact<{ [key: string]: never; }>;


export type CurrentAdminAiSessions = { readonly currentUser: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly aiAssistantSessions: ReadonlyArray<{ readonly __typename: 'AiAssistantUserSession', readonly id: string, readonly name: string | null, readonly assistantName: string, readonly polcoAssistantId: string | null, readonly startAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly lastInteractedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null }> } | { readonly __typename: 'PublicAdmin' } | null } | null } };

export type CurrentAdminManagedPublishingEntitiesVariables = Exact<{
  filter?: InputMaybe<Scalars['String']>;
}>;


export type CurrentAdminManagedPublishingEntities = { readonly currentUser: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly managedPublishingEntities: ReadonlyArray<{ readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly presidingArea: { readonly __typename: 'PresidingArea', readonly id: string, readonly name: string } | null }> } | { readonly __typename: 'PublicAdmin' } | null } | null } };

export type CurrentAdminRegistrationInfoVariables = Exact<{ [key: string]: never; }>;


export type CurrentAdminRegistrationInfo = { readonly registrationInformation: { readonly __typename: 'RegistrationInformation', readonly reasons: ReadonlyArray<{ readonly __typename: 'AdminRegistrationReason', readonly id: string, readonly reason: string }>, readonly outcomes: ReadonlyArray<{ readonly __typename: 'AdminRegistrationOutcome', readonly id: string, readonly outcome: string }>, readonly interests: ReadonlyArray<{ readonly __typename: 'AdminRegistrationInterest', readonly id: string, readonly interest: string, readonly url: string }> }, readonly currentUser: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly name: string, readonly emailVerificationStatus: EmailVerificationStatus, readonly registrationRequests: ReadonlyArray<{ readonly __typename: 'AdminRegistration', readonly id: string, readonly decision: AdminRegistrationDecision | null, readonly createdTime: { readonly __typename: 'GqlDate', readonly raw: number }, readonly registrationReason: { readonly __typename: 'AdminRegistrationReason', readonly id: string } | null, readonly desiredOutcome: { readonly __typename: 'AdminRegistrationOutcome', readonly id: string } | null, readonly interests: ReadonlyArray<{ readonly __typename: 'AdminRegistrationInterest', readonly id: string }>, readonly metadata: ReadonlyArray<{ readonly __typename: 'AdminRegistrationMetadata', readonly key: string, readonly value: string }>, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly activationState: PublishingEntityActivationState, readonly showExampleQuestions: boolean, readonly slug: string, readonly systemType: string | null, readonly approvalDecision: PublishingEntityApprovalDecision, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly postedBy: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly url: string, readonly type: PublishingEntityAssetType }>, readonly featureSettings: ReadonlyArray<{ readonly __typename: 'PublishingEntityFeatureSetting', readonly id: string, readonly featureSettingId: string, readonly featureSettingName: string, readonly enabled: boolean, readonly quantity: number, readonly isUnlimited: boolean, readonly expirationDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }> | null, readonly defaultGeoView: { readonly __typename: 'GeoView', readonly id: string, readonly name: string } | { readonly __typename: 'PublishingEntityGeoView', readonly id: string, readonly name: string }, readonly availableGeoViews: ReadonlyArray<{ readonly __typename: 'GeoView', readonly id: string, readonly name: string } | { readonly __typename: 'PublishingEntityGeoView', readonly id: string, readonly name: string }>, readonly presidingArea: { readonly __typename: 'PresidingArea', readonly id: string, readonly name: string, readonly center: { readonly __typename: 'CoordinateCenter', readonly size: number, readonly coordinate: { readonly __typename: 'Coordinate', readonly lat: number, readonly lng: number } } } | null, readonly activeLiveEvents: ReadonlyArray<{ readonly __typename: 'PolcoLive', readonly id: string, readonly slug: string | null }>, readonly organizationType: { readonly __typename: 'PublishingEntityOrganizationType', readonly id: string, readonly displayName: string } | null, readonly organizationSubtype: { readonly __typename: 'PublishingEntityOrganizationSubtype', readonly id: string, readonly displayName: string } | null, readonly organizationArea: { readonly __typename: 'PublishingEntityOrganizationArea', readonly id: string, readonly displayName: string } | null } | null }> } | { readonly __typename: 'PublicAdmin' } | null } | null } };

export type CurrentAdminRequestedFeaturesVariables = Exact<{ [key: string]: never; }>;


export type CurrentAdminRequestedFeatures = { readonly currentUser: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly requestedFeatures: ReadonlyArray<string>, readonly email: string, readonly phoneNumber: string | null, readonly phoneExt: string | null, readonly commsEmail: string | null } | { readonly __typename: 'PublicAdmin' } | null } | null } };

export type CurrentRespondentVariables = Exact<{ [key: string]: never; }>;


export type CurrentRespondent = { readonly currentUser: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string, readonly respondent: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null, readonly avatarUrl: string | null, readonly guest: boolean, readonly zipCode: string | null, readonly inputtedLat: number | null, readonly inputtedLon: number | null, readonly verified: boolean, readonly invitedPlaceholderAccount: boolean, readonly requiresVerificationPrompt: boolean, readonly postAnonymously: boolean, readonly requestLocationLastShown: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly subscriptions: ReadonlyArray<{ readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string }> } | { readonly __typename: 'PublicRespondent' } | null, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly isEnvisioUser: boolean } | { readonly __typename: 'PublicAdmin', readonly id: string, readonly isEnvisioUser: boolean } | null } | null, readonly location: { readonly __typename: 'UserLocation', readonly id: string, readonly ip: string | null, readonly zipCode: string | null, readonly coordinate: { readonly __typename: 'Coordinate', readonly lat: number, readonly lng: number } | null } | null } };

export type CurrentUserVariables = Exact<{ [key: string]: never; }>;


export type CurrentUser = { readonly currentUser: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string, readonly respondent: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly email: string | null } | { readonly __typename: 'PublicRespondent', readonly id: string } | null, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly email: string, readonly demoPollyUrl: string | null, readonly managedPublishingEntities: ReadonlyArray<{ readonly __typename: 'PublishingEntity', readonly id: string }>, readonly activePublishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | null } | { readonly __typename: 'PublicAdmin' } | null } | null } };

export type CurrentUserNearbyLocationsVariables = Exact<{
  zipCode?: InputMaybe<Scalars['String']>;
}>;


export type CurrentUserNearbyLocations = { readonly currentUser: { readonly __typename: 'CurrentUser', readonly id: string, readonly nearbyLocations: { readonly __typename: 'NearbyLocations', readonly zipCode: string, readonly locations: ReadonlyArray<{ readonly __typename: 'FipsArea', readonly id: string, readonly name: string }> } | null } };

export type OpenAiAssistantVariables = Exact<{
  assistant: AssistantIdInput;
}>;


export type OpenAiAssistant = { readonly openAiAssistant: { readonly __typename: 'PubAssistant', readonly id: string, readonly name: string, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string } | null } } | null };

export type OpenIdeaVariables = Exact<{
  ideaId: Scalars['ID'];
  respondentId?: InputMaybe<Scalars['ID']>;
}>;


export type OpenIdea = { readonly openIdea: { readonly __typename: 'Idea', readonly id: string, readonly title: string, readonly description: string | null, readonly respondentVote: VoteType, readonly respondent: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly publicName: string } | { readonly __typename: 'PublicRespondent', readonly id: string, readonly publicName: string }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly aggregations: { readonly __typename: 'IdeaAggregations', readonly voteUp: number, readonly voteDown: number } | null } };

export type OpenTrackVariablesVariables = Exact<{
  fipsCodes: ReadonlyArray<Scalars['String']> | Scalars['String'];
  variableNames: ReadonlyArray<Scalars['String']> | Scalars['String'];
  statisticType: StatisticType;
  comparisonGroupId?: InputMaybe<Scalars['ID']>;
  areaMode: TrackAreaMode;
  publishingEntityId?: InputMaybe<Scalars['ID']>;
}>;


export type OpenTrackVariables = { readonly openTrackVariables: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } | { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }> };

export type PublishingEntityByIdVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type PublishingEntityById = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly activationState: PublishingEntityActivationState, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly postedBy: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }>, readonly mailingsData: { readonly __typename: 'PublishingEntityMailingsData', readonly id: string, readonly title: string | null, readonly fullName: string | null, readonly contactPhoneNumber: string | null, readonly adminIndicatedComplete: boolean, readonly returnMailingAddress: string | null, readonly samplingZipCodes: string | null, readonly useExistingInfo: boolean } | null, readonly featureSettings: ReadonlyArray<{ readonly __typename: 'PublishingEntityFeatureSetting', readonly id: string, readonly featureSettingId: string, readonly featureSettingName: string, readonly enabled: boolean, readonly quantity: number, readonly isUnlimited: boolean, readonly expirationDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }> | null } | null };

export type PublishingEntityCreationFormVariables = Exact<{ [key: string]: never; }>;


export type PublishingEntityCreationForm = { readonly publishingEntityOrganizations: ReadonlyArray<{ readonly __typename: 'PublishingEntityOrganizationType', readonly id: string, readonly displayName: string, readonly nameEntryLabel: string, readonly subtypes: ReadonlyArray<{ readonly __typename: 'PublishingEntityOrganizationSubtype', readonly id: string, readonly displayName: string }> }>, readonly publishingEntityOrganizationAreas: ReadonlyArray<{ readonly __typename: 'PublishingEntityOrganizationArea', readonly id: string, readonly displayName: string, readonly areaLookupEntryLabel: string | null, readonly areaLookupType: AreaLookupType, readonly knownKey: KnownOrganizationAreaKey | null }> };

export type RespondentActiveSubscriptionsForIdeaVariables = Exact<{
  respondentId: Scalars['ID'];
}>;


export type RespondentActiveSubscriptionsForIdea = { readonly openRespondent: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly subscriptionsCanPublishIdeas: ReadonlyArray<{ readonly __typename: 'PublishingEntity', readonly id: string, readonly subscriptionType: SubscriptionType | null, readonly slug: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> }> } | { readonly __typename: 'PublicRespondent' } | null };

export type RespondentFeedVariables = Exact<{
  respondentId?: InputMaybe<Scalars['ID']>;
  zipCode?: InputMaybe<Scalars['String']>;
  latLng?: InputMaybe<CoordinateInput>;
  before?: InputMaybe<GqlDateInput>;
  resultLimit?: InputMaybe<Scalars['Int']>;
}>;


export type RespondentFeed = { readonly feed: { readonly __typename: 'RespondentFeed', readonly items: ReadonlyArray<{ readonly __typename: 'RespondentFeedItem', readonly id: string, readonly image: string | null, readonly isPinnedToPublisher: boolean, readonly primaryCallout: string, readonly bottomData: string | null, readonly bottomIcon: BottomIcon | null, readonly badges: ReadonlyArray<{ readonly __typename: 'RespondentFeedItemBadge', readonly type: RespondentFeedItemBadgeType, readonly label: string }>, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly subscriptionType: SubscriptionType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }>, readonly presidingArea: { readonly __typename: 'PresidingArea', readonly id: string, readonly name: string } | null }, readonly topAction: { readonly __typename: 'RespondentFeedItemAction', readonly type: RespondentFeedItemActionType } | null, readonly dotActions: ReadonlyArray<{ readonly __typename: 'RespondentFeedItemAction', readonly type: RespondentFeedItemActionType }>, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly primaryAction: { readonly __typename: 'RespondentFeedItemAction', readonly type: RespondentFeedItemActionType }, readonly secondaryBottomActions: ReadonlyArray<{ readonly __typename: 'RespondentFeedItemAction', readonly type: RespondentFeedItemActionType }>, readonly typedData: { readonly __typename: 'RespondentFeedItemTypedData_BalancingActSimulation', readonly id: string, readonly contentState: RespondentFeedItemStatus, readonly simulationType: string } | { readonly __typename: 'RespondentFeedItemTypedData_Idea', readonly id: string, readonly idea: { readonly __typename: 'Idea', readonly id: string, readonly respondentVote: VoteType, readonly respondent: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly publicName: string } | { readonly __typename: 'PublicRespondent', readonly id: string, readonly publicName: string }, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly aggregations: { readonly __typename: 'IdeaAggregations', readonly voteUp: number, readonly voteDown: number } | null } } | { readonly __typename: 'RespondentFeedItemTypedData_Question', readonly id: string, readonly voted: boolean, readonly acknowledgeOnly: boolean, readonly setSlug: string | null, readonly setId: string, readonly contentState: RespondentFeedItemStatus } | { readonly __typename: 'RespondentFeedItemTypedData_QuestionSet', readonly id: string, readonly slug: string | null, readonly contentType: QuestionSetType, readonly contentState: RespondentFeedItemStatus, readonly shareable: boolean } }> } };

export type RespondentOutcomePageVariables = Exact<{
  publishingEntitySlug: Scalars['String'];
  questionSetSlug: Scalars['String'];
}>;


export type RespondentOutcomePage = { readonly openContentSetBySlug: { readonly __typename: 'GenericContent', readonly id: string, readonly slug: string | null, readonly shareable: boolean, readonly totalRespondents: number | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly publiclyShared: boolean, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly outcome: { readonly __typename: 'Outcome', readonly id: string, readonly text: string, readonly state: ContentOutcomeState } | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> }, readonly image: { readonly __typename: 'QuestionSetImage', readonly id: string, readonly verticalUrl: string, readonly backgroundColor: string } | null } | { readonly __typename: 'PolcoLive', readonly id: string, readonly totalRespondents: number | null, readonly slug: string | null, readonly shareable: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly outcome: { readonly __typename: 'Outcome', readonly id: string, readonly text: string, readonly state: ContentOutcomeState } | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> }, readonly image: { readonly __typename: 'QuestionSetImage', readonly id: string, readonly verticalUrl: string, readonly backgroundColor: string } | null, readonly settings: { readonly __typename: 'PolcoLiveSettings', readonly id: string, readonly liveVideoLink: string | null, readonly eventStartDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly totalRespondents: number | null, readonly slug: string | null, readonly shareable: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly outcome: { readonly __typename: 'Outcome', readonly id: string, readonly text: string, readonly state: ContentOutcomeState } | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> }, readonly image: { readonly __typename: 'QuestionSetImage', readonly id: string, readonly verticalUrl: string, readonly backgroundColor: string } | null } | { readonly __typename: 'Survey', readonly id: string, readonly totalRespondents: number | null, readonly slug: string | null, readonly shareable: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly publiclyShared: boolean, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly outcome: { readonly __typename: 'Outcome', readonly id: string, readonly text: string, readonly state: ContentOutcomeState } | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> }, readonly image: { readonly __typename: 'QuestionSetImage', readonly id: string, readonly verticalUrl: string, readonly backgroundColor: string } | null } | null };

export type RespondentOverviewPageVariables = Exact<{
  publishingEntitySlug: Scalars['String'];
  questionSetSlug: Scalars['String'];
  respondentId?: InputMaybe<Scalars['ID']>;
}>;


export type RespondentOverviewPage = { readonly openContentSetBySlug: { readonly __typename: 'GenericContent', readonly id: string, readonly slug: string | null, readonly shareable: boolean, readonly showConversionPrompts: boolean, readonly outcome: { readonly __typename: 'Outcome', readonly id: string } | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly publiclyShared: boolean, readonly order: number, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly slug: string | null, readonly shareable: boolean, readonly showConversionPrompts: boolean, readonly setForRespondentVote: { readonly __typename: 'RespondentQuestionVoteData', readonly id: string, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly previousVote: { readonly __typename: 'Vote', readonly id: string } | null }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> }, readonly outcome: { readonly __typename: 'Outcome', readonly id: string } | null } | { readonly __typename: 'QuestionSet', readonly id: string, readonly slug: string | null, readonly shareable: boolean, readonly showConversionPrompts: boolean, readonly setForRespondentVote: { readonly __typename: 'RespondentQuestionVoteData', readonly id: string, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly previousVote: { readonly __typename: 'Vote', readonly id: string } | null }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> }, readonly outcome: { readonly __typename: 'Outcome', readonly id: string } | null } | { readonly __typename: 'Survey', readonly id: string, readonly slug: string | null, readonly shareable: boolean, readonly showConversionPrompts: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly reportTabs: ReadonlyArray<{ readonly __typename: 'ReportTab', readonly id: string, readonly title: string, readonly publiclyShared: boolean, readonly order: number, readonly content: { readonly __typename: 'ReportTabContent', readonly type: ReportTabContentType, readonly HTML: string | null, readonly TABLEAU: string | null, readonly height: number | null } }> | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> }, readonly outcome: { readonly __typename: 'Outcome', readonly id: string } | null } | null };

export type RespondentPolcoLiveBaseVariables = Exact<{
  publishingEntitySlug: Scalars['String'];
  questionSetSlug: Scalars['String'];
  respondentId?: InputMaybe<Scalars['ID']>;
}>;


export type RespondentPolcoLiveBase = { readonly openContentSetBySlug: { readonly __typename: 'GenericContent', readonly id: string } | { readonly __typename: 'PolcoLive', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly settings: { readonly __typename: 'PolcoLiveSettings', readonly id: string, readonly liveVideoLink: string | null }, readonly setForRespondentVote: { readonly __typename: 'RespondentQuestionVoteData', readonly id: string, readonly status: RespondentsSetStatus, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly previousVote: { readonly __typename: 'Vote', readonly id: string } | null, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } }> } } | { readonly __typename: 'QuestionSet', readonly id: string } | { readonly __typename: 'Survey', readonly id: string } | null, readonly contextPublishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }>, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | null };

export type RespondentProfileVariables = Exact<{
  respondentId: Scalars['ID'];
}>;


export type RespondentProfile = { readonly openRespondent: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly postAnonymously: boolean, readonly avatarUrl: string | null, readonly zipCode: string | null, readonly inputtedLat: number | null, readonly inputtedLon: number | null, readonly email: string | null, readonly verified: boolean, readonly emailSettings: { readonly __typename: 'UserEmailSettings', readonly id: string, readonly weeklyEmailEnabled: boolean, readonly outreachEmailEnabled: boolean, readonly outcomeEmailEnabled: boolean } | null } | { readonly __typename: 'PublicRespondent' } | null };

export type RespondentPublisherProfileVariables = Exact<{
  slug: Scalars['String'];
  respondentId?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<GqlDateInput>;
  resultLimit?: InputMaybe<Scalars['Int']>;
}>;


export type RespondentPublisherProfile = { readonly openPublishingEntityBySlug: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly subscriptionType: SubscriptionType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly url: string, readonly type: PublishingEntityAssetType }>, readonly presidingArea: { readonly __typename: 'PresidingArea', readonly id: string, readonly name: string, readonly center: { readonly __typename: 'CoordinateCenter', readonly size: number, readonly coordinate: { readonly __typename: 'Coordinate', readonly lat: number, readonly lng: number } } } | null, readonly publisherFeed: { readonly __typename: 'RespondentFeed', readonly items: ReadonlyArray<{ readonly __typename: 'RespondentFeedItem', readonly id: string, readonly image: string | null, readonly isPinnedToPublisher: boolean, readonly primaryCallout: string, readonly bottomData: string | null, readonly bottomIcon: BottomIcon | null, readonly badges: ReadonlyArray<{ readonly __typename: 'RespondentFeedItemBadge', readonly type: RespondentFeedItemBadgeType, readonly label: string }>, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly subscriptionType: SubscriptionType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }>, readonly presidingArea: { readonly __typename: 'PresidingArea', readonly id: string, readonly name: string } | null }, readonly topAction: { readonly __typename: 'RespondentFeedItemAction', readonly type: RespondentFeedItemActionType } | null, readonly dotActions: ReadonlyArray<{ readonly __typename: 'RespondentFeedItemAction', readonly type: RespondentFeedItemActionType }>, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly primaryAction: { readonly __typename: 'RespondentFeedItemAction', readonly type: RespondentFeedItemActionType }, readonly secondaryBottomActions: ReadonlyArray<{ readonly __typename: 'RespondentFeedItemAction', readonly type: RespondentFeedItemActionType }>, readonly typedData: { readonly __typename: 'RespondentFeedItemTypedData_BalancingActSimulation', readonly id: string, readonly contentState: RespondentFeedItemStatus, readonly simulationType: string } | { readonly __typename: 'RespondentFeedItemTypedData_Idea', readonly id: string, readonly idea: { readonly __typename: 'Idea', readonly id: string, readonly respondentVote: VoteType, readonly respondent: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly publicName: string } | { readonly __typename: 'PublicRespondent', readonly id: string, readonly publicName: string }, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly aggregations: { readonly __typename: 'IdeaAggregations', readonly voteUp: number, readonly voteDown: number } | null } } | { readonly __typename: 'RespondentFeedItemTypedData_Question', readonly id: string, readonly voted: boolean, readonly acknowledgeOnly: boolean, readonly setSlug: string | null, readonly setId: string, readonly contentState: RespondentFeedItemStatus } | { readonly __typename: 'RespondentFeedItemTypedData_QuestionSet', readonly id: string, readonly slug: string | null, readonly contentType: QuestionSetType, readonly contentState: RespondentFeedItemStatus, readonly shareable: boolean } }> } } | null };

export type RespondentSubscribablePublishersVariables = Exact<{
  respondentId?: InputMaybe<Scalars['ID']>;
}>;


export type RespondentSubscribablePublishers = { readonly openSubscribablePublishers: ReadonlyArray<{ readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> }> };

export type RespondentSubscriptionsVariables = Exact<{
  respondentId: Scalars['ID'];
}>;


export type RespondentSubscriptions = { readonly openRespondent: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly subscriptions: ReadonlyArray<{ readonly __typename: 'PublishingEntity', readonly id: string, readonly subscriptionType: SubscriptionType | null, readonly slug: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> }> } | { readonly __typename: 'PublicRespondent' } | null };

export type RespondentVotingPageVariables = Exact<{
  publishingEntitySlug: Scalars['String'];
  questionSetSlug: Scalars['String'];
  respondentId?: InputMaybe<Scalars['ID']>;
  areaMode?: InputMaybe<TrackAreaMode>;
  comparisonGroupId?: InputMaybe<Scalars['ID']>;
  fipsCodes?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type RespondentVotingPage = { readonly openContentSetBySlug: { readonly __typename: 'GenericContent', readonly id: string, readonly slug: string | null, readonly shareable: boolean, readonly showConversionPrompts: boolean, readonly allowMultipleResponses: boolean, readonly questionsCount: number, readonly allowGuestRespondents: boolean, readonly estCompletionTime: string, readonly image: { readonly __typename: 'QuestionSetImage', readonly id: string, readonly horizontalUrl: string } | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly subscriptionType: SubscriptionType | null, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }>, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly outcome: { readonly __typename: 'Outcome', readonly id: string, readonly text: string, readonly state: ContentOutcomeState } | null, readonly alternateLanguages: ReadonlyArray<{ readonly __typename: 'Language', readonly id: string, readonly key: string, readonly name: string }>, readonly contents: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly summary: string | null, readonly questionNumber: number | null, readonly optional: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly includeComment: boolean, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly demographicAttribute: { readonly __typename: 'DemographicAttribute', readonly id: string, readonly name: string, readonly premium: boolean, readonly owner: { readonly __typename: 'PublishingEntity', readonly id: string } | null } | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly displayName: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly previousVote: { readonly __typename: 'Vote', readonly id: string, readonly voteDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly question: { readonly __typename: 'Question', readonly id: string, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly randomizeChoices: boolean | null } }, readonly choices: ReadonlyArray<{ readonly __typename: 'RespondentQuestionChoice', readonly id: string, readonly allocation: number, readonly questionChoice: { readonly __typename: 'QuestionChoice', readonly id: string } }> | null, readonly comment: { readonly __typename: 'Comment', readonly id: string, readonly comment: string, readonly upvoteCount: number, readonly commenterChoice: { readonly __typename: 'QuestionChoice', readonly id: string } | null } | null, readonly upvotedComments: ReadonlyArray<{ readonly __typename: 'Comment', readonly id: string }> } | null } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly questionNumber: number | null, readonly numColumns: number, readonly nodeType: QuestionHierarchyParentNodeType, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly displayName: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly randomizeChoices: boolean | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly includeComment: boolean, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly displayName: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly previousVote: { readonly __typename: 'Vote', readonly id: string, readonly voteDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly question: { readonly __typename: 'Question', readonly id: string, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly randomizeChoices: boolean | null } }, readonly choices: ReadonlyArray<{ readonly __typename: 'RespondentQuestionChoice', readonly id: string, readonly questionChoice: { readonly __typename: 'QuestionChoice', readonly id: string } }> | null, readonly comment: { readonly __typename: 'Comment', readonly id: string, readonly comment: string, readonly upvoteCount: number, readonly commenterChoice: { readonly __typename: 'QuestionChoice', readonly id: string } | null } | null, readonly upvotedComments: ReadonlyArray<{ readonly __typename: 'Comment', readonly id: string }> } | null }>, readonly rowContents: ReadonlyArray<{ readonly __typename: 'RowContentHierarchyNodeBaReceipt', readonly id: string, readonly receipt: { readonly __typename: 'BalancingActSimulationWithPubId', readonly id: number, readonly name: string, readonly simulationType: string, readonly publishedAt: { readonly __typename: 'GqlDate', readonly raw: number } } } | { readonly __typename: 'RowContentHierarchyNodeBaSim', readonly id: string, readonly simulation: { readonly __typename: 'BalancingActSimulationWithPubId', readonly id: number, readonly name: string, readonly simulationType: string, readonly prioritization: boolean, readonly publishedAt: { readonly __typename: 'GqlDate', readonly raw: number } } } | { readonly __typename: 'RowContentHierarchyNodePolco', readonly id: string, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'Survey', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } }> } | { readonly __typename: 'QuestionHierarchySimulationNode', readonly id: string, readonly simulationType: SimulationNodeType, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly simulation: { readonly __typename: 'SimulationNodeData', readonly id: number, readonly url: string } | null } | { readonly __typename: 'QuestionHierarchyVisualizationNode', readonly id: string, readonly altLabel: string | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly trackVariableVisualization: { readonly __typename: 'TrackVariableVisualization', readonly id: string, readonly fips: string | null, readonly publishingEntityId: string, readonly benchmarkFilter: BenchmarkFilter, readonly visualizationType: VisualizationType | null, readonly state: SavedVisualizationActivationState, readonly comparisonGroupId: string | null, readonly visualizationAreas: ReadonlyArray<{ readonly __typename: 'FipsArea', readonly id: string, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null }>, readonly plans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }>, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly trackVariables: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } | { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }> } | null }> } | { readonly __typename: 'PolcoLive', readonly allowGuestRespondents: boolean, readonly id: string, readonly totalRespondents: number | null, readonly slug: string | null, readonly shareable: boolean, readonly showConversionPrompts: boolean, readonly allowMultipleResponses: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly outcome: { readonly __typename: 'Outcome', readonly id: string, readonly text: string, readonly state: ContentOutcomeState } | null, readonly setForRespondentVote: { readonly __typename: 'RespondentQuestionVoteData', readonly id: string, readonly status: RespondentsSetStatus, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly previousVote: { readonly __typename: 'Vote', readonly id: string, readonly voteDate: { readonly __typename: 'GqlDate', readonly raw: number } } | null, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly subscriptionType: SubscriptionType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly image: { readonly __typename: 'QuestionSetImage', readonly id: string, readonly verticalUrl: string, readonly backgroundColor: string, readonly horizontalUrl: string } | null, readonly settings: { readonly __typename: 'PolcoLiveSettings', readonly id: string, readonly liveVideoLink: string | null, readonly eventStartDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } } | { readonly __typename: 'QuestionSet', readonly allowGuestRespondents: boolean, readonly id: string, readonly totalRespondents: number | null, readonly slug: string | null, readonly shareable: boolean, readonly showConversionPrompts: boolean, readonly allowMultipleResponses: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly outcome: { readonly __typename: 'Outcome', readonly id: string, readonly text: string, readonly state: ContentOutcomeState } | null, readonly setForRespondentVote: { readonly __typename: 'RespondentQuestionVoteData', readonly id: string, readonly status: RespondentsSetStatus, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly previousVote: { readonly __typename: 'Vote', readonly id: string, readonly voteDate: { readonly __typename: 'GqlDate', readonly raw: number } } | null, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } }> }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly subscriptionType: SubscriptionType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly image: { readonly __typename: 'QuestionSetImage', readonly id: string, readonly verticalUrl: string, readonly backgroundColor: string, readonly horizontalUrl: string } | null } | { readonly __typename: 'Survey', readonly id: string, readonly questionsCount: number, readonly allowGuestRespondents: boolean, readonly estCompletionTime: string, readonly slug: string | null, readonly shareable: boolean, readonly showConversionPrompts: boolean, readonly allowMultipleResponses: boolean, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly subscriptionType: SubscriptionType | null, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }>, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly outcome: { readonly __typename: 'Outcome', readonly id: string, readonly text: string, readonly state: ContentOutcomeState } | null, readonly alternateLanguages: ReadonlyArray<{ readonly __typename: 'Language', readonly id: string, readonly key: string, readonly name: string }>, readonly contents: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly summary: string | null, readonly questionNumber: number | null, readonly optional: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly includeComment: boolean, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly demographicAttribute: { readonly __typename: 'DemographicAttribute', readonly id: string, readonly name: string, readonly premium: boolean, readonly owner: { readonly __typename: 'PublishingEntity', readonly id: string } | null } | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly displayName: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly previousVote: { readonly __typename: 'Vote', readonly id: string, readonly voteDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly question: { readonly __typename: 'Question', readonly id: string, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly randomizeChoices: boolean | null } }, readonly choices: ReadonlyArray<{ readonly __typename: 'RespondentQuestionChoice', readonly id: string, readonly allocation: number, readonly questionChoice: { readonly __typename: 'QuestionChoice', readonly id: string } }> | null, readonly comment: { readonly __typename: 'Comment', readonly id: string, readonly comment: string, readonly upvoteCount: number, readonly commenterChoice: { readonly __typename: 'QuestionChoice', readonly id: string } | null } | null, readonly upvotedComments: ReadonlyArray<{ readonly __typename: 'Comment', readonly id: string }> } | null } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly questionNumber: number | null, readonly numColumns: number, readonly nodeType: QuestionHierarchyParentNodeType, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly displayName: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly optional: boolean, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly randomizeChoices: boolean | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly includeComment: boolean, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }>, readonly sharedChoiceSetData: { readonly __typename: 'ShareableQuestionChoiceSet', readonly id: string } | null }, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly displayName: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly previousVote: { readonly __typename: 'Vote', readonly id: string, readonly voteDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly question: { readonly __typename: 'Question', readonly id: string, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly randomizeChoices: boolean | null } }, readonly choices: ReadonlyArray<{ readonly __typename: 'RespondentQuestionChoice', readonly id: string, readonly questionChoice: { readonly __typename: 'QuestionChoice', readonly id: string } }> | null, readonly comment: { readonly __typename: 'Comment', readonly id: string, readonly comment: string, readonly upvoteCount: number, readonly commenterChoice: { readonly __typename: 'QuestionChoice', readonly id: string } | null } | null, readonly upvotedComments: ReadonlyArray<{ readonly __typename: 'Comment', readonly id: string }> } | null }>, readonly rowContents: ReadonlyArray<{ readonly __typename: 'RowContentHierarchyNodeBaReceipt', readonly id: string, readonly receipt: { readonly __typename: 'BalancingActSimulationWithPubId', readonly id: number, readonly name: string, readonly simulationType: string, readonly publishedAt: { readonly __typename: 'GqlDate', readonly raw: number } } } | { readonly __typename: 'RowContentHierarchyNodeBaSim', readonly id: string, readonly simulation: { readonly __typename: 'BalancingActSimulationWithPubId', readonly id: number, readonly name: string, readonly simulationType: string, readonly prioritization: boolean, readonly publishedAt: { readonly __typename: 'GqlDate', readonly raw: number } } } | { readonly __typename: 'RowContentHierarchyNodePolco', readonly id: string, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } | { readonly __typename: 'Survey', readonly id: string, readonly featureSetType: QuestionSetFeatureSetType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly image: { readonly __typename: 'QuestionSetImage', readonly horizontalUrl: string } | null, readonly createDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string } } }> } | { readonly __typename: 'QuestionHierarchySimulationNode', readonly id: string, readonly simulationType: SimulationNodeType, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly simulation: { readonly __typename: 'SimulationNodeData', readonly id: number, readonly url: string } | null } | { readonly __typename: 'QuestionHierarchyVisualizationNode', readonly id: string, readonly altLabel: string | null, readonly conditions: { readonly __typename: 'ConditionalLogic', readonly metaConditions: ReadonlyArray<{ readonly __typename: 'MetaCondition', readonly id: string, readonly childMetaConditionIds: ReadonlyArray<string>, readonly combinationOperator: MetaConditionCombinationOperator, readonly displayName: string }>, readonly questionChoiceConditions: ReadonlyArray<{ readonly __typename: 'QuestionChoiceCondition', readonly id: string, readonly metaConditionId: string, readonly questionId: string, readonly questionChoiceId: string }> }, readonly trackVariableVisualization: { readonly __typename: 'TrackVariableVisualization', readonly id: string, readonly fips: string | null, readonly publishingEntityId: string, readonly benchmarkFilter: BenchmarkFilter, readonly visualizationType: VisualizationType | null, readonly state: SavedVisualizationActivationState, readonly comparisonGroupId: string | null, readonly visualizationAreas: ReadonlyArray<{ readonly __typename: 'FipsArea', readonly id: string, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null }>, readonly plans: ReadonlyArray<{ readonly __typename: 'StrategicPlan', readonly id: string, readonly goals: ReadonlyArray<{ readonly __typename: 'Goal', readonly id: string, readonly value: number, readonly variable: { readonly __typename: 'TrackVariable', readonly id: string } }> }>, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly trackVariables: ReadonlyArray<{ readonly __typename: 'TrackVariable', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }>, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }> } | { readonly __typename: 'TrackVariableWithDistributions', readonly id: string, readonly name: string, readonly label: string, readonly description: string | null, readonly includedInIndex: boolean, readonly suffix: string | null, readonly statisticType: StatisticType, readonly source: string | null, readonly valueType: AnalyticsValueType, readonly dateLevel: DateLevel, readonly direction: TrackVariableDirection | null, readonly isOA: boolean, readonly isDefault: boolean, readonly demographicSegment: VariableDemographicSegment, readonly areasData: ReadonlyArray<{ readonly __typename: 'TrackAreaData', readonly area: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly performanceData: ReadonlyArray<{ readonly __typename: 'TrackPerformanceDatum', readonly id: string, readonly value: number, readonly distributions: ReadonlyArray<{ readonly __typename: 'PerformanceDatumDistribution', readonly id: string, readonly geoType: FipsAreaType, readonly benchmarkFilter: BenchmarkFilter, readonly comparisonGroup: { readonly __typename: 'ComparisonGroup', readonly id: string } | null, readonly bins: ReadonlyArray<{ readonly __typename: 'DistributionBin', readonly id: string, readonly percentile: number, readonly percentValue: number, readonly count: number | null }> }>, readonly benchmarkValues: ReadonlyArray<{ readonly __typename: 'AnalyticsBenchmark', readonly value: AnalyticsBenchmarkValue, readonly filter: BenchmarkFilter, readonly percentileBucketIndex: number | null }>, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly previousValue: { readonly __typename: 'PerformanceDatumPreviousValue', readonly id: string, readonly value: number, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } } | null }>, readonly arPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }>, readonly gpalPredictiveData: ReadonlyArray<{ readonly __typename: 'PredictivePerformanceDatum', readonly id: string, readonly value: number, readonly fipsArea: { readonly __typename: 'FipsArea', readonly id: string, readonly name: string, readonly type: FipsAreaType | null, readonly shortName: string | null }, readonly recordedAt: { readonly __typename: 'GqlDate', readonly raw: number } }> }>, readonly domains: ReadonlyArray<{ readonly __typename: 'AnalyticsDomainType', readonly domain: AnalyticsDomain, readonly subdomain: AnalyticsSubdomain | null }> }> } | null }>, readonly image: { readonly __typename: 'QuestionSetImage', readonly id: string, readonly horizontalUrl: string } | null } | null, readonly contextPublishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly subscriptionType: SubscriptionType | null, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }>, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | null };

export type SuperAdminAiAssistantSessionSummariesVariables = Exact<{
  sortBy?: InputMaybe<AiAssistantSessionSortType>;
  sortOrder?: InputMaybe<SortOrder>;
  filterAssistantName?: InputMaybe<Scalars['String']>;
  filterPolcoAssistantId?: InputMaybe<Scalars['String']>;
}>;


export type SuperAdminAiAssistantSessionSummaries = { readonly superAdminAiAssistantSessions: ReadonlyArray<{ readonly __typename: 'AiAssistantSession', readonly id: string, readonly summary: { readonly __typename: 'AiAssistantSessionSummary', readonly assistantName: string | null, readonly polcoAssistantId: string | null, readonly numberOfQueries: number, readonly userEmail: string | null, readonly sessionStartAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string } } | null }> };

export type SuperAdminAllBenchmarkReportRequestsVariables = Exact<{ [key: string]: never; }>;


export type SuperAdminAllBenchmarkReportRequests = { readonly superAdminBenchmarkReportRequests: ReadonlyArray<{ readonly __typename: 'BenchmarkReportRequest', readonly id: string, readonly status: BenchmarkReportRequestStatus, readonly benchmarkSurveyType: BenchmarkSurveyTypes, readonly reportDueAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }> };

export type SuperAdminAllPublishersVariables = Exact<{
  filter?: InputMaybe<Scalars['String']>;
}>;


export type SuperAdminAllPublishers = { readonly superAdminAllPublishers: ReadonlyArray<{ readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly approvalDecision: PublishingEntityApprovalDecision, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly presidingArea: { readonly __typename: 'PresidingArea', readonly id: string, readonly name: string } | null, readonly organizationType: { readonly __typename: 'PublishingEntityOrganizationType', readonly id: string, readonly displayName: string } | null }> };

export type SuperAdminAllSuperAdminsVariables = Exact<{ [key: string]: never; }>;


export type SuperAdminAllSuperAdmins = { readonly superAdminAllSuperAdmins: ReadonlyArray<{ readonly __typename: 'User', readonly id: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly name: string, readonly email: string, readonly user: { readonly __typename: 'User', readonly id: string } } | { readonly __typename: 'PublicAdmin' } | null }> };

export type SuperAdminBenchmarkDataDictionaryVariables = Exact<{
  contentSetId: Scalars['ID'];
  reportRequestId: Scalars['ID'];
}>;


export type SuperAdminBenchmarkDataDictionary = { readonly openContentSetById: { readonly __typename: 'GenericContent' } | { readonly __typename: 'PolcoLive' } | { readonly __typename: 'QuestionSet' } | { readonly __typename: 'Survey', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly contents: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly variableName: string | null, readonly reportDisplayLabel: string | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly maxSelection: number, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleThreshold: number, readonly scaleType: ScaleType } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }> }, readonly dataDictionary: { readonly __typename: 'QuestionDataDictionary', readonly benchmarkArea: string | null, readonly weightingLabel: string | null } | null } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly variableName: string | null, readonly reportDisplayLabel: string | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly maxSelection: number, readonly scaleData: { readonly __typename: 'ScaleData', readonly scaleThreshold: number, readonly scaleType: ScaleType } | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }> }, readonly dataDictionary: { readonly __typename: 'QuestionDataDictionary', readonly benchmarkArea: string | null, readonly weightingLabel: string | null } | null }> } | { readonly __typename: 'QuestionHierarchySimulationNode' } | { readonly __typename: 'QuestionHierarchyVisualizationNode' }> } | null };

export type SuperAdminBenchmarkPdfsVariables = Exact<{
  filter: Scalars['String'];
}>;


export type SuperAdminBenchmarkPdfs = { readonly superAdminBenchmarkPdfs: ReadonlyArray<{ readonly __typename: 'PdfDataResult', readonly publisherName: string, readonly publisherSlug: string, readonly error: string | null, readonly survey: { readonly __typename: 'Survey', readonly id: string, readonly slug: string | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly pdfData: { readonly __typename: 'PdfData', readonly uploadUrl: string | null, readonly status: ReportGenerationStatus | null, readonly lastModified: { readonly __typename: 'GqlDate', readonly raw: number } | null } | null }> };

export type SuperAdminBenchmarkReportRequestVariables = Exact<{
  requestId: Scalars['ID'];
}>;


export type SuperAdminBenchmarkReportRequest = { readonly superAdminBenchmarkReportRequestById: { readonly __typename: 'BenchmarkReportRequest', readonly id: string, readonly status: BenchmarkReportRequestStatus, readonly benchmarkSurveyType: BenchmarkSurveyTypes, readonly surveyFormat: SurveyFormat | null, readonly trendsExpected: boolean, readonly expectedTrendYears: string | null, readonly fips: string | null, readonly customBenchmarks: string | null, readonly additionalNotes: string | null, readonly mailedCount: number | null, readonly emailedCount: number | null, readonly eligibleSamplingResponseCount: number | null, readonly responseRate: number | null, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly presidingArea: { readonly __typename: 'PresidingArea', readonly id: string, readonly name: string } | null }, readonly startAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closedAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly clientDueAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly reportDueAt: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly questionSetData: ReadonlyArray<{ readonly __typename: 'BenchmarkReportRequestQuestionSetData', readonly id: string, readonly language: string | null, readonly optIn: boolean, readonly weighted: boolean, readonly contentSet: { readonly __typename: 'GenericContent', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | { readonly __typename: 'Survey', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | null }> | null, readonly areaData: ReadonlyArray<{ readonly __typename: 'BenchmarkReportRequestAreaData', readonly id: string, readonly name: string | null, readonly value: string | null, readonly group: BenchmarkReportRequestAreaGroup | null, readonly weight: number | null }> | null } };

export type SuperAdminContentSetSettingsVariables = Exact<{
  setId: Scalars['ID'];
}>;


export type SuperAdminContentSetSettings = { readonly openContentSetById: { readonly __typename: 'GenericContent', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly shortUrls: ReadonlyArray<{ readonly __typename: 'ShortUrl', readonly id: string, readonly shortUrl: string, readonly fullUrl: string, readonly isPrimary: boolean }>, readonly alternateLanguages: ReadonlyArray<{ readonly __typename: 'Language', readonly id: string, readonly key: string, readonly name: string }> } | { readonly __typename: 'PolcoLive', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly shortUrls: ReadonlyArray<{ readonly __typename: 'ShortUrl', readonly id: string, readonly shortUrl: string, readonly fullUrl: string, readonly isPrimary: boolean }>, readonly alternateLanguages: ReadonlyArray<{ readonly __typename: 'Language', readonly id: string, readonly key: string, readonly name: string }> } | { readonly __typename: 'QuestionSet', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly shortUrls: ReadonlyArray<{ readonly __typename: 'ShortUrl', readonly id: string, readonly shortUrl: string, readonly fullUrl: string, readonly isPrimary: boolean }>, readonly alternateLanguages: ReadonlyArray<{ readonly __typename: 'Language', readonly id: string, readonly key: string, readonly name: string }> } | { readonly __typename: 'Survey', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly schedule: { readonly __typename: 'QuestionSetSchedule', readonly status: QuestionSetStatus }, readonly shortUrls: ReadonlyArray<{ readonly __typename: 'ShortUrl', readonly id: string, readonly shortUrl: string, readonly fullUrl: string, readonly isPrimary: boolean }>, readonly alternateLanguages: ReadonlyArray<{ readonly __typename: 'Language', readonly id: string, readonly key: string, readonly name: string }> } | null };

export type SuperAdminExportTranslationsVariables = Exact<{
  surveyId: Scalars['ID'];
}>;


export type SuperAdminExportTranslations = { readonly openContentSetById: { readonly __typename: 'GenericContent' } | { readonly __typename: 'PolcoLive' } | { readonly __typename: 'QuestionSet' } | { readonly __typename: 'Survey', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly shortDescription: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly contents: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }> } } | { readonly __typename: 'QuestionHierarchyParentNode', readonly id: string, readonly label: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }> } }> } | { readonly __typename: 'QuestionHierarchySimulationNode' } | { readonly __typename: 'QuestionHierarchyVisualizationNode' }> } | null };

export type SuperAdminFilteredPubsVariables = Exact<{
  filter: SuperAdminPublisherFilter;
}>;


export type SuperAdminFilteredPubs = { readonly superAdminFilteredPublishers: ReadonlyArray<{ readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly organizationArea: { readonly __typename: 'PublishingEntityOrganizationArea', readonly id: string, readonly displayName: string } | null, readonly organizationType: { readonly __typename: 'PublishingEntityOrganizationType', readonly id: string, readonly displayName: string } | null }> };

export type SuperAdminPlacesListVariables = Exact<{
  filter: Scalars['String'];
}>;


export type SuperAdminPlacesList = { readonly superAdminCensusPlaces: ReadonlyArray<{ readonly __typename: 'CensusPlace', readonly id: string, readonly name: string, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] }, readonly center: { readonly __typename: 'CoordinateCenter', readonly size: number, readonly coordinate: { readonly __typename: 'Coordinate', readonly lat: number, readonly lng: number } } }> };

export type SuperAdminPublishingEntityConfigurationDashboardVariables = Exact<{
  publishingEntityId: Scalars['ID'];
}>;


export type SuperAdminPublishingEntityConfigurationDashboard = { readonly openPublishingEntityById: { readonly __typename: 'PublishingEntity', readonly id: string, readonly occupiedSeats: number, readonly activeEngageContentCount: number, readonly subscriptionMode: SubscriptionMode, readonly aiAssistantInteractions: { readonly __typename: 'AiAssistantPublisher', readonly publishingEntityId: string, readonly sessionCount: number, readonly queryCount: number } | null, readonly grantWriterAssistantInteractions: { readonly __typename: 'AiAssistantPublisher', readonly publishingEntityId: string, readonly sessionCount: number, readonly queryCount: number } | null, readonly featureSettings: ReadonlyArray<{ readonly __typename: 'PublishingEntityFeatureSetting', readonly id: string, readonly featureSettingId: string, readonly featureSettingName: string, readonly enabled: boolean, readonly quantity: number, readonly isUnlimited: boolean, readonly expirationDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }> | null, readonly managingAdmins: ReadonlyArray<{ readonly __typename: 'PublishingEntityAdmin', readonly id: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly name: string, readonly emailVerificationStatus: EmailVerificationStatus, readonly email: string } | { readonly __typename: 'PublicAdmin' } }> | null, readonly thirdPartyRecords: ReadonlyArray<{ readonly __typename: 'ThirdPartyRecord', readonly id: string, readonly thirdParty: ThirdParty, readonly thirdPartyIdentifier: string }> | null, readonly presidingArea: { readonly __typename: 'PresidingArea', readonly id: string, readonly name: string, readonly center: { readonly __typename: 'CoordinateCenter', readonly size: number, readonly coordinate: { readonly __typename: 'Coordinate', readonly lat: number, readonly lng: number } }, readonly shape: { readonly __typename: 'GeoJsonMultiPolygon', readonly type: string, readonly coordinates: readonly (readonly (readonly (readonly number[])[])[])[] } | null } | null, readonly envisioSetting: { readonly __typename: 'PublishingEntityEnvisioSetting', readonly id: string, readonly magicToken: string, readonly instanceId: string | null } | null } | null, readonly adminOrderedStoreItems: ReadonlyArray<{ readonly __typename: 'PublishingEntityStoreItem', readonly id: string, readonly status: StoreItemPublisherStatus, readonly storeItem: { readonly __typename: 'StoreItem', readonly id: string, readonly name: string } }>, readonly currentUser: { readonly __typename: 'CurrentUser', readonly id: string, readonly user: { readonly __typename: 'User', readonly id: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string } | { readonly __typename: 'PublicAdmin', readonly id: string } | null } | null } };

export type SuperAdminPurchasesVariables = Exact<{ [key: string]: never; }>;


export type SuperAdminPurchases = { readonly superAdminPurchasedStoreItems: ReadonlyArray<{ readonly __typename: 'PurchasedStoreItem', readonly id: string, readonly price: number, readonly status: PurchaseStatusType, readonly purchasedInStripe: boolean, readonly createdAt: { readonly __typename: 'GqlDate', readonly raw: number }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }, readonly storeItem: { readonly __typename: 'StoreItem', readonly id: string, readonly name: string, readonly provider: StoreItemProvider }, readonly purchasedByAdmin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly name: string } | { readonly __typename: 'PublicAdmin', readonly id: string, readonly name: string } }> };

export type SuperAdminRegistrationRequestsVariables = Exact<{ [key: string]: never; }>;


export type SuperAdminRegistrationRequests = { readonly superAdminRegistrationDecisions: ReadonlyArray<{ readonly __typename: 'AdminRegistration', readonly id: string, readonly decision: AdminRegistrationDecision | null, readonly user: { readonly __typename: 'User', readonly id: string, readonly admin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly name: string, readonly email: string } | { readonly __typename: 'PublicAdmin' } | null }, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly activationState: PublishingEntityActivationState, readonly type: { readonly __typename: 'PublishingEntityType', readonly id: string, readonly displayName: string } | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } | null, readonly createdTime: { readonly __typename: 'GqlDate', readonly raw: number }, readonly decidingAdmin: { readonly __typename: 'PrivateAdmin', readonly id: string, readonly name: string } | { readonly __typename: 'PublicAdmin', readonly id: string, readonly name: string } | null, readonly decisionTime: { readonly __typename: 'GqlDate', readonly raw: number } | null }> };

export type VotingVariables = Exact<{
  respondentId?: InputMaybe<Scalars['ID']>;
  questionId: Scalars['ID'];
  pagination?: InputMaybe<PaginationParams>;
}>;


export type Voting = { readonly openQuestion: { readonly __typename: 'Question', readonly id: string, readonly summary: string | null, readonly title: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly questionSet: { readonly __typename: 'GenericContent', readonly id: string, readonly slug: string | null, readonly allowGuestRespondents: boolean, readonly allowMultipleResponses: boolean, readonly showConversionPrompts: boolean, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly subscriptionType: SubscriptionType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> } } | { readonly __typename: 'PolcoLive', readonly id: string, readonly slug: string | null, readonly allowGuestRespondents: boolean, readonly allowMultipleResponses: boolean, readonly showConversionPrompts: boolean, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly subscriptionType: SubscriptionType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> } } | { readonly __typename: 'QuestionSet', readonly id: string, readonly slug: string | null, readonly allowGuestRespondents: boolean, readonly allowMultipleResponses: boolean, readonly showConversionPrompts: boolean, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly subscriptionType: SubscriptionType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> } } | { readonly __typename: 'Survey', readonly id: string, readonly slug: string | null, readonly allowGuestRespondents: boolean, readonly allowMultipleResponses: boolean, readonly showConversionPrompts: boolean, readonly publishingEntity: { readonly __typename: 'PublishingEntity', readonly id: string, readonly slug: string, readonly subscriptionType: SubscriptionType | null, readonly name: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> }, readonly assets: ReadonlyArray<{ readonly __typename: 'PublishingEntityAsset', readonly id: string, readonly type: PublishingEntityAssetType, readonly url: string }> } }, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null }, readonly choiceSet: { readonly __typename: 'QuestionChoiceSet', readonly id: string, readonly type: QuestionType, readonly maxSelection: number, readonly randomizeChoices: boolean | null, readonly choices: ReadonlyArray<{ readonly __typename: 'QuestionChoice', readonly id: string, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } }> }, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly votesCount: number | null, readonly result: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string, readonly choiceValue: number | null, readonly text: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } } }>, readonly description: { readonly __typename: 'MultiLanguageContent', readonly defaultValue: string, readonly alternates: ReadonlyArray<{ readonly __typename: 'LanguageSpecificContent', readonly languageKey: string, readonly value: string }> } | null, readonly commentsData: { readonly __typename: 'CommentsData', readonly totalCount: number, readonly comments: ReadonlyArray<{ readonly __typename: 'Comment', readonly id: string, readonly comment: string, readonly upvoteCount: number, readonly commentDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly commenter: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly avatarUrl: string | null, readonly postAnonymously: boolean } | { readonly __typename: 'PublicRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly avatarUrl: string | null, readonly postAnonymously: boolean }, readonly commenterChoice: { readonly __typename: 'QuestionChoice', readonly id: string } | null }> }, readonly previousVote: { readonly __typename: 'Vote', readonly id: string, readonly choices: ReadonlyArray<{ readonly __typename: 'RespondentQuestionChoice', readonly id: string, readonly allocation: number, readonly questionChoice: { readonly __typename: 'QuestionChoice', readonly id: string } }> | null, readonly comment: { readonly __typename: 'Comment', readonly id: string, readonly comment: string, readonly upvoteCount: number, readonly commentDate: { readonly __typename: 'GqlDate', readonly raw: number } } | null, readonly upvotedComments: ReadonlyArray<{ readonly __typename: 'Comment', readonly id: string }> } | null } | null };

export type LiveContentSetVariables = Exact<{
  contentSetId: Scalars['ID'];
  respondentId?: InputMaybe<Scalars['ID']>;
}>;


export type LiveContentSet = { readonly liveContentSet: { readonly __typename: 'PolcoLive', readonly id: string, readonly setForRespondentVote: { readonly __typename: 'RespondentQuestionVoteData', readonly id: string, readonly status: RespondentsSetStatus, readonly questions: ReadonlyArray<{ readonly __typename: 'Question', readonly id: string, readonly schedule: { readonly __typename: 'QuestionSchedule', readonly status: QuestionStatus, readonly openDate: { readonly __typename: 'GqlDate', readonly raw: number } | null, readonly closeDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } }> }, readonly settings: { readonly __typename: 'PolcoLiveSettings', readonly id: string, readonly eventEndDate: { readonly __typename: 'GqlDate', readonly raw: number } | null } } };

export type QuestionNewCommentVariables = Exact<{
  questionId: Scalars['ID'];
}>;


export type QuestionNewComment = { readonly questionNewComment: { readonly __typename: 'Comment', readonly id: string, readonly comment: string, readonly upvoteCount: number, readonly commentDate: { readonly __typename: 'GqlDate', readonly raw: number }, readonly commenter: { readonly __typename: 'PrivateRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly avatarUrl: string | null, readonly postAnonymously: boolean } | { readonly __typename: 'PublicRespondent', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly avatarUrl: string | null, readonly postAnonymously: boolean }, readonly commenterChoice: { readonly __typename: 'QuestionChoice', readonly id: string } | null } | null };

export type QuestionResultsVariables = Exact<{
  questionId: Scalars['ID'];
}>;


export type QuestionResults = { readonly questionResults: { readonly __typename: 'Question', readonly id: string, readonly results: ReadonlyArray<{ readonly __typename: 'VotingChoice', readonly result: number | null, readonly votesCount: number | null, readonly choice: { readonly __typename: 'QuestionChoice', readonly id: string } }> } };

export const BalancingActReportingCategory = gql`
    fragment BalancingActReportingCategory on BalancingActReportingCategoryBase {
  id
  averageAmountDecreased
  averageAmountIncreased
  averagePercentChange
  averageSessionAmountChanged
  averageSessionDecreased
  averageSessionIncreased
  averageSubmittedAmount
  averageSubmittedAmountChanged
  decreaseClicks
  detailsClicks
  displayOrder
  increaseClicks
  infoClicks
  maxSubmittedAmount
  medianSessionAmountChanged
  medianSubmittedAmountChanged
  modeSessionAmountChanged
  modeSubmittedAmountChanged
  minSubmittedAmount
  name
  percentSubmissionsChanged
  percentSubmissionsDecreased
  percentSubmissionsIncreased
  percentSubmissionsUnchanged
  totalSubmissionsChanged
  totalSubmissionsDecreased
  totalSubmissionsIncreased
  totalSubmissionsUnchanged
}
    `;
export const Breakdown = gql`
    fragment breakdown on StatBreakdown {
  label
  unknownTotal
  values {
    label
    total
  }
}
    `;
export const TrackVariable = gql`
    fragment TrackVariable on TrackVariable {
  id
  name
  label
  description
  domains {
    domain
    subdomain
  }
  includedInIndex
  suffix
  statisticType
  source
  valueType
  dateLevel
  direction
  isOA
  isDefault
  demographicSegment
  areasData(
    areaMode: $areaMode
    comparisonGroupId: $comparisonGroupId
    fipsCodes: $fipsCodes
  ) {
    area {
      id
      name
      type
      shortName
    }
    performanceData {
      id
      value
      benchmarkValues {
        value
        filter
        percentileBucketIndex
      }
      fipsArea {
        id
        name
        type
        shortName
      }
      recordedAt {
        raw
      }
      previousValue {
        id
        value
        recordedAt {
          raw
        }
      }
    }
    arPredictiveData {
      id
      value
      fipsArea {
        id
        name
        type
        shortName
      }
      recordedAt {
        raw
      }
    }
    gpalPredictiveData {
      id
      value
      fipsArea {
        id
        name
        type
        shortName
      }
      recordedAt {
        raw
      }
    }
  }
}
    `;
export const ComparisonGroupTrackDomain = gql`
    fragment ComparisonGroupTrackDomain on TrackDomain {
  id
  domain
  fips
  indexScores(
    historicalDataEntries: $historicalDataEntries
    displayType: $displayType
    areaMode: $areaMode
  ) {
    ...TrackVariable
  }
  indicators(
    includeHierarchicalData: $includeHierarchicalData
    historicalDataEntries: $historicalDataEntries
    displayType: $displayType
    areaMode: $areaMode
  ) {
    ...TrackVariable
  }
}
    ${TrackVariable}`;
export const TrackVariableWithDistribution = gql`
    fragment TrackVariableWithDistribution on TrackVariable {
  ...TrackVariable
  areasData(
    areaMode: $areaMode
    comparisonGroupId: $comparisonGroupId
    fipsCodes: $fipsCodes
  ) {
    area {
      id
      name
      type
      shortName
    }
    performanceData {
      id
      distributions {
        id
        geoType
        benchmarkFilter
        comparisonGroup {
          id
        }
        bins {
          id
          percentile
          percentValue
          count
        }
      }
    }
    arPredictiveData {
      id
      value
      fipsArea {
        id
        name
        type
        shortName
      }
      recordedAt {
        raw
      }
    }
    gpalPredictiveData {
      id
      value
      fipsArea {
        id
        name
        type
        shortName
      }
      recordedAt {
        raw
      }
    }
  }
}
    ${TrackVariable}`;
export const DomainTrackVariables = gql`
    fragment DomainTrackVariables on TrackDomain {
  id
  indexScores(
    historicalDataEntries: $historicalDataEntries
    displayType: $displayType
    areaMode: $areaMode
  ) {
    ...TrackVariableWithDistribution
  }
  sentimentValues(
    historicalDataEntries: $historicalDataEntries
    displayType: $displayType
    areaMode: $areaMode
  ) {
    ...TrackVariable
  }
  indicators(
    includeHierarchicalData: $includeHierarchicalData
    historicalDataEntries: $historicalDataEntries
    displayType: $displayType
    areaMode: $areaMode
  ) {
    ...TrackVariable
  }
}
    ${TrackVariableWithDistribution}
${TrackVariable}`;
export const PerformanceDatum_Variable = gql`
    fragment PerformanceDatum_Variable on AnalyticsVariable {
  __typename
  id
  name
  domains {
    domain
    subdomain
  }
  statisticType
  valueType
  suffix
  label
  description
  source
  dateLevel
  includedInIndex
  direction
  isOA
  isDefault
  demographicSegment
}
    `;
export const Multilang = gql`
    fragment multilang on MultiLanguageContent {
  defaultValue
  alternates {
    languageKey
    value
  }
}
    `;
export const RespondentFeed_Item = gql`
    fragment RespondentFeed_Item on RespondentFeedItem {
  id
  badges {
    type
    label
  }
  publishingEntity {
    id
    name {
      ...multilang
    }
    slug
    assets {
      id
      type
      url
    }
    subscriptionType(respondentId: $respondentId)
    presidingArea {
      id
      name
    }
  }
  topAction {
    type
  }
  dotActions {
    type
  }
  title {
    ...multilang
  }
  shortDescription {
    ...multilang
  }
  image
  isPinnedToPublisher
  primaryCallout
  primaryAction {
    type
  }
  bottomData
  bottomIcon
  secondaryBottomActions {
    type
  }
  typedData {
    __typename
    ... on RespondentFeedItemTypedData_QuestionSet {
      id
      slug
      contentType
      contentState
      shareable
    }
    ... on RespondentFeedItemTypedData_Question {
      id
      voted
      acknowledgeOnly
      setSlug
      setId
      contentState
    }
    ... on RespondentFeedItemTypedData_BalancingActSimulation {
      id
      contentState
      simulationType
    }
    ... on RespondentFeedItemTypedData_Idea {
      id
      idea {
        id
        respondent {
          ... on RespondentBase {
            id
            publicName
          }
        }
        createDate {
          raw
        }
        aggregations {
          voteUp
          voteDown
        }
        respondentVote(respondentId: $respondentId)
      }
    }
  }
}
    ${Multilang}`;
export const RespondentSimulationNode = gql`
    fragment RespondentSimulationNode on QuestionHierarchySimulationNode {
  id
  conditions {
    metaConditions {
      id
      childMetaConditionIds
      combinationOperator
      displayName
    }
    questionChoiceConditions {
      id
      metaConditionId
      questionId
      questionChoiceId
    }
  }
  simulationType
  simulation {
    id
    url
  }
}
    `;
export const RowContentHierarchyNodes = gql`
    fragment RowContentHierarchyNodes on QuestionHierarchyParentNode {
  rowContents {
    ... on RowContentHierarchyNodePolco {
      id
      questionSet {
        ... on ContentSetBase {
          id
          name {
            ...multilang
          }
          shortDescription {
            ...multilang
          }
          image {
            horizontalUrl
          }
          featureSetType
          createDate {
            raw
          }
          schedule {
            status
          }
          publishingEntity {
            id
            slug
          }
        }
      }
    }
    ... on RowContentHierarchyNodeBaSim {
      id
      simulation {
        id
        name
        simulationType
        prioritization
        publishedAt {
          raw
        }
      }
    }
    ... on RowContentHierarchyNodeBaReceipt {
      id
      receipt {
        id
        name
        simulationType
        publishedAt {
          raw
        }
      }
    }
  }
}
    ${Multilang}`;
export const SimulationCategory = gql`
    fragment SimulationCategory on SimulationCategory {
  id
  name
  type
  displayOrder
  isLocked
  details
  subcategories {
    id
    name
    displayOrder
    amount
    details
    isLocked
    inTour
  }
}
    `;
export const StatBreakdownLocation = gql`
    fragment StatBreakdownLocation on StatBreakdownLocation {
  center {
    size
    coordinate {
      lat
      lng
    }
  }
  values {
    key
    shape {
      type
      coordinates
    }
    total
  }
}
    `;
export const TrendAggregateResult = gql`
    fragment TrendAggregateResult on TrendAggregateResult {
  value
  historicalDataPoints {
    date {
      raw
    }
    scalePercent
    averageChoiceValueData {
      averageChoiceValue
      scaleName
    }
    value
  }
  trendSignificance
}
    `;
export const AggregateResults = gql`
    fragment AggregateResults on AggregateResults {
  choices {
    choice {
      id
      text {
        ...multilang
      }
      choiceValue
    }
    rawTotal
    weightedTotal
  }
  scaleData {
    scaleType
    scaleThreshold
    alternateScaleName
  }
  averageChoiceValueData {
    averageChoiceValue
    scaleName
  }
  aggregateValue
  trend {
    value
    historicalDataPoints {
      date {
        raw
      }
      scalePercent
      averageChoiceValueData {
        averageChoiceValue
        scaleName
      }
      value
    }
    trendSignificance
  }
  benchmark {
    value
    rank
    totalDataPoints
    dateRange {
      start {
        raw
      }
      end {
        raw
      }
    }
    benchmarkSignificance
  }
  topic
  category
}
    ${Multilang}`;
export const Crosstab_QuestionResults = gql`
    fragment Crosstab_QuestionResults on CrosstabQuestionResults {
  question {
    id
    questionNumber
    title {
      ...multilang
    }
    description {
      ...multilang
    }
    isBenchmarkedQuestion
    choiceSet {
      id
      type
      scaleData {
        scaleType
        scaleThreshold
        alternateScaleName
      }
    }
    hierarchyParentNode {
      id
      label {
        ...multilang
      }
    }
    questionSet {
      ... on ContentSetBase {
        id
        schedule {
          status
          openDate {
            raw
          }
          closeDate {
            raw
          }
        }
        publishingEntity {
          id
          name {
            ...multilang
          }
        }
      }
    }
    aggregateResults {
      ...AggregateResults
    }
    commentsData {
      totalCount
    }
    commentsWordCount {
      value
      text
    }
  }
  results {
    crosstabGroup {
      label
    }
    value
    statisticalDifferences {
      label
    }
  }
}
    ${Multilang}
${AggregateResults}`;
export const SurveyBenchmarkTopic = gql`
    fragment SurveyBenchmarkTopic on SurveyBenchmarkTopic {
  id
  topic {
    id
    name
    icon
    description
    trackDomain
    category {
      id
      name
      priority
    }
  }
}
    `;
export const TopicDetails = gql`
    fragment topicDetails on SurveyBenchmarkTopic {
  ...SurveyBenchmarkTopic
  importance: qualitativeQuestion(qualitativeTopic: IMPORTANCE) {
    id
    aggregateResults {
      aggregateValue
      trend {
        value
      }
      benchmark {
        value
      }
    }
  }
  quality: qualitativeQuestion(qualitativeTopic: QUALITY) {
    id
    aggregateResults {
      aggregateValue
      trend {
        historicalDataPoints {
          date {
            raw
          }
        }
        value
      }
      benchmark {
        value
      }
    }
  }
}
    ${SurveyBenchmarkTopic}`;
export const ContentSetAndShareable = gql`
    fragment ContentSetAndShareable on ContentSetBase {
  id
  __typename
  name {
    ...multilang
  }
  shortDescription {
    ...multilang
  }
  featureSetType
  createDate {
    raw
  }
  schedule {
    status
    openDate {
      raw
    }
    closeDate {
      raw
    }
  }
  questionsCount
  publishingEntity {
    id
  }
  shareableContentSet {
    id
    shareType
    order
    adminDescription
    numberOfShares
    domains
    isPaidContent
  }
}
    ${Multilang}`;
export const QuestionResults_Fragment = gql`
    fragment QuestionResults_Fragment on VotingChoice {
  choice {
    id
    text {
      ...multilang
    }
    choiceValue
  }
  votesCount
  result
}
    ${Multilang}`;
export const AdminOpenQuestionSet_QuestionSet = gql`
    fragment AdminOpenQuestionSet_QuestionSet on QuestionSet {
  createdQuestions(status: [PUBLISHED, CLOSED, DRAFT, SCHEDULED, CART, ARCHIVED]) {
    questions {
      id
      title {
        ...multilang
      }
      description {
        ...multilang
      }
      optional
      isBenchmarkedQuestion
      variableName
      choiceSet {
        id
        type
        maxSelection
        randomizeChoices
        scaleData {
          scaleType
          scaleThreshold
        }
        choices {
          id
          text {
            ...multilang
          }
          choiceValue
        }
        sharedChoiceSetData {
          id
        }
      }
      results(filter: $filter) {
        ...QuestionResults_Fragment
      }
      commentsWordCount {
        value
        text
      }
      schedule {
        status
        openDate {
          raw
        }
        closeDate {
          raw
        }
      }
      totalVotesCount(filter: $filter)
      commentsData(filter: $commentFilter) {
        totalCount
      }
      questionSet {
        ... on ContentSetBase {
          __typename
          id
        }
      }
    }
    pagination {
      totalCount
    }
  }
}
    ${Multilang}
${QuestionResults_Fragment}`;
export const AdminOpenQuestionSet_PolcoLive = gql`
    fragment AdminOpenQuestionSet_PolcoLive on PolcoLive {
  settings {
    id
    eventStartDate {
      raw
    }
    eventEndDate {
      raw
    }
    liveVideoLink
    state
  }
  shortId
  createdQuestions(status: [PUBLISHED, CLOSED, DRAFT, SCHEDULED, CART]) {
    questions {
      id
      title {
        ...multilang
      }
      description {
        ...multilang
      }
      optional
      variableName
      choiceSet {
        id
        type
        maxSelection
        randomizeChoices
        scaleData {
          scaleType
          scaleThreshold
        }
        choices {
          id
          text {
            ...multilang
          }
          choiceValue
        }
        sharedChoiceSetData {
          id
        }
      }
      results(filter: $filter) {
        ...QuestionResults_Fragment
      }
      commentsWordCount {
        value
        text
      }
      schedule {
        status
        openDate {
          raw
        }
        closeDate {
          raw
        }
      }
      totalVotesCount
      commentsData(filter: $commentFilter) {
        totalCount
      }
      questionSet {
        ... on ContentSetBase {
          __typename
          id
        }
      }
    }
    pagination {
      totalCount
    }
  }
}
    ${Multilang}
${QuestionResults_Fragment}`;
export const TrackVariables = gql`
    fragment TrackVariables on TrackVariableWithDistributions {
  id
  name
  label
  description
  domains {
    domain
    subdomain
  }
  includedInIndex
  suffix
  statisticType
  source
  valueType
  dateLevel
  direction
  isOA
  isDefault
  demographicSegment
  areasData {
    area {
      id
      name
      type
      shortName
    }
    performanceData {
      id
      value
      benchmarkValues {
        value
        filter
        percentileBucketIndex
      }
      fipsArea {
        id
        name
        type
        shortName
      }
      recordedAt {
        raw
      }
      previousValue {
        id
        value
        recordedAt {
          raw
        }
      }
    }
  }
}
    `;
export const TrackVariableWithDistributions = gql`
    fragment TrackVariableWithDistributions on TrackVariableWithDistributions {
  ...TrackVariables
  areasData {
    area {
      id
      name
      type
      shortName
    }
    performanceData {
      id
      distributions {
        id
        geoType
        benchmarkFilter
        comparisonGroup {
          id
        }
        bins {
          id
          percentile
          percentValue
          count
        }
      }
    }
    arPredictiveData {
      id
      value
      fipsArea {
        id
        name
        type
        shortName
      }
      recordedAt {
        raw
      }
    }
    gpalPredictiveData {
      id
      value
      fipsArea {
        id
        name
        type
        shortName
      }
      recordedAt {
        raw
      }
    }
  }
}
    ${TrackVariables}`;
export const TrackVisualization = gql`
    fragment TrackVisualization on TrackVariableVisualization {
  __typename
  id
  fips
  publishingEntityId
  benchmarkFilter
  visualizationType
  state
  recordedAt {
    raw
  }
  comparisonGroupId
  trackVariables {
    ... on TrackVariable {
      ...TrackVariable
    }
    ... on TrackVariableWithDistributions {
      ...TrackVariableWithDistributions
    }
  }
}
    ${TrackVariable}
${TrackVariableWithDistributions}`;
export const StrategicPlan = gql`
    fragment StrategicPlan on StrategicPlan {
  id
  goals {
    id
    variable {
      id
    }
    value
  }
}
    `;
export const VisualizationNode = gql`
    fragment VisualizationNode on QuestionHierarchyVisualizationNode {
  id
  conditions {
    metaConditions {
      id
      childMetaConditionIds
      combinationOperator
      displayName
    }
    questionChoiceConditions {
      id
      metaConditionId
      questionId
      questionChoiceId
    }
  }
  trackVariableVisualization {
    ...TrackVisualization
    visualizationAreas {
      id
      shape {
        type
        coordinates
      }
    }
    plans {
      ...StrategicPlan
    }
  }
  altLabel
}
    ${TrackVisualization}
${StrategicPlan}`;
export const AdminSimulationNode = gql`
    fragment AdminSimulationNode on QuestionHierarchySimulationNode {
  id
  conditions {
    metaConditions {
      id
      childMetaConditionIds
      combinationOperator
      displayName
    }
    questionChoiceConditions {
      id
      metaConditionId
      questionId
      questionChoiceId
    }
  }
  simulationType
  simulation {
    id
    adminData {
      name
      description
      prioritization
      simulationType
      status
    }
    url
  }
}
    `;
export const AdminOpenQuestionSet_Survey = gql`
    fragment AdminOpenQuestionSet_Survey on Survey {
  hasAutomaticWeighting
  dimensionGroupDefinitions {
    id
    description
  }
  benchmarkType {
    weighted
  }
  schedule {
    status
    openDate {
      raw
    }
    closeDate {
      raw
    }
  }
  hasVisibleReportTabs
  topics(filter: {type: ALL_NON_QUALITATIVE}) {
    ...SurveyBenchmarkTopic
  }
  contents(filterByTopicIds: $filterByTopicIds) {
    __typename
    ... on Question {
      id
      title {
        ...multilang
      }
      summary
      description {
        ...multilang
      }
      questionNumber
      optional
      isBenchmarkedQuestion
      variableName
      choiceSet {
        id
        type
        maxSelection
        randomizeChoices
        scaleData {
          scaleType
          scaleThreshold
        }
        choices {
          id
          text {
            ...multilang
          }
          choiceValue
        }
        sharedChoiceSetData {
          id
        }
      }
      conditions {
        metaConditions {
          id
          childMetaConditionIds
          combinationOperator
          displayName
        }
        questionChoiceConditions {
          id
          metaConditionId
          questionId
          questionChoiceId
        }
      }
      schedule {
        status
      }
      results(filter: $filter) {
        ...QuestionResults_Fragment
      }
      totalVotesCount
      commentsWordCount {
        text
        value
      }
      commentsData(filter: $commentFilter) {
        totalCount
      }
      questionSet {
        ... on ContentSetBase {
          __typename
          id
        }
      }
    }
    ... on QuestionHierarchyParentNode {
      id
      structureType: type
      label {
        ...multilang
      }
      structureDescription: description {
        ...multilang
      }
      survey {
        id
      }
      questionNumber
      hasBenchmarkedContent
      conditions {
        metaConditions {
          id
          childMetaConditionIds
          combinationOperator
          displayName
        }
        questionChoiceConditions {
          id
          metaConditionId
          questionId
          questionChoiceId
        }
      }
      questions(filterByTopicIds: $filterByTopicIds) {
        __typename
        id
        title {
          ...multilang
        }
        description {
          ...multilang
        }
        optional
        isBenchmarkedQuestion
        variableName
        choiceSet {
          id
          type
          maxSelection
          randomizeChoices
          scaleData {
            scaleType
            scaleThreshold
          }
          choices {
            id
            text {
              ...multilang
            }
            choiceValue
          }
          sharedChoiceSetData {
            id
          }
        }
        results(filter: $filter) {
          ...QuestionResults_Fragment
        }
        schedule {
          status
        }
      }
    }
    ... on QuestionHierarchyVisualizationNode {
      ...VisualizationNode
    }
    ... on QuestionHierarchySimulationNode {
      ...AdminSimulationNode
    }
  }
}
    ${SurveyBenchmarkTopic}
${Multilang}
${QuestionResults_Fragment}
${VisualizationNode}
${AdminSimulationNode}`;
export const AdminOpenQuestionSet_Generic = gql`
    fragment AdminOpenQuestionSet_Generic on GenericContent {
  hasAutomaticWeighting
  dimensionGroupDefinitions {
    id
    description
  }
  benchmarkType {
    weighted
  }
  schedule {
    status
    openDate {
      raw
    }
    closeDate {
      raw
    }
  }
  topics(filter: {type: ALL_NON_QUALITATIVE}) {
    ...SurveyBenchmarkTopic
  }
  contents(filterByTopicIds: $filterByTopicIds) {
    __typename
    ... on Question {
      id
      title {
        ...multilang
      }
      summary
      description {
        ...multilang
      }
      questionNumber
      optional
      isBenchmarkedQuestion
      variableName
      choiceSet {
        id
        type
        maxSelection
        randomizeChoices
        scaleData {
          scaleType
          scaleThreshold
        }
        choices {
          id
          text {
            ...multilang
          }
          choiceValue
        }
        sharedChoiceSetData {
          id
        }
      }
      conditions {
        metaConditions {
          id
          childMetaConditionIds
          combinationOperator
          displayName
        }
        questionChoiceConditions {
          id
          metaConditionId
          questionId
          questionChoiceId
        }
      }
      schedule {
        status
      }
      results(filter: $filter) {
        ...QuestionResults_Fragment
      }
      totalVotesCount
      commentsWordCount {
        text
        value
      }
      commentsData(filter: $commentFilter) {
        totalCount
      }
      questionSet {
        ... on ContentSetBase {
          __typename
          id
        }
      }
    }
    ... on QuestionHierarchyParentNode {
      id
      structureType: type
      label {
        ...multilang
      }
      structureDescription: description {
        ...multilang
      }
      survey {
        id
      }
      questionNumber
      hasBenchmarkedContent
      conditions {
        metaConditions {
          id
          childMetaConditionIds
          combinationOperator
          displayName
        }
        questionChoiceConditions {
          id
          metaConditionId
          questionId
          questionChoiceId
        }
      }
      questions(filterByTopicIds: $filterByTopicIds) {
        __typename
        id
        title {
          ...multilang
        }
        description {
          ...multilang
        }
        optional
        isBenchmarkedQuestion
        variableName
        choiceSet {
          id
          type
          maxSelection
          randomizeChoices
          scaleData {
            scaleType
            scaleThreshold
          }
          choices {
            id
            text {
              ...multilang
            }
            choiceValue
          }
          sharedChoiceSetData {
            id
          }
        }
        results(filter: $filter) {
          ...QuestionResults_Fragment
        }
        schedule {
          status
        }
      }
    }
    ... on QuestionHierarchyVisualizationNode {
      ...VisualizationNode
    }
    ... on QuestionHierarchySimulationNode {
      ...AdminSimulationNode
    }
  }
}
    ${SurveyBenchmarkTopic}
${Multilang}
${QuestionResults_Fragment}
${VisualizationNode}
${AdminSimulationNode}`;
export const AddAdminToPublishingEntityDocument = gql`
    mutation AddAdminToPublishingEntity($publishingEntityId: ID!, $adminEmail: String!, $adminName: String!, $roleId: ID) {
  addAdminToPublishingEntity(
    publishingEntityId: $publishingEntityId
    adminEmail: $adminEmail
    adminName: $adminName
    roleId: $roleId
  ) {
    id
    managingAdmins {
      id
      admin {
        __typename
        ... on AdminBase {
          id
          name
        }
        ... on PrivateAdmin {
          email
        }
      }
      roleId
    }
  }
}
    `;
export type AddAdminToPublishingEntityMutationFn = Apollo.MutationFunction<AddAdminToPublishingEntity, AddAdminToPublishingEntityVariables>;

/**
 * __useAddAdminToPublishingEntity__
 *
 * To run a mutation, you first call `useAddAdminToPublishingEntity` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAdminToPublishingEntity` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAdminToPublishingEntity, { data, loading, error }] = useAddAdminToPublishingEntity({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      adminEmail: // value for 'adminEmail'
 *      adminName: // value for 'adminName'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useAddAdminToPublishingEntity(baseOptions?: Apollo.MutationHookOptions<AddAdminToPublishingEntity, AddAdminToPublishingEntityVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAdminToPublishingEntity, AddAdminToPublishingEntityVariables>(AddAdminToPublishingEntityDocument, options);
      }
export type AddAdminToPublishingEntityHookResult = ReturnType<typeof useAddAdminToPublishingEntity>;
export type AddAdminToPublishingEntityMutationResult = Apollo.MutationResult<AddAdminToPublishingEntity>;
export type AddAdminToPublishingEntityMutationOptions = Apollo.BaseMutationOptions<AddAdminToPublishingEntity, AddAdminToPublishingEntityVariables>;
export const AddCommentDocument = gql`
    mutation AddComment($questionId: ID!, $comment: String!) {
  addComment(questionId: $questionId, comment: $comment) {
    id
    comment
    commenter {
      ... on RespondentBase {
        id
      }
    }
    commentDate {
      raw
    }
  }
}
    `;
export type AddCommentMutationFn = Apollo.MutationFunction<AddComment, AddCommentVariables>;

/**
 * __useAddComment__
 *
 * To run a mutation, you first call `useAddComment` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddComment` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addComment, { data, loading, error }] = useAddComment({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAddComment(baseOptions?: Apollo.MutationHookOptions<AddComment, AddCommentVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddComment, AddCommentVariables>(AddCommentDocument, options);
      }
export type AddCommentHookResult = ReturnType<typeof useAddComment>;
export type AddCommentMutationResult = Apollo.MutationResult<AddComment>;
export type AddCommentMutationOptions = Apollo.BaseMutationOptions<AddComment, AddCommentVariables>;
export const AdminAiAssistantCancelProcessingDocument = gql`
    mutation AdminAiAssistantCancelProcessing($sessionId: ID!, $assistant: AssistantIdInput!) {
  adminAiAssistantCancelProcessing(sessionId: $sessionId, assistant: $assistant) {
    id
    queryStatus {
      type
      message
      loadingText
    }
  }
}
    `;
export type AdminAiAssistantCancelProcessingMutationFn = Apollo.MutationFunction<AdminAiAssistantCancelProcessing, AdminAiAssistantCancelProcessingVariables>;

/**
 * __useAdminAiAssistantCancelProcessing__
 *
 * To run a mutation, you first call `useAdminAiAssistantCancelProcessing` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAiAssistantCancelProcessing` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAiAssistantCancelProcessing, { data, loading, error }] = useAdminAiAssistantCancelProcessing({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      assistant: // value for 'assistant'
 *   },
 * });
 */
export function useAdminAiAssistantCancelProcessing(baseOptions?: Apollo.MutationHookOptions<AdminAiAssistantCancelProcessing, AdminAiAssistantCancelProcessingVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAiAssistantCancelProcessing, AdminAiAssistantCancelProcessingVariables>(AdminAiAssistantCancelProcessingDocument, options);
      }
export type AdminAiAssistantCancelProcessingHookResult = ReturnType<typeof useAdminAiAssistantCancelProcessing>;
export type AdminAiAssistantCancelProcessingMutationResult = Apollo.MutationResult<AdminAiAssistantCancelProcessing>;
export type AdminAiAssistantCancelProcessingMutationOptions = Apollo.BaseMutationOptions<AdminAiAssistantCancelProcessing, AdminAiAssistantCancelProcessingVariables>;
export const AdminAiAssistantCreateSessionDocument = gql`
    mutation AdminAiAssistantCreateSession($sessionId: ID!, $assistant: AssistantIdInput!, $sessionIdToResume: ID) {
  adminAiAssistantCreateSession(
    sessionId: $sessionId
    assistant: $assistant
    sessionIdToResume: $sessionIdToResume
  )
}
    `;
export type AdminAiAssistantCreateSessionMutationFn = Apollo.MutationFunction<AdminAiAssistantCreateSession, AdminAiAssistantCreateSessionVariables>;

/**
 * __useAdminAiAssistantCreateSession__
 *
 * To run a mutation, you first call `useAdminAiAssistantCreateSession` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAiAssistantCreateSession` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAiAssistantCreateSession, { data, loading, error }] = useAdminAiAssistantCreateSession({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      assistant: // value for 'assistant'
 *      sessionIdToResume: // value for 'sessionIdToResume'
 *   },
 * });
 */
export function useAdminAiAssistantCreateSession(baseOptions?: Apollo.MutationHookOptions<AdminAiAssistantCreateSession, AdminAiAssistantCreateSessionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAiAssistantCreateSession, AdminAiAssistantCreateSessionVariables>(AdminAiAssistantCreateSessionDocument, options);
      }
export type AdminAiAssistantCreateSessionHookResult = ReturnType<typeof useAdminAiAssistantCreateSession>;
export type AdminAiAssistantCreateSessionMutationResult = Apollo.MutationResult<AdminAiAssistantCreateSession>;
export type AdminAiAssistantCreateSessionMutationOptions = Apollo.BaseMutationOptions<AdminAiAssistantCreateSession, AdminAiAssistantCreateSessionVariables>;
export const AdminAiAssistantDeleteUserSessionDocument = gql`
    mutation AdminAiAssistantDeleteUserSession($sessionId: ID!) {
  adminAiAssistantDeleteUserSession(sessionId: $sessionId)
}
    `;
export type AdminAiAssistantDeleteUserSessionMutationFn = Apollo.MutationFunction<AdminAiAssistantDeleteUserSession, AdminAiAssistantDeleteUserSessionVariables>;

/**
 * __useAdminAiAssistantDeleteUserSession__
 *
 * To run a mutation, you first call `useAdminAiAssistantDeleteUserSession` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAiAssistantDeleteUserSession` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAiAssistantDeleteUserSession, { data, loading, error }] = useAdminAiAssistantDeleteUserSession({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useAdminAiAssistantDeleteUserSession(baseOptions?: Apollo.MutationHookOptions<AdminAiAssistantDeleteUserSession, AdminAiAssistantDeleteUserSessionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAiAssistantDeleteUserSession, AdminAiAssistantDeleteUserSessionVariables>(AdminAiAssistantDeleteUserSessionDocument, options);
      }
export type AdminAiAssistantDeleteUserSessionHookResult = ReturnType<typeof useAdminAiAssistantDeleteUserSession>;
export type AdminAiAssistantDeleteUserSessionMutationResult = Apollo.MutationResult<AdminAiAssistantDeleteUserSession>;
export type AdminAiAssistantDeleteUserSessionMutationOptions = Apollo.BaseMutationOptions<AdminAiAssistantDeleteUserSession, AdminAiAssistantDeleteUserSessionVariables>;
export const AdminAiAssistantPostMessageDocument = gql`
    mutation AdminAiAssistantPostMessage($sessionId: ID!, $assistant: AssistantIdInput!, $messageContent: String!) {
  adminAiAssistantPostMessage(
    sessionId: $sessionId
    assistant: $assistant
    messageContent: $messageContent
  ) {
    id
    queryStatus {
      type
      message
      loadingText
    }
    stats {
      publishingEntityId
      sessionCount
      queryCount
    }
  }
}
    `;
export type AdminAiAssistantPostMessageMutationFn = Apollo.MutationFunction<AdminAiAssistantPostMessage, AdminAiAssistantPostMessageVariables>;

/**
 * __useAdminAiAssistantPostMessage__
 *
 * To run a mutation, you first call `useAdminAiAssistantPostMessage` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAiAssistantPostMessage` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAiAssistantPostMessage, { data, loading, error }] = useAdminAiAssistantPostMessage({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      assistant: // value for 'assistant'
 *      messageContent: // value for 'messageContent'
 *   },
 * });
 */
export function useAdminAiAssistantPostMessage(baseOptions?: Apollo.MutationHookOptions<AdminAiAssistantPostMessage, AdminAiAssistantPostMessageVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAiAssistantPostMessage, AdminAiAssistantPostMessageVariables>(AdminAiAssistantPostMessageDocument, options);
      }
export type AdminAiAssistantPostMessageHookResult = ReturnType<typeof useAdminAiAssistantPostMessage>;
export type AdminAiAssistantPostMessageMutationResult = Apollo.MutationResult<AdminAiAssistantPostMessage>;
export type AdminAiAssistantPostMessageMutationOptions = Apollo.BaseMutationOptions<AdminAiAssistantPostMessage, AdminAiAssistantPostMessageVariables>;
export const AdminAiAssistantUpdateUserSessionDocument = gql`
    mutation AdminAiAssistantUpdateUserSession($sessionId: ID!, $input: AiAssistantUserSessionUpdateInput!) {
  adminAiAssistantUpdateUserSession(sessionId: $sessionId, input: $input) {
    id
    name
  }
}
    `;
export type AdminAiAssistantUpdateUserSessionMutationFn = Apollo.MutationFunction<AdminAiAssistantUpdateUserSession, AdminAiAssistantUpdateUserSessionVariables>;

/**
 * __useAdminAiAssistantUpdateUserSession__
 *
 * To run a mutation, you first call `useAdminAiAssistantUpdateUserSession` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAiAssistantUpdateUserSession` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAiAssistantUpdateUserSession, { data, loading, error }] = useAdminAiAssistantUpdateUserSession({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminAiAssistantUpdateUserSession(baseOptions?: Apollo.MutationHookOptions<AdminAiAssistantUpdateUserSession, AdminAiAssistantUpdateUserSessionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAiAssistantUpdateUserSession, AdminAiAssistantUpdateUserSessionVariables>(AdminAiAssistantUpdateUserSessionDocument, options);
      }
export type AdminAiAssistantUpdateUserSessionHookResult = ReturnType<typeof useAdminAiAssistantUpdateUserSession>;
export type AdminAiAssistantUpdateUserSessionMutationResult = Apollo.MutationResult<AdminAiAssistantUpdateUserSession>;
export type AdminAiAssistantUpdateUserSessionMutationOptions = Apollo.BaseMutationOptions<AdminAiAssistantUpdateUserSession, AdminAiAssistantUpdateUserSessionVariables>;
export const AdminAiAssistantUploadFileDocument = gql`
    mutation AdminAiAssistantUploadFile($sessionId: ID!, $assistant: AssistantIdInput!, $file: String!, $fileName: String!) {
  adminAiAssistantUploadFile(
    sessionId: $sessionId
    assistant: $assistant
    file: $file
    fileName: $fileName
  )
}
    `;
export type AdminAiAssistantUploadFileMutationFn = Apollo.MutationFunction<AdminAiAssistantUploadFile, AdminAiAssistantUploadFileVariables>;

/**
 * __useAdminAiAssistantUploadFile__
 *
 * To run a mutation, you first call `useAdminAiAssistantUploadFile` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAiAssistantUploadFile` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAiAssistantUploadFile, { data, loading, error }] = useAdminAiAssistantUploadFile({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      assistant: // value for 'assistant'
 *      file: // value for 'file'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useAdminAiAssistantUploadFile(baseOptions?: Apollo.MutationHookOptions<AdminAiAssistantUploadFile, AdminAiAssistantUploadFileVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAiAssistantUploadFile, AdminAiAssistantUploadFileVariables>(AdminAiAssistantUploadFileDocument, options);
      }
export type AdminAiAssistantUploadFileHookResult = ReturnType<typeof useAdminAiAssistantUploadFile>;
export type AdminAiAssistantUploadFileMutationResult = Apollo.MutationResult<AdminAiAssistantUploadFile>;
export type AdminAiAssistantUploadFileMutationOptions = Apollo.BaseMutationOptions<AdminAiAssistantUploadFile, AdminAiAssistantUploadFileVariables>;
export const AdminCopyContentSetDocument = gql`
    mutation AdminCopyContentSet($contentSetId: ID!, $receivingPublishingEntityId: ID!, $questionRelationship: QuestionRelationshipType!, $newName: String!, $templateParams: [TemplateParams!]!) {
  adminCopyContentSet(
    contentSetId: $contentSetId
    receivingPublishingEntityId: $receivingPublishingEntityId
    questionRelationship: $questionRelationship
    newName: $newName
    templateParams: $templateParams
  ) {
    __typename
    ... on ContentSetBase {
      id
      name {
        ...multilang
      }
    }
  }
}
    ${Multilang}`;
export type AdminCopyContentSetMutationFn = Apollo.MutationFunction<AdminCopyContentSet, AdminCopyContentSetVariables>;

/**
 * __useAdminCopyContentSet__
 *
 * To run a mutation, you first call `useAdminCopyContentSet` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCopyContentSet` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCopyContentSet, { data, loading, error }] = useAdminCopyContentSet({
 *   variables: {
 *      contentSetId: // value for 'contentSetId'
 *      receivingPublishingEntityId: // value for 'receivingPublishingEntityId'
 *      questionRelationship: // value for 'questionRelationship'
 *      newName: // value for 'newName'
 *      templateParams: // value for 'templateParams'
 *   },
 * });
 */
export function useAdminCopyContentSet(baseOptions?: Apollo.MutationHookOptions<AdminCopyContentSet, AdminCopyContentSetVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCopyContentSet, AdminCopyContentSetVariables>(AdminCopyContentSetDocument, options);
      }
export type AdminCopyContentSetHookResult = ReturnType<typeof useAdminCopyContentSet>;
export type AdminCopyContentSetMutationResult = Apollo.MutationResult<AdminCopyContentSet>;
export type AdminCopyContentSetMutationOptions = Apollo.BaseMutationOptions<AdminCopyContentSet, AdminCopyContentSetVariables>;
export const AdminCreateEmailListDocument = gql`
    mutation AdminCreateEmailList($publishingEntityId: ID!, $listName: String!, $emails: [String!]) {
  adminCreateEmailList(
    publishingEntityId: $publishingEntityId
    listName: $listName
    emails: $emails
  ) {
    id
    name
    emails
  }
}
    `;
export type AdminCreateEmailListMutationFn = Apollo.MutationFunction<AdminCreateEmailList, AdminCreateEmailListVariables>;

/**
 * __useAdminCreateEmailList__
 *
 * To run a mutation, you first call `useAdminCreateEmailList` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateEmailList` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateEmailList, { data, loading, error }] = useAdminCreateEmailList({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      listName: // value for 'listName'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useAdminCreateEmailList(baseOptions?: Apollo.MutationHookOptions<AdminCreateEmailList, AdminCreateEmailListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateEmailList, AdminCreateEmailListVariables>(AdminCreateEmailListDocument, options);
      }
export type AdminCreateEmailListHookResult = ReturnType<typeof useAdminCreateEmailList>;
export type AdminCreateEmailListMutationResult = Apollo.MutationResult<AdminCreateEmailList>;
export type AdminCreateEmailListMutationOptions = Apollo.BaseMutationOptions<AdminCreateEmailList, AdminCreateEmailListVariables>;
export const AdminCreateSocialConnectionDocument = gql`
    mutation AdminCreateSocialConnection($publishingEntityId: ID!, $input: AdminCreateSocialConnectionInput!) {
  adminCreateSocialConnection(
    publishingEntityId: $publishingEntityId
    input: $input
  ) {
    provider
    availableAccounts {
      id
      name
    }
  }
}
    `;
export type AdminCreateSocialConnectionMutationFn = Apollo.MutationFunction<AdminCreateSocialConnection, AdminCreateSocialConnectionVariables>;

/**
 * __useAdminCreateSocialConnection__
 *
 * To run a mutation, you first call `useAdminCreateSocialConnection` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateSocialConnection` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateSocialConnection, { data, loading, error }] = useAdminCreateSocialConnection({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateSocialConnection(baseOptions?: Apollo.MutationHookOptions<AdminCreateSocialConnection, AdminCreateSocialConnectionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateSocialConnection, AdminCreateSocialConnectionVariables>(AdminCreateSocialConnectionDocument, options);
      }
export type AdminCreateSocialConnectionHookResult = ReturnType<typeof useAdminCreateSocialConnection>;
export type AdminCreateSocialConnectionMutationResult = Apollo.MutationResult<AdminCreateSocialConnection>;
export type AdminCreateSocialConnectionMutationOptions = Apollo.BaseMutationOptions<AdminCreateSocialConnection, AdminCreateSocialConnectionVariables>;
export const AdminCsvReportUrlDocument = gql`
    mutation AdminCsvReportUrl($input: CsvReportInput!) {
  adminCsvReportUrl(input: $input)
}
    `;
export type AdminCsvReportUrlMutationFn = Apollo.MutationFunction<AdminCsvReportUrl, AdminCsvReportUrlVariables>;

/**
 * __useAdminCsvReportUrl__
 *
 * To run a mutation, you first call `useAdminCsvReportUrl` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCsvReportUrl` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCsvReportUrl, { data, loading, error }] = useAdminCsvReportUrl({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCsvReportUrl(baseOptions?: Apollo.MutationHookOptions<AdminCsvReportUrl, AdminCsvReportUrlVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCsvReportUrl, AdminCsvReportUrlVariables>(AdminCsvReportUrlDocument, options);
      }
export type AdminCsvReportUrlHookResult = ReturnType<typeof useAdminCsvReportUrl>;
export type AdminCsvReportUrlMutationResult = Apollo.MutationResult<AdminCsvReportUrl>;
export type AdminCsvReportUrlMutationOptions = Apollo.BaseMutationOptions<AdminCsvReportUrl, AdminCsvReportUrlVariables>;
export const DeletePollSetQuestionDocument = gql`
    mutation DeletePollSetQuestion($questionId: ID!) {
  deletePollSetQuestion(questionId: $questionId)
}
    `;
export type DeletePollSetQuestionMutationFn = Apollo.MutationFunction<DeletePollSetQuestion, DeletePollSetQuestionVariables>;

/**
 * __useDeletePollSetQuestion__
 *
 * To run a mutation, you first call `useDeletePollSetQuestion` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePollSetQuestion` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePollSetQuestion, { data, loading, error }] = useDeletePollSetQuestion({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useDeletePollSetQuestion(baseOptions?: Apollo.MutationHookOptions<DeletePollSetQuestion, DeletePollSetQuestionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePollSetQuestion, DeletePollSetQuestionVariables>(DeletePollSetQuestionDocument, options);
      }
export type DeletePollSetQuestionHookResult = ReturnType<typeof useDeletePollSetQuestion>;
export type DeletePollSetQuestionMutationResult = Apollo.MutationResult<DeletePollSetQuestion>;
export type DeletePollSetQuestionMutationOptions = Apollo.BaseMutationOptions<DeletePollSetQuestion, DeletePollSetQuestionVariables>;
export const AdminDeleteSocialConnectionDocument = gql`
    mutation AdminDeleteSocialConnection($publishingEntityId: ID!, $socialConnectionType: SocialConnectionProvider!) {
  adminDeleteSocialConnection(
    publishingEntityId: $publishingEntityId
    socialConnectionType: $socialConnectionType
  )
}
    `;
export type AdminDeleteSocialConnectionMutationFn = Apollo.MutationFunction<AdminDeleteSocialConnection, AdminDeleteSocialConnectionVariables>;

/**
 * __useAdminDeleteSocialConnection__
 *
 * To run a mutation, you first call `useAdminDeleteSocialConnection` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteSocialConnection` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteSocialConnection, { data, loading, error }] = useAdminDeleteSocialConnection({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      socialConnectionType: // value for 'socialConnectionType'
 *   },
 * });
 */
export function useAdminDeleteSocialConnection(baseOptions?: Apollo.MutationHookOptions<AdminDeleteSocialConnection, AdminDeleteSocialConnectionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteSocialConnection, AdminDeleteSocialConnectionVariables>(AdminDeleteSocialConnectionDocument, options);
      }
export type AdminDeleteSocialConnectionHookResult = ReturnType<typeof useAdminDeleteSocialConnection>;
export type AdminDeleteSocialConnectionMutationResult = Apollo.MutationResult<AdminDeleteSocialConnection>;
export type AdminDeleteSocialConnectionMutationOptions = Apollo.BaseMutationOptions<AdminDeleteSocialConnection, AdminDeleteSocialConnectionVariables>;
export const AdminDuplicateSimulationDocument = gql`
    mutation AdminDuplicateSimulation($publishingEntityId: ID!, $balancingActSimulationId: Int!, $type: BalancingActSimulationType!) {
  duplicateSimulation(
    publishingEntityId: $publishingEntityId
    balancingActSimulationId: $balancingActSimulationId
    type: $type
  ) {
    __typename
    id
  }
}
    `;
export type AdminDuplicateSimulationMutationFn = Apollo.MutationFunction<AdminDuplicateSimulation, AdminDuplicateSimulationVariables>;

/**
 * __useAdminDuplicateSimulation__
 *
 * To run a mutation, you first call `useAdminDuplicateSimulation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDuplicateSimulation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDuplicateSimulation, { data, loading, error }] = useAdminDuplicateSimulation({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      balancingActSimulationId: // value for 'balancingActSimulationId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAdminDuplicateSimulation(baseOptions?: Apollo.MutationHookOptions<AdminDuplicateSimulation, AdminDuplicateSimulationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDuplicateSimulation, AdminDuplicateSimulationVariables>(AdminDuplicateSimulationDocument, options);
      }
export type AdminDuplicateSimulationHookResult = ReturnType<typeof useAdminDuplicateSimulation>;
export type AdminDuplicateSimulationMutationResult = Apollo.MutationResult<AdminDuplicateSimulation>;
export type AdminDuplicateSimulationMutationOptions = Apollo.BaseMutationOptions<AdminDuplicateSimulation, AdminDuplicateSimulationVariables>;
export const AdminEnableTrackDomainFeatureSettingsDocument = gql`
    mutation AdminEnableTrackDomainFeatureSettings($publishingEntityId: ID!, $featureSettings: [FeatureSettingInput!]!) {
  adminEnableTrackDomainFeatureSettings(
    publishingEntityId: $publishingEntityId
    featureSettings: $featureSettings
  ) {
    id
    featureSettingId
    featureSettingName
    enabled
    quantity
    isUnlimited
    expirationDate {
      raw
    }
  }
}
    `;
export type AdminEnableTrackDomainFeatureSettingsMutationFn = Apollo.MutationFunction<AdminEnableTrackDomainFeatureSettings, AdminEnableTrackDomainFeatureSettingsVariables>;

/**
 * __useAdminEnableTrackDomainFeatureSettings__
 *
 * To run a mutation, you first call `useAdminEnableTrackDomainFeatureSettings` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEnableTrackDomainFeatureSettings` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEnableTrackDomainFeatureSettings, { data, loading, error }] = useAdminEnableTrackDomainFeatureSettings({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      featureSettings: // value for 'featureSettings'
 *   },
 * });
 */
export function useAdminEnableTrackDomainFeatureSettings(baseOptions?: Apollo.MutationHookOptions<AdminEnableTrackDomainFeatureSettings, AdminEnableTrackDomainFeatureSettingsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminEnableTrackDomainFeatureSettings, AdminEnableTrackDomainFeatureSettingsVariables>(AdminEnableTrackDomainFeatureSettingsDocument, options);
      }
export type AdminEnableTrackDomainFeatureSettingsHookResult = ReturnType<typeof useAdminEnableTrackDomainFeatureSettings>;
export type AdminEnableTrackDomainFeatureSettingsMutationResult = Apollo.MutationResult<AdminEnableTrackDomainFeatureSettings>;
export type AdminEnableTrackDomainFeatureSettingsMutationOptions = Apollo.BaseMutationOptions<AdminEnableTrackDomainFeatureSettings, AdminEnableTrackDomainFeatureSettingsVariables>;
export const AdminGenerateBenchmarkSurveyPdfDocument = gql`
    mutation AdminGenerateBenchmarkSurveyPdf($surveyId: ID!) {
  generateBenchmarkSurveyPdf(surveyId: $surveyId)
}
    `;
export type AdminGenerateBenchmarkSurveyPdfMutationFn = Apollo.MutationFunction<AdminGenerateBenchmarkSurveyPdf, AdminGenerateBenchmarkSurveyPdfVariables>;

/**
 * __useAdminGenerateBenchmarkSurveyPdf__
 *
 * To run a mutation, you first call `useAdminGenerateBenchmarkSurveyPdf` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminGenerateBenchmarkSurveyPdf` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminGenerateBenchmarkSurveyPdf, { data, loading, error }] = useAdminGenerateBenchmarkSurveyPdf({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useAdminGenerateBenchmarkSurveyPdf(baseOptions?: Apollo.MutationHookOptions<AdminGenerateBenchmarkSurveyPdf, AdminGenerateBenchmarkSurveyPdfVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminGenerateBenchmarkSurveyPdf, AdminGenerateBenchmarkSurveyPdfVariables>(AdminGenerateBenchmarkSurveyPdfDocument, options);
      }
export type AdminGenerateBenchmarkSurveyPdfHookResult = ReturnType<typeof useAdminGenerateBenchmarkSurveyPdf>;
export type AdminGenerateBenchmarkSurveyPdfMutationResult = Apollo.MutationResult<AdminGenerateBenchmarkSurveyPdf>;
export type AdminGenerateBenchmarkSurveyPdfMutationOptions = Apollo.BaseMutationOptions<AdminGenerateBenchmarkSurveyPdf, AdminGenerateBenchmarkSurveyPdfVariables>;
export const AdminMakeNoPaymentStorePurchaseDocument = gql`
    mutation AdminMakeNoPaymentStorePurchase($input: StorePurchaseNoPayment!) {
  adminMakeNoPaymentStorePurchase(input: $input) {
    id
    status
    expiresAt {
      raw
    }
    purchasedInStripe
    storeItem {
      id
      name
      provider
      shortDescription
      longDescription
      freeTrialLengthMs
      purchaseLengthMs
      repurchaseDelayMs
      key
      thumbnailUrl
      mainImageUrl
      category
      oneTime
      stripeId
      linkedFeatureSettingId
      plans {
        id
        active
        amount
        trialPeriodDays
        billingScheme
        interval
        intervalCount
        nickname
        product
        usageType
      }
      childStoreItems {
        id
        key
        name
        shortDescription
        category
        order
        isHiddenInUI
      }
    }
  }
}
    `;
export type AdminMakeNoPaymentStorePurchaseMutationFn = Apollo.MutationFunction<AdminMakeNoPaymentStorePurchase, AdminMakeNoPaymentStorePurchaseVariables>;

/**
 * __useAdminMakeNoPaymentStorePurchase__
 *
 * To run a mutation, you first call `useAdminMakeNoPaymentStorePurchase` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMakeNoPaymentStorePurchase` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMakeNoPaymentStorePurchase, { data, loading, error }] = useAdminMakeNoPaymentStorePurchase({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMakeNoPaymentStorePurchase(baseOptions?: Apollo.MutationHookOptions<AdminMakeNoPaymentStorePurchase, AdminMakeNoPaymentStorePurchaseVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMakeNoPaymentStorePurchase, AdminMakeNoPaymentStorePurchaseVariables>(AdminMakeNoPaymentStorePurchaseDocument, options);
      }
export type AdminMakeNoPaymentStorePurchaseHookResult = ReturnType<typeof useAdminMakeNoPaymentStorePurchase>;
export type AdminMakeNoPaymentStorePurchaseMutationResult = Apollo.MutationResult<AdminMakeNoPaymentStorePurchase>;
export type AdminMakeNoPaymentStorePurchaseMutationOptions = Apollo.BaseMutationOptions<AdminMakeNoPaymentStorePurchase, AdminMakeNoPaymentStorePurchaseVariables>;
export const AdminRegistrationAdditionalDataDocument = gql`
    mutation AdminRegistrationAdditionalData($registrationId: ID!, $additionalData: AdminRegistrationAdditionalDataInput!) {
  adminRegistrationAdditionalData(
    registrationId: $registrationId
    additionalData: $additionalData
  ) {
    id
    registrationReason {
      id
    }
    desiredOutcome {
      id
    }
    interests {
      id
    }
  }
}
    `;
export type AdminRegistrationAdditionalDataMutationFn = Apollo.MutationFunction<AdminRegistrationAdditionalData, AdminRegistrationAdditionalDataVariables>;

/**
 * __useAdminRegistrationAdditionalData__
 *
 * To run a mutation, you first call `useAdminRegistrationAdditionalData` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRegistrationAdditionalData` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRegistrationAdditionalData, { data, loading, error }] = useAdminRegistrationAdditionalData({
 *   variables: {
 *      registrationId: // value for 'registrationId'
 *      additionalData: // value for 'additionalData'
 *   },
 * });
 */
export function useAdminRegistrationAdditionalData(baseOptions?: Apollo.MutationHookOptions<AdminRegistrationAdditionalData, AdminRegistrationAdditionalDataVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRegistrationAdditionalData, AdminRegistrationAdditionalDataVariables>(AdminRegistrationAdditionalDataDocument, options);
      }
export type AdminRegistrationAdditionalDataHookResult = ReturnType<typeof useAdminRegistrationAdditionalData>;
export type AdminRegistrationAdditionalDataMutationResult = Apollo.MutationResult<AdminRegistrationAdditionalData>;
export type AdminRegistrationAdditionalDataMutationOptions = Apollo.BaseMutationOptions<AdminRegistrationAdditionalData, AdminRegistrationAdditionalDataVariables>;
export const AdminRegistrationForRespondentDocument = gql`
    mutation AdminRegistrationForRespondent($metadata: [RegistrationMetadataEntry!]!) {
  adminRegistrationForRespondent(metadata: $metadata) {
    id
    user {
      id
      admin {
        __typename
        ... on PrivateAdmin {
          id
          registrationRequests {
            id
            createdTime {
              raw
            }
          }
        }
      }
    }
  }
}
    `;
export type AdminRegistrationForRespondentMutationFn = Apollo.MutationFunction<AdminRegistrationForRespondent, AdminRegistrationForRespondentVariables>;

/**
 * __useAdminRegistrationForRespondent__
 *
 * To run a mutation, you first call `useAdminRegistrationForRespondent` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRegistrationForRespondent` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRegistrationForRespondent, { data, loading, error }] = useAdminRegistrationForRespondent({
 *   variables: {
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useAdminRegistrationForRespondent(baseOptions?: Apollo.MutationHookOptions<AdminRegistrationForRespondent, AdminRegistrationForRespondentVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRegistrationForRespondent, AdminRegistrationForRespondentVariables>(AdminRegistrationForRespondentDocument, options);
      }
export type AdminRegistrationForRespondentHookResult = ReturnType<typeof useAdminRegistrationForRespondent>;
export type AdminRegistrationForRespondentMutationResult = Apollo.MutationResult<AdminRegistrationForRespondent>;
export type AdminRegistrationForRespondentMutationOptions = Apollo.BaseMutationOptions<AdminRegistrationForRespondent, AdminRegistrationForRespondentVariables>;
export const AdminRegistrationProfileSelectionDocument = gql`
    mutation adminRegistrationProfileSelection($registrationId: ID!, $profileInput: AdminRegistrationProfileSelectionInput!) {
  adminRegistrationProfileSelection(
    registrationId: $registrationId
    profileData: $profileInput
  ) {
    __typename
    ... on PrivateAdmin {
      id
      registrationRequests {
        id
        publishingEntity {
          id
          type {
            id
          }
          presidingArea {
            id
            name
            center {
              size
              coordinate {
                lat
                lng
              }
            }
          }
        }
        metadata {
          key
          value
        }
      }
      activePublishingEntity {
        id
        name {
          ...multilang
        }
        type {
          id
        }
        presidingArea {
          id
          name
          center {
            size
            coordinate {
              lat
              lng
            }
          }
        }
      }
    }
  }
}
    ${Multilang}`;
export type AdminRegistrationProfileSelectionMutationFn = Apollo.MutationFunction<AdminRegistrationProfileSelection, AdminRegistrationProfileSelectionVariables>;

/**
 * __useAdminRegistrationProfileSelection__
 *
 * To run a mutation, you first call `useAdminRegistrationProfileSelection` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRegistrationProfileSelection` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRegistrationProfileSelection, { data, loading, error }] = useAdminRegistrationProfileSelection({
 *   variables: {
 *      registrationId: // value for 'registrationId'
 *      profileInput: // value for 'profileInput'
 *   },
 * });
 */
export function useAdminRegistrationProfileSelection(baseOptions?: Apollo.MutationHookOptions<AdminRegistrationProfileSelection, AdminRegistrationProfileSelectionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRegistrationProfileSelection, AdminRegistrationProfileSelectionVariables>(AdminRegistrationProfileSelectionDocument, options);
      }
export type AdminRegistrationProfileSelectionHookResult = ReturnType<typeof useAdminRegistrationProfileSelection>;
export type AdminRegistrationProfileSelectionMutationResult = Apollo.MutationResult<AdminRegistrationProfileSelection>;
export type AdminRegistrationProfileSelectionMutationOptions = Apollo.BaseMutationOptions<AdminRegistrationProfileSelection, AdminRegistrationProfileSelectionVariables>;
export const AdminRegistrationUserCreationDocument = gql`
    mutation AdminRegistrationUserCreation($userData: AdminRegistrationUserInput!, $metadata: [RegistrationMetadataEntry!]!) {
  adminRegistrationUserCreation(userData: $userData, metadata: $metadata) {
    id
    user {
      id
      admin {
        __typename
        ... on PrivateAdmin {
          id
          registrationRequests {
            id
            createdTime {
              raw
            }
          }
        }
      }
    }
  }
}
    `;
export type AdminRegistrationUserCreationMutationFn = Apollo.MutationFunction<AdminRegistrationUserCreation, AdminRegistrationUserCreationVariables>;

/**
 * __useAdminRegistrationUserCreation__
 *
 * To run a mutation, you first call `useAdminRegistrationUserCreation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRegistrationUserCreation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRegistrationUserCreation, { data, loading, error }] = useAdminRegistrationUserCreation({
 *   variables: {
 *      userData: // value for 'userData'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useAdminRegistrationUserCreation(baseOptions?: Apollo.MutationHookOptions<AdminRegistrationUserCreation, AdminRegistrationUserCreationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRegistrationUserCreation, AdminRegistrationUserCreationVariables>(AdminRegistrationUserCreationDocument, options);
      }
export type AdminRegistrationUserCreationHookResult = ReturnType<typeof useAdminRegistrationUserCreation>;
export type AdminRegistrationUserCreationMutationResult = Apollo.MutationResult<AdminRegistrationUserCreation>;
export type AdminRegistrationUserCreationMutationOptions = Apollo.BaseMutationOptions<AdminRegistrationUserCreation, AdminRegistrationUserCreationVariables>;
export const AdminRequestFeatureContactInfoDocument = gql`
    mutation AdminRequestFeatureContactInfo($input: RequestFeatureContactInfo!) {
  adminRequestFeatureContactInfo(input: $input) {
    __typename
    ... on PrivateAdmin {
      id
      requestedFeatures
      commsEmail
      phoneNumber
      phoneExt
    }
  }
}
    `;
export type AdminRequestFeatureContactInfoMutationFn = Apollo.MutationFunction<AdminRequestFeatureContactInfo, AdminRequestFeatureContactInfoVariables>;

/**
 * __useAdminRequestFeatureContactInfo__
 *
 * To run a mutation, you first call `useAdminRequestFeatureContactInfo` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRequestFeatureContactInfo` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRequestFeatureContactInfo, { data, loading, error }] = useAdminRequestFeatureContactInfo({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminRequestFeatureContactInfo(baseOptions?: Apollo.MutationHookOptions<AdminRequestFeatureContactInfo, AdminRequestFeatureContactInfoVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRequestFeatureContactInfo, AdminRequestFeatureContactInfoVariables>(AdminRequestFeatureContactInfoDocument, options);
      }
export type AdminRequestFeatureContactInfoHookResult = ReturnType<typeof useAdminRequestFeatureContactInfo>;
export type AdminRequestFeatureContactInfoMutationResult = Apollo.MutationResult<AdminRequestFeatureContactInfo>;
export type AdminRequestFeatureContactInfoMutationOptions = Apollo.BaseMutationOptions<AdminRequestFeatureContactInfo, AdminRequestFeatureContactInfoVariables>;
export const AdminRequestFeaturesDocument = gql`
    mutation AdminRequestFeatures($features: [String!]!) {
  adminRequestFeatures(features: $features) {
    __typename
    ... on PrivateAdmin {
      id
      requestedFeatures
    }
  }
}
    `;
export type AdminRequestFeaturesMutationFn = Apollo.MutationFunction<AdminRequestFeatures, AdminRequestFeaturesVariables>;

/**
 * __useAdminRequestFeatures__
 *
 * To run a mutation, you first call `useAdminRequestFeatures` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRequestFeatures` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRequestFeatures, { data, loading, error }] = useAdminRequestFeatures({
 *   variables: {
 *      features: // value for 'features'
 *   },
 * });
 */
export function useAdminRequestFeatures(baseOptions?: Apollo.MutationHookOptions<AdminRequestFeatures, AdminRequestFeaturesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRequestFeatures, AdminRequestFeaturesVariables>(AdminRequestFeaturesDocument, options);
      }
export type AdminRequestFeaturesHookResult = ReturnType<typeof useAdminRequestFeatures>;
export type AdminRequestFeaturesMutationResult = Apollo.MutationResult<AdminRequestFeatures>;
export type AdminRequestFeaturesMutationOptions = Apollo.BaseMutationOptions<AdminRequestFeatures, AdminRequestFeaturesVariables>;
export const AdminResendVerificationEmailDocument = gql`
    mutation AdminResendVerificationEmail {
  adminResendVerificationEmail
}
    `;
export type AdminResendVerificationEmailMutationFn = Apollo.MutationFunction<AdminResendVerificationEmail, AdminResendVerificationEmailVariables>;

/**
 * __useAdminResendVerificationEmail__
 *
 * To run a mutation, you first call `useAdminResendVerificationEmail` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminResendVerificationEmail` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminResendVerificationEmail, { data, loading, error }] = useAdminResendVerificationEmail({
 *   variables: {
 *   },
 * });
 */
export function useAdminResendVerificationEmail(baseOptions?: Apollo.MutationHookOptions<AdminResendVerificationEmail, AdminResendVerificationEmailVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminResendVerificationEmail, AdminResendVerificationEmailVariables>(AdminResendVerificationEmailDocument, options);
      }
export type AdminResendVerificationEmailHookResult = ReturnType<typeof useAdminResendVerificationEmail>;
export type AdminResendVerificationEmailMutationResult = Apollo.MutationResult<AdminResendVerificationEmail>;
export type AdminResendVerificationEmailMutationOptions = Apollo.BaseMutationOptions<AdminResendVerificationEmail, AdminResendVerificationEmailVariables>;
export const AdminRevertSurveyToDraftDocument = gql`
    mutation AdminRevertSurveyToDraft($surveyId: ID!) {
  adminRevertSurveyToDraft(surveyId: $surveyId) {
    __typename
    ... on ContentSetBase {
      id
      schedule {
        status
        openDate {
          raw
        }
        closeDate {
          raw
        }
      }
      totalRespondents
    }
  }
}
    `;
export type AdminRevertSurveyToDraftMutationFn = Apollo.MutationFunction<AdminRevertSurveyToDraft, AdminRevertSurveyToDraftVariables>;

/**
 * __useAdminRevertSurveyToDraft__
 *
 * To run a mutation, you first call `useAdminRevertSurveyToDraft` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRevertSurveyToDraft` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRevertSurveyToDraft, { data, loading, error }] = useAdminRevertSurveyToDraft({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useAdminRevertSurveyToDraft(baseOptions?: Apollo.MutationHookOptions<AdminRevertSurveyToDraft, AdminRevertSurveyToDraftVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRevertSurveyToDraft, AdminRevertSurveyToDraftVariables>(AdminRevertSurveyToDraftDocument, options);
      }
export type AdminRevertSurveyToDraftHookResult = ReturnType<typeof useAdminRevertSurveyToDraft>;
export type AdminRevertSurveyToDraftMutationResult = Apollo.MutationResult<AdminRevertSurveyToDraft>;
export type AdminRevertSurveyToDraftMutationOptions = Apollo.BaseMutationOptions<AdminRevertSurveyToDraft, AdminRevertSurveyToDraftVariables>;
export const AdminSaveNewTrackGoalDocument = gql`
    mutation adminSaveNewTrackGoal($input: CreateGoalInput!) {
  adminSaveNewTrackGoal(input: $input) {
    id
    strategicPlans {
      ...StrategicPlan
    }
  }
}
    ${StrategicPlan}`;
export type AdminSaveNewTrackGoalMutationFn = Apollo.MutationFunction<AdminSaveNewTrackGoal, AdminSaveNewTrackGoalVariables>;

/**
 * __useAdminSaveNewTrackGoal__
 *
 * To run a mutation, you first call `useAdminSaveNewTrackGoal` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSaveNewTrackGoal` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSaveNewTrackGoal, { data, loading, error }] = useAdminSaveNewTrackGoal({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminSaveNewTrackGoal(baseOptions?: Apollo.MutationHookOptions<AdminSaveNewTrackGoal, AdminSaveNewTrackGoalVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSaveNewTrackGoal, AdminSaveNewTrackGoalVariables>(AdminSaveNewTrackGoalDocument, options);
      }
export type AdminSaveNewTrackGoalHookResult = ReturnType<typeof useAdminSaveNewTrackGoal>;
export type AdminSaveNewTrackGoalMutationResult = Apollo.MutationResult<AdminSaveNewTrackGoal>;
export type AdminSaveNewTrackGoalMutationOptions = Apollo.BaseMutationOptions<AdminSaveNewTrackGoal, AdminSaveNewTrackGoalVariables>;
export const AdminSaveNewVisualizationDocument = gql`
    mutation AdminSaveNewVisualization($input: TrackVariableVisualizationInput!, $areaMode: TrackAreaMode, $comparisonGroupId: ID, $fipsCodes: [String!]) {
  adminSaveNewVisualizationWithMultipleFips(input: $input) {
    id
    trackVariableVisualizations {
      ...TrackVisualization
    }
  }
}
    ${TrackVisualization}`;
export type AdminSaveNewVisualizationMutationFn = Apollo.MutationFunction<AdminSaveNewVisualization, AdminSaveNewVisualizationVariables>;

/**
 * __useAdminSaveNewVisualization__
 *
 * To run a mutation, you first call `useAdminSaveNewVisualization` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSaveNewVisualization` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSaveNewVisualization, { data, loading, error }] = useAdminSaveNewVisualization({
 *   variables: {
 *      input: // value for 'input'
 *      areaMode: // value for 'areaMode'
 *      comparisonGroupId: // value for 'comparisonGroupId'
 *      fipsCodes: // value for 'fipsCodes'
 *   },
 * });
 */
export function useAdminSaveNewVisualization(baseOptions?: Apollo.MutationHookOptions<AdminSaveNewVisualization, AdminSaveNewVisualizationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSaveNewVisualization, AdminSaveNewVisualizationVariables>(AdminSaveNewVisualizationDocument, options);
      }
export type AdminSaveNewVisualizationHookResult = ReturnType<typeof useAdminSaveNewVisualization>;
export type AdminSaveNewVisualizationMutationResult = Apollo.MutationResult<AdminSaveNewVisualization>;
export type AdminSaveNewVisualizationMutationOptions = Apollo.BaseMutationOptions<AdminSaveNewVisualization, AdminSaveNewVisualizationVariables>;
export const ScheduleQuestionsDocument = gql`
    mutation ScheduleQuestions($questionSetId: ID!, $questions: [QuestionScheduleWithIdInput!]!, $accessSetting: AccessSettingInput) {
  scheduleQuestions(
    questionSetId: $questionSetId
    questions: $questions
    accessSetting: $accessSetting
  ) {
    __typename
    ... on QuestionSet {
      id
      createdQuestions(status: [PUBLISHED, CLOSED, DRAFT, SCHEDULED, CART]) {
        questions {
          id
          schedule {
            status
            openDate {
              raw
            }
            closeDate {
              raw
            }
          }
        }
      }
    }
    ... on PolcoLive {
      id
      createdQuestions(status: [PUBLISHED, CLOSED, DRAFT, SCHEDULED, CART]) {
        questions {
          id
          schedule {
            status
            openDate {
              raw
            }
            closeDate {
              raw
            }
          }
        }
      }
    }
    ... on Survey {
      id
      schedule {
        status
        openDate {
          raw
        }
        closeDate {
          raw
        }
      }
      contents {
        __typename
        ... on Question {
          id
          schedule {
            status
          }
        }
        ... on QuestionHierarchyParentNode {
          id
          questions {
            id
            __typename
            schedule {
              status
            }
          }
        }
      }
    }
    ... on GenericContent {
      id
      schedule {
        status
        openDate {
          raw
        }
        closeDate {
          raw
        }
      }
      contents {
        __typename
        ... on Question {
          id
          schedule {
            status
          }
        }
        ... on QuestionHierarchyParentNode {
          id
          questions {
            id
            __typename
            schedule {
              status
            }
          }
        }
      }
    }
  }
}
    `;
export type ScheduleQuestionsMutationFn = Apollo.MutationFunction<ScheduleQuestions, ScheduleQuestionsVariables>;

/**
 * __useScheduleQuestions__
 *
 * To run a mutation, you first call `useScheduleQuestions` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleQuestions` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleQuestions, { data, loading, error }] = useScheduleQuestions({
 *   variables: {
 *      questionSetId: // value for 'questionSetId'
 *      questions: // value for 'questions'
 *      accessSetting: // value for 'accessSetting'
 *   },
 * });
 */
export function useScheduleQuestions(baseOptions?: Apollo.MutationHookOptions<ScheduleQuestions, ScheduleQuestionsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleQuestions, ScheduleQuestionsVariables>(ScheduleQuestionsDocument, options);
      }
export type ScheduleQuestionsHookResult = ReturnType<typeof useScheduleQuestions>;
export type ScheduleQuestionsMutationResult = Apollo.MutationResult<ScheduleQuestions>;
export type ScheduleQuestionsMutationOptions = Apollo.BaseMutationOptions<ScheduleQuestions, ScheduleQuestionsVariables>;
export const AdminSendOutreachEmailDocument = gql`
    mutation AdminSendOutreachEmail($emailListIds: [ID!]!, $publishingEntityId: ID!, $emailSubscribers: Boolean!, $questionSetId: ID!, $subject: String!, $message: String!, $sendDate: GqlDateInput) {
  adminSendOutreachEmail(
    emailListIds: $emailListIds
    publishingEntityId: $publishingEntityId
    emailSubscribers: $emailSubscribers
    questionSetId: $questionSetId
    subject: $subject
    message: $message
    sendDate: $sendDate
  )
}
    `;
export type AdminSendOutreachEmailMutationFn = Apollo.MutationFunction<AdminSendOutreachEmail, AdminSendOutreachEmailVariables>;

/**
 * __useAdminSendOutreachEmail__
 *
 * To run a mutation, you first call `useAdminSendOutreachEmail` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSendOutreachEmail` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSendOutreachEmail, { data, loading, error }] = useAdminSendOutreachEmail({
 *   variables: {
 *      emailListIds: // value for 'emailListIds'
 *      publishingEntityId: // value for 'publishingEntityId'
 *      emailSubscribers: // value for 'emailSubscribers'
 *      questionSetId: // value for 'questionSetId'
 *      subject: // value for 'subject'
 *      message: // value for 'message'
 *      sendDate: // value for 'sendDate'
 *   },
 * });
 */
export function useAdminSendOutreachEmail(baseOptions?: Apollo.MutationHookOptions<AdminSendOutreachEmail, AdminSendOutreachEmailVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSendOutreachEmail, AdminSendOutreachEmailVariables>(AdminSendOutreachEmailDocument, options);
      }
export type AdminSendOutreachEmailHookResult = ReturnType<typeof useAdminSendOutreachEmail>;
export type AdminSendOutreachEmailMutationResult = Apollo.MutationResult<AdminSendOutreachEmail>;
export type AdminSendOutreachEmailMutationOptions = Apollo.BaseMutationOptions<AdminSendOutreachEmail, AdminSendOutreachEmailVariables>;
export const AdminSendShareEmailDocument = gql`
    mutation AdminSendShareEmail($emailArgs: AdminShareEmailInput!) {
  adminSendSharePolcoEmail(emailArgs: $emailArgs)
}
    `;
export type AdminSendShareEmailMutationFn = Apollo.MutationFunction<AdminSendShareEmail, AdminSendShareEmailVariables>;

/**
 * __useAdminSendShareEmail__
 *
 * To run a mutation, you first call `useAdminSendShareEmail` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSendShareEmail` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSendShareEmail, { data, loading, error }] = useAdminSendShareEmail({
 *   variables: {
 *      emailArgs: // value for 'emailArgs'
 *   },
 * });
 */
export function useAdminSendShareEmail(baseOptions?: Apollo.MutationHookOptions<AdminSendShareEmail, AdminSendShareEmailVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSendShareEmail, AdminSendShareEmailVariables>(AdminSendShareEmailDocument, options);
      }
export type AdminSendShareEmailHookResult = ReturnType<typeof useAdminSendShareEmail>;
export type AdminSendShareEmailMutationResult = Apollo.MutationResult<AdminSendShareEmail>;
export type AdminSendShareEmailMutationOptions = Apollo.BaseMutationOptions<AdminSendShareEmail, AdminSendShareEmailVariables>;
export const AdminSetActivePublishingEntityDocument = gql`
    mutation AdminSetActivePublishingEntity($publishingEntityId: ID!) {
  adminSetActivePublishingEntity(publishingEntityId: $publishingEntityId) {
    __typename
    ... on PrivateAdmin {
      id
      superAdmin
      demoPollyUrl
      activePublishingEntity {
        id
        activationState
        showExampleQuestions
        slug
        name {
          ...multilang
        }
        assets {
          id
          url
          type
        }
        featureSettings {
          id
          featureSettingId
          featureSettingName
          enabled
          quantity
          isUnlimited
          expirationDate {
            raw
          }
        }
      }
    }
  }
}
    ${Multilang}`;
export type AdminSetActivePublishingEntityMutationFn = Apollo.MutationFunction<AdminSetActivePublishingEntity, AdminSetActivePublishingEntityVariables>;

/**
 * __useAdminSetActivePublishingEntity__
 *
 * To run a mutation, you first call `useAdminSetActivePublishingEntity` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetActivePublishingEntity` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetActivePublishingEntity, { data, loading, error }] = useAdminSetActivePublishingEntity({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useAdminSetActivePublishingEntity(baseOptions?: Apollo.MutationHookOptions<AdminSetActivePublishingEntity, AdminSetActivePublishingEntityVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSetActivePublishingEntity, AdminSetActivePublishingEntityVariables>(AdminSetActivePublishingEntityDocument, options);
      }
export type AdminSetActivePublishingEntityHookResult = ReturnType<typeof useAdminSetActivePublishingEntity>;
export type AdminSetActivePublishingEntityMutationResult = Apollo.MutationResult<AdminSetActivePublishingEntity>;
export type AdminSetActivePublishingEntityMutationOptions = Apollo.BaseMutationOptions<AdminSetActivePublishingEntity, AdminSetActivePublishingEntityVariables>;
export const SetPollSetQuestionDocument = gql`
    mutation SetPollSetQuestion($questionSetId: ID!, $input: QuestionInput!, $schedule: QuestionScheduleInput) {
  setPollSetQuestion(
    questionSetId: $questionSetId
    input: $input
    schedule: $schedule
  ) {
    id
    title {
      ...multilang
    }
    description {
      ...multilang
    }
    optional
    isBenchmarkedQuestion
    choiceSet {
      id
      type
      maxSelection
      choices {
        id
        text {
          ...multilang
        }
      }
      sharedChoiceSetData {
        id
      }
    }
    schedule {
      status
      openDate {
        raw
      }
      closeDate {
        raw
      }
    }
  }
}
    ${Multilang}`;
export type SetPollSetQuestionMutationFn = Apollo.MutationFunction<SetPollSetQuestion, SetPollSetQuestionVariables>;

/**
 * __useSetPollSetQuestion__
 *
 * To run a mutation, you first call `useSetPollSetQuestion` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPollSetQuestion` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPollSetQuestion, { data, loading, error }] = useSetPollSetQuestion({
 *   variables: {
 *      questionSetId: // value for 'questionSetId'
 *      input: // value for 'input'
 *      schedule: // value for 'schedule'
 *   },
 * });
 */
export function useSetPollSetQuestion(baseOptions?: Apollo.MutationHookOptions<SetPollSetQuestion, SetPollSetQuestionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPollSetQuestion, SetPollSetQuestionVariables>(SetPollSetQuestionDocument, options);
      }
export type SetPollSetQuestionHookResult = ReturnType<typeof useSetPollSetQuestion>;
export type SetPollSetQuestionMutationResult = Apollo.MutationResult<SetPollSetQuestion>;
export type SetPollSetQuestionMutationOptions = Apollo.BaseMutationOptions<SetPollSetQuestion, SetPollSetQuestionVariables>;
export const AdminSetPublishingEntityShortUrlDocument = gql`
    mutation AdminSetPublishingEntityShortUrl($publishingEntityId: ID!, $url: String) {
  adminSetPublishingEntityShortUrl(
    publishingEntityId: $publishingEntityId
    url: $url
  ) {
    id
    shortUrl
  }
}
    `;
export type AdminSetPublishingEntityShortUrlMutationFn = Apollo.MutationFunction<AdminSetPublishingEntityShortUrl, AdminSetPublishingEntityShortUrlVariables>;

/**
 * __useAdminSetPublishingEntityShortUrl__
 *
 * To run a mutation, you first call `useAdminSetPublishingEntityShortUrl` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetPublishingEntityShortUrl` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetPublishingEntityShortUrl, { data, loading, error }] = useAdminSetPublishingEntityShortUrl({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useAdminSetPublishingEntityShortUrl(baseOptions?: Apollo.MutationHookOptions<AdminSetPublishingEntityShortUrl, AdminSetPublishingEntityShortUrlVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSetPublishingEntityShortUrl, AdminSetPublishingEntityShortUrlVariables>(AdminSetPublishingEntityShortUrlDocument, options);
      }
export type AdminSetPublishingEntityShortUrlHookResult = ReturnType<typeof useAdminSetPublishingEntityShortUrl>;
export type AdminSetPublishingEntityShortUrlMutationResult = Apollo.MutationResult<AdminSetPublishingEntityShortUrl>;
export type AdminSetPublishingEntityShortUrlMutationOptions = Apollo.BaseMutationOptions<AdminSetPublishingEntityShortUrl, AdminSetPublishingEntityShortUrlVariables>;
export const AdminSetShowExampleQuestionsDocument = gql`
    mutation AdminSetShowExampleQuestions($publishingEntityId: ID!, $show: Boolean!) {
  adminSetShowExampleQuestions(
    publishingEntityId: $publishingEntityId
    show: $show
  ) {
    id
    showExampleQuestions
  }
}
    `;
export type AdminSetShowExampleQuestionsMutationFn = Apollo.MutationFunction<AdminSetShowExampleQuestions, AdminSetShowExampleQuestionsVariables>;

/**
 * __useAdminSetShowExampleQuestions__
 *
 * To run a mutation, you first call `useAdminSetShowExampleQuestions` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetShowExampleQuestions` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetShowExampleQuestions, { data, loading, error }] = useAdminSetShowExampleQuestions({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      show: // value for 'show'
 *   },
 * });
 */
export function useAdminSetShowExampleQuestions(baseOptions?: Apollo.MutationHookOptions<AdminSetShowExampleQuestions, AdminSetShowExampleQuestionsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSetShowExampleQuestions, AdminSetShowExampleQuestionsVariables>(AdminSetShowExampleQuestionsDocument, options);
      }
export type AdminSetShowExampleQuestionsHookResult = ReturnType<typeof useAdminSetShowExampleQuestions>;
export type AdminSetShowExampleQuestionsMutationResult = Apollo.MutationResult<AdminSetShowExampleQuestions>;
export type AdminSetShowExampleQuestionsMutationOptions = Apollo.BaseMutationOptions<AdminSetShowExampleQuestions, AdminSetShowExampleQuestionsVariables>;
export const SetSurveyContentsDocument = gql`
    mutation SetSurveyContents($questionSetId: ID!, $input: [SurveyNodeInput!]!, $conditions: ConditionsInput!, $areaMode: TrackAreaMode, $comparisonGroupId: ID, $fipsCodes: [String!]) {
  setSurveyContents(
    questionSetId: $questionSetId
    input: $input
    conditions: $conditions
  ) {
    id
    schedule {
      openDate {
        raw
      }
      closeDate {
        raw
      }
    }
    description {
      ...multilang
    }
    contents {
      __typename
      ... on Question {
        id
        title {
          ...multilang
        }
        questionNumber
        summary
        description {
          ...multilang
        }
        optional
        variableName
        reportDisplayLabel
        conditions {
          metaConditions {
            id
            displayName
            combinationOperator
            childMetaConditionIds
          }
          questionChoiceConditions {
            id
            metaConditionId
            questionId
            questionChoiceId
          }
        }
        choiceSet {
          id
          type
          maxSelection
          randomizeChoices
          scaleData {
            scaleType
            scaleThreshold
          }
          choices {
            id
            text {
              ...multilang
            }
            choiceValue
          }
        }
        schedule {
          status
          openDate {
            raw
          }
          closeDate {
            raw
          }
        }
      }
      ... on QuestionHierarchyParentNode {
        id
        label {
          ...multilang
        }
        nodeType: type
        description {
          ...multilang
        }
        questionNumber
        conditions {
          metaConditions {
            id
            displayName
            combinationOperator
            childMetaConditionIds
          }
          questionChoiceConditions {
            id
            metaConditionId
            questionId
            questionChoiceId
          }
        }
        questions {
          id
          title {
            ...multilang
          }
          optional
          variableName
          reportDisplayLabel
          conditions {
            metaConditions {
              id
              displayName
              combinationOperator
              childMetaConditionIds
            }
            questionChoiceConditions {
              id
              metaConditionId
              questionId
              questionChoiceId
            }
          }
          choiceSet {
            id
            scaleData {
              scaleType
              scaleThreshold
            }
            choices {
              id
              text {
                ...multilang
              }
              choiceValue
            }
          }
        }
      }
      ... on QuestionHierarchyVisualizationNode {
        ...VisualizationNode
      }
      ... on QuestionHierarchySimulationNode {
        ...AdminSimulationNode
      }
    }
    allConditions {
      metaConditions {
        id
        displayName
        combinationOperator
        childMetaConditionIds
      }
      questionChoiceConditions {
        id
        metaConditionId
        questionId
        questionChoiceId
      }
    }
  }
}
    ${Multilang}
${VisualizationNode}
${AdminSimulationNode}`;
export type SetSurveyContentsMutationFn = Apollo.MutationFunction<SetSurveyContents, SetSurveyContentsVariables>;

/**
 * __useSetSurveyContents__
 *
 * To run a mutation, you first call `useSetSurveyContents` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSurveyContents` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSurveyContents, { data, loading, error }] = useSetSurveyContents({
 *   variables: {
 *      questionSetId: // value for 'questionSetId'
 *      input: // value for 'input'
 *      conditions: // value for 'conditions'
 *      areaMode: // value for 'areaMode'
 *      comparisonGroupId: // value for 'comparisonGroupId'
 *      fipsCodes: // value for 'fipsCodes'
 *   },
 * });
 */
export function useSetSurveyContents(baseOptions?: Apollo.MutationHookOptions<SetSurveyContents, SetSurveyContentsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSurveyContents, SetSurveyContentsVariables>(SetSurveyContentsDocument, options);
      }
export type SetSurveyContentsHookResult = ReturnType<typeof useSetSurveyContents>;
export type SetSurveyContentsMutationResult = Apollo.MutationResult<SetSurveyContents>;
export type SetSurveyContentsMutationOptions = Apollo.BaseMutationOptions<SetSurveyContents, SetSurveyContentsVariables>;
export const AdminTrackEventInCrmDocument = gql`
    mutation AdminTrackEventInCrm($event: CrmTrackedEvent!) {
  adminTrackEventInCrm(event: $event)
}
    `;
export type AdminTrackEventInCrmMutationFn = Apollo.MutationFunction<AdminTrackEventInCrm, AdminTrackEventInCrmVariables>;

/**
 * __useAdminTrackEventInCrm__
 *
 * To run a mutation, you first call `useAdminTrackEventInCrm` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminTrackEventInCrm` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminTrackEventInCrm, { data, loading, error }] = useAdminTrackEventInCrm({
 *   variables: {
 *      event: // value for 'event'
 *   },
 * });
 */
export function useAdminTrackEventInCrm(baseOptions?: Apollo.MutationHookOptions<AdminTrackEventInCrm, AdminTrackEventInCrmVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminTrackEventInCrm, AdminTrackEventInCrmVariables>(AdminTrackEventInCrmDocument, options);
      }
export type AdminTrackEventInCrmHookResult = ReturnType<typeof useAdminTrackEventInCrm>;
export type AdminTrackEventInCrmMutationResult = Apollo.MutationResult<AdminTrackEventInCrm>;
export type AdminTrackEventInCrmMutationOptions = Apollo.BaseMutationOptions<AdminTrackEventInCrm, AdminTrackEventInCrmVariables>;
export const AdminUpdateEmailListDocument = gql`
    mutation AdminUpdateEmailList($emailListId: ID!, $emails: [String!]!, $name: String!) {
  adminUpdateEmailList(emailListId: $emailListId, emails: $emails, name: $name) {
    id
    name
    emails
  }
}
    `;
export type AdminUpdateEmailListMutationFn = Apollo.MutationFunction<AdminUpdateEmailList, AdminUpdateEmailListVariables>;

/**
 * __useAdminUpdateEmailList__
 *
 * To run a mutation, you first call `useAdminUpdateEmailList` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateEmailList` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateEmailList, { data, loading, error }] = useAdminUpdateEmailList({
 *   variables: {
 *      emailListId: // value for 'emailListId'
 *      emails: // value for 'emails'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAdminUpdateEmailList(baseOptions?: Apollo.MutationHookOptions<AdminUpdateEmailList, AdminUpdateEmailListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateEmailList, AdminUpdateEmailListVariables>(AdminUpdateEmailListDocument, options);
      }
export type AdminUpdateEmailListHookResult = ReturnType<typeof useAdminUpdateEmailList>;
export type AdminUpdateEmailListMutationResult = Apollo.MutationResult<AdminUpdateEmailList>;
export type AdminUpdateEmailListMutationOptions = Apollo.BaseMutationOptions<AdminUpdateEmailList, AdminUpdateEmailListVariables>;
export const AdminUpdatePublishingEntityDocument = gql`
    mutation AdminUpdatePublishingEntity($publishingEntityId: ID!, $input: AdminUpdatePublishingEntityInput!) {
  adminUpdatePublishingEntity(
    publishingEntityId: $publishingEntityId
    input: $input
  ) {
    id
    name {
      ...multilang
    }
    description {
      ...multilang
    }
    postedBy {
      ...multilang
    }
    slug
    activationState
    assets {
      id
      type
      url
    }
  }
}
    ${Multilang}`;
export type AdminUpdatePublishingEntityMutationFn = Apollo.MutationFunction<AdminUpdatePublishingEntity, AdminUpdatePublishingEntityVariables>;

/**
 * __useAdminUpdatePublishingEntity__
 *
 * To run a mutation, you first call `useAdminUpdatePublishingEntity` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdatePublishingEntity` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdatePublishingEntity, { data, loading, error }] = useAdminUpdatePublishingEntity({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdatePublishingEntity(baseOptions?: Apollo.MutationHookOptions<AdminUpdatePublishingEntity, AdminUpdatePublishingEntityVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdatePublishingEntity, AdminUpdatePublishingEntityVariables>(AdminUpdatePublishingEntityDocument, options);
      }
export type AdminUpdatePublishingEntityHookResult = ReturnType<typeof useAdminUpdatePublishingEntity>;
export type AdminUpdatePublishingEntityMutationResult = Apollo.MutationResult<AdminUpdatePublishingEntity>;
export type AdminUpdatePublishingEntityMutationOptions = Apollo.BaseMutationOptions<AdminUpdatePublishingEntity, AdminUpdatePublishingEntityVariables>;
export const AdminUpdateSimulationDocument = gql`
    mutation AdminUpdateSimulation($simId: ID!, $simulationUpdate: SimulationInput!) {
  setSimulationContents(simId: $simId, simUpdate: $simulationUpdate) {
    id
    name
    locale
    description
    slug
    url
    status
    isPrioritization
    type
    createDate {
      raw
    }
    updatedAt {
      raw
    }
    canPreview
    canPublish
    submissionsAvailable
    categories {
      ...SimulationCategory
    }
  }
}
    ${SimulationCategory}`;
export type AdminUpdateSimulationMutationFn = Apollo.MutationFunction<AdminUpdateSimulation, AdminUpdateSimulationVariables>;

/**
 * __useAdminUpdateSimulation__
 *
 * To run a mutation, you first call `useAdminUpdateSimulation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateSimulation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateSimulation, { data, loading, error }] = useAdminUpdateSimulation({
 *   variables: {
 *      simId: // value for 'simId'
 *      simulationUpdate: // value for 'simulationUpdate'
 *   },
 * });
 */
export function useAdminUpdateSimulation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateSimulation, AdminUpdateSimulationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateSimulation, AdminUpdateSimulationVariables>(AdminUpdateSimulationDocument, options);
      }
export type AdminUpdateSimulationHookResult = ReturnType<typeof useAdminUpdateSimulation>;
export type AdminUpdateSimulationMutationResult = Apollo.MutationResult<AdminUpdateSimulation>;
export type AdminUpdateSimulationMutationOptions = Apollo.BaseMutationOptions<AdminUpdateSimulation, AdminUpdateSimulationVariables>;
export const AdminUpdateSocialConnectionDocument = gql`
    mutation AdminUpdateSocialConnection($publishingEntityId: ID!, $input: AdminUpdateSocialConnectionInput!) {
  adminSetActiveSocialConnectionProfiles(
    publishingEntityId: $publishingEntityId
    input: $input
  ) {
    id
    provider
  }
}
    `;
export type AdminUpdateSocialConnectionMutationFn = Apollo.MutationFunction<AdminUpdateSocialConnection, AdminUpdateSocialConnectionVariables>;

/**
 * __useAdminUpdateSocialConnection__
 *
 * To run a mutation, you first call `useAdminUpdateSocialConnection` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateSocialConnection` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateSocialConnection, { data, loading, error }] = useAdminUpdateSocialConnection({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateSocialConnection(baseOptions?: Apollo.MutationHookOptions<AdminUpdateSocialConnection, AdminUpdateSocialConnectionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateSocialConnection, AdminUpdateSocialConnectionVariables>(AdminUpdateSocialConnectionDocument, options);
      }
export type AdminUpdateSocialConnectionHookResult = ReturnType<typeof useAdminUpdateSocialConnection>;
export type AdminUpdateSocialConnectionMutationResult = Apollo.MutationResult<AdminUpdateSocialConnection>;
export type AdminUpdateSocialConnectionMutationOptions = Apollo.BaseMutationOptions<AdminUpdateSocialConnection, AdminUpdateSocialConnectionVariables>;
export const AdminUpdateVisualizationStateDocument = gql`
    mutation AdminUpdateVisualizationState($input: UpdatePerformanceDataVisualizationInput!) {
  adminUpdateTrackVariableVisualizationState(input: $input) {
    id
    visualizationType
    state
    comparisonGroupId
  }
}
    `;
export type AdminUpdateVisualizationStateMutationFn = Apollo.MutationFunction<AdminUpdateVisualizationState, AdminUpdateVisualizationStateVariables>;

/**
 * __useAdminUpdateVisualizationState__
 *
 * To run a mutation, you first call `useAdminUpdateVisualizationState` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateVisualizationState` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateVisualizationState, { data, loading, error }] = useAdminUpdateVisualizationState({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateVisualizationState(baseOptions?: Apollo.MutationHookOptions<AdminUpdateVisualizationState, AdminUpdateVisualizationStateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateVisualizationState, AdminUpdateVisualizationStateVariables>(AdminUpdateVisualizationStateDocument, options);
      }
export type AdminUpdateVisualizationStateHookResult = ReturnType<typeof useAdminUpdateVisualizationState>;
export type AdminUpdateVisualizationStateMutationResult = Apollo.MutationResult<AdminUpdateVisualizationState>;
export type AdminUpdateVisualizationStateMutationOptions = Apollo.BaseMutationOptions<AdminUpdateVisualizationState, AdminUpdateVisualizationStateVariables>;
export const ApplyRecommendedContentSetDocument = gql`
    mutation ApplyRecommendedContentSet($contentSetId: ID!, $publishingEntityId: ID!, $questions: [ID!]) {
  applyRecommendedContentSet(
    contentSetId: $contentSetId
    publishingEntityId: $publishingEntityId
    questions: $questions
  ) {
    __typename
    ... on ContentSetBase {
      id
      name {
        ...multilang
      }
    }
  }
}
    ${Multilang}`;
export type ApplyRecommendedContentSetMutationFn = Apollo.MutationFunction<ApplyRecommendedContentSet, ApplyRecommendedContentSetVariables>;

/**
 * __useApplyRecommendedContentSet__
 *
 * To run a mutation, you first call `useApplyRecommendedContentSet` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyRecommendedContentSet` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyRecommendedContentSet, { data, loading, error }] = useApplyRecommendedContentSet({
 *   variables: {
 *      contentSetId: // value for 'contentSetId'
 *      publishingEntityId: // value for 'publishingEntityId'
 *      questions: // value for 'questions'
 *   },
 * });
 */
export function useApplyRecommendedContentSet(baseOptions?: Apollo.MutationHookOptions<ApplyRecommendedContentSet, ApplyRecommendedContentSetVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyRecommendedContentSet, ApplyRecommendedContentSetVariables>(ApplyRecommendedContentSetDocument, options);
      }
export type ApplyRecommendedContentSetHookResult = ReturnType<typeof useApplyRecommendedContentSet>;
export type ApplyRecommendedContentSetMutationResult = Apollo.MutationResult<ApplyRecommendedContentSet>;
export type ApplyRecommendedContentSetMutationOptions = Apollo.BaseMutationOptions<ApplyRecommendedContentSet, ApplyRecommendedContentSetVariables>;
export const ArchiveQuestionSetDocument = gql`
    mutation ArchiveQuestionSet($surveyId: ID!, $status: QuestionStatus!, $accessSetting: AccessSettingInput) {
  archiveQuestionSet(
    questionSetId: $surveyId
    status: $status
    accessSetting: $accessSetting
  ) {
    __typename
    ... on QuestionSet {
      id
      schedule {
        status
        openDate {
          raw
        }
        closeDate {
          raw
        }
      }
      accessSetting {
        __typename
        ... on AccessSetting_Email {
          emailLists {
            id
            name
          }
        }
      }
      createdQuestions(status: [PUBLISHED, CLOSED, DRAFT, SCHEDULED, CART, ARCHIVED]) {
        questions {
          id
          schedule {
            status
            openDate {
              raw
            }
            closeDate {
              raw
            }
          }
          questionSet {
            ... on ContentSetBase {
              __typename
              id
            }
          }
        }
      }
    }
    ... on PolcoLive {
      id
      schedule {
        status
        openDate {
          raw
        }
        closeDate {
          raw
        }
      }
      accessSetting {
        __typename
        ... on AccessSetting_Email {
          emailLists {
            id
            name
          }
        }
      }
      createdQuestions(status: [PUBLISHED, CLOSED, DRAFT, SCHEDULED, CART, ARCHIVED]) {
        questions {
          id
          schedule {
            status
            openDate {
              raw
            }
            closeDate {
              raw
            }
          }
          questionSet {
            ... on ContentSetBase {
              __typename
              id
            }
          }
        }
      }
    }
    ... on Survey {
      id
      schedule {
        status
        openDate {
          raw
        }
        closeDate {
          raw
        }
      }
      accessSetting {
        __typename
        ... on AccessSetting_Email {
          emailLists {
            id
            name
          }
        }
      }
    }
    ... on GenericContent {
      id
      schedule {
        status
        openDate {
          raw
        }
        closeDate {
          raw
        }
      }
      accessSetting {
        __typename
        ... on AccessSetting_Email {
          emailLists {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export type ArchiveQuestionSetMutationFn = Apollo.MutationFunction<ArchiveQuestionSet, ArchiveQuestionSetVariables>;

/**
 * __useArchiveQuestionSet__
 *
 * To run a mutation, you first call `useArchiveQuestionSet` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveQuestionSet` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveQuestionSet, { data, loading, error }] = useArchiveQuestionSet({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      status: // value for 'status'
 *      accessSetting: // value for 'accessSetting'
 *   },
 * });
 */
export function useArchiveQuestionSet(baseOptions?: Apollo.MutationHookOptions<ArchiveQuestionSet, ArchiveQuestionSetVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveQuestionSet, ArchiveQuestionSetVariables>(ArchiveQuestionSetDocument, options);
      }
export type ArchiveQuestionSetHookResult = ReturnType<typeof useArchiveQuestionSet>;
export type ArchiveQuestionSetMutationResult = Apollo.MutationResult<ArchiveQuestionSet>;
export type ArchiveQuestionSetMutationOptions = Apollo.BaseMutationOptions<ArchiveQuestionSet, ArchiveQuestionSetVariables>;
export const ContentSetSocialShareDocument = gql`
    mutation ContentSetSocialShare($publishingEntityId: ID!, $shareTypes: [SocialConnectionProvider!]!, $contentSetId: ID!, $message: String) {
  contentSetSocialShare(
    publishingEntityId: $publishingEntityId
    shareTypes: $shareTypes
    contentSetId: $contentSetId
    message: $message
  ) {
    __typename
    ... on ContentSetBase {
      id
    }
  }
}
    `;
export type ContentSetSocialShareMutationFn = Apollo.MutationFunction<ContentSetSocialShare, ContentSetSocialShareVariables>;

/**
 * __useContentSetSocialShare__
 *
 * To run a mutation, you first call `useContentSetSocialShare` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContentSetSocialShare` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contentSetSocialShare, { data, loading, error }] = useContentSetSocialShare({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      shareTypes: // value for 'shareTypes'
 *      contentSetId: // value for 'contentSetId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useContentSetSocialShare(baseOptions?: Apollo.MutationHookOptions<ContentSetSocialShare, ContentSetSocialShareVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContentSetSocialShare, ContentSetSocialShareVariables>(ContentSetSocialShareDocument, options);
      }
export type ContentSetSocialShareHookResult = ReturnType<typeof useContentSetSocialShare>;
export type ContentSetSocialShareMutationResult = Apollo.MutationResult<ContentSetSocialShare>;
export type ContentSetSocialShareMutationOptions = Apollo.BaseMutationOptions<ContentSetSocialShare, ContentSetSocialShareVariables>;
export const CreateClientOnlyAnalyticsEventDocument = gql`
    mutation CreateClientOnlyAnalyticsEvent($event: ClientOnlyAnalyticsEvent!, $metadata: String) {
  createClientOnlyAnalyticsEvent(event: $event, metadata: $metadata)
}
    `;
export type CreateClientOnlyAnalyticsEventMutationFn = Apollo.MutationFunction<CreateClientOnlyAnalyticsEvent, CreateClientOnlyAnalyticsEventVariables>;

/**
 * __useCreateClientOnlyAnalyticsEvent__
 *
 * To run a mutation, you first call `useCreateClientOnlyAnalyticsEvent` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientOnlyAnalyticsEvent` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientOnlyAnalyticsEvent, { data, loading, error }] = useCreateClientOnlyAnalyticsEvent({
 *   variables: {
 *      event: // value for 'event'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useCreateClientOnlyAnalyticsEvent(baseOptions?: Apollo.MutationHookOptions<CreateClientOnlyAnalyticsEvent, CreateClientOnlyAnalyticsEventVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientOnlyAnalyticsEvent, CreateClientOnlyAnalyticsEventVariables>(CreateClientOnlyAnalyticsEventDocument, options);
      }
export type CreateClientOnlyAnalyticsEventHookResult = ReturnType<typeof useCreateClientOnlyAnalyticsEvent>;
export type CreateClientOnlyAnalyticsEventMutationResult = Apollo.MutationResult<CreateClientOnlyAnalyticsEvent>;
export type CreateClientOnlyAnalyticsEventMutationOptions = Apollo.BaseMutationOptions<CreateClientOnlyAnalyticsEvent, CreateClientOnlyAnalyticsEventVariables>;
export const CreateIdeaDocument = gql`
    mutation CreateIdea($input: IdeaInput!) {
  createIdea(idea: $input) {
    __typename
    ... on Idea {
      id
      respondent {
        ... on RespondentBase {
          id
        }
      }
      publishingEntity {
        id
        name {
          ...multilang
        }
      }
      title
      description
      createDate {
        raw
      }
    }
  }
}
    ${Multilang}`;
export type CreateIdeaMutationFn = Apollo.MutationFunction<CreateIdea, CreateIdeaVariables>;

/**
 * __useCreateIdea__
 *
 * To run a mutation, you first call `useCreateIdea` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIdea` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIdea, { data, loading, error }] = useCreateIdea({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIdea(baseOptions?: Apollo.MutationHookOptions<CreateIdea, CreateIdeaVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIdea, CreateIdeaVariables>(CreateIdeaDocument, options);
      }
export type CreateIdeaHookResult = ReturnType<typeof useCreateIdea>;
export type CreateIdeaMutationResult = Apollo.MutationResult<CreateIdea>;
export type CreateIdeaMutationOptions = Apollo.BaseMutationOptions<CreateIdea, CreateIdeaVariables>;
export const CreateOutcomeDocument = gql`
    mutation CreateOutcome($setId: ID!, $input: OutcomeInput!) {
  createOutcome(setId: $setId, input: $input) {
    __typename
    ... on ContentSetBase {
      id
      reportTabs(publiclyShared: false) {
        id
        publiclyShared
      }
      outcome {
        id
        text
        state
      }
    }
  }
}
    `;
export type CreateOutcomeMutationFn = Apollo.MutationFunction<CreateOutcome, CreateOutcomeVariables>;

/**
 * __useCreateOutcome__
 *
 * To run a mutation, you first call `useCreateOutcome` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOutcome` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOutcome, { data, loading, error }] = useCreateOutcome({
 *   variables: {
 *      setId: // value for 'setId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOutcome(baseOptions?: Apollo.MutationHookOptions<CreateOutcome, CreateOutcomeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOutcome, CreateOutcomeVariables>(CreateOutcomeDocument, options);
      }
export type CreateOutcomeHookResult = ReturnType<typeof useCreateOutcome>;
export type CreateOutcomeMutationResult = Apollo.MutationResult<CreateOutcome>;
export type CreateOutcomeMutationOptions = Apollo.BaseMutationOptions<CreateOutcome, CreateOutcomeVariables>;
export const CreateQuestionSetDocument = gql`
    mutation CreateQuestionSet($publishingEntityId: ID!, $input: QuestionSetInput!) {
  createQuestionSet(publishingEntityId: $publishingEntityId, input: $input) {
    __typename
    ... on ContentSetBase {
      id
      name {
        ...multilang
      }
    }
  }
}
    ${Multilang}`;
export type CreateQuestionSetMutationFn = Apollo.MutationFunction<CreateQuestionSet, CreateQuestionSetVariables>;

/**
 * __useCreateQuestionSet__
 *
 * To run a mutation, you first call `useCreateQuestionSet` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionSet` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionSet, { data, loading, error }] = useCreateQuestionSet({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuestionSet(baseOptions?: Apollo.MutationHookOptions<CreateQuestionSet, CreateQuestionSetVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuestionSet, CreateQuestionSetVariables>(CreateQuestionSetDocument, options);
      }
export type CreateQuestionSetHookResult = ReturnType<typeof useCreateQuestionSet>;
export type CreateQuestionSetMutationResult = Apollo.MutationResult<CreateQuestionSet>;
export type CreateQuestionSetMutationOptions = Apollo.BaseMutationOptions<CreateQuestionSet, CreateQuestionSetVariables>;
export const DeleteAdminFromPublishingEntityDocument = gql`
    mutation DeleteAdminFromPublishingEntity($publishingEntityId: ID!, $adminId: ID!) {
  deleteAdminFromPublishingEntity(
    publishingEntityId: $publishingEntityId
    adminId: $adminId
  ) {
    id
    managingAdmins {
      id
      admin {
        ... on AdminBase {
          id
          name
          user {
            id
          }
        }
      }
    }
  }
}
    `;
export type DeleteAdminFromPublishingEntityMutationFn = Apollo.MutationFunction<DeleteAdminFromPublishingEntity, DeleteAdminFromPublishingEntityVariables>;

/**
 * __useDeleteAdminFromPublishingEntity__
 *
 * To run a mutation, you first call `useDeleteAdminFromPublishingEntity` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminFromPublishingEntity` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminFromPublishingEntity, { data, loading, error }] = useDeleteAdminFromPublishingEntity({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      adminId: // value for 'adminId'
 *   },
 * });
 */
export function useDeleteAdminFromPublishingEntity(baseOptions?: Apollo.MutationHookOptions<DeleteAdminFromPublishingEntity, DeleteAdminFromPublishingEntityVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdminFromPublishingEntity, DeleteAdminFromPublishingEntityVariables>(DeleteAdminFromPublishingEntityDocument, options);
      }
export type DeleteAdminFromPublishingEntityHookResult = ReturnType<typeof useDeleteAdminFromPublishingEntity>;
export type DeleteAdminFromPublishingEntityMutationResult = Apollo.MutationResult<DeleteAdminFromPublishingEntity>;
export type DeleteAdminFromPublishingEntityMutationOptions = Apollo.BaseMutationOptions<DeleteAdminFromPublishingEntity, DeleteAdminFromPublishingEntityVariables>;
export const DeleteEmailListDocument = gql`
    mutation DeleteEmailList($publishingEntityId: ID!, $emailListId: ID!) {
  deleteEmailList(
    emailListId: $emailListId
    publishingEntityId: $publishingEntityId
  )
}
    `;
export type DeleteEmailListMutationFn = Apollo.MutationFunction<DeleteEmailList, DeleteEmailListVariables>;

/**
 * __useDeleteEmailList__
 *
 * To run a mutation, you first call `useDeleteEmailList` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailList` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmailList, { data, loading, error }] = useDeleteEmailList({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      emailListId: // value for 'emailListId'
 *   },
 * });
 */
export function useDeleteEmailList(baseOptions?: Apollo.MutationHookOptions<DeleteEmailList, DeleteEmailListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmailList, DeleteEmailListVariables>(DeleteEmailListDocument, options);
      }
export type DeleteEmailListHookResult = ReturnType<typeof useDeleteEmailList>;
export type DeleteEmailListMutationResult = Apollo.MutationResult<DeleteEmailList>;
export type DeleteEmailListMutationOptions = Apollo.BaseMutationOptions<DeleteEmailList, DeleteEmailListVariables>;
export const DeleteOutcomeDocument = gql`
    mutation DeleteOutcome($outcomeId: ID!) {
  deleteOutcome(outcomeId: $outcomeId)
}
    `;
export type DeleteOutcomeMutationFn = Apollo.MutationFunction<DeleteOutcome, DeleteOutcomeVariables>;

/**
 * __useDeleteOutcome__
 *
 * To run a mutation, you first call `useDeleteOutcome` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOutcome` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOutcome, { data, loading, error }] = useDeleteOutcome({
 *   variables: {
 *      outcomeId: // value for 'outcomeId'
 *   },
 * });
 */
export function useDeleteOutcome(baseOptions?: Apollo.MutationHookOptions<DeleteOutcome, DeleteOutcomeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOutcome, DeleteOutcomeVariables>(DeleteOutcomeDocument, options);
      }
export type DeleteOutcomeHookResult = ReturnType<typeof useDeleteOutcome>;
export type DeleteOutcomeMutationResult = Apollo.MutationResult<DeleteOutcome>;
export type DeleteOutcomeMutationOptions = Apollo.BaseMutationOptions<DeleteOutcome, DeleteOutcomeVariables>;
export const DeleteQuestionSetDocument = gql`
    mutation DeleteQuestionSet($id: ID!) {
  deleteQuestionSet(id: $id)
}
    `;
export type DeleteQuestionSetMutationFn = Apollo.MutationFunction<DeleteQuestionSet, DeleteQuestionSetVariables>;

/**
 * __useDeleteQuestionSet__
 *
 * To run a mutation, you first call `useDeleteQuestionSet` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuestionSet` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuestionSet, { data, loading, error }] = useDeleteQuestionSet({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQuestionSet(baseOptions?: Apollo.MutationHookOptions<DeleteQuestionSet, DeleteQuestionSetVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQuestionSet, DeleteQuestionSetVariables>(DeleteQuestionSetDocument, options);
      }
export type DeleteQuestionSetHookResult = ReturnType<typeof useDeleteQuestionSet>;
export type DeleteQuestionSetMutationResult = Apollo.MutationResult<DeleteQuestionSet>;
export type DeleteQuestionSetMutationOptions = Apollo.BaseMutationOptions<DeleteQuestionSet, DeleteQuestionSetVariables>;
export const EmailLoginDocument = gql`
    mutation EmailLogin($email: String!, $password: String!, $fingerprint: String!) {
  emailLogin(email: $email, password: $password, fingerprint: $fingerprint) {
    __typename
    ... on CurrentUser {
      id
      user {
        id
        respondent {
          __typename
          ... on PrivateRespondent {
            id
            firstName
            lastName
            email
            avatarUrl
            guest
            zipCode
            verified
            invitedPlaceholderAccount
            requiresVerificationPrompt
            postAnonymously
            subscriptions {
              id
              slug
            }
          }
        }
        admin {
          __typename
          ... on PrivateAdmin {
            id
            superAdmin
            registrationRequests {
              id
              decision
            }
            activePublishingEntity {
              id
            }
            emailVerificationStatus
            demoPollyUrl
          }
        }
      }
      location {
        id
        ip
        zipCode
        coordinate {
          lat
          lng
        }
      }
    }
    ... on EmailLoginFailed {
      reason
    }
  }
}
    `;
export type EmailLoginMutationFn = Apollo.MutationFunction<EmailLogin, EmailLoginVariables>;

/**
 * __useEmailLogin__
 *
 * To run a mutation, you first call `useEmailLogin` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailLogin` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailLogin, { data, loading, error }] = useEmailLogin({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      fingerprint: // value for 'fingerprint'
 *   },
 * });
 */
export function useEmailLogin(baseOptions?: Apollo.MutationHookOptions<EmailLogin, EmailLoginVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailLogin, EmailLoginVariables>(EmailLoginDocument, options);
      }
export type EmailLoginHookResult = ReturnType<typeof useEmailLogin>;
export type EmailLoginMutationResult = Apollo.MutationResult<EmailLogin>;
export type EmailLoginMutationOptions = Apollo.BaseMutationOptions<EmailLogin, EmailLoginVariables>;
export const EmailSignupDocument = gql`
    mutation EmailSignup($email: String!, $password: String!, $firstName: String, $lastName: String, $zipCode: String!, $fingerprint: String!) {
  emailSignup(
    email: $email
    password: $password
    firstName: $firstName
    lastName: $lastName
    zipCode: $zipCode
    fingerprint: $fingerprint
  ) {
    __typename
    ... on CurrentUser {
      id
      user {
        id
        respondent {
          ... on RespondentBase {
            id
            firstName
            lastName
            avatarUrl
          }
          __typename
          ... on PrivateRespondent {
            id
            firstName
            lastName
            email
            avatarUrl
            guest
            zipCode
            verified
            invitedPlaceholderAccount
            requiresVerificationPrompt
            postAnonymously
            subscriptions {
              id
              slug
            }
          }
        }
      }
      location {
        id
        ip
        zipCode
        coordinate {
          lat
          lng
        }
      }
    }
    ... on EmailSignupFailed {
      reason
    }
  }
}
    `;
export type EmailSignupMutationFn = Apollo.MutationFunction<EmailSignup, EmailSignupVariables>;

/**
 * __useEmailSignup__
 *
 * To run a mutation, you first call `useEmailSignup` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailSignup` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailSignup, { data, loading, error }] = useEmailSignup({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      zipCode: // value for 'zipCode'
 *      fingerprint: // value for 'fingerprint'
 *   },
 * });
 */
export function useEmailSignup(baseOptions?: Apollo.MutationHookOptions<EmailSignup, EmailSignupVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailSignup, EmailSignupVariables>(EmailSignupDocument, options);
      }
export type EmailSignupHookResult = ReturnType<typeof useEmailSignup>;
export type EmailSignupMutationResult = Apollo.MutationResult<EmailSignup>;
export type EmailSignupMutationOptions = Apollo.BaseMutationOptions<EmailSignup, EmailSignupVariables>;
export const FollowPublishingEntityDocument = gql`
    mutation FollowPublishingEntity($publishingEntityId: ID!, $respondentId: ID!, $follow: Boolean!) {
  followPublishingEntity(
    publishingEntityId: $publishingEntityId
    respondentId: $respondentId
    follow: $follow
  ) {
    id
    subscriptionType(respondentId: $respondentId)
  }
}
    `;
export type FollowPublishingEntityMutationFn = Apollo.MutationFunction<FollowPublishingEntity, FollowPublishingEntityVariables>;

/**
 * __useFollowPublishingEntity__
 *
 * To run a mutation, you first call `useFollowPublishingEntity` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowPublishingEntity` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followPublishingEntity, { data, loading, error }] = useFollowPublishingEntity({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      respondentId: // value for 'respondentId'
 *      follow: // value for 'follow'
 *   },
 * });
 */
export function useFollowPublishingEntity(baseOptions?: Apollo.MutationHookOptions<FollowPublishingEntity, FollowPublishingEntityVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowPublishingEntity, FollowPublishingEntityVariables>(FollowPublishingEntityDocument, options);
      }
export type FollowPublishingEntityHookResult = ReturnType<typeof useFollowPublishingEntity>;
export type FollowPublishingEntityMutationResult = Apollo.MutationResult<FollowPublishingEntity>;
export type FollowPublishingEntityMutationOptions = Apollo.BaseMutationOptions<FollowPublishingEntity, FollowPublishingEntityVariables>;
export const InteractWithIdeaDocument = gql`
    mutation InteractWithIdea($input: InteractionInput!, $respondentId: ID!) {
  interactWithIdea(interaction: $input) {
    id
    respondentVote(respondentId: $respondentId)
    aggregations {
      voteUp
      voteDown
    }
  }
}
    `;
export type InteractWithIdeaMutationFn = Apollo.MutationFunction<InteractWithIdea, InteractWithIdeaVariables>;

/**
 * __useInteractWithIdea__
 *
 * To run a mutation, you first call `useInteractWithIdea` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInteractWithIdea` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interactWithIdea, { data, loading, error }] = useInteractWithIdea({
 *   variables: {
 *      input: // value for 'input'
 *      respondentId: // value for 'respondentId'
 *   },
 * });
 */
export function useInteractWithIdea(baseOptions?: Apollo.MutationHookOptions<InteractWithIdea, InteractWithIdeaVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InteractWithIdea, InteractWithIdeaVariables>(InteractWithIdeaDocument, options);
      }
export type InteractWithIdeaHookResult = ReturnType<typeof useInteractWithIdea>;
export type InteractWithIdeaMutationResult = Apollo.MutationResult<InteractWithIdea>;
export type InteractWithIdeaMutationOptions = Apollo.BaseMutationOptions<InteractWithIdea, InteractWithIdeaVariables>;
export const LogOutDocument = gql`
    mutation LogOut {
  logOut {
    id
    user {
      id
    }
  }
}
    `;
export type LogOutMutationFn = Apollo.MutationFunction<LogOut, LogOutVariables>;

/**
 * __useLogOut__
 *
 * To run a mutation, you first call `useLogOut` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogOut` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logOut, { data, loading, error }] = useLogOut({
 *   variables: {
 *   },
 * });
 */
export function useLogOut(baseOptions?: Apollo.MutationHookOptions<LogOut, LogOutVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogOut, LogOutVariables>(LogOutDocument, options);
      }
export type LogOutHookResult = ReturnType<typeof useLogOut>;
export type LogOutMutationResult = Apollo.MutationResult<LogOut>;
export type LogOutMutationOptions = Apollo.BaseMutationOptions<LogOut, LogOutVariables>;
export const PasswordResetDocument = gql`
    mutation PasswordReset($password: String!, $token: String!, $email: String!, $fingerprint: String!, $context: RequestPasswordResetContext!) {
  passwordReset(
    password: $password
    token: $token
    email: $email
    fingerprint: $fingerprint
    context: $context
  ) {
    __typename
    ... on CurrentUser {
      id
      user {
        id
        respondent {
          ... on RespondentBase {
            id
          }
        }
        admin {
          ... on AdminBase {
            id
          }
        }
      }
    }
    ... on ResetPasswordFailed {
      reason
    }
  }
}
    `;
export type PasswordResetMutationFn = Apollo.MutationFunction<PasswordReset, PasswordResetVariables>;

/**
 * __usePasswordReset__
 *
 * To run a mutation, you first call `usePasswordReset` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordReset` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordReset, { data, loading, error }] = usePasswordReset({
 *   variables: {
 *      password: // value for 'password'
 *      token: // value for 'token'
 *      email: // value for 'email'
 *      fingerprint: // value for 'fingerprint'
 *      context: // value for 'context'
 *   },
 * });
 */
export function usePasswordReset(baseOptions?: Apollo.MutationHookOptions<PasswordReset, PasswordResetVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasswordReset, PasswordResetVariables>(PasswordResetDocument, options);
      }
export type PasswordResetHookResult = ReturnType<typeof usePasswordReset>;
export type PasswordResetMutationResult = Apollo.MutationResult<PasswordReset>;
export type PasswordResetMutationOptions = Apollo.BaseMutationOptions<PasswordReset, PasswordResetVariables>;
export const PublishOutcomeDocument = gql`
    mutation PublishOutcome($outcomeId: ID!) {
  publishOutcome(outcomeId: $outcomeId) {
    id
    state
    text
  }
}
    `;
export type PublishOutcomeMutationFn = Apollo.MutationFunction<PublishOutcome, PublishOutcomeVariables>;

/**
 * __usePublishOutcome__
 *
 * To run a mutation, you first call `usePublishOutcome` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishOutcome` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishOutcome, { data, loading, error }] = usePublishOutcome({
 *   variables: {
 *      outcomeId: // value for 'outcomeId'
 *   },
 * });
 */
export function usePublishOutcome(baseOptions?: Apollo.MutationHookOptions<PublishOutcome, PublishOutcomeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishOutcome, PublishOutcomeVariables>(PublishOutcomeDocument, options);
      }
export type PublishOutcomeHookResult = ReturnType<typeof usePublishOutcome>;
export type PublishOutcomeMutationResult = Apollo.MutationResult<PublishOutcome>;
export type PublishOutcomeMutationOptions = Apollo.BaseMutationOptions<PublishOutcome, PublishOutcomeVariables>;
export const PublishingEntitySocialShareDocument = gql`
    mutation PublishingEntitySocialShare($publishingEntityId: ID!, $shareTypes: [SocialConnectionProvider!]!) {
  publishingEntitySocialShare(
    publishingEntityId: $publishingEntityId
    shareTypes: $shareTypes
  ) {
    id
  }
}
    `;
export type PublishingEntitySocialShareMutationFn = Apollo.MutationFunction<PublishingEntitySocialShare, PublishingEntitySocialShareVariables>;

/**
 * __usePublishingEntitySocialShare__
 *
 * To run a mutation, you first call `usePublishingEntitySocialShare` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishingEntitySocialShare` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishingEntitySocialShare, { data, loading, error }] = usePublishingEntitySocialShare({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      shareTypes: // value for 'shareTypes'
 *   },
 * });
 */
export function usePublishingEntitySocialShare(baseOptions?: Apollo.MutationHookOptions<PublishingEntitySocialShare, PublishingEntitySocialShareVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishingEntitySocialShare, PublishingEntitySocialShareVariables>(PublishingEntitySocialShareDocument, options);
      }
export type PublishingEntitySocialShareHookResult = ReturnType<typeof usePublishingEntitySocialShare>;
export type PublishingEntitySocialShareMutationResult = Apollo.MutationResult<PublishingEntitySocialShare>;
export type PublishingEntitySocialShareMutationOptions = Apollo.BaseMutationOptions<PublishingEntitySocialShare, PublishingEntitySocialShareVariables>;
export const VoteForQuestionDocument = gql`
    mutation VoteForQuestion($questionId: ID!, $voteInput: VoteInput!, $upvoteComments: [ID!]!, $voteMetadata: [VoteMetadataEntry!]!) {
  voteForQuestion(
    questionId: $questionId
    input: $voteInput
    upvoteComments: $upvoteComments
    voteMetadata: $voteMetadata
  ) {
    id
    choices {
      id
      allocation
      questionChoice {
        id
      }
    }
    comment {
      id
      comment
      upvoteCount
    }
    upvotedComments {
      id
    }
    voter {
      ... on RespondentBase {
        id
      }
    }
  }
}
    `;
export type VoteForQuestionMutationFn = Apollo.MutationFunction<VoteForQuestion, VoteForQuestionVariables>;

/**
 * __useVoteForQuestion__
 *
 * To run a mutation, you first call `useVoteForQuestion` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoteForQuestion` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voteForQuestion, { data, loading, error }] = useVoteForQuestion({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      voteInput: // value for 'voteInput'
 *      upvoteComments: // value for 'upvoteComments'
 *      voteMetadata: // value for 'voteMetadata'
 *   },
 * });
 */
export function useVoteForQuestion(baseOptions?: Apollo.MutationHookOptions<VoteForQuestion, VoteForQuestionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoteForQuestion, VoteForQuestionVariables>(VoteForQuestionDocument, options);
      }
export type VoteForQuestionHookResult = ReturnType<typeof useVoteForQuestion>;
export type VoteForQuestionMutationResult = Apollo.MutationResult<VoteForQuestion>;
export type VoteForQuestionMutationOptions = Apollo.BaseMutationOptions<VoteForQuestion, VoteForQuestionVariables>;
export const ReorderQuestionSetDocument = gql`
    mutation ReorderQuestionSet($setId: ID!, $questionIds: [ID!]!) {
  reorderQuestionSet(setId: $setId, questionIds: $questionIds) {
    __typename
    ... on PolcoLive {
      id
      createdQuestions(status: [PUBLISHED, CLOSED, DRAFT, SCHEDULED, CART]) {
        questions {
          id
        }
      }
    }
  }
}
    `;
export type ReorderQuestionSetMutationFn = Apollo.MutationFunction<ReorderQuestionSet, ReorderQuestionSetVariables>;

/**
 * __useReorderQuestionSet__
 *
 * To run a mutation, you first call `useReorderQuestionSet` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderQuestionSet` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderQuestionSet, { data, loading, error }] = useReorderQuestionSet({
 *   variables: {
 *      setId: // value for 'setId'
 *      questionIds: // value for 'questionIds'
 *   },
 * });
 */
export function useReorderQuestionSet(baseOptions?: Apollo.MutationHookOptions<ReorderQuestionSet, ReorderQuestionSetVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderQuestionSet, ReorderQuestionSetVariables>(ReorderQuestionSetDocument, options);
      }
export type ReorderQuestionSetHookResult = ReturnType<typeof useReorderQuestionSet>;
export type ReorderQuestionSetMutationResult = Apollo.MutationResult<ReorderQuestionSet>;
export type ReorderQuestionSetMutationOptions = Apollo.BaseMutationOptions<ReorderQuestionSet, ReorderQuestionSetVariables>;
export const RepostContentSetDocument = gql`
    mutation RepostContentSet($contentSetId: ID!, $forPublisherId: ID!) {
  repostContentSet(contentSetId: $contentSetId, forPublisherId: $forPublisherId) {
    ... on ContentSetBase {
      id
    }
  }
}
    `;
export type RepostContentSetMutationFn = Apollo.MutationFunction<RepostContentSet, RepostContentSetVariables>;

/**
 * __useRepostContentSet__
 *
 * To run a mutation, you first call `useRepostContentSet` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRepostContentSet` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [repostContentSet, { data, loading, error }] = useRepostContentSet({
 *   variables: {
 *      contentSetId: // value for 'contentSetId'
 *      forPublisherId: // value for 'forPublisherId'
 *   },
 * });
 */
export function useRepostContentSet(baseOptions?: Apollo.MutationHookOptions<RepostContentSet, RepostContentSetVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RepostContentSet, RepostContentSetVariables>(RepostContentSetDocument, options);
      }
export type RepostContentSetHookResult = ReturnType<typeof useRepostContentSet>;
export type RepostContentSetMutationResult = Apollo.MutationResult<RepostContentSet>;
export type RepostContentSetMutationOptions = Apollo.BaseMutationOptions<RepostContentSet, RepostContentSetVariables>;
export const RequestBenchmarkProgramDocument = gql`
    mutation RequestBenchmarkProgram($benchmarkProgram: BenchmarkProgramInput!) {
  requestBenchmarkProgram(benchmarkProgram: $benchmarkProgram)
}
    `;
export type RequestBenchmarkProgramMutationFn = Apollo.MutationFunction<RequestBenchmarkProgram, RequestBenchmarkProgramVariables>;

/**
 * __useRequestBenchmarkProgram__
 *
 * To run a mutation, you first call `useRequestBenchmarkProgram` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestBenchmarkProgram` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestBenchmarkProgram, { data, loading, error }] = useRequestBenchmarkProgram({
 *   variables: {
 *      benchmarkProgram: // value for 'benchmarkProgram'
 *   },
 * });
 */
export function useRequestBenchmarkProgram(baseOptions?: Apollo.MutationHookOptions<RequestBenchmarkProgram, RequestBenchmarkProgramVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestBenchmarkProgram, RequestBenchmarkProgramVariables>(RequestBenchmarkProgramDocument, options);
      }
export type RequestBenchmarkProgramHookResult = ReturnType<typeof useRequestBenchmarkProgram>;
export type RequestBenchmarkProgramMutationResult = Apollo.MutationResult<RequestBenchmarkProgram>;
export type RequestBenchmarkProgramMutationOptions = Apollo.BaseMutationOptions<RequestBenchmarkProgram, RequestBenchmarkProgramVariables>;
export const RequestMagicLinkEmailDocument = gql`
    mutation RequestMagicLinkEmail($input: MagicLinkRequestInput!) {
  requestMagicLinkEmail(input: $input)
}
    `;
export type RequestMagicLinkEmailMutationFn = Apollo.MutationFunction<RequestMagicLinkEmail, RequestMagicLinkEmailVariables>;

/**
 * __useRequestMagicLinkEmail__
 *
 * To run a mutation, you first call `useRequestMagicLinkEmail` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMagicLinkEmail` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMagicLinkEmail, { data, loading, error }] = useRequestMagicLinkEmail({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestMagicLinkEmail(baseOptions?: Apollo.MutationHookOptions<RequestMagicLinkEmail, RequestMagicLinkEmailVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestMagicLinkEmail, RequestMagicLinkEmailVariables>(RequestMagicLinkEmailDocument, options);
      }
export type RequestMagicLinkEmailHookResult = ReturnType<typeof useRequestMagicLinkEmail>;
export type RequestMagicLinkEmailMutationResult = Apollo.MutationResult<RequestMagicLinkEmail>;
export type RequestMagicLinkEmailMutationOptions = Apollo.BaseMutationOptions<RequestMagicLinkEmail, RequestMagicLinkEmailVariables>;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($email: String!, $context: RequestPasswordResetContext!) {
  requestPasswordReset(email: $email, context: $context)
}
    `;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordReset, RequestPasswordResetVariables>;

/**
 * __useRequestPasswordReset__
 *
 * To run a mutation, you first call `useRequestPasswordReset` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordReset` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordReset, { data, loading, error }] = useRequestPasswordReset({
 *   variables: {
 *      email: // value for 'email'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useRequestPasswordReset(baseOptions?: Apollo.MutationHookOptions<RequestPasswordReset, RequestPasswordResetVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordReset, RequestPasswordResetVariables>(RequestPasswordResetDocument, options);
      }
export type RequestPasswordResetHookResult = ReturnType<typeof useRequestPasswordReset>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordReset>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordReset, RequestPasswordResetVariables>;
export const RespondentUpdateProfileDocument = gql`
    mutation RespondentUpdateProfile($respondentId: ID!, $input: UpdateRespondentProfileInput!) {
  updateRespondent(respondentId: $respondentId, input: $input) {
    ... on PrivateRespondent {
      id
      firstName
      lastName
      zipCode
      inputtedLat
      inputtedLon
      requestLocationLastShown {
        raw
      }
      postAnonymously
      avatarUrl
      guest
      verified
      invitedPlaceholderAccount
      requiresVerificationPrompt
      email
    }
  }
}
    `;
export type RespondentUpdateProfileMutationFn = Apollo.MutationFunction<RespondentUpdateProfile, RespondentUpdateProfileVariables>;

/**
 * __useRespondentUpdateProfile__
 *
 * To run a mutation, you first call `useRespondentUpdateProfile` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondentUpdateProfile` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondentUpdateProfile, { data, loading, error }] = useRespondentUpdateProfile({
 *   variables: {
 *      respondentId: // value for 'respondentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRespondentUpdateProfile(baseOptions?: Apollo.MutationHookOptions<RespondentUpdateProfile, RespondentUpdateProfileVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RespondentUpdateProfile, RespondentUpdateProfileVariables>(RespondentUpdateProfileDocument, options);
      }
export type RespondentUpdateProfileHookResult = ReturnType<typeof useRespondentUpdateProfile>;
export type RespondentUpdateProfileMutationResult = Apollo.MutationResult<RespondentUpdateProfile>;
export type RespondentUpdateProfileMutationOptions = Apollo.BaseMutationOptions<RespondentUpdateProfile, RespondentUpdateProfileVariables>;
export const RetrieveBenchmarkSurveyPdfDocument = gql`
    mutation RetrieveBenchmarkSurveyPdf($surveyId: ID!) {
  retrieveBenchmarkSurveyPdf(surveyId: $surveyId)
}
    `;
export type RetrieveBenchmarkSurveyPdfMutationFn = Apollo.MutationFunction<RetrieveBenchmarkSurveyPdf, RetrieveBenchmarkSurveyPdfVariables>;

/**
 * __useRetrieveBenchmarkSurveyPdf__
 *
 * To run a mutation, you first call `useRetrieveBenchmarkSurveyPdf` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetrieveBenchmarkSurveyPdf` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retrieveBenchmarkSurveyPdf, { data, loading, error }] = useRetrieveBenchmarkSurveyPdf({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useRetrieveBenchmarkSurveyPdf(baseOptions?: Apollo.MutationHookOptions<RetrieveBenchmarkSurveyPdf, RetrieveBenchmarkSurveyPdfVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetrieveBenchmarkSurveyPdf, RetrieveBenchmarkSurveyPdfVariables>(RetrieveBenchmarkSurveyPdfDocument, options);
      }
export type RetrieveBenchmarkSurveyPdfHookResult = ReturnType<typeof useRetrieveBenchmarkSurveyPdf>;
export type RetrieveBenchmarkSurveyPdfMutationResult = Apollo.MutationResult<RetrieveBenchmarkSurveyPdf>;
export type RetrieveBenchmarkSurveyPdfMutationOptions = Apollo.BaseMutationOptions<RetrieveBenchmarkSurveyPdf, RetrieveBenchmarkSurveyPdfVariables>;
export const ScheduleSurveyDocument = gql`
    mutation ScheduleSurvey($surveyId: ID!, $schedule: QuestionScheduleInput!, $accessSetting: AccessSettingInput) {
  scheduleSurvey(
    surveyId: $surveyId
    schedule: $schedule
    accessSetting: $accessSetting
  ) {
    __typename
    ... on ContentSetBase {
      id
      schedule {
        status
        openDate {
          raw
        }
        closeDate {
          raw
        }
      }
      accessSetting {
        __typename
        ... on AccessSetting_Email {
          emailLists {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export type ScheduleSurveyMutationFn = Apollo.MutationFunction<ScheduleSurvey, ScheduleSurveyVariables>;

/**
 * __useScheduleSurvey__
 *
 * To run a mutation, you first call `useScheduleSurvey` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleSurvey` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleSurvey, { data, loading, error }] = useScheduleSurvey({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      schedule: // value for 'schedule'
 *      accessSetting: // value for 'accessSetting'
 *   },
 * });
 */
export function useScheduleSurvey(baseOptions?: Apollo.MutationHookOptions<ScheduleSurvey, ScheduleSurveyVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleSurvey, ScheduleSurveyVariables>(ScheduleSurveyDocument, options);
      }
export type ScheduleSurveyHookResult = ReturnType<typeof useScheduleSurvey>;
export type ScheduleSurveyMutationResult = Apollo.MutationResult<ScheduleSurvey>;
export type ScheduleSurveyMutationOptions = Apollo.BaseMutationOptions<ScheduleSurvey, ScheduleSurveyVariables>;
export const SocialLoginDocument = gql`
    mutation SocialLogin($data: SocialLoginData!, $fingerprint: String!) {
  socialLogin(data: $data, fingerprint: $fingerprint) {
    isNewUser
    currentUser {
      id
      user {
        id
        respondent {
          __typename
          ... on RespondentBase {
            id
            firstName
            lastName
            avatarUrl
          }
          ... on PrivateRespondent {
            id
            firstName
            lastName
            avatarUrl
            guest
            zipCode
            verified
            email
          }
        }
      }
      location {
        id
        ip
        zipCode
        coordinate {
          lat
          lng
        }
      }
    }
  }
}
    `;
export type SocialLoginMutationFn = Apollo.MutationFunction<SocialLogin, SocialLoginVariables>;

/**
 * __useSocialLogin__
 *
 * To run a mutation, you first call `useSocialLogin` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialLogin` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialLogin, { data, loading, error }] = useSocialLogin({
 *   variables: {
 *      data: // value for 'data'
 *      fingerprint: // value for 'fingerprint'
 *   },
 * });
 */
export function useSocialLogin(baseOptions?: Apollo.MutationHookOptions<SocialLogin, SocialLoginVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SocialLogin, SocialLoginVariables>(SocialLoginDocument, options);
      }
export type SocialLoginHookResult = ReturnType<typeof useSocialLogin>;
export type SocialLoginMutationResult = Apollo.MutationResult<SocialLogin>;
export type SocialLoginMutationOptions = Apollo.BaseMutationOptions<SocialLogin, SocialLoginVariables>;
export const SoftDeleteQuestionSetDocument = gql`
    mutation SoftDeleteQuestionSet($id: ID!) {
  softDeleteQuestionSet(questionSetId: $id) {
    __typename
  }
}
    `;
export type SoftDeleteQuestionSetMutationFn = Apollo.MutationFunction<SoftDeleteQuestionSet, SoftDeleteQuestionSetVariables>;

/**
 * __useSoftDeleteQuestionSet__
 *
 * To run a mutation, you first call `useSoftDeleteQuestionSet` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeleteQuestionSet` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeleteQuestionSet, { data, loading, error }] = useSoftDeleteQuestionSet({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftDeleteQuestionSet(baseOptions?: Apollo.MutationHookOptions<SoftDeleteQuestionSet, SoftDeleteQuestionSetVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftDeleteQuestionSet, SoftDeleteQuestionSetVariables>(SoftDeleteQuestionSetDocument, options);
      }
export type SoftDeleteQuestionSetHookResult = ReturnType<typeof useSoftDeleteQuestionSet>;
export type SoftDeleteQuestionSetMutationResult = Apollo.MutationResult<SoftDeleteQuestionSet>;
export type SoftDeleteQuestionSetMutationOptions = Apollo.BaseMutationOptions<SoftDeleteQuestionSet, SoftDeleteQuestionSetVariables>;
export const SuperAdminApproveRegistrationDocument = gql`
    mutation SuperAdminApproveRegistration($registrationId: ID!) {
  superAdminApproveRegistration(registrationId: $registrationId) {
    id
  }
}
    `;
export type SuperAdminApproveRegistrationMutationFn = Apollo.MutationFunction<SuperAdminApproveRegistration, SuperAdminApproveRegistrationVariables>;

/**
 * __useSuperAdminApproveRegistration__
 *
 * To run a mutation, you first call `useSuperAdminApproveRegistration` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminApproveRegistration` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminApproveRegistration, { data, loading, error }] = useSuperAdminApproveRegistration({
 *   variables: {
 *      registrationId: // value for 'registrationId'
 *   },
 * });
 */
export function useSuperAdminApproveRegistration(baseOptions?: Apollo.MutationHookOptions<SuperAdminApproveRegistration, SuperAdminApproveRegistrationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminApproveRegistration, SuperAdminApproveRegistrationVariables>(SuperAdminApproveRegistrationDocument, options);
      }
export type SuperAdminApproveRegistrationHookResult = ReturnType<typeof useSuperAdminApproveRegistration>;
export type SuperAdminApproveRegistrationMutationResult = Apollo.MutationResult<SuperAdminApproveRegistration>;
export type SuperAdminApproveRegistrationMutationOptions = Apollo.BaseMutationOptions<SuperAdminApproveRegistration, SuperAdminApproveRegistrationVariables>;
export const SuperAdminAssociatePublishingEntityWithRegistrationDocument = gql`
    mutation SuperAdminAssociatePublishingEntityWithRegistration($registrationId: ID!, $publishingEntityId: ID!) {
  superAdminAssociatePublishingEntityWithRegistration(
    registrationId: $registrationId
    publishingEntityId: $publishingEntityId
  ) {
    id
    publishingEntity {
      id
      name {
        ...multilang
      }
    }
    user {
      id
      admin {
        ... on AdminBase {
          id
          name
        }
      }
    }
  }
}
    ${Multilang}`;
export type SuperAdminAssociatePublishingEntityWithRegistrationMutationFn = Apollo.MutationFunction<SuperAdminAssociatePublishingEntityWithRegistration, SuperAdminAssociatePublishingEntityWithRegistrationVariables>;

/**
 * __useSuperAdminAssociatePublishingEntityWithRegistration__
 *
 * To run a mutation, you first call `useSuperAdminAssociatePublishingEntityWithRegistration` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminAssociatePublishingEntityWithRegistration` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminAssociatePublishingEntityWithRegistration, { data, loading, error }] = useSuperAdminAssociatePublishingEntityWithRegistration({
 *   variables: {
 *      registrationId: // value for 'registrationId'
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useSuperAdminAssociatePublishingEntityWithRegistration(baseOptions?: Apollo.MutationHookOptions<SuperAdminAssociatePublishingEntityWithRegistration, SuperAdminAssociatePublishingEntityWithRegistrationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminAssociatePublishingEntityWithRegistration, SuperAdminAssociatePublishingEntityWithRegistrationVariables>(SuperAdminAssociatePublishingEntityWithRegistrationDocument, options);
      }
export type SuperAdminAssociatePublishingEntityWithRegistrationHookResult = ReturnType<typeof useSuperAdminAssociatePublishingEntityWithRegistration>;
export type SuperAdminAssociatePublishingEntityWithRegistrationMutationResult = Apollo.MutationResult<SuperAdminAssociatePublishingEntityWithRegistration>;
export type SuperAdminAssociatePublishingEntityWithRegistrationMutationOptions = Apollo.BaseMutationOptions<SuperAdminAssociatePublishingEntityWithRegistration, SuperAdminAssociatePublishingEntityWithRegistrationVariables>;
export const SuperAdminCreateContentSetReportTabDocument = gql`
    mutation SuperAdminCreateContentSetReportTab($setId: ID!, $input: ReportTabCreateInput!) {
  superAdminCreateContentSetReportTab(setId: $setId, input: $input) {
    __typename
    ... on ContentSetBase {
      id
      name {
        ...multilang
      }
      reportTabs(publiclyShared: false) {
        id
        title
        visibleToAdmins
        order
        content {
          type
          HTML
          TABLEAU
          height
        }
        trackDomain
      }
    }
  }
}
    ${Multilang}`;
export type SuperAdminCreateContentSetReportTabMutationFn = Apollo.MutationFunction<SuperAdminCreateContentSetReportTab, SuperAdminCreateContentSetReportTabVariables>;

/**
 * __useSuperAdminCreateContentSetReportTab__
 *
 * To run a mutation, you first call `useSuperAdminCreateContentSetReportTab` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminCreateContentSetReportTab` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminCreateContentSetReportTab, { data, loading, error }] = useSuperAdminCreateContentSetReportTab({
 *   variables: {
 *      setId: // value for 'setId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuperAdminCreateContentSetReportTab(baseOptions?: Apollo.MutationHookOptions<SuperAdminCreateContentSetReportTab, SuperAdminCreateContentSetReportTabVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminCreateContentSetReportTab, SuperAdminCreateContentSetReportTabVariables>(SuperAdminCreateContentSetReportTabDocument, options);
      }
export type SuperAdminCreateContentSetReportTabHookResult = ReturnType<typeof useSuperAdminCreateContentSetReportTab>;
export type SuperAdminCreateContentSetReportTabMutationResult = Apollo.MutationResult<SuperAdminCreateContentSetReportTab>;
export type SuperAdminCreateContentSetReportTabMutationOptions = Apollo.BaseMutationOptions<SuperAdminCreateContentSetReportTab, SuperAdminCreateContentSetReportTabVariables>;
export const SuperAdminCreateOrUpdateRecommendedContentDocument = gql`
    mutation SuperAdminCreateOrUpdateRecommendedContent($isPaidContent: Boolean!, $setId: ID!, $shareableContentType: ShareableContentType!, $adminDescription: String, $domains: [ShareableContentDomains!]!) {
  superAdminCreateOrUpdateRecommendedContent(
    isPaidContent: $isPaidContent
    setId: $setId
    shareableContentType: $shareableContentType
    adminDescription: $adminDescription
    domains: $domains
  ) {
    id
    shareType
    adminDescription
    isPaidContent
    contentSet {
      __typename
      ... on ContentSetBase {
        id
      }
    }
  }
}
    `;
export type SuperAdminCreateOrUpdateRecommendedContentMutationFn = Apollo.MutationFunction<SuperAdminCreateOrUpdateRecommendedContent, SuperAdminCreateOrUpdateRecommendedContentVariables>;

/**
 * __useSuperAdminCreateOrUpdateRecommendedContent__
 *
 * To run a mutation, you first call `useSuperAdminCreateOrUpdateRecommendedContent` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminCreateOrUpdateRecommendedContent` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminCreateOrUpdateRecommendedContent, { data, loading, error }] = useSuperAdminCreateOrUpdateRecommendedContent({
 *   variables: {
 *      isPaidContent: // value for 'isPaidContent'
 *      setId: // value for 'setId'
 *      shareableContentType: // value for 'shareableContentType'
 *      adminDescription: // value for 'adminDescription'
 *      domains: // value for 'domains'
 *   },
 * });
 */
export function useSuperAdminCreateOrUpdateRecommendedContent(baseOptions?: Apollo.MutationHookOptions<SuperAdminCreateOrUpdateRecommendedContent, SuperAdminCreateOrUpdateRecommendedContentVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminCreateOrUpdateRecommendedContent, SuperAdminCreateOrUpdateRecommendedContentVariables>(SuperAdminCreateOrUpdateRecommendedContentDocument, options);
      }
export type SuperAdminCreateOrUpdateRecommendedContentHookResult = ReturnType<typeof useSuperAdminCreateOrUpdateRecommendedContent>;
export type SuperAdminCreateOrUpdateRecommendedContentMutationResult = Apollo.MutationResult<SuperAdminCreateOrUpdateRecommendedContent>;
export type SuperAdminCreateOrUpdateRecommendedContentMutationOptions = Apollo.BaseMutationOptions<SuperAdminCreateOrUpdateRecommendedContent, SuperAdminCreateOrUpdateRecommendedContentVariables>;
export const SuperAdminCreatePublisherPresidingAreaDocument = gql`
    mutation SuperAdminCreatePublisherPresidingArea($publishingEntityId: ID!, $areaShape: GeoJsonMultiPolygonInput!, $areaName: String!) {
  superAdminUpdatePresidingArea(
    publishingEntityId: $publishingEntityId
    area: {shape: $areaShape, name: $areaName}
  ) {
    id
    presidingArea {
      id
      center {
        coordinate {
          lat
          lng
        }
        size
      }
      shape {
        type
        coordinates
      }
      name
    }
  }
}
    `;
export type SuperAdminCreatePublisherPresidingAreaMutationFn = Apollo.MutationFunction<SuperAdminCreatePublisherPresidingArea, SuperAdminCreatePublisherPresidingAreaVariables>;

/**
 * __useSuperAdminCreatePublisherPresidingArea__
 *
 * To run a mutation, you first call `useSuperAdminCreatePublisherPresidingArea` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminCreatePublisherPresidingArea` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminCreatePublisherPresidingArea, { data, loading, error }] = useSuperAdminCreatePublisherPresidingArea({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      areaShape: // value for 'areaShape'
 *      areaName: // value for 'areaName'
 *   },
 * });
 */
export function useSuperAdminCreatePublisherPresidingArea(baseOptions?: Apollo.MutationHookOptions<SuperAdminCreatePublisherPresidingArea, SuperAdminCreatePublisherPresidingAreaVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminCreatePublisherPresidingArea, SuperAdminCreatePublisherPresidingAreaVariables>(SuperAdminCreatePublisherPresidingAreaDocument, options);
      }
export type SuperAdminCreatePublisherPresidingAreaHookResult = ReturnType<typeof useSuperAdminCreatePublisherPresidingArea>;
export type SuperAdminCreatePublisherPresidingAreaMutationResult = Apollo.MutationResult<SuperAdminCreatePublisherPresidingArea>;
export type SuperAdminCreatePublisherPresidingAreaMutationOptions = Apollo.BaseMutationOptions<SuperAdminCreatePublisherPresidingArea, SuperAdminCreatePublisherPresidingAreaVariables>;
export const SuperAdminCreatePublishingEntityDocument = gql`
    mutation superAdminCreatePublishingEntity($input: PublishingEntityCreationInput!) {
  superAdminCreatePublishingEntity(input: $input) {
    id
  }
}
    `;
export type SuperAdminCreatePublishingEntityMutationFn = Apollo.MutationFunction<SuperAdminCreatePublishingEntity, SuperAdminCreatePublishingEntityVariables>;

/**
 * __useSuperAdminCreatePublishingEntity__
 *
 * To run a mutation, you first call `useSuperAdminCreatePublishingEntity` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminCreatePublishingEntity` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminCreatePublishingEntity, { data, loading, error }] = useSuperAdminCreatePublishingEntity({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuperAdminCreatePublishingEntity(baseOptions?: Apollo.MutationHookOptions<SuperAdminCreatePublishingEntity, SuperAdminCreatePublishingEntityVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminCreatePublishingEntity, SuperAdminCreatePublishingEntityVariables>(SuperAdminCreatePublishingEntityDocument, options);
      }
export type SuperAdminCreatePublishingEntityHookResult = ReturnType<typeof useSuperAdminCreatePublishingEntity>;
export type SuperAdminCreatePublishingEntityMutationResult = Apollo.MutationResult<SuperAdminCreatePublishingEntity>;
export type SuperAdminCreatePublishingEntityMutationOptions = Apollo.BaseMutationOptions<SuperAdminCreatePublishingEntity, SuperAdminCreatePublishingEntityVariables>;
export const SuperAdminCreateSuperAdminDocument = gql`
    mutation SuperAdminCreateSuperAdmin($input: CreateSuperAdminInput!) {
  superAdminCreateSuperAdmin(input: $input) {
    activationLink
  }
}
    `;
export type SuperAdminCreateSuperAdminMutationFn = Apollo.MutationFunction<SuperAdminCreateSuperAdmin, SuperAdminCreateSuperAdminVariables>;

/**
 * __useSuperAdminCreateSuperAdmin__
 *
 * To run a mutation, you first call `useSuperAdminCreateSuperAdmin` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminCreateSuperAdmin` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminCreateSuperAdmin, { data, loading, error }] = useSuperAdminCreateSuperAdmin({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuperAdminCreateSuperAdmin(baseOptions?: Apollo.MutationHookOptions<SuperAdminCreateSuperAdmin, SuperAdminCreateSuperAdminVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminCreateSuperAdmin, SuperAdminCreateSuperAdminVariables>(SuperAdminCreateSuperAdminDocument, options);
      }
export type SuperAdminCreateSuperAdminHookResult = ReturnType<typeof useSuperAdminCreateSuperAdmin>;
export type SuperAdminCreateSuperAdminMutationResult = Apollo.MutationResult<SuperAdminCreateSuperAdmin>;
export type SuperAdminCreateSuperAdminMutationOptions = Apollo.BaseMutationOptions<SuperAdminCreateSuperAdmin, SuperAdminCreateSuperAdminVariables>;
export const SuperAdminCreateThirdPartyRecordDocument = gql`
    mutation superAdminCreateThirdPartyRecord($input: ThirdPartyRecordInput!) {
  superAdminCreateThirdPartyRecord(input: $input) {
    id
    thirdParty
    thirdPartyIdentifier
  }
}
    `;
export type SuperAdminCreateThirdPartyRecordMutationFn = Apollo.MutationFunction<SuperAdminCreateThirdPartyRecord, SuperAdminCreateThirdPartyRecordVariables>;

/**
 * __useSuperAdminCreateThirdPartyRecord__
 *
 * To run a mutation, you first call `useSuperAdminCreateThirdPartyRecord` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminCreateThirdPartyRecord` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminCreateThirdPartyRecord, { data, loading, error }] = useSuperAdminCreateThirdPartyRecord({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuperAdminCreateThirdPartyRecord(baseOptions?: Apollo.MutationHookOptions<SuperAdminCreateThirdPartyRecord, SuperAdminCreateThirdPartyRecordVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminCreateThirdPartyRecord, SuperAdminCreateThirdPartyRecordVariables>(SuperAdminCreateThirdPartyRecordDocument, options);
      }
export type SuperAdminCreateThirdPartyRecordHookResult = ReturnType<typeof useSuperAdminCreateThirdPartyRecord>;
export type SuperAdminCreateThirdPartyRecordMutationResult = Apollo.MutationResult<SuperAdminCreateThirdPartyRecord>;
export type SuperAdminCreateThirdPartyRecordMutationOptions = Apollo.BaseMutationOptions<SuperAdminCreateThirdPartyRecord, SuperAdminCreateThirdPartyRecordVariables>;
export const SuperAdminDeleteBenchmarkReportRequestDocument = gql`
    mutation superAdminDeleteBenchmarkReportRequest($id: ID!) {
  superAdminDeleteBenchmarkReportRequest(requestId: $id)
}
    `;
export type SuperAdminDeleteBenchmarkReportRequestMutationFn = Apollo.MutationFunction<SuperAdminDeleteBenchmarkReportRequest, SuperAdminDeleteBenchmarkReportRequestVariables>;

/**
 * __useSuperAdminDeleteBenchmarkReportRequest__
 *
 * To run a mutation, you first call `useSuperAdminDeleteBenchmarkReportRequest` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminDeleteBenchmarkReportRequest` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminDeleteBenchmarkReportRequest, { data, loading, error }] = useSuperAdminDeleteBenchmarkReportRequest({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuperAdminDeleteBenchmarkReportRequest(baseOptions?: Apollo.MutationHookOptions<SuperAdminDeleteBenchmarkReportRequest, SuperAdminDeleteBenchmarkReportRequestVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminDeleteBenchmarkReportRequest, SuperAdminDeleteBenchmarkReportRequestVariables>(SuperAdminDeleteBenchmarkReportRequestDocument, options);
      }
export type SuperAdminDeleteBenchmarkReportRequestHookResult = ReturnType<typeof useSuperAdminDeleteBenchmarkReportRequest>;
export type SuperAdminDeleteBenchmarkReportRequestMutationResult = Apollo.MutationResult<SuperAdminDeleteBenchmarkReportRequest>;
export type SuperAdminDeleteBenchmarkReportRequestMutationOptions = Apollo.BaseMutationOptions<SuperAdminDeleteBenchmarkReportRequest, SuperAdminDeleteBenchmarkReportRequestVariables>;
export const SuperAdminDeleteContentSetReportTabDocument = gql`
    mutation SuperAdminDeleteContentSetReportTab($tabId: ID!) {
  superAdminDeleteContentSetReportTab(tabId: $tabId) {
    __typename
    ... on ContentSetBase {
      id
      name {
        ...multilang
      }
      reportTabs(publiclyShared: false) {
        id
        title
        visibleToAdmins
        order
        content {
          type
          HTML
          TABLEAU
          height
        }
      }
    }
  }
}
    ${Multilang}`;
export type SuperAdminDeleteContentSetReportTabMutationFn = Apollo.MutationFunction<SuperAdminDeleteContentSetReportTab, SuperAdminDeleteContentSetReportTabVariables>;

/**
 * __useSuperAdminDeleteContentSetReportTab__
 *
 * To run a mutation, you first call `useSuperAdminDeleteContentSetReportTab` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminDeleteContentSetReportTab` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminDeleteContentSetReportTab, { data, loading, error }] = useSuperAdminDeleteContentSetReportTab({
 *   variables: {
 *      tabId: // value for 'tabId'
 *   },
 * });
 */
export function useSuperAdminDeleteContentSetReportTab(baseOptions?: Apollo.MutationHookOptions<SuperAdminDeleteContentSetReportTab, SuperAdminDeleteContentSetReportTabVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminDeleteContentSetReportTab, SuperAdminDeleteContentSetReportTabVariables>(SuperAdminDeleteContentSetReportTabDocument, options);
      }
export type SuperAdminDeleteContentSetReportTabHookResult = ReturnType<typeof useSuperAdminDeleteContentSetReportTab>;
export type SuperAdminDeleteContentSetReportTabMutationResult = Apollo.MutationResult<SuperAdminDeleteContentSetReportTab>;
export type SuperAdminDeleteContentSetReportTabMutationOptions = Apollo.BaseMutationOptions<SuperAdminDeleteContentSetReportTab, SuperAdminDeleteContentSetReportTabVariables>;
export const SuperAdminDeletePublishingEntityDocument = gql`
    mutation SuperAdminDeletePublishingEntity($publishingEntityId: ID!) {
  superAdminDeletePublishingEntity(publishingEntityId: $publishingEntityId)
}
    `;
export type SuperAdminDeletePublishingEntityMutationFn = Apollo.MutationFunction<SuperAdminDeletePublishingEntity, SuperAdminDeletePublishingEntityVariables>;

/**
 * __useSuperAdminDeletePublishingEntity__
 *
 * To run a mutation, you first call `useSuperAdminDeletePublishingEntity` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminDeletePublishingEntity` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminDeletePublishingEntity, { data, loading, error }] = useSuperAdminDeletePublishingEntity({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useSuperAdminDeletePublishingEntity(baseOptions?: Apollo.MutationHookOptions<SuperAdminDeletePublishingEntity, SuperAdminDeletePublishingEntityVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminDeletePublishingEntity, SuperAdminDeletePublishingEntityVariables>(SuperAdminDeletePublishingEntityDocument, options);
      }
export type SuperAdminDeletePublishingEntityHookResult = ReturnType<typeof useSuperAdminDeletePublishingEntity>;
export type SuperAdminDeletePublishingEntityMutationResult = Apollo.MutationResult<SuperAdminDeletePublishingEntity>;
export type SuperAdminDeletePublishingEntityMutationOptions = Apollo.BaseMutationOptions<SuperAdminDeletePublishingEntity, SuperAdminDeletePublishingEntityVariables>;
export const SuperAdminDeleteShortUrlDocument = gql`
    mutation SuperAdminDeleteShortUrl($shortUrlId: ID!) {
  superAdminDeleteShortUrl(shortUrlId: $shortUrlId)
}
    `;
export type SuperAdminDeleteShortUrlMutationFn = Apollo.MutationFunction<SuperAdminDeleteShortUrl, SuperAdminDeleteShortUrlVariables>;

/**
 * __useSuperAdminDeleteShortUrl__
 *
 * To run a mutation, you first call `useSuperAdminDeleteShortUrl` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminDeleteShortUrl` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminDeleteShortUrl, { data, loading, error }] = useSuperAdminDeleteShortUrl({
 *   variables: {
 *      shortUrlId: // value for 'shortUrlId'
 *   },
 * });
 */
export function useSuperAdminDeleteShortUrl(baseOptions?: Apollo.MutationHookOptions<SuperAdminDeleteShortUrl, SuperAdminDeleteShortUrlVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminDeleteShortUrl, SuperAdminDeleteShortUrlVariables>(SuperAdminDeleteShortUrlDocument, options);
      }
export type SuperAdminDeleteShortUrlHookResult = ReturnType<typeof useSuperAdminDeleteShortUrl>;
export type SuperAdminDeleteShortUrlMutationResult = Apollo.MutationResult<SuperAdminDeleteShortUrl>;
export type SuperAdminDeleteShortUrlMutationOptions = Apollo.BaseMutationOptions<SuperAdminDeleteShortUrl, SuperAdminDeleteShortUrlVariables>;
export const SuperAdminDeleteThirdPartyRecordDocument = gql`
    mutation superAdminDeleteThirdPartyRecord($thirdPartyRecordId: ID!) {
  superAdminDeleteThirdPartyRecord(thirdPartyRecordId: $thirdPartyRecordId)
}
    `;
export type SuperAdminDeleteThirdPartyRecordMutationFn = Apollo.MutationFunction<SuperAdminDeleteThirdPartyRecord, SuperAdminDeleteThirdPartyRecordVariables>;

/**
 * __useSuperAdminDeleteThirdPartyRecord__
 *
 * To run a mutation, you first call `useSuperAdminDeleteThirdPartyRecord` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminDeleteThirdPartyRecord` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminDeleteThirdPartyRecord, { data, loading, error }] = useSuperAdminDeleteThirdPartyRecord({
 *   variables: {
 *      thirdPartyRecordId: // value for 'thirdPartyRecordId'
 *   },
 * });
 */
export function useSuperAdminDeleteThirdPartyRecord(baseOptions?: Apollo.MutationHookOptions<SuperAdminDeleteThirdPartyRecord, SuperAdminDeleteThirdPartyRecordVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminDeleteThirdPartyRecord, SuperAdminDeleteThirdPartyRecordVariables>(SuperAdminDeleteThirdPartyRecordDocument, options);
      }
export type SuperAdminDeleteThirdPartyRecordHookResult = ReturnType<typeof useSuperAdminDeleteThirdPartyRecord>;
export type SuperAdminDeleteThirdPartyRecordMutationResult = Apollo.MutationResult<SuperAdminDeleteThirdPartyRecord>;
export type SuperAdminDeleteThirdPartyRecordMutationOptions = Apollo.BaseMutationOptions<SuperAdminDeleteThirdPartyRecord, SuperAdminDeleteThirdPartyRecordVariables>;
export const SuperAdminDownloadBenchmarkReporRequesttDataDocument = gql`
    mutation SuperAdminDownloadBenchmarkReporRequesttData($requestId: ID!) {
  superAdminDownloadBenchmarkReportRequestData(requestId: $requestId)
}
    `;
export type SuperAdminDownloadBenchmarkReporRequesttDataMutationFn = Apollo.MutationFunction<SuperAdminDownloadBenchmarkReporRequesttData, SuperAdminDownloadBenchmarkReporRequesttDataVariables>;

/**
 * __useSuperAdminDownloadBenchmarkReporRequesttData__
 *
 * To run a mutation, you first call `useSuperAdminDownloadBenchmarkReporRequesttData` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminDownloadBenchmarkReporRequesttData` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminDownloadBenchmarkReporRequesttData, { data, loading, error }] = useSuperAdminDownloadBenchmarkReporRequesttData({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useSuperAdminDownloadBenchmarkReporRequesttData(baseOptions?: Apollo.MutationHookOptions<SuperAdminDownloadBenchmarkReporRequesttData, SuperAdminDownloadBenchmarkReporRequesttDataVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminDownloadBenchmarkReporRequesttData, SuperAdminDownloadBenchmarkReporRequesttDataVariables>(SuperAdminDownloadBenchmarkReporRequesttDataDocument, options);
      }
export type SuperAdminDownloadBenchmarkReporRequesttDataHookResult = ReturnType<typeof useSuperAdminDownloadBenchmarkReporRequesttData>;
export type SuperAdminDownloadBenchmarkReporRequesttDataMutationResult = Apollo.MutationResult<SuperAdminDownloadBenchmarkReporRequesttData>;
export type SuperAdminDownloadBenchmarkReporRequesttDataMutationOptions = Apollo.BaseMutationOptions<SuperAdminDownloadBenchmarkReporRequesttData, SuperAdminDownloadBenchmarkReporRequesttDataVariables>;
export const SuperAdminGenerateContentSetShortUrlsDocument = gql`
    mutation SuperAdminGenerateContentSetShortUrls($setId: ID!, $parameters: [NewShortUrlParameters!]!) {
  superAdminGenerateContentSetShortUrls(setId: $setId, parameters: $parameters) {
    __typename
    ... on ContentSetBase {
      id
      shortUrls {
        id
        shortUrl
        fullUrl
      }
    }
  }
}
    `;
export type SuperAdminGenerateContentSetShortUrlsMutationFn = Apollo.MutationFunction<SuperAdminGenerateContentSetShortUrls, SuperAdminGenerateContentSetShortUrlsVariables>;

/**
 * __useSuperAdminGenerateContentSetShortUrls__
 *
 * To run a mutation, you first call `useSuperAdminGenerateContentSetShortUrls` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminGenerateContentSetShortUrls` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminGenerateContentSetShortUrls, { data, loading, error }] = useSuperAdminGenerateContentSetShortUrls({
 *   variables: {
 *      setId: // value for 'setId'
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useSuperAdminGenerateContentSetShortUrls(baseOptions?: Apollo.MutationHookOptions<SuperAdminGenerateContentSetShortUrls, SuperAdminGenerateContentSetShortUrlsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminGenerateContentSetShortUrls, SuperAdminGenerateContentSetShortUrlsVariables>(SuperAdminGenerateContentSetShortUrlsDocument, options);
      }
export type SuperAdminGenerateContentSetShortUrlsHookResult = ReturnType<typeof useSuperAdminGenerateContentSetShortUrls>;
export type SuperAdminGenerateContentSetShortUrlsMutationResult = Apollo.MutationResult<SuperAdminGenerateContentSetShortUrls>;
export type SuperAdminGenerateContentSetShortUrlsMutationOptions = Apollo.BaseMutationOptions<SuperAdminGenerateContentSetShortUrls, SuperAdminGenerateContentSetShortUrlsVariables>;
export const SuperAdminImportTranslationsDocument = gql`
    mutation SuperAdminImportTranslations($surveyId: ID!, $translationSets: [TranslationSet!]!) {
  superAdminImportTranslations(
    surveyId: $surveyId
    translationSets: $translationSets
  )
}
    `;
export type SuperAdminImportTranslationsMutationFn = Apollo.MutationFunction<SuperAdminImportTranslations, SuperAdminImportTranslationsVariables>;

/**
 * __useSuperAdminImportTranslations__
 *
 * To run a mutation, you first call `useSuperAdminImportTranslations` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminImportTranslations` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminImportTranslations, { data, loading, error }] = useSuperAdminImportTranslations({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      translationSets: // value for 'translationSets'
 *   },
 * });
 */
export function useSuperAdminImportTranslations(baseOptions?: Apollo.MutationHookOptions<SuperAdminImportTranslations, SuperAdminImportTranslationsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminImportTranslations, SuperAdminImportTranslationsVariables>(SuperAdminImportTranslationsDocument, options);
      }
export type SuperAdminImportTranslationsHookResult = ReturnType<typeof useSuperAdminImportTranslations>;
export type SuperAdminImportTranslationsMutationResult = Apollo.MutationResult<SuperAdminImportTranslations>;
export type SuperAdminImportTranslationsMutationOptions = Apollo.BaseMutationOptions<SuperAdminImportTranslations, SuperAdminImportTranslationsVariables>;
export const SuperAdminPublishBenchmarkReportRequestDocument = gql`
    mutation superAdminPublishBenchmarkReportRequest($id: ID!) {
  superAdminPublishBenchmarkReportRequest(requestId: $id) {
    id
    status
  }
}
    `;
export type SuperAdminPublishBenchmarkReportRequestMutationFn = Apollo.MutationFunction<SuperAdminPublishBenchmarkReportRequest, SuperAdminPublishBenchmarkReportRequestVariables>;

/**
 * __useSuperAdminPublishBenchmarkReportRequest__
 *
 * To run a mutation, you first call `useSuperAdminPublishBenchmarkReportRequest` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminPublishBenchmarkReportRequest` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminPublishBenchmarkReportRequest, { data, loading, error }] = useSuperAdminPublishBenchmarkReportRequest({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuperAdminPublishBenchmarkReportRequest(baseOptions?: Apollo.MutationHookOptions<SuperAdminPublishBenchmarkReportRequest, SuperAdminPublishBenchmarkReportRequestVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminPublishBenchmarkReportRequest, SuperAdminPublishBenchmarkReportRequestVariables>(SuperAdminPublishBenchmarkReportRequestDocument, options);
      }
export type SuperAdminPublishBenchmarkReportRequestHookResult = ReturnType<typeof useSuperAdminPublishBenchmarkReportRequest>;
export type SuperAdminPublishBenchmarkReportRequestMutationResult = Apollo.MutationResult<SuperAdminPublishBenchmarkReportRequest>;
export type SuperAdminPublishBenchmarkReportRequestMutationOptions = Apollo.BaseMutationOptions<SuperAdminPublishBenchmarkReportRequest, SuperAdminPublishBenchmarkReportRequestVariables>;
export const SuperAdminRejectRegistrationDocument = gql`
    mutation SuperAdminRejectRegistration($registrationId: ID!) {
  superAdminRejectRegistration(registrationId: $registrationId) {
    id
  }
}
    `;
export type SuperAdminRejectRegistrationMutationFn = Apollo.MutationFunction<SuperAdminRejectRegistration, SuperAdminRejectRegistrationVariables>;

/**
 * __useSuperAdminRejectRegistration__
 *
 * To run a mutation, you first call `useSuperAdminRejectRegistration` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminRejectRegistration` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminRejectRegistration, { data, loading, error }] = useSuperAdminRejectRegistration({
 *   variables: {
 *      registrationId: // value for 'registrationId'
 *   },
 * });
 */
export function useSuperAdminRejectRegistration(baseOptions?: Apollo.MutationHookOptions<SuperAdminRejectRegistration, SuperAdminRejectRegistrationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminRejectRegistration, SuperAdminRejectRegistrationVariables>(SuperAdminRejectRegistrationDocument, options);
      }
export type SuperAdminRejectRegistrationHookResult = ReturnType<typeof useSuperAdminRejectRegistration>;
export type SuperAdminRejectRegistrationMutationResult = Apollo.MutationResult<SuperAdminRejectRegistration>;
export type SuperAdminRejectRegistrationMutationOptions = Apollo.BaseMutationOptions<SuperAdminRejectRegistration, SuperAdminRejectRegistrationVariables>;
export const SuperAdminRemovePublisherPresidingAreaDocument = gql`
    mutation SuperAdminRemovePublisherPresidingArea($publishingEntityId: ID!) {
  superAdminUpdatePresidingArea(
    publishingEntityId: $publishingEntityId
    area: null
  ) {
    id
    presidingArea {
      id
      center {
        coordinate {
          lat
          lng
        }
        size
      }
      shape {
        type
        coordinates
      }
      name
    }
  }
}
    `;
export type SuperAdminRemovePublisherPresidingAreaMutationFn = Apollo.MutationFunction<SuperAdminRemovePublisherPresidingArea, SuperAdminRemovePublisherPresidingAreaVariables>;

/**
 * __useSuperAdminRemovePublisherPresidingArea__
 *
 * To run a mutation, you first call `useSuperAdminRemovePublisherPresidingArea` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminRemovePublisherPresidingArea` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminRemovePublisherPresidingArea, { data, loading, error }] = useSuperAdminRemovePublisherPresidingArea({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useSuperAdminRemovePublisherPresidingArea(baseOptions?: Apollo.MutationHookOptions<SuperAdminRemovePublisherPresidingArea, SuperAdminRemovePublisherPresidingAreaVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminRemovePublisherPresidingArea, SuperAdminRemovePublisherPresidingAreaVariables>(SuperAdminRemovePublisherPresidingAreaDocument, options);
      }
export type SuperAdminRemovePublisherPresidingAreaHookResult = ReturnType<typeof useSuperAdminRemovePublisherPresidingArea>;
export type SuperAdminRemovePublisherPresidingAreaMutationResult = Apollo.MutationResult<SuperAdminRemovePublisherPresidingArea>;
export type SuperAdminRemovePublisherPresidingAreaMutationOptions = Apollo.BaseMutationOptions<SuperAdminRemovePublisherPresidingArea, SuperAdminRemovePublisherPresidingAreaVariables>;
export const SuperAdminRemoveSuperAdminDocument = gql`
    mutation superAdminRemoveSuperAdmin($adminId: ID!) {
  superAdminRemoveSuperAdmin(adminId: $adminId)
}
    `;
export type SuperAdminRemoveSuperAdminMutationFn = Apollo.MutationFunction<SuperAdminRemoveSuperAdmin, SuperAdminRemoveSuperAdminVariables>;

/**
 * __useSuperAdminRemoveSuperAdmin__
 *
 * To run a mutation, you first call `useSuperAdminRemoveSuperAdmin` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminRemoveSuperAdmin` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminRemoveSuperAdmin, { data, loading, error }] = useSuperAdminRemoveSuperAdmin({
 *   variables: {
 *      adminId: // value for 'adminId'
 *   },
 * });
 */
export function useSuperAdminRemoveSuperAdmin(baseOptions?: Apollo.MutationHookOptions<SuperAdminRemoveSuperAdmin, SuperAdminRemoveSuperAdminVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminRemoveSuperAdmin, SuperAdminRemoveSuperAdminVariables>(SuperAdminRemoveSuperAdminDocument, options);
      }
export type SuperAdminRemoveSuperAdminHookResult = ReturnType<typeof useSuperAdminRemoveSuperAdmin>;
export type SuperAdminRemoveSuperAdminMutationResult = Apollo.MutationResult<SuperAdminRemoveSuperAdmin>;
export type SuperAdminRemoveSuperAdminMutationOptions = Apollo.BaseMutationOptions<SuperAdminRemoveSuperAdmin, SuperAdminRemoveSuperAdminVariables>;
export const SuperAdminReorderReportTabsDocument = gql`
    mutation SuperAdminReorderReportTabs($setId: ID!, $tabOrder: [ID!]!) {
  superAdminReorderReportTabs(setId: $setId, tabOrder: $tabOrder) {
    __typename
    ... on ContentSetBase {
      id
      name {
        ...multilang
      }
      reportTabs(publiclyShared: false) {
        id
        title
        visibleToAdmins
        order
        content {
          type
          HTML
          TABLEAU
          height
        }
      }
    }
  }
}
    ${Multilang}`;
export type SuperAdminReorderReportTabsMutationFn = Apollo.MutationFunction<SuperAdminReorderReportTabs, SuperAdminReorderReportTabsVariables>;

/**
 * __useSuperAdminReorderReportTabs__
 *
 * To run a mutation, you first call `useSuperAdminReorderReportTabs` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminReorderReportTabs` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminReorderReportTabs, { data, loading, error }] = useSuperAdminReorderReportTabs({
 *   variables: {
 *      setId: // value for 'setId'
 *      tabOrder: // value for 'tabOrder'
 *   },
 * });
 */
export function useSuperAdminReorderReportTabs(baseOptions?: Apollo.MutationHookOptions<SuperAdminReorderReportTabs, SuperAdminReorderReportTabsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminReorderReportTabs, SuperAdminReorderReportTabsVariables>(SuperAdminReorderReportTabsDocument, options);
      }
export type SuperAdminReorderReportTabsHookResult = ReturnType<typeof useSuperAdminReorderReportTabs>;
export type SuperAdminReorderReportTabsMutationResult = Apollo.MutationResult<SuperAdminReorderReportTabs>;
export type SuperAdminReorderReportTabsMutationOptions = Apollo.BaseMutationOptions<SuperAdminReorderReportTabs, SuperAdminReorderReportTabsVariables>;
export const SuperAdminResetFeatureSettingsDocument = gql`
    mutation SuperAdminResetFeatureSettings($publishingEntityId: ID!, $resetState: ResetFeatureSettingState) {
  superAdminResetFeatureSettings(
    publishingEntityId: $publishingEntityId
    resetState: $resetState
  ) {
    id
    featureSettingId
    featureSettingName
    enabled
    expirationDate {
      raw
    }
  }
}
    `;
export type SuperAdminResetFeatureSettingsMutationFn = Apollo.MutationFunction<SuperAdminResetFeatureSettings, SuperAdminResetFeatureSettingsVariables>;

/**
 * __useSuperAdminResetFeatureSettings__
 *
 * To run a mutation, you first call `useSuperAdminResetFeatureSettings` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminResetFeatureSettings` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminResetFeatureSettings, { data, loading, error }] = useSuperAdminResetFeatureSettings({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      resetState: // value for 'resetState'
 *   },
 * });
 */
export function useSuperAdminResetFeatureSettings(baseOptions?: Apollo.MutationHookOptions<SuperAdminResetFeatureSettings, SuperAdminResetFeatureSettingsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminResetFeatureSettings, SuperAdminResetFeatureSettingsVariables>(SuperAdminResetFeatureSettingsDocument, options);
      }
export type SuperAdminResetFeatureSettingsHookResult = ReturnType<typeof useSuperAdminResetFeatureSettings>;
export type SuperAdminResetFeatureSettingsMutationResult = Apollo.MutationResult<SuperAdminResetFeatureSettings>;
export type SuperAdminResetFeatureSettingsMutationOptions = Apollo.BaseMutationOptions<SuperAdminResetFeatureSettings, SuperAdminResetFeatureSettingsVariables>;
export const SuperAdminSetPurchaseStatusDocument = gql`
    mutation SuperAdminSetPurchaseStatus($purchaseId: ID!, $markPaid: Boolean!) {
  superAdminSetPurchaseStatus(purchaseId: $purchaseId, markPaid: $markPaid) {
    id
    createdAt {
      raw
    }
    publishingEntity {
      id
      name {
        ...multilang
      }
    }
    storeItem {
      id
      name
      provider
    }
    purchasedByAdmin {
      ... on AdminBase {
        id
        name
      }
    }
    price
    status
  }
}
    ${Multilang}`;
export type SuperAdminSetPurchaseStatusMutationFn = Apollo.MutationFunction<SuperAdminSetPurchaseStatus, SuperAdminSetPurchaseStatusVariables>;

/**
 * __useSuperAdminSetPurchaseStatus__
 *
 * To run a mutation, you first call `useSuperAdminSetPurchaseStatus` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminSetPurchaseStatus` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminSetPurchaseStatus, { data, loading, error }] = useSuperAdminSetPurchaseStatus({
 *   variables: {
 *      purchaseId: // value for 'purchaseId'
 *      markPaid: // value for 'markPaid'
 *   },
 * });
 */
export function useSuperAdminSetPurchaseStatus(baseOptions?: Apollo.MutationHookOptions<SuperAdminSetPurchaseStatus, SuperAdminSetPurchaseStatusVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminSetPurchaseStatus, SuperAdminSetPurchaseStatusVariables>(SuperAdminSetPurchaseStatusDocument, options);
      }
export type SuperAdminSetPurchaseStatusHookResult = ReturnType<typeof useSuperAdminSetPurchaseStatus>;
export type SuperAdminSetPurchaseStatusMutationResult = Apollo.MutationResult<SuperAdminSetPurchaseStatus>;
export type SuperAdminSetPurchaseStatusMutationOptions = Apollo.BaseMutationOptions<SuperAdminSetPurchaseStatus, SuperAdminSetPurchaseStatusVariables>;
export const SuperAdminTogglePublishingEntityFeatureSettingDocument = gql`
    mutation SuperAdminTogglePublishingEntityFeatureSetting($publishingEntityId: ID!, $featureSettingId: ID!, $dateToEnableUntil: GqlDateInput, $quantity: Int, $isUnlimited: Boolean) {
  superAdminTogglePublishingEntityFeatureSetting(
    publishingEntityId: $publishingEntityId
    featureSettingId: $featureSettingId
    dateToEnableUntil: $dateToEnableUntil
    quantity: $quantity
    isUnlimited: $isUnlimited
  ) {
    id
    featureSettingId
    featureSettingName
    enabled
    quantity
    isUnlimited
    expirationDate {
      raw
    }
  }
}
    `;
export type SuperAdminTogglePublishingEntityFeatureSettingMutationFn = Apollo.MutationFunction<SuperAdminTogglePublishingEntityFeatureSetting, SuperAdminTogglePublishingEntityFeatureSettingVariables>;

/**
 * __useSuperAdminTogglePublishingEntityFeatureSetting__
 *
 * To run a mutation, you first call `useSuperAdminTogglePublishingEntityFeatureSetting` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminTogglePublishingEntityFeatureSetting` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminTogglePublishingEntityFeatureSetting, { data, loading, error }] = useSuperAdminTogglePublishingEntityFeatureSetting({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      featureSettingId: // value for 'featureSettingId'
 *      dateToEnableUntil: // value for 'dateToEnableUntil'
 *      quantity: // value for 'quantity'
 *      isUnlimited: // value for 'isUnlimited'
 *   },
 * });
 */
export function useSuperAdminTogglePublishingEntityFeatureSetting(baseOptions?: Apollo.MutationHookOptions<SuperAdminTogglePublishingEntityFeatureSetting, SuperAdminTogglePublishingEntityFeatureSettingVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminTogglePublishingEntityFeatureSetting, SuperAdminTogglePublishingEntityFeatureSettingVariables>(SuperAdminTogglePublishingEntityFeatureSettingDocument, options);
      }
export type SuperAdminTogglePublishingEntityFeatureSettingHookResult = ReturnType<typeof useSuperAdminTogglePublishingEntityFeatureSetting>;
export type SuperAdminTogglePublishingEntityFeatureSettingMutationResult = Apollo.MutationResult<SuperAdminTogglePublishingEntityFeatureSetting>;
export type SuperAdminTogglePublishingEntityFeatureSettingMutationOptions = Apollo.BaseMutationOptions<SuperAdminTogglePublishingEntityFeatureSetting, SuperAdminTogglePublishingEntityFeatureSettingVariables>;
export const SuperAdminTogglePublishingEntityFeatureSettingsDocument = gql`
    mutation SuperAdminTogglePublishingEntityFeatureSettings($publishingEntityId: ID!, $featureSettings: [FeatureSettingInput!]!) {
  superAdminTogglePublishingEntityFeatureSettings(
    publishingEntityId: $publishingEntityId
    featureSettings: $featureSettings
  ) {
    id
    featureSettingId
    featureSettingName
    enabled
    quantity
    isUnlimited
    expirationDate {
      raw
    }
  }
}
    `;
export type SuperAdminTogglePublishingEntityFeatureSettingsMutationFn = Apollo.MutationFunction<SuperAdminTogglePublishingEntityFeatureSettings, SuperAdminTogglePublishingEntityFeatureSettingsVariables>;

/**
 * __useSuperAdminTogglePublishingEntityFeatureSettings__
 *
 * To run a mutation, you first call `useSuperAdminTogglePublishingEntityFeatureSettings` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminTogglePublishingEntityFeatureSettings` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminTogglePublishingEntityFeatureSettings, { data, loading, error }] = useSuperAdminTogglePublishingEntityFeatureSettings({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      featureSettings: // value for 'featureSettings'
 *   },
 * });
 */
export function useSuperAdminTogglePublishingEntityFeatureSettings(baseOptions?: Apollo.MutationHookOptions<SuperAdminTogglePublishingEntityFeatureSettings, SuperAdminTogglePublishingEntityFeatureSettingsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminTogglePublishingEntityFeatureSettings, SuperAdminTogglePublishingEntityFeatureSettingsVariables>(SuperAdminTogglePublishingEntityFeatureSettingsDocument, options);
      }
export type SuperAdminTogglePublishingEntityFeatureSettingsHookResult = ReturnType<typeof useSuperAdminTogglePublishingEntityFeatureSettings>;
export type SuperAdminTogglePublishingEntityFeatureSettingsMutationResult = Apollo.MutationResult<SuperAdminTogglePublishingEntityFeatureSettings>;
export type SuperAdminTogglePublishingEntityFeatureSettingsMutationOptions = Apollo.BaseMutationOptions<SuperAdminTogglePublishingEntityFeatureSettings, SuperAdminTogglePublishingEntityFeatureSettingsVariables>;
export const SuperAdminUpdateContentSetReportTabDocument = gql`
    mutation SuperAdminUpdateContentSetReportTab($setId: ID!, $input: ReportTabUpdateInput!) {
  superAdminUpdateContentSetReportTab(setId: $setId, input: $input) {
    id
    title
    visibleToAdmins
    order
    content {
      type
      HTML
      TABLEAU
      height
    }
    trackDomain
  }
}
    `;
export type SuperAdminUpdateContentSetReportTabMutationFn = Apollo.MutationFunction<SuperAdminUpdateContentSetReportTab, SuperAdminUpdateContentSetReportTabVariables>;

/**
 * __useSuperAdminUpdateContentSetReportTab__
 *
 * To run a mutation, you first call `useSuperAdminUpdateContentSetReportTab` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminUpdateContentSetReportTab` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminUpdateContentSetReportTab, { data, loading, error }] = useSuperAdminUpdateContentSetReportTab({
 *   variables: {
 *      setId: // value for 'setId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuperAdminUpdateContentSetReportTab(baseOptions?: Apollo.MutationHookOptions<SuperAdminUpdateContentSetReportTab, SuperAdminUpdateContentSetReportTabVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminUpdateContentSetReportTab, SuperAdminUpdateContentSetReportTabVariables>(SuperAdminUpdateContentSetReportTabDocument, options);
      }
export type SuperAdminUpdateContentSetReportTabHookResult = ReturnType<typeof useSuperAdminUpdateContentSetReportTab>;
export type SuperAdminUpdateContentSetReportTabMutationResult = Apollo.MutationResult<SuperAdminUpdateContentSetReportTab>;
export type SuperAdminUpdateContentSetReportTabMutationOptions = Apollo.BaseMutationOptions<SuperAdminUpdateContentSetReportTab, SuperAdminUpdateContentSetReportTabVariables>;
export const SuperAdminUpdatePublisherAttributesDocument = gql`
    mutation SuperAdminUpdatePublisherAttributes($publishingEntityId: ID!, $attributes: SuperAdminPublisherAttributesInput!) {
  superAdminUpdatePublisherAttributes(
    publishingEntityId: $publishingEntityId
    attributes: $attributes
  ) {
    id
    fipsArea {
      id
    }
    envisioSetting {
      id
      instanceId
      magicToken
    }
    balancingActCustomer {
      id
    }
    isEnterprise
  }
}
    `;
export type SuperAdminUpdatePublisherAttributesMutationFn = Apollo.MutationFunction<SuperAdminUpdatePublisherAttributes, SuperAdminUpdatePublisherAttributesVariables>;

/**
 * __useSuperAdminUpdatePublisherAttributes__
 *
 * To run a mutation, you first call `useSuperAdminUpdatePublisherAttributes` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminUpdatePublisherAttributes` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminUpdatePublisherAttributes, { data, loading, error }] = useSuperAdminUpdatePublisherAttributes({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useSuperAdminUpdatePublisherAttributes(baseOptions?: Apollo.MutationHookOptions<SuperAdminUpdatePublisherAttributes, SuperAdminUpdatePublisherAttributesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminUpdatePublisherAttributes, SuperAdminUpdatePublisherAttributesVariables>(SuperAdminUpdatePublisherAttributesDocument, options);
      }
export type SuperAdminUpdatePublisherAttributesHookResult = ReturnType<typeof useSuperAdminUpdatePublisherAttributes>;
export type SuperAdminUpdatePublisherAttributesMutationResult = Apollo.MutationResult<SuperAdminUpdatePublisherAttributes>;
export type SuperAdminUpdatePublisherAttributesMutationOptions = Apollo.BaseMutationOptions<SuperAdminUpdatePublisherAttributes, SuperAdminUpdatePublisherAttributesVariables>;
export const SuperAdminUpdatePublisherPresidingAreaDocument = gql`
    mutation SuperAdminUpdatePublisherPresidingArea($publishingEntityId: ID!, $areaShape: GeoJsonMultiPolygonInput, $areaName: String!) {
  superAdminUpdatePresidingArea(
    publishingEntityId: $publishingEntityId
    area: {shape: $areaShape, name: $areaName}
  ) {
    id
    presidingArea {
      id
      center {
        coordinate {
          lat
          lng
        }
        size
      }
      shape {
        type
        coordinates
      }
      name
    }
  }
}
    `;
export type SuperAdminUpdatePublisherPresidingAreaMutationFn = Apollo.MutationFunction<SuperAdminUpdatePublisherPresidingArea, SuperAdminUpdatePublisherPresidingAreaVariables>;

/**
 * __useSuperAdminUpdatePublisherPresidingArea__
 *
 * To run a mutation, you first call `useSuperAdminUpdatePublisherPresidingArea` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminUpdatePublisherPresidingArea` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminUpdatePublisherPresidingArea, { data, loading, error }] = useSuperAdminUpdatePublisherPresidingArea({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      areaShape: // value for 'areaShape'
 *      areaName: // value for 'areaName'
 *   },
 * });
 */
export function useSuperAdminUpdatePublisherPresidingArea(baseOptions?: Apollo.MutationHookOptions<SuperAdminUpdatePublisherPresidingArea, SuperAdminUpdatePublisherPresidingAreaVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminUpdatePublisherPresidingArea, SuperAdminUpdatePublisherPresidingAreaVariables>(SuperAdminUpdatePublisherPresidingAreaDocument, options);
      }
export type SuperAdminUpdatePublisherPresidingAreaHookResult = ReturnType<typeof useSuperAdminUpdatePublisherPresidingArea>;
export type SuperAdminUpdatePublisherPresidingAreaMutationResult = Apollo.MutationResult<SuperAdminUpdatePublisherPresidingArea>;
export type SuperAdminUpdatePublisherPresidingAreaMutationOptions = Apollo.BaseMutationOptions<SuperAdminUpdatePublisherPresidingArea, SuperAdminUpdatePublisherPresidingAreaVariables>;
export const SuperAdminUpdateShortUrlDocument = gql`
    mutation SuperAdminUpdateShortUrl($shortUrlId: ID!, $updatedShortUrl: String!) {
  superAdminUpdateShortUrl(
    shortUrlId: $shortUrlId
    updatedShortUrl: $updatedShortUrl
  ) {
    id
    shortUrl
    fullUrl
  }
}
    `;
export type SuperAdminUpdateShortUrlMutationFn = Apollo.MutationFunction<SuperAdminUpdateShortUrl, SuperAdminUpdateShortUrlVariables>;

/**
 * __useSuperAdminUpdateShortUrl__
 *
 * To run a mutation, you first call `useSuperAdminUpdateShortUrl` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminUpdateShortUrl` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminUpdateShortUrl, { data, loading, error }] = useSuperAdminUpdateShortUrl({
 *   variables: {
 *      shortUrlId: // value for 'shortUrlId'
 *      updatedShortUrl: // value for 'updatedShortUrl'
 *   },
 * });
 */
export function useSuperAdminUpdateShortUrl(baseOptions?: Apollo.MutationHookOptions<SuperAdminUpdateShortUrl, SuperAdminUpdateShortUrlVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminUpdateShortUrl, SuperAdminUpdateShortUrlVariables>(SuperAdminUpdateShortUrlDocument, options);
      }
export type SuperAdminUpdateShortUrlHookResult = ReturnType<typeof useSuperAdminUpdateShortUrl>;
export type SuperAdminUpdateShortUrlMutationResult = Apollo.MutationResult<SuperAdminUpdateShortUrl>;
export type SuperAdminUpdateShortUrlMutationOptions = Apollo.BaseMutationOptions<SuperAdminUpdateShortUrl, SuperAdminUpdateShortUrlVariables>;
export const SuperAdminUpdateThirdPartyRecordDocument = gql`
    mutation superAdminUpdateThirdPartyRecord($input: ThirdPartyRecordInput!, $thirdPartyRecordId: ID!) {
  superAdminUpdateThirdPartyRecord(
    input: $input
    thirdPartyRecordId: $thirdPartyRecordId
  ) {
    id
    thirdParty
    thirdPartyIdentifier
  }
}
    `;
export type SuperAdminUpdateThirdPartyRecordMutationFn = Apollo.MutationFunction<SuperAdminUpdateThirdPartyRecord, SuperAdminUpdateThirdPartyRecordVariables>;

/**
 * __useSuperAdminUpdateThirdPartyRecord__
 *
 * To run a mutation, you first call `useSuperAdminUpdateThirdPartyRecord` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminUpdateThirdPartyRecord` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminUpdateThirdPartyRecord, { data, loading, error }] = useSuperAdminUpdateThirdPartyRecord({
 *   variables: {
 *      input: // value for 'input'
 *      thirdPartyRecordId: // value for 'thirdPartyRecordId'
 *   },
 * });
 */
export function useSuperAdminUpdateThirdPartyRecord(baseOptions?: Apollo.MutationHookOptions<SuperAdminUpdateThirdPartyRecord, SuperAdminUpdateThirdPartyRecordVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminUpdateThirdPartyRecord, SuperAdminUpdateThirdPartyRecordVariables>(SuperAdminUpdateThirdPartyRecordDocument, options);
      }
export type SuperAdminUpdateThirdPartyRecordHookResult = ReturnType<typeof useSuperAdminUpdateThirdPartyRecord>;
export type SuperAdminUpdateThirdPartyRecordMutationResult = Apollo.MutationResult<SuperAdminUpdateThirdPartyRecord>;
export type SuperAdminUpdateThirdPartyRecordMutationOptions = Apollo.BaseMutationOptions<SuperAdminUpdateThirdPartyRecord, SuperAdminUpdateThirdPartyRecordVariables>;
export const SuperAdminUploadContentSetShortUrlsDocument = gql`
    mutation SuperAdminUploadContentSetShortUrls($setId: ID!, $shortUrls: [UploadShortUrlInput!]!) {
  superAdminUploadContentSetShortUrls(setId: $setId, shortUrls: $shortUrls)
}
    `;
export type SuperAdminUploadContentSetShortUrlsMutationFn = Apollo.MutationFunction<SuperAdminUploadContentSetShortUrls, SuperAdminUploadContentSetShortUrlsVariables>;

/**
 * __useSuperAdminUploadContentSetShortUrls__
 *
 * To run a mutation, you first call `useSuperAdminUploadContentSetShortUrls` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminUploadContentSetShortUrls` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminUploadContentSetShortUrls, { data, loading, error }] = useSuperAdminUploadContentSetShortUrls({
 *   variables: {
 *      setId: // value for 'setId'
 *      shortUrls: // value for 'shortUrls'
 *   },
 * });
 */
export function useSuperAdminUploadContentSetShortUrls(baseOptions?: Apollo.MutationHookOptions<SuperAdminUploadContentSetShortUrls, SuperAdminUploadContentSetShortUrlsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminUploadContentSetShortUrls, SuperAdminUploadContentSetShortUrlsVariables>(SuperAdminUploadContentSetShortUrlsDocument, options);
      }
export type SuperAdminUploadContentSetShortUrlsHookResult = ReturnType<typeof useSuperAdminUploadContentSetShortUrls>;
export type SuperAdminUploadContentSetShortUrlsMutationResult = Apollo.MutationResult<SuperAdminUploadContentSetShortUrls>;
export type SuperAdminUploadContentSetShortUrlsMutationOptions = Apollo.BaseMutationOptions<SuperAdminUploadContentSetShortUrls, SuperAdminUploadContentSetShortUrlsVariables>;
export const SuperAdminUpsertBenchmarkReportRequestDocument = gql`
    mutation superAdminUpsertBenchmarkReportRequest($input: BenchmarkReportRequestInput!) {
  superAdminUpsertBenchmarkReportRequest(data: $input) {
    id
    status
    publishingEntity {
      id
      name {
        ...multilang
      }
    }
    benchmarkSurveyType
    startAt {
      raw
    }
    closedAt {
      raw
    }
    clientDueAt {
      raw
    }
    reportDueAt {
      raw
    }
    surveyFormat
    trendsExpected
    expectedTrendYears
    fips
    customBenchmarks
    additionalNotes
    mailedCount
    emailedCount
    eligibleSamplingResponseCount
    responseRate
    questionSetData {
      id
      contentSet {
        __typename
        ... on ContentSetBase {
          id
          name {
            ...multilang
          }
        }
      }
      language
      optIn
      weighted
    }
    areaData {
      id
      name
      value
      group
      weight
    }
  }
}
    ${Multilang}`;
export type SuperAdminUpsertBenchmarkReportRequestMutationFn = Apollo.MutationFunction<SuperAdminUpsertBenchmarkReportRequest, SuperAdminUpsertBenchmarkReportRequestVariables>;

/**
 * __useSuperAdminUpsertBenchmarkReportRequest__
 *
 * To run a mutation, you first call `useSuperAdminUpsertBenchmarkReportRequest` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminUpsertBenchmarkReportRequest` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminUpsertBenchmarkReportRequest, { data, loading, error }] = useSuperAdminUpsertBenchmarkReportRequest({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuperAdminUpsertBenchmarkReportRequest(baseOptions?: Apollo.MutationHookOptions<SuperAdminUpsertBenchmarkReportRequest, SuperAdminUpsertBenchmarkReportRequestVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminUpsertBenchmarkReportRequest, SuperAdminUpsertBenchmarkReportRequestVariables>(SuperAdminUpsertBenchmarkReportRequestDocument, options);
      }
export type SuperAdminUpsertBenchmarkReportRequestHookResult = ReturnType<typeof useSuperAdminUpsertBenchmarkReportRequest>;
export type SuperAdminUpsertBenchmarkReportRequestMutationResult = Apollo.MutationResult<SuperAdminUpsertBenchmarkReportRequest>;
export type SuperAdminUpsertBenchmarkReportRequestMutationOptions = Apollo.BaseMutationOptions<SuperAdminUpsertBenchmarkReportRequest, SuperAdminUpsertBenchmarkReportRequestVariables>;
export const VoteForSurveyDocument = gql`
    mutation VoteForSurvey($questionSetId: ID!, $surveyInput: [SurveyVoteInputWithId!]!, $voteMetadata: [VoteMetadataEntry!]!) {
  voteForSurvey(
    questionSetId: $questionSetId
    surveyInput: $surveyInput
    voteMetadata: $voteMetadata
  ) {
    id
    voter {
      ... on RespondentBase {
        id
      }
    }
  }
}
    `;
export type VoteForSurveyMutationFn = Apollo.MutationFunction<VoteForSurvey, VoteForSurveyVariables>;

/**
 * __useVoteForSurvey__
 *
 * To run a mutation, you first call `useVoteForSurvey` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoteForSurvey` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voteForSurvey, { data, loading, error }] = useVoteForSurvey({
 *   variables: {
 *      questionSetId: // value for 'questionSetId'
 *      surveyInput: // value for 'surveyInput'
 *      voteMetadata: // value for 'voteMetadata'
 *   },
 * });
 */
export function useVoteForSurvey(baseOptions?: Apollo.MutationHookOptions<VoteForSurvey, VoteForSurveyVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoteForSurvey, VoteForSurveyVariables>(VoteForSurveyDocument, options);
      }
export type VoteForSurveyHookResult = ReturnType<typeof useVoteForSurvey>;
export type VoteForSurveyMutationResult = Apollo.MutationResult<VoteForSurvey>;
export type VoteForSurveyMutationOptions = Apollo.BaseMutationOptions<VoteForSurvey, VoteForSurveyVariables>;
export const UnUpvoteCommentDocument = gql`
    mutation UnUpvoteComment($questionId: ID!, $commentId: ID!) {
  unUpvoteComment(questionId: $questionId, commentId: $commentId) {
    voteId
    questionId
    direction
    comment {
      id
      upvoteCount
    }
  }
}
    `;
export type UnUpvoteCommentMutationFn = Apollo.MutationFunction<UnUpvoteComment, UnUpvoteCommentVariables>;

/**
 * __useUnUpvoteComment__
 *
 * To run a mutation, you first call `useUnUpvoteComment` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnUpvoteComment` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unUpvoteComment, { data, loading, error }] = useUnUpvoteComment({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useUnUpvoteComment(baseOptions?: Apollo.MutationHookOptions<UnUpvoteComment, UnUpvoteCommentVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnUpvoteComment, UnUpvoteCommentVariables>(UnUpvoteCommentDocument, options);
      }
export type UnUpvoteCommentHookResult = ReturnType<typeof useUnUpvoteComment>;
export type UnUpvoteCommentMutationResult = Apollo.MutationResult<UnUpvoteComment>;
export type UnUpvoteCommentMutationOptions = Apollo.BaseMutationOptions<UnUpvoteComment, UnUpvoteCommentVariables>;
export const UnsubscribeFromAdminShareEmailDocument = gql`
    mutation UnsubscribeFromAdminShareEmail($shareEmailMetadataId: ID!) {
  unsubscribeFromAdminShareEmail(shareEmailMetadataId: $shareEmailMetadataId)
}
    `;
export type UnsubscribeFromAdminShareEmailMutationFn = Apollo.MutationFunction<UnsubscribeFromAdminShareEmail, UnsubscribeFromAdminShareEmailVariables>;

/**
 * __useUnsubscribeFromAdminShareEmail__
 *
 * To run a mutation, you first call `useUnsubscribeFromAdminShareEmail` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeFromAdminShareEmail` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeFromAdminShareEmail, { data, loading, error }] = useUnsubscribeFromAdminShareEmail({
 *   variables: {
 *      shareEmailMetadataId: // value for 'shareEmailMetadataId'
 *   },
 * });
 */
export function useUnsubscribeFromAdminShareEmail(baseOptions?: Apollo.MutationHookOptions<UnsubscribeFromAdminShareEmail, UnsubscribeFromAdminShareEmailVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeFromAdminShareEmail, UnsubscribeFromAdminShareEmailVariables>(UnsubscribeFromAdminShareEmailDocument, options);
      }
export type UnsubscribeFromAdminShareEmailHookResult = ReturnType<typeof useUnsubscribeFromAdminShareEmail>;
export type UnsubscribeFromAdminShareEmailMutationResult = Apollo.MutationResult<UnsubscribeFromAdminShareEmail>;
export type UnsubscribeFromAdminShareEmailMutationOptions = Apollo.BaseMutationOptions<UnsubscribeFromAdminShareEmail, UnsubscribeFromAdminShareEmailVariables>;
export const UnsubscribeFromOutreachEmailDocument = gql`
    mutation UnsubscribeFromOutreachEmail($emailListEntryId: ID!) {
  unsubscribeFromOutreachEmail(emailListEntryId: $emailListEntryId)
}
    `;
export type UnsubscribeFromOutreachEmailMutationFn = Apollo.MutationFunction<UnsubscribeFromOutreachEmail, UnsubscribeFromOutreachEmailVariables>;

/**
 * __useUnsubscribeFromOutreachEmail__
 *
 * To run a mutation, you first call `useUnsubscribeFromOutreachEmail` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeFromOutreachEmail` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeFromOutreachEmail, { data, loading, error }] = useUnsubscribeFromOutreachEmail({
 *   variables: {
 *      emailListEntryId: // value for 'emailListEntryId'
 *   },
 * });
 */
export function useUnsubscribeFromOutreachEmail(baseOptions?: Apollo.MutationHookOptions<UnsubscribeFromOutreachEmail, UnsubscribeFromOutreachEmailVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeFromOutreachEmail, UnsubscribeFromOutreachEmailVariables>(UnsubscribeFromOutreachEmailDocument, options);
      }
export type UnsubscribeFromOutreachEmailHookResult = ReturnType<typeof useUnsubscribeFromOutreachEmail>;
export type UnsubscribeFromOutreachEmailMutationResult = Apollo.MutationResult<UnsubscribeFromOutreachEmail>;
export type UnsubscribeFromOutreachEmailMutationOptions = Apollo.BaseMutationOptions<UnsubscribeFromOutreachEmail, UnsubscribeFromOutreachEmailVariables>;
export const UpdateAdminForPublishingEntityDocument = gql`
    mutation UpdateAdminForPublishingEntity($publishingEntityId: ID!, $userId: ID!, $roleId: ID!) {
  updateAdminForPublishingEntity(
    publishingEntityId: $publishingEntityId
    userId: $userId
    roleId: $roleId
  ) {
    id
    managingAdmins {
      id
      admin {
        __typename
        ... on AdminBase {
          id
          name
        }
        ... on PrivateAdmin {
          email
        }
      }
      roleId
    }
  }
}
    `;
export type UpdateAdminForPublishingEntityMutationFn = Apollo.MutationFunction<UpdateAdminForPublishingEntity, UpdateAdminForPublishingEntityVariables>;

/**
 * __useUpdateAdminForPublishingEntity__
 *
 * To run a mutation, you first call `useUpdateAdminForPublishingEntity` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminForPublishingEntity` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminForPublishingEntity, { data, loading, error }] = useUpdateAdminForPublishingEntity({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useUpdateAdminForPublishingEntity(baseOptions?: Apollo.MutationHookOptions<UpdateAdminForPublishingEntity, UpdateAdminForPublishingEntityVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminForPublishingEntity, UpdateAdminForPublishingEntityVariables>(UpdateAdminForPublishingEntityDocument, options);
      }
export type UpdateAdminForPublishingEntityHookResult = ReturnType<typeof useUpdateAdminForPublishingEntity>;
export type UpdateAdminForPublishingEntityMutationResult = Apollo.MutationResult<UpdateAdminForPublishingEntity>;
export type UpdateAdminForPublishingEntityMutationOptions = Apollo.BaseMutationOptions<UpdateAdminForPublishingEntity, UpdateAdminForPublishingEntityVariables>;
export const UpdateEmailSettingsDocument = gql`
    mutation UpdateEmailSettings($token: String!, $unsubscribeTypes: [EmailType!]!) {
  updateEmailSettings(token: $token, unsubscribeTypes: $unsubscribeTypes)
}
    `;
export type UpdateEmailSettingsMutationFn = Apollo.MutationFunction<UpdateEmailSettings, UpdateEmailSettingsVariables>;

/**
 * __useUpdateEmailSettings__
 *
 * To run a mutation, you first call `useUpdateEmailSettings` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailSettings` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailSettings, { data, loading, error }] = useUpdateEmailSettings({
 *   variables: {
 *      token: // value for 'token'
 *      unsubscribeTypes: // value for 'unsubscribeTypes'
 *   },
 * });
 */
export function useUpdateEmailSettings(baseOptions?: Apollo.MutationHookOptions<UpdateEmailSettings, UpdateEmailSettingsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailSettings, UpdateEmailSettingsVariables>(UpdateEmailSettingsDocument, options);
      }
export type UpdateEmailSettingsHookResult = ReturnType<typeof useUpdateEmailSettings>;
export type UpdateEmailSettingsMutationResult = Apollo.MutationResult<UpdateEmailSettings>;
export type UpdateEmailSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateEmailSettings, UpdateEmailSettingsVariables>;
export const UpdateOutcomeDocument = gql`
    mutation UpdateOutcome($outcomeId: ID!, $input: OutcomeInput!) {
  updateOutcome(outcomeId: $outcomeId, input: $input) {
    __typename
    ... on ContentSetBase {
      id
      reportTabs(publiclyShared: false) {
        id
        publiclyShared
      }
      outcome {
        id
        text
        state
      }
    }
  }
}
    `;
export type UpdateOutcomeMutationFn = Apollo.MutationFunction<UpdateOutcome, UpdateOutcomeVariables>;

/**
 * __useUpdateOutcome__
 *
 * To run a mutation, you first call `useUpdateOutcome` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOutcome` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOutcome, { data, loading, error }] = useUpdateOutcome({
 *   variables: {
 *      outcomeId: // value for 'outcomeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOutcome(baseOptions?: Apollo.MutationHookOptions<UpdateOutcome, UpdateOutcomeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOutcome, UpdateOutcomeVariables>(UpdateOutcomeDocument, options);
      }
export type UpdateOutcomeHookResult = ReturnType<typeof useUpdateOutcome>;
export type UpdateOutcomeMutationResult = Apollo.MutationResult<UpdateOutcome>;
export type UpdateOutcomeMutationOptions = Apollo.BaseMutationOptions<UpdateOutcome, UpdateOutcomeVariables>;
export const UpdateQuestionSetDocument = gql`
    mutation UpdateQuestionSet($id: ID!, $input: QuestionSetInput!) {
  updateQuestionSet(id: $id, input: $input) {
    __typename
    ... on ContentSetBase {
      id
      name {
        ...multilang
      }
      accessSetting {
        __typename
        ... on AccessSetting_Email {
          emailLists {
            id
            name
          }
        }
      }
    }
  }
}
    ${Multilang}`;
export type UpdateQuestionSetMutationFn = Apollo.MutationFunction<UpdateQuestionSet, UpdateQuestionSetVariables>;

/**
 * __useUpdateQuestionSet__
 *
 * To run a mutation, you first call `useUpdateQuestionSet` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionSet` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionSet, { data, loading, error }] = useUpdateQuestionSet({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionSet(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionSet, UpdateQuestionSetVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionSet, UpdateQuestionSetVariables>(UpdateQuestionSetDocument, options);
      }
export type UpdateQuestionSetHookResult = ReturnType<typeof useUpdateQuestionSet>;
export type UpdateQuestionSetMutationResult = Apollo.MutationResult<UpdateQuestionSet>;
export type UpdateQuestionSetMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionSet, UpdateQuestionSetVariables>;
export const UploadQuestionSetImageDocument = gql`
    mutation UploadQuestionSetImage($imageUrl: String!, $publishingEntityId: ID!) {
  uploadQuestionSetImage(
    imageUrl: $imageUrl
    publishingEntityId: $publishingEntityId
  ) {
    id
    questionSetImages {
      id
      horizontalUrl
    }
  }
}
    `;
export type UploadQuestionSetImageMutationFn = Apollo.MutationFunction<UploadQuestionSetImage, UploadQuestionSetImageVariables>;

/**
 * __useUploadQuestionSetImage__
 *
 * To run a mutation, you first call `useUploadQuestionSetImage` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadQuestionSetImage` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadQuestionSetImage, { data, loading, error }] = useUploadQuestionSetImage({
 *   variables: {
 *      imageUrl: // value for 'imageUrl'
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useUploadQuestionSetImage(baseOptions?: Apollo.MutationHookOptions<UploadQuestionSetImage, UploadQuestionSetImageVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadQuestionSetImage, UploadQuestionSetImageVariables>(UploadQuestionSetImageDocument, options);
      }
export type UploadQuestionSetImageHookResult = ReturnType<typeof useUploadQuestionSetImage>;
export type UploadQuestionSetImageMutationResult = Apollo.MutationResult<UploadQuestionSetImage>;
export type UploadQuestionSetImageMutationOptions = Apollo.BaseMutationOptions<UploadQuestionSetImage, UploadQuestionSetImageVariables>;
export const UpvoteCommentDocument = gql`
    mutation UpvoteComment($questionId: ID!, $commentId: ID!) {
  upvoteComment(questionId: $questionId, commentId: $commentId) {
    voteId
    questionId
    direction
    comment {
      id
      upvoteCount
    }
  }
}
    `;
export type UpvoteCommentMutationFn = Apollo.MutationFunction<UpvoteComment, UpvoteCommentVariables>;

/**
 * __useUpvoteComment__
 *
 * To run a mutation, you first call `useUpvoteComment` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpvoteComment` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upvoteComment, { data, loading, error }] = useUpvoteComment({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useUpvoteComment(baseOptions?: Apollo.MutationHookOptions<UpvoteComment, UpvoteCommentVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpvoteComment, UpvoteCommentVariables>(UpvoteCommentDocument, options);
      }
export type UpvoteCommentHookResult = ReturnType<typeof useUpvoteComment>;
export type UpvoteCommentMutationResult = Apollo.MutationResult<UpvoteComment>;
export type UpvoteCommentMutationOptions = Apollo.BaseMutationOptions<UpvoteComment, UpvoteCommentVariables>;
export const VerifyAdminEmailDocument = gql`
    mutation VerifyAdminEmail($userId: ID!, $token: String!) {
  verifyAdminEmail(userId: $userId, token: $token) {
    id
    admin {
      __typename
      ... on PrivateAdmin {
        id
        name
        email
        emailVerificationStatus
        registrationRequests {
          id
          createdTime {
            raw
          }
          decision
          publishingEntity {
            id
          }
        }
        activePublishingEntity {
          id
        }
      }
    }
  }
}
    `;
export type VerifyAdminEmailMutationFn = Apollo.MutationFunction<VerifyAdminEmail, VerifyAdminEmailVariables>;

/**
 * __useVerifyAdminEmail__
 *
 * To run a mutation, you first call `useVerifyAdminEmail` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAdminEmail` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAdminEmail, { data, loading, error }] = useVerifyAdminEmail({
 *   variables: {
 *      userId: // value for 'userId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyAdminEmail(baseOptions?: Apollo.MutationHookOptions<VerifyAdminEmail, VerifyAdminEmailVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyAdminEmail, VerifyAdminEmailVariables>(VerifyAdminEmailDocument, options);
      }
export type VerifyAdminEmailHookResult = ReturnType<typeof useVerifyAdminEmail>;
export type VerifyAdminEmailMutationResult = Apollo.MutationResult<VerifyAdminEmail>;
export type VerifyAdminEmailMutationOptions = Apollo.BaseMutationOptions<VerifyAdminEmail, VerifyAdminEmailVariables>;
export const AdminDeleteTrackGoalDocument = gql`
    mutation adminDeleteTrackGoal($input: DeleteGoalInput!) {
  adminDeleteTrackGoal(input: $input) {
    id
    strategicPlans {
      ...StrategicPlan
    }
  }
}
    ${StrategicPlan}`;
export type AdminDeleteTrackGoalMutationFn = Apollo.MutationFunction<AdminDeleteTrackGoal, AdminDeleteTrackGoalVariables>;

/**
 * __useAdminDeleteTrackGoal__
 *
 * To run a mutation, you first call `useAdminDeleteTrackGoal` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteTrackGoal` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteTrackGoal, { data, loading, error }] = useAdminDeleteTrackGoal({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminDeleteTrackGoal(baseOptions?: Apollo.MutationHookOptions<AdminDeleteTrackGoal, AdminDeleteTrackGoalVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteTrackGoal, AdminDeleteTrackGoalVariables>(AdminDeleteTrackGoalDocument, options);
      }
export type AdminDeleteTrackGoalHookResult = ReturnType<typeof useAdminDeleteTrackGoal>;
export type AdminDeleteTrackGoalMutationResult = Apollo.MutationResult<AdminDeleteTrackGoal>;
export type AdminDeleteTrackGoalMutationOptions = Apollo.BaseMutationOptions<AdminDeleteTrackGoal, AdminDeleteTrackGoalVariables>;
export const AdminUpdateTrackGoalDocument = gql`
    mutation adminUpdateTrackGoal($input: UpdateGoalInput!) {
  adminUpdateTrackGoal(input: $input) {
    id
    strategicPlans {
      ...StrategicPlan
    }
  }
}
    ${StrategicPlan}`;
export type AdminUpdateTrackGoalMutationFn = Apollo.MutationFunction<AdminUpdateTrackGoal, AdminUpdateTrackGoalVariables>;

/**
 * __useAdminUpdateTrackGoal__
 *
 * To run a mutation, you first call `useAdminUpdateTrackGoal` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateTrackGoal` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateTrackGoal, { data, loading, error }] = useAdminUpdateTrackGoal({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateTrackGoal(baseOptions?: Apollo.MutationHookOptions<AdminUpdateTrackGoal, AdminUpdateTrackGoalVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateTrackGoal, AdminUpdateTrackGoalVariables>(AdminUpdateTrackGoalDocument, options);
      }
export type AdminUpdateTrackGoalHookResult = ReturnType<typeof useAdminUpdateTrackGoal>;
export type AdminUpdateTrackGoalMutationResult = Apollo.MutationResult<AdminUpdateTrackGoal>;
export type AdminUpdateTrackGoalMutationOptions = Apollo.BaseMutationOptions<AdminUpdateTrackGoal, AdminUpdateTrackGoalVariables>;
export const AdminBenchmarkReportCrosstabDocument = gql`
    query AdminBenchmarkReportCrosstab($surveyId: ID!, $topicId: ID!, $dimensionGroupDefinitionId: ID!) {
  openContentSetById(setId: $surveyId) {
    __typename
    ... on Survey {
      id
      publishingEntity {
        id
        name {
          ...multilang
        }
      }
      crosstab(
        topicId: $topicId
        dimensionGroupDefinitionId: $dimensionGroupDefinitionId
      ) {
        __typename
        ... on CrosstabQuestionResults {
          ...Crosstab_QuestionResults
        }
        ... on CrosstabGridResults {
          label
          questionResults {
            ...Crosstab_QuestionResults
          }
        }
      }
    }
  }
}
    ${Multilang}
${Crosstab_QuestionResults}`;

/**
 * __useAdminBenchmarkReportCrosstab__
 *
 * To run a query within a React component, call `useAdminBenchmarkReportCrosstab` and pass it any options that fit your needs.
 * When your component renders, `useAdminBenchmarkReportCrosstab` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBenchmarkReportCrosstab({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      topicId: // value for 'topicId'
 *      dimensionGroupDefinitionId: // value for 'dimensionGroupDefinitionId'
 *   },
 * });
 */
export function useAdminBenchmarkReportCrosstab(baseOptions: Apollo.QueryHookOptions<AdminBenchmarkReportCrosstab, AdminBenchmarkReportCrosstabVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBenchmarkReportCrosstab, AdminBenchmarkReportCrosstabVariables>(AdminBenchmarkReportCrosstabDocument, options);
      }
export function useAdminBenchmarkReportCrosstabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBenchmarkReportCrosstab, AdminBenchmarkReportCrosstabVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBenchmarkReportCrosstab, AdminBenchmarkReportCrosstabVariables>(AdminBenchmarkReportCrosstabDocument, options);
        }
export type AdminBenchmarkReportCrosstabHookResult = ReturnType<typeof useAdminBenchmarkReportCrosstab>;
export type AdminBenchmarkReportCrosstabLazyQueryHookResult = ReturnType<typeof useAdminBenchmarkReportCrosstabLazyQuery>;
export type AdminBenchmarkReportCrosstabQueryResult = Apollo.QueryResult<AdminBenchmarkReportCrosstab, AdminBenchmarkReportCrosstabVariables>;
export const AdminBenchmarkReportTopicDisparitiesDocument = gql`
    query AdminBenchmarkReportTopicDisparities($surveyId: ID!, $dimensionGroupDefinitionIds: [ID!]!, $filter: TopicFilter!) {
  openContentSetById(setId: $surveyId) {
    __typename
    ... on Survey {
      id
      topicDisparities(
        topicFilter: $filter
        dimensionGroupDefinitionIds: $dimensionGroupDefinitionIds
      ) {
        topic {
          id
          name
          icon
          description
        }
        dimensionGroupDefinition {
          id
          description
        }
        disparityLevel
      }
    }
  }
}
    `;

/**
 * __useAdminBenchmarkReportTopicDisparities__
 *
 * To run a query within a React component, call `useAdminBenchmarkReportTopicDisparities` and pass it any options that fit your needs.
 * When your component renders, `useAdminBenchmarkReportTopicDisparities` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBenchmarkReportTopicDisparities({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      dimensionGroupDefinitionIds: // value for 'dimensionGroupDefinitionIds'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAdminBenchmarkReportTopicDisparities(baseOptions: Apollo.QueryHookOptions<AdminBenchmarkReportTopicDisparities, AdminBenchmarkReportTopicDisparitiesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBenchmarkReportTopicDisparities, AdminBenchmarkReportTopicDisparitiesVariables>(AdminBenchmarkReportTopicDisparitiesDocument, options);
      }
export function useAdminBenchmarkReportTopicDisparitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBenchmarkReportTopicDisparities, AdminBenchmarkReportTopicDisparitiesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBenchmarkReportTopicDisparities, AdminBenchmarkReportTopicDisparitiesVariables>(AdminBenchmarkReportTopicDisparitiesDocument, options);
        }
export type AdminBenchmarkReportTopicDisparitiesHookResult = ReturnType<typeof useAdminBenchmarkReportTopicDisparities>;
export type AdminBenchmarkReportTopicDisparitiesLazyQueryHookResult = ReturnType<typeof useAdminBenchmarkReportTopicDisparitiesLazyQuery>;
export type AdminBenchmarkReportTopicDisparitiesQueryResult = Apollo.QueryResult<AdminBenchmarkReportTopicDisparities, AdminBenchmarkReportTopicDisparitiesVariables>;
export const AdminBenchmarkReportTopicRankingsDocument = gql`
    query AdminBenchmarkReportTopicRankings($setId: ID!, $filter: TopicFilter!) {
  openContentSetById(setId: $setId) {
    __typename
    ... on Survey {
      id
      topicsByQualityPercent: topics(
        filter: $filter
        sort: {type: QUALITATIVE_QUESTION_RESULT, order: DESC, QUALITATIVE_QUESTION_RESULT: {qualitativeQuestionType: QUALITY, sortBy: WEIGHTED_PERCENT}}
      ) {
        ...topicDetails
      }
      topicsByTrendDifference: topics(
        filter: $filter
        sort: {type: QUALITATIVE_QUESTION_RESULT, order: DESC, QUALITATIVE_QUESTION_RESULT: {qualitativeQuestionType: QUALITY, sortBy: TREND_DIFFERENCE}}
      ) {
        ...topicDetails
      }
      topicsByBenchmarkDifference: topics(
        filter: $filter
        sort: {type: QUALITATIVE_QUESTION_RESULT, order: DESC, QUALITATIVE_QUESTION_RESULT: {qualitativeQuestionType: QUALITY, sortBy: BENCHMARK_DIFFERENCE}}
      ) {
        ...topicDetails
      }
      criticalFocusTopics(filter: $filter) {
        ...SurveyBenchmarkTopic
      }
    }
  }
}
    ${TopicDetails}
${SurveyBenchmarkTopic}`;

/**
 * __useAdminBenchmarkReportTopicRankings__
 *
 * To run a query within a React component, call `useAdminBenchmarkReportTopicRankings` and pass it any options that fit your needs.
 * When your component renders, `useAdminBenchmarkReportTopicRankings` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBenchmarkReportTopicRankings({
 *   variables: {
 *      setId: // value for 'setId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAdminBenchmarkReportTopicRankings(baseOptions: Apollo.QueryHookOptions<AdminBenchmarkReportTopicRankings, AdminBenchmarkReportTopicRankingsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBenchmarkReportTopicRankings, AdminBenchmarkReportTopicRankingsVariables>(AdminBenchmarkReportTopicRankingsDocument, options);
      }
export function useAdminBenchmarkReportTopicRankingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBenchmarkReportTopicRankings, AdminBenchmarkReportTopicRankingsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBenchmarkReportTopicRankings, AdminBenchmarkReportTopicRankingsVariables>(AdminBenchmarkReportTopicRankingsDocument, options);
        }
export type AdminBenchmarkReportTopicRankingsHookResult = ReturnType<typeof useAdminBenchmarkReportTopicRankings>;
export type AdminBenchmarkReportTopicRankingsLazyQueryHookResult = ReturnType<typeof useAdminBenchmarkReportTopicRankingsLazyQuery>;
export type AdminBenchmarkReportTopicRankingsQueryResult = Apollo.QueryResult<AdminBenchmarkReportTopicRankings, AdminBenchmarkReportTopicRankingsVariables>;
export const AdminComparisonGroupDomainIndexScoresDocument = gql`
    query AdminComparisonGroupDomainIndexScores($comparisonGroupId: ID!, $domain: AnalyticsDomain!, $displayType: VariableDisplayType, $areaMode: TrackAreaMode!, $historicalDataEntries: Int, $fipsCodes: [String!]) {
  openComparisonGroupById(comparisonGroupId: $comparisonGroupId) {
    id
    name
    trackDomain(domain: $domain) {
      id
      domain
      fips
      indexScores(
        historicalDataEntries: $historicalDataEntries
        displayType: $displayType
        areaMode: $areaMode
        comparisonGroupId: $comparisonGroupId
      ) {
        ...TrackVariable
      }
    }
  }
}
    ${TrackVariable}`;

/**
 * __useAdminComparisonGroupDomainIndexScores__
 *
 * To run a query within a React component, call `useAdminComparisonGroupDomainIndexScores` and pass it any options that fit your needs.
 * When your component renders, `useAdminComparisonGroupDomainIndexScores` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminComparisonGroupDomainIndexScores({
 *   variables: {
 *      comparisonGroupId: // value for 'comparisonGroupId'
 *      domain: // value for 'domain'
 *      displayType: // value for 'displayType'
 *      areaMode: // value for 'areaMode'
 *      historicalDataEntries: // value for 'historicalDataEntries'
 *      fipsCodes: // value for 'fipsCodes'
 *   },
 * });
 */
export function useAdminComparisonGroupDomainIndexScores(baseOptions: Apollo.QueryHookOptions<AdminComparisonGroupDomainIndexScores, AdminComparisonGroupDomainIndexScoresVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminComparisonGroupDomainIndexScores, AdminComparisonGroupDomainIndexScoresVariables>(AdminComparisonGroupDomainIndexScoresDocument, options);
      }
export function useAdminComparisonGroupDomainIndexScoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminComparisonGroupDomainIndexScores, AdminComparisonGroupDomainIndexScoresVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminComparisonGroupDomainIndexScores, AdminComparisonGroupDomainIndexScoresVariables>(AdminComparisonGroupDomainIndexScoresDocument, options);
        }
export type AdminComparisonGroupDomainIndexScoresHookResult = ReturnType<typeof useAdminComparisonGroupDomainIndexScores>;
export type AdminComparisonGroupDomainIndexScoresLazyQueryHookResult = ReturnType<typeof useAdminComparisonGroupDomainIndexScoresLazyQuery>;
export type AdminComparisonGroupDomainIndexScoresQueryResult = Apollo.QueryResult<AdminComparisonGroupDomainIndexScores, AdminComparisonGroupDomainIndexScoresVariables>;
export const AdminComparisonGroupDomainIndicatorsDocument = gql`
    query AdminComparisonGroupDomainIndicators($comparisonGroupId: ID!, $domain: AnalyticsDomain!, $displayType: VariableDisplayType, $areaMode: TrackAreaMode!, $includeHierarchicalData: Boolean!, $historicalDataEntries: Int, $fipsCodes: [String!]) {
  openComparisonGroupById(comparisonGroupId: $comparisonGroupId) {
    id
    name
    trackDomain(domain: $domain) {
      id
      domain
      fips
      indicators(
        includeHierarchicalData: $includeHierarchicalData
        historicalDataEntries: $historicalDataEntries
        displayType: $displayType
        areaMode: $areaMode
        comparisonGroupId: $comparisonGroupId
      ) {
        ...TrackVariable
      }
    }
  }
}
    ${TrackVariable}`;

/**
 * __useAdminComparisonGroupDomainIndicators__
 *
 * To run a query within a React component, call `useAdminComparisonGroupDomainIndicators` and pass it any options that fit your needs.
 * When your component renders, `useAdminComparisonGroupDomainIndicators` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminComparisonGroupDomainIndicators({
 *   variables: {
 *      comparisonGroupId: // value for 'comparisonGroupId'
 *      domain: // value for 'domain'
 *      displayType: // value for 'displayType'
 *      areaMode: // value for 'areaMode'
 *      includeHierarchicalData: // value for 'includeHierarchicalData'
 *      historicalDataEntries: // value for 'historicalDataEntries'
 *      fipsCodes: // value for 'fipsCodes'
 *   },
 * });
 */
export function useAdminComparisonGroupDomainIndicators(baseOptions: Apollo.QueryHookOptions<AdminComparisonGroupDomainIndicators, AdminComparisonGroupDomainIndicatorsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminComparisonGroupDomainIndicators, AdminComparisonGroupDomainIndicatorsVariables>(AdminComparisonGroupDomainIndicatorsDocument, options);
      }
export function useAdminComparisonGroupDomainIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminComparisonGroupDomainIndicators, AdminComparisonGroupDomainIndicatorsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminComparisonGroupDomainIndicators, AdminComparisonGroupDomainIndicatorsVariables>(AdminComparisonGroupDomainIndicatorsDocument, options);
        }
export type AdminComparisonGroupDomainIndicatorsHookResult = ReturnType<typeof useAdminComparisonGroupDomainIndicators>;
export type AdminComparisonGroupDomainIndicatorsLazyQueryHookResult = ReturnType<typeof useAdminComparisonGroupDomainIndicatorsLazyQuery>;
export type AdminComparisonGroupDomainIndicatorsQueryResult = Apollo.QueryResult<AdminComparisonGroupDomainIndicators, AdminComparisonGroupDomainIndicatorsVariables>;
export const AdminComparisonGroupDomainTrackVariablesDocument = gql`
    query AdminComparisonGroupDomainTrackVariables($comparisonGroupId: ID!, $domain: AnalyticsDomain!, $displayType: VariableDisplayType, $areaMode: TrackAreaMode!, $includeHierarchicalData: Boolean!, $historicalDataEntries: Int, $fipsCodes: [String!]) {
  openComparisonGroupById(comparisonGroupId: $comparisonGroupId) {
    id
    name
    trackDomain(domain: $domain) {
      ...ComparisonGroupTrackDomain
    }
  }
}
    ${ComparisonGroupTrackDomain}`;

/**
 * __useAdminComparisonGroupDomainTrackVariables__
 *
 * To run a query within a React component, call `useAdminComparisonGroupDomainTrackVariables` and pass it any options that fit your needs.
 * When your component renders, `useAdminComparisonGroupDomainTrackVariables` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminComparisonGroupDomainTrackVariables({
 *   variables: {
 *      comparisonGroupId: // value for 'comparisonGroupId'
 *      domain: // value for 'domain'
 *      displayType: // value for 'displayType'
 *      areaMode: // value for 'areaMode'
 *      includeHierarchicalData: // value for 'includeHierarchicalData'
 *      historicalDataEntries: // value for 'historicalDataEntries'
 *      fipsCodes: // value for 'fipsCodes'
 *   },
 * });
 */
export function useAdminComparisonGroupDomainTrackVariables(baseOptions: Apollo.QueryHookOptions<AdminComparisonGroupDomainTrackVariables, AdminComparisonGroupDomainTrackVariablesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminComparisonGroupDomainTrackVariables, AdminComparisonGroupDomainTrackVariablesVariables>(AdminComparisonGroupDomainTrackVariablesDocument, options);
      }
export function useAdminComparisonGroupDomainTrackVariablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminComparisonGroupDomainTrackVariables, AdminComparisonGroupDomainTrackVariablesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminComparisonGroupDomainTrackVariables, AdminComparisonGroupDomainTrackVariablesVariables>(AdminComparisonGroupDomainTrackVariablesDocument, options);
        }
export type AdminComparisonGroupDomainTrackVariablesHookResult = ReturnType<typeof useAdminComparisonGroupDomainTrackVariables>;
export type AdminComparisonGroupDomainTrackVariablesLazyQueryHookResult = ReturnType<typeof useAdminComparisonGroupDomainTrackVariablesLazyQuery>;
export type AdminComparisonGroupDomainTrackVariablesQueryResult = Apollo.QueryResult<AdminComparisonGroupDomainTrackVariables, AdminComparisonGroupDomainTrackVariablesVariables>;
export const AdminComparisonGroupFipsShapesDocument = gql`
    query AdminComparisonGroupFipsShapes($comparisonGroupId: ID!) {
  openComparisonGroupById(comparisonGroupId: $comparisonGroupId) {
    id
    name
    fips {
      id
      shape {
        type
        coordinates
      }
    }
    boundingBox {
      id
      xMin
      xMax
      yMin
      yMax
    }
  }
}
    `;

/**
 * __useAdminComparisonGroupFipsShapes__
 *
 * To run a query within a React component, call `useAdminComparisonGroupFipsShapes` and pass it any options that fit your needs.
 * When your component renders, `useAdminComparisonGroupFipsShapes` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminComparisonGroupFipsShapes({
 *   variables: {
 *      comparisonGroupId: // value for 'comparisonGroupId'
 *   },
 * });
 */
export function useAdminComparisonGroupFipsShapes(baseOptions: Apollo.QueryHookOptions<AdminComparisonGroupFipsShapes, AdminComparisonGroupFipsShapesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminComparisonGroupFipsShapes, AdminComparisonGroupFipsShapesVariables>(AdminComparisonGroupFipsShapesDocument, options);
      }
export function useAdminComparisonGroupFipsShapesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminComparisonGroupFipsShapes, AdminComparisonGroupFipsShapesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminComparisonGroupFipsShapes, AdminComparisonGroupFipsShapesVariables>(AdminComparisonGroupFipsShapesDocument, options);
        }
export type AdminComparisonGroupFipsShapesHookResult = ReturnType<typeof useAdminComparisonGroupFipsShapes>;
export type AdminComparisonGroupFipsShapesLazyQueryHookResult = ReturnType<typeof useAdminComparisonGroupFipsShapesLazyQuery>;
export type AdminComparisonGroupFipsShapesQueryResult = Apollo.QueryResult<AdminComparisonGroupFipsShapes, AdminComparisonGroupFipsShapesVariables>;
export const AdminComparisonGroupTrackOverviewDocument = gql`
    query AdminComparisonGroupTrackOverview($comparisonGroupId: ID!, $areaMode: TrackAreaMode!, $displayType: VariableDisplayType!, $historicalDataEntries: Int, $fipsCodes: [String!]) {
  openComparisonGroupById(comparisonGroupId: $comparisonGroupId) {
    id
    name
    SAFETY: trackDomain(domain: SAFETY) {
      id
      domain
      fips
      indexScores(
        historicalDataEntries: $historicalDataEntries
        displayType: $displayType
        areaMode: $areaMode
      ) {
        ...TrackVariable
      }
    }
    ECONOMY: trackDomain(domain: ECONOMY) {
      id
      domain
      fips
      indexScores(
        historicalDataEntries: $historicalDataEntries
        displayType: $displayType
        areaMode: $areaMode
      ) {
        ...TrackVariable
      }
    }
    EDUCATION_ARTS_CULTURE: trackDomain(domain: EDUCATION_ARTS_CULTURE) {
      id
      domain
      fips
      indexScores(
        historicalDataEntries: $historicalDataEntries
        displayType: $displayType
        areaMode: $areaMode
      ) {
        ...TrackVariable
      }
    }
    MOBILITY: trackDomain(domain: MOBILITY) {
      id
      domain
      fips
      indexScores(
        historicalDataEntries: $historicalDataEntries
        displayType: $displayType
        areaMode: $areaMode
      ) {
        ...TrackVariable
      }
    }
    COMMUNITY_DESIGN: trackDomain(domain: COMMUNITY_DESIGN) {
      id
      domain
      fips
      indexScores(
        historicalDataEntries: $historicalDataEntries
        displayType: $displayType
        areaMode: $areaMode
      ) {
        ...TrackVariable
      }
    }
    PARKS_AND_RECREATION: trackDomain(domain: PARKS_AND_RECREATION) {
      id
      domain
      fips
      indexScores(
        historicalDataEntries: $historicalDataEntries
        displayType: $displayType
        areaMode: $areaMode
      ) {
        ...TrackVariable
      }
    }
    UTILITIES: trackDomain(domain: UTILITIES) {
      id
      domain
      fips
      indexScores(
        historicalDataEntries: $historicalDataEntries
        displayType: $displayType
        areaMode: $areaMode
      ) {
        ...TrackVariable
      }
    }
    HEALTH_AND_WELLNESS: trackDomain(domain: HEALTH_AND_WELLNESS) {
      id
      domain
      fips
      indexScores(
        historicalDataEntries: $historicalDataEntries
        displayType: $displayType
        areaMode: $areaMode
      ) {
        ...TrackVariable
      }
    }
    INCLUSIVITY_AND_ENGAGEMENT: trackDomain(domain: INCLUSIVITY_AND_ENGAGEMENT) {
      id
      domain
      fips
      indexScores(
        historicalDataEntries: $historicalDataEntries
        displayType: $displayType
        areaMode: $areaMode
      ) {
        ...TrackVariable
      }
    }
    NATURAL_ENVIRONMENT: trackDomain(domain: NATURAL_ENVIRONMENT) {
      id
      domain
      fips
      indexScores(
        historicalDataEntries: $historicalDataEntries
        displayType: $displayType
        areaMode: $areaMode
      ) {
        ...TrackVariable
      }
    }
    COMMUNITY_CHARACTERISTICS: trackDomain(domain: COMMUNITY_CHARACTERISTICS) {
      id
      domain
      fips
      indicators(
        includeHierarchicalData: true
        historicalDataEntries: $historicalDataEntries
        displayType: $displayType
        areaMode: $areaMode
      ) {
        ...TrackVariable
      }
    }
  }
}
    ${TrackVariable}`;

/**
 * __useAdminComparisonGroupTrackOverview__
 *
 * To run a query within a React component, call `useAdminComparisonGroupTrackOverview` and pass it any options that fit your needs.
 * When your component renders, `useAdminComparisonGroupTrackOverview` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminComparisonGroupTrackOverview({
 *   variables: {
 *      comparisonGroupId: // value for 'comparisonGroupId'
 *      areaMode: // value for 'areaMode'
 *      displayType: // value for 'displayType'
 *      historicalDataEntries: // value for 'historicalDataEntries'
 *      fipsCodes: // value for 'fipsCodes'
 *   },
 * });
 */
export function useAdminComparisonGroupTrackOverview(baseOptions: Apollo.QueryHookOptions<AdminComparisonGroupTrackOverview, AdminComparisonGroupTrackOverviewVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminComparisonGroupTrackOverview, AdminComparisonGroupTrackOverviewVariables>(AdminComparisonGroupTrackOverviewDocument, options);
      }
export function useAdminComparisonGroupTrackOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminComparisonGroupTrackOverview, AdminComparisonGroupTrackOverviewVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminComparisonGroupTrackOverview, AdminComparisonGroupTrackOverviewVariables>(AdminComparisonGroupTrackOverviewDocument, options);
        }
export type AdminComparisonGroupTrackOverviewHookResult = ReturnType<typeof useAdminComparisonGroupTrackOverview>;
export type AdminComparisonGroupTrackOverviewLazyQueryHookResult = ReturnType<typeof useAdminComparisonGroupTrackOverviewLazyQuery>;
export type AdminComparisonGroupTrackOverviewQueryResult = Apollo.QueryResult<AdminComparisonGroupTrackOverview, AdminComparisonGroupTrackOverviewVariables>;
export const AdminContentReportDocument = gql`
    query AdminContentReport($setId: ID!, $publishingEntityId: ID!, $source: RespondentAttributeValueSource!, $filter: ResultFilter, $paginationForComments: PaginationParams) {
  openContentSetById(setId: $setId) {
    __typename
    ... on ContentSetBase {
      id
      name {
        ...multilang
      }
      description {
        ...multilang
      }
      questionsCount
      schedule {
        status
      }
      reportTabs(publiclyShared: false) {
        id
        title
        order
        visibleToAdmins
        content {
          type
          HTML
          TABLEAU
          height
        }
      }
    }
    ... on QuestionSet {
      createdQuestions(status: [PUBLISHED, CLOSED]) {
        pagination {
          totalCount
        }
        questions {
          id
          title {
            ...multilang
          }
          description {
            ...multilang
          }
          optional
          totalVotesCount
          choiceSet {
            id
            type
            maxSelection
            randomizeChoices
            scaleData {
              scaleType
            }
            choices {
              id
              text {
                ...multilang
              }
            }
          }
          commentsData {
            totalCount
            comments(pagination: $paginationForComments) {
              id
              commenterChoice {
                id
              }
              comment
              commenter {
                ... on RespondentBase {
                  id
                  firstName
                  lastName
                  postAnonymously
                  avatarUrl
                }
              }
              upvoteCount
            }
          }
          results(filter: $filter) {
            ...QuestionResults_Fragment
          }
          stats {
            id
            breakdowns(scopedPublishingEntityId: $publishingEntityId, source: $source) {
              key
              hits
              buckets {
                key
                hits
                buckets {
                  key
                  hits
                }
              }
            }
          }
        }
      }
    }
    ... on PolcoLive {
      createdQuestions(status: [PUBLISHED, CLOSED]) {
        pagination {
          totalCount
        }
        questions {
          id
          title {
            ...multilang
          }
          description {
            ...multilang
          }
          optional
          totalVotesCount
          choiceSet {
            id
            type
            maxSelection
            randomizeChoices
            scaleData {
              scaleType
            }
            choices {
              id
              text {
                ...multilang
              }
            }
          }
          commentsData {
            totalCount
            comments(pagination: $paginationForComments) {
              id
              commenterChoice {
                id
              }
              comment
              commenter {
                ... on RespondentBase {
                  id
                  firstName
                  lastName
                  postAnonymously
                  avatarUrl
                }
              }
              upvoteCount
            }
          }
          results(filter: $filter) {
            ...QuestionResults_Fragment
          }
          stats {
            id
            breakdowns(scopedPublishingEntityId: $publishingEntityId, source: $source) {
              key
              hits
              buckets {
                key
                hits
                buckets {
                  key
                  hits
                }
              }
            }
          }
        }
      }
    }
    ... on Survey {
      contents {
        __typename
        ... on Question {
          id
          title {
            ...multilang
          }
          description {
            ...multilang
          }
          optional
          totalVotesCount
          choiceSet {
            id
            type
            maxSelection
            randomizeChoices
            scaleData {
              scaleType
            }
            choices {
              id
              text {
                ...multilang
              }
            }
          }
          commentsData {
            totalCount
            comments(pagination: $paginationForComments) {
              id
              commenterChoice {
                id
              }
              comment
              commenter {
                ... on RespondentBase {
                  id
                  firstName
                  lastName
                  postAnonymously
                  avatarUrl
                }
              }
              upvoteCount
            }
          }
          results(filter: $filter) {
            ...QuestionResults_Fragment
          }
          stats {
            id
            breakdowns(scopedPublishingEntityId: $publishingEntityId, source: $source) {
              key
              hits
              buckets {
                key
                hits
                buckets {
                  key
                  hits
                }
              }
            }
          }
        }
        ... on QuestionHierarchyParentNode {
          id
          structureType: type
          label {
            ...multilang
          }
          structureDescription: description {
            ...multilang
          }
          survey {
            id
          }
          questions {
            id
            title {
              ...multilang
            }
            description {
              ...multilang
            }
            optional
            totalVotesCount
            choiceSet {
              id
              type
              maxSelection
              randomizeChoices
              scaleData {
                scaleType
              }
              choices {
                id
                text {
                  ...multilang
                }
              }
            }
            commentsData {
              totalCount
              comments(pagination: $paginationForComments) {
                id
                commenterChoice {
                  id
                }
                comment
                commenter {
                  ... on RespondentBase {
                    id
                    firstName
                    lastName
                    postAnonymously
                    avatarUrl
                  }
                }
                upvoteCount
              }
            }
            results(filter: $filter) {
              ...QuestionResults_Fragment
            }
            stats {
              id
              breakdowns(scopedPublishingEntityId: $publishingEntityId, source: $source) {
                key
                hits
                buckets {
                  key
                  hits
                  buckets {
                    key
                    hits
                  }
                }
              }
            }
          }
        }
      }
    }
    ... on GenericContent {
      contents {
        __typename
        ... on Question {
          id
          title {
            ...multilang
          }
          description {
            ...multilang
          }
          optional
          totalVotesCount
          choiceSet {
            id
            type
            maxSelection
            randomizeChoices
            scaleData {
              scaleType
            }
            choices {
              id
              text {
                ...multilang
              }
            }
          }
          commentsData {
            totalCount
            comments(pagination: $paginationForComments) {
              id
              commenterChoice {
                id
              }
              comment
              commenter {
                ... on RespondentBase {
                  id
                  firstName
                  lastName
                  postAnonymously
                  avatarUrl
                }
              }
              upvoteCount
            }
          }
          results(filter: $filter) {
            ...QuestionResults_Fragment
          }
          stats {
            id
            breakdowns(scopedPublishingEntityId: $publishingEntityId, source: $source) {
              key
              hits
              buckets {
                key
                hits
                buckets {
                  key
                  hits
                }
              }
            }
          }
        }
        ... on QuestionHierarchyParentNode {
          id
          structureType: type
          label {
            ...multilang
          }
          structureDescription: description {
            ...multilang
          }
          survey {
            id
          }
          questions {
            id
            title {
              ...multilang
            }
            description {
              ...multilang
            }
            optional
            totalVotesCount
            choiceSet {
              id
              type
              maxSelection
              randomizeChoices
              scaleData {
                scaleType
              }
              choices {
                id
                text {
                  ...multilang
                }
              }
            }
            commentsData {
              totalCount
              comments(pagination: $paginationForComments) {
                id
                commenterChoice {
                  id
                }
                comment
                commenter {
                  ... on RespondentBase {
                    id
                    firstName
                    lastName
                    postAnonymously
                    avatarUrl
                  }
                }
                upvoteCount
              }
            }
            results(filter: $filter) {
              ...QuestionResults_Fragment
            }
            stats {
              id
              breakdowns(scopedPublishingEntityId: $publishingEntityId, source: $source) {
                key
                hits
                buckets {
                  key
                  hits
                  buckets {
                    key
                    hits
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${Multilang}
${QuestionResults_Fragment}`;

/**
 * __useAdminContentReport__
 *
 * To run a query within a React component, call `useAdminContentReport` and pass it any options that fit your needs.
 * When your component renders, `useAdminContentReport` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminContentReport({
 *   variables: {
 *      setId: // value for 'setId'
 *      publishingEntityId: // value for 'publishingEntityId'
 *      source: // value for 'source'
 *      filter: // value for 'filter'
 *      paginationForComments: // value for 'paginationForComments'
 *   },
 * });
 */
export function useAdminContentReport(baseOptions: Apollo.QueryHookOptions<AdminContentReport, AdminContentReportVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminContentReport, AdminContentReportVariables>(AdminContentReportDocument, options);
      }
export function useAdminContentReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminContentReport, AdminContentReportVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminContentReport, AdminContentReportVariables>(AdminContentReportDocument, options);
        }
export type AdminContentReportHookResult = ReturnType<typeof useAdminContentReport>;
export type AdminContentReportLazyQueryHookResult = ReturnType<typeof useAdminContentReportLazyQuery>;
export type AdminContentReportQueryResult = Apollo.QueryResult<AdminContentReport, AdminContentReportVariables>;
export const AdminContentSetRespondentStatsWithRepresentivityDataDocument = gql`
    query AdminContentSetRespondentStatsWithRepresentivityData($setId: ID!, $publishingEntityId: ID!) {
  openContentSetById(setId: $setId) {
    __typename
    ... on Survey {
      id
      slug
      shortId
      benchmarkType {
        type
        weighted
      }
      publishingEntity {
        id
        slug
      }
      alternateLanguages {
        id
        key
        name
      }
      totalRespondents(scopeByPublishingEntityId: $publishingEntityId)
      responsesOverTime(scopeByPublishingEntityId: $publishingEntityId) {
        interval
        data {
          value
          time
        }
      }
      ageBreakdown: representivityData(attributeType: "age") {
        __typename
        label
        unknownBreakdown {
          label
          respondentSelfReportedPercent
          respondentThirdPartyPercent
        }
        breakdowns {
          label
          respondentSelfReportedPercent
          respondentThirdPartyPercent
          communityPercent
        }
      }
      genderBreakdown: representivityData(attributeType: "gender") {
        __typename
        label
        unknownBreakdown {
          label
          respondentSelfReportedPercent
          respondentThirdPartyPercent
        }
        breakdowns {
          label
          respondentSelfReportedPercent
          respondentThirdPartyPercent
          communityPercent
        }
      }
      raceBreakdown: representivityData(attributeType: "race") {
        __typename
        label
        unknownBreakdown {
          label
          respondentSelfReportedPercent
          respondentThirdPartyPercent
        }
        breakdowns {
          label
          respondentSelfReportedPercent
          respondentThirdPartyPercent
          communityPercent
        }
      }
      sampleBreakdown: responseStat(
        input: {type: SAMPLE, scopeByPublishingEntityId: $publishingEntityId}
      ) {
        __typename
        ...breakdown
      }
      languageBreakdown: responseStat(
        input: {type: LANGUAGE, scopeByPublishingEntityId: $publishingEntityId}
      ) {
        __typename
        ...breakdown
      }
      verifiedResponses: responseStat(
        input: {type: VERIFIED_RESPONSES, scopeByPublishingEntityId: $publishingEntityId}
      ) {
        __typename
        ... on StatValueDelta {
          changeLabel
          currentValue
          label
          recentChange
        }
      }
    }
    ... on GenericContent {
      id
      slug
      shortId
      benchmarkType {
        type
        weighted
      }
      publishingEntity {
        id
        slug
      }
      alternateLanguages {
        id
        key
        name
      }
      totalRespondents(scopeByPublishingEntityId: $publishingEntityId)
      responsesOverTime(scopeByPublishingEntityId: $publishingEntityId) {
        interval
        data {
          value
          time
        }
      }
      ageBreakdown: representivityData(attributeType: "age") {
        __typename
        label
        unknownBreakdown {
          label
          respondentSelfReportedPercent
          respondentThirdPartyPercent
        }
        breakdowns {
          label
          respondentSelfReportedPercent
          respondentThirdPartyPercent
          communityPercent
        }
      }
      genderBreakdown: representivityData(attributeType: "gender") {
        __typename
        label
        unknownBreakdown {
          label
          respondentSelfReportedPercent
          respondentThirdPartyPercent
        }
        breakdowns {
          label
          respondentSelfReportedPercent
          respondentThirdPartyPercent
          communityPercent
        }
      }
      raceBreakdown: representivityData(attributeType: "race") {
        __typename
        label
        unknownBreakdown {
          label
          respondentSelfReportedPercent
          respondentThirdPartyPercent
        }
        breakdowns {
          label
          respondentSelfReportedPercent
          respondentThirdPartyPercent
          communityPercent
        }
      }
      sampleBreakdown: responseStat(
        input: {type: SAMPLE, scopeByPublishingEntityId: $publishingEntityId}
      ) {
        __typename
        ...breakdown
      }
      languageBreakdown: responseStat(
        input: {type: LANGUAGE, scopeByPublishingEntityId: $publishingEntityId}
      ) {
        __typename
        ...breakdown
      }
      verifiedResponses: responseStat(
        input: {type: VERIFIED_RESPONSES, scopeByPublishingEntityId: $publishingEntityId}
      ) {
        __typename
        ... on StatValueDelta {
          changeLabel
          currentValue
          label
          recentChange
        }
      }
    }
  }
}
    ${Breakdown}`;

/**
 * __useAdminContentSetRespondentStatsWithRepresentivityData__
 *
 * To run a query within a React component, call `useAdminContentSetRespondentStatsWithRepresentivityData` and pass it any options that fit your needs.
 * When your component renders, `useAdminContentSetRespondentStatsWithRepresentivityData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminContentSetRespondentStatsWithRepresentivityData({
 *   variables: {
 *      setId: // value for 'setId'
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useAdminContentSetRespondentStatsWithRepresentivityData(baseOptions: Apollo.QueryHookOptions<AdminContentSetRespondentStatsWithRepresentivityData, AdminContentSetRespondentStatsWithRepresentivityDataVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminContentSetRespondentStatsWithRepresentivityData, AdminContentSetRespondentStatsWithRepresentivityDataVariables>(AdminContentSetRespondentStatsWithRepresentivityDataDocument, options);
      }
export function useAdminContentSetRespondentStatsWithRepresentivityDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminContentSetRespondentStatsWithRepresentivityData, AdminContentSetRespondentStatsWithRepresentivityDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminContentSetRespondentStatsWithRepresentivityData, AdminContentSetRespondentStatsWithRepresentivityDataVariables>(AdminContentSetRespondentStatsWithRepresentivityDataDocument, options);
        }
export type AdminContentSetRespondentStatsWithRepresentivityDataHookResult = ReturnType<typeof useAdminContentSetRespondentStatsWithRepresentivityData>;
export type AdminContentSetRespondentStatsWithRepresentivityDataLazyQueryHookResult = ReturnType<typeof useAdminContentSetRespondentStatsWithRepresentivityDataLazyQuery>;
export type AdminContentSetRespondentStatsWithRepresentivityDataQueryResult = Apollo.QueryResult<AdminContentSetRespondentStatsWithRepresentivityData, AdminContentSetRespondentStatsWithRepresentivityDataVariables>;
export const AdminContentSetRespondentsStatsDocument = gql`
    query AdminContentSetRespondentsStats($setId: ID!, $publishingEntityId: ID!) {
  openContentSetById(setId: $setId) {
    __typename
    ... on Survey {
      id
      slug
      shortId
      benchmarkType {
        type
        weighted
      }
      publishingEntity {
        id
        slug
      }
      alternateLanguages {
        id
        key
        name
      }
      totalRespondents(scopeByPublishingEntityId: $publishingEntityId)
      responsesOverTime(scopeByPublishingEntityId: $publishingEntityId) {
        interval
        data {
          value
          time
        }
      }
      ageBreakdownThirdParty: responseStat(
        input: {type: AGE, scopeByPublishingEntityId: $publishingEntityId, AGE: {source: THIRD_PARTY}}
      ) {
        __typename
        ...breakdown
      }
      ageBreakdownUserReported: responseStat(
        input: {type: AGE, scopeByPublishingEntityId: $publishingEntityId, AGE: {source: USER_REPORTED}}
      ) {
        __typename
        ...breakdown
      }
      genderBreakdownThirdParty: responseStat(
        input: {type: GENDER, scopeByPublishingEntityId: $publishingEntityId, GENDER: {source: THIRD_PARTY}}
      ) {
        __typename
        ...breakdown
      }
      genderBreakdownUserReported: responseStat(
        input: {type: GENDER, scopeByPublishingEntityId: $publishingEntityId, GENDER: {source: USER_REPORTED}}
      ) {
        __typename
        ...breakdown
      }
      sampleBreakdown: responseStat(
        input: {type: SAMPLE, scopeByPublishingEntityId: $publishingEntityId}
      ) {
        __typename
        ...breakdown
      }
      languageBreakdown: responseStat(
        input: {type: LANGUAGE, scopeByPublishingEntityId: $publishingEntityId}
      ) {
        __typename
        ...breakdown
      }
      raceBreakdown: responseStat(
        input: {type: RACE, scopeByPublishingEntityId: $publishingEntityId}
      ) {
        __typename
        ...breakdown
      }
      verifiedResponses: responseStat(
        input: {type: VERIFIED_RESPONSES, scopeByPublishingEntityId: $publishingEntityId}
      ) {
        __typename
        ... on StatValueDelta {
          changeLabel
          currentValue
          label
          recentChange
        }
      }
    }
  }
}
    ${Breakdown}`;

/**
 * __useAdminContentSetRespondentsStats__
 *
 * To run a query within a React component, call `useAdminContentSetRespondentsStats` and pass it any options that fit your needs.
 * When your component renders, `useAdminContentSetRespondentsStats` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminContentSetRespondentsStats({
 *   variables: {
 *      setId: // value for 'setId'
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useAdminContentSetRespondentsStats(baseOptions: Apollo.QueryHookOptions<AdminContentSetRespondentsStats, AdminContentSetRespondentsStatsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminContentSetRespondentsStats, AdminContentSetRespondentsStatsVariables>(AdminContentSetRespondentsStatsDocument, options);
      }
export function useAdminContentSetRespondentsStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminContentSetRespondentsStats, AdminContentSetRespondentsStatsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminContentSetRespondentsStats, AdminContentSetRespondentsStatsVariables>(AdminContentSetRespondentsStatsDocument, options);
        }
export type AdminContentSetRespondentsStatsHookResult = ReturnType<typeof useAdminContentSetRespondentsStats>;
export type AdminContentSetRespondentsStatsLazyQueryHookResult = ReturnType<typeof useAdminContentSetRespondentsStatsLazyQuery>;
export type AdminContentSetRespondentsStatsQueryResult = Apollo.QueryResult<AdminContentSetRespondentsStats, AdminContentSetRespondentsStatsVariables>;
export const AdminContentSetRespondentsStatsLocationDocument = gql`
    query AdminContentSetRespondentsStatsLocation($setId: ID!, $publishingEntityId: ID!, $geoViewId: ID!) {
  openContentSetById(setId: $setId) {
    __typename
    ... on Survey {
      id
      locationBreakdown: responseStat(
        input: {type: LOCATION, scopeByPublishingEntityId: $publishingEntityId, LOCATION: {geoViewId: $geoViewId}}
      ) {
        __typename
        ...StatBreakdownLocation
      }
    }
  }
}
    ${StatBreakdownLocation}`;

/**
 * __useAdminContentSetRespondentsStatsLocation__
 *
 * To run a query within a React component, call `useAdminContentSetRespondentsStatsLocation` and pass it any options that fit your needs.
 * When your component renders, `useAdminContentSetRespondentsStatsLocation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminContentSetRespondentsStatsLocation({
 *   variables: {
 *      setId: // value for 'setId'
 *      publishingEntityId: // value for 'publishingEntityId'
 *      geoViewId: // value for 'geoViewId'
 *   },
 * });
 */
export function useAdminContentSetRespondentsStatsLocation(baseOptions: Apollo.QueryHookOptions<AdminContentSetRespondentsStatsLocation, AdminContentSetRespondentsStatsLocationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminContentSetRespondentsStatsLocation, AdminContentSetRespondentsStatsLocationVariables>(AdminContentSetRespondentsStatsLocationDocument, options);
      }
export function useAdminContentSetRespondentsStatsLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminContentSetRespondentsStatsLocation, AdminContentSetRespondentsStatsLocationVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminContentSetRespondentsStatsLocation, AdminContentSetRespondentsStatsLocationVariables>(AdminContentSetRespondentsStatsLocationDocument, options);
        }
export type AdminContentSetRespondentsStatsLocationHookResult = ReturnType<typeof useAdminContentSetRespondentsStatsLocation>;
export type AdminContentSetRespondentsStatsLocationLazyQueryHookResult = ReturnType<typeof useAdminContentSetRespondentsStatsLocationLazyQuery>;
export type AdminContentSetRespondentsStatsLocationQueryResult = Apollo.QueryResult<AdminContentSetRespondentsStatsLocation, AdminContentSetRespondentsStatsLocationVariables>;
export const AdminCopyContentSetDataDocument = gql`
    query AdminCopyContentSetData($filter: String!) {
  currentUser {
    id
    user {
      id
      admin {
        __typename
        ... on PrivateAdmin {
          id
          superAdmin
          managedPublishingEntities(filter: $filter) {
            id
            name {
              ...multilang
            }
            presidingArea {
              id
              name
            }
          }
        }
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useAdminCopyContentSetData__
 *
 * To run a query within a React component, call `useAdminCopyContentSetData` and pass it any options that fit your needs.
 * When your component renders, `useAdminCopyContentSetData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCopyContentSetData({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAdminCopyContentSetData(baseOptions: Apollo.QueryHookOptions<AdminCopyContentSetData, AdminCopyContentSetDataVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCopyContentSetData, AdminCopyContentSetDataVariables>(AdminCopyContentSetDataDocument, options);
      }
export function useAdminCopyContentSetDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCopyContentSetData, AdminCopyContentSetDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCopyContentSetData, AdminCopyContentSetDataVariables>(AdminCopyContentSetDataDocument, options);
        }
export type AdminCopyContentSetDataHookResult = ReturnType<typeof useAdminCopyContentSetData>;
export type AdminCopyContentSetDataLazyQueryHookResult = ReturnType<typeof useAdminCopyContentSetDataLazyQuery>;
export type AdminCopyContentSetDataQueryResult = Apollo.QueryResult<AdminCopyContentSetData, AdminCopyContentSetDataVariables>;
export const AdminCurrentAiAssistantQueryStatusDocument = gql`
    query AdminCurrentAiAssistantQueryStatus($sessionId: ID!, $assistant: AssistantIdInput!) {
  currentAiAssistantSession(sessionId: $sessionId, assistant: $assistant) {
    id
    queryStatus {
      type
      loadingText
      message
    }
  }
}
    `;

/**
 * __useAdminCurrentAiAssistantQueryStatus__
 *
 * To run a query within a React component, call `useAdminCurrentAiAssistantQueryStatus` and pass it any options that fit your needs.
 * When your component renders, `useAdminCurrentAiAssistantQueryStatus` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCurrentAiAssistantQueryStatus({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      assistant: // value for 'assistant'
 *   },
 * });
 */
export function useAdminCurrentAiAssistantQueryStatus(baseOptions: Apollo.QueryHookOptions<AdminCurrentAiAssistantQueryStatus, AdminCurrentAiAssistantQueryStatusVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCurrentAiAssistantQueryStatus, AdminCurrentAiAssistantQueryStatusVariables>(AdminCurrentAiAssistantQueryStatusDocument, options);
      }
export function useAdminCurrentAiAssistantQueryStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCurrentAiAssistantQueryStatus, AdminCurrentAiAssistantQueryStatusVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCurrentAiAssistantQueryStatus, AdminCurrentAiAssistantQueryStatusVariables>(AdminCurrentAiAssistantQueryStatusDocument, options);
        }
export type AdminCurrentAiAssistantQueryStatusHookResult = ReturnType<typeof useAdminCurrentAiAssistantQueryStatus>;
export type AdminCurrentAiAssistantQueryStatusLazyQueryHookResult = ReturnType<typeof useAdminCurrentAiAssistantQueryStatusLazyQuery>;
export type AdminCurrentAiAssistantQueryStatusQueryResult = Apollo.QueryResult<AdminCurrentAiAssistantQueryStatus, AdminCurrentAiAssistantQueryStatusVariables>;
export const AdminCurrentAiAssistantSessionConversationDocument = gql`
    query AdminCurrentAiAssistantSessionConversation($sessionId: ID!, $assistant: AssistantIdInput!) {
  currentAiAssistantSession(sessionId: $sessionId, assistant: $assistant) {
    id
    conversation(assistant: $assistant) {
      modelVersion
      userId
      publishingEntityId
      messages {
        role
        timestamp {
          raw
        }
        content
      }
    }
  }
}
    `;

/**
 * __useAdminCurrentAiAssistantSessionConversation__
 *
 * To run a query within a React component, call `useAdminCurrentAiAssistantSessionConversation` and pass it any options that fit your needs.
 * When your component renders, `useAdminCurrentAiAssistantSessionConversation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCurrentAiAssistantSessionConversation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      assistant: // value for 'assistant'
 *   },
 * });
 */
export function useAdminCurrentAiAssistantSessionConversation(baseOptions: Apollo.QueryHookOptions<AdminCurrentAiAssistantSessionConversation, AdminCurrentAiAssistantSessionConversationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCurrentAiAssistantSessionConversation, AdminCurrentAiAssistantSessionConversationVariables>(AdminCurrentAiAssistantSessionConversationDocument, options);
      }
export function useAdminCurrentAiAssistantSessionConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCurrentAiAssistantSessionConversation, AdminCurrentAiAssistantSessionConversationVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCurrentAiAssistantSessionConversation, AdminCurrentAiAssistantSessionConversationVariables>(AdminCurrentAiAssistantSessionConversationDocument, options);
        }
export type AdminCurrentAiAssistantSessionConversationHookResult = ReturnType<typeof useAdminCurrentAiAssistantSessionConversation>;
export type AdminCurrentAiAssistantSessionConversationLazyQueryHookResult = ReturnType<typeof useAdminCurrentAiAssistantSessionConversationLazyQuery>;
export type AdminCurrentAiAssistantSessionConversationQueryResult = Apollo.QueryResult<AdminCurrentAiAssistantSessionConversation, AdminCurrentAiAssistantSessionConversationVariables>;
export const AdminCurrentAiAssistantSessionStatusDocument = gql`
    query AdminCurrentAiAssistantSessionStatus($sessionId: ID!, $assistant: AssistantIdInput!) {
  currentAiAssistantSession(sessionId: $sessionId, assistant: $assistant) {
    id
    status
  }
}
    `;

/**
 * __useAdminCurrentAiAssistantSessionStatus__
 *
 * To run a query within a React component, call `useAdminCurrentAiAssistantSessionStatus` and pass it any options that fit your needs.
 * When your component renders, `useAdminCurrentAiAssistantSessionStatus` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCurrentAiAssistantSessionStatus({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      assistant: // value for 'assistant'
 *   },
 * });
 */
export function useAdminCurrentAiAssistantSessionStatus(baseOptions: Apollo.QueryHookOptions<AdminCurrentAiAssistantSessionStatus, AdminCurrentAiAssistantSessionStatusVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCurrentAiAssistantSessionStatus, AdminCurrentAiAssistantSessionStatusVariables>(AdminCurrentAiAssistantSessionStatusDocument, options);
      }
export function useAdminCurrentAiAssistantSessionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCurrentAiAssistantSessionStatus, AdminCurrentAiAssistantSessionStatusVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCurrentAiAssistantSessionStatus, AdminCurrentAiAssistantSessionStatusVariables>(AdminCurrentAiAssistantSessionStatusDocument, options);
        }
export type AdminCurrentAiAssistantSessionStatusHookResult = ReturnType<typeof useAdminCurrentAiAssistantSessionStatus>;
export type AdminCurrentAiAssistantSessionStatusLazyQueryHookResult = ReturnType<typeof useAdminCurrentAiAssistantSessionStatusLazyQuery>;
export type AdminCurrentAiAssistantSessionStatusQueryResult = Apollo.QueryResult<AdminCurrentAiAssistantSessionStatus, AdminCurrentAiAssistantSessionStatusVariables>;
export const AdminDashboardDocument = gql`
    query AdminDashboard($publishingEntityId: ID!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    totalSubscribers
    totalResponses {
      __typename
      changeLabel
      currentValue
      label
      recentChange
    }
    subscribersOverTime {
      __typename
      interval
      data {
        value
        time
      }
    }
  }
}
    `;

/**
 * __useAdminDashboard__
 *
 * To run a query within a React component, call `useAdminDashboard` and pass it any options that fit your needs.
 * When your component renders, `useAdminDashboard` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDashboard({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useAdminDashboard(baseOptions: Apollo.QueryHookOptions<AdminDashboard, AdminDashboardVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminDashboard, AdminDashboardVariables>(AdminDashboardDocument, options);
      }
export function useAdminDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminDashboard, AdminDashboardVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminDashboard, AdminDashboardVariables>(AdminDashboardDocument, options);
        }
export type AdminDashboardHookResult = ReturnType<typeof useAdminDashboard>;
export type AdminDashboardLazyQueryHookResult = ReturnType<typeof useAdminDashboardLazyQuery>;
export type AdminDashboardQueryResult = Apollo.QueryResult<AdminDashboard, AdminDashboardVariables>;
export const AdminDashboardDemographicsDocument = gql`
    query AdminDashboardDemographics($publishingEntityId: ID!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    ageBreakdownThirdParty: subscribersStat(
      input: {type: AGE, AGE: {source: THIRD_PARTY}}
    ) {
      __typename
      ...breakdown
    }
    ageBreakdownUserReported: subscribersStat(
      input: {type: AGE, AGE: {source: USER_REPORTED}}
    ) {
      __typename
      ...breakdown
    }
    genderBreakdownThirdParty: subscribersStat(
      input: {type: GENDER, GENDER: {source: THIRD_PARTY}}
    ) {
      __typename
      ...breakdown
    }
    genderBreakdownUserReported: subscribersStat(
      input: {type: GENDER, GENDER: {source: USER_REPORTED}}
    ) {
      __typename
      ...breakdown
    }
    raceBreakdown: subscribersStat(input: {type: RACE}) {
      __typename
      ...breakdown
    }
  }
}
    ${Breakdown}`;

/**
 * __useAdminDashboardDemographics__
 *
 * To run a query within a React component, call `useAdminDashboardDemographics` and pass it any options that fit your needs.
 * When your component renders, `useAdminDashboardDemographics` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDashboardDemographics({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useAdminDashboardDemographics(baseOptions: Apollo.QueryHookOptions<AdminDashboardDemographics, AdminDashboardDemographicsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminDashboardDemographics, AdminDashboardDemographicsVariables>(AdminDashboardDemographicsDocument, options);
      }
export function useAdminDashboardDemographicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminDashboardDemographics, AdminDashboardDemographicsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminDashboardDemographics, AdminDashboardDemographicsVariables>(AdminDashboardDemographicsDocument, options);
        }
export type AdminDashboardDemographicsHookResult = ReturnType<typeof useAdminDashboardDemographics>;
export type AdminDashboardDemographicsLazyQueryHookResult = ReturnType<typeof useAdminDashboardDemographicsLazyQuery>;
export type AdminDashboardDemographicsQueryResult = Apollo.QueryResult<AdminDashboardDemographics, AdminDashboardDemographicsVariables>;
export const AdminDashboardLocationDocument = gql`
    query AdminDashboardLocation($publishingEntityId: ID!, $geoViewId: ID!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    locationBreakdown: subscribersStat(
      input: {type: LOCATION, LOCATION: {geoViewId: $geoViewId}}
    ) {
      __typename
      ...StatBreakdownLocation
    }
  }
}
    ${StatBreakdownLocation}`;

/**
 * __useAdminDashboardLocation__
 *
 * To run a query within a React component, call `useAdminDashboardLocation` and pass it any options that fit your needs.
 * When your component renders, `useAdminDashboardLocation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDashboardLocation({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      geoViewId: // value for 'geoViewId'
 *   },
 * });
 */
export function useAdminDashboardLocation(baseOptions: Apollo.QueryHookOptions<AdminDashboardLocation, AdminDashboardLocationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminDashboardLocation, AdminDashboardLocationVariables>(AdminDashboardLocationDocument, options);
      }
export function useAdminDashboardLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminDashboardLocation, AdminDashboardLocationVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminDashboardLocation, AdminDashboardLocationVariables>(AdminDashboardLocationDocument, options);
        }
export type AdminDashboardLocationHookResult = ReturnType<typeof useAdminDashboardLocation>;
export type AdminDashboardLocationLazyQueryHookResult = ReturnType<typeof useAdminDashboardLocationLazyQuery>;
export type AdminDashboardLocationQueryResult = Apollo.QueryResult<AdminDashboardLocation, AdminDashboardLocationVariables>;
export const AdminLibraryContentSearchDocument = gql`
    query AdminLibraryContentSearch($publishingEntityId: ID!, $query: String!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    featureSettings {
      id
      featureSettingName
      enabled
    }
    searchShareableContent(searchQuery: $query) {
      paywalledItemCount
      surveys {
        ...ContentSetAndShareable
      }
      simulations {
        __typename
        id
        name
        description
        type
        status
        isPrioritization
        createDate {
          raw
        }
        url
      }
    }
  }
}
    ${ContentSetAndShareable}`;

/**
 * __useAdminLibraryContentSearch__
 *
 * To run a query within a React component, call `useAdminLibraryContentSearch` and pass it any options that fit your needs.
 * When your component renders, `useAdminLibraryContentSearch` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLibraryContentSearch({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAdminLibraryContentSearch(baseOptions: Apollo.QueryHookOptions<AdminLibraryContentSearch, AdminLibraryContentSearchVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminLibraryContentSearch, AdminLibraryContentSearchVariables>(AdminLibraryContentSearchDocument, options);
      }
export function useAdminLibraryContentSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminLibraryContentSearch, AdminLibraryContentSearchVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminLibraryContentSearch, AdminLibraryContentSearchVariables>(AdminLibraryContentSearchDocument, options);
        }
export type AdminLibraryContentSearchHookResult = ReturnType<typeof useAdminLibraryContentSearch>;
export type AdminLibraryContentSearchLazyQueryHookResult = ReturnType<typeof useAdminLibraryContentSearchLazyQuery>;
export type AdminLibraryContentSearchQueryResult = Apollo.QueryResult<AdminLibraryContentSearch, AdminLibraryContentSearchVariables>;
export const AdminLiveQuestionResultsDocument = gql`
    query AdminLiveQuestionResults($questionId: ID!, $pagination: PaginationParams!) {
  openQuestion(questionId: $questionId) {
    id
    title {
      ...multilang
    }
    description {
      ...multilang
    }
    totalVotesCount
    variableName
    optional
    questionSet {
      ... on ContentSetBase {
        id
      }
    }
    choiceSet {
      id
      type
      maxSelection
      scaleData {
        scaleType
        scaleThreshold
      }
      choices {
        id
        text {
          ...multilang
        }
        choiceValue
      }
      sharedChoiceSetData {
        id
      }
    }
    commentsWordCount {
      text
      value
    }
    commentsData {
      totalCount
      comments(pagination: $pagination) {
        id
        commenterChoice {
          id
        }
        comment
        commenter {
          ... on RespondentBase {
            id
            firstName
            lastName
            postAnonymously
            avatarUrl
          }
        }
        upvoteCount
        commentDate {
          raw
        }
      }
    }
    schedule {
      status
      openDate {
        raw
      }
      closeDate {
        raw
      }
    }
    results {
      ...QuestionResults_Fragment
    }
  }
}
    ${Multilang}
${QuestionResults_Fragment}`;

/**
 * __useAdminLiveQuestionResults__
 *
 * To run a query within a React component, call `useAdminLiveQuestionResults` and pass it any options that fit your needs.
 * When your component renders, `useAdminLiveQuestionResults` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLiveQuestionResults({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAdminLiveQuestionResults(baseOptions: Apollo.QueryHookOptions<AdminLiveQuestionResults, AdminLiveQuestionResultsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminLiveQuestionResults, AdminLiveQuestionResultsVariables>(AdminLiveQuestionResultsDocument, options);
      }
export function useAdminLiveQuestionResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminLiveQuestionResults, AdminLiveQuestionResultsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminLiveQuestionResults, AdminLiveQuestionResultsVariables>(AdminLiveQuestionResultsDocument, options);
        }
export type AdminLiveQuestionResultsHookResult = ReturnType<typeof useAdminLiveQuestionResults>;
export type AdminLiveQuestionResultsLazyQueryHookResult = ReturnType<typeof useAdminLiveQuestionResultsLazyQuery>;
export type AdminLiveQuestionResultsQueryResult = Apollo.QueryResult<AdminLiveQuestionResults, AdminLiveQuestionResultsVariables>;
export const AdminLiveQuestionSetStructureDocument = gql`
    query AdminLiveQuestionSetStructure($setId: ID!) {
  openContentSetById(setId: $setId) {
    __typename
    ... on PolcoLive {
      id
      createdQuestions(status: [PUBLISHED, CLOSED, DRAFT, SCHEDULED, CART]) {
        questions {
          id
          title {
            ...multilang
          }
          description {
            ...multilang
          }
          commentsData {
            totalCount
          }
          totalVotesCount
          schedule {
            status
            openDate {
              raw
            }
            closeDate {
              raw
            }
          }
          choiceSet {
            id
            type
          }
        }
      }
      settings {
        id
        eventStartDate {
          raw
        }
        eventEndDate {
          raw
        }
        state
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useAdminLiveQuestionSetStructure__
 *
 * To run a query within a React component, call `useAdminLiveQuestionSetStructure` and pass it any options that fit your needs.
 * When your component renders, `useAdminLiveQuestionSetStructure` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLiveQuestionSetStructure({
 *   variables: {
 *      setId: // value for 'setId'
 *   },
 * });
 */
export function useAdminLiveQuestionSetStructure(baseOptions: Apollo.QueryHookOptions<AdminLiveQuestionSetStructure, AdminLiveQuestionSetStructureVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminLiveQuestionSetStructure, AdminLiveQuestionSetStructureVariables>(AdminLiveQuestionSetStructureDocument, options);
      }
export function useAdminLiveQuestionSetStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminLiveQuestionSetStructure, AdminLiveQuestionSetStructureVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminLiveQuestionSetStructure, AdminLiveQuestionSetStructureVariables>(AdminLiveQuestionSetStructureDocument, options);
        }
export type AdminLiveQuestionSetStructureHookResult = ReturnType<typeof useAdminLiveQuestionSetStructure>;
export type AdminLiveQuestionSetStructureLazyQueryHookResult = ReturnType<typeof useAdminLiveQuestionSetStructureLazyQuery>;
export type AdminLiveQuestionSetStructureQueryResult = Apollo.QueryResult<AdminLiveQuestionSetStructure, AdminLiveQuestionSetStructureVariables>;
export const AdminLoadEmailListWithEmailsDocument = gql`
    query AdminLoadEmailListWithEmails($publishingEntityId: ID!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    emailLists {
      id
      name
      emails
    }
  }
}
    `;

/**
 * __useAdminLoadEmailListWithEmails__
 *
 * To run a query within a React component, call `useAdminLoadEmailListWithEmails` and pass it any options that fit your needs.
 * When your component renders, `useAdminLoadEmailListWithEmails` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLoadEmailListWithEmails({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useAdminLoadEmailListWithEmails(baseOptions: Apollo.QueryHookOptions<AdminLoadEmailListWithEmails, AdminLoadEmailListWithEmailsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminLoadEmailListWithEmails, AdminLoadEmailListWithEmailsVariables>(AdminLoadEmailListWithEmailsDocument, options);
      }
export function useAdminLoadEmailListWithEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminLoadEmailListWithEmails, AdminLoadEmailListWithEmailsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminLoadEmailListWithEmails, AdminLoadEmailListWithEmailsVariables>(AdminLoadEmailListWithEmailsDocument, options);
        }
export type AdminLoadEmailListWithEmailsHookResult = ReturnType<typeof useAdminLoadEmailListWithEmails>;
export type AdminLoadEmailListWithEmailsLazyQueryHookResult = ReturnType<typeof useAdminLoadEmailListWithEmailsLazyQuery>;
export type AdminLoadEmailListWithEmailsQueryResult = Apollo.QueryResult<AdminLoadEmailListWithEmails, AdminLoadEmailListWithEmailsVariables>;
export const AdminLoadPublisherShareConfigurationsDocument = gql`
    query AdminLoadPublisherShareConfigurations($publishingEntityId: ID!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    totalSubscribers
    socialConnections {
      id
      provider
      profileNames
    }
    emailLists {
      id
      name
    }
  }
}
    `;

/**
 * __useAdminLoadPublisherShareConfigurations__
 *
 * To run a query within a React component, call `useAdminLoadPublisherShareConfigurations` and pass it any options that fit your needs.
 * When your component renders, `useAdminLoadPublisherShareConfigurations` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLoadPublisherShareConfigurations({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useAdminLoadPublisherShareConfigurations(baseOptions: Apollo.QueryHookOptions<AdminLoadPublisherShareConfigurations, AdminLoadPublisherShareConfigurationsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminLoadPublisherShareConfigurations, AdminLoadPublisherShareConfigurationsVariables>(AdminLoadPublisherShareConfigurationsDocument, options);
      }
export function useAdminLoadPublisherShareConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminLoadPublisherShareConfigurations, AdminLoadPublisherShareConfigurationsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminLoadPublisherShareConfigurations, AdminLoadPublisherShareConfigurationsVariables>(AdminLoadPublisherShareConfigurationsDocument, options);
        }
export type AdminLoadPublisherShareConfigurationsHookResult = ReturnType<typeof useAdminLoadPublisherShareConfigurations>;
export type AdminLoadPublisherShareConfigurationsLazyQueryHookResult = ReturnType<typeof useAdminLoadPublisherShareConfigurationsLazyQuery>;
export type AdminLoadPublisherShareConfigurationsQueryResult = Apollo.QueryResult<AdminLoadPublisherShareConfigurations, AdminLoadPublisherShareConfigurationsVariables>;
export const AdminLoadQuestionSetCreationDataDocument = gql`
    query AdminLoadQuestionSetCreationData($publishingEntityId: ID!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    featureSettings(names: ["ENGAGE_CONTENT_LIMIT"]) {
      id
      featureSettingId
      featureSettingName
      activeCount
      quantity
      isUnlimited
      enabled
      expirationDate {
        raw
      }
    }
    demographicQuestions {
      id
      title {
        ...multilang
      }
      summary
      description {
        ...multilang
      }
      optional
      choiceSet {
        id
        type
        maxSelection
        choices {
          id
          text {
            ...multilang
          }
        }
        sharedChoiceSetData {
          id
        }
      }
      schedule {
        status
      }
      demographicAttribute {
        id
        name
        premium
        owner {
          id
        }
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useAdminLoadQuestionSetCreationData__
 *
 * To run a query within a React component, call `useAdminLoadQuestionSetCreationData` and pass it any options that fit your needs.
 * When your component renders, `useAdminLoadQuestionSetCreationData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLoadQuestionSetCreationData({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useAdminLoadQuestionSetCreationData(baseOptions: Apollo.QueryHookOptions<AdminLoadQuestionSetCreationData, AdminLoadQuestionSetCreationDataVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminLoadQuestionSetCreationData, AdminLoadQuestionSetCreationDataVariables>(AdminLoadQuestionSetCreationDataDocument, options);
      }
export function useAdminLoadQuestionSetCreationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminLoadQuestionSetCreationData, AdminLoadQuestionSetCreationDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminLoadQuestionSetCreationData, AdminLoadQuestionSetCreationDataVariables>(AdminLoadQuestionSetCreationDataDocument, options);
        }
export type AdminLoadQuestionSetCreationDataHookResult = ReturnType<typeof useAdminLoadQuestionSetCreationData>;
export type AdminLoadQuestionSetCreationDataLazyQueryHookResult = ReturnType<typeof useAdminLoadQuestionSetCreationDataLazyQuery>;
export type AdminLoadQuestionSetCreationDataQueryResult = Apollo.QueryResult<AdminLoadQuestionSetCreationData, AdminLoadQuestionSetCreationDataVariables>;
export const AdminLoadQuestionSetImagesDocument = gql`
    query AdminLoadQuestionSetImages($publishingEntityId: ID!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    questionSetImages {
      id
      horizontalUrl
    }
  }
}
    `;

/**
 * __useAdminLoadQuestionSetImages__
 *
 * To run a query within a React component, call `useAdminLoadQuestionSetImages` and pass it any options that fit your needs.
 * When your component renders, `useAdminLoadQuestionSetImages` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLoadQuestionSetImages({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useAdminLoadQuestionSetImages(baseOptions: Apollo.QueryHookOptions<AdminLoadQuestionSetImages, AdminLoadQuestionSetImagesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminLoadQuestionSetImages, AdminLoadQuestionSetImagesVariables>(AdminLoadQuestionSetImagesDocument, options);
      }
export function useAdminLoadQuestionSetImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminLoadQuestionSetImages, AdminLoadQuestionSetImagesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminLoadQuestionSetImages, AdminLoadQuestionSetImagesVariables>(AdminLoadQuestionSetImagesDocument, options);
        }
export type AdminLoadQuestionSetImagesHookResult = ReturnType<typeof useAdminLoadQuestionSetImages>;
export type AdminLoadQuestionSetImagesLazyQueryHookResult = ReturnType<typeof useAdminLoadQuestionSetImagesLazyQuery>;
export type AdminLoadQuestionSetImagesQueryResult = Apollo.QueryResult<AdminLoadQuestionSetImages, AdminLoadQuestionSetImagesVariables>;
export const AdminMenuItemsDocument = gql`
    query AdminMenuItems {
  currentUser {
    id
    user {
      id
      admin {
        __typename
        ... on PrivateAdmin {
          id
          menuItems {
            id
            text
            url
            icon
            materialIcon
            isNew
            isShown
            childrenMenuItems {
              id
              text
              url
              icon
              materialIcon
              isNew
              isShown
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAdminMenuItems__
 *
 * To run a query within a React component, call `useAdminMenuItems` and pass it any options that fit your needs.
 * When your component renders, `useAdminMenuItems` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMenuItems({
 *   variables: {
 *   },
 * });
 */
export function useAdminMenuItems(baseOptions?: Apollo.QueryHookOptions<AdminMenuItems, AdminMenuItemsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMenuItems, AdminMenuItemsVariables>(AdminMenuItemsDocument, options);
      }
export function useAdminMenuItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMenuItems, AdminMenuItemsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMenuItems, AdminMenuItemsVariables>(AdminMenuItemsDocument, options);
        }
export type AdminMenuItemsHookResult = ReturnType<typeof useAdminMenuItems>;
export type AdminMenuItemsLazyQueryHookResult = ReturnType<typeof useAdminMenuItemsLazyQuery>;
export type AdminMenuItemsQueryResult = Apollo.QueryResult<AdminMenuItems, AdminMenuItemsVariables>;
export const AdminNcsFacetSummariesDocument = gql`
    query AdminNcsFacetSummaries {
  currentUser {
    id
    user {
      id
      admin {
        __typename
        ... on PrivateAdmin {
          id
          activePublishingEntity {
            id
            ncsFacetSummaries {
              id
              surveyid
              GEO_NAME
              fips
              year
              ncs
              added
              area
              title
              newmax
              pctpos
              avgptm
              n
              bmark
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAdminNcsFacetSummaries__
 *
 * To run a query within a React component, call `useAdminNcsFacetSummaries` and pass it any options that fit your needs.
 * When your component renders, `useAdminNcsFacetSummaries` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminNcsFacetSummaries({
 *   variables: {
 *   },
 * });
 */
export function useAdminNcsFacetSummaries(baseOptions?: Apollo.QueryHookOptions<AdminNcsFacetSummaries, AdminNcsFacetSummariesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminNcsFacetSummaries, AdminNcsFacetSummariesVariables>(AdminNcsFacetSummariesDocument, options);
      }
export function useAdminNcsFacetSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminNcsFacetSummaries, AdminNcsFacetSummariesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminNcsFacetSummaries, AdminNcsFacetSummariesVariables>(AdminNcsFacetSummariesDocument, options);
        }
export type AdminNcsFacetSummariesHookResult = ReturnType<typeof useAdminNcsFacetSummaries>;
export type AdminNcsFacetSummariesLazyQueryHookResult = ReturnType<typeof useAdminNcsFacetSummariesLazyQuery>;
export type AdminNcsFacetSummariesQueryResult = Apollo.QueryResult<AdminNcsFacetSummaries, AdminNcsFacetSummariesVariables>;
export const AdminOpenBalancingActSimulationDocument = gql`
    query AdminOpenBalancingActSimulation($balancingActSimulationId: Int!) {
  openBalancingActSimulation(balancingActSimulationId: $balancingActSimulationId) {
    id
    url
    publishingEntityId
  }
}
    `;

/**
 * __useAdminOpenBalancingActSimulation__
 *
 * To run a query within a React component, call `useAdminOpenBalancingActSimulation` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenBalancingActSimulation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenBalancingActSimulation({
 *   variables: {
 *      balancingActSimulationId: // value for 'balancingActSimulationId'
 *   },
 * });
 */
export function useAdminOpenBalancingActSimulation(baseOptions: Apollo.QueryHookOptions<AdminOpenBalancingActSimulation, AdminOpenBalancingActSimulationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenBalancingActSimulation, AdminOpenBalancingActSimulationVariables>(AdminOpenBalancingActSimulationDocument, options);
      }
export function useAdminOpenBalancingActSimulationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenBalancingActSimulation, AdminOpenBalancingActSimulationVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenBalancingActSimulation, AdminOpenBalancingActSimulationVariables>(AdminOpenBalancingActSimulationDocument, options);
        }
export type AdminOpenBalancingActSimulationHookResult = ReturnType<typeof useAdminOpenBalancingActSimulation>;
export type AdminOpenBalancingActSimulationLazyQueryHookResult = ReturnType<typeof useAdminOpenBalancingActSimulationLazyQuery>;
export type AdminOpenBalancingActSimulationQueryResult = Apollo.QueryResult<AdminOpenBalancingActSimulation, AdminOpenBalancingActSimulationVariables>;
export const AdminOpenBalancingActTaxReceiptDocument = gql`
    query AdminOpenBalancingActTaxReceipt($balancingActTaxReceiptId: Int!) {
  openBalancingActTaxReceipt(balancingActTaxReceiptId: $balancingActTaxReceiptId) {
    id
    url
    publishingEntityId
  }
}
    `;

/**
 * __useAdminOpenBalancingActTaxReceipt__
 *
 * To run a query within a React component, call `useAdminOpenBalancingActTaxReceipt` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenBalancingActTaxReceipt` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenBalancingActTaxReceipt({
 *   variables: {
 *      balancingActTaxReceiptId: // value for 'balancingActTaxReceiptId'
 *   },
 * });
 */
export function useAdminOpenBalancingActTaxReceipt(baseOptions: Apollo.QueryHookOptions<AdminOpenBalancingActTaxReceipt, AdminOpenBalancingActTaxReceiptVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenBalancingActTaxReceipt, AdminOpenBalancingActTaxReceiptVariables>(AdminOpenBalancingActTaxReceiptDocument, options);
      }
export function useAdminOpenBalancingActTaxReceiptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenBalancingActTaxReceipt, AdminOpenBalancingActTaxReceiptVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenBalancingActTaxReceipt, AdminOpenBalancingActTaxReceiptVariables>(AdminOpenBalancingActTaxReceiptDocument, options);
        }
export type AdminOpenBalancingActTaxReceiptHookResult = ReturnType<typeof useAdminOpenBalancingActTaxReceipt>;
export type AdminOpenBalancingActTaxReceiptLazyQueryHookResult = ReturnType<typeof useAdminOpenBalancingActTaxReceiptLazyQuery>;
export type AdminOpenBalancingActTaxReceiptQueryResult = Apollo.QueryResult<AdminOpenBalancingActTaxReceipt, AdminOpenBalancingActTaxReceiptVariables>;
export const AdminOpenDashboardByIdDocument = gql`
    query AdminOpenDashboardById($dashboardId: ID!, $areaMode: TrackAreaMode, $comparisonGroupId: ID, $fipsCodes: [String!]) {
  openDashboardById(dashboardId: $dashboardId) {
    id
    name
    nodes {
      ... on DashboardVariableNode {
        id
        variable(
          fips: $fipsCodes
          comparisonGroupId: $comparisonGroupId
          areaMode: $areaMode
        ) {
          ...TrackVariable
        }
      }
      ... on DashboardByodVariableNode {
        id
        byodVariable(
          fips: $fipsCodes
          comparisonGroupId: $comparisonGroupId
          areaMode: $areaMode
        ) {
          ...TrackVariable
        }
      }
      ... on DashboardHtmlNode {
        id
        rawHtml
      }
    }
  }
}
    ${TrackVariable}`;

/**
 * __useAdminOpenDashboardById__
 *
 * To run a query within a React component, call `useAdminOpenDashboardById` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenDashboardById` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenDashboardById({
 *   variables: {
 *      dashboardId: // value for 'dashboardId'
 *      areaMode: // value for 'areaMode'
 *      comparisonGroupId: // value for 'comparisonGroupId'
 *      fipsCodes: // value for 'fipsCodes'
 *   },
 * });
 */
export function useAdminOpenDashboardById(baseOptions: Apollo.QueryHookOptions<AdminOpenDashboardById, AdminOpenDashboardByIdVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenDashboardById, AdminOpenDashboardByIdVariables>(AdminOpenDashboardByIdDocument, options);
      }
export function useAdminOpenDashboardByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenDashboardById, AdminOpenDashboardByIdVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenDashboardById, AdminOpenDashboardByIdVariables>(AdminOpenDashboardByIdDocument, options);
        }
export type AdminOpenDashboardByIdHookResult = ReturnType<typeof useAdminOpenDashboardById>;
export type AdminOpenDashboardByIdLazyQueryHookResult = ReturnType<typeof useAdminOpenDashboardByIdLazyQuery>;
export type AdminOpenDashboardByIdQueryResult = Apollo.QueryResult<AdminOpenDashboardById, AdminOpenDashboardByIdVariables>;
export const AdminOpenFullTrendsQuestionSetAggregateResultsDocument = gql`
    query AdminOpenFullTrendsQuestionSetAggregateResults($setId: ID!, $filterByTopicIds: [ID!], $reportingBetaMode: Boolean, $areaMode: TrackAreaMode, $comparisonGroupId: ID, $fipsCodes: [String!]) {
  openContentSetById(setId: $setId) {
    __typename
    ... on ContentSetBase {
      id
      publishingEntity {
        id
        name {
          ...multilang
        }
      }
      hasAutomaticWeighting
    }
    ... on Survey {
      benchmarkType {
        weighted
      }
      topics(filter: {type: ALL_NON_QUALITATIVE}) {
        ...SurveyBenchmarkTopic
      }
      contents(filterByTopicIds: $filterByTopicIds, filterNonGridQuestions: true) {
        __typename
        ... on Question {
          id
          variableName
          isBenchmarkedQuestion
          questionNumber
          title {
            ...multilang
          }
          choiceSet {
            id
            type
            scaleData {
              scaleType
              scaleThreshold
              alternateScaleName
            }
          }
          hierarchyParentNode {
            id
            label {
              ...multilang
            }
          }
          commentsData {
            totalCount
          }
          commentsWordCount {
            value
            text
          }
          aggregateResults(
            omitBenchmarks: true
            omitTrends: true
            reportingBetaMode: $reportingBetaMode
          ) {
            ...AggregateResults
          }
        }
        ... on QuestionHierarchyParentNode {
          id
          structureType: type
          label {
            ...multilang
          }
          questionNumber
          questions(filterByTopicIds: $filterByTopicIds) {
            __typename
            id
            variableName
            isBenchmarkedQuestion
            title {
              ...multilang
            }
            choiceSet {
              id
              type
              scaleData {
                scaleType
                scaleThreshold
                alternateScaleName
              }
            }
            aggregateResults(
              omitBenchmarks: true
              omitTrends: true
              reportingBetaMode: $reportingBetaMode
            ) {
              ...AggregateResults
            }
          }
        }
        ... on QuestionHierarchyVisualizationNode {
          ...VisualizationNode
        }
        ... on QuestionHierarchySimulationNode {
          ...AdminSimulationNode
        }
      }
    }
  }
}
    ${Multilang}
${SurveyBenchmarkTopic}
${AggregateResults}
${VisualizationNode}
${AdminSimulationNode}`;

/**
 * __useAdminOpenFullTrendsQuestionSetAggregateResults__
 *
 * To run a query within a React component, call `useAdminOpenFullTrendsQuestionSetAggregateResults` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenFullTrendsQuestionSetAggregateResults` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenFullTrendsQuestionSetAggregateResults({
 *   variables: {
 *      setId: // value for 'setId'
 *      filterByTopicIds: // value for 'filterByTopicIds'
 *      reportingBetaMode: // value for 'reportingBetaMode'
 *      areaMode: // value for 'areaMode'
 *      comparisonGroupId: // value for 'comparisonGroupId'
 *      fipsCodes: // value for 'fipsCodes'
 *   },
 * });
 */
export function useAdminOpenFullTrendsQuestionSetAggregateResults(baseOptions: Apollo.QueryHookOptions<AdminOpenFullTrendsQuestionSetAggregateResults, AdminOpenFullTrendsQuestionSetAggregateResultsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenFullTrendsQuestionSetAggregateResults, AdminOpenFullTrendsQuestionSetAggregateResultsVariables>(AdminOpenFullTrendsQuestionSetAggregateResultsDocument, options);
      }
export function useAdminOpenFullTrendsQuestionSetAggregateResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenFullTrendsQuestionSetAggregateResults, AdminOpenFullTrendsQuestionSetAggregateResultsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenFullTrendsQuestionSetAggregateResults, AdminOpenFullTrendsQuestionSetAggregateResultsVariables>(AdminOpenFullTrendsQuestionSetAggregateResultsDocument, options);
        }
export type AdminOpenFullTrendsQuestionSetAggregateResultsHookResult = ReturnType<typeof useAdminOpenFullTrendsQuestionSetAggregateResults>;
export type AdminOpenFullTrendsQuestionSetAggregateResultsLazyQueryHookResult = ReturnType<typeof useAdminOpenFullTrendsQuestionSetAggregateResultsLazyQuery>;
export type AdminOpenFullTrendsQuestionSetAggregateResultsQueryResult = Apollo.QueryResult<AdminOpenFullTrendsQuestionSetAggregateResults, AdminOpenFullTrendsQuestionSetAggregateResultsVariables>;
export const AdminOpenPublishingEntityGeoViewByIdDocument = gql`
    query AdminOpenPublishingEntityGeoViewById($geoViewId: ID!) {
  openPublishingEntityGeoViewById(geoViewId: $geoViewId) {
    id
    name
    publishingEntity {
      id
      name {
        ...multilang
      }
    }
    geoAreas {
      id
      name
      shape {
        type
        coordinates
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useAdminOpenPublishingEntityGeoViewById__
 *
 * To run a query within a React component, call `useAdminOpenPublishingEntityGeoViewById` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenPublishingEntityGeoViewById` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenPublishingEntityGeoViewById({
 *   variables: {
 *      geoViewId: // value for 'geoViewId'
 *   },
 * });
 */
export function useAdminOpenPublishingEntityGeoViewById(baseOptions: Apollo.QueryHookOptions<AdminOpenPublishingEntityGeoViewById, AdminOpenPublishingEntityGeoViewByIdVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenPublishingEntityGeoViewById, AdminOpenPublishingEntityGeoViewByIdVariables>(AdminOpenPublishingEntityGeoViewByIdDocument, options);
      }
export function useAdminOpenPublishingEntityGeoViewByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenPublishingEntityGeoViewById, AdminOpenPublishingEntityGeoViewByIdVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenPublishingEntityGeoViewById, AdminOpenPublishingEntityGeoViewByIdVariables>(AdminOpenPublishingEntityGeoViewByIdDocument, options);
        }
export type AdminOpenPublishingEntityGeoViewByIdHookResult = ReturnType<typeof useAdminOpenPublishingEntityGeoViewById>;
export type AdminOpenPublishingEntityGeoViewByIdLazyQueryHookResult = ReturnType<typeof useAdminOpenPublishingEntityGeoViewByIdLazyQuery>;
export type AdminOpenPublishingEntityGeoViewByIdQueryResult = Apollo.QueryResult<AdminOpenPublishingEntityGeoViewById, AdminOpenPublishingEntityGeoViewByIdVariables>;
export const AdminOpenQuestionDocument = gql`
    query AdminOpenQuestion($questionId: ID!, $filter: ResultFilter) {
  openQuestion(questionId: $questionId) {
    id
    title {
      ...multilang
    }
    summary
    description {
      ...multilang
    }
    shortId
    optional
    isBenchmarkedQuestion
    choiceSet {
      id
      type
      maxSelection
      choices {
        id
        text {
          ...multilang
        }
      }
    }
    questionSet {
      ... on ContentSetBase {
        id
      }
    }
    schedule {
      status
      openDate {
        raw
      }
      closeDate {
        raw
      }
    }
    results(filter: $filter) {
      ...QuestionResults_Fragment
    }
  }
}
    ${Multilang}
${QuestionResults_Fragment}`;

/**
 * __useAdminOpenQuestion__
 *
 * To run a query within a React component, call `useAdminOpenQuestion` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenQuestion` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenQuestion({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAdminOpenQuestion(baseOptions: Apollo.QueryHookOptions<AdminOpenQuestion, AdminOpenQuestionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenQuestion, AdminOpenQuestionVariables>(AdminOpenQuestionDocument, options);
      }
export function useAdminOpenQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenQuestion, AdminOpenQuestionVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenQuestion, AdminOpenQuestionVariables>(AdminOpenQuestionDocument, options);
        }
export type AdminOpenQuestionHookResult = ReturnType<typeof useAdminOpenQuestion>;
export type AdminOpenQuestionLazyQueryHookResult = ReturnType<typeof useAdminOpenQuestionLazyQuery>;
export type AdminOpenQuestionQueryResult = Apollo.QueryResult<AdminOpenQuestion, AdminOpenQuestionVariables>;
export const AdminOpenQuestionAggregateResultsDocument = gql`
    query AdminOpenQuestionAggregateResults($questionId: ID!, $reportingBetaMode: Boolean) {
  openQuestion(questionId: $questionId) {
    id
    title {
      ...multilang
    }
    isBenchmarkedQuestion
    questionNumber
    choiceSet {
      id
      type
      scaleData {
        scaleThreshold
        scaleType
        alternateScaleName
      }
    }
    hierarchyParentNode {
      id
      label {
        ...multilang
      }
    }
    questionSet {
      ... on ContentSetBase {
        id
        schedule {
          status
          openDate {
            raw
          }
          closeDate {
            raw
          }
        }
        publishingEntity {
          id
          name {
            ...multilang
          }
        }
      }
    }
    aggregateResults(reportingBetaMode: $reportingBetaMode) {
      ...AggregateResults
    }
    commentsData {
      totalCount
    }
    commentsWordCount {
      value
      text
    }
  }
}
    ${Multilang}
${AggregateResults}`;

/**
 * __useAdminOpenQuestionAggregateResults__
 *
 * To run a query within a React component, call `useAdminOpenQuestionAggregateResults` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenQuestionAggregateResults` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenQuestionAggregateResults({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      reportingBetaMode: // value for 'reportingBetaMode'
 *   },
 * });
 */
export function useAdminOpenQuestionAggregateResults(baseOptions: Apollo.QueryHookOptions<AdminOpenQuestionAggregateResults, AdminOpenQuestionAggregateResultsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenQuestionAggregateResults, AdminOpenQuestionAggregateResultsVariables>(AdminOpenQuestionAggregateResultsDocument, options);
      }
export function useAdminOpenQuestionAggregateResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenQuestionAggregateResults, AdminOpenQuestionAggregateResultsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenQuestionAggregateResults, AdminOpenQuestionAggregateResultsVariables>(AdminOpenQuestionAggregateResultsDocument, options);
        }
export type AdminOpenQuestionAggregateResultsHookResult = ReturnType<typeof useAdminOpenQuestionAggregateResults>;
export type AdminOpenQuestionAggregateResultsLazyQueryHookResult = ReturnType<typeof useAdminOpenQuestionAggregateResultsLazyQuery>;
export type AdminOpenQuestionAggregateResultsQueryResult = Apollo.QueryResult<AdminOpenQuestionAggregateResults, AdminOpenQuestionAggregateResultsVariables>;
export const AdminOpenQuestionBaseDocument = gql`
    query AdminOpenQuestionBase($questionId: ID!) {
  openQuestion(questionId: $questionId) {
    id
    questionSet {
      __typename
      ... on ContentSetBase {
        id
        publishingEntity {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useAdminOpenQuestionBase__
 *
 * To run a query within a React component, call `useAdminOpenQuestionBase` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenQuestionBase` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenQuestionBase({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useAdminOpenQuestionBase(baseOptions: Apollo.QueryHookOptions<AdminOpenQuestionBase, AdminOpenQuestionBaseVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenQuestionBase, AdminOpenQuestionBaseVariables>(AdminOpenQuestionBaseDocument, options);
      }
export function useAdminOpenQuestionBaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenQuestionBase, AdminOpenQuestionBaseVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenQuestionBase, AdminOpenQuestionBaseVariables>(AdminOpenQuestionBaseDocument, options);
        }
export type AdminOpenQuestionBaseHookResult = ReturnType<typeof useAdminOpenQuestionBase>;
export type AdminOpenQuestionBaseLazyQueryHookResult = ReturnType<typeof useAdminOpenQuestionBaseLazyQuery>;
export type AdminOpenQuestionBaseQueryResult = Apollo.QueryResult<AdminOpenQuestionBase, AdminOpenQuestionBaseVariables>;
export const AdminOpenQuestionSetDocument = gql`
    query AdminOpenQuestionSet($setId: ID!, $filter: ResultFilter, $commentFilter: CommentFilter, $filterByTopicIds: [ID!], $areaMode: TrackAreaMode, $comparisonGroupId: ID, $fipsCodes: [String!]) {
  openContentSetById(setId: $setId) {
    __typename
    ... on ContentSetBase {
      id
      name {
        ...multilang
      }
      slug
      allowGuestRespondents
      allowMultipleResponses
      showConversionPrompts
      setImageId
      description {
        ...multilang
      }
      shortDescription {
        ...multilang
      }
      featureSetType
      questionsCount
      hasBenchmarkedContent
      polcoManaged
      isPinnedToPublisher
      image {
        id
        horizontalUrl
      }
      accessSetting {
        __typename
        ... on AccessSetting_Email {
          emailLists {
            id
            name
          }
        }
      }
      publishingEntity {
        id
        name {
          ...multilang
        }
        slug
        activationState
      }
      hasAutomaticWeighting
      createDate {
        raw
      }
      schedule {
        status
        closeDate {
          raw
        }
        openDate {
          raw
        }
      }
    }
    ...AdminOpenQuestionSet_QuestionSet
    ...AdminOpenQuestionSet_PolcoLive
    ...AdminOpenQuestionSet_Survey
    ...AdminOpenQuestionSet_Generic
  }
}
    ${Multilang}
${AdminOpenQuestionSet_QuestionSet}
${AdminOpenQuestionSet_PolcoLive}
${AdminOpenQuestionSet_Survey}
${AdminOpenQuestionSet_Generic}`;

/**
 * __useAdminOpenQuestionSet__
 *
 * To run a query within a React component, call `useAdminOpenQuestionSet` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenQuestionSet` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenQuestionSet({
 *   variables: {
 *      setId: // value for 'setId'
 *      filter: // value for 'filter'
 *      commentFilter: // value for 'commentFilter'
 *      filterByTopicIds: // value for 'filterByTopicIds'
 *      areaMode: // value for 'areaMode'
 *      comparisonGroupId: // value for 'comparisonGroupId'
 *      fipsCodes: // value for 'fipsCodes'
 *   },
 * });
 */
export function useAdminOpenQuestionSet(baseOptions: Apollo.QueryHookOptions<AdminOpenQuestionSet, AdminOpenQuestionSetVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenQuestionSet, AdminOpenQuestionSetVariables>(AdminOpenQuestionSetDocument, options);
      }
export function useAdminOpenQuestionSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenQuestionSet, AdminOpenQuestionSetVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenQuestionSet, AdminOpenQuestionSetVariables>(AdminOpenQuestionSetDocument, options);
        }
export type AdminOpenQuestionSetHookResult = ReturnType<typeof useAdminOpenQuestionSet>;
export type AdminOpenQuestionSetLazyQueryHookResult = ReturnType<typeof useAdminOpenQuestionSetLazyQuery>;
export type AdminOpenQuestionSetQueryResult = Apollo.QueryResult<AdminOpenQuestionSet, AdminOpenQuestionSetVariables>;
export const AdminOpenQuestionSetAggregateResultsDocument = gql`
    query AdminOpenQuestionSetAggregateResults($setId: ID!, $filterByTopicIds: [ID!], $omitBenchmarks: Boolean, $omitTrends: Boolean, $reportingBetaMode: Boolean, $onlyGridQuestions: Boolean, $areaMode: TrackAreaMode, $comparisonGroupId: ID, $fipsCodes: [String!]) {
  openContentSetById(setId: $setId) {
    __typename
    ... on ContentSetBase {
      id
      publishingEntity {
        id
        name {
          ...multilang
        }
      }
      hasAutomaticWeighting
    }
    ... on Survey {
      benchmarkType {
        weighted
      }
      topics(filter: {type: ALL_NON_QUALITATIVE}, useMicroservice: $reportingBetaMode) {
        ...SurveyBenchmarkTopic
      }
      contents(
        filterByTopicIds: $filterByTopicIds
        filterNonGridQuestions: $onlyGridQuestions
        useMicroservice: $reportingBetaMode
      ) {
        __typename
        ... on Question {
          id
          variableName
          isBenchmarkedQuestion
          questionNumber
          title {
            ...multilang
          }
          choiceSet {
            id
            type
            scaleData {
              scaleType
              scaleThreshold
              alternateScaleName
            }
          }
          hierarchyParentNode {
            id
            label {
              ...multilang
            }
          }
          commentsData {
            totalCount
          }
          commentsWordCount {
            value
            text
          }
          aggregateResults(
            omitBenchmarks: $omitBenchmarks
            omitTrends: $omitTrends
            reportingBetaMode: $reportingBetaMode
          ) {
            ...AggregateResults
          }
        }
        ... on QuestionHierarchyParentNode {
          id
          structureType: type
          label {
            ...multilang
          }
          questionNumber
          questions(
            filterByTopicIds: $filterByTopicIds
            useMicroservice: $reportingBetaMode
          ) {
            __typename
            id
            variableName
            isBenchmarkedQuestion
            title {
              ...multilang
            }
            choiceSet {
              id
              type
              scaleData {
                scaleType
                scaleThreshold
                alternateScaleName
              }
            }
            aggregateResults(
              omitBenchmarks: $omitBenchmarks
              omitTrends: $omitTrends
              reportingBetaMode: $reportingBetaMode
            ) {
              ...AggregateResults
            }
          }
        }
        ... on QuestionHierarchyVisualizationNode {
          ...VisualizationNode
        }
        ... on QuestionHierarchySimulationNode {
          ...AdminSimulationNode
        }
      }
    }
    ... on GenericContent {
      benchmarkType {
        weighted
      }
      topics(filter: {type: ALL_NON_QUALITATIVE}, useMicroservice: $reportingBetaMode) {
        ...SurveyBenchmarkTopic
      }
      contents(
        filterByTopicIds: $filterByTopicIds
        filterNonGridQuestions: $onlyGridQuestions
        useMicroservice: $reportingBetaMode
      ) {
        __typename
        ... on Question {
          id
          variableName
          isBenchmarkedQuestion
          questionNumber
          title {
            ...multilang
          }
          choiceSet {
            id
            type
            scaleData {
              scaleType
              scaleThreshold
              alternateScaleName
            }
          }
          hierarchyParentNode {
            id
            label {
              ...multilang
            }
          }
          commentsData {
            totalCount
          }
          commentsWordCount {
            value
            text
          }
          aggregateResults(
            omitBenchmarks: $omitBenchmarks
            omitTrends: $omitTrends
            reportingBetaMode: $reportingBetaMode
          ) {
            ...AggregateResults
          }
        }
        ... on QuestionHierarchyParentNode {
          id
          structureType: type
          label {
            ...multilang
          }
          questionNumber
          questions(
            filterByTopicIds: $filterByTopicIds
            useMicroservice: $reportingBetaMode
          ) {
            __typename
            id
            variableName
            isBenchmarkedQuestion
            title {
              ...multilang
            }
            choiceSet {
              id
              type
              scaleData {
                scaleType
                scaleThreshold
                alternateScaleName
              }
            }
            aggregateResults(
              omitBenchmarks: $omitBenchmarks
              omitTrends: $omitTrends
              reportingBetaMode: $reportingBetaMode
            ) {
              ...AggregateResults
            }
          }
        }
        ... on QuestionHierarchyVisualizationNode {
          ...VisualizationNode
        }
        ... on QuestionHierarchySimulationNode {
          ...AdminSimulationNode
        }
      }
    }
  }
}
    ${Multilang}
${SurveyBenchmarkTopic}
${AggregateResults}
${VisualizationNode}
${AdminSimulationNode}`;

/**
 * __useAdminOpenQuestionSetAggregateResults__
 *
 * To run a query within a React component, call `useAdminOpenQuestionSetAggregateResults` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenQuestionSetAggregateResults` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenQuestionSetAggregateResults({
 *   variables: {
 *      setId: // value for 'setId'
 *      filterByTopicIds: // value for 'filterByTopicIds'
 *      omitBenchmarks: // value for 'omitBenchmarks'
 *      omitTrends: // value for 'omitTrends'
 *      reportingBetaMode: // value for 'reportingBetaMode'
 *      onlyGridQuestions: // value for 'onlyGridQuestions'
 *      areaMode: // value for 'areaMode'
 *      comparisonGroupId: // value for 'comparisonGroupId'
 *      fipsCodes: // value for 'fipsCodes'
 *   },
 * });
 */
export function useAdminOpenQuestionSetAggregateResults(baseOptions: Apollo.QueryHookOptions<AdminOpenQuestionSetAggregateResults, AdminOpenQuestionSetAggregateResultsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenQuestionSetAggregateResults, AdminOpenQuestionSetAggregateResultsVariables>(AdminOpenQuestionSetAggregateResultsDocument, options);
      }
export function useAdminOpenQuestionSetAggregateResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenQuestionSetAggregateResults, AdminOpenQuestionSetAggregateResultsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenQuestionSetAggregateResults, AdminOpenQuestionSetAggregateResultsVariables>(AdminOpenQuestionSetAggregateResultsDocument, options);
        }
export type AdminOpenQuestionSetAggregateResultsHookResult = ReturnType<typeof useAdminOpenQuestionSetAggregateResults>;
export type AdminOpenQuestionSetAggregateResultsLazyQueryHookResult = ReturnType<typeof useAdminOpenQuestionSetAggregateResultsLazyQuery>;
export type AdminOpenQuestionSetAggregateResultsQueryResult = Apollo.QueryResult<AdminOpenQuestionSetAggregateResults, AdminOpenQuestionSetAggregateResultsVariables>;
export const AdminOpenQuestionSetBaseDocument = gql`
    query AdminOpenQuestionSetBase($setId: ID!) {
  openContentSetById(setId: $setId) {
    __typename
    ... on ContentSetBase {
      id
      publishingEntity {
        id
      }
      hasAutomaticWeighting
      schedule {
        status
        closeDate {
          raw
        }
        openDate {
          raw
        }
      }
    }
    ... on Survey {
      benchmarkType {
        type
      }
    }
  }
}
    `;

/**
 * __useAdminOpenQuestionSetBase__
 *
 * To run a query within a React component, call `useAdminOpenQuestionSetBase` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenQuestionSetBase` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenQuestionSetBase({
 *   variables: {
 *      setId: // value for 'setId'
 *   },
 * });
 */
export function useAdminOpenQuestionSetBase(baseOptions: Apollo.QueryHookOptions<AdminOpenQuestionSetBase, AdminOpenQuestionSetBaseVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenQuestionSetBase, AdminOpenQuestionSetBaseVariables>(AdminOpenQuestionSetBaseDocument, options);
      }
export function useAdminOpenQuestionSetBaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenQuestionSetBase, AdminOpenQuestionSetBaseVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenQuestionSetBase, AdminOpenQuestionSetBaseVariables>(AdminOpenQuestionSetBaseDocument, options);
        }
export type AdminOpenQuestionSetBaseHookResult = ReturnType<typeof useAdminOpenQuestionSetBase>;
export type AdminOpenQuestionSetBaseLazyQueryHookResult = ReturnType<typeof useAdminOpenQuestionSetBaseLazyQuery>;
export type AdminOpenQuestionSetBaseQueryResult = Apollo.QueryResult<AdminOpenQuestionSetBase, AdminOpenQuestionSetBaseVariables>;
export const AdminOpenQuestionSetBenchmarkOverviewStructureDocument = gql`
    query AdminOpenQuestionSetBenchmarkOverviewStructure($setId: ID!) {
  openContentSetById(setId: $setId) {
    __typename
    ... on Survey {
      id
      publishingEntity {
        id
        name {
          ...multilang
        }
      }
      benchmarkType {
        type
      }
      dimensionGroupDefinitions {
        id
        description
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useAdminOpenQuestionSetBenchmarkOverviewStructure__
 *
 * To run a query within a React component, call `useAdminOpenQuestionSetBenchmarkOverviewStructure` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenQuestionSetBenchmarkOverviewStructure` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenQuestionSetBenchmarkOverviewStructure({
 *   variables: {
 *      setId: // value for 'setId'
 *   },
 * });
 */
export function useAdminOpenQuestionSetBenchmarkOverviewStructure(baseOptions: Apollo.QueryHookOptions<AdminOpenQuestionSetBenchmarkOverviewStructure, AdminOpenQuestionSetBenchmarkOverviewStructureVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenQuestionSetBenchmarkOverviewStructure, AdminOpenQuestionSetBenchmarkOverviewStructureVariables>(AdminOpenQuestionSetBenchmarkOverviewStructureDocument, options);
      }
export function useAdminOpenQuestionSetBenchmarkOverviewStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenQuestionSetBenchmarkOverviewStructure, AdminOpenQuestionSetBenchmarkOverviewStructureVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenQuestionSetBenchmarkOverviewStructure, AdminOpenQuestionSetBenchmarkOverviewStructureVariables>(AdminOpenQuestionSetBenchmarkOverviewStructureDocument, options);
        }
export type AdminOpenQuestionSetBenchmarkOverviewStructureHookResult = ReturnType<typeof useAdminOpenQuestionSetBenchmarkOverviewStructure>;
export type AdminOpenQuestionSetBenchmarkOverviewStructureLazyQueryHookResult = ReturnType<typeof useAdminOpenQuestionSetBenchmarkOverviewStructureLazyQuery>;
export type AdminOpenQuestionSetBenchmarkOverviewStructureQueryResult = Apollo.QueryResult<AdminOpenQuestionSetBenchmarkOverviewStructure, AdminOpenQuestionSetBenchmarkOverviewStructureVariables>;
export const AdminOpenQuestionSetCrosstabOptionsDocument = gql`
    query AdminOpenQuestionSetCrosstabOptions($setId: ID!, $filter: TopicFilter!) {
  openContentSetById(setId: $setId) {
    __typename
    ... on Survey {
      id
      topics(filter: $filter) {
        ...SurveyBenchmarkTopic
      }
      dimensionGroupDefinitions {
        id
        description
      }
    }
  }
}
    ${SurveyBenchmarkTopic}`;

/**
 * __useAdminOpenQuestionSetCrosstabOptions__
 *
 * To run a query within a React component, call `useAdminOpenQuestionSetCrosstabOptions` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenQuestionSetCrosstabOptions` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenQuestionSetCrosstabOptions({
 *   variables: {
 *      setId: // value for 'setId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAdminOpenQuestionSetCrosstabOptions(baseOptions: Apollo.QueryHookOptions<AdminOpenQuestionSetCrosstabOptions, AdminOpenQuestionSetCrosstabOptionsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenQuestionSetCrosstabOptions, AdminOpenQuestionSetCrosstabOptionsVariables>(AdminOpenQuestionSetCrosstabOptionsDocument, options);
      }
export function useAdminOpenQuestionSetCrosstabOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenQuestionSetCrosstabOptions, AdminOpenQuestionSetCrosstabOptionsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenQuestionSetCrosstabOptions, AdminOpenQuestionSetCrosstabOptionsVariables>(AdminOpenQuestionSetCrosstabOptionsDocument, options);
        }
export type AdminOpenQuestionSetCrosstabOptionsHookResult = ReturnType<typeof useAdminOpenQuestionSetCrosstabOptions>;
export type AdminOpenQuestionSetCrosstabOptionsLazyQueryHookResult = ReturnType<typeof useAdminOpenQuestionSetCrosstabOptionsLazyQuery>;
export type AdminOpenQuestionSetCrosstabOptionsQueryResult = Apollo.QueryResult<AdminOpenQuestionSetCrosstabOptions, AdminOpenQuestionSetCrosstabOptionsVariables>;
export const AdminOpenQuestionSetGridAggregateResultsDocument = gql`
    query AdminOpenQuestionSetGridAggregateResults($setId: ID!, $filterByTopicIds: [ID!], $omitBenchmarks: Boolean, $omitTrends: Boolean, $reportingBetaMode: Boolean) {
  openContentSetById(setId: $setId) {
    __typename
    ... on ContentSetBase {
      id
      publishingEntity {
        id
        name {
          ...multilang
        }
      }
      hasAutomaticWeighting
    }
    ... on Survey {
      benchmarkType {
        weighted
      }
      contents(filterByTopicIds: $filterByTopicIds, filterNonGridQuestions: true) {
        __typename
        ... on QuestionHierarchyParentNode {
          id
          structureType: type
          label {
            ...multilang
          }
          questionNumber
          questions(filterByTopicIds: $filterByTopicIds) {
            __typename
            id
            variableName
            isBenchmarkedQuestion
            title {
              ...multilang
            }
            choiceSet {
              id
              type
              scaleData {
                scaleType
                scaleThreshold
                alternateScaleName
              }
            }
            aggregateResults(
              omitBenchmarks: $omitBenchmarks
              omitTrends: $omitTrends
              reportingBetaMode: $reportingBetaMode
            ) {
              ...AggregateResults
            }
          }
        }
      }
    }
  }
}
    ${Multilang}
${AggregateResults}`;

/**
 * __useAdminOpenQuestionSetGridAggregateResults__
 *
 * To run a query within a React component, call `useAdminOpenQuestionSetGridAggregateResults` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenQuestionSetGridAggregateResults` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenQuestionSetGridAggregateResults({
 *   variables: {
 *      setId: // value for 'setId'
 *      filterByTopicIds: // value for 'filterByTopicIds'
 *      omitBenchmarks: // value for 'omitBenchmarks'
 *      omitTrends: // value for 'omitTrends'
 *      reportingBetaMode: // value for 'reportingBetaMode'
 *   },
 * });
 */
export function useAdminOpenQuestionSetGridAggregateResults(baseOptions: Apollo.QueryHookOptions<AdminOpenQuestionSetGridAggregateResults, AdminOpenQuestionSetGridAggregateResultsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenQuestionSetGridAggregateResults, AdminOpenQuestionSetGridAggregateResultsVariables>(AdminOpenQuestionSetGridAggregateResultsDocument, options);
      }
export function useAdminOpenQuestionSetGridAggregateResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenQuestionSetGridAggregateResults, AdminOpenQuestionSetGridAggregateResultsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenQuestionSetGridAggregateResults, AdminOpenQuestionSetGridAggregateResultsVariables>(AdminOpenQuestionSetGridAggregateResultsDocument, options);
        }
export type AdminOpenQuestionSetGridAggregateResultsHookResult = ReturnType<typeof useAdminOpenQuestionSetGridAggregateResults>;
export type AdminOpenQuestionSetGridAggregateResultsLazyQueryHookResult = ReturnType<typeof useAdminOpenQuestionSetGridAggregateResultsLazyQuery>;
export type AdminOpenQuestionSetGridAggregateResultsQueryResult = Apollo.QueryResult<AdminOpenQuestionSetGridAggregateResults, AdminOpenQuestionSetGridAggregateResultsVariables>;
export const AdminOpenQuestionSetStructureDocument = gql`
    query AdminOpenQuestionSetStructure($setId: ID!, $areaMode: TrackAreaMode, $comparisonGroupId: ID, $fipsCodes: [String!]) {
  openContentSetById(setId: $setId) {
    __typename
    ... on ContentSetBase {
      id
      name {
        ...multilang
      }
      slug
      description {
        ...multilang
      }
      shortDescription {
        ...multilang
      }
      featureSetType
      questionsCount
      hasBenchmarkedContent
      polcoManaged
      isPinnedToPublisher
      image {
        id
        horizontalUrl
      }
      reposters {
        id
        name {
          ...multilang
        }
      }
      isRepostable
      accessSetting {
        __typename
        ... on AccessSetting_Email {
          emailLists {
            id
            name
          }
        }
      }
      publishingEntity {
        id
        name {
          ...multilang
        }
        slug
        activationState
      }
      createDate {
        raw
      }
      schedule {
        status
        closeDate {
          raw
        }
        openDate {
          raw
        }
      }
      outcome {
        id
        text
        state
      }
      alternateLanguages {
        id
        key
        name
      }
      hasAutomaticWeighting
      allowMultipleResponses
    }
    ... on QuestionSet {
      allowGuestRespondents
      showConversionPrompts
      isPinnedToPublisher
      setImageId
      createdQuestions(status: [PUBLISHED, CLOSED, DRAFT, SCHEDULED, CART, ARCHIVED]) {
        questions {
          id
          title {
            ...multilang
          }
          description {
            ...multilang
          }
          questionNumber
          optional
          variableName
          choiceSet {
            id
            type
            maxSelection
            randomizeChoices
            scaleData {
              scaleType
              scaleThreshold
            }
            choices {
              id
              text {
                ...multilang
              }
              choiceValue
              includeComment
            }
            sharedChoiceSetData {
              id
            }
          }
          schedule {
            status
            openDate {
              raw
            }
            closeDate {
              raw
            }
          }
          questionSet {
            ... on ContentSetBase {
              __typename
              id
            }
          }
        }
        pagination {
          totalCount
        }
      }
    }
    ... on PolcoLive {
      allowGuestRespondents
      showConversionPrompts
      isPinnedToPublisher
      setImageId
      shortId
      settings {
        id
        eventStartDate {
          raw
        }
        eventEndDate {
          raw
        }
        liveVideoLink
        state
      }
      createdQuestions(status: [PUBLISHED, CLOSED, DRAFT, SCHEDULED, CART]) {
        questions {
          id
          title {
            ...multilang
          }
          description {
            ...multilang
          }
          optional
          variableName
          choiceSet {
            id
            type
            maxSelection
            randomizeChoices
            scaleData {
              scaleType
              scaleThreshold
            }
            choices {
              id
              text {
                ...multilang
              }
              choiceValue
            }
            sharedChoiceSetData {
              id
            }
          }
          schedule {
            status
            openDate {
              raw
            }
            closeDate {
              raw
            }
          }
          questionSet {
            ... on ContentSetBase {
              __typename
              id
            }
          }
        }
        pagination {
          totalCount
        }
      }
    }
    ... on Survey {
      allowGuestRespondents
      showConversionPrompts
      isPinnedToPublisher
      setImageId
      shortId
      hasVisibleReportTabs
      benchmarkType {
        type
      }
      allConditions {
        metaConditions {
          id
          displayName
          combinationOperator
          childMetaConditionIds
        }
        questionChoiceConditions {
          id
          metaConditionId
          questionId
          questionChoiceId
        }
      }
      contents {
        __typename
        ... on Question {
          id
          title {
            ...multilang
          }
          questionNumber
          summary
          description {
            ...multilang
          }
          optional
          variableName
          reportDisplayLabel
          choiceSet {
            id
            type
            maxSelection
            randomizeChoices
            scaleData {
              scaleType
              scaleThreshold
            }
            choices {
              id
              text {
                ...multilang
              }
              choiceValue
              includeComment
            }
            sharedChoiceSetData {
              id
            }
          }
          conditions {
            metaConditions {
              id
              childMetaConditionIds
              combinationOperator
              displayName
            }
            questionChoiceConditions {
              id
              metaConditionId
              questionId
              questionChoiceId
            }
          }
          schedule {
            status
          }
          questionSet {
            ... on ContentSetBase {
              __typename
              id
            }
          }
          demographicAttribute {
            id
            name
            premium
            owner {
              id
            }
          }
        }
        ... on QuestionHierarchyParentNode {
          id
          structureType: type
          label {
            ...multilang
          }
          structureDescription: description {
            ...multilang
          }
          survey {
            id
          }
          questionNumber
          conditions {
            metaConditions {
              id
              childMetaConditionIds
              combinationOperator
              displayName
            }
            questionChoiceConditions {
              id
              metaConditionId
              questionId
              questionChoiceId
            }
          }
          questions {
            __typename
            id
            title {
              ...multilang
            }
            description {
              ...multilang
            }
            optional
            variableName
            reportDisplayLabel
            choiceSet {
              id
              type
              maxSelection
              randomizeChoices
              scaleData {
                scaleType
                scaleThreshold
              }
              choices {
                id
                text {
                  ...multilang
                }
                choiceValue
              }
              sharedChoiceSetData {
                id
              }
            }
            schedule {
              status
            }
            conditions {
              metaConditions {
                id
                childMetaConditionIds
                combinationOperator
                displayName
              }
              questionChoiceConditions {
                id
                metaConditionId
                questionId
                questionChoiceId
              }
            }
          }
          numColumns
          ...RowContentHierarchyNodes
        }
        ... on QuestionHierarchyVisualizationNode {
          ...VisualizationNode
        }
        ... on QuestionHierarchySimulationNode {
          ...AdminSimulationNode
        }
      }
      reportTabs(publiclyShared: false) {
        id
        title
        order
        visibleToAdmins
        publiclyShared
        trackDomain
        content {
          type
          HTML
          TABLEAU
          height
        }
      }
      hasPdfUrl
      totalRespondents
    }
    ... on GenericContent {
      allowGuestRespondents
      showConversionPrompts
      isPinnedToPublisher
      setImageId
      shortId
      benchmarkType {
        type
      }
      allConditions {
        metaConditions {
          id
          displayName
          combinationOperator
          childMetaConditionIds
        }
        questionChoiceConditions {
          id
          metaConditionId
          questionId
          questionChoiceId
        }
      }
      contents {
        __typename
        ... on Question {
          id
          title {
            ...multilang
          }
          questionNumber
          summary
          description {
            ...multilang
          }
          optional
          variableName
          reportDisplayLabel
          choiceSet {
            id
            type
            maxSelection
            randomizeChoices
            scaleData {
              scaleType
              scaleThreshold
            }
            choices {
              id
              text {
                ...multilang
              }
              choiceValue
            }
            sharedChoiceSetData {
              id
            }
          }
          conditions {
            metaConditions {
              id
              childMetaConditionIds
              combinationOperator
              displayName
            }
            questionChoiceConditions {
              id
              metaConditionId
              questionId
              questionChoiceId
            }
          }
          schedule {
            status
          }
          questionSet {
            ... on ContentSetBase {
              __typename
              id
            }
          }
          demographicAttribute {
            id
            name
            premium
            owner {
              id
            }
          }
        }
        ... on QuestionHierarchyParentNode {
          id
          structureType: type
          label {
            ...multilang
          }
          structureDescription: description {
            ...multilang
          }
          survey {
            id
          }
          questionNumber
          conditions {
            metaConditions {
              id
              childMetaConditionIds
              combinationOperator
              displayName
            }
            questionChoiceConditions {
              id
              metaConditionId
              questionId
              questionChoiceId
            }
          }
          questions {
            __typename
            id
            title {
              ...multilang
            }
            description {
              ...multilang
            }
            optional
            variableName
            reportDisplayLabel
            choiceSet {
              id
              type
              maxSelection
              randomizeChoices
              scaleData {
                scaleType
                scaleThreshold
              }
              choices {
                id
                text {
                  ...multilang
                }
                choiceValue
              }
              sharedChoiceSetData {
                id
              }
            }
            schedule {
              status
            }
            conditions {
              metaConditions {
                id
                childMetaConditionIds
                combinationOperator
                displayName
              }
              questionChoiceConditions {
                id
                metaConditionId
                questionId
                questionChoiceId
              }
            }
          }
          numColumns
          ...RowContentHierarchyNodes
        }
        ... on QuestionHierarchyVisualizationNode {
          ...VisualizationNode
        }
        ... on QuestionHierarchySimulationNode {
          ...AdminSimulationNode
        }
      }
      reportTabs(publiclyShared: false) {
        id
        title
        order
        visibleToAdmins
        publiclyShared
        trackDomain
        content {
          type
          HTML
          TABLEAU
          height
        }
      }
      hasPdfUrl
      totalRespondents
    }
  }
}
    ${Multilang}
${RowContentHierarchyNodes}
${VisualizationNode}
${AdminSimulationNode}`;

/**
 * __useAdminOpenQuestionSetStructure__
 *
 * To run a query within a React component, call `useAdminOpenQuestionSetStructure` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenQuestionSetStructure` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenQuestionSetStructure({
 *   variables: {
 *      setId: // value for 'setId'
 *      areaMode: // value for 'areaMode'
 *      comparisonGroupId: // value for 'comparisonGroupId'
 *      fipsCodes: // value for 'fipsCodes'
 *   },
 * });
 */
export function useAdminOpenQuestionSetStructure(baseOptions: Apollo.QueryHookOptions<AdminOpenQuestionSetStructure, AdminOpenQuestionSetStructureVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenQuestionSetStructure, AdminOpenQuestionSetStructureVariables>(AdminOpenQuestionSetStructureDocument, options);
      }
export function useAdminOpenQuestionSetStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenQuestionSetStructure, AdminOpenQuestionSetStructureVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenQuestionSetStructure, AdminOpenQuestionSetStructureVariables>(AdminOpenQuestionSetStructureDocument, options);
        }
export type AdminOpenQuestionSetStructureHookResult = ReturnType<typeof useAdminOpenQuestionSetStructure>;
export type AdminOpenQuestionSetStructureLazyQueryHookResult = ReturnType<typeof useAdminOpenQuestionSetStructureLazyQuery>;
export type AdminOpenQuestionSetStructureQueryResult = Apollo.QueryResult<AdminOpenQuestionSetStructure, AdminOpenQuestionSetStructureVariables>;
export const AdminOpenQuestionSetTopicDetailsQualityAggregateResultDocument = gql`
    query AdminOpenQuestionSetTopicDetailsQualityAggregateResult($setId: ID!, $filter: TopicFilter!) {
  openContentSetById(setId: $setId) {
    __typename
    ... on Survey {
      id
      publishingEntity {
        id
        name {
          ...multilang
        }
      }
      schedule {
        openDate {
          raw
        }
        closeDate {
          raw
        }
      }
      topics(filter: $filter) {
        ...SurveyBenchmarkTopic
        quality: qualitativeAggregateResult(qualitativeTopic: QUALITY) {
          aggregateValue
          trend {
            ...TrendAggregateResult
          }
        }
        relatedQuestions {
          id
          isBenchmarkedQuestion
          questionNumber
          title {
            ...multilang
          }
          topics {
            id
            name
          }
          choiceSet {
            id
            type
            scaleData {
              scaleType
              scaleThreshold
              alternateScaleName
            }
          }
          hierarchyParentNode {
            id
            label {
              ...multilang
            }
          }
          aggregateResults {
            ...AggregateResults
          }
          commentsData {
            totalCount
          }
          commentsWordCount {
            value
            text
          }
          questionSet {
            ... on ContentSetBase {
              id
              schedule {
                status
                openDate {
                  raw
                }
                closeDate {
                  raw
                }
              }
              publishingEntity {
                id
                name {
                  ...multilang
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${Multilang}
${SurveyBenchmarkTopic}
${TrendAggregateResult}
${AggregateResults}`;

/**
 * __useAdminOpenQuestionSetTopicDetailsQualityAggregateResult__
 *
 * To run a query within a React component, call `useAdminOpenQuestionSetTopicDetailsQualityAggregateResult` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenQuestionSetTopicDetailsQualityAggregateResult` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenQuestionSetTopicDetailsQualityAggregateResult({
 *   variables: {
 *      setId: // value for 'setId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAdminOpenQuestionSetTopicDetailsQualityAggregateResult(baseOptions: Apollo.QueryHookOptions<AdminOpenQuestionSetTopicDetailsQualityAggregateResult, AdminOpenQuestionSetTopicDetailsQualityAggregateResultVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenQuestionSetTopicDetailsQualityAggregateResult, AdminOpenQuestionSetTopicDetailsQualityAggregateResultVariables>(AdminOpenQuestionSetTopicDetailsQualityAggregateResultDocument, options);
      }
export function useAdminOpenQuestionSetTopicDetailsQualityAggregateResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenQuestionSetTopicDetailsQualityAggregateResult, AdminOpenQuestionSetTopicDetailsQualityAggregateResultVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenQuestionSetTopicDetailsQualityAggregateResult, AdminOpenQuestionSetTopicDetailsQualityAggregateResultVariables>(AdminOpenQuestionSetTopicDetailsQualityAggregateResultDocument, options);
        }
export type AdminOpenQuestionSetTopicDetailsQualityAggregateResultHookResult = ReturnType<typeof useAdminOpenQuestionSetTopicDetailsQualityAggregateResult>;
export type AdminOpenQuestionSetTopicDetailsQualityAggregateResultLazyQueryHookResult = ReturnType<typeof useAdminOpenQuestionSetTopicDetailsQualityAggregateResultLazyQuery>;
export type AdminOpenQuestionSetTopicDetailsQualityAggregateResultQueryResult = Apollo.QueryResult<AdminOpenQuestionSetTopicDetailsQualityAggregateResult, AdminOpenQuestionSetTopicDetailsQualityAggregateResultVariables>;
export const AdminOpenQuestionSetTopicDetailsQualityImportanceDocument = gql`
    query AdminOpenQuestionSetTopicDetailsQualityImportance($setId: ID!, $filter: TopicFilter!) {
  openContentSetById(setId: $setId) {
    __typename
    ... on Survey {
      id
      publishingEntity {
        id
        name {
          ...multilang
        }
      }
      topics(filter: $filter) {
        ...SurveyBenchmarkTopic
        importance: qualitativeQuestion(qualitativeTopic: IMPORTANCE) {
          id
          isBenchmarkedQuestion
          questionNumber
          title {
            ...multilang
          }
          choiceSet {
            id
            type
            scaleData {
              scaleType
              scaleThreshold
              alternateScaleName
            }
          }
          hierarchyParentNode {
            id
            label {
              ...multilang
            }
          }
          aggregateResults {
            ...AggregateResults
          }
          commentsData {
            totalCount
          }
          commentsWordCount {
            value
            text
          }
          questionSet {
            ... on ContentSetBase {
              id
              schedule {
                openDate {
                  raw
                }
                closeDate {
                  raw
                }
                status
              }
              publishingEntity {
                id
                name {
                  ...multilang
                }
              }
            }
          }
        }
        quality: qualitativeQuestion(qualitativeTopic: QUALITY) {
          id
          isBenchmarkedQuestion
          questionNumber
          title {
            ...multilang
          }
          choiceSet {
            id
            type
            scaleData {
              scaleType
              scaleThreshold
              alternateScaleName
            }
          }
          hierarchyParentNode {
            id
            label {
              ...multilang
            }
          }
          aggregateResults {
            ...AggregateResults
          }
          commentsData {
            totalCount
          }
          commentsWordCount {
            value
            text
          }
          questionSet {
            ... on ContentSetBase {
              id
              schedule {
                openDate {
                  raw
                }
                closeDate {
                  raw
                }
                status
              }
              publishingEntity {
                id
                name {
                  ...multilang
                }
              }
            }
          }
        }
        relatedQuestions {
          id
          isBenchmarkedQuestion
          questionNumber
          title {
            ...multilang
          }
          topics {
            id
            name
          }
          choiceSet {
            id
            type
            scaleData {
              scaleType
              scaleThreshold
              alternateScaleName
            }
          }
          hierarchyParentNode {
            id
            label {
              ...multilang
            }
          }
          aggregateResults {
            ...AggregateResults
          }
          commentsData {
            totalCount
          }
          commentsWordCount {
            value
            text
          }
          questionSet {
            ... on ContentSetBase {
              id
              schedule {
                openDate {
                  raw
                }
                closeDate {
                  raw
                }
                status
              }
              publishingEntity {
                id
                name {
                  ...multilang
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${Multilang}
${SurveyBenchmarkTopic}
${AggregateResults}`;

/**
 * __useAdminOpenQuestionSetTopicDetailsQualityImportance__
 *
 * To run a query within a React component, call `useAdminOpenQuestionSetTopicDetailsQualityImportance` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenQuestionSetTopicDetailsQualityImportance` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenQuestionSetTopicDetailsQualityImportance({
 *   variables: {
 *      setId: // value for 'setId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAdminOpenQuestionSetTopicDetailsQualityImportance(baseOptions: Apollo.QueryHookOptions<AdminOpenQuestionSetTopicDetailsQualityImportance, AdminOpenQuestionSetTopicDetailsQualityImportanceVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenQuestionSetTopicDetailsQualityImportance, AdminOpenQuestionSetTopicDetailsQualityImportanceVariables>(AdminOpenQuestionSetTopicDetailsQualityImportanceDocument, options);
      }
export function useAdminOpenQuestionSetTopicDetailsQualityImportanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenQuestionSetTopicDetailsQualityImportance, AdminOpenQuestionSetTopicDetailsQualityImportanceVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenQuestionSetTopicDetailsQualityImportance, AdminOpenQuestionSetTopicDetailsQualityImportanceVariables>(AdminOpenQuestionSetTopicDetailsQualityImportanceDocument, options);
        }
export type AdminOpenQuestionSetTopicDetailsQualityImportanceHookResult = ReturnType<typeof useAdminOpenQuestionSetTopicDetailsQualityImportance>;
export type AdminOpenQuestionSetTopicDetailsQualityImportanceLazyQueryHookResult = ReturnType<typeof useAdminOpenQuestionSetTopicDetailsQualityImportanceLazyQuery>;
export type AdminOpenQuestionSetTopicDetailsQualityImportanceQueryResult = Apollo.QueryResult<AdminOpenQuestionSetTopicDetailsQualityImportance, AdminOpenQuestionSetTopicDetailsQualityImportanceVariables>;
export const AdminOpenQuestionSetTopicsQualityAggregateResultDocument = gql`
    query AdminOpenQuestionSetTopicsQualityAggregateResult($setId: ID!, $filter: TopicFilter!) {
  openContentSetById(setId: $setId) {
    __typename
    ... on Survey {
      id
      publishingEntity {
        id
        name {
          ...multilang
        }
      }
      topics(filter: $filter) {
        ...SurveyBenchmarkTopic
        quality: qualitativeAggregateResult(qualitativeTopic: QUALITY) {
          aggregateValue
          trend {
            ...TrendAggregateResult
          }
        }
      }
    }
  }
}
    ${Multilang}
${SurveyBenchmarkTopic}
${TrendAggregateResult}`;

/**
 * __useAdminOpenQuestionSetTopicsQualityAggregateResult__
 *
 * To run a query within a React component, call `useAdminOpenQuestionSetTopicsQualityAggregateResult` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenQuestionSetTopicsQualityAggregateResult` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenQuestionSetTopicsQualityAggregateResult({
 *   variables: {
 *      setId: // value for 'setId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAdminOpenQuestionSetTopicsQualityAggregateResult(baseOptions: Apollo.QueryHookOptions<AdminOpenQuestionSetTopicsQualityAggregateResult, AdminOpenQuestionSetTopicsQualityAggregateResultVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenQuestionSetTopicsQualityAggregateResult, AdminOpenQuestionSetTopicsQualityAggregateResultVariables>(AdminOpenQuestionSetTopicsQualityAggregateResultDocument, options);
      }
export function useAdminOpenQuestionSetTopicsQualityAggregateResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenQuestionSetTopicsQualityAggregateResult, AdminOpenQuestionSetTopicsQualityAggregateResultVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenQuestionSetTopicsQualityAggregateResult, AdminOpenQuestionSetTopicsQualityAggregateResultVariables>(AdminOpenQuestionSetTopicsQualityAggregateResultDocument, options);
        }
export type AdminOpenQuestionSetTopicsQualityAggregateResultHookResult = ReturnType<typeof useAdminOpenQuestionSetTopicsQualityAggregateResult>;
export type AdminOpenQuestionSetTopicsQualityAggregateResultLazyQueryHookResult = ReturnType<typeof useAdminOpenQuestionSetTopicsQualityAggregateResultLazyQuery>;
export type AdminOpenQuestionSetTopicsQualityAggregateResultQueryResult = Apollo.QueryResult<AdminOpenQuestionSetTopicsQualityAggregateResult, AdminOpenQuestionSetTopicsQualityAggregateResultVariables>;
export const AdminOpenQuestionSetTopicsQualityImportanceDocument = gql`
    query AdminOpenQuestionSetTopicsQualityImportance($setId: ID!, $filter: TopicFilter!) {
  openContentSetById(setId: $setId) {
    __typename
    ... on Survey {
      id
      publishingEntity {
        id
        name {
          ...multilang
        }
      }
      topics(filter: $filter) {
        ...SurveyBenchmarkTopic
        importance: qualitativeQuestion(qualitativeTopic: IMPORTANCE) {
          id
          aggregateResults {
            aggregateValue
            trend {
              value
            }
            benchmark {
              value
            }
          }
        }
        quality: qualitativeQuestion(qualitativeTopic: QUALITY) {
          id
          aggregateResults {
            aggregateValue
            trend {
              value
            }
            benchmark {
              value
            }
          }
        }
      }
      criticalFocusTopics(filter: $filter) {
        ...SurveyBenchmarkTopic
      }
    }
  }
}
    ${Multilang}
${SurveyBenchmarkTopic}`;

/**
 * __useAdminOpenQuestionSetTopicsQualityImportance__
 *
 * To run a query within a React component, call `useAdminOpenQuestionSetTopicsQualityImportance` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenQuestionSetTopicsQualityImportance` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenQuestionSetTopicsQualityImportance({
 *   variables: {
 *      setId: // value for 'setId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAdminOpenQuestionSetTopicsQualityImportance(baseOptions: Apollo.QueryHookOptions<AdminOpenQuestionSetTopicsQualityImportance, AdminOpenQuestionSetTopicsQualityImportanceVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenQuestionSetTopicsQualityImportance, AdminOpenQuestionSetTopicsQualityImportanceVariables>(AdminOpenQuestionSetTopicsQualityImportanceDocument, options);
      }
export function useAdminOpenQuestionSetTopicsQualityImportanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenQuestionSetTopicsQualityImportance, AdminOpenQuestionSetTopicsQualityImportanceVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenQuestionSetTopicsQualityImportance, AdminOpenQuestionSetTopicsQualityImportanceVariables>(AdminOpenQuestionSetTopicsQualityImportanceDocument, options);
        }
export type AdminOpenQuestionSetTopicsQualityImportanceHookResult = ReturnType<typeof useAdminOpenQuestionSetTopicsQualityImportance>;
export type AdminOpenQuestionSetTopicsQualityImportanceLazyQueryHookResult = ReturnType<typeof useAdminOpenQuestionSetTopicsQualityImportanceLazyQuery>;
export type AdminOpenQuestionSetTopicsQualityImportanceQueryResult = Apollo.QueryResult<AdminOpenQuestionSetTopicsQualityImportance, AdminOpenQuestionSetTopicsQualityImportanceVariables>;
export const AdminOpenQuestionStructureDocument = gql`
    query AdminOpenQuestionStructure($questionId: ID!) {
  openQuestion(questionId: $questionId) {
    id
    title {
      ...multilang
    }
    summary
    description {
      ...multilang
    }
    shortId
    optional
    isBenchmarkedQuestion
    choiceSet {
      id
      type
      maxSelection
      choices {
        id
        text {
          ...multilang
        }
      }
      sharedChoiceSetData {
        id
      }
    }
    questionSet {
      ... on ContentSetBase {
        id
        polcoManaged
      }
    }
    schedule {
      status
      openDate {
        raw
      }
      closeDate {
        raw
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useAdminOpenQuestionStructure__
 *
 * To run a query within a React component, call `useAdminOpenQuestionStructure` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenQuestionStructure` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenQuestionStructure({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useAdminOpenQuestionStructure(baseOptions: Apollo.QueryHookOptions<AdminOpenQuestionStructure, AdminOpenQuestionStructureVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenQuestionStructure, AdminOpenQuestionStructureVariables>(AdminOpenQuestionStructureDocument, options);
      }
export function useAdminOpenQuestionStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenQuestionStructure, AdminOpenQuestionStructureVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenQuestionStructure, AdminOpenQuestionStructureVariables>(AdminOpenQuestionStructureDocument, options);
        }
export type AdminOpenQuestionStructureHookResult = ReturnType<typeof useAdminOpenQuestionStructure>;
export type AdminOpenQuestionStructureLazyQueryHookResult = ReturnType<typeof useAdminOpenQuestionStructureLazyQuery>;
export type AdminOpenQuestionStructureQueryResult = Apollo.QueryResult<AdminOpenQuestionStructure, AdminOpenQuestionStructureVariables>;
export const OpenQuestionWithCommentsDocument = gql`
    query OpenQuestionWithComments($commentFilter: CommentFilter, $pagination: PaginationParams, $questionId: ID!, $resultFilter: ResultFilter) {
  openQuestion(questionId: $questionId) {
    id
    title {
      ...multilang
    }
    summary
    description {
      ...multilang
    }
    variableName
    choiceSet {
      id
      type
      choices {
        id
        text {
          ...multilang
        }
        choiceValue
      }
    }
    results(filter: $resultFilter) {
      ...QuestionResults_Fragment
    }
    commentsData(filter: $commentFilter) {
      totalCount
      comments(pagination: $pagination) {
        id
        commenterChoice {
          id
        }
        comment
        commenter {
          ... on RespondentBase {
            id
            firstName
            lastName
            postAnonymously
            avatarUrl
          }
        }
        commentDate {
          raw
        }
        upvoteCount
      }
    }
  }
}
    ${Multilang}
${QuestionResults_Fragment}`;

/**
 * __useOpenQuestionWithComments__
 *
 * To run a query within a React component, call `useOpenQuestionWithComments` and pass it any options that fit your needs.
 * When your component renders, `useOpenQuestionWithComments` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenQuestionWithComments({
 *   variables: {
 *      commentFilter: // value for 'commentFilter'
 *      pagination: // value for 'pagination'
 *      questionId: // value for 'questionId'
 *      resultFilter: // value for 'resultFilter'
 *   },
 * });
 */
export function useOpenQuestionWithComments(baseOptions: Apollo.QueryHookOptions<OpenQuestionWithComments, OpenQuestionWithCommentsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpenQuestionWithComments, OpenQuestionWithCommentsVariables>(OpenQuestionWithCommentsDocument, options);
      }
export function useOpenQuestionWithCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpenQuestionWithComments, OpenQuestionWithCommentsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpenQuestionWithComments, OpenQuestionWithCommentsVariables>(OpenQuestionWithCommentsDocument, options);
        }
export type OpenQuestionWithCommentsHookResult = ReturnType<typeof useOpenQuestionWithComments>;
export type OpenQuestionWithCommentsLazyQueryHookResult = ReturnType<typeof useOpenQuestionWithCommentsLazyQuery>;
export type OpenQuestionWithCommentsQueryResult = Apollo.QueryResult<OpenQuestionWithComments, OpenQuestionWithCommentsVariables>;
export const AdminOpenVisualizationDocument = gql`
    query AdminOpenVisualization($visualizationId: ID!, $areaMode: TrackAreaMode, $comparisonGroupId: ID, $fipsCodes: [String!]) {
  openSavedTrackVariableVisualizationById(visualizationId: $visualizationId) {
    ...TrackVisualization
    visualizationAreas {
      id
      shape {
        type
        coordinates
      }
    }
    boundingBox {
      id
      xMin
      xMax
      yMin
      yMax
    }
    plans {
      ...StrategicPlan
    }
  }
}
    ${TrackVisualization}
${StrategicPlan}`;

/**
 * __useAdminOpenVisualization__
 *
 * To run a query within a React component, call `useAdminOpenVisualization` and pass it any options that fit your needs.
 * When your component renders, `useAdminOpenVisualization` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOpenVisualization({
 *   variables: {
 *      visualizationId: // value for 'visualizationId'
 *      areaMode: // value for 'areaMode'
 *      comparisonGroupId: // value for 'comparisonGroupId'
 *      fipsCodes: // value for 'fipsCodes'
 *   },
 * });
 */
export function useAdminOpenVisualization(baseOptions: Apollo.QueryHookOptions<AdminOpenVisualization, AdminOpenVisualizationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOpenVisualization, AdminOpenVisualizationVariables>(AdminOpenVisualizationDocument, options);
      }
export function useAdminOpenVisualizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOpenVisualization, AdminOpenVisualizationVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOpenVisualization, AdminOpenVisualizationVariables>(AdminOpenVisualizationDocument, options);
        }
export type AdminOpenVisualizationHookResult = ReturnType<typeof useAdminOpenVisualization>;
export type AdminOpenVisualizationLazyQueryHookResult = ReturnType<typeof useAdminOpenVisualizationLazyQuery>;
export type AdminOpenVisualizationQueryResult = Apollo.QueryResult<AdminOpenVisualization, AdminOpenVisualizationVariables>;
export const AdminOverviewParticipantsDocument = gql`
    query AdminOverviewParticipants($setId: ID!) {
  openContentSetById(setId: $setId) {
    __typename
    ... on Survey {
      id
      totalRespondents
      totalWeightedRespondents
      benchmarkType {
        type
      }
      publishingEntity {
        id
        name {
          ...multilang
        }
      }
      schedule {
        openDate {
          raw
        }
        closeDate {
          raw
        }
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useAdminOverviewParticipants__
 *
 * To run a query within a React component, call `useAdminOverviewParticipants` and pass it any options that fit your needs.
 * When your component renders, `useAdminOverviewParticipants` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOverviewParticipants({
 *   variables: {
 *      setId: // value for 'setId'
 *   },
 * });
 */
export function useAdminOverviewParticipants(baseOptions: Apollo.QueryHookOptions<AdminOverviewParticipants, AdminOverviewParticipantsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOverviewParticipants, AdminOverviewParticipantsVariables>(AdminOverviewParticipantsDocument, options);
      }
export function useAdminOverviewParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOverviewParticipants, AdminOverviewParticipantsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOverviewParticipants, AdminOverviewParticipantsVariables>(AdminOverviewParticipantsDocument, options);
        }
export type AdminOverviewParticipantsHookResult = ReturnType<typeof useAdminOverviewParticipants>;
export type AdminOverviewParticipantsLazyQueryHookResult = ReturnType<typeof useAdminOverviewParticipantsLazyQuery>;
export type AdminOverviewParticipantsQueryResult = Apollo.QueryResult<AdminOverviewParticipants, AdminOverviewParticipantsVariables>;
export const AdminPublishContentLimitDocument = gql`
    query AdminPublishContentLimit($setId: ID!, $skipBenchmarkCheck: Boolean!) {
  currentUser {
    id
    user {
      id
      admin {
        __typename
        ... on PrivateAdmin {
          id
          superAdmin
          requestedFeatures
          activePublishingEntity {
            id
            isEnterprise
            engageContentLimit: featureSettings(names: ["ENGAGE_CONTENT_LIMIT"]) {
              id
              isUnlimited
              featureSettingId
              featureSettingName
              enabled
              expirationDate {
                raw
              }
              quantity
              activeCount
            }
          }
        }
      }
    }
  }
  openContentSetById(setId: $setId) @skip(if: $skipBenchmarkCheck) {
    ... on ContentSetBase {
      id
    }
    ... on Survey {
      id
      benchmarkType {
        type
      }
    }
  }
}
    `;

/**
 * __useAdminPublishContentLimit__
 *
 * To run a query within a React component, call `useAdminPublishContentLimit` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishContentLimit` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishContentLimit({
 *   variables: {
 *      setId: // value for 'setId'
 *      skipBenchmarkCheck: // value for 'skipBenchmarkCheck'
 *   },
 * });
 */
export function useAdminPublishContentLimit(baseOptions: Apollo.QueryHookOptions<AdminPublishContentLimit, AdminPublishContentLimitVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishContentLimit, AdminPublishContentLimitVariables>(AdminPublishContentLimitDocument, options);
      }
export function useAdminPublishContentLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishContentLimit, AdminPublishContentLimitVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishContentLimit, AdminPublishContentLimitVariables>(AdminPublishContentLimitDocument, options);
        }
export type AdminPublishContentLimitHookResult = ReturnType<typeof useAdminPublishContentLimit>;
export type AdminPublishContentLimitLazyQueryHookResult = ReturnType<typeof useAdminPublishContentLimitLazyQuery>;
export type AdminPublishContentLimitQueryResult = Apollo.QueryResult<AdminPublishContentLimit, AdminPublishContentLimitVariables>;
export const AdminPublishersFeatureSettingsDocument = gql`
    query AdminPublishersFeatureSettings($filter: String) {
  adminPublishers(page: 0, filter: $filter) {
    id
    name {
      ...multilang
    }
    occupiedSeats
    totalSeats: featureSettingQuantity(featureSettingName: "ADMIN_SEATS")
    aiAssistantQueryLimit: featureSettingQuantity(
      featureSettingName: "AI_ASSISTANT"
    )
    grantWriterAssistantQueryLimit: featureSettingQuantity(
      featureSettingName: "GRANT_WRITER_ASSISTANT"
    )
    engageContentLimit: featureSettingQuantity(
      featureSettingName: "ENGAGE_CONTENT_LIMIT"
    )
    visualizationsLimit: featureSettingQuantity(
      featureSettingName: "SAVED_DATA_POINTS"
    )
    activeEngageContentCount
  }
}
    ${Multilang}`;

/**
 * __useAdminPublishersFeatureSettings__
 *
 * To run a query within a React component, call `useAdminPublishersFeatureSettings` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishersFeatureSettings` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishersFeatureSettings({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAdminPublishersFeatureSettings(baseOptions?: Apollo.QueryHookOptions<AdminPublishersFeatureSettings, AdminPublishersFeatureSettingsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishersFeatureSettings, AdminPublishersFeatureSettingsVariables>(AdminPublishersFeatureSettingsDocument, options);
      }
export function useAdminPublishersFeatureSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishersFeatureSettings, AdminPublishersFeatureSettingsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishersFeatureSettings, AdminPublishersFeatureSettingsVariables>(AdminPublishersFeatureSettingsDocument, options);
        }
export type AdminPublishersFeatureSettingsHookResult = ReturnType<typeof useAdminPublishersFeatureSettings>;
export type AdminPublishersFeatureSettingsLazyQueryHookResult = ReturnType<typeof useAdminPublishersFeatureSettingsLazyQuery>;
export type AdminPublishersFeatureSettingsQueryResult = Apollo.QueryResult<AdminPublishersFeatureSettings, AdminPublishersFeatureSettingsVariables>;
export const AdminPublishersWithSeatsDocument = gql`
    query AdminPublishersWithSeats($filter: String) {
  adminPublishers(page: 0, filter: $filter) {
    id
    name {
      ...multilang
    }
    occupiedSeats
    totalSeats: featureSettingQuantity(featureSettingName: "ADMIN_SEATS")
  }
}
    ${Multilang}`;

/**
 * __useAdminPublishersWithSeats__
 *
 * To run a query within a React component, call `useAdminPublishersWithSeats` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishersWithSeats` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishersWithSeats({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAdminPublishersWithSeats(baseOptions?: Apollo.QueryHookOptions<AdminPublishersWithSeats, AdminPublishersWithSeatsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishersWithSeats, AdminPublishersWithSeatsVariables>(AdminPublishersWithSeatsDocument, options);
      }
export function useAdminPublishersWithSeatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishersWithSeats, AdminPublishersWithSeatsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishersWithSeats, AdminPublishersWithSeatsVariables>(AdminPublishersWithSeatsDocument, options);
        }
export type AdminPublishersWithSeatsHookResult = ReturnType<typeof useAdminPublishersWithSeats>;
export type AdminPublishersWithSeatsLazyQueryHookResult = ReturnType<typeof useAdminPublishersWithSeatsLazyQuery>;
export type AdminPublishersWithSeatsQueryResult = Apollo.QueryResult<AdminPublishersWithSeats, AdminPublishersWithSeatsVariables>;
export const AdminPublishingEntityAiAssistantInteractionsDocument = gql`
    query AdminPublishingEntityAiAssistantInteractions($publishingEntityId: ID!, $assistant: AssistantIdInput!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    aiAssistantInteractions(assistant: $assistant) {
      publishingEntityId
      sessionCount
      queryCount
    }
  }
}
    `;

/**
 * __useAdminPublishingEntityAiAssistantInteractions__
 *
 * To run a query within a React component, call `useAdminPublishingEntityAiAssistantInteractions` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingEntityAiAssistantInteractions` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingEntityAiAssistantInteractions({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      assistant: // value for 'assistant'
 *   },
 * });
 */
export function useAdminPublishingEntityAiAssistantInteractions(baseOptions: Apollo.QueryHookOptions<AdminPublishingEntityAiAssistantInteractions, AdminPublishingEntityAiAssistantInteractionsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingEntityAiAssistantInteractions, AdminPublishingEntityAiAssistantInteractionsVariables>(AdminPublishingEntityAiAssistantInteractionsDocument, options);
      }
export function useAdminPublishingEntityAiAssistantInteractionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingEntityAiAssistantInteractions, AdminPublishingEntityAiAssistantInteractionsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingEntityAiAssistantInteractions, AdminPublishingEntityAiAssistantInteractionsVariables>(AdminPublishingEntityAiAssistantInteractionsDocument, options);
        }
export type AdminPublishingEntityAiAssistantInteractionsHookResult = ReturnType<typeof useAdminPublishingEntityAiAssistantInteractions>;
export type AdminPublishingEntityAiAssistantInteractionsLazyQueryHookResult = ReturnType<typeof useAdminPublishingEntityAiAssistantInteractionsLazyQuery>;
export type AdminPublishingEntityAiAssistantInteractionsQueryResult = Apollo.QueryResult<AdminPublishingEntityAiAssistantInteractions, AdminPublishingEntityAiAssistantInteractionsVariables>;
export const AdminPublishingEntityBenchmarkSurveysDocument = gql`
    query AdminPublishingEntityBenchmarkSurveys($publishingEntityId: ID!, $type: BenchmarkSurveyTypes) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    createdBenchmarkSurveys(type: $type) {
      id
      name {
        defaultValue
      }
      schedule {
        status
        openDate {
          raw
        }
        closeDate {
          raw
        }
      }
      benchmarkType {
        type
      }
      hasVisibleReportTabs
    }
  }
}
    `;

/**
 * __useAdminPublishingEntityBenchmarkSurveys__
 *
 * To run a query within a React component, call `useAdminPublishingEntityBenchmarkSurveys` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingEntityBenchmarkSurveys` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingEntityBenchmarkSurveys({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAdminPublishingEntityBenchmarkSurveys(baseOptions: Apollo.QueryHookOptions<AdminPublishingEntityBenchmarkSurveys, AdminPublishingEntityBenchmarkSurveysVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingEntityBenchmarkSurveys, AdminPublishingEntityBenchmarkSurveysVariables>(AdminPublishingEntityBenchmarkSurveysDocument, options);
      }
export function useAdminPublishingEntityBenchmarkSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingEntityBenchmarkSurveys, AdminPublishingEntityBenchmarkSurveysVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingEntityBenchmarkSurveys, AdminPublishingEntityBenchmarkSurveysVariables>(AdminPublishingEntityBenchmarkSurveysDocument, options);
        }
export type AdminPublishingEntityBenchmarkSurveysHookResult = ReturnType<typeof useAdminPublishingEntityBenchmarkSurveys>;
export type AdminPublishingEntityBenchmarkSurveysLazyQueryHookResult = ReturnType<typeof useAdminPublishingEntityBenchmarkSurveysLazyQuery>;
export type AdminPublishingEntityBenchmarkSurveysQueryResult = Apollo.QueryResult<AdminPublishingEntityBenchmarkSurveys, AdminPublishingEntityBenchmarkSurveysVariables>;
export const AdminPublishingEntityComparisonGroupsDocument = gql`
    query AdminPublishingEntityComparisonGroups($publishingEntityId: ID!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    fipsArea {
      id
      name
      shortName
      type
    }
    comparisonGroups {
      id
      name
      fips {
        id
      }
    }
  }
}
    `;

/**
 * __useAdminPublishingEntityComparisonGroups__
 *
 * To run a query within a React component, call `useAdminPublishingEntityComparisonGroups` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingEntityComparisonGroups` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingEntityComparisonGroups({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useAdminPublishingEntityComparisonGroups(baseOptions: Apollo.QueryHookOptions<AdminPublishingEntityComparisonGroups, AdminPublishingEntityComparisonGroupsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingEntityComparisonGroups, AdminPublishingEntityComparisonGroupsVariables>(AdminPublishingEntityComparisonGroupsDocument, options);
      }
export function useAdminPublishingEntityComparisonGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingEntityComparisonGroups, AdminPublishingEntityComparisonGroupsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingEntityComparisonGroups, AdminPublishingEntityComparisonGroupsVariables>(AdminPublishingEntityComparisonGroupsDocument, options);
        }
export type AdminPublishingEntityComparisonGroupsHookResult = ReturnType<typeof useAdminPublishingEntityComparisonGroups>;
export type AdminPublishingEntityComparisonGroupsLazyQueryHookResult = ReturnType<typeof useAdminPublishingEntityComparisonGroupsLazyQuery>;
export type AdminPublishingEntityComparisonGroupsQueryResult = Apollo.QueryResult<AdminPublishingEntityComparisonGroups, AdminPublishingEntityComparisonGroupsVariables>;
export const AdminPublishingEntityContentListDocument = gql`
    query AdminPublishingEntityContentList($publishingEntityId: ID!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    simulations {
      id
      name
      isPrioritization
      type
      url
      description
      status
      createDate {
        raw
      }
    }
    createdQuestionSets(
      status: [NOT_STARTED, IN_PROGRESS, SCHEDULED, CLOSED, ARCHIVED]
      generatedTypes: [RAILS_SET]
    ) {
      questionSets {
        __typename
        ... on ContentSetBase {
          id
          slug
          name {
            ...multilang
          }
          description {
            ...multilang
          }
          shortDescription {
            ...multilang
          }
          featureSetType
          isPinnedToPublisher
          createDate {
            raw
          }
          schedule {
            status
            openDate {
              raw
            }
            closeDate {
              raw
            }
          }
          questionsCount
          publishingEntity {
            id
            slug
          }
          totalRespondents(scopeByPublishingEntityId: $publishingEntityId)
          polcoManaged
          shareableContentSet {
            id
            isPaidContent
            shareType
            adminDescription
            contentSet {
              __typename
              ... on ContentSetBase {
                id
              }
            }
          }
        }
        ... on PolcoLive {
          settings {
            id
            eventStartDate {
              raw
            }
            eventEndDate {
              raw
            }
          }
        }
      }
    }
    shareableContentSetsForSidebar {
      id
      shareType
      isPaidContent
      adminDescription
      contentSet {
        __typename
        ... on ContentSetBase {
          id
          name {
            ...multilang
          }
          description {
            ...multilang
          }
        }
      }
    }
    ncsFacetSummaries {
      id
      surveyid
      GEO_NAME
      fips
      year
      ncs
      added
      area
      title
      newmax
      pctpos
      avgptm
      n
      bmark
    }
  }
}
    ${Multilang}`;

/**
 * __useAdminPublishingEntityContentList__
 *
 * To run a query within a React component, call `useAdminPublishingEntityContentList` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingEntityContentList` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingEntityContentList({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useAdminPublishingEntityContentList(baseOptions: Apollo.QueryHookOptions<AdminPublishingEntityContentList, AdminPublishingEntityContentListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingEntityContentList, AdminPublishingEntityContentListVariables>(AdminPublishingEntityContentListDocument, options);
      }
export function useAdminPublishingEntityContentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingEntityContentList, AdminPublishingEntityContentListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingEntityContentList, AdminPublishingEntityContentListVariables>(AdminPublishingEntityContentListDocument, options);
        }
export type AdminPublishingEntityContentListHookResult = ReturnType<typeof useAdminPublishingEntityContentList>;
export type AdminPublishingEntityContentListLazyQueryHookResult = ReturnType<typeof useAdminPublishingEntityContentListLazyQuery>;
export type AdminPublishingEntityContentListQueryResult = Apollo.QueryResult<AdminPublishingEntityContentList, AdminPublishingEntityContentListVariables>;
export const AdminPublishingEntityContentSetIdsDocument = gql`
    query AdminPublishingEntityContentSetIds($publishingEntityId: ID!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    createdQuestionSets(
      status: [NOT_STARTED, IN_PROGRESS, SCHEDULED, CLOSED]
      generatedTypes: []
    ) {
      questionSets {
        __typename
        ... on ContentSetBase {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useAdminPublishingEntityContentSetIds__
 *
 * To run a query within a React component, call `useAdminPublishingEntityContentSetIds` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingEntityContentSetIds` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingEntityContentSetIds({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useAdminPublishingEntityContentSetIds(baseOptions: Apollo.QueryHookOptions<AdminPublishingEntityContentSetIds, AdminPublishingEntityContentSetIdsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingEntityContentSetIds, AdminPublishingEntityContentSetIdsVariables>(AdminPublishingEntityContentSetIdsDocument, options);
      }
export function useAdminPublishingEntityContentSetIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingEntityContentSetIds, AdminPublishingEntityContentSetIdsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingEntityContentSetIds, AdminPublishingEntityContentSetIdsVariables>(AdminPublishingEntityContentSetIdsDocument, options);
        }
export type AdminPublishingEntityContentSetIdsHookResult = ReturnType<typeof useAdminPublishingEntityContentSetIds>;
export type AdminPublishingEntityContentSetIdsLazyQueryHookResult = ReturnType<typeof useAdminPublishingEntityContentSetIdsLazyQuery>;
export type AdminPublishingEntityContentSetIdsQueryResult = Apollo.QueryResult<AdminPublishingEntityContentSetIds, AdminPublishingEntityContentSetIdsVariables>;
export const AdminPublishingEntityContentSetNamesAndShortUrlsDocument = gql`
    query AdminPublishingEntityContentSetNamesAndShortUrls($publishingEntityId: ID!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    createdQuestionSets(
      status: [NOT_STARTED, IN_PROGRESS, SCHEDULED, CLOSED]
      generatedTypes: []
    ) {
      questionSets {
        __typename
        ... on ContentSetBase {
          id
          name {
            ...multilang
          }
          shortUrls {
            id
            fullUrl
            shortUrl
          }
        }
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useAdminPublishingEntityContentSetNamesAndShortUrls__
 *
 * To run a query within a React component, call `useAdminPublishingEntityContentSetNamesAndShortUrls` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingEntityContentSetNamesAndShortUrls` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingEntityContentSetNamesAndShortUrls({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useAdminPublishingEntityContentSetNamesAndShortUrls(baseOptions: Apollo.QueryHookOptions<AdminPublishingEntityContentSetNamesAndShortUrls, AdminPublishingEntityContentSetNamesAndShortUrlsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingEntityContentSetNamesAndShortUrls, AdminPublishingEntityContentSetNamesAndShortUrlsVariables>(AdminPublishingEntityContentSetNamesAndShortUrlsDocument, options);
      }
export function useAdminPublishingEntityContentSetNamesAndShortUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingEntityContentSetNamesAndShortUrls, AdminPublishingEntityContentSetNamesAndShortUrlsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingEntityContentSetNamesAndShortUrls, AdminPublishingEntityContentSetNamesAndShortUrlsVariables>(AdminPublishingEntityContentSetNamesAndShortUrlsDocument, options);
        }
export type AdminPublishingEntityContentSetNamesAndShortUrlsHookResult = ReturnType<typeof useAdminPublishingEntityContentSetNamesAndShortUrls>;
export type AdminPublishingEntityContentSetNamesAndShortUrlsLazyQueryHookResult = ReturnType<typeof useAdminPublishingEntityContentSetNamesAndShortUrlsLazyQuery>;
export type AdminPublishingEntityContentSetNamesAndShortUrlsQueryResult = Apollo.QueryResult<AdminPublishingEntityContentSetNamesAndShortUrls, AdminPublishingEntityContentSetNamesAndShortUrlsVariables>;
export const AdminPublishingEntityFeatureSettingsDocument = gql`
    query AdminPublishingEntityFeatureSettings($publishingEntityId: ID!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    name {
      ...multilang
    }
    occupiedSeats
    aiAssistantInteractions(assistant: {id: "POLLY", type: StandardAssistant}) {
      queryCount
    }
    grantWriterAssistantInteractions: aiAssistantInteractions(
      assistant: {id: "GRANT_WRITER", type: StandardAssistant}
    ) {
      queryCount
    }
    activeEngageContentCount
    featureSettings {
      id
      featureSettingId
      featureSettingName
      enabled
      expirationDate {
        raw
      }
      quantity
      isUnlimited
    }
  }
}
    ${Multilang}`;

/**
 * __useAdminPublishingEntityFeatureSettings__
 *
 * To run a query within a React component, call `useAdminPublishingEntityFeatureSettings` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingEntityFeatureSettings` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingEntityFeatureSettings({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useAdminPublishingEntityFeatureSettings(baseOptions: Apollo.QueryHookOptions<AdminPublishingEntityFeatureSettings, AdminPublishingEntityFeatureSettingsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingEntityFeatureSettings, AdminPublishingEntityFeatureSettingsVariables>(AdminPublishingEntityFeatureSettingsDocument, options);
      }
export function useAdminPublishingEntityFeatureSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingEntityFeatureSettings, AdminPublishingEntityFeatureSettingsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingEntityFeatureSettings, AdminPublishingEntityFeatureSettingsVariables>(AdminPublishingEntityFeatureSettingsDocument, options);
        }
export type AdminPublishingEntityFeatureSettingsHookResult = ReturnType<typeof useAdminPublishingEntityFeatureSettings>;
export type AdminPublishingEntityFeatureSettingsLazyQueryHookResult = ReturnType<typeof useAdminPublishingEntityFeatureSettingsLazyQuery>;
export type AdminPublishingEntityFeatureSettingsQueryResult = Apollo.QueryResult<AdminPublishingEntityFeatureSettings, AdminPublishingEntityFeatureSettingsVariables>;
export const AdminPublishingEntityIdeaSubmissionsDocument = gql`
    query AdminPublishingEntityIdeaSubmissions($publishingEntityId: ID!, $pagination: PaginationParams!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    ideaSubmissions(pagination: $pagination) {
      id
      respondent {
        ... on RespondentBase {
          id
          publicName
        }
      }
      title
      createDate {
        raw
      }
      aggregations {
        voteUp
        voteDown
      }
    }
  }
}
    `;

/**
 * __useAdminPublishingEntityIdeaSubmissions__
 *
 * To run a query within a React component, call `useAdminPublishingEntityIdeaSubmissions` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingEntityIdeaSubmissions` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingEntityIdeaSubmissions({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAdminPublishingEntityIdeaSubmissions(baseOptions: Apollo.QueryHookOptions<AdminPublishingEntityIdeaSubmissions, AdminPublishingEntityIdeaSubmissionsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingEntityIdeaSubmissions, AdminPublishingEntityIdeaSubmissionsVariables>(AdminPublishingEntityIdeaSubmissionsDocument, options);
      }
export function useAdminPublishingEntityIdeaSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingEntityIdeaSubmissions, AdminPublishingEntityIdeaSubmissionsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingEntityIdeaSubmissions, AdminPublishingEntityIdeaSubmissionsVariables>(AdminPublishingEntityIdeaSubmissionsDocument, options);
        }
export type AdminPublishingEntityIdeaSubmissionsHookResult = ReturnType<typeof useAdminPublishingEntityIdeaSubmissions>;
export type AdminPublishingEntityIdeaSubmissionsLazyQueryHookResult = ReturnType<typeof useAdminPublishingEntityIdeaSubmissionsLazyQuery>;
export type AdminPublishingEntityIdeaSubmissionsQueryResult = Apollo.QueryResult<AdminPublishingEntityIdeaSubmissions, AdminPublishingEntityIdeaSubmissionsVariables>;
export const AdminPublishingEntityOutreachDocument = gql`
    query AdminPublishingEntityOutreach($publishingEntityId: ID!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    name {
      ...multilang
    }
    slug
    description {
      ...multilang
    }
    shortUrl {
      id
      shortUrl
    }
    assets {
      id
      type
      url
    }
    socialConnections {
      id
      provider
      profileNames
    }
  }
}
    ${Multilang}`;

/**
 * __useAdminPublishingEntityOutreach__
 *
 * To run a query within a React component, call `useAdminPublishingEntityOutreach` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingEntityOutreach` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingEntityOutreach({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useAdminPublishingEntityOutreach(baseOptions: Apollo.QueryHookOptions<AdminPublishingEntityOutreach, AdminPublishingEntityOutreachVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingEntityOutreach, AdminPublishingEntityOutreachVariables>(AdminPublishingEntityOutreachDocument, options);
      }
export function useAdminPublishingEntityOutreachLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingEntityOutreach, AdminPublishingEntityOutreachVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingEntityOutreach, AdminPublishingEntityOutreachVariables>(AdminPublishingEntityOutreachDocument, options);
        }
export type AdminPublishingEntityOutreachHookResult = ReturnType<typeof useAdminPublishingEntityOutreach>;
export type AdminPublishingEntityOutreachLazyQueryHookResult = ReturnType<typeof useAdminPublishingEntityOutreachLazyQuery>;
export type AdminPublishingEntityOutreachQueryResult = Apollo.QueryResult<AdminPublishingEntityOutreach, AdminPublishingEntityOutreachVariables>;
export const AdminPublishingEntityPerformanceDataDocument = gql`
    query AdminPublishingEntityPerformanceData($publishingEntityId: ID!, $includeHierarchicalData: Boolean, $historicalDataEntries: Int = 1, $displayType: VariableDisplayType, $areaMode: TrackAreaMode!, $comparisonGroupId: ID, $fipsCodes: [String!]) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    COMMUNITY_CHARACTERISTICS: trackDomain(
      domain: COMMUNITY_CHARACTERISTICS
      includeHierarchicalData: $includeHierarchicalData
      historicalDataEntries: $historicalDataEntries
      displayType: $displayType
      areaMode: $areaMode
    ) {
      ...DomainTrackVariables
    }
    SAFETY: trackDomain(
      domain: SAFETY
      includeHierarchicalData: $includeHierarchicalData
      historicalDataEntries: $historicalDataEntries
      displayType: $displayType
      areaMode: $areaMode
    ) {
      ...DomainTrackVariables
    }
    ECONOMY: trackDomain(
      domain: ECONOMY
      includeHierarchicalData: $includeHierarchicalData
      historicalDataEntries: $historicalDataEntries
      displayType: $displayType
      areaMode: $areaMode
    ) {
      ...DomainTrackVariables
    }
    COMMUNITY_DESIGN: trackDomain(
      domain: COMMUNITY_DESIGN
      includeHierarchicalData: $includeHierarchicalData
      historicalDataEntries: $historicalDataEntries
      displayType: $displayType
      areaMode: $areaMode
    ) {
      ...DomainTrackVariables
    }
    MOBILITY: trackDomain(
      domain: MOBILITY
      includeHierarchicalData: $includeHierarchicalData
      historicalDataEntries: $historicalDataEntries
      displayType: $displayType
      areaMode: $areaMode
    ) {
      ...DomainTrackVariables
    }
    UTILITIES: trackDomain(
      domain: UTILITIES
      includeHierarchicalData: $includeHierarchicalData
      historicalDataEntries: $historicalDataEntries
      displayType: $displayType
      areaMode: $areaMode
    ) {
      ...DomainTrackVariables
    }
    HEALTH_AND_WELLNESS: trackDomain(
      domain: HEALTH_AND_WELLNESS
      includeHierarchicalData: $includeHierarchicalData
      historicalDataEntries: $historicalDataEntries
      displayType: $displayType
      areaMode: $areaMode
    ) {
      ...DomainTrackVariables
    }
    INCLUSIVITY_AND_ENGAGEMENT: trackDomain(
      domain: INCLUSIVITY_AND_ENGAGEMENT
      includeHierarchicalData: $includeHierarchicalData
      historicalDataEntries: $historicalDataEntries
      displayType: $displayType
      areaMode: $areaMode
    ) {
      ...DomainTrackVariables
    }
    EDUCATION_ARTS_CULTURE: trackDomain(
      domain: EDUCATION_ARTS_CULTURE
      includeHierarchicalData: $includeHierarchicalData
      historicalDataEntries: $historicalDataEntries
      displayType: $displayType
      areaMode: $areaMode
    ) {
      ...DomainTrackVariables
    }
    GOVERNANCE: trackDomain(
      domain: GOVERNANCE
      includeHierarchicalData: $includeHierarchicalData
      historicalDataEntries: $historicalDataEntries
      displayType: $displayType
      areaMode: $areaMode
    ) {
      ...DomainTrackVariables
    }
    COMMUNITY_LIVABILITY: trackDomain(
      domain: COMMUNITY_LIVABILITY
      includeHierarchicalData: $includeHierarchicalData
      historicalDataEntries: $historicalDataEntries
      displayType: $displayType
      areaMode: $areaMode
    ) {
      ...DomainTrackVariables
    }
    NATURAL_ENVIRONMENT: trackDomain(
      domain: NATURAL_ENVIRONMENT
      includeHierarchicalData: $includeHierarchicalData
      historicalDataEntries: $historicalDataEntries
      displayType: $displayType
      areaMode: $areaMode
    ) {
      ...DomainTrackVariables
    }
    PARKS_AND_RECREATION: trackDomain(
      domain: PARKS_AND_RECREATION
      includeHierarchicalData: $includeHierarchicalData
      historicalDataEntries: $historicalDataEntries
      displayType: $displayType
      areaMode: $areaMode
    ) {
      ...DomainTrackVariables
    }
    FINANCE: trackDomain(
      domain: FINANCE
      includeHierarchicalData: false
      historicalDataEntries: $historicalDataEntries
      displayType: $displayType
      areaMode: $areaMode
    ) {
      ...DomainTrackVariables
    }
  }
}
    ${DomainTrackVariables}`;

/**
 * __useAdminPublishingEntityPerformanceData__
 *
 * To run a query within a React component, call `useAdminPublishingEntityPerformanceData` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingEntityPerformanceData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingEntityPerformanceData({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      includeHierarchicalData: // value for 'includeHierarchicalData'
 *      historicalDataEntries: // value for 'historicalDataEntries'
 *      displayType: // value for 'displayType'
 *      areaMode: // value for 'areaMode'
 *      comparisonGroupId: // value for 'comparisonGroupId'
 *      fipsCodes: // value for 'fipsCodes'
 *   },
 * });
 */
export function useAdminPublishingEntityPerformanceData(baseOptions: Apollo.QueryHookOptions<AdminPublishingEntityPerformanceData, AdminPublishingEntityPerformanceDataVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingEntityPerformanceData, AdminPublishingEntityPerformanceDataVariables>(AdminPublishingEntityPerformanceDataDocument, options);
      }
export function useAdminPublishingEntityPerformanceDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingEntityPerformanceData, AdminPublishingEntityPerformanceDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingEntityPerformanceData, AdminPublishingEntityPerformanceDataVariables>(AdminPublishingEntityPerformanceDataDocument, options);
        }
export type AdminPublishingEntityPerformanceDataHookResult = ReturnType<typeof useAdminPublishingEntityPerformanceData>;
export type AdminPublishingEntityPerformanceDataLazyQueryHookResult = ReturnType<typeof useAdminPublishingEntityPerformanceDataLazyQuery>;
export type AdminPublishingEntityPerformanceDataQueryResult = Apollo.QueryResult<AdminPublishingEntityPerformanceData, AdminPublishingEntityPerformanceDataVariables>;
export const AdminPublishingEntityPerformanceDataByDomainDocument = gql`
    query AdminPublishingEntityPerformanceDataByDomain($publishingEntityId: ID!, $domain: AnalyticsDomain!, $includeHierarchicalData: Boolean, $historicalDataEntries: Int, $displayType: VariableDisplayType, $areaMode: TrackAreaMode!, $comparisonGroupId: ID, $fipsCodes: [String!]) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    trackDomain(
      domain: $domain
      includeHierarchicalData: $includeHierarchicalData
      historicalDataEntries: $historicalDataEntries
      displayType: $displayType
      areaMode: $areaMode
    ) {
      ...DomainTrackVariables
    }
  }
}
    ${DomainTrackVariables}`;

/**
 * __useAdminPublishingEntityPerformanceDataByDomain__
 *
 * To run a query within a React component, call `useAdminPublishingEntityPerformanceDataByDomain` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingEntityPerformanceDataByDomain` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingEntityPerformanceDataByDomain({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      domain: // value for 'domain'
 *      includeHierarchicalData: // value for 'includeHierarchicalData'
 *      historicalDataEntries: // value for 'historicalDataEntries'
 *      displayType: // value for 'displayType'
 *      areaMode: // value for 'areaMode'
 *      comparisonGroupId: // value for 'comparisonGroupId'
 *      fipsCodes: // value for 'fipsCodes'
 *   },
 * });
 */
export function useAdminPublishingEntityPerformanceDataByDomain(baseOptions: Apollo.QueryHookOptions<AdminPublishingEntityPerformanceDataByDomain, AdminPublishingEntityPerformanceDataByDomainVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingEntityPerformanceDataByDomain, AdminPublishingEntityPerformanceDataByDomainVariables>(AdminPublishingEntityPerformanceDataByDomainDocument, options);
      }
export function useAdminPublishingEntityPerformanceDataByDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingEntityPerformanceDataByDomain, AdminPublishingEntityPerformanceDataByDomainVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingEntityPerformanceDataByDomain, AdminPublishingEntityPerformanceDataByDomainVariables>(AdminPublishingEntityPerformanceDataByDomainDocument, options);
        }
export type AdminPublishingEntityPerformanceDataByDomainHookResult = ReturnType<typeof useAdminPublishingEntityPerformanceDataByDomain>;
export type AdminPublishingEntityPerformanceDataByDomainLazyQueryHookResult = ReturnType<typeof useAdminPublishingEntityPerformanceDataByDomainLazyQuery>;
export type AdminPublishingEntityPerformanceDataByDomainQueryResult = Apollo.QueryResult<AdminPublishingEntityPerformanceDataByDomain, AdminPublishingEntityPerformanceDataByDomainVariables>;
export const AdminPublishingEntityQualityImportanceMatrixDocument = gql`
    query AdminPublishingEntityQualityImportanceMatrix($publishingEntityId: ID!) {
  openQualityImportanceMatrix(publishingEntityId: $publishingEntityId) {
    points {
      importance {
        sources {
          questionSetId
          source
          sourceLabel
          sourceType
        }
        value
      }
      quality {
        sources {
          questionSetId
          source
          sourceLabel
          sourceType
        }
        value
      }
      topic
    }
    publishingEntityId
    date {
      raw
    }
  }
}
    `;

/**
 * __useAdminPublishingEntityQualityImportanceMatrix__
 *
 * To run a query within a React component, call `useAdminPublishingEntityQualityImportanceMatrix` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingEntityQualityImportanceMatrix` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingEntityQualityImportanceMatrix({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useAdminPublishingEntityQualityImportanceMatrix(baseOptions: Apollo.QueryHookOptions<AdminPublishingEntityQualityImportanceMatrix, AdminPublishingEntityQualityImportanceMatrixVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingEntityQualityImportanceMatrix, AdminPublishingEntityQualityImportanceMatrixVariables>(AdminPublishingEntityQualityImportanceMatrixDocument, options);
      }
export function useAdminPublishingEntityQualityImportanceMatrixLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingEntityQualityImportanceMatrix, AdminPublishingEntityQualityImportanceMatrixVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingEntityQualityImportanceMatrix, AdminPublishingEntityQualityImportanceMatrixVariables>(AdminPublishingEntityQualityImportanceMatrixDocument, options);
        }
export type AdminPublishingEntityQualityImportanceMatrixHookResult = ReturnType<typeof useAdminPublishingEntityQualityImportanceMatrix>;
export type AdminPublishingEntityQualityImportanceMatrixLazyQueryHookResult = ReturnType<typeof useAdminPublishingEntityQualityImportanceMatrixLazyQuery>;
export type AdminPublishingEntityQualityImportanceMatrixQueryResult = Apollo.QueryResult<AdminPublishingEntityQualityImportanceMatrix, AdminPublishingEntityQualityImportanceMatrixVariables>;
export const AdminPublishingEntityRolesDocument = gql`
    query AdminPublishingEntityRoles($publishingEntityId: ID!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    adminRoles {
      id
      name
      description
      permissions {
        name
        displayName
        category {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useAdminPublishingEntityRoles__
 *
 * To run a query within a React component, call `useAdminPublishingEntityRoles` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingEntityRoles` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingEntityRoles({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useAdminPublishingEntityRoles(baseOptions: Apollo.QueryHookOptions<AdminPublishingEntityRoles, AdminPublishingEntityRolesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingEntityRoles, AdminPublishingEntityRolesVariables>(AdminPublishingEntityRolesDocument, options);
      }
export function useAdminPublishingEntityRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingEntityRoles, AdminPublishingEntityRolesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingEntityRoles, AdminPublishingEntityRolesVariables>(AdminPublishingEntityRolesDocument, options);
        }
export type AdminPublishingEntityRolesHookResult = ReturnType<typeof useAdminPublishingEntityRoles>;
export type AdminPublishingEntityRolesLazyQueryHookResult = ReturnType<typeof useAdminPublishingEntityRolesLazyQuery>;
export type AdminPublishingEntityRolesQueryResult = Apollo.QueryResult<AdminPublishingEntityRoles, AdminPublishingEntityRolesVariables>;
export const AdminPublishingEntitySettingsDocument = gql`
    query AdminPublishingEntitySettings($publishingEntityId: ID!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    managingAdmins {
      id
      admin {
        __typename
        ... on AdminBase {
          id
          name
          user {
            id
          }
          isEnvisioUser
        }
        ... on PrivateAdmin {
          id
          name
          email
          user {
            id
          }
        }
      }
      roleId
    }
    featureSettings {
      id
      featureSettingId
      featureSettingName
      enabled
      expirationDate {
        raw
      }
      quantity
      isUnlimited
    }
    occupiedSeats
    totalSeats: featureSettingQuantity(featureSettingName: "ADMIN_SEATS")
  }
}
    `;

/**
 * __useAdminPublishingEntitySettings__
 *
 * To run a query within a React component, call `useAdminPublishingEntitySettings` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingEntitySettings` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingEntitySettings({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useAdminPublishingEntitySettings(baseOptions: Apollo.QueryHookOptions<AdminPublishingEntitySettings, AdminPublishingEntitySettingsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingEntitySettings, AdminPublishingEntitySettingsVariables>(AdminPublishingEntitySettingsDocument, options);
      }
export function useAdminPublishingEntitySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingEntitySettings, AdminPublishingEntitySettingsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingEntitySettings, AdminPublishingEntitySettingsVariables>(AdminPublishingEntitySettingsDocument, options);
        }
export type AdminPublishingEntitySettingsHookResult = ReturnType<typeof useAdminPublishingEntitySettings>;
export type AdminPublishingEntitySettingsLazyQueryHookResult = ReturnType<typeof useAdminPublishingEntitySettingsLazyQuery>;
export type AdminPublishingEntitySettingsQueryResult = Apollo.QueryResult<AdminPublishingEntitySettings, AdminPublishingEntitySettingsVariables>;
export const AdminPublishingEntitySimulationWithResultsDocument = gql`
    query AdminPublishingEntitySimulationWithResults($publishingEntityId: ID!, $balancingActSimulationId: Int!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    simulations(simulationId: $balancingActSimulationId) {
      id
      name
      isPrioritization
      type
      url
      status
      results {
        averageSecondsOnSite
        averageSubmittedExpenses
        averageSubmittedRevenue
        budgetName
        clientName
        metric {
          age {
            label
            amount
            rank
            percentage
          }
          city {
            label
            amount
            rank
            percentage
          }
          deviceType {
            label
            amount
            rank
            percentage
          }
          gender {
            label
            amount
            rank
            percentage
          }
          userType {
            label
            amount
            rank
            percentage
          }
        }
        resetAllClicks
        status
        submissionCount
        taxpayerReceiptExperiences
        totalPageviews
        locale
        referrerPaths {
          source
          sessions
          rank
          percentage
        }
        sources {
          source
          sessions
          rank
          percentage
        }
        socialNetworks {
          source
          sessions
          rank
          percentage
        }
        categories {
          ...BalancingActReportingCategory
          openClicks
          total
          type
          subcategories {
            ...BalancingActReportingCategory
            amount
            averageSubmittedRate
            comments {
              text
              timestamp
            }
            customQuestionText
            customizedQuestionJson
            questionOptions {
              displayOrder
              title
              deltaAmount
              netAmount
              submittedCount
              submittedPercentage
              clickedCount
              clickedPercentage
            }
          }
        }
      }
    }
  }
}
    ${BalancingActReportingCategory}`;

/**
 * __useAdminPublishingEntitySimulationWithResults__
 *
 * To run a query within a React component, call `useAdminPublishingEntitySimulationWithResults` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingEntitySimulationWithResults` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingEntitySimulationWithResults({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      balancingActSimulationId: // value for 'balancingActSimulationId'
 *   },
 * });
 */
export function useAdminPublishingEntitySimulationWithResults(baseOptions: Apollo.QueryHookOptions<AdminPublishingEntitySimulationWithResults, AdminPublishingEntitySimulationWithResultsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingEntitySimulationWithResults, AdminPublishingEntitySimulationWithResultsVariables>(AdminPublishingEntitySimulationWithResultsDocument, options);
      }
export function useAdminPublishingEntitySimulationWithResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingEntitySimulationWithResults, AdminPublishingEntitySimulationWithResultsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingEntitySimulationWithResults, AdminPublishingEntitySimulationWithResultsVariables>(AdminPublishingEntitySimulationWithResultsDocument, options);
        }
export type AdminPublishingEntitySimulationWithResultsHookResult = ReturnType<typeof useAdminPublishingEntitySimulationWithResults>;
export type AdminPublishingEntitySimulationWithResultsLazyQueryHookResult = ReturnType<typeof useAdminPublishingEntitySimulationWithResultsLazyQuery>;
export type AdminPublishingEntitySimulationWithResultsQueryResult = Apollo.QueryResult<AdminPublishingEntitySimulationWithResults, AdminPublishingEntitySimulationWithResultsVariables>;
export const AdminPublishingEntitySimulationsDocument = gql`
    query AdminPublishingEntitySimulations($publishingEntityId: ID!, $balancingActSimulationId: Int) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    simulations(simulationId: $balancingActSimulationId) {
      id
      name
      isPrioritization
      type
      url
      status
      description
      createDate {
        raw
      }
    }
  }
}
    `;

/**
 * __useAdminPublishingEntitySimulations__
 *
 * To run a query within a React component, call `useAdminPublishingEntitySimulations` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingEntitySimulations` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingEntitySimulations({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      balancingActSimulationId: // value for 'balancingActSimulationId'
 *   },
 * });
 */
export function useAdminPublishingEntitySimulations(baseOptions: Apollo.QueryHookOptions<AdminPublishingEntitySimulations, AdminPublishingEntitySimulationsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingEntitySimulations, AdminPublishingEntitySimulationsVariables>(AdminPublishingEntitySimulationsDocument, options);
      }
export function useAdminPublishingEntitySimulationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingEntitySimulations, AdminPublishingEntitySimulationsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingEntitySimulations, AdminPublishingEntitySimulationsVariables>(AdminPublishingEntitySimulationsDocument, options);
        }
export type AdminPublishingEntitySimulationsHookResult = ReturnType<typeof useAdminPublishingEntitySimulations>;
export type AdminPublishingEntitySimulationsLazyQueryHookResult = ReturnType<typeof useAdminPublishingEntitySimulationsLazyQuery>;
export type AdminPublishingEntitySimulationsQueryResult = Apollo.QueryResult<AdminPublishingEntitySimulations, AdminPublishingEntitySimulationsVariables>;
export const AdminPublishingEntitySimulationsWithCategoriesDocument = gql`
    query AdminPublishingEntitySimulationsWithCategories($publishingEntityId: ID!, $balancingActSimulationId: Int) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    simulations(simulationId: $balancingActSimulationId) {
      id
      name
      type
      url
      description
      categories {
        id
        name
        type
        subcategories {
          id
          name
          amount
          details
          isLocked
        }
      }
    }
  }
}
    `;

/**
 * __useAdminPublishingEntitySimulationsWithCategories__
 *
 * To run a query within a React component, call `useAdminPublishingEntitySimulationsWithCategories` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingEntitySimulationsWithCategories` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingEntitySimulationsWithCategories({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      balancingActSimulationId: // value for 'balancingActSimulationId'
 *   },
 * });
 */
export function useAdminPublishingEntitySimulationsWithCategories(baseOptions: Apollo.QueryHookOptions<AdminPublishingEntitySimulationsWithCategories, AdminPublishingEntitySimulationsWithCategoriesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingEntitySimulationsWithCategories, AdminPublishingEntitySimulationsWithCategoriesVariables>(AdminPublishingEntitySimulationsWithCategoriesDocument, options);
      }
export function useAdminPublishingEntitySimulationsWithCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingEntitySimulationsWithCategories, AdminPublishingEntitySimulationsWithCategoriesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingEntitySimulationsWithCategories, AdminPublishingEntitySimulationsWithCategoriesVariables>(AdminPublishingEntitySimulationsWithCategoriesDocument, options);
        }
export type AdminPublishingEntitySimulationsWithCategoriesHookResult = ReturnType<typeof useAdminPublishingEntitySimulationsWithCategories>;
export type AdminPublishingEntitySimulationsWithCategoriesLazyQueryHookResult = ReturnType<typeof useAdminPublishingEntitySimulationsWithCategoriesLazyQuery>;
export type AdminPublishingEntitySimulationsWithCategoriesQueryResult = Apollo.QueryResult<AdminPublishingEntitySimulationsWithCategories, AdminPublishingEntitySimulationsWithCategoriesVariables>;
export const AdminPublishingEntityStrategicPlansDocument = gql`
    query AdminPublishingEntityStrategicPlans($publishingEntityId: ID!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    strategicPlans {
      ...StrategicPlan
    }
  }
}
    ${StrategicPlan}`;

/**
 * __useAdminPublishingEntityStrategicPlans__
 *
 * To run a query within a React component, call `useAdminPublishingEntityStrategicPlans` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingEntityStrategicPlans` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingEntityStrategicPlans({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useAdminPublishingEntityStrategicPlans(baseOptions: Apollo.QueryHookOptions<AdminPublishingEntityStrategicPlans, AdminPublishingEntityStrategicPlansVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingEntityStrategicPlans, AdminPublishingEntityStrategicPlansVariables>(AdminPublishingEntityStrategicPlansDocument, options);
      }
export function useAdminPublishingEntityStrategicPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingEntityStrategicPlans, AdminPublishingEntityStrategicPlansVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingEntityStrategicPlans, AdminPublishingEntityStrategicPlansVariables>(AdminPublishingEntityStrategicPlansDocument, options);
        }
export type AdminPublishingEntityStrategicPlansHookResult = ReturnType<typeof useAdminPublishingEntityStrategicPlans>;
export type AdminPublishingEntityStrategicPlansLazyQueryHookResult = ReturnType<typeof useAdminPublishingEntityStrategicPlansLazyQuery>;
export type AdminPublishingEntityStrategicPlansQueryResult = Apollo.QueryResult<AdminPublishingEntityStrategicPlans, AdminPublishingEntityStrategicPlansVariables>;
export const AdminPublishingEntityVisualizationsDocument = gql`
    query AdminPublishingEntityVisualizations($publishingEntityId: ID!, $areaMode: TrackAreaMode, $comparisonGroupId: ID, $notShowingVisualizations: Boolean!, $fipsCodes: [String!]) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    trackVariableVisualizations {
      ...TrackVisualization
      visualizationAreas @skip(if: $notShowingVisualizations) {
        id
        shape {
          type
          coordinates
        }
      }
      boundingBox {
        id
        xMin
        xMax
        yMin
        yMax
      }
    }
    featureSettings(names: ["SAVED_DATA_POINTS"]) {
      id
      isUnlimited
      activeCount
      featureSettingName
      featureSettingId
      enabled
      quantity
      expirationDate {
        raw
      }
    }
    strategicPlans {
      ...StrategicPlan
    }
  }
}
    ${TrackVisualization}
${StrategicPlan}`;

/**
 * __useAdminPublishingEntityVisualizations__
 *
 * To run a query within a React component, call `useAdminPublishingEntityVisualizations` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingEntityVisualizations` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingEntityVisualizations({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      areaMode: // value for 'areaMode'
 *      comparisonGroupId: // value for 'comparisonGroupId'
 *      notShowingVisualizations: // value for 'notShowingVisualizations'
 *      fipsCodes: // value for 'fipsCodes'
 *   },
 * });
 */
export function useAdminPublishingEntityVisualizations(baseOptions: Apollo.QueryHookOptions<AdminPublishingEntityVisualizations, AdminPublishingEntityVisualizationsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingEntityVisualizations, AdminPublishingEntityVisualizationsVariables>(AdminPublishingEntityVisualizationsDocument, options);
      }
export function useAdminPublishingEntityVisualizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingEntityVisualizations, AdminPublishingEntityVisualizationsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingEntityVisualizations, AdminPublishingEntityVisualizationsVariables>(AdminPublishingEntityVisualizationsDocument, options);
        }
export type AdminPublishingEntityVisualizationsHookResult = ReturnType<typeof useAdminPublishingEntityVisualizations>;
export type AdminPublishingEntityVisualizationsLazyQueryHookResult = ReturnType<typeof useAdminPublishingEntityVisualizationsLazyQuery>;
export type AdminPublishingEntityVisualizationsQueryResult = Apollo.QueryResult<AdminPublishingEntityVisualizations, AdminPublishingEntityVisualizationsVariables>;
export const AdminPublishingWizardScheduleDocument = gql`
    query AdminPublishingWizardSchedule($questionSetId: ID!) {
  currentUser {
    id
    user {
      id
      admin {
        __typename
        ... on PrivateAdmin {
          id
          activePublishingEntity {
            id
            name {
              ...multilang
            }
            slug
            shortUrl {
              id
              shortUrl
            }
            description {
              ...multilang
            }
            socialConnections {
              id
              provider
            }
            assets {
              id
              type
              url
            }
            activationState
          }
        }
      }
    }
  }
  openContentSetById(setId: $questionSetId) {
    __typename
    ... on ContentSetBase {
      id
      name {
        ...multilang
      }
      hasBenchmarkedContent
      polcoManaged
      publishingEntity {
        id
        name {
          ...multilang
        }
        activationState
        assets {
          id
          type
          url
        }
      }
    }
    ... on QuestionSet {
      cartQuestions: createdQuestions(status: [CART]) {
        questions {
          id
          title {
            ...multilang
          }
          description {
            ...multilang
          }
          optional
          isBenchmarkedQuestion
          choiceSet {
            id
            type
            maxSelection
            choices {
              id
              text {
                ...multilang
              }
            }
            sharedChoiceSetData {
              id
            }
          }
          schedule {
            status
            openDate {
              raw
            }
            closeDate {
              raw
            }
          }
        }
      }
    }
    ... on PolcoLive {
      cartQuestions: createdQuestions(status: [CART]) {
        questions {
          id
          title {
            ...multilang
          }
          description {
            ...multilang
          }
          optional
          isBenchmarkedQuestion
          choiceSet {
            id
            type
            maxSelection
            choices {
              id
              text {
                ...multilang
              }
            }
            sharedChoiceSetData {
              id
            }
          }
          schedule {
            status
            openDate {
              raw
            }
            closeDate {
              raw
            }
          }
        }
      }
    }
    ... on Survey {
      schedule {
        status
        openDate {
          raw
        }
        closeDate {
          raw
        }
      }
      questionsCount
    }
    ... on GenericContent {
      schedule {
        status
        openDate {
          raw
        }
        closeDate {
          raw
        }
      }
      questionsCount
    }
  }
}
    ${Multilang}`;

/**
 * __useAdminPublishingWizardSchedule__
 *
 * To run a query within a React component, call `useAdminPublishingWizardSchedule` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingWizardSchedule` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingWizardSchedule({
 *   variables: {
 *      questionSetId: // value for 'questionSetId'
 *   },
 * });
 */
export function useAdminPublishingWizardSchedule(baseOptions: Apollo.QueryHookOptions<AdminPublishingWizardSchedule, AdminPublishingWizardScheduleVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingWizardSchedule, AdminPublishingWizardScheduleVariables>(AdminPublishingWizardScheduleDocument, options);
      }
export function useAdminPublishingWizardScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingWizardSchedule, AdminPublishingWizardScheduleVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingWizardSchedule, AdminPublishingWizardScheduleVariables>(AdminPublishingWizardScheduleDocument, options);
        }
export type AdminPublishingWizardScheduleHookResult = ReturnType<typeof useAdminPublishingWizardSchedule>;
export type AdminPublishingWizardScheduleLazyQueryHookResult = ReturnType<typeof useAdminPublishingWizardScheduleLazyQuery>;
export type AdminPublishingWizardScheduleQueryResult = Apollo.QueryResult<AdminPublishingWizardSchedule, AdminPublishingWizardScheduleVariables>;
export const AdminPublishingWizardShareDocument = gql`
    query AdminPublishingWizardShare($questionSetId: ID!) {
  currentUser {
    id
    user {
      id
      admin {
        __typename
        ... on PrivateAdmin {
          id
          activePublishingEntity {
            id
            name {
              ...multilang
            }
            slug
            shortUrl {
              id
              shortUrl
            }
            description {
              ...multilang
            }
            socialConnections {
              id
              provider
              profileNames
            }
            assets {
              id
              type
              url
            }
            activationState
            featureSettings {
              id
              featureSettingId
              featureSettingName
              enabled
              quantity
              isUnlimited
              expirationDate {
                raw
              }
            }
          }
          requestedFeatures
        }
      }
    }
  }
  openContentSetById(setId: $questionSetId) {
    __typename
    ... on ContentSetBase {
      id
      name {
        ...multilang
      }
      slug
      publishingEntity {
        id
        name {
          ...multilang
        }
        activationState
        assets {
          id
          type
          url
        }
      }
    }
    ... on QuestionSet {
      cartQuestions: createdQuestions(status: [CART]) {
        questions {
          id
          schedule {
            openDate {
              raw
            }
            closeDate {
              raw
            }
          }
        }
      }
    }
    ... on PolcoLive {
      shortId
      cartQuestions: createdQuestions(status: [CART]) {
        questions {
          id
          schedule {
            openDate {
              raw
            }
            closeDate {
              raw
            }
          }
        }
      }
    }
    ... on Survey {
      questionsCount
      shortId
      schedule {
        status
        openDate {
          raw
        }
        closeDate {
          raw
        }
      }
    }
    ... on GenericContent {
      questionsCount
      shortId
      schedule {
        status
        openDate {
          raw
        }
        closeDate {
          raw
        }
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useAdminPublishingWizardShare__
 *
 * To run a query within a React component, call `useAdminPublishingWizardShare` and pass it any options that fit your needs.
 * When your component renders, `useAdminPublishingWizardShare` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPublishingWizardShare({
 *   variables: {
 *      questionSetId: // value for 'questionSetId'
 *   },
 * });
 */
export function useAdminPublishingWizardShare(baseOptions: Apollo.QueryHookOptions<AdminPublishingWizardShare, AdminPublishingWizardShareVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPublishingWizardShare, AdminPublishingWizardShareVariables>(AdminPublishingWizardShareDocument, options);
      }
export function useAdminPublishingWizardShareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPublishingWizardShare, AdminPublishingWizardShareVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPublishingWizardShare, AdminPublishingWizardShareVariables>(AdminPublishingWizardShareDocument, options);
        }
export type AdminPublishingWizardShareHookResult = ReturnType<typeof useAdminPublishingWizardShare>;
export type AdminPublishingWizardShareLazyQueryHookResult = ReturnType<typeof useAdminPublishingWizardShareLazyQuery>;
export type AdminPublishingWizardShareQueryResult = Apollo.QueryResult<AdminPublishingWizardShare, AdminPublishingWizardShareVariables>;
export const AdminQuestionResultsAdvancedDocument = gql`
    query AdminQuestionResultsAdvanced($questionId: ID!, $publishingEntityId: ID!, $source: RespondentAttributeValueSource!) {
  openQuestion(questionId: $questionId) {
    id
    title {
      ...multilang
    }
    description {
      ...multilang
    }
    totalVotesCount
    commentsWordCount {
      text
      value
    }
    choiceSet {
      id
      type
      maxSelection
      scaleData {
        scaleType
      }
    }
    questionSet {
      __typename
      ... on ContentSetBase {
        id
        name {
          ...multilang
        }
        publishingEntity {
          id
          name {
            ...multilang
          }
          activationState
        }
      }
    }
    stats {
      id
      overview(scopedPublishingEntityId: $publishingEntityId) {
        label
        stats {
          totalResponses
          byChoice {
            choiceId
            label
            percent
            value
          }
        }
      }
      breakdowns(scopedPublishingEntityId: $publishingEntityId, source: $source) {
        key
        hits
        buckets {
          key
          hits
          buckets {
            key
            hits
          }
        }
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useAdminQuestionResultsAdvanced__
 *
 * To run a query within a React component, call `useAdminQuestionResultsAdvanced` and pass it any options that fit your needs.
 * When your component renders, `useAdminQuestionResultsAdvanced` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminQuestionResultsAdvanced({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      publishingEntityId: // value for 'publishingEntityId'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useAdminQuestionResultsAdvanced(baseOptions: Apollo.QueryHookOptions<AdminQuestionResultsAdvanced, AdminQuestionResultsAdvancedVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminQuestionResultsAdvanced, AdminQuestionResultsAdvancedVariables>(AdminQuestionResultsAdvancedDocument, options);
      }
export function useAdminQuestionResultsAdvancedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminQuestionResultsAdvanced, AdminQuestionResultsAdvancedVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminQuestionResultsAdvanced, AdminQuestionResultsAdvancedVariables>(AdminQuestionResultsAdvancedDocument, options);
        }
export type AdminQuestionResultsAdvancedHookResult = ReturnType<typeof useAdminQuestionResultsAdvanced>;
export type AdminQuestionResultsAdvancedLazyQueryHookResult = ReturnType<typeof useAdminQuestionResultsAdvancedLazyQuery>;
export type AdminQuestionResultsAdvancedQueryResult = Apollo.QueryResult<AdminQuestionResultsAdvanced, AdminQuestionResultsAdvancedVariables>;
export const AdminQuestionResultsAdvancedMapDocument = gql`
    query AdminQuestionResultsAdvancedMap($questionId: ID!, $publishingEntityId: ID!, $source: RespondentAttributeValueSource!, $geoViewId: ID!) {
  openQuestion(questionId: $questionId) {
    id
    stats {
      id
      map(
        geoViewId: $geoViewId
        scopedPublishingEntityId: $publishingEntityId
        source: $source
      ) {
        questionMapStats {
          hits
          buckets {
            key
            hits
            buckets {
              key
              hits
            }
            shape {
              type
              coordinates
            }
          }
          center {
            coordinate {
              lat
              lng
            }
            size
          }
        }
        mapStatsStatus
      }
    }
  }
}
    `;

/**
 * __useAdminQuestionResultsAdvancedMap__
 *
 * To run a query within a React component, call `useAdminQuestionResultsAdvancedMap` and pass it any options that fit your needs.
 * When your component renders, `useAdminQuestionResultsAdvancedMap` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminQuestionResultsAdvancedMap({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      publishingEntityId: // value for 'publishingEntityId'
 *      source: // value for 'source'
 *      geoViewId: // value for 'geoViewId'
 *   },
 * });
 */
export function useAdminQuestionResultsAdvancedMap(baseOptions: Apollo.QueryHookOptions<AdminQuestionResultsAdvancedMap, AdminQuestionResultsAdvancedMapVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminQuestionResultsAdvancedMap, AdminQuestionResultsAdvancedMapVariables>(AdminQuestionResultsAdvancedMapDocument, options);
      }
export function useAdminQuestionResultsAdvancedMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminQuestionResultsAdvancedMap, AdminQuestionResultsAdvancedMapVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminQuestionResultsAdvancedMap, AdminQuestionResultsAdvancedMapVariables>(AdminQuestionResultsAdvancedMapDocument, options);
        }
export type AdminQuestionResultsAdvancedMapHookResult = ReturnType<typeof useAdminQuestionResultsAdvancedMap>;
export type AdminQuestionResultsAdvancedMapLazyQueryHookResult = ReturnType<typeof useAdminQuestionResultsAdvancedMapLazyQuery>;
export type AdminQuestionResultsAdvancedMapQueryResult = Apollo.QueryResult<AdminQuestionResultsAdvancedMap, AdminQuestionResultsAdvancedMapVariables>;
export const AdminQuestionResultsHeaderDocument = gql`
    query AdminQuestionResultsHeader($questionId: ID!, $filter: ResultFilter) {
  openQuestion(questionId: $questionId) {
    id
    title {
      ...multilang
    }
    description {
      ...multilang
    }
    commentsWordCount {
      text
      value
    }
    totalVotesCount
    shortId
    questionSet {
      __typename
      ... on ContentSetBase {
        id
        name {
          ...multilang
        }
        slug
        allowGuestRespondents
        publishingEntity {
          id
          name {
            ...multilang
          }
          slug
          activationState
          socialConnections {
            id
            provider
            profileNames
          }
        }
      }
    }
    choiceSet {
      id
      type
      maxSelection
      choices {
        id
        text {
          ...multilang
        }
      }
      sharedChoiceSetData {
        id
      }
      scaleData {
        scaleType
      }
    }
    schedule {
      status
      openDate {
        raw
      }
      closeDate {
        raw
      }
    }
    results(filter: $filter) {
      ...QuestionResults_Fragment
    }
  }
}
    ${Multilang}
${QuestionResults_Fragment}`;

/**
 * __useAdminQuestionResultsHeader__
 *
 * To run a query within a React component, call `useAdminQuestionResultsHeader` and pass it any options that fit your needs.
 * When your component renders, `useAdminQuestionResultsHeader` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminQuestionResultsHeader({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAdminQuestionResultsHeader(baseOptions: Apollo.QueryHookOptions<AdminQuestionResultsHeader, AdminQuestionResultsHeaderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminQuestionResultsHeader, AdminQuestionResultsHeaderVariables>(AdminQuestionResultsHeaderDocument, options);
      }
export function useAdminQuestionResultsHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminQuestionResultsHeader, AdminQuestionResultsHeaderVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminQuestionResultsHeader, AdminQuestionResultsHeaderVariables>(AdminQuestionResultsHeaderDocument, options);
        }
export type AdminQuestionResultsHeaderHookResult = ReturnType<typeof useAdminQuestionResultsHeader>;
export type AdminQuestionResultsHeaderLazyQueryHookResult = ReturnType<typeof useAdminQuestionResultsHeaderLazyQuery>;
export type AdminQuestionResultsHeaderQueryResult = Apollo.QueryResult<AdminQuestionResultsHeader, AdminQuestionResultsHeaderVariables>;
export const AdminQuestionStatsDocument = gql`
    query AdminQuestionStats($questionId: ID!, $publishingEntityId: ID!, $geoViewId: ID!) {
  openQuestion(questionId: $questionId) {
    id
    totalVotesCount
    responsesOverTime(scopeByPublishingEntityId: $publishingEntityId) {
      interval
      data {
        value
        time
      }
    }
    ageBreakdownThirdParty: responseStat(
      input: {type: AGE, scopeByPublishingEntityId: $publishingEntityId, AGE: {source: THIRD_PARTY}}
    ) {
      __typename
      ...breakdown
    }
    ageBreakdownUserReported: responseStat(
      input: {type: AGE, scopeByPublishingEntityId: $publishingEntityId, AGE: {source: USER_REPORTED}}
    ) {
      __typename
      ...breakdown
    }
    genderBreakdownThirdParty: responseStat(
      input: {type: GENDER, scopeByPublishingEntityId: $publishingEntityId, GENDER: {source: THIRD_PARTY}}
    ) {
      __typename
      ...breakdown
    }
    genderBreakdownUserReported: responseStat(
      input: {type: GENDER, scopeByPublishingEntityId: $publishingEntityId, GENDER: {source: USER_REPORTED}}
    ) {
      __typename
      ...breakdown
    }
    sampleBreakdown: responseStat(
      input: {type: SAMPLE, scopeByPublishingEntityId: $publishingEntityId}
    ) {
      __typename
      ...breakdown
    }
    languageBreakdown: responseStat(
      input: {type: LANGUAGE, scopeByPublishingEntityId: $publishingEntityId}
    ) {
      __typename
      ...breakdown
    }
    raceBreakdown: responseStat(
      input: {type: RACE, scopeByPublishingEntityId: $publishingEntityId}
    ) {
      __typename
      ...breakdown
    }
    verifiedResponses: responseStat(
      input: {type: VERIFIED_RESPONSES, scopeByPublishingEntityId: $publishingEntityId}
    ) {
      __typename
      ... on StatValueDelta {
        changeLabel
        currentValue
        label
        recentChange
      }
    }
    locationBreakdown: responseStat(
      input: {type: LOCATION, scopeByPublishingEntityId: $publishingEntityId, LOCATION: {geoViewId: $geoViewId}}
    ) {
      __typename
      ...StatBreakdownLocation
    }
  }
}
    ${Breakdown}
${StatBreakdownLocation}`;

/**
 * __useAdminQuestionStats__
 *
 * To run a query within a React component, call `useAdminQuestionStats` and pass it any options that fit your needs.
 * When your component renders, `useAdminQuestionStats` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminQuestionStats({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      publishingEntityId: // value for 'publishingEntityId'
 *      geoViewId: // value for 'geoViewId'
 *   },
 * });
 */
export function useAdminQuestionStats(baseOptions: Apollo.QueryHookOptions<AdminQuestionStats, AdminQuestionStatsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminQuestionStats, AdminQuestionStatsVariables>(AdminQuestionStatsDocument, options);
      }
export function useAdminQuestionStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminQuestionStats, AdminQuestionStatsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminQuestionStats, AdminQuestionStatsVariables>(AdminQuestionStatsDocument, options);
        }
export type AdminQuestionStatsHookResult = ReturnType<typeof useAdminQuestionStats>;
export type AdminQuestionStatsLazyQueryHookResult = ReturnType<typeof useAdminQuestionStatsLazyQuery>;
export type AdminQuestionStatsQueryResult = Apollo.QueryResult<AdminQuestionStats, AdminQuestionStatsVariables>;
export const AdminReadyToShareQuestionsDocument = gql`
    query AdminReadyToShareQuestions($setId: ID!, $forPublisherId: ID!, $shareType: ShareableContentType!, $areaMode: TrackAreaMode, $comparisonGroupId: ID, $fipsCodes: [String!]) {
  adminShareableContentSet(
    setId: $setId
    forPublisherId: $forPublisherId
    shareType: $shareType
  ) {
    id
    isPaidContent
    domains
    contentSet {
      __typename
      ... on QuestionSet {
        id
        description {
          ...multilang
        }
        questionsCount
        name {
          ...multilang
        }
        publishingEntity {
          id
          name {
            ...multilang
          }
        }
        setImageId
        createdQuestions(status: [PUBLISHED]) {
          questions {
            id
            title {
              ...multilang
            }
            description {
              ...multilang
            }
            optional
            choiceSet {
              id
              type
              maxSelection
              choices {
                id
                text {
                  ...multilang
                }
                choiceValue
              }
              sharedChoiceSetData {
                id
              }
            }
            schedule {
              status
            }
          }
        }
      }
      ... on PolcoLive {
        id
        description {
          ...multilang
        }
        questionsCount
        name {
          ...multilang
        }
        publishingEntity {
          id
          name {
            ...multilang
          }
        }
        setImageId
        createdQuestions(status: [PUBLISHED]) {
          questions {
            id
            title {
              ...multilang
            }
            description {
              ...multilang
            }
            optional
            choiceSet {
              id
              type
              maxSelection
              choices {
                id
                text {
                  ...multilang
                }
                choiceValue
              }
              sharedChoiceSetData {
                id
              }
            }
            schedule {
              status
            }
          }
        }
      }
      ... on Survey {
        id
        description {
          ...multilang
        }
        questionsCount
        name {
          ...multilang
        }
        setImageId
        publishingEntity {
          id
          name {
            ...multilang
          }
        }
        contents {
          __typename
          ... on Question {
            id
            optional
            questionNumber
            title {
              ...multilang
            }
            summary
            description {
              ...multilang
            }
            reportDisplayLabel
            variableName
            choiceSet {
              id
              type
              maxSelection
              scaleData {
                scaleType
                scaleThreshold
              }
              choices {
                id
                text {
                  ...multilang
                }
                choiceValue
              }
              sharedChoiceSetData {
                id
              }
            }
            schedule {
              status
            }
            questionSet {
              ... on ContentSetBase {
                __typename
                id
              }
            }
            demographicAttribute {
              id
              name
              premium
              owner {
                id
              }
            }
            conditions {
              metaConditions {
                id
                childMetaConditionIds
                combinationOperator
                displayName
              }
              questionChoiceConditions {
                id
                metaConditionId
                questionId
                questionChoiceId
              }
            }
          }
          ... on QuestionHierarchyParentNode {
            id
            structureType: type
            label {
              ...multilang
            }
            structureDescription: description {
              ...multilang
            }
            survey {
              id
            }
            questionNumber
            conditions {
              metaConditions {
                id
                childMetaConditionIds
                combinationOperator
                displayName
              }
              questionChoiceConditions {
                id
                metaConditionId
                questionId
                questionChoiceId
              }
            }
            questions {
              __typename
              id
              title {
                ...multilang
              }
              description {
                ...multilang
              }
              optional
              choiceSet {
                id
                type
                maxSelection
                choices {
                  id
                  text {
                    ...multilang
                  }
                  choiceValue
                }
                sharedChoiceSetData {
                  id
                }
              }
            }
            numColumns
            ...RowContentHierarchyNodes
          }
          ... on QuestionHierarchyVisualizationNode {
            ...VisualizationNode
          }
          ... on QuestionHierarchySimulationNode {
            ...AdminSimulationNode
          }
        }
      }
      ... on GenericContent {
        id
        description {
          ...multilang
        }
        questionsCount
        name {
          ...multilang
        }
        setImageId
        publishingEntity {
          id
          name {
            ...multilang
          }
        }
        contents {
          __typename
          ... on Question {
            id
            optional
            questionNumber
            title {
              ...multilang
            }
            summary
            description {
              ...multilang
            }
            reportDisplayLabel
            variableName
            choiceSet {
              id
              type
              maxSelection
              scaleData {
                scaleType
                scaleThreshold
              }
              choices {
                id
                text {
                  ...multilang
                }
                choiceValue
              }
              sharedChoiceSetData {
                id
              }
            }
            schedule {
              status
            }
            questionSet {
              ... on ContentSetBase {
                __typename
                id
              }
            }
            demographicAttribute {
              id
              name
              premium
              owner {
                id
              }
            }
            conditions {
              metaConditions {
                id
                childMetaConditionIds
                combinationOperator
                displayName
              }
              questionChoiceConditions {
                id
                metaConditionId
                questionId
                questionChoiceId
              }
            }
          }
          ... on QuestionHierarchyParentNode {
            id
            structureType: type
            label {
              ...multilang
            }
            structureDescription: description {
              ...multilang
            }
            survey {
              id
            }
            questionNumber
            conditions {
              metaConditions {
                id
                childMetaConditionIds
                combinationOperator
                displayName
              }
              questionChoiceConditions {
                id
                metaConditionId
                questionId
                questionChoiceId
              }
            }
            questions {
              __typename
              id
              title {
                ...multilang
              }
              description {
                ...multilang
              }
              optional
              choiceSet {
                id
                type
                maxSelection
                choices {
                  id
                  text {
                    ...multilang
                  }
                  choiceValue
                }
                sharedChoiceSetData {
                  id
                }
              }
            }
            numColumns
            ...RowContentHierarchyNodes
          }
          ... on QuestionHierarchyVisualizationNode {
            ...VisualizationNode
          }
          ... on QuestionHierarchySimulationNode {
            ...AdminSimulationNode
          }
        }
      }
    }
  }
}
    ${Multilang}
${RowContentHierarchyNodes}
${VisualizationNode}
${AdminSimulationNode}`;

/**
 * __useAdminReadyToShareQuestions__
 *
 * To run a query within a React component, call `useAdminReadyToShareQuestions` and pass it any options that fit your needs.
 * When your component renders, `useAdminReadyToShareQuestions` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminReadyToShareQuestions({
 *   variables: {
 *      setId: // value for 'setId'
 *      forPublisherId: // value for 'forPublisherId'
 *      shareType: // value for 'shareType'
 *      areaMode: // value for 'areaMode'
 *      comparisonGroupId: // value for 'comparisonGroupId'
 *      fipsCodes: // value for 'fipsCodes'
 *   },
 * });
 */
export function useAdminReadyToShareQuestions(baseOptions: Apollo.QueryHookOptions<AdminReadyToShareQuestions, AdminReadyToShareQuestionsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminReadyToShareQuestions, AdminReadyToShareQuestionsVariables>(AdminReadyToShareQuestionsDocument, options);
      }
export function useAdminReadyToShareQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminReadyToShareQuestions, AdminReadyToShareQuestionsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminReadyToShareQuestions, AdminReadyToShareQuestionsVariables>(AdminReadyToShareQuestionsDocument, options);
        }
export type AdminReadyToShareQuestionsHookResult = ReturnType<typeof useAdminReadyToShareQuestions>;
export type AdminReadyToShareQuestionsLazyQueryHookResult = ReturnType<typeof useAdminReadyToShareQuestionsLazyQuery>;
export type AdminReadyToShareQuestionsQueryResult = Apollo.QueryResult<AdminReadyToShareQuestions, AdminReadyToShareQuestionsVariables>;
export const AdminRegistrationRolesDocument = gql`
    query AdminRegistrationRoles($filter: AdminRoleFilter!) {
  adminRegistrationRoles(filter: $filter) {
    id
    displayName
    archived
  }
}
    `;

/**
 * __useAdminRegistrationRoles__
 *
 * To run a query within a React component, call `useAdminRegistrationRoles` and pass it any options that fit your needs.
 * When your component renders, `useAdminRegistrationRoles` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRegistrationRoles({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAdminRegistrationRoles(baseOptions: Apollo.QueryHookOptions<AdminRegistrationRoles, AdminRegistrationRolesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminRegistrationRoles, AdminRegistrationRolesVariables>(AdminRegistrationRolesDocument, options);
      }
export function useAdminRegistrationRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminRegistrationRoles, AdminRegistrationRolesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminRegistrationRoles, AdminRegistrationRolesVariables>(AdminRegistrationRolesDocument, options);
        }
export type AdminRegistrationRolesHookResult = ReturnType<typeof useAdminRegistrationRoles>;
export type AdminRegistrationRolesLazyQueryHookResult = ReturnType<typeof useAdminRegistrationRolesLazyQuery>;
export type AdminRegistrationRolesQueryResult = Apollo.QueryResult<AdminRegistrationRoles, AdminRegistrationRolesVariables>;
export const AdminStoreDocument = gql`
    query AdminStore($publishingEntityId: ID!, $storeType: StoreItemsType!) {
  adminOrderedStoreItems(
    type: $storeType
    publishingEntityId: $publishingEntityId
  ) {
    id
    purchasedInStripe
    status
    expiresAt {
      raw
    }
    storeItem {
      id
      name
      provider
      shortDescription
      longDescription
      freeTrialLengthMs
      purchaseLengthMs
      repurchaseDelayMs
      key
      thumbnailUrl
      mainImageUrl
      category
      oneTime
      stripeId
      linkedFeatureSettingId
      isHiddenInUI
      plans {
        id
        active
        amount
        trialPeriodDays
        billingScheme
        interval
        intervalCount
        nickname
        product
        usageType
      }
      childStoreItems {
        id
        key
        name
        shortDescription
        category
        order
        isHiddenInUI
      }
    }
  }
}
    `;

/**
 * __useAdminStore__
 *
 * To run a query within a React component, call `useAdminStore` and pass it any options that fit your needs.
 * When your component renders, `useAdminStore` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminStore({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      storeType: // value for 'storeType'
 *   },
 * });
 */
export function useAdminStore(baseOptions: Apollo.QueryHookOptions<AdminStore, AdminStoreVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminStore, AdminStoreVariables>(AdminStoreDocument, options);
      }
export function useAdminStoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminStore, AdminStoreVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminStore, AdminStoreVariables>(AdminStoreDocument, options);
        }
export type AdminStoreHookResult = ReturnType<typeof useAdminStore>;
export type AdminStoreLazyQueryHookResult = ReturnType<typeof useAdminStoreLazyQuery>;
export type AdminStoreQueryResult = Apollo.QueryResult<AdminStore, AdminStoreVariables>;
export const AdminStoreItemDocument = gql`
    query AdminStoreItem($publishingEntityId: ID!, $idOrKey: String!) {
  adminStoreItemByIdOrKey(
    publishingEntityId: $publishingEntityId
    idOrKey: $idOrKey
  ) {
    id
    purchasedInStripe
    status
    expiresAt {
      raw
    }
    storeItem {
      id
      name
      provider
      shortDescription
      longDescription
      freeTrialLengthMs
      purchaseLengthMs
      repurchaseDelayMs
      key
      thumbnailUrl
      mainImageUrl
      category
      oneTime
      stripeId
      linkedFeatureSettingId
      isHiddenInUI
      plans {
        id
        active
        amount
        trialPeriodDays
        billingScheme
        interval
        intervalCount
        nickname
        product
        usageType
      }
      childStoreItems {
        id
        key
        name
        shortDescription
        category
        order
        isHiddenInUI
      }
    }
  }
}
    `;

/**
 * __useAdminStoreItem__
 *
 * To run a query within a React component, call `useAdminStoreItem` and pass it any options that fit your needs.
 * When your component renders, `useAdminStoreItem` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminStoreItem({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *      idOrKey: // value for 'idOrKey'
 *   },
 * });
 */
export function useAdminStoreItem(baseOptions: Apollo.QueryHookOptions<AdminStoreItem, AdminStoreItemVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminStoreItem, AdminStoreItemVariables>(AdminStoreItemDocument, options);
      }
export function useAdminStoreItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminStoreItem, AdminStoreItemVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminStoreItem, AdminStoreItemVariables>(AdminStoreItemDocument, options);
        }
export type AdminStoreItemHookResult = ReturnType<typeof useAdminStoreItem>;
export type AdminStoreItemLazyQueryHookResult = ReturnType<typeof useAdminStoreItemLazyQuery>;
export type AdminStoreItemQueryResult = Apollo.QueryResult<AdminStoreItem, AdminStoreItemVariables>;
export const CurrentActiveFlagsDocument = gql`
    query CurrentActiveFlags($userId: ID, $publishingEntityId: ID) {
  flags(userId: $userId, publishingEntityId: $publishingEntityId) {
    flags {
      __typename
      ... on BooleanFlag {
        flagKey
        enabled
      }
      ... on VariantFlag {
        match
        flagKey
      }
      ... on ErrorFlag {
        flagKey
      }
    }
  }
}
    `;

/**
 * __useCurrentActiveFlags__
 *
 * To run a query within a React component, call `useCurrentActiveFlags` and pass it any options that fit your needs.
 * When your component renders, `useCurrentActiveFlags` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentActiveFlags({
 *   variables: {
 *      userId: // value for 'userId'
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useCurrentActiveFlags(baseOptions?: Apollo.QueryHookOptions<CurrentActiveFlags, CurrentActiveFlagsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentActiveFlags, CurrentActiveFlagsVariables>(CurrentActiveFlagsDocument, options);
      }
export function useCurrentActiveFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentActiveFlags, CurrentActiveFlagsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentActiveFlags, CurrentActiveFlagsVariables>(CurrentActiveFlagsDocument, options);
        }
export type CurrentActiveFlagsHookResult = ReturnType<typeof useCurrentActiveFlags>;
export type CurrentActiveFlagsLazyQueryHookResult = ReturnType<typeof useCurrentActiveFlagsLazyQuery>;
export type CurrentActiveFlagsQueryResult = Apollo.QueryResult<CurrentActiveFlags, CurrentActiveFlagsVariables>;
export const CurrentAdminDocument = gql`
    query CurrentAdmin {
  currentUser {
    id
    user {
      id
      admin {
        __typename
        ... on PrivateAdmin {
          id
          createDate {
            raw
          }
          name
          email
          permissions
          superAdmin
          emailVerificationStatus
          isEnvisioUser
          registrationRequests {
            id
            createdTime {
              raw
            }
            decision
            publishingEntity {
              id
            }
          }
          registrationRole {
            id
            displayName
            persona {
              id
              name
            }
          }
          activePublishingEntity {
            id
            description {
              ...multilang
            }
            postedBy {
              ...multilang
            }
            activationState
            showExampleQuestions
            slug
            name {
              ...multilang
            }
            assets {
              id
              url
              type
            }
            fipsArea {
              id
              type
              populationSizeSegment
            }
            featureSettings {
              id
              featureSettingId
              featureSettingName
              enabled
              quantity
              isUnlimited
              expirationDate {
                raw
              }
            }
            defaultGeoView {
              id
              name
            }
            availableGeoViews {
              id
              name
            }
            presidingArea {
              id
              name
              center {
                size
                coordinate {
                  lat
                  lng
                }
              }
            }
            systemType
            activeLiveEvents {
              id
              slug
            }
            approvalDecision
            balancingActCustomer {
              id
              name
            }
            organizationType {
              id
              displayName
            }
            organizationSubtype {
              id
              displayName
            }
            isEnterprise
            storeTiers: storeItems(type: TIER) {
              id
              purchasedInStripe
              status
              expiresAt {
                raw
              }
              storeItem {
                id
                name
                provider
                shortDescription
                longDescription
                freeTrialLengthMs
                purchaseLengthMs
                repurchaseDelayMs
                key
                thumbnailUrl
                mainImageUrl
                category
                oneTime
                stripeId
                linkedFeatureSettingId
                isHiddenInUI
                plans {
                  id
                  active
                  amount
                  trialPeriodDays
                  billingScheme
                  interval
                  intervalCount
                  nickname
                  product
                  usageType
                }
                childStoreItems {
                  id
                  key
                  name
                  shortDescription
                  category
                  order
                  isHiddenInUI
                }
              }
            }
          }
          demoPollyUrl
          menuItems {
            id
            text
            url
            icon
            materialIcon
            isNew
            isShown
            childrenMenuItems {
              id
              text
              url
              icon
              materialIcon
              isNew
              isShown
            }
          }
        }
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useCurrentAdmin__
 *
 * To run a query within a React component, call `useCurrentAdmin` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAdmin` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAdmin({
 *   variables: {
 *   },
 * });
 */
export function useCurrentAdmin(baseOptions?: Apollo.QueryHookOptions<CurrentAdmin, CurrentAdminVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentAdmin, CurrentAdminVariables>(CurrentAdminDocument, options);
      }
export function useCurrentAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAdmin, CurrentAdminVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentAdmin, CurrentAdminVariables>(CurrentAdminDocument, options);
        }
export type CurrentAdminHookResult = ReturnType<typeof useCurrentAdmin>;
export type CurrentAdminLazyQueryHookResult = ReturnType<typeof useCurrentAdminLazyQuery>;
export type CurrentAdminQueryResult = Apollo.QueryResult<CurrentAdmin, CurrentAdminVariables>;
export const CurrentAdminAiSessionsDocument = gql`
    query CurrentAdminAiSessions {
  currentUser {
    id
    user {
      id
      admin {
        __typename
        ... on PrivateAdmin {
          id
          aiAssistantSessions {
            id
            name
            startAt {
              raw
            }
            lastInteractedAt {
              raw
            }
            assistantName
            polcoAssistantId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCurrentAdminAiSessions__
 *
 * To run a query within a React component, call `useCurrentAdminAiSessions` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAdminAiSessions` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAdminAiSessions({
 *   variables: {
 *   },
 * });
 */
export function useCurrentAdminAiSessions(baseOptions?: Apollo.QueryHookOptions<CurrentAdminAiSessions, CurrentAdminAiSessionsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentAdminAiSessions, CurrentAdminAiSessionsVariables>(CurrentAdminAiSessionsDocument, options);
      }
export function useCurrentAdminAiSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAdminAiSessions, CurrentAdminAiSessionsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentAdminAiSessions, CurrentAdminAiSessionsVariables>(CurrentAdminAiSessionsDocument, options);
        }
export type CurrentAdminAiSessionsHookResult = ReturnType<typeof useCurrentAdminAiSessions>;
export type CurrentAdminAiSessionsLazyQueryHookResult = ReturnType<typeof useCurrentAdminAiSessionsLazyQuery>;
export type CurrentAdminAiSessionsQueryResult = Apollo.QueryResult<CurrentAdminAiSessions, CurrentAdminAiSessionsVariables>;
export const CurrentAdminManagedPublishingEntitiesDocument = gql`
    query CurrentAdminManagedPublishingEntities($filter: String) {
  currentUser {
    id
    user {
      id
      admin {
        __typename
        ... on PrivateAdmin {
          id
          managedPublishingEntities(filter: $filter) {
            id
            name {
              ...multilang
            }
            presidingArea {
              id
              name
            }
          }
        }
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useCurrentAdminManagedPublishingEntities__
 *
 * To run a query within a React component, call `useCurrentAdminManagedPublishingEntities` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAdminManagedPublishingEntities` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAdminManagedPublishingEntities({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCurrentAdminManagedPublishingEntities(baseOptions?: Apollo.QueryHookOptions<CurrentAdminManagedPublishingEntities, CurrentAdminManagedPublishingEntitiesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentAdminManagedPublishingEntities, CurrentAdminManagedPublishingEntitiesVariables>(CurrentAdminManagedPublishingEntitiesDocument, options);
      }
export function useCurrentAdminManagedPublishingEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAdminManagedPublishingEntities, CurrentAdminManagedPublishingEntitiesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentAdminManagedPublishingEntities, CurrentAdminManagedPublishingEntitiesVariables>(CurrentAdminManagedPublishingEntitiesDocument, options);
        }
export type CurrentAdminManagedPublishingEntitiesHookResult = ReturnType<typeof useCurrentAdminManagedPublishingEntities>;
export type CurrentAdminManagedPublishingEntitiesLazyQueryHookResult = ReturnType<typeof useCurrentAdminManagedPublishingEntitiesLazyQuery>;
export type CurrentAdminManagedPublishingEntitiesQueryResult = Apollo.QueryResult<CurrentAdminManagedPublishingEntities, CurrentAdminManagedPublishingEntitiesVariables>;
export const CurrentAdminRegistrationInfoDocument = gql`
    query CurrentAdminRegistrationInfo {
  registrationInformation {
    reasons {
      id
      reason
    }
    outcomes {
      id
      outcome
    }
    interests {
      id
      interest
      url
    }
  }
  currentUser {
    id
    user {
      id
      admin {
        __typename
        ... on PrivateAdmin {
          id
          name
          emailVerificationStatus
          registrationRequests {
            id
            createdTime {
              raw
            }
            decision
            registrationReason {
              id
            }
            desiredOutcome {
              id
            }
            interests {
              id
            }
            metadata {
              key
              value
            }
            publishingEntity {
              id
              description {
                ...multilang
              }
              postedBy {
                ...multilang
              }
              activationState
              showExampleQuestions
              slug
              name {
                ...multilang
              }
              assets {
                id
                url
                type
              }
              featureSettings {
                id
                featureSettingId
                featureSettingName
                enabled
                quantity
                isUnlimited
                expirationDate {
                  raw
                }
              }
              defaultGeoView {
                id
                name
              }
              availableGeoViews {
                id
                name
              }
              presidingArea {
                id
                name
                center {
                  size
                  coordinate {
                    lat
                    lng
                  }
                }
              }
              systemType
              activeLiveEvents {
                id
                slug
              }
              approvalDecision
              organizationType {
                id
                displayName
              }
              organizationSubtype {
                id
                displayName
              }
              organizationArea {
                id
                displayName
              }
            }
          }
        }
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useCurrentAdminRegistrationInfo__
 *
 * To run a query within a React component, call `useCurrentAdminRegistrationInfo` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAdminRegistrationInfo` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAdminRegistrationInfo({
 *   variables: {
 *   },
 * });
 */
export function useCurrentAdminRegistrationInfo(baseOptions?: Apollo.QueryHookOptions<CurrentAdminRegistrationInfo, CurrentAdminRegistrationInfoVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentAdminRegistrationInfo, CurrentAdminRegistrationInfoVariables>(CurrentAdminRegistrationInfoDocument, options);
      }
export function useCurrentAdminRegistrationInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAdminRegistrationInfo, CurrentAdminRegistrationInfoVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentAdminRegistrationInfo, CurrentAdminRegistrationInfoVariables>(CurrentAdminRegistrationInfoDocument, options);
        }
export type CurrentAdminRegistrationInfoHookResult = ReturnType<typeof useCurrentAdminRegistrationInfo>;
export type CurrentAdminRegistrationInfoLazyQueryHookResult = ReturnType<typeof useCurrentAdminRegistrationInfoLazyQuery>;
export type CurrentAdminRegistrationInfoQueryResult = Apollo.QueryResult<CurrentAdminRegistrationInfo, CurrentAdminRegistrationInfoVariables>;
export const CurrentAdminRequestedFeaturesDocument = gql`
    query CurrentAdminRequestedFeatures {
  currentUser {
    id
    user {
      id
      admin {
        __typename
        ... on PrivateAdmin {
          id
          requestedFeatures
          email
          phoneNumber
          phoneExt
          commsEmail
        }
      }
    }
  }
}
    `;

/**
 * __useCurrentAdminRequestedFeatures__
 *
 * To run a query within a React component, call `useCurrentAdminRequestedFeatures` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAdminRequestedFeatures` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAdminRequestedFeatures({
 *   variables: {
 *   },
 * });
 */
export function useCurrentAdminRequestedFeatures(baseOptions?: Apollo.QueryHookOptions<CurrentAdminRequestedFeatures, CurrentAdminRequestedFeaturesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentAdminRequestedFeatures, CurrentAdminRequestedFeaturesVariables>(CurrentAdminRequestedFeaturesDocument, options);
      }
export function useCurrentAdminRequestedFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAdminRequestedFeatures, CurrentAdminRequestedFeaturesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentAdminRequestedFeatures, CurrentAdminRequestedFeaturesVariables>(CurrentAdminRequestedFeaturesDocument, options);
        }
export type CurrentAdminRequestedFeaturesHookResult = ReturnType<typeof useCurrentAdminRequestedFeatures>;
export type CurrentAdminRequestedFeaturesLazyQueryHookResult = ReturnType<typeof useCurrentAdminRequestedFeaturesLazyQuery>;
export type CurrentAdminRequestedFeaturesQueryResult = Apollo.QueryResult<CurrentAdminRequestedFeatures, CurrentAdminRequestedFeaturesVariables>;
export const CurrentRespondentDocument = gql`
    query CurrentRespondent {
  currentUser {
    id
    user {
      id
      respondent {
        __typename
        ... on PrivateRespondent {
          id
          firstName
          lastName
          email
          avatarUrl
          guest
          zipCode
          inputtedLat
          inputtedLon
          requestLocationLastShown {
            raw
          }
          verified
          invitedPlaceholderAccount
          requiresVerificationPrompt
          postAnonymously
          subscriptions {
            id
            slug
          }
        }
      }
      admin {
        __typename
        ... on AdminBase {
          id
          isEnvisioUser
        }
      }
    }
    location {
      id
      ip
      zipCode
      coordinate {
        lat
        lng
      }
    }
  }
}
    `;

/**
 * __useCurrentRespondent__
 *
 * To run a query within a React component, call `useCurrentRespondent` and pass it any options that fit your needs.
 * When your component renders, `useCurrentRespondent` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentRespondent({
 *   variables: {
 *   },
 * });
 */
export function useCurrentRespondent(baseOptions?: Apollo.QueryHookOptions<CurrentRespondent, CurrentRespondentVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentRespondent, CurrentRespondentVariables>(CurrentRespondentDocument, options);
      }
export function useCurrentRespondentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentRespondent, CurrentRespondentVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentRespondent, CurrentRespondentVariables>(CurrentRespondentDocument, options);
        }
export type CurrentRespondentHookResult = ReturnType<typeof useCurrentRespondent>;
export type CurrentRespondentLazyQueryHookResult = ReturnType<typeof useCurrentRespondentLazyQuery>;
export type CurrentRespondentQueryResult = Apollo.QueryResult<CurrentRespondent, CurrentRespondentVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    id
    user {
      id
      respondent {
        __typename
        ... on RespondentBase {
          id
        }
        ... on PrivateRespondent {
          id
          email
        }
        ... on PublicRespondent {
          id
        }
      }
      admin {
        __typename
        ... on PrivateAdmin {
          id
          email
          managedPublishingEntities {
            id
          }
          activePublishingEntity {
            id
            name {
              ...multilang
            }
          }
          demoPollyUrl
        }
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useCurrentUser__
 *
 * To run a query within a React component, call `useCurrentUser` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUser` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUser({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUser(baseOptions?: Apollo.QueryHookOptions<CurrentUser, CurrentUserVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUser, CurrentUserVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUser, CurrentUserVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUser, CurrentUserVariables>(CurrentUserDocument, options);
        }
export type CurrentUserHookResult = ReturnType<typeof useCurrentUser>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUser, CurrentUserVariables>;
export const CurrentUserNearbyLocationsDocument = gql`
    query CurrentUserNearbyLocations($zipCode: String) {
  currentUser {
    id
    nearbyLocations(zipCode: $zipCode) {
      zipCode
      locations {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCurrentUserNearbyLocations__
 *
 * To run a query within a React component, call `useCurrentUserNearbyLocations` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserNearbyLocations` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserNearbyLocations({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useCurrentUserNearbyLocations(baseOptions?: Apollo.QueryHookOptions<CurrentUserNearbyLocations, CurrentUserNearbyLocationsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserNearbyLocations, CurrentUserNearbyLocationsVariables>(CurrentUserNearbyLocationsDocument, options);
      }
export function useCurrentUserNearbyLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserNearbyLocations, CurrentUserNearbyLocationsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserNearbyLocations, CurrentUserNearbyLocationsVariables>(CurrentUserNearbyLocationsDocument, options);
        }
export type CurrentUserNearbyLocationsHookResult = ReturnType<typeof useCurrentUserNearbyLocations>;
export type CurrentUserNearbyLocationsLazyQueryHookResult = ReturnType<typeof useCurrentUserNearbyLocationsLazyQuery>;
export type CurrentUserNearbyLocationsQueryResult = Apollo.QueryResult<CurrentUserNearbyLocations, CurrentUserNearbyLocationsVariables>;
export const OpenAiAssistantDocument = gql`
    query OpenAiAssistant($assistant: AssistantIdInput!) {
  openAiAssistant(assistant: $assistant) {
    id
    name
    publishingEntity {
      id
      fipsArea {
        id
      }
    }
  }
}
    `;

/**
 * __useOpenAiAssistant__
 *
 * To run a query within a React component, call `useOpenAiAssistant` and pass it any options that fit your needs.
 * When your component renders, `useOpenAiAssistant` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenAiAssistant({
 *   variables: {
 *      assistant: // value for 'assistant'
 *   },
 * });
 */
export function useOpenAiAssistant(baseOptions: Apollo.QueryHookOptions<OpenAiAssistant, OpenAiAssistantVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpenAiAssistant, OpenAiAssistantVariables>(OpenAiAssistantDocument, options);
      }
export function useOpenAiAssistantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpenAiAssistant, OpenAiAssistantVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpenAiAssistant, OpenAiAssistantVariables>(OpenAiAssistantDocument, options);
        }
export type OpenAiAssistantHookResult = ReturnType<typeof useOpenAiAssistant>;
export type OpenAiAssistantLazyQueryHookResult = ReturnType<typeof useOpenAiAssistantLazyQuery>;
export type OpenAiAssistantQueryResult = Apollo.QueryResult<OpenAiAssistant, OpenAiAssistantVariables>;
export const OpenIdeaDocument = gql`
    query OpenIdea($ideaId: ID!, $respondentId: ID) {
  openIdea(ideaId: $ideaId) {
    id
    respondent {
      ... on RespondentBase {
        id
        publicName
      }
    }
    publishingEntity {
      id
      name {
        ...multilang
      }
      slug
    }
    title
    description
    createDate {
      raw
    }
    aggregations {
      voteUp
      voteDown
    }
    respondentVote(respondentId: $respondentId)
  }
}
    ${Multilang}`;

/**
 * __useOpenIdea__
 *
 * To run a query within a React component, call `useOpenIdea` and pass it any options that fit your needs.
 * When your component renders, `useOpenIdea` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenIdea({
 *   variables: {
 *      ideaId: // value for 'ideaId'
 *      respondentId: // value for 'respondentId'
 *   },
 * });
 */
export function useOpenIdea(baseOptions: Apollo.QueryHookOptions<OpenIdea, OpenIdeaVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpenIdea, OpenIdeaVariables>(OpenIdeaDocument, options);
      }
export function useOpenIdeaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpenIdea, OpenIdeaVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpenIdea, OpenIdeaVariables>(OpenIdeaDocument, options);
        }
export type OpenIdeaHookResult = ReturnType<typeof useOpenIdea>;
export type OpenIdeaLazyQueryHookResult = ReturnType<typeof useOpenIdeaLazyQuery>;
export type OpenIdeaQueryResult = Apollo.QueryResult<OpenIdea, OpenIdeaVariables>;
export const OpenTrackVariablesDocument = gql`
    query OpenTrackVariables($fipsCodes: [String!]!, $variableNames: [String!]!, $statisticType: StatisticType!, $comparisonGroupId: ID, $areaMode: TrackAreaMode!, $publishingEntityId: ID) {
  openTrackVariables(
    fipsCodes: $fipsCodes
    variableNames: $variableNames
    statisticType: $statisticType
    comparisonGroupId: $comparisonGroupId
    publishingEntityId: $publishingEntityId
  ) {
    ... on TrackVariable {
      ...TrackVariable
    }
    ... on TrackVariableWithDistributions {
      ...TrackVariableWithDistributions
    }
  }
}
    ${TrackVariable}
${TrackVariableWithDistributions}`;

/**
 * __useOpenTrackVariables__
 *
 * To run a query within a React component, call `useOpenTrackVariables` and pass it any options that fit your needs.
 * When your component renders, `useOpenTrackVariables` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenTrackVariables({
 *   variables: {
 *      fipsCodes: // value for 'fipsCodes'
 *      variableNames: // value for 'variableNames'
 *      statisticType: // value for 'statisticType'
 *      comparisonGroupId: // value for 'comparisonGroupId'
 *      areaMode: // value for 'areaMode'
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useOpenTrackVariables(baseOptions: Apollo.QueryHookOptions<OpenTrackVariables, OpenTrackVariablesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpenTrackVariables, OpenTrackVariablesVariables>(OpenTrackVariablesDocument, options);
      }
export function useOpenTrackVariablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpenTrackVariables, OpenTrackVariablesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpenTrackVariables, OpenTrackVariablesVariables>(OpenTrackVariablesDocument, options);
        }
export type OpenTrackVariablesHookResult = ReturnType<typeof useOpenTrackVariables>;
export type OpenTrackVariablesLazyQueryHookResult = ReturnType<typeof useOpenTrackVariablesLazyQuery>;
export type OpenTrackVariablesQueryResult = Apollo.QueryResult<OpenTrackVariables, OpenTrackVariablesVariables>;
export const PublishingEntityByIdDocument = gql`
    query PublishingEntityById($publishingEntityId: ID!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    name {
      ...multilang
    }
    description {
      ...multilang
    }
    slug
    postedBy {
      ...multilang
    }
    assets {
      id
      type
      url
    }
    activationState
    mailingsData {
      id
      title
      fullName
      contactPhoneNumber
      adminIndicatedComplete
      returnMailingAddress
      samplingZipCodes
      useExistingInfo
    }
    featureSettings {
      id
      featureSettingId
      featureSettingName
      enabled
      quantity
      isUnlimited
      expirationDate {
        raw
      }
    }
  }
}
    ${Multilang}`;

/**
 * __usePublishingEntityById__
 *
 * To run a query within a React component, call `usePublishingEntityById` and pass it any options that fit your needs.
 * When your component renders, `usePublishingEntityById` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishingEntityById({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function usePublishingEntityById(baseOptions: Apollo.QueryHookOptions<PublishingEntityById, PublishingEntityByIdVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublishingEntityById, PublishingEntityByIdVariables>(PublishingEntityByIdDocument, options);
      }
export function usePublishingEntityByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublishingEntityById, PublishingEntityByIdVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublishingEntityById, PublishingEntityByIdVariables>(PublishingEntityByIdDocument, options);
        }
export type PublishingEntityByIdHookResult = ReturnType<typeof usePublishingEntityById>;
export type PublishingEntityByIdLazyQueryHookResult = ReturnType<typeof usePublishingEntityByIdLazyQuery>;
export type PublishingEntityByIdQueryResult = Apollo.QueryResult<PublishingEntityById, PublishingEntityByIdVariables>;
export const PublishingEntityCreationFormDocument = gql`
    query PublishingEntityCreationForm {
  publishingEntityOrganizations {
    id
    displayName
    nameEntryLabel
    subtypes {
      id
      displayName
    }
  }
  publishingEntityOrganizationAreas {
    id
    displayName
    areaLookupEntryLabel
    areaLookupType
    knownKey
  }
}
    `;

/**
 * __usePublishingEntityCreationForm__
 *
 * To run a query within a React component, call `usePublishingEntityCreationForm` and pass it any options that fit your needs.
 * When your component renders, `usePublishingEntityCreationForm` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishingEntityCreationForm({
 *   variables: {
 *   },
 * });
 */
export function usePublishingEntityCreationForm(baseOptions?: Apollo.QueryHookOptions<PublishingEntityCreationForm, PublishingEntityCreationFormVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublishingEntityCreationForm, PublishingEntityCreationFormVariables>(PublishingEntityCreationFormDocument, options);
      }
export function usePublishingEntityCreationFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublishingEntityCreationForm, PublishingEntityCreationFormVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublishingEntityCreationForm, PublishingEntityCreationFormVariables>(PublishingEntityCreationFormDocument, options);
        }
export type PublishingEntityCreationFormHookResult = ReturnType<typeof usePublishingEntityCreationForm>;
export type PublishingEntityCreationFormLazyQueryHookResult = ReturnType<typeof usePublishingEntityCreationFormLazyQuery>;
export type PublishingEntityCreationFormQueryResult = Apollo.QueryResult<PublishingEntityCreationForm, PublishingEntityCreationFormVariables>;
export const RespondentActiveSubscriptionsForIdeaDocument = gql`
    query RespondentActiveSubscriptionsForIdea($respondentId: ID!) {
  openRespondent(respondentId: $respondentId) {
    __typename
    ... on PrivateRespondent {
      id
      subscriptionsCanPublishIdeas {
        id
        subscriptionType(respondentId: $respondentId)
        name {
          ...multilang
        }
        slug
        assets {
          id
          type
          url
        }
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useRespondentActiveSubscriptionsForIdea__
 *
 * To run a query within a React component, call `useRespondentActiveSubscriptionsForIdea` and pass it any options that fit your needs.
 * When your component renders, `useRespondentActiveSubscriptionsForIdea` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRespondentActiveSubscriptionsForIdea({
 *   variables: {
 *      respondentId: // value for 'respondentId'
 *   },
 * });
 */
export function useRespondentActiveSubscriptionsForIdea(baseOptions: Apollo.QueryHookOptions<RespondentActiveSubscriptionsForIdea, RespondentActiveSubscriptionsForIdeaVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RespondentActiveSubscriptionsForIdea, RespondentActiveSubscriptionsForIdeaVariables>(RespondentActiveSubscriptionsForIdeaDocument, options);
      }
export function useRespondentActiveSubscriptionsForIdeaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RespondentActiveSubscriptionsForIdea, RespondentActiveSubscriptionsForIdeaVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RespondentActiveSubscriptionsForIdea, RespondentActiveSubscriptionsForIdeaVariables>(RespondentActiveSubscriptionsForIdeaDocument, options);
        }
export type RespondentActiveSubscriptionsForIdeaHookResult = ReturnType<typeof useRespondentActiveSubscriptionsForIdea>;
export type RespondentActiveSubscriptionsForIdeaLazyQueryHookResult = ReturnType<typeof useRespondentActiveSubscriptionsForIdeaLazyQuery>;
export type RespondentActiveSubscriptionsForIdeaQueryResult = Apollo.QueryResult<RespondentActiveSubscriptionsForIdea, RespondentActiveSubscriptionsForIdeaVariables>;
export const RespondentFeedDocument = gql`
    query RespondentFeed($respondentId: ID, $zipCode: String, $latLng: CoordinateInput, $before: GqlDateInput, $resultLimit: Int) {
  feed(
    respId: $respondentId
    zipCode: $zipCode
    latLng: $latLng
    before: $before
    resultLimit: $resultLimit
  ) {
    items {
      ...RespondentFeed_Item
    }
  }
}
    ${RespondentFeed_Item}`;

/**
 * __useRespondentFeed__
 *
 * To run a query within a React component, call `useRespondentFeed` and pass it any options that fit your needs.
 * When your component renders, `useRespondentFeed` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRespondentFeed({
 *   variables: {
 *      respondentId: // value for 'respondentId'
 *      zipCode: // value for 'zipCode'
 *      latLng: // value for 'latLng'
 *      before: // value for 'before'
 *      resultLimit: // value for 'resultLimit'
 *   },
 * });
 */
export function useRespondentFeed(baseOptions?: Apollo.QueryHookOptions<RespondentFeed, RespondentFeedVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RespondentFeed, RespondentFeedVariables>(RespondentFeedDocument, options);
      }
export function useRespondentFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RespondentFeed, RespondentFeedVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RespondentFeed, RespondentFeedVariables>(RespondentFeedDocument, options);
        }
export type RespondentFeedHookResult = ReturnType<typeof useRespondentFeed>;
export type RespondentFeedLazyQueryHookResult = ReturnType<typeof useRespondentFeedLazyQuery>;
export type RespondentFeedQueryResult = Apollo.QueryResult<RespondentFeed, RespondentFeedVariables>;
export const RespondentOutcomePageDocument = gql`
    query RespondentOutcomePage($publishingEntitySlug: String!, $questionSetSlug: String!) {
  openContentSetBySlug(
    publishingEntitySlug: $publishingEntitySlug
    questionSetSlug: $questionSetSlug
  ) {
    ... on ContentSetBase {
      id
      slug
      __typename
      shareable
      ... on Survey {
        id
        name {
          ...multilang
        }
        totalRespondents
        description {
          ...multilang
        }
        reportTabs(publiclyShared: true) {
          id
          title
          publiclyShared
          content {
            type
            HTML
            TABLEAU
            height
          }
        }
        schedule {
          status
        }
        outcome {
          id
          text
          state
        }
        publishingEntity {
          id
          slug
          name {
            ...multilang
          }
          assets {
            id
            type
            url
          }
        }
        image {
          id
          verticalUrl
          backgroundColor
        }
      }
      ... on GenericContent {
        id
        name {
          ...multilang
        }
        totalRespondents
        description {
          ...multilang
        }
        reportTabs(publiclyShared: true) {
          id
          title
          publiclyShared
          content {
            type
            HTML
            TABLEAU
            height
          }
        }
        schedule {
          status
        }
        outcome {
          id
          text
          state
        }
        publishingEntity {
          id
          slug
          name {
            ...multilang
          }
          assets {
            id
            type
            url
          }
        }
        image {
          id
          verticalUrl
          backgroundColor
        }
      }
      ... on QuestionSet {
        id
        name {
          ...multilang
        }
        schedule {
          status
        }
        totalRespondents
        description {
          ...multilang
        }
        outcome {
          id
          text
          state
        }
        publishingEntity {
          id
          slug
          name {
            ...multilang
          }
          assets {
            id
            type
            url
          }
        }
        image {
          id
          verticalUrl
          backgroundColor
        }
      }
      ... on PolcoLive {
        id
        name {
          ...multilang
        }
        totalRespondents
        description {
          ...multilang
        }
        schedule {
          status
        }
        outcome {
          id
          text
          state
        }
        publishingEntity {
          id
          name {
            ...multilang
          }
          slug
          assets {
            id
            type
            url
          }
        }
        image {
          id
          verticalUrl
          backgroundColor
        }
        settings {
          id
          eventStartDate {
            raw
          }
          liveVideoLink
        }
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useRespondentOutcomePage__
 *
 * To run a query within a React component, call `useRespondentOutcomePage` and pass it any options that fit your needs.
 * When your component renders, `useRespondentOutcomePage` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRespondentOutcomePage({
 *   variables: {
 *      publishingEntitySlug: // value for 'publishingEntitySlug'
 *      questionSetSlug: // value for 'questionSetSlug'
 *   },
 * });
 */
export function useRespondentOutcomePage(baseOptions: Apollo.QueryHookOptions<RespondentOutcomePage, RespondentOutcomePageVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RespondentOutcomePage, RespondentOutcomePageVariables>(RespondentOutcomePageDocument, options);
      }
export function useRespondentOutcomePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RespondentOutcomePage, RespondentOutcomePageVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RespondentOutcomePage, RespondentOutcomePageVariables>(RespondentOutcomePageDocument, options);
        }
export type RespondentOutcomePageHookResult = ReturnType<typeof useRespondentOutcomePage>;
export type RespondentOutcomePageLazyQueryHookResult = ReturnType<typeof useRespondentOutcomePageLazyQuery>;
export type RespondentOutcomePageQueryResult = Apollo.QueryResult<RespondentOutcomePage, RespondentOutcomePageVariables>;
export const RespondentOverviewPageDocument = gql`
    query RespondentOverviewPage($publishingEntitySlug: String!, $questionSetSlug: String!, $respondentId: ID) {
  openContentSetBySlug(
    publishingEntitySlug: $publishingEntitySlug
    questionSetSlug: $questionSetSlug
  ) {
    ... on ContentSetBase {
      id
      slug
      __typename
      shareable
      outcome {
        id
      }
      showConversionPrompts
      ... on QuestionSet {
        id
        setForRespondentVote(respondentId: $respondentId) {
          id
          questions {
            id
            title {
              ...multilang
            }
            previousVote(respondentId: $respondentId) {
              id
            }
          }
        }
        publishingEntity {
          id
          slug
          name {
            ...multilang
          }
          assets {
            id
            type
            url
          }
        }
      }
      ... on PolcoLive {
        id
        setForRespondentVote(respondentId: $respondentId) {
          id
          questions {
            id
            title {
              ...multilang
            }
            previousVote(respondentId: $respondentId) {
              id
            }
          }
        }
        publishingEntity {
          id
          name {
            ...multilang
          }
          slug
          assets {
            id
            type
            url
          }
        }
      }
      ... on Survey {
        id
        name {
          ...multilang
        }
        reportTabs(publiclyShared: true) {
          id
          title
          publiclyShared
          order
          content {
            type
            HTML
            TABLEAU
            height
          }
        }
        publishingEntity {
          id
          name {
            ...multilang
          }
          slug
          assets {
            id
            type
            url
          }
        }
      }
      ... on GenericContent {
        id
        name {
          ...multilang
        }
        reportTabs(publiclyShared: true) {
          id
          title
          publiclyShared
          order
          content {
            type
            HTML
            TABLEAU
            height
          }
        }
        publishingEntity {
          id
          name {
            ...multilang
          }
          slug
          assets {
            id
            type
            url
          }
        }
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useRespondentOverviewPage__
 *
 * To run a query within a React component, call `useRespondentOverviewPage` and pass it any options that fit your needs.
 * When your component renders, `useRespondentOverviewPage` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRespondentOverviewPage({
 *   variables: {
 *      publishingEntitySlug: // value for 'publishingEntitySlug'
 *      questionSetSlug: // value for 'questionSetSlug'
 *      respondentId: // value for 'respondentId'
 *   },
 * });
 */
export function useRespondentOverviewPage(baseOptions: Apollo.QueryHookOptions<RespondentOverviewPage, RespondentOverviewPageVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RespondentOverviewPage, RespondentOverviewPageVariables>(RespondentOverviewPageDocument, options);
      }
export function useRespondentOverviewPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RespondentOverviewPage, RespondentOverviewPageVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RespondentOverviewPage, RespondentOverviewPageVariables>(RespondentOverviewPageDocument, options);
        }
export type RespondentOverviewPageHookResult = ReturnType<typeof useRespondentOverviewPage>;
export type RespondentOverviewPageLazyQueryHookResult = ReturnType<typeof useRespondentOverviewPageLazyQuery>;
export type RespondentOverviewPageQueryResult = Apollo.QueryResult<RespondentOverviewPage, RespondentOverviewPageVariables>;
export const RespondentPolcoLiveBaseDocument = gql`
    query RespondentPolcoLiveBase($publishingEntitySlug: String!, $questionSetSlug: String!, $respondentId: ID) {
  openContentSetBySlug(
    publishingEntitySlug: $publishingEntitySlug
    questionSetSlug: $questionSetSlug
  ) {
    ... on ContentSetBase {
      id
      __typename
      ... on PolcoLive {
        id
        name {
          ...multilang
        }
        settings {
          id
          liveVideoLink
        }
        setForRespondentVote(respondentId: $respondentId) {
          id
          questions {
            id
            title {
              ...multilang
            }
            previousVote(respondentId: $respondentId) {
              id
            }
            schedule {
              status
              openDate {
                raw
              }
              closeDate {
                raw
              }
            }
          }
          status
        }
      }
    }
  }
  contextPublishingEntity: openPublishingEntityBySlug(slug: $publishingEntitySlug) {
    id
    slug
    assets {
      id
      type
      url
    }
    name {
      ...multilang
    }
  }
}
    ${Multilang}`;

/**
 * __useRespondentPolcoLiveBase__
 *
 * To run a query within a React component, call `useRespondentPolcoLiveBase` and pass it any options that fit your needs.
 * When your component renders, `useRespondentPolcoLiveBase` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRespondentPolcoLiveBase({
 *   variables: {
 *      publishingEntitySlug: // value for 'publishingEntitySlug'
 *      questionSetSlug: // value for 'questionSetSlug'
 *      respondentId: // value for 'respondentId'
 *   },
 * });
 */
export function useRespondentPolcoLiveBase(baseOptions: Apollo.QueryHookOptions<RespondentPolcoLiveBase, RespondentPolcoLiveBaseVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RespondentPolcoLiveBase, RespondentPolcoLiveBaseVariables>(RespondentPolcoLiveBaseDocument, options);
      }
export function useRespondentPolcoLiveBaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RespondentPolcoLiveBase, RespondentPolcoLiveBaseVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RespondentPolcoLiveBase, RespondentPolcoLiveBaseVariables>(RespondentPolcoLiveBaseDocument, options);
        }
export type RespondentPolcoLiveBaseHookResult = ReturnType<typeof useRespondentPolcoLiveBase>;
export type RespondentPolcoLiveBaseLazyQueryHookResult = ReturnType<typeof useRespondentPolcoLiveBaseLazyQuery>;
export type RespondentPolcoLiveBaseQueryResult = Apollo.QueryResult<RespondentPolcoLiveBase, RespondentPolcoLiveBaseVariables>;
export const RespondentProfileDocument = gql`
    query RespondentProfile($respondentId: ID!) {
  openRespondent(respondentId: $respondentId) {
    __typename
    ... on PrivateRespondent {
      id
      firstName
      lastName
      postAnonymously
      avatarUrl
      zipCode
      inputtedLat
      inputtedLon
      email
      emailSettings {
        id
        weeklyEmailEnabled
        outreachEmailEnabled
        outcomeEmailEnabled
      }
      verified
    }
  }
}
    `;

/**
 * __useRespondentProfile__
 *
 * To run a query within a React component, call `useRespondentProfile` and pass it any options that fit your needs.
 * When your component renders, `useRespondentProfile` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRespondentProfile({
 *   variables: {
 *      respondentId: // value for 'respondentId'
 *   },
 * });
 */
export function useRespondentProfile(baseOptions: Apollo.QueryHookOptions<RespondentProfile, RespondentProfileVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RespondentProfile, RespondentProfileVariables>(RespondentProfileDocument, options);
      }
export function useRespondentProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RespondentProfile, RespondentProfileVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RespondentProfile, RespondentProfileVariables>(RespondentProfileDocument, options);
        }
export type RespondentProfileHookResult = ReturnType<typeof useRespondentProfile>;
export type RespondentProfileLazyQueryHookResult = ReturnType<typeof useRespondentProfileLazyQuery>;
export type RespondentProfileQueryResult = Apollo.QueryResult<RespondentProfile, RespondentProfileVariables>;
export const RespondentPublisherProfileDocument = gql`
    query RespondentPublisherProfile($slug: String!, $respondentId: ID, $before: GqlDateInput, $resultLimit: Int) {
  openPublishingEntityBySlug(slug: $slug) {
    id
    slug
    name {
      ...multilang
    }
    description {
      ...multilang
    }
    assets {
      id
      url
      type
    }
    presidingArea {
      id
      center {
        coordinate {
          lat
          lng
        }
        size
      }
      name
    }
    subscriptionType(respondentId: $respondentId)
    publisherFeed(
      respondentId: $respondentId
      before: $before
      resultLimit: $resultLimit
    ) {
      items {
        ...RespondentFeed_Item
      }
    }
  }
}
    ${Multilang}
${RespondentFeed_Item}`;

/**
 * __useRespondentPublisherProfile__
 *
 * To run a query within a React component, call `useRespondentPublisherProfile` and pass it any options that fit your needs.
 * When your component renders, `useRespondentPublisherProfile` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRespondentPublisherProfile({
 *   variables: {
 *      slug: // value for 'slug'
 *      respondentId: // value for 'respondentId'
 *      before: // value for 'before'
 *      resultLimit: // value for 'resultLimit'
 *   },
 * });
 */
export function useRespondentPublisherProfile(baseOptions: Apollo.QueryHookOptions<RespondentPublisherProfile, RespondentPublisherProfileVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RespondentPublisherProfile, RespondentPublisherProfileVariables>(RespondentPublisherProfileDocument, options);
      }
export function useRespondentPublisherProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RespondentPublisherProfile, RespondentPublisherProfileVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RespondentPublisherProfile, RespondentPublisherProfileVariables>(RespondentPublisherProfileDocument, options);
        }
export type RespondentPublisherProfileHookResult = ReturnType<typeof useRespondentPublisherProfile>;
export type RespondentPublisherProfileLazyQueryHookResult = ReturnType<typeof useRespondentPublisherProfileLazyQuery>;
export type RespondentPublisherProfileQueryResult = Apollo.QueryResult<RespondentPublisherProfile, RespondentPublisherProfileVariables>;
export const RespondentSubscribablePublishersDocument = gql`
    query RespondentSubscribablePublishers($respondentId: ID) {
  openSubscribablePublishers(respondentId: $respondentId) {
    id
    name {
      ...multilang
    }
    slug
    assets {
      id
      type
      url
    }
  }
}
    ${Multilang}`;

/**
 * __useRespondentSubscribablePublishers__
 *
 * To run a query within a React component, call `useRespondentSubscribablePublishers` and pass it any options that fit your needs.
 * When your component renders, `useRespondentSubscribablePublishers` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRespondentSubscribablePublishers({
 *   variables: {
 *      respondentId: // value for 'respondentId'
 *   },
 * });
 */
export function useRespondentSubscribablePublishers(baseOptions?: Apollo.QueryHookOptions<RespondentSubscribablePublishers, RespondentSubscribablePublishersVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RespondentSubscribablePublishers, RespondentSubscribablePublishersVariables>(RespondentSubscribablePublishersDocument, options);
      }
export function useRespondentSubscribablePublishersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RespondentSubscribablePublishers, RespondentSubscribablePublishersVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RespondentSubscribablePublishers, RespondentSubscribablePublishersVariables>(RespondentSubscribablePublishersDocument, options);
        }
export type RespondentSubscribablePublishersHookResult = ReturnType<typeof useRespondentSubscribablePublishers>;
export type RespondentSubscribablePublishersLazyQueryHookResult = ReturnType<typeof useRespondentSubscribablePublishersLazyQuery>;
export type RespondentSubscribablePublishersQueryResult = Apollo.QueryResult<RespondentSubscribablePublishers, RespondentSubscribablePublishersVariables>;
export const RespondentSubscriptionsDocument = gql`
    query RespondentSubscriptions($respondentId: ID!) {
  openRespondent(respondentId: $respondentId) {
    __typename
    ... on PrivateRespondent {
      id
      subscriptions {
        id
        subscriptionType(respondentId: $respondentId)
        name {
          ...multilang
        }
        slug
        assets {
          id
          type
          url
        }
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useRespondentSubscriptions__
 *
 * To run a query within a React component, call `useRespondentSubscriptions` and pass it any options that fit your needs.
 * When your component renders, `useRespondentSubscriptions` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRespondentSubscriptions({
 *   variables: {
 *      respondentId: // value for 'respondentId'
 *   },
 * });
 */
export function useRespondentSubscriptions(baseOptions: Apollo.QueryHookOptions<RespondentSubscriptions, RespondentSubscriptionsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RespondentSubscriptions, RespondentSubscriptionsVariables>(RespondentSubscriptionsDocument, options);
      }
export function useRespondentSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RespondentSubscriptions, RespondentSubscriptionsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RespondentSubscriptions, RespondentSubscriptionsVariables>(RespondentSubscriptionsDocument, options);
        }
export type RespondentSubscriptionsHookResult = ReturnType<typeof useRespondentSubscriptions>;
export type RespondentSubscriptionsLazyQueryHookResult = ReturnType<typeof useRespondentSubscriptionsLazyQuery>;
export type RespondentSubscriptionsQueryResult = Apollo.QueryResult<RespondentSubscriptions, RespondentSubscriptionsVariables>;
export const RespondentVotingPageDocument = gql`
    query RespondentVotingPage($publishingEntitySlug: String!, $questionSetSlug: String!, $respondentId: ID, $areaMode: TrackAreaMode, $comparisonGroupId: ID, $fipsCodes: [String!]) {
  openContentSetBySlug(
    publishingEntitySlug: $publishingEntitySlug
    questionSetSlug: $questionSetSlug
  ) {
    ... on ContentSetBase {
      id
      slug
      __typename
      shareable
      showConversionPrompts
      allowMultipleResponses
      image {
        id
        horizontalUrl
      }
      ... on QuestionSet {
        allowGuestRespondents
        id
        name {
          ...multilang
        }
        totalRespondents
        outcome {
          id
          text
          state
        }
        setForRespondentVote(respondentId: $respondentId) {
          id
          questions {
            id
            title {
              ...multilang
            }
            previousVote(respondentId: $respondentId) {
              id
              voteDate {
                raw
              }
            }
            schedule {
              status
              openDate {
                raw
              }
              closeDate {
                raw
              }
            }
          }
          status
        }
        publishingEntity {
          id
          name {
            ...multilang
          }
          slug
          subscriptionType(respondentId: $respondentId)
        }
        image {
          id
          verticalUrl
          backgroundColor
        }
      }
      ... on PolcoLive {
        allowGuestRespondents
        id
        name {
          ...multilang
        }
        totalRespondents
        outcome {
          id
          text
          state
        }
        setForRespondentVote(respondentId: $respondentId) {
          id
          questions {
            id
            title {
              ...multilang
            }
            previousVote(respondentId: $respondentId) {
              id
              voteDate {
                raw
              }
            }
            schedule {
              openDate {
                raw
              }
              closeDate {
                raw
              }
              status
            }
          }
          status
        }
        publishingEntity {
          id
          slug
          subscriptionType(respondentId: $respondentId)
          name {
            ...multilang
          }
        }
        image {
          id
          verticalUrl
          backgroundColor
        }
        settings {
          id
          eventStartDate {
            raw
          }
          liveVideoLink
        }
      }
      ... on Survey {
        id
        name {
          ...multilang
        }
        description {
          ...multilang
        }
        questionsCount
        allowGuestRespondents
        estCompletionTime
        publishingEntity {
          id
          slug
          assets {
            id
            type
            url
          }
          name {
            ...multilang
          }
          subscriptionType(respondentId: $respondentId)
        }
        createDate {
          raw
        }
        schedule {
          openDate {
            raw
          }
          closeDate {
            raw
          }
          status
        }
        outcome {
          id
          text
          state
        }
        alternateLanguages {
          id
          key
          name
        }
        contents {
          __typename
          ... on Question {
            id
            title {
              ...multilang
            }
            summary
            description {
              ...multilang
            }
            questionNumber
            optional
            choiceSet {
              id
              type
              maxSelection
              randomizeChoices
              choices {
                id
                text {
                  ...multilang
                }
                includeComment
              }
              sharedChoiceSetData {
                id
              }
            }
            schedule {
              openDate {
                raw
              }
              closeDate {
                raw
              }
              status
            }
            demographicAttribute {
              id
              name
              premium
              owner {
                id
              }
            }
            conditions {
              metaConditions {
                id
                displayName
                childMetaConditionIds
                combinationOperator
              }
              questionChoiceConditions {
                id
                metaConditionId
                questionId
                questionChoiceId
              }
            }
            previousVote(respondentId: $respondentId) {
              id
              voteDate {
                raw
              }
              question {
                id
                choiceSet {
                  id
                  type
                  randomizeChoices
                }
              }
              choices {
                id
                questionChoice {
                  id
                }
                allocation
              }
              comment {
                id
                comment
                upvoteCount
                commenterChoice {
                  id
                }
              }
              upvotedComments {
                id
              }
            }
          }
          ... on QuestionHierarchyParentNode {
            id
            label {
              ...multilang
            }
            nodeType: type
            description {
              ...multilang
            }
            questionNumber
            conditions {
              metaConditions {
                id
                displayName
                childMetaConditionIds
                combinationOperator
              }
              questionChoiceConditions {
                id
                metaConditionId
                questionId
                questionChoiceId
              }
            }
            numColumns
            ...RowContentHierarchyNodes
            questions {
              id
              title {
                ...multilang
              }
              optional
              schedule {
                status
              }
              choiceSet {
                id
                choices {
                  id
                  text {
                    ...multilang
                  }
                  includeComment
                }
                sharedChoiceSetData {
                  id
                }
                randomizeChoices
              }
              conditions {
                metaConditions {
                  id
                  displayName
                  childMetaConditionIds
                  combinationOperator
                }
                questionChoiceConditions {
                  id
                  metaConditionId
                  questionId
                  questionChoiceId
                }
              }
              previousVote(respondentId: $respondentId) {
                id
                voteDate {
                  raw
                }
                question {
                  id
                  choiceSet {
                    id
                    type
                    randomizeChoices
                  }
                }
                choices {
                  id
                  questionChoice {
                    id
                  }
                }
                comment {
                  id
                  comment
                  upvoteCount
                  commenterChoice {
                    id
                  }
                }
                upvotedComments {
                  id
                }
              }
            }
          }
          ... on QuestionHierarchyVisualizationNode {
            ...VisualizationNode
          }
          ... on QuestionHierarchySimulationNode {
            ...RespondentSimulationNode
          }
        }
      }
      ... on GenericContent {
        id
        name {
          ...multilang
        }
        description {
          ...multilang
        }
        questionsCount
        allowGuestRespondents
        estCompletionTime
        publishingEntity {
          id
          slug
          assets {
            id
            type
            url
          }
          name {
            ...multilang
          }
          subscriptionType(respondentId: $respondentId)
        }
        createDate {
          raw
        }
        schedule {
          openDate {
            raw
          }
          closeDate {
            raw
          }
          status
        }
        outcome {
          id
          text
          state
        }
        alternateLanguages {
          id
          key
          name
        }
        contents {
          __typename
          ... on Question {
            id
            title {
              ...multilang
            }
            summary
            description {
              ...multilang
            }
            questionNumber
            optional
            choiceSet {
              id
              type
              maxSelection
              randomizeChoices
              choices {
                id
                text {
                  ...multilang
                }
                includeComment
              }
              sharedChoiceSetData {
                id
              }
            }
            schedule {
              openDate {
                raw
              }
              closeDate {
                raw
              }
              status
            }
            demographicAttribute {
              id
              name
              premium
              owner {
                id
              }
            }
            conditions {
              metaConditions {
                id
                displayName
                childMetaConditionIds
                combinationOperator
              }
              questionChoiceConditions {
                id
                metaConditionId
                questionId
                questionChoiceId
              }
            }
            previousVote(respondentId: $respondentId) {
              id
              voteDate {
                raw
              }
              question {
                id
                choiceSet {
                  id
                  type
                  randomizeChoices
                }
              }
              choices {
                id
                questionChoice {
                  id
                }
                allocation
              }
              comment {
                id
                comment
                upvoteCount
                commenterChoice {
                  id
                }
              }
              upvotedComments {
                id
              }
            }
          }
          ... on QuestionHierarchyParentNode {
            id
            label {
              ...multilang
            }
            nodeType: type
            description {
              ...multilang
            }
            questionNumber
            conditions {
              metaConditions {
                id
                displayName
                childMetaConditionIds
                combinationOperator
              }
              questionChoiceConditions {
                id
                metaConditionId
                questionId
                questionChoiceId
              }
            }
            numColumns
            ...RowContentHierarchyNodes
            questions {
              id
              title {
                ...multilang
              }
              optional
              schedule {
                status
              }
              choiceSet {
                id
                choices {
                  id
                  text {
                    ...multilang
                  }
                  includeComment
                }
                sharedChoiceSetData {
                  id
                }
                randomizeChoices
              }
              conditions {
                metaConditions {
                  id
                  displayName
                  childMetaConditionIds
                  combinationOperator
                }
                questionChoiceConditions {
                  id
                  metaConditionId
                  questionId
                  questionChoiceId
                }
              }
              previousVote(respondentId: $respondentId) {
                id
                voteDate {
                  raw
                }
                question {
                  id
                  choiceSet {
                    id
                    type
                    randomizeChoices
                  }
                }
                choices {
                  id
                  questionChoice {
                    id
                  }
                }
                comment {
                  id
                  comment
                  upvoteCount
                  commenterChoice {
                    id
                  }
                }
                upvotedComments {
                  id
                }
              }
            }
          }
          ... on QuestionHierarchyVisualizationNode {
            ...VisualizationNode
          }
          ... on QuestionHierarchySimulationNode {
            ...RespondentSimulationNode
          }
        }
      }
    }
  }
  contextPublishingEntity: openPublishingEntityBySlug(slug: $publishingEntitySlug) {
    id
    slug
    assets {
      id
      type
      url
    }
    name {
      ...multilang
    }
    subscriptionType(respondentId: $respondentId)
  }
}
    ${Multilang}
${RowContentHierarchyNodes}
${VisualizationNode}
${RespondentSimulationNode}`;

/**
 * __useRespondentVotingPage__
 *
 * To run a query within a React component, call `useRespondentVotingPage` and pass it any options that fit your needs.
 * When your component renders, `useRespondentVotingPage` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRespondentVotingPage({
 *   variables: {
 *      publishingEntitySlug: // value for 'publishingEntitySlug'
 *      questionSetSlug: // value for 'questionSetSlug'
 *      respondentId: // value for 'respondentId'
 *      areaMode: // value for 'areaMode'
 *      comparisonGroupId: // value for 'comparisonGroupId'
 *      fipsCodes: // value for 'fipsCodes'
 *   },
 * });
 */
export function useRespondentVotingPage(baseOptions: Apollo.QueryHookOptions<RespondentVotingPage, RespondentVotingPageVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RespondentVotingPage, RespondentVotingPageVariables>(RespondentVotingPageDocument, options);
      }
export function useRespondentVotingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RespondentVotingPage, RespondentVotingPageVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RespondentVotingPage, RespondentVotingPageVariables>(RespondentVotingPageDocument, options);
        }
export type RespondentVotingPageHookResult = ReturnType<typeof useRespondentVotingPage>;
export type RespondentVotingPageLazyQueryHookResult = ReturnType<typeof useRespondentVotingPageLazyQuery>;
export type RespondentVotingPageQueryResult = Apollo.QueryResult<RespondentVotingPage, RespondentVotingPageVariables>;
export const SuperAdminAiAssistantSessionSummariesDocument = gql`
    query superAdminAiAssistantSessionSummaries($sortBy: AiAssistantSessionSortType, $sortOrder: SortOrder, $filterAssistantName: String, $filterPolcoAssistantId: String) {
  superAdminAiAssistantSessions(
    sortBy: $sortBy
    sortOrder: $sortOrder
    filterAssistantName: $filterAssistantName
    filterPolcoAssistantId: $filterPolcoAssistantId
  ) {
    id
    summary {
      assistantName
      polcoAssistantId
      sessionStartAt {
        raw
      }
      numberOfQueries
      publishingEntity {
        id
      }
      userEmail
    }
  }
}
    `;

/**
 * __useSuperAdminAiAssistantSessionSummaries__
 *
 * To run a query within a React component, call `useSuperAdminAiAssistantSessionSummaries` and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminAiAssistantSessionSummaries` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperAdminAiAssistantSessionSummaries({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      filterAssistantName: // value for 'filterAssistantName'
 *      filterPolcoAssistantId: // value for 'filterPolcoAssistantId'
 *   },
 * });
 */
export function useSuperAdminAiAssistantSessionSummaries(baseOptions?: Apollo.QueryHookOptions<SuperAdminAiAssistantSessionSummaries, SuperAdminAiAssistantSessionSummariesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperAdminAiAssistantSessionSummaries, SuperAdminAiAssistantSessionSummariesVariables>(SuperAdminAiAssistantSessionSummariesDocument, options);
      }
export function useSuperAdminAiAssistantSessionSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperAdminAiAssistantSessionSummaries, SuperAdminAiAssistantSessionSummariesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperAdminAiAssistantSessionSummaries, SuperAdminAiAssistantSessionSummariesVariables>(SuperAdminAiAssistantSessionSummariesDocument, options);
        }
export type SuperAdminAiAssistantSessionSummariesHookResult = ReturnType<typeof useSuperAdminAiAssistantSessionSummaries>;
export type SuperAdminAiAssistantSessionSummariesLazyQueryHookResult = ReturnType<typeof useSuperAdminAiAssistantSessionSummariesLazyQuery>;
export type SuperAdminAiAssistantSessionSummariesQueryResult = Apollo.QueryResult<SuperAdminAiAssistantSessionSummaries, SuperAdminAiAssistantSessionSummariesVariables>;
export const SuperAdminAllBenchmarkReportRequestsDocument = gql`
    query SuperAdminAllBenchmarkReportRequests {
  superAdminBenchmarkReportRequests {
    id
    status
    reportDueAt {
      raw
    }
    publishingEntity {
      id
      name {
        ...multilang
      }
    }
    benchmarkSurveyType
  }
}
    ${Multilang}`;

/**
 * __useSuperAdminAllBenchmarkReportRequests__
 *
 * To run a query within a React component, call `useSuperAdminAllBenchmarkReportRequests` and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminAllBenchmarkReportRequests` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperAdminAllBenchmarkReportRequests({
 *   variables: {
 *   },
 * });
 */
export function useSuperAdminAllBenchmarkReportRequests(baseOptions?: Apollo.QueryHookOptions<SuperAdminAllBenchmarkReportRequests, SuperAdminAllBenchmarkReportRequestsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperAdminAllBenchmarkReportRequests, SuperAdminAllBenchmarkReportRequestsVariables>(SuperAdminAllBenchmarkReportRequestsDocument, options);
      }
export function useSuperAdminAllBenchmarkReportRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperAdminAllBenchmarkReportRequests, SuperAdminAllBenchmarkReportRequestsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperAdminAllBenchmarkReportRequests, SuperAdminAllBenchmarkReportRequestsVariables>(SuperAdminAllBenchmarkReportRequestsDocument, options);
        }
export type SuperAdminAllBenchmarkReportRequestsHookResult = ReturnType<typeof useSuperAdminAllBenchmarkReportRequests>;
export type SuperAdminAllBenchmarkReportRequestsLazyQueryHookResult = ReturnType<typeof useSuperAdminAllBenchmarkReportRequestsLazyQuery>;
export type SuperAdminAllBenchmarkReportRequestsQueryResult = Apollo.QueryResult<SuperAdminAllBenchmarkReportRequests, SuperAdminAllBenchmarkReportRequestsVariables>;
export const SuperAdminAllPublishersDocument = gql`
    query SuperAdminAllPublishers($filter: String) {
  superAdminAllPublishers(page: 0, filter: $filter) {
    id
    name {
      ...multilang
    }
    slug
    presidingArea {
      id
      name
    }
    approvalDecision
    organizationType {
      id
      displayName
    }
  }
}
    ${Multilang}`;

/**
 * __useSuperAdminAllPublishers__
 *
 * To run a query within a React component, call `useSuperAdminAllPublishers` and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminAllPublishers` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperAdminAllPublishers({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSuperAdminAllPublishers(baseOptions?: Apollo.QueryHookOptions<SuperAdminAllPublishers, SuperAdminAllPublishersVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperAdminAllPublishers, SuperAdminAllPublishersVariables>(SuperAdminAllPublishersDocument, options);
      }
export function useSuperAdminAllPublishersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperAdminAllPublishers, SuperAdminAllPublishersVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperAdminAllPublishers, SuperAdminAllPublishersVariables>(SuperAdminAllPublishersDocument, options);
        }
export type SuperAdminAllPublishersHookResult = ReturnType<typeof useSuperAdminAllPublishers>;
export type SuperAdminAllPublishersLazyQueryHookResult = ReturnType<typeof useSuperAdminAllPublishersLazyQuery>;
export type SuperAdminAllPublishersQueryResult = Apollo.QueryResult<SuperAdminAllPublishers, SuperAdminAllPublishersVariables>;
export const SuperAdminAllSuperAdminsDocument = gql`
    query SuperAdminAllSuperAdmins {
  superAdminAllSuperAdmins {
    id
    admin {
      __typename
      ... on PrivateAdmin {
        id
        name
        email
        user {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useSuperAdminAllSuperAdmins__
 *
 * To run a query within a React component, call `useSuperAdminAllSuperAdmins` and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminAllSuperAdmins` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperAdminAllSuperAdmins({
 *   variables: {
 *   },
 * });
 */
export function useSuperAdminAllSuperAdmins(baseOptions?: Apollo.QueryHookOptions<SuperAdminAllSuperAdmins, SuperAdminAllSuperAdminsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperAdminAllSuperAdmins, SuperAdminAllSuperAdminsVariables>(SuperAdminAllSuperAdminsDocument, options);
      }
export function useSuperAdminAllSuperAdminsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperAdminAllSuperAdmins, SuperAdminAllSuperAdminsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperAdminAllSuperAdmins, SuperAdminAllSuperAdminsVariables>(SuperAdminAllSuperAdminsDocument, options);
        }
export type SuperAdminAllSuperAdminsHookResult = ReturnType<typeof useSuperAdminAllSuperAdmins>;
export type SuperAdminAllSuperAdminsLazyQueryHookResult = ReturnType<typeof useSuperAdminAllSuperAdminsLazyQuery>;
export type SuperAdminAllSuperAdminsQueryResult = Apollo.QueryResult<SuperAdminAllSuperAdmins, SuperAdminAllSuperAdminsVariables>;
export const SuperAdminBenchmarkDataDictionaryDocument = gql`
    query SuperAdminBenchmarkDataDictionary($contentSetId: ID!, $reportRequestId: ID!) {
  openContentSetById(setId: $contentSetId) {
    __typename
    ... on Survey {
      id
      name {
        ...multilang
      }
      contents {
        __typename
        ... on Question {
          id
          title {
            ...multilang
          }
          variableName
          reportDisplayLabel
          choiceSet {
            id
            maxSelection
            scaleData {
              scaleThreshold
              scaleType
            }
            choices {
              id
              text {
                ...multilang
              }
              choiceValue
            }
          }
          dataDictionary(reportRequestId: $reportRequestId) {
            benchmarkArea
            weightingLabel
          }
        }
        ... on QuestionHierarchyParentNode {
          id
          label {
            ...multilang
          }
          questions {
            id
            title {
              ...multilang
            }
            variableName
            reportDisplayLabel
            choiceSet {
              id
              maxSelection
              scaleData {
                scaleThreshold
                scaleType
              }
              choices {
                id
                text {
                  ...multilang
                }
                choiceValue
              }
            }
            dataDictionary(reportRequestId: $reportRequestId) {
              benchmarkArea
              weightingLabel
            }
          }
        }
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useSuperAdminBenchmarkDataDictionary__
 *
 * To run a query within a React component, call `useSuperAdminBenchmarkDataDictionary` and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminBenchmarkDataDictionary` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperAdminBenchmarkDataDictionary({
 *   variables: {
 *      contentSetId: // value for 'contentSetId'
 *      reportRequestId: // value for 'reportRequestId'
 *   },
 * });
 */
export function useSuperAdminBenchmarkDataDictionary(baseOptions: Apollo.QueryHookOptions<SuperAdminBenchmarkDataDictionary, SuperAdminBenchmarkDataDictionaryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperAdminBenchmarkDataDictionary, SuperAdminBenchmarkDataDictionaryVariables>(SuperAdminBenchmarkDataDictionaryDocument, options);
      }
export function useSuperAdminBenchmarkDataDictionaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperAdminBenchmarkDataDictionary, SuperAdminBenchmarkDataDictionaryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperAdminBenchmarkDataDictionary, SuperAdminBenchmarkDataDictionaryVariables>(SuperAdminBenchmarkDataDictionaryDocument, options);
        }
export type SuperAdminBenchmarkDataDictionaryHookResult = ReturnType<typeof useSuperAdminBenchmarkDataDictionary>;
export type SuperAdminBenchmarkDataDictionaryLazyQueryHookResult = ReturnType<typeof useSuperAdminBenchmarkDataDictionaryLazyQuery>;
export type SuperAdminBenchmarkDataDictionaryQueryResult = Apollo.QueryResult<SuperAdminBenchmarkDataDictionary, SuperAdminBenchmarkDataDictionaryVariables>;
export const SuperAdminBenchmarkPdfsDocument = gql`
    query SuperAdminBenchmarkPdfs($filter: String!) {
  superAdminBenchmarkPdfs(filter: $filter) {
    survey {
      id
      name {
        ...multilang
      }
      slug
    }
    publisherName
    publisherSlug
    pdfData {
      lastModified {
        raw
      }
      uploadUrl
      status
    }
    error
  }
}
    ${Multilang}`;

/**
 * __useSuperAdminBenchmarkPdfs__
 *
 * To run a query within a React component, call `useSuperAdminBenchmarkPdfs` and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminBenchmarkPdfs` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperAdminBenchmarkPdfs({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSuperAdminBenchmarkPdfs(baseOptions: Apollo.QueryHookOptions<SuperAdminBenchmarkPdfs, SuperAdminBenchmarkPdfsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperAdminBenchmarkPdfs, SuperAdminBenchmarkPdfsVariables>(SuperAdminBenchmarkPdfsDocument, options);
      }
export function useSuperAdminBenchmarkPdfsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperAdminBenchmarkPdfs, SuperAdminBenchmarkPdfsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperAdminBenchmarkPdfs, SuperAdminBenchmarkPdfsVariables>(SuperAdminBenchmarkPdfsDocument, options);
        }
export type SuperAdminBenchmarkPdfsHookResult = ReturnType<typeof useSuperAdminBenchmarkPdfs>;
export type SuperAdminBenchmarkPdfsLazyQueryHookResult = ReturnType<typeof useSuperAdminBenchmarkPdfsLazyQuery>;
export type SuperAdminBenchmarkPdfsQueryResult = Apollo.QueryResult<SuperAdminBenchmarkPdfs, SuperAdminBenchmarkPdfsVariables>;
export const SuperAdminBenchmarkReportRequestDocument = gql`
    query SuperAdminBenchmarkReportRequest($requestId: ID!) {
  superAdminBenchmarkReportRequestById(reportRequestId: $requestId) {
    id
    status
    publishingEntity {
      id
      name {
        ...multilang
      }
      presidingArea {
        id
        name
      }
    }
    benchmarkSurveyType
    startAt {
      raw
    }
    closedAt {
      raw
    }
    clientDueAt {
      raw
    }
    reportDueAt {
      raw
    }
    surveyFormat
    trendsExpected
    expectedTrendYears
    fips
    customBenchmarks
    additionalNotes
    mailedCount
    emailedCount
    eligibleSamplingResponseCount
    responseRate
    questionSetData {
      id
      contentSet {
        __typename
        ... on ContentSetBase {
          id
          name {
            ...multilang
          }
        }
      }
      language
      optIn
      weighted
    }
    areaData {
      id
      name
      value
      group
      weight
    }
  }
}
    ${Multilang}`;

/**
 * __useSuperAdminBenchmarkReportRequest__
 *
 * To run a query within a React component, call `useSuperAdminBenchmarkReportRequest` and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminBenchmarkReportRequest` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperAdminBenchmarkReportRequest({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useSuperAdminBenchmarkReportRequest(baseOptions: Apollo.QueryHookOptions<SuperAdminBenchmarkReportRequest, SuperAdminBenchmarkReportRequestVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperAdminBenchmarkReportRequest, SuperAdminBenchmarkReportRequestVariables>(SuperAdminBenchmarkReportRequestDocument, options);
      }
export function useSuperAdminBenchmarkReportRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperAdminBenchmarkReportRequest, SuperAdminBenchmarkReportRequestVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperAdminBenchmarkReportRequest, SuperAdminBenchmarkReportRequestVariables>(SuperAdminBenchmarkReportRequestDocument, options);
        }
export type SuperAdminBenchmarkReportRequestHookResult = ReturnType<typeof useSuperAdminBenchmarkReportRequest>;
export type SuperAdminBenchmarkReportRequestLazyQueryHookResult = ReturnType<typeof useSuperAdminBenchmarkReportRequestLazyQuery>;
export type SuperAdminBenchmarkReportRequestQueryResult = Apollo.QueryResult<SuperAdminBenchmarkReportRequest, SuperAdminBenchmarkReportRequestVariables>;
export const SuperAdminContentSetSettingsDocument = gql`
    query SuperAdminContentSetSettings($setId: ID!) {
  openContentSetById(setId: $setId) {
    __typename
    ... on ContentSetBase {
      id
      name {
        ...multilang
      }
      schedule {
        status
      }
      shortUrls {
        id
        shortUrl
        fullUrl
        isPrimary
      }
      alternateLanguages {
        id
        key
        name
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useSuperAdminContentSetSettings__
 *
 * To run a query within a React component, call `useSuperAdminContentSetSettings` and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminContentSetSettings` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperAdminContentSetSettings({
 *   variables: {
 *      setId: // value for 'setId'
 *   },
 * });
 */
export function useSuperAdminContentSetSettings(baseOptions: Apollo.QueryHookOptions<SuperAdminContentSetSettings, SuperAdminContentSetSettingsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperAdminContentSetSettings, SuperAdminContentSetSettingsVariables>(SuperAdminContentSetSettingsDocument, options);
      }
export function useSuperAdminContentSetSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperAdminContentSetSettings, SuperAdminContentSetSettingsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperAdminContentSetSettings, SuperAdminContentSetSettingsVariables>(SuperAdminContentSetSettingsDocument, options);
        }
export type SuperAdminContentSetSettingsHookResult = ReturnType<typeof useSuperAdminContentSetSettings>;
export type SuperAdminContentSetSettingsLazyQueryHookResult = ReturnType<typeof useSuperAdminContentSetSettingsLazyQuery>;
export type SuperAdminContentSetSettingsQueryResult = Apollo.QueryResult<SuperAdminContentSetSettings, SuperAdminContentSetSettingsVariables>;
export const SuperAdminExportTranslationsDocument = gql`
    query SuperAdminExportTranslations($surveyId: ID!) {
  openContentSetById(setId: $surveyId) {
    __typename
    ... on Survey {
      id
      name {
        ...multilang
      }
      description {
        ...multilang
      }
      shortDescription {
        ...multilang
      }
      contents {
        __typename
        ... on Question {
          id
          title {
            ...multilang
          }
          description {
            ...multilang
          }
          choiceSet {
            id
            choices {
              id
              text {
                ...multilang
              }
            }
          }
        }
        ... on QuestionHierarchyParentNode {
          id
          label {
            ...multilang
          }
          description {
            ...multilang
          }
          questions {
            id
            description {
              ...multilang
            }
            title {
              ...multilang
            }
            choiceSet {
              id
              choices {
                id
                text {
                  ...multilang
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${Multilang}`;

/**
 * __useSuperAdminExportTranslations__
 *
 * To run a query within a React component, call `useSuperAdminExportTranslations` and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminExportTranslations` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperAdminExportTranslations({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useSuperAdminExportTranslations(baseOptions: Apollo.QueryHookOptions<SuperAdminExportTranslations, SuperAdminExportTranslationsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperAdminExportTranslations, SuperAdminExportTranslationsVariables>(SuperAdminExportTranslationsDocument, options);
      }
export function useSuperAdminExportTranslationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperAdminExportTranslations, SuperAdminExportTranslationsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperAdminExportTranslations, SuperAdminExportTranslationsVariables>(SuperAdminExportTranslationsDocument, options);
        }
export type SuperAdminExportTranslationsHookResult = ReturnType<typeof useSuperAdminExportTranslations>;
export type SuperAdminExportTranslationsLazyQueryHookResult = ReturnType<typeof useSuperAdminExportTranslationsLazyQuery>;
export type SuperAdminExportTranslationsQueryResult = Apollo.QueryResult<SuperAdminExportTranslations, SuperAdminExportTranslationsVariables>;
export const SuperAdminFilteredPubsDocument = gql`
    query SuperAdminFilteredPubs($filter: SuperAdminPublisherFilter!) {
  superAdminFilteredPublishers(filter: $filter) {
    id
    name {
      ...multilang
    }
    slug
    organizationArea {
      id
      displayName
    }
    organizationType {
      id
      displayName
    }
  }
}
    ${Multilang}`;

/**
 * __useSuperAdminFilteredPubs__
 *
 * To run a query within a React component, call `useSuperAdminFilteredPubs` and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminFilteredPubs` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperAdminFilteredPubs({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSuperAdminFilteredPubs(baseOptions: Apollo.QueryHookOptions<SuperAdminFilteredPubs, SuperAdminFilteredPubsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperAdminFilteredPubs, SuperAdminFilteredPubsVariables>(SuperAdminFilteredPubsDocument, options);
      }
export function useSuperAdminFilteredPubsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperAdminFilteredPubs, SuperAdminFilteredPubsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperAdminFilteredPubs, SuperAdminFilteredPubsVariables>(SuperAdminFilteredPubsDocument, options);
        }
export type SuperAdminFilteredPubsHookResult = ReturnType<typeof useSuperAdminFilteredPubs>;
export type SuperAdminFilteredPubsLazyQueryHookResult = ReturnType<typeof useSuperAdminFilteredPubsLazyQuery>;
export type SuperAdminFilteredPubsQueryResult = Apollo.QueryResult<SuperAdminFilteredPubs, SuperAdminFilteredPubsVariables>;
export const SuperAdminPlacesListDocument = gql`
    query SuperAdminPlacesList($filter: String!) {
  superAdminCensusPlaces(filter: $filter) {
    id
    name
    shape {
      type
      coordinates
    }
    center {
      coordinate {
        lat
        lng
      }
      size
    }
  }
}
    `;

/**
 * __useSuperAdminPlacesList__
 *
 * To run a query within a React component, call `useSuperAdminPlacesList` and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminPlacesList` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperAdminPlacesList({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSuperAdminPlacesList(baseOptions: Apollo.QueryHookOptions<SuperAdminPlacesList, SuperAdminPlacesListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperAdminPlacesList, SuperAdminPlacesListVariables>(SuperAdminPlacesListDocument, options);
      }
export function useSuperAdminPlacesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperAdminPlacesList, SuperAdminPlacesListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperAdminPlacesList, SuperAdminPlacesListVariables>(SuperAdminPlacesListDocument, options);
        }
export type SuperAdminPlacesListHookResult = ReturnType<typeof useSuperAdminPlacesList>;
export type SuperAdminPlacesListLazyQueryHookResult = ReturnType<typeof useSuperAdminPlacesListLazyQuery>;
export type SuperAdminPlacesListQueryResult = Apollo.QueryResult<SuperAdminPlacesList, SuperAdminPlacesListVariables>;
export const SuperAdminPublishingEntityConfigurationDashboardDocument = gql`
    query SuperAdminPublishingEntityConfigurationDashboard($publishingEntityId: ID!) {
  openPublishingEntityById(publishingEntityId: $publishingEntityId) {
    id
    occupiedSeats
    aiAssistantInteractions(assistant: {id: "POLLY", type: StandardAssistant}) {
      publishingEntityId
      sessionCount
      queryCount
    }
    grantWriterAssistantInteractions: aiAssistantInteractions(
      assistant: {id: "GRANT_WRITER", type: StandardAssistant}
    ) {
      publishingEntityId
      sessionCount
      queryCount
    }
    activeEngageContentCount
    featureSettings {
      id
      featureSettingId
      featureSettingName
      enabled
      quantity
      isUnlimited
      expirationDate {
        raw
      }
    }
    managingAdmins {
      id
      admin {
        __typename
        ... on PrivateAdmin {
          id
          name
          emailVerificationStatus
          email
        }
      }
    }
    thirdPartyRecords {
      id
      thirdParty
      thirdPartyIdentifier
    }
    presidingArea {
      id
      center {
        coordinate {
          lat
          lng
        }
        size
      }
      shape {
        type
        coordinates
      }
      name
    }
    subscriptionMode
    envisioSetting {
      id
      magicToken
      instanceId
    }
  }
  adminOrderedStoreItems(type: TIER, publishingEntityId: $publishingEntityId) {
    id
    status
    storeItem {
      id
      name
    }
  }
  currentUser {
    id
    user {
      id
      admin {
        ... on AdminBase {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useSuperAdminPublishingEntityConfigurationDashboard__
 *
 * To run a query within a React component, call `useSuperAdminPublishingEntityConfigurationDashboard` and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminPublishingEntityConfigurationDashboard` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperAdminPublishingEntityConfigurationDashboard({
 *   variables: {
 *      publishingEntityId: // value for 'publishingEntityId'
 *   },
 * });
 */
export function useSuperAdminPublishingEntityConfigurationDashboard(baseOptions: Apollo.QueryHookOptions<SuperAdminPublishingEntityConfigurationDashboard, SuperAdminPublishingEntityConfigurationDashboardVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperAdminPublishingEntityConfigurationDashboard, SuperAdminPublishingEntityConfigurationDashboardVariables>(SuperAdminPublishingEntityConfigurationDashboardDocument, options);
      }
export function useSuperAdminPublishingEntityConfigurationDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperAdminPublishingEntityConfigurationDashboard, SuperAdminPublishingEntityConfigurationDashboardVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperAdminPublishingEntityConfigurationDashboard, SuperAdminPublishingEntityConfigurationDashboardVariables>(SuperAdminPublishingEntityConfigurationDashboardDocument, options);
        }
export type SuperAdminPublishingEntityConfigurationDashboardHookResult = ReturnType<typeof useSuperAdminPublishingEntityConfigurationDashboard>;
export type SuperAdminPublishingEntityConfigurationDashboardLazyQueryHookResult = ReturnType<typeof useSuperAdminPublishingEntityConfigurationDashboardLazyQuery>;
export type SuperAdminPublishingEntityConfigurationDashboardQueryResult = Apollo.QueryResult<SuperAdminPublishingEntityConfigurationDashboard, SuperAdminPublishingEntityConfigurationDashboardVariables>;
export const SuperAdminPurchasesDocument = gql`
    query SuperAdminPurchases {
  superAdminPurchasedStoreItems {
    id
    createdAt {
      raw
    }
    publishingEntity {
      id
      name {
        ...multilang
      }
    }
    storeItem {
      id
      name
      provider
    }
    purchasedByAdmin {
      ... on AdminBase {
        id
        name
      }
    }
    price
    status
    purchasedInStripe
  }
}
    ${Multilang}`;

/**
 * __useSuperAdminPurchases__
 *
 * To run a query within a React component, call `useSuperAdminPurchases` and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminPurchases` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperAdminPurchases({
 *   variables: {
 *   },
 * });
 */
export function useSuperAdminPurchases(baseOptions?: Apollo.QueryHookOptions<SuperAdminPurchases, SuperAdminPurchasesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperAdminPurchases, SuperAdminPurchasesVariables>(SuperAdminPurchasesDocument, options);
      }
export function useSuperAdminPurchasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperAdminPurchases, SuperAdminPurchasesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperAdminPurchases, SuperAdminPurchasesVariables>(SuperAdminPurchasesDocument, options);
        }
export type SuperAdminPurchasesHookResult = ReturnType<typeof useSuperAdminPurchases>;
export type SuperAdminPurchasesLazyQueryHookResult = ReturnType<typeof useSuperAdminPurchasesLazyQuery>;
export type SuperAdminPurchasesQueryResult = Apollo.QueryResult<SuperAdminPurchases, SuperAdminPurchasesVariables>;
export const SuperAdminRegistrationRequestsDocument = gql`
    query SuperAdminRegistrationRequests {
  superAdminRegistrationDecisions {
    id
    user {
      id
      admin {
        __typename
        ... on PrivateAdmin {
          id
          name
          email
        }
      }
    }
    publishingEntity {
      id
      activationState
      type {
        id
        displayName
      }
      name {
        ...multilang
      }
    }
    createdTime {
      raw
    }
    decidingAdmin {
      ... on AdminBase {
        id
        name
      }
    }
    decision
    decisionTime {
      raw
    }
  }
}
    ${Multilang}`;

/**
 * __useSuperAdminRegistrationRequests__
 *
 * To run a query within a React component, call `useSuperAdminRegistrationRequests` and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminRegistrationRequests` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperAdminRegistrationRequests({
 *   variables: {
 *   },
 * });
 */
export function useSuperAdminRegistrationRequests(baseOptions?: Apollo.QueryHookOptions<SuperAdminRegistrationRequests, SuperAdminRegistrationRequestsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperAdminRegistrationRequests, SuperAdminRegistrationRequestsVariables>(SuperAdminRegistrationRequestsDocument, options);
      }
export function useSuperAdminRegistrationRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperAdminRegistrationRequests, SuperAdminRegistrationRequestsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperAdminRegistrationRequests, SuperAdminRegistrationRequestsVariables>(SuperAdminRegistrationRequestsDocument, options);
        }
export type SuperAdminRegistrationRequestsHookResult = ReturnType<typeof useSuperAdminRegistrationRequests>;
export type SuperAdminRegistrationRequestsLazyQueryHookResult = ReturnType<typeof useSuperAdminRegistrationRequestsLazyQuery>;
export type SuperAdminRegistrationRequestsQueryResult = Apollo.QueryResult<SuperAdminRegistrationRequests, SuperAdminRegistrationRequestsVariables>;
export const VotingDocument = gql`
    query Voting($respondentId: ID, $questionId: ID!, $pagination: PaginationParams) {
  openQuestion(questionId: $questionId) {
    id
    title {
      ...multilang
    }
    questionSet {
      ... on ContentSetBase {
        id
        slug
        allowGuestRespondents
        allowMultipleResponses
        showConversionPrompts
        publishingEntity {
          id
          name {
            ...multilang
          }
          slug
          assets {
            id
            type
            url
          }
          subscriptionType(respondentId: $respondentId)
        }
      }
    }
    schedule {
      openDate {
        raw
      }
      closeDate {
        raw
      }
    }
    choiceSet {
      id
      type
      maxSelection
      randomizeChoices
      choices {
        id
        text {
          ...multilang
        }
      }
    }
    results {
      ...QuestionResults_Fragment
    }
    summary
    description {
      ...multilang
    }
    commentsData {
      totalCount
      comments(pagination: $pagination) {
        id
        comment
        commentDate {
          raw
        }
        commenter {
          ... on RespondentBase {
            id
            firstName
            lastName
            avatarUrl
            postAnonymously
          }
        }
        commenterChoice {
          id
        }
        upvoteCount
      }
    }
    previousVote(respondentId: $respondentId) {
      id
      choices {
        id
        questionChoice {
          id
        }
        allocation
      }
      comment {
        id
        comment
        commentDate {
          raw
        }
        upvoteCount
      }
      upvotedComments {
        id
      }
    }
  }
}
    ${Multilang}
${QuestionResults_Fragment}`;

/**
 * __useVoting__
 *
 * To run a query within a React component, call `useVoting` and pass it any options that fit your needs.
 * When your component renders, `useVoting` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoting({
 *   variables: {
 *      respondentId: // value for 'respondentId'
 *      questionId: // value for 'questionId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useVoting(baseOptions: Apollo.QueryHookOptions<Voting, VotingVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Voting, VotingVariables>(VotingDocument, options);
      }
export function useVotingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Voting, VotingVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Voting, VotingVariables>(VotingDocument, options);
        }
export type VotingHookResult = ReturnType<typeof useVoting>;
export type VotingLazyQueryHookResult = ReturnType<typeof useVotingLazyQuery>;
export type VotingQueryResult = Apollo.QueryResult<Voting, VotingVariables>;
export const LiveContentSetDocument = gql`
    subscription LiveContentSet($contentSetId: ID!, $respondentId: ID) {
  liveContentSet(contentSetId: $contentSetId) {
    id
    setForRespondentVote(respondentId: $respondentId) {
      id
      questions {
        id
        schedule {
          openDate {
            raw
          }
          closeDate {
            raw
          }
          status
        }
      }
      status
    }
    settings {
      id
      eventEndDate {
        raw
      }
    }
  }
}
    `;

/**
 * __useLiveContentSet__
 *
 * To run a query within a React component, call `useLiveContentSet` and pass it any options that fit your needs.
 * When your component renders, `useLiveContentSet` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveContentSet({
 *   variables: {
 *      contentSetId: // value for 'contentSetId'
 *      respondentId: // value for 'respondentId'
 *   },
 * });
 */
export function useLiveContentSet(baseOptions: Apollo.SubscriptionHookOptions<LiveContentSet, LiveContentSetVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveContentSet, LiveContentSetVariables>(LiveContentSetDocument, options);
      }
export type LiveContentSetHookResult = ReturnType<typeof useLiveContentSet>;
export type LiveContentSetSubscriptionResult = Apollo.SubscriptionResult<LiveContentSet>;
export const QuestionNewCommentDocument = gql`
    subscription QuestionNewComment($questionId: ID!) {
  questionNewComment(questionId: $questionId) {
    id
    comment
    commentDate {
      raw
    }
    commenter {
      ... on RespondentBase {
        id
        firstName
        lastName
        avatarUrl
        postAnonymously
      }
    }
    commenterChoice {
      id
    }
    upvoteCount
  }
}
    `;

/**
 * __useQuestionNewComment__
 *
 * To run a query within a React component, call `useQuestionNewComment` and pass it any options that fit your needs.
 * When your component renders, `useQuestionNewComment` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionNewComment({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useQuestionNewComment(baseOptions: Apollo.SubscriptionHookOptions<QuestionNewComment, QuestionNewCommentVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<QuestionNewComment, QuestionNewCommentVariables>(QuestionNewCommentDocument, options);
      }
export type QuestionNewCommentHookResult = ReturnType<typeof useQuestionNewComment>;
export type QuestionNewCommentSubscriptionResult = Apollo.SubscriptionResult<QuestionNewComment>;
export const QuestionResultsDocument = gql`
    subscription QuestionResults($questionId: ID!) {
  questionResults(questionId: $questionId) {
    id
    results {
      choice {
        id
      }
      result
      votesCount
    }
  }
}
    `;

/**
 * __useQuestionResults__
 *
 * To run a query within a React component, call `useQuestionResults` and pass it any options that fit your needs.
 * When your component renders, `useQuestionResults` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionResults({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useQuestionResults(baseOptions: Apollo.SubscriptionHookOptions<QuestionResults, QuestionResultsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<QuestionResults, QuestionResultsVariables>(QuestionResultsDocument, options);
      }
export type QuestionResultsHookResult = ReturnType<typeof useQuestionResults>;
export type QuestionResultsSubscriptionResult = Apollo.SubscriptionResult<QuestionResults>;